webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(15);
	var isBuffer = __webpack_require__(84);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = options.computed || (options.computed = {})
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(1);
	var normalizeHeaderName = __webpack_require__(41);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(11);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(11);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(5)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.5.16
	 * (c) 2014-2018 Evan You
	 * Released under the MIT License.
	 */
	'use strict';
	
	/*  */
	
	var emptyObject = Object.freeze({});
	
	// these helpers produces better vm code in JS engines due to their
	// explicitness and function inlining
	function isUndef (v) {
	  return v === undefined || v === null
	}
	
	function isDef (v) {
	  return v !== undefined && v !== null
	}
	
	function isTrue (v) {
	  return v === true
	}
	
	function isFalse (v) {
	  return v === false
	}
	
	/**
	 * Check if value is primitive
	 */
	function isPrimitive (value) {
	  return (
	    typeof value === 'string' ||
	    typeof value === 'number' ||
	    // $flow-disable-line
	    typeof value === 'symbol' ||
	    typeof value === 'boolean'
	  )
	}
	
	/**
	 * Quick object check - this is primarily used to tell
	 * Objects from primitive values when we know the value
	 * is a JSON-compliant type.
	 */
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	/**
	 * Get the raw type string of a value e.g. [object Object]
	 */
	var _toString = Object.prototype.toString;
	
	function toRawType (value) {
	  return _toString.call(value).slice(8, -1)
	}
	
	/**
	 * Strict object type check. Only returns true
	 * for plain JavaScript objects.
	 */
	function isPlainObject (obj) {
	  return _toString.call(obj) === '[object Object]'
	}
	
	function isRegExp (v) {
	  return _toString.call(v) === '[object RegExp]'
	}
	
	/**
	 * Check if val is a valid array index.
	 */
	function isValidArrayIndex (val) {
	  var n = parseFloat(String(val));
	  return n >= 0 && Math.floor(n) === n && isFinite(val)
	}
	
	/**
	 * Convert a value to a string that is actually rendered.
	 */
	function toString (val) {
	  return val == null
	    ? ''
	    : typeof val === 'object'
	      ? JSON.stringify(val, null, 2)
	      : String(val)
	}
	
	/**
	 * Convert a input value to a number for persistence.
	 * If the conversion fails, return original string.
	 */
	function toNumber (val) {
	  var n = parseFloat(val);
	  return isNaN(n) ? val : n
	}
	
	/**
	 * Make a map and return a function for checking if a key
	 * is in that map.
	 */
	function makeMap (
	  str,
	  expectsLowerCase
	) {
	  var map = Object.create(null);
	  var list = str.split(',');
	  for (var i = 0; i < list.length; i++) {
	    map[list[i]] = true;
	  }
	  return expectsLowerCase
	    ? function (val) { return map[val.toLowerCase()]; }
	    : function (val) { return map[val]; }
	}
	
	/**
	 * Check if a tag is a built-in tag.
	 */
	var isBuiltInTag = makeMap('slot,component', true);
	
	/**
	 * Check if a attribute is a reserved attribute.
	 */
	var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
	
	/**
	 * Remove an item from an array
	 */
	function remove (arr, item) {
	  if (arr.length) {
	    var index = arr.indexOf(item);
	    if (index > -1) {
	      return arr.splice(index, 1)
	    }
	  }
	}
	
	/**
	 * Check whether the object has the property.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn (obj, key) {
	  return hasOwnProperty.call(obj, key)
	}
	
	/**
	 * Create a cached version of a pure function.
	 */
	function cached (fn) {
	  var cache = Object.create(null);
	  return (function cachedFn (str) {
	    var hit = cache[str];
	    return hit || (cache[str] = fn(str))
	  })
	}
	
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = cached(function (str) {
	  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
	});
	
	/**
	 * Capitalize a string.
	 */
	var capitalize = cached(function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1)
	});
	
	/**
	 * Hyphenate a camelCase string.
	 */
	var hyphenateRE = /\B([A-Z])/g;
	var hyphenate = cached(function (str) {
	  return str.replace(hyphenateRE, '-$1').toLowerCase()
	});
	
	/**
	 * Simple bind polyfill for environments that do not support it... e.g.
	 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
	 * now more performant in most browsers, but removing it would be breaking for
	 * code that was able to run in PhantomJS 1.x, so this must be kept for
	 * backwards compatibility.
	 */
	
	/* istanbul ignore next */
	function polyfillBind (fn, ctx) {
	  function boundFn (a) {
	    var l = arguments.length;
	    return l
	      ? l > 1
	        ? fn.apply(ctx, arguments)
	        : fn.call(ctx, a)
	      : fn.call(ctx)
	  }
	
	  boundFn._length = fn.length;
	  return boundFn
	}
	
	function nativeBind (fn, ctx) {
	  return fn.bind(ctx)
	}
	
	var bind = Function.prototype.bind
	  ? nativeBind
	  : polyfillBind;
	
	/**
	 * Convert an Array-like object to a real Array.
	 */
	function toArray (list, start) {
	  start = start || 0;
	  var i = list.length - start;
	  var ret = new Array(i);
	  while (i--) {
	    ret[i] = list[i + start];
	  }
	  return ret
	}
	
	/**
	 * Mix properties into target object.
	 */
	function extend (to, _from) {
	  for (var key in _from) {
	    to[key] = _from[key];
	  }
	  return to
	}
	
	/**
	 * Merge an Array of Objects into a single Object.
	 */
	function toObject (arr) {
	  var res = {};
	  for (var i = 0; i < arr.length; i++) {
	    if (arr[i]) {
	      extend(res, arr[i]);
	    }
	  }
	  return res
	}
	
	/**
	 * Perform no operation.
	 * Stubbing args to make Flow happy without leaving useless transpiled code
	 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
	 */
	function noop (a, b, c) {}
	
	/**
	 * Always return false.
	 */
	var no = function (a, b, c) { return false; };
	
	/**
	 * Return same value
	 */
	var identity = function (_) { return _; };
	
	/**
	 * Generate a static keys string from compiler modules.
	 */
	function genStaticKeys (modules) {
	  return modules.reduce(function (keys, m) {
	    return keys.concat(m.staticKeys || [])
	  }, []).join(',')
	}
	
	/**
	 * Check if two values are loosely equal - that is,
	 * if they are plain objects, do they have the same shape?
	 */
	function looseEqual (a, b) {
	  if (a === b) { return true }
	  var isObjectA = isObject(a);
	  var isObjectB = isObject(b);
	  if (isObjectA && isObjectB) {
	    try {
	      var isArrayA = Array.isArray(a);
	      var isArrayB = Array.isArray(b);
	      if (isArrayA && isArrayB) {
	        return a.length === b.length && a.every(function (e, i) {
	          return looseEqual(e, b[i])
	        })
	      } else if (!isArrayA && !isArrayB) {
	        var keysA = Object.keys(a);
	        var keysB = Object.keys(b);
	        return keysA.length === keysB.length && keysA.every(function (key) {
	          return looseEqual(a[key], b[key])
	        })
	      } else {
	        /* istanbul ignore next */
	        return false
	      }
	    } catch (e) {
	      /* istanbul ignore next */
	      return false
	    }
	  } else if (!isObjectA && !isObjectB) {
	    return String(a) === String(b)
	  } else {
	    return false
	  }
	}
	
	function looseIndexOf (arr, val) {
	  for (var i = 0; i < arr.length; i++) {
	    if (looseEqual(arr[i], val)) { return i }
	  }
	  return -1
	}
	
	/**
	 * Ensure a function is called only once.
	 */
	function once (fn) {
	  var called = false;
	  return function () {
	    if (!called) {
	      called = true;
	      fn.apply(this, arguments);
	    }
	  }
	}
	
	var SSR_ATTR = 'data-server-rendered';
	
	var ASSET_TYPES = [
	  'component',
	  'directive',
	  'filter'
	];
	
	var LIFECYCLE_HOOKS = [
	  'beforeCreate',
	  'created',
	  'beforeMount',
	  'mounted',
	  'beforeUpdate',
	  'updated',
	  'beforeDestroy',
	  'destroyed',
	  'activated',
	  'deactivated',
	  'errorCaptured'
	];
	
	/*  */
	
	var config = ({
	  /**
	   * Option merge strategies (used in core/util/options)
	   */
	  // $flow-disable-line
	  optionMergeStrategies: Object.create(null),
	
	  /**
	   * Whether to suppress warnings.
	   */
	  silent: false,
	
	  /**
	   * Show production mode tip message on boot?
	   */
	  productionTip: ("production") !== 'production',
	
	  /**
	   * Whether to enable devtools
	   */
	  devtools: ("production") !== 'production',
	
	  /**
	   * Whether to record perf
	   */
	  performance: false,
	
	  /**
	   * Error handler for watcher errors
	   */
	  errorHandler: null,
	
	  /**
	   * Warn handler for watcher warns
	   */
	  warnHandler: null,
	
	  /**
	   * Ignore certain custom elements
	   */
	  ignoredElements: [],
	
	  /**
	   * Custom user key aliases for v-on
	   */
	  // $flow-disable-line
	  keyCodes: Object.create(null),
	
	  /**
	   * Check if a tag is reserved so that it cannot be registered as a
	   * component. This is platform-dependent and may be overwritten.
	   */
	  isReservedTag: no,
	
	  /**
	   * Check if an attribute is reserved so that it cannot be used as a component
	   * prop. This is platform-dependent and may be overwritten.
	   */
	  isReservedAttr: no,
	
	  /**
	   * Check if a tag is an unknown element.
	   * Platform-dependent.
	   */
	  isUnknownElement: no,
	
	  /**
	   * Get the namespace of an element
	   */
	  getTagNamespace: noop,
	
	  /**
	   * Parse the real tag name for the specific platform.
	   */
	  parsePlatformTagName: identity,
	
	  /**
	   * Check if an attribute must be bound using property, e.g. value
	   * Platform-dependent.
	   */
	  mustUseProp: no,
	
	  /**
	   * Exposed for legacy reasons
	   */
	  _lifecycleHooks: LIFECYCLE_HOOKS
	})
	
	/*  */
	
	/**
	 * Check if a string starts with $ or _
	 */
	function isReserved (str) {
	  var c = (str + '').charCodeAt(0);
	  return c === 0x24 || c === 0x5F
	}
	
	/**
	 * Define a property.
	 */
	function def (obj, key, val, enumerable) {
	  Object.defineProperty(obj, key, {
	    value: val,
	    enumerable: !!enumerable,
	    writable: true,
	    configurable: true
	  });
	}
	
	/**
	 * Parse simple path.
	 */
	var bailRE = /[^\w.$]/;
	function parsePath (path) {
	  if (bailRE.test(path)) {
	    return
	  }
	  var segments = path.split('.');
	  return function (obj) {
	    for (var i = 0; i < segments.length; i++) {
	      if (!obj) { return }
	      obj = obj[segments[i]];
	    }
	    return obj
	  }
	}
	
	/*  */
	
	// can we use __proto__?
	var hasProto = '__proto__' in {};
	
	// Browser environment sniffing
	var inBrowser = typeof window !== 'undefined';
	var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
	var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
	var UA = inBrowser && window.navigator.userAgent.toLowerCase();
	var isIE = UA && /msie|trident/.test(UA);
	var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
	var isEdge = UA && UA.indexOf('edge/') > 0;
	var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
	var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
	var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
	
	// Firefox has a "watch" function on Object.prototype...
	var nativeWatch = ({}).watch;
	
	var supportsPassive = false;
	if (inBrowser) {
	  try {
	    var opts = {};
	    Object.defineProperty(opts, 'passive', ({
	      get: function get () {
	        /* istanbul ignore next */
	        supportsPassive = true;
	      }
	    })); // https://github.com/facebook/flow/issues/285
	    window.addEventListener('test-passive', null, opts);
	  } catch (e) {}
	}
	
	// this needs to be lazy-evaled because vue may be required before
	// vue-server-renderer can set VUE_ENV
	var _isServer;
	var isServerRendering = function () {
	  if (_isServer === undefined) {
	    /* istanbul ignore if */
	    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
	      // detect presence of vue-server-renderer and avoid
	      // Webpack shimming the process
	      _isServer = global['process'].env.VUE_ENV === 'server';
	    } else {
	      _isServer = false;
	    }
	  }
	  return _isServer
	};
	
	// detect devtools
	var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	/* istanbul ignore next */
	function isNative (Ctor) {
	  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
	}
	
	var hasSymbol =
	  typeof Symbol !== 'undefined' && isNative(Symbol) &&
	  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);
	
	var _Set;
	/* istanbul ignore if */ // $flow-disable-line
	if (typeof Set !== 'undefined' && isNative(Set)) {
	  // use native Set when available.
	  _Set = Set;
	} else {
	  // a non-standard Set polyfill that only works with primitive keys.
	  _Set = (function () {
	    function Set () {
	      this.set = Object.create(null);
	    }
	    Set.prototype.has = function has (key) {
	      return this.set[key] === true
	    };
	    Set.prototype.add = function add (key) {
	      this.set[key] = true;
	    };
	    Set.prototype.clear = function clear () {
	      this.set = Object.create(null);
	    };
	
	    return Set;
	  }());
	}
	
	/*  */
	
	var warn = noop;
	var tip = noop;
	var generateComponentTrace = (noop); // work around flow check
	var formatComponentName = (noop);
	
	if (false) {
	  var hasConsole = typeof console !== 'undefined';
	  var classifyRE = /(?:^|[-_])(\w)/g;
	  var classify = function (str) { return str
	    .replace(classifyRE, function (c) { return c.toUpperCase(); })
	    .replace(/[-_]/g, ''); };
	
	  warn = function (msg, vm) {
	    var trace = vm ? generateComponentTrace(vm) : '';
	
	    if (config.warnHandler) {
	      config.warnHandler.call(null, msg, vm, trace);
	    } else if (hasConsole && (!config.silent)) {
	      console.error(("[Vue warn]: " + msg + trace));
	    }
	  };
	
	  tip = function (msg, vm) {
	    if (hasConsole && (!config.silent)) {
	      console.warn("[Vue tip]: " + msg + (
	        vm ? generateComponentTrace(vm) : ''
	      ));
	    }
	  };
	
	  formatComponentName = function (vm, includeFile) {
	    if (vm.$root === vm) {
	      return '<Root>'
	    }
	    var options = typeof vm === 'function' && vm.cid != null
	      ? vm.options
	      : vm._isVue
	        ? vm.$options || vm.constructor.options
	        : vm || {};
	    var name = options.name || options._componentTag;
	    var file = options.__file;
	    if (!name && file) {
	      var match = file.match(/([^/\\]+)\.vue$/);
	      name = match && match[1];
	    }
	
	    return (
	      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
	      (file && includeFile !== false ? (" at " + file) : '')
	    )
	  };
	
	  var repeat = function (str, n) {
	    var res = '';
	    while (n) {
	      if (n % 2 === 1) { res += str; }
	      if (n > 1) { str += str; }
	      n >>= 1;
	    }
	    return res
	  };
	
	  generateComponentTrace = function (vm) {
	    if (vm._isVue && vm.$parent) {
	      var tree = [];
	      var currentRecursiveSequence = 0;
	      while (vm) {
	        if (tree.length > 0) {
	          var last = tree[tree.length - 1];
	          if (last.constructor === vm.constructor) {
	            currentRecursiveSequence++;
	            vm = vm.$parent;
	            continue
	          } else if (currentRecursiveSequence > 0) {
	            tree[tree.length - 1] = [last, currentRecursiveSequence];
	            currentRecursiveSequence = 0;
	          }
	        }
	        tree.push(vm);
	        vm = vm.$parent;
	      }
	      return '\n\nfound in\n\n' + tree
	        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
	            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
	            : formatComponentName(vm))); })
	        .join('\n')
	    } else {
	      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
	    }
	  };
	}
	
	/*  */
	
	
	var uid = 0;
	
	/**
	 * A dep is an observable that can have multiple
	 * directives subscribing to it.
	 */
	var Dep = function Dep () {
	  this.id = uid++;
	  this.subs = [];
	};
	
	Dep.prototype.addSub = function addSub (sub) {
	  this.subs.push(sub);
	};
	
	Dep.prototype.removeSub = function removeSub (sub) {
	  remove(this.subs, sub);
	};
	
	Dep.prototype.depend = function depend () {
	  if (Dep.target) {
	    Dep.target.addDep(this);
	  }
	};
	
	Dep.prototype.notify = function notify () {
	  // stabilize the subscriber list first
	  var subs = this.subs.slice();
	  for (var i = 0, l = subs.length; i < l; i++) {
	    subs[i].update();
	  }
	};
	
	// the current target watcher being evaluated.
	// this is globally unique because there could be only one
	// watcher being evaluated at any time.
	Dep.target = null;
	var targetStack = [];
	
	function pushTarget (_target) {
	  if (Dep.target) { targetStack.push(Dep.target); }
	  Dep.target = _target;
	}
	
	function popTarget () {
	  Dep.target = targetStack.pop();
	}
	
	/*  */
	
	var VNode = function VNode (
	  tag,
	  data,
	  children,
	  text,
	  elm,
	  context,
	  componentOptions,
	  asyncFactory
	) {
	  this.tag = tag;
	  this.data = data;
	  this.children = children;
	  this.text = text;
	  this.elm = elm;
	  this.ns = undefined;
	  this.context = context;
	  this.fnContext = undefined;
	  this.fnOptions = undefined;
	  this.fnScopeId = undefined;
	  this.key = data && data.key;
	  this.componentOptions = componentOptions;
	  this.componentInstance = undefined;
	  this.parent = undefined;
	  this.raw = false;
	  this.isStatic = false;
	  this.isRootInsert = true;
	  this.isComment = false;
	  this.isCloned = false;
	  this.isOnce = false;
	  this.asyncFactory = asyncFactory;
	  this.asyncMeta = undefined;
	  this.isAsyncPlaceholder = false;
	};
	
	var prototypeAccessors = { child: { configurable: true } };
	
	// DEPRECATED: alias for componentInstance for backwards compat.
	/* istanbul ignore next */
	prototypeAccessors.child.get = function () {
	  return this.componentInstance
	};
	
	Object.defineProperties( VNode.prototype, prototypeAccessors );
	
	var createEmptyVNode = function (text) {
	  if ( text === void 0 ) text = '';
	
	  var node = new VNode();
	  node.text = text;
	  node.isComment = true;
	  return node
	};
	
	function createTextVNode (val) {
	  return new VNode(undefined, undefined, undefined, String(val))
	}
	
	// optimized shallow clone
	// used for static nodes and slot nodes because they may be reused across
	// multiple renders, cloning them avoids errors when DOM manipulations rely
	// on their elm reference.
	function cloneVNode (vnode) {
	  var cloned = new VNode(
	    vnode.tag,
	    vnode.data,
	    vnode.children,
	    vnode.text,
	    vnode.elm,
	    vnode.context,
	    vnode.componentOptions,
	    vnode.asyncFactory
	  );
	  cloned.ns = vnode.ns;
	  cloned.isStatic = vnode.isStatic;
	  cloned.key = vnode.key;
	  cloned.isComment = vnode.isComment;
	  cloned.fnContext = vnode.fnContext;
	  cloned.fnOptions = vnode.fnOptions;
	  cloned.fnScopeId = vnode.fnScopeId;
	  cloned.isCloned = true;
	  return cloned
	}
	
	/*
	 * not type checking this file because flow doesn't play well with
	 * dynamically accessing methods on Array prototype
	 */
	
	var arrayProto = Array.prototype;
	var arrayMethods = Object.create(arrayProto);
	
	var methodsToPatch = [
	  'push',
	  'pop',
	  'shift',
	  'unshift',
	  'splice',
	  'sort',
	  'reverse'
	];
	
	/**
	 * Intercept mutating methods and emit events
	 */
	methodsToPatch.forEach(function (method) {
	  // cache original method
	  var original = arrayProto[method];
	  def(arrayMethods, method, function mutator () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var result = original.apply(this, args);
	    var ob = this.__ob__;
	    var inserted;
	    switch (method) {
	      case 'push':
	      case 'unshift':
	        inserted = args;
	        break
	      case 'splice':
	        inserted = args.slice(2);
	        break
	    }
	    if (inserted) { ob.observeArray(inserted); }
	    // notify change
	    ob.dep.notify();
	    return result
	  });
	});
	
	/*  */
	
	var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
	
	/**
	 * In some cases we may want to disable observation inside a component's
	 * update computation.
	 */
	var shouldObserve = true;
	
	function toggleObserving (value) {
	  shouldObserve = value;
	}
	
	/**
	 * Observer class that is attached to each observed
	 * object. Once attached, the observer converts the target
	 * object's property keys into getter/setters that
	 * collect dependencies and dispatch updates.
	 */
	var Observer = function Observer (value) {
	  this.value = value;
	  this.dep = new Dep();
	  this.vmCount = 0;
	  def(value, '__ob__', this);
	  if (Array.isArray(value)) {
	    var augment = hasProto
	      ? protoAugment
	      : copyAugment;
	    augment(value, arrayMethods, arrayKeys);
	    this.observeArray(value);
	  } else {
	    this.walk(value);
	  }
	};
	
	/**
	 * Walk through each property and convert them into
	 * getter/setters. This method should only be called when
	 * value type is Object.
	 */
	Observer.prototype.walk = function walk (obj) {
	  var keys = Object.keys(obj);
	  for (var i = 0; i < keys.length; i++) {
	    defineReactive(obj, keys[i]);
	  }
	};
	
	/**
	 * Observe a list of Array items.
	 */
	Observer.prototype.observeArray = function observeArray (items) {
	  for (var i = 0, l = items.length; i < l; i++) {
	    observe(items[i]);
	  }
	};
	
	// helpers
	
	/**
	 * Augment an target Object or Array by intercepting
	 * the prototype chain using __proto__
	 */
	function protoAugment (target, src, keys) {
	  /* eslint-disable no-proto */
	  target.__proto__ = src;
	  /* eslint-enable no-proto */
	}
	
	/**
	 * Augment an target Object or Array by defining
	 * hidden properties.
	 */
	/* istanbul ignore next */
	function copyAugment (target, src, keys) {
	  for (var i = 0, l = keys.length; i < l; i++) {
	    var key = keys[i];
	    def(target, key, src[key]);
	  }
	}
	
	/**
	 * Attempt to create an observer instance for a value,
	 * returns the new observer if successfully observed,
	 * or the existing observer if the value already has one.
	 */
	function observe (value, asRootData) {
	  if (!isObject(value) || value instanceof VNode) {
	    return
	  }
	  var ob;
	  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
	    ob = value.__ob__;
	  } else if (
	    shouldObserve &&
	    !isServerRendering() &&
	    (Array.isArray(value) || isPlainObject(value)) &&
	    Object.isExtensible(value) &&
	    !value._isVue
	  ) {
	    ob = new Observer(value);
	  }
	  if (asRootData && ob) {
	    ob.vmCount++;
	  }
	  return ob
	}
	
	/**
	 * Define a reactive property on an Object.
	 */
	function defineReactive (
	  obj,
	  key,
	  val,
	  customSetter,
	  shallow
	) {
	  var dep = new Dep();
	
	  var property = Object.getOwnPropertyDescriptor(obj, key);
	  if (property && property.configurable === false) {
	    return
	  }
	
	  // cater for pre-defined getter/setters
	  var getter = property && property.get;
	  if (!getter && arguments.length === 2) {
	    val = obj[key];
	  }
	  var setter = property && property.set;
	
	  var childOb = !shallow && observe(val);
	  Object.defineProperty(obj, key, {
	    enumerable: true,
	    configurable: true,
	    get: function reactiveGetter () {
	      var value = getter ? getter.call(obj) : val;
	      if (Dep.target) {
	        dep.depend();
	        if (childOb) {
	          childOb.dep.depend();
	          if (Array.isArray(value)) {
	            dependArray(value);
	          }
	        }
	      }
	      return value
	    },
	    set: function reactiveSetter (newVal) {
	      var value = getter ? getter.call(obj) : val;
	      /* eslint-disable no-self-compare */
	      if (newVal === value || (newVal !== newVal && value !== value)) {
	        return
	      }
	      /* eslint-enable no-self-compare */
	      if (false) {
	        customSetter();
	      }
	      if (setter) {
	        setter.call(obj, newVal);
	      } else {
	        val = newVal;
	      }
	      childOb = !shallow && observe(newVal);
	      dep.notify();
	    }
	  });
	}
	
	/**
	 * Set a property on an object. Adds the new property and
	 * triggers change notification if the property doesn't
	 * already exist.
	 */
	function set (target, key, val) {
	  if (false
	  ) {
	    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
	  }
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.length = Math.max(target.length, key);
	    target.splice(key, 1, val);
	    return val
	  }
	  if (key in target && !(key in Object.prototype)) {
	    target[key] = val;
	    return val
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid adding reactive properties to a Vue instance or its root $data ' +
	      'at runtime - declare it upfront in the data option.'
	    );
	    return val
	  }
	  if (!ob) {
	    target[key] = val;
	    return val
	  }
	  defineReactive(ob.value, key, val);
	  ob.dep.notify();
	  return val
	}
	
	/**
	 * Delete a property and trigger change if necessary.
	 */
	function del (target, key) {
	  if (false
	  ) {
	    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
	  }
	  if (Array.isArray(target) && isValidArrayIndex(key)) {
	    target.splice(key, 1);
	    return
	  }
	  var ob = (target).__ob__;
	  if (target._isVue || (ob && ob.vmCount)) {
	    ("production") !== 'production' && warn(
	      'Avoid deleting properties on a Vue instance or its root $data ' +
	      '- just set it to null.'
	    );
	    return
	  }
	  if (!hasOwn(target, key)) {
	    return
	  }
	  delete target[key];
	  if (!ob) {
	    return
	  }
	  ob.dep.notify();
	}
	
	/**
	 * Collect dependencies on array elements when the array is touched, since
	 * we cannot intercept array element access like property getters.
	 */
	function dependArray (value) {
	  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
	    e = value[i];
	    e && e.__ob__ && e.__ob__.dep.depend();
	    if (Array.isArray(e)) {
	      dependArray(e);
	    }
	  }
	}
	
	/*  */
	
	/**
	 * Option overwriting strategies are functions that handle
	 * how to merge a parent option value and a child option
	 * value into the final value.
	 */
	var strats = config.optionMergeStrategies;
	
	/**
	 * Options with restrictions
	 */
	if (false) {
	  strats.el = strats.propsData = function (parent, child, vm, key) {
	    if (!vm) {
	      warn(
	        "option \"" + key + "\" can only be used during instance " +
	        'creation with the `new` keyword.'
	      );
	    }
	    return defaultStrat(parent, child)
	  };
	}
	
	/**
	 * Helper that recursively merges two data objects together.
	 */
	function mergeData (to, from) {
	  if (!from) { return to }
	  var key, toVal, fromVal;
	  var keys = Object.keys(from);
	  for (var i = 0; i < keys.length; i++) {
	    key = keys[i];
	    toVal = to[key];
	    fromVal = from[key];
	    if (!hasOwn(to, key)) {
	      set(to, key, fromVal);
	    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
	      mergeData(toVal, fromVal);
	    }
	  }
	  return to
	}
	
	/**
	 * Data
	 */
	function mergeDataOrFn (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    // in a Vue.extend merge, both should be functions
	    if (!childVal) {
	      return parentVal
	    }
	    if (!parentVal) {
	      return childVal
	    }
	    // when parentVal & childVal are both present,
	    // we need to return a function that returns the
	    // merged result of both functions... no need to
	    // check if parentVal is a function here because
	    // it has to be a function to pass previous merges.
	    return function mergedDataFn () {
	      return mergeData(
	        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
	        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
	      )
	    }
	  } else {
	    return function mergedInstanceDataFn () {
	      // instance merge
	      var instanceData = typeof childVal === 'function'
	        ? childVal.call(vm, vm)
	        : childVal;
	      var defaultData = typeof parentVal === 'function'
	        ? parentVal.call(vm, vm)
	        : parentVal;
	      if (instanceData) {
	        return mergeData(instanceData, defaultData)
	      } else {
	        return defaultData
	      }
	    }
	  }
	}
	
	strats.data = function (
	  parentVal,
	  childVal,
	  vm
	) {
	  if (!vm) {
	    if (childVal && typeof childVal !== 'function') {
	      ("production") !== 'production' && warn(
	        'The "data" option should be a function ' +
	        'that returns a per-instance value in component ' +
	        'definitions.',
	        vm
	      );
	
	      return parentVal
	    }
	    return mergeDataOrFn(parentVal, childVal)
	  }
	
	  return mergeDataOrFn(parentVal, childVal, vm)
	};
	
	/**
	 * Hooks and props are merged as arrays.
	 */
	function mergeHook (
	  parentVal,
	  childVal
	) {
	  return childVal
	    ? parentVal
	      ? parentVal.concat(childVal)
	      : Array.isArray(childVal)
	        ? childVal
	        : [childVal]
	    : parentVal
	}
	
	LIFECYCLE_HOOKS.forEach(function (hook) {
	  strats[hook] = mergeHook;
	});
	
	/**
	 * Assets
	 *
	 * When a vm is present (instance creation), we need to do
	 * a three-way merge between constructor options, instance
	 * options and parent options.
	 */
	function mergeAssets (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  var res = Object.create(parentVal || null);
	  if (childVal) {
	    ("production") !== 'production' && assertObjectType(key, childVal, vm);
	    return extend(res, childVal)
	  } else {
	    return res
	  }
	}
	
	ASSET_TYPES.forEach(function (type) {
	  strats[type + 's'] = mergeAssets;
	});
	
	/**
	 * Watchers.
	 *
	 * Watchers hashes should not overwrite one
	 * another, so we merge them as arrays.
	 */
	strats.watch = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  // work around Firefox's Object.prototype.watch...
	  if (parentVal === nativeWatch) { parentVal = undefined; }
	  if (childVal === nativeWatch) { childVal = undefined; }
	  /* istanbul ignore if */
	  if (!childVal) { return Object.create(parentVal || null) }
	  if (false) {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = {};
	  extend(ret, parentVal);
	  for (var key$1 in childVal) {
	    var parent = ret[key$1];
	    var child = childVal[key$1];
	    if (parent && !Array.isArray(parent)) {
	      parent = [parent];
	    }
	    ret[key$1] = parent
	      ? parent.concat(child)
	      : Array.isArray(child) ? child : [child];
	  }
	  return ret
	};
	
	/**
	 * Other object hashes.
	 */
	strats.props =
	strats.methods =
	strats.inject =
	strats.computed = function (
	  parentVal,
	  childVal,
	  vm,
	  key
	) {
	  if (childVal && ("production") !== 'production') {
	    assertObjectType(key, childVal, vm);
	  }
	  if (!parentVal) { return childVal }
	  var ret = Object.create(null);
	  extend(ret, parentVal);
	  if (childVal) { extend(ret, childVal); }
	  return ret
	};
	strats.provide = mergeDataOrFn;
	
	/**
	 * Default strategy.
	 */
	var defaultStrat = function (parentVal, childVal) {
	  return childVal === undefined
	    ? parentVal
	    : childVal
	};
	
	/**
	 * Validate component names
	 */
	function checkComponents (options) {
	  for (var key in options.components) {
	    validateComponentName(key);
	  }
	}
	
	function validateComponentName (name) {
	  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
	    warn(
	      'Invalid component name: "' + name + '". Component names ' +
	      'can only contain alphanumeric characters and the hyphen, ' +
	      'and must start with a letter.'
	    );
	  }
	  if (isBuiltInTag(name) || config.isReservedTag(name)) {
	    warn(
	      'Do not use built-in or reserved HTML elements as component ' +
	      'id: ' + name
	    );
	  }
	}
	
	/**
	 * Ensure all props option syntax are normalized into the
	 * Object-based format.
	 */
	function normalizeProps (options, vm) {
	  var props = options.props;
	  if (!props) { return }
	  var res = {};
	  var i, val, name;
	  if (Array.isArray(props)) {
	    i = props.length;
	    while (i--) {
	      val = props[i];
	      if (typeof val === 'string') {
	        name = camelize(val);
	        res[name] = { type: null };
	      } else if (false) {
	        warn('props must be strings when using array syntax.');
	      }
	    }
	  } else if (isPlainObject(props)) {
	    for (var key in props) {
	      val = props[key];
	      name = camelize(key);
	      res[name] = isPlainObject(val)
	        ? val
	        : { type: val };
	    }
	  } else if (false) {
	    warn(
	      "Invalid value for option \"props\": expected an Array or an Object, " +
	      "but got " + (toRawType(props)) + ".",
	      vm
	    );
	  }
	  options.props = res;
	}
	
	/**
	 * Normalize all injections into Object-based format
	 */
	function normalizeInject (options, vm) {
	  var inject = options.inject;
	  if (!inject) { return }
	  var normalized = options.inject = {};
	  if (Array.isArray(inject)) {
	    for (var i = 0; i < inject.length; i++) {
	      normalized[inject[i]] = { from: inject[i] };
	    }
	  } else if (isPlainObject(inject)) {
	    for (var key in inject) {
	      var val = inject[key];
	      normalized[key] = isPlainObject(val)
	        ? extend({ from: key }, val)
	        : { from: val };
	    }
	  } else if (false) {
	    warn(
	      "Invalid value for option \"inject\": expected an Array or an Object, " +
	      "but got " + (toRawType(inject)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Normalize raw function directives into object format.
	 */
	function normalizeDirectives (options) {
	  var dirs = options.directives;
	  if (dirs) {
	    for (var key in dirs) {
	      var def = dirs[key];
	      if (typeof def === 'function') {
	        dirs[key] = { bind: def, update: def };
	      }
	    }
	  }
	}
	
	function assertObjectType (name, value, vm) {
	  if (!isPlainObject(value)) {
	    warn(
	      "Invalid value for option \"" + name + "\": expected an Object, " +
	      "but got " + (toRawType(value)) + ".",
	      vm
	    );
	  }
	}
	
	/**
	 * Merge two option objects into a new one.
	 * Core utility used in both instantiation and inheritance.
	 */
	function mergeOptions (
	  parent,
	  child,
	  vm
	) {
	  if (false) {
	    checkComponents(child);
	  }
	
	  if (typeof child === 'function') {
	    child = child.options;
	  }
	
	  normalizeProps(child, vm);
	  normalizeInject(child, vm);
	  normalizeDirectives(child);
	  var extendsFrom = child.extends;
	  if (extendsFrom) {
	    parent = mergeOptions(parent, extendsFrom, vm);
	  }
	  if (child.mixins) {
	    for (var i = 0, l = child.mixins.length; i < l; i++) {
	      parent = mergeOptions(parent, child.mixins[i], vm);
	    }
	  }
	  var options = {};
	  var key;
	  for (key in parent) {
	    mergeField(key);
	  }
	  for (key in child) {
	    if (!hasOwn(parent, key)) {
	      mergeField(key);
	    }
	  }
	  function mergeField (key) {
	    var strat = strats[key] || defaultStrat;
	    options[key] = strat(parent[key], child[key], vm, key);
	  }
	  return options
	}
	
	/**
	 * Resolve an asset.
	 * This function is used because child instances need access
	 * to assets defined in its ancestor chain.
	 */
	function resolveAsset (
	  options,
	  type,
	  id,
	  warnMissing
	) {
	  /* istanbul ignore if */
	  if (typeof id !== 'string') {
	    return
	  }
	  var assets = options[type];
	  // check local registration variations first
	  if (hasOwn(assets, id)) { return assets[id] }
	  var camelizedId = camelize(id);
	  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
	  var PascalCaseId = capitalize(camelizedId);
	  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
	  // fallback to prototype chain
	  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
	  if (false) {
	    warn(
	      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
	      options
	    );
	  }
	  return res
	}
	
	/*  */
	
	function validateProp (
	  key,
	  propOptions,
	  propsData,
	  vm
	) {
	  var prop = propOptions[key];
	  var absent = !hasOwn(propsData, key);
	  var value = propsData[key];
	  // boolean casting
	  var booleanIndex = getTypeIndex(Boolean, prop.type);
	  if (booleanIndex > -1) {
	    if (absent && !hasOwn(prop, 'default')) {
	      value = false;
	    } else if (value === '' || value === hyphenate(key)) {
	      // only cast empty string / same name to boolean if
	      // boolean has higher priority
	      var stringIndex = getTypeIndex(String, prop.type);
	      if (stringIndex < 0 || booleanIndex < stringIndex) {
	        value = true;
	      }
	    }
	  }
	  // check default value
	  if (value === undefined) {
	    value = getPropDefaultValue(vm, prop, key);
	    // since the default value is a fresh copy,
	    // make sure to observe it.
	    var prevShouldObserve = shouldObserve;
	    toggleObserving(true);
	    observe(value);
	    toggleObserving(prevShouldObserve);
	  }
	  if (
	    false
	  ) {
	    assertProp(prop, key, value, vm, absent);
	  }
	  return value
	}
	
	/**
	 * Get the default value of a prop.
	 */
	function getPropDefaultValue (vm, prop, key) {
	  // no default, return undefined
	  if (!hasOwn(prop, 'default')) {
	    return undefined
	  }
	  var def = prop.default;
	  // warn against non-factory defaults for Object & Array
	  if (false) {
	    warn(
	      'Invalid default value for prop "' + key + '": ' +
	      'Props with type Object/Array must use a factory function ' +
	      'to return the default value.',
	      vm
	    );
	  }
	  // the raw prop value was also undefined from previous render,
	  // return previous default value to avoid unnecessary watcher trigger
	  if (vm && vm.$options.propsData &&
	    vm.$options.propsData[key] === undefined &&
	    vm._props[key] !== undefined
	  ) {
	    return vm._props[key]
	  }
	  // call factory function for non-Function types
	  // a value is Function if its prototype is function even across different execution context
	  return typeof def === 'function' && getType(prop.type) !== 'Function'
	    ? def.call(vm)
	    : def
	}
	
	/**
	 * Assert whether a prop is valid.
	 */
	function assertProp (
	  prop,
	  name,
	  value,
	  vm,
	  absent
	) {
	  if (prop.required && absent) {
	    warn(
	      'Missing required prop: "' + name + '"',
	      vm
	    );
	    return
	  }
	  if (value == null && !prop.required) {
	    return
	  }
	  var type = prop.type;
	  var valid = !type || type === true;
	  var expectedTypes = [];
	  if (type) {
	    if (!Array.isArray(type)) {
	      type = [type];
	    }
	    for (var i = 0; i < type.length && !valid; i++) {
	      var assertedType = assertType(value, type[i]);
	      expectedTypes.push(assertedType.expectedType || '');
	      valid = assertedType.valid;
	    }
	  }
	  if (!valid) {
	    warn(
	      "Invalid prop: type check failed for prop \"" + name + "\"." +
	      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
	      ", got " + (toRawType(value)) + ".",
	      vm
	    );
	    return
	  }
	  var validator = prop.validator;
	  if (validator) {
	    if (!validator(value)) {
	      warn(
	        'Invalid prop: custom validator check failed for prop "' + name + '".',
	        vm
	      );
	    }
	  }
	}
	
	var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;
	
	function assertType (value, type) {
	  var valid;
	  var expectedType = getType(type);
	  if (simpleCheckRE.test(expectedType)) {
	    var t = typeof value;
	    valid = t === expectedType.toLowerCase();
	    // for primitive wrapper objects
	    if (!valid && t === 'object') {
	      valid = value instanceof type;
	    }
	  } else if (expectedType === 'Object') {
	    valid = isPlainObject(value);
	  } else if (expectedType === 'Array') {
	    valid = Array.isArray(value);
	  } else {
	    valid = value instanceof type;
	  }
	  return {
	    valid: valid,
	    expectedType: expectedType
	  }
	}
	
	/**
	 * Use function string name to check built-in types,
	 * because a simple equality check will fail when running
	 * across different vms / iframes.
	 */
	function getType (fn) {
	  var match = fn && fn.toString().match(/^\s*function (\w+)/);
	  return match ? match[1] : ''
	}
	
	function isSameType (a, b) {
	  return getType(a) === getType(b)
	}
	
	function getTypeIndex (type, expectedTypes) {
	  if (!Array.isArray(expectedTypes)) {
	    return isSameType(expectedTypes, type) ? 0 : -1
	  }
	  for (var i = 0, len = expectedTypes.length; i < len; i++) {
	    if (isSameType(expectedTypes[i], type)) {
	      return i
	    }
	  }
	  return -1
	}
	
	/*  */
	
	function handleError (err, vm, info) {
	  if (vm) {
	    var cur = vm;
	    while ((cur = cur.$parent)) {
	      var hooks = cur.$options.errorCaptured;
	      if (hooks) {
	        for (var i = 0; i < hooks.length; i++) {
	          try {
	            var capture = hooks[i].call(cur, err, vm, info) === false;
	            if (capture) { return }
	          } catch (e) {
	            globalHandleError(e, cur, 'errorCaptured hook');
	          }
	        }
	      }
	    }
	  }
	  globalHandleError(err, vm, info);
	}
	
	function globalHandleError (err, vm, info) {
	  if (config.errorHandler) {
	    try {
	      return config.errorHandler.call(null, err, vm, info)
	    } catch (e) {
	      logError(e, null, 'config.errorHandler');
	    }
	  }
	  logError(err, vm, info);
	}
	
	function logError (err, vm, info) {
	  if (false) {
	    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
	  }
	  /* istanbul ignore else */
	  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
	    console.error(err);
	  } else {
	    throw err
	  }
	}
	
	/*  */
	/* globals MessageChannel */
	
	var callbacks = [];
	var pending = false;
	
	function flushCallbacks () {
	  pending = false;
	  var copies = callbacks.slice(0);
	  callbacks.length = 0;
	  for (var i = 0; i < copies.length; i++) {
	    copies[i]();
	  }
	}
	
	// Here we have async deferring wrappers using both microtasks and (macro) tasks.
	// In < 2.4 we used microtasks everywhere, but there are some scenarios where
	// microtasks have too high a priority and fire in between supposedly
	// sequential events (e.g. #4521, #6690) or even between bubbling of the same
	// event (#6566). However, using (macro) tasks everywhere also has subtle problems
	// when state is changed right before repaint (e.g. #6813, out-in transitions).
	// Here we use microtask by default, but expose a way to force (macro) task when
	// needed (e.g. in event handlers attached by v-on).
	var microTimerFunc;
	var macroTimerFunc;
	var useMacroTask = false;
	
	// Determine (macro) task defer implementation.
	// Technically setImmediate should be the ideal choice, but it's only available
	// in IE. The only polyfill that consistently queues the callback after all DOM
	// events triggered in the same loop is by using MessageChannel.
	/* istanbul ignore if */
	if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
	  macroTimerFunc = function () {
	    setImmediate(flushCallbacks);
	  };
	} else if (typeof MessageChannel !== 'undefined' && (
	  isNative(MessageChannel) ||
	  // PhantomJS
	  MessageChannel.toString() === '[object MessageChannelConstructor]'
	)) {
	  var channel = new MessageChannel();
	  var port = channel.port2;
	  channel.port1.onmessage = flushCallbacks;
	  macroTimerFunc = function () {
	    port.postMessage(1);
	  };
	} else {
	  /* istanbul ignore next */
	  macroTimerFunc = function () {
	    setTimeout(flushCallbacks, 0);
	  };
	}
	
	// Determine microtask defer implementation.
	/* istanbul ignore next, $flow-disable-line */
	if (typeof Promise !== 'undefined' && isNative(Promise)) {
	  var p = Promise.resolve();
	  microTimerFunc = function () {
	    p.then(flushCallbacks);
	    // in problematic UIWebViews, Promise.then doesn't completely break, but
	    // it can get stuck in a weird state where callbacks are pushed into the
	    // microtask queue but the queue isn't being flushed, until the browser
	    // needs to do some other work, e.g. handle a timer. Therefore we can
	    // "force" the microtask queue to be flushed by adding an empty timer.
	    if (isIOS) { setTimeout(noop); }
	  };
	} else {
	  // fallback to macro
	  microTimerFunc = macroTimerFunc;
	}
	
	/**
	 * Wrap a function so that if any code inside triggers state change,
	 * the changes are queued using a (macro) task instead of a microtask.
	 */
	function withMacroTask (fn) {
	  return fn._withTask || (fn._withTask = function () {
	    useMacroTask = true;
	    var res = fn.apply(null, arguments);
	    useMacroTask = false;
	    return res
	  })
	}
	
	function nextTick (cb, ctx) {
	  var _resolve;
	  callbacks.push(function () {
	    if (cb) {
	      try {
	        cb.call(ctx);
	      } catch (e) {
	        handleError(e, ctx, 'nextTick');
	      }
	    } else if (_resolve) {
	      _resolve(ctx);
	    }
	  });
	  if (!pending) {
	    pending = true;
	    if (useMacroTask) {
	      macroTimerFunc();
	    } else {
	      microTimerFunc();
	    }
	  }
	  // $flow-disable-line
	  if (!cb && typeof Promise !== 'undefined') {
	    return new Promise(function (resolve) {
	      _resolve = resolve;
	    })
	  }
	}
	
	/*  */
	
	var mark;
	var measure;
	
	if (false) {
	  var perf = inBrowser && window.performance;
	  /* istanbul ignore if */
	  if (
	    perf &&
	    perf.mark &&
	    perf.measure &&
	    perf.clearMarks &&
	    perf.clearMeasures
	  ) {
	    mark = function (tag) { return perf.mark(tag); };
	    measure = function (name, startTag, endTag) {
	      perf.measure(name, startTag, endTag);
	      perf.clearMarks(startTag);
	      perf.clearMarks(endTag);
	      perf.clearMeasures(name);
	    };
	  }
	}
	
	/* not type checking this file because flow doesn't play well with Proxy */
	
	var initProxy;
	
	if (false) {
	  var allowedGlobals = makeMap(
	    'Infinity,undefined,NaN,isFinite,isNaN,' +
	    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
	    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
	    'require' // for Webpack/Browserify
	  );
	
	  var warnNonPresent = function (target, key) {
	    warn(
	      "Property or method \"" + key + "\" is not defined on the instance but " +
	      'referenced during render. Make sure that this property is reactive, ' +
	      'either in the data option, or for class-based components, by ' +
	      'initializing the property. ' +
	      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
	      target
	    );
	  };
	
	  var hasProxy =
	    typeof Proxy !== 'undefined' && isNative(Proxy);
	
	  if (hasProxy) {
	    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
	    config.keyCodes = new Proxy(config.keyCodes, {
	      set: function set (target, key, value) {
	        if (isBuiltInModifier(key)) {
	          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
	          return false
	        } else {
	          target[key] = value;
	          return true
	        }
	      }
	    });
	  }
	
	  var hasHandler = {
	    has: function has (target, key) {
	      var has = key in target;
	      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
	      if (!has && !isAllowed) {
	        warnNonPresent(target, key);
	      }
	      return has || !isAllowed
	    }
	  };
	
	  var getHandler = {
	    get: function get (target, key) {
	      if (typeof key === 'string' && !(key in target)) {
	        warnNonPresent(target, key);
	      }
	      return target[key]
	    }
	  };
	
	  initProxy = function initProxy (vm) {
	    if (hasProxy) {
	      // determine which proxy handler to use
	      var options = vm.$options;
	      var handlers = options.render && options.render._withStripped
	        ? getHandler
	        : hasHandler;
	      vm._renderProxy = new Proxy(vm, handlers);
	    } else {
	      vm._renderProxy = vm;
	    }
	  };
	}
	
	/*  */
	
	var seenObjects = new _Set();
	
	/**
	 * Recursively traverse an object to evoke all converted
	 * getters, so that every nested property inside the object
	 * is collected as a "deep" dependency.
	 */
	function traverse (val) {
	  _traverse(val, seenObjects);
	  seenObjects.clear();
	}
	
	function _traverse (val, seen) {
	  var i, keys;
	  var isA = Array.isArray(val);
	  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
	    return
	  }
	  if (val.__ob__) {
	    var depId = val.__ob__.dep.id;
	    if (seen.has(depId)) {
	      return
	    }
	    seen.add(depId);
	  }
	  if (isA) {
	    i = val.length;
	    while (i--) { _traverse(val[i], seen); }
	  } else {
	    keys = Object.keys(val);
	    i = keys.length;
	    while (i--) { _traverse(val[keys[i]], seen); }
	  }
	}
	
	/*  */
	
	var normalizeEvent = cached(function (name) {
	  var passive = name.charAt(0) === '&';
	  name = passive ? name.slice(1) : name;
	  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
	  name = once$$1 ? name.slice(1) : name;
	  var capture = name.charAt(0) === '!';
	  name = capture ? name.slice(1) : name;
	  return {
	    name: name,
	    once: once$$1,
	    capture: capture,
	    passive: passive
	  }
	});
	
	function createFnInvoker (fns) {
	  function invoker () {
	    var arguments$1 = arguments;
	
	    var fns = invoker.fns;
	    if (Array.isArray(fns)) {
	      var cloned = fns.slice();
	      for (var i = 0; i < cloned.length; i++) {
	        cloned[i].apply(null, arguments$1);
	      }
	    } else {
	      // return handler return value for single handlers
	      return fns.apply(null, arguments)
	    }
	  }
	  invoker.fns = fns;
	  return invoker
	}
	
	function updateListeners (
	  on,
	  oldOn,
	  add,
	  remove$$1,
	  vm
	) {
	  var name, def, cur, old, event;
	  for (name in on) {
	    def = cur = on[name];
	    old = oldOn[name];
	    event = normalizeEvent(name);
	    /* istanbul ignore if */
	    if (isUndef(cur)) {
	      ("production") !== 'production' && warn(
	        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
	        vm
	      );
	    } else if (isUndef(old)) {
	      if (isUndef(cur.fns)) {
	        cur = on[name] = createFnInvoker(cur);
	      }
	      add(event.name, cur, event.once, event.capture, event.passive, event.params);
	    } else if (cur !== old) {
	      old.fns = cur;
	      on[name] = old;
	    }
	  }
	  for (name in oldOn) {
	    if (isUndef(on[name])) {
	      event = normalizeEvent(name);
	      remove$$1(event.name, oldOn[name], event.capture);
	    }
	  }
	}
	
	/*  */
	
	function mergeVNodeHook (def, hookKey, hook) {
	  if (def instanceof VNode) {
	    def = def.data.hook || (def.data.hook = {});
	  }
	  var invoker;
	  var oldHook = def[hookKey];
	
	  function wrappedHook () {
	    hook.apply(this, arguments);
	    // important: remove merged hook to ensure it's called only once
	    // and prevent memory leak
	    remove(invoker.fns, wrappedHook);
	  }
	
	  if (isUndef(oldHook)) {
	    // no existing hook
	    invoker = createFnInvoker([wrappedHook]);
	  } else {
	    /* istanbul ignore if */
	    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
	      // already a merged invoker
	      invoker = oldHook;
	      invoker.fns.push(wrappedHook);
	    } else {
	      // existing plain hook
	      invoker = createFnInvoker([oldHook, wrappedHook]);
	    }
	  }
	
	  invoker.merged = true;
	  def[hookKey] = invoker;
	}
	
	/*  */
	
	function extractPropsFromVNodeData (
	  data,
	  Ctor,
	  tag
	) {
	  // we are only extracting raw values here.
	  // validation and default values are handled in the child
	  // component itself.
	  var propOptions = Ctor.options.props;
	  if (isUndef(propOptions)) {
	    return
	  }
	  var res = {};
	  var attrs = data.attrs;
	  var props = data.props;
	  if (isDef(attrs) || isDef(props)) {
	    for (var key in propOptions) {
	      var altKey = hyphenate(key);
	      if (false) {
	        var keyInLowerCase = key.toLowerCase();
	        if (
	          key !== keyInLowerCase &&
	          attrs && hasOwn(attrs, keyInLowerCase)
	        ) {
	          tip(
	            "Prop \"" + keyInLowerCase + "\" is passed to component " +
	            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
	            " \"" + key + "\". " +
	            "Note that HTML attributes are case-insensitive and camelCased " +
	            "props need to use their kebab-case equivalents when using in-DOM " +
	            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
	          );
	        }
	      }
	      checkProp(res, props, key, altKey, true) ||
	      checkProp(res, attrs, key, altKey, false);
	    }
	  }
	  return res
	}
	
	function checkProp (
	  res,
	  hash,
	  key,
	  altKey,
	  preserve
	) {
	  if (isDef(hash)) {
	    if (hasOwn(hash, key)) {
	      res[key] = hash[key];
	      if (!preserve) {
	        delete hash[key];
	      }
	      return true
	    } else if (hasOwn(hash, altKey)) {
	      res[key] = hash[altKey];
	      if (!preserve) {
	        delete hash[altKey];
	      }
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	// The template compiler attempts to minimize the need for normalization by
	// statically analyzing the template at compile time.
	//
	// For plain HTML markup, normalization can be completely skipped because the
	// generated render function is guaranteed to return Array<VNode>. There are
	// two cases where extra normalization is needed:
	
	// 1. When the children contains components - because a functional component
	// may return an Array instead of a single root. In this case, just a simple
	// normalization is needed - if any child is an Array, we flatten the whole
	// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
	// because functional components already normalize their own children.
	function simpleNormalizeChildren (children) {
	  for (var i = 0; i < children.length; i++) {
	    if (Array.isArray(children[i])) {
	      return Array.prototype.concat.apply([], children)
	    }
	  }
	  return children
	}
	
	// 2. When the children contains constructs that always generated nested Arrays,
	// e.g. <template>, <slot>, v-for, or when the children is provided by user
	// with hand-written render functions / JSX. In such cases a full normalization
	// is needed to cater to all possible types of children values.
	function normalizeChildren (children) {
	  return isPrimitive(children)
	    ? [createTextVNode(children)]
	    : Array.isArray(children)
	      ? normalizeArrayChildren(children)
	      : undefined
	}
	
	function isTextNode (node) {
	  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
	}
	
	function normalizeArrayChildren (children, nestedIndex) {
	  var res = [];
	  var i, c, lastIndex, last;
	  for (i = 0; i < children.length; i++) {
	    c = children[i];
	    if (isUndef(c) || typeof c === 'boolean') { continue }
	    lastIndex = res.length - 1;
	    last = res[lastIndex];
	    //  nested
	    if (Array.isArray(c)) {
	      if (c.length > 0) {
	        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
	        // merge adjacent text nodes
	        if (isTextNode(c[0]) && isTextNode(last)) {
	          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
	          c.shift();
	        }
	        res.push.apply(res, c);
	      }
	    } else if (isPrimitive(c)) {
	      if (isTextNode(last)) {
	        // merge adjacent text nodes
	        // this is necessary for SSR hydration because text nodes are
	        // essentially merged when rendered to HTML strings
	        res[lastIndex] = createTextVNode(last.text + c);
	      } else if (c !== '') {
	        // convert primitive to vnode
	        res.push(createTextVNode(c));
	      }
	    } else {
	      if (isTextNode(c) && isTextNode(last)) {
	        // merge adjacent text nodes
	        res[lastIndex] = createTextVNode(last.text + c.text);
	      } else {
	        // default key for nested array children (likely generated by v-for)
	        if (isTrue(children._isVList) &&
	          isDef(c.tag) &&
	          isUndef(c.key) &&
	          isDef(nestedIndex)) {
	          c.key = "__vlist" + nestedIndex + "_" + i + "__";
	        }
	        res.push(c);
	      }
	    }
	  }
	  return res
	}
	
	/*  */
	
	function ensureCtor (comp, base) {
	  if (
	    comp.__esModule ||
	    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
	  ) {
	    comp = comp.default;
	  }
	  return isObject(comp)
	    ? base.extend(comp)
	    : comp
	}
	
	function createAsyncPlaceholder (
	  factory,
	  data,
	  context,
	  children,
	  tag
	) {
	  var node = createEmptyVNode();
	  node.asyncFactory = factory;
	  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
	  return node
	}
	
	function resolveAsyncComponent (
	  factory,
	  baseCtor,
	  context
	) {
	  if (isTrue(factory.error) && isDef(factory.errorComp)) {
	    return factory.errorComp
	  }
	
	  if (isDef(factory.resolved)) {
	    return factory.resolved
	  }
	
	  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
	    return factory.loadingComp
	  }
	
	  if (isDef(factory.contexts)) {
	    // already pending
	    factory.contexts.push(context);
	  } else {
	    var contexts = factory.contexts = [context];
	    var sync = true;
	
	    var forceRender = function () {
	      for (var i = 0, l = contexts.length; i < l; i++) {
	        contexts[i].$forceUpdate();
	      }
	    };
	
	    var resolve = once(function (res) {
	      // cache resolved
	      factory.resolved = ensureCtor(res, baseCtor);
	      // invoke callbacks only if this is not a synchronous resolve
	      // (async resolves are shimmed as synchronous during SSR)
	      if (!sync) {
	        forceRender();
	      }
	    });
	
	    var reject = once(function (reason) {
	      ("production") !== 'production' && warn(
	        "Failed to resolve async component: " + (String(factory)) +
	        (reason ? ("\nReason: " + reason) : '')
	      );
	      if (isDef(factory.errorComp)) {
	        factory.error = true;
	        forceRender();
	      }
	    });
	
	    var res = factory(resolve, reject);
	
	    if (isObject(res)) {
	      if (typeof res.then === 'function') {
	        // () => Promise
	        if (isUndef(factory.resolved)) {
	          res.then(resolve, reject);
	        }
	      } else if (isDef(res.component) && typeof res.component.then === 'function') {
	        res.component.then(resolve, reject);
	
	        if (isDef(res.error)) {
	          factory.errorComp = ensureCtor(res.error, baseCtor);
	        }
	
	        if (isDef(res.loading)) {
	          factory.loadingComp = ensureCtor(res.loading, baseCtor);
	          if (res.delay === 0) {
	            factory.loading = true;
	          } else {
	            setTimeout(function () {
	              if (isUndef(factory.resolved) && isUndef(factory.error)) {
	                factory.loading = true;
	                forceRender();
	              }
	            }, res.delay || 200);
	          }
	        }
	
	        if (isDef(res.timeout)) {
	          setTimeout(function () {
	            if (isUndef(factory.resolved)) {
	              reject(
	                 false
	                  ? ("timeout (" + (res.timeout) + "ms)")
	                  : null
	              );
	            }
	          }, res.timeout);
	        }
	      }
	    }
	
	    sync = false;
	    // return in case resolved synchronously
	    return factory.loading
	      ? factory.loadingComp
	      : factory.resolved
	  }
	}
	
	/*  */
	
	function isAsyncPlaceholder (node) {
	  return node.isComment && node.asyncFactory
	}
	
	/*  */
	
	function getFirstComponentChild (children) {
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      var c = children[i];
	      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
	        return c
	      }
	    }
	  }
	}
	
	/*  */
	
	/*  */
	
	function initEvents (vm) {
	  vm._events = Object.create(null);
	  vm._hasHookEvent = false;
	  // init parent attached events
	  var listeners = vm.$options._parentListeners;
	  if (listeners) {
	    updateComponentListeners(vm, listeners);
	  }
	}
	
	var target;
	
	function add (event, fn, once) {
	  if (once) {
	    target.$once(event, fn);
	  } else {
	    target.$on(event, fn);
	  }
	}
	
	function remove$1 (event, fn) {
	  target.$off(event, fn);
	}
	
	function updateComponentListeners (
	  vm,
	  listeners,
	  oldListeners
	) {
	  target = vm;
	  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
	  target = undefined;
	}
	
	function eventsMixin (Vue) {
	  var hookRE = /^hook:/;
	  Vue.prototype.$on = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$on(event[i], fn);
	      }
	    } else {
	      (vm._events[event] || (vm._events[event] = [])).push(fn);
	      // optimize hook:event cost by using a boolean flag marked at registration
	      // instead of a hash lookup
	      if (hookRE.test(event)) {
	        vm._hasHookEvent = true;
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$once = function (event, fn) {
	    var vm = this;
	    function on () {
	      vm.$off(event, on);
	      fn.apply(vm, arguments);
	    }
	    on.fn = fn;
	    vm.$on(event, on);
	    return vm
	  };
	
	  Vue.prototype.$off = function (event, fn) {
	    var this$1 = this;
	
	    var vm = this;
	    // all
	    if (!arguments.length) {
	      vm._events = Object.create(null);
	      return vm
	    }
	    // array of events
	    if (Array.isArray(event)) {
	      for (var i = 0, l = event.length; i < l; i++) {
	        this$1.$off(event[i], fn);
	      }
	      return vm
	    }
	    // specific event
	    var cbs = vm._events[event];
	    if (!cbs) {
	      return vm
	    }
	    if (!fn) {
	      vm._events[event] = null;
	      return vm
	    }
	    if (fn) {
	      // specific handler
	      var cb;
	      var i$1 = cbs.length;
	      while (i$1--) {
	        cb = cbs[i$1];
	        if (cb === fn || cb.fn === fn) {
	          cbs.splice(i$1, 1);
	          break
	        }
	      }
	    }
	    return vm
	  };
	
	  Vue.prototype.$emit = function (event) {
	    var vm = this;
	    if (false) {
	      var lowerCaseEvent = event.toLowerCase();
	      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
	        tip(
	          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
	          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
	          "Note that HTML attributes are case-insensitive and you cannot use " +
	          "v-on to listen to camelCase events when using in-DOM templates. " +
	          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
	        );
	      }
	    }
	    var cbs = vm._events[event];
	    if (cbs) {
	      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
	      var args = toArray(arguments, 1);
	      for (var i = 0, l = cbs.length; i < l; i++) {
	        try {
	          cbs[i].apply(vm, args);
	        } catch (e) {
	          handleError(e, vm, ("event handler for \"" + event + "\""));
	        }
	      }
	    }
	    return vm
	  };
	}
	
	/*  */
	
	
	
	/**
	 * Runtime helper for resolving raw children VNodes into a slot object.
	 */
	function resolveSlots (
	  children,
	  context
	) {
	  var slots = {};
	  if (!children) {
	    return slots
	  }
	  for (var i = 0, l = children.length; i < l; i++) {
	    var child = children[i];
	    var data = child.data;
	    // remove slot attribute if the node is resolved as a Vue slot node
	    if (data && data.attrs && data.attrs.slot) {
	      delete data.attrs.slot;
	    }
	    // named slots should only be respected if the vnode was rendered in the
	    // same context.
	    if ((child.context === context || child.fnContext === context) &&
	      data && data.slot != null
	    ) {
	      var name = data.slot;
	      var slot = (slots[name] || (slots[name] = []));
	      if (child.tag === 'template') {
	        slot.push.apply(slot, child.children || []);
	      } else {
	        slot.push(child);
	      }
	    } else {
	      (slots.default || (slots.default = [])).push(child);
	    }
	  }
	  // ignore slots that contains only whitespace
	  for (var name$1 in slots) {
	    if (slots[name$1].every(isWhitespace)) {
	      delete slots[name$1];
	    }
	  }
	  return slots
	}
	
	function isWhitespace (node) {
	  return (node.isComment && !node.asyncFactory) || node.text === ' '
	}
	
	function resolveScopedSlots (
	  fns, // see flow/vnode
	  res
	) {
	  res = res || {};
	  for (var i = 0; i < fns.length; i++) {
	    if (Array.isArray(fns[i])) {
	      resolveScopedSlots(fns[i], res);
	    } else {
	      res[fns[i].key] = fns[i].fn;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var activeInstance = null;
	var isUpdatingChildComponent = false;
	
	function initLifecycle (vm) {
	  var options = vm.$options;
	
	  // locate first non-abstract parent
	  var parent = options.parent;
	  if (parent && !options.abstract) {
	    while (parent.$options.abstract && parent.$parent) {
	      parent = parent.$parent;
	    }
	    parent.$children.push(vm);
	  }
	
	  vm.$parent = parent;
	  vm.$root = parent ? parent.$root : vm;
	
	  vm.$children = [];
	  vm.$refs = {};
	
	  vm._watcher = null;
	  vm._inactive = null;
	  vm._directInactive = false;
	  vm._isMounted = false;
	  vm._isDestroyed = false;
	  vm._isBeingDestroyed = false;
	}
	
	function lifecycleMixin (Vue) {
	  Vue.prototype._update = function (vnode, hydrating) {
	    var vm = this;
	    if (vm._isMounted) {
	      callHook(vm, 'beforeUpdate');
	    }
	    var prevEl = vm.$el;
	    var prevVnode = vm._vnode;
	    var prevActiveInstance = activeInstance;
	    activeInstance = vm;
	    vm._vnode = vnode;
	    // Vue.prototype.__patch__ is injected in entry points
	    // based on the rendering backend used.
	    if (!prevVnode) {
	      // initial render
	      vm.$el = vm.__patch__(
	        vm.$el, vnode, hydrating, false /* removeOnly */,
	        vm.$options._parentElm,
	        vm.$options._refElm
	      );
	      // no need for the ref nodes after initial patch
	      // this prevents keeping a detached DOM tree in memory (#5851)
	      vm.$options._parentElm = vm.$options._refElm = null;
	    } else {
	      // updates
	      vm.$el = vm.__patch__(prevVnode, vnode);
	    }
	    activeInstance = prevActiveInstance;
	    // update __vue__ reference
	    if (prevEl) {
	      prevEl.__vue__ = null;
	    }
	    if (vm.$el) {
	      vm.$el.__vue__ = vm;
	    }
	    // if parent is an HOC, update its $el as well
	    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
	      vm.$parent.$el = vm.$el;
	    }
	    // updated hook is called by the scheduler to ensure that children are
	    // updated in a parent's updated hook.
	  };
	
	  Vue.prototype.$forceUpdate = function () {
	    var vm = this;
	    if (vm._watcher) {
	      vm._watcher.update();
	    }
	  };
	
	  Vue.prototype.$destroy = function () {
	    var vm = this;
	    if (vm._isBeingDestroyed) {
	      return
	    }
	    callHook(vm, 'beforeDestroy');
	    vm._isBeingDestroyed = true;
	    // remove self from parent
	    var parent = vm.$parent;
	    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
	      remove(parent.$children, vm);
	    }
	    // teardown watchers
	    if (vm._watcher) {
	      vm._watcher.teardown();
	    }
	    var i = vm._watchers.length;
	    while (i--) {
	      vm._watchers[i].teardown();
	    }
	    // remove reference from data ob
	    // frozen object may not have observer.
	    if (vm._data.__ob__) {
	      vm._data.__ob__.vmCount--;
	    }
	    // call the last hook...
	    vm._isDestroyed = true;
	    // invoke destroy hooks on current rendered tree
	    vm.__patch__(vm._vnode, null);
	    // fire destroyed hook
	    callHook(vm, 'destroyed');
	    // turn off all instance listeners.
	    vm.$off();
	    // remove __vue__ reference
	    if (vm.$el) {
	      vm.$el.__vue__ = null;
	    }
	    // release circular reference (#6759)
	    if (vm.$vnode) {
	      vm.$vnode.parent = null;
	    }
	  };
	}
	
	function mountComponent (
	  vm,
	  el,
	  hydrating
	) {
	  vm.$el = el;
	  if (!vm.$options.render) {
	    vm.$options.render = createEmptyVNode;
	    if (false) {
	      /* istanbul ignore if */
	      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
	        vm.$options.el || el) {
	        warn(
	          'You are using the runtime-only build of Vue where the template ' +
	          'compiler is not available. Either pre-compile the templates into ' +
	          'render functions, or use the compiler-included build.',
	          vm
	        );
	      } else {
	        warn(
	          'Failed to mount component: template or render function not defined.',
	          vm
	        );
	      }
	    }
	  }
	  callHook(vm, 'beforeMount');
	
	  var updateComponent;
	  /* istanbul ignore if */
	  if (false) {
	    updateComponent = function () {
	      var name = vm._name;
	      var id = vm._uid;
	      var startTag = "vue-perf-start:" + id;
	      var endTag = "vue-perf-end:" + id;
	
	      mark(startTag);
	      var vnode = vm._render();
	      mark(endTag);
	      measure(("vue " + name + " render"), startTag, endTag);
	
	      mark(startTag);
	      vm._update(vnode, hydrating);
	      mark(endTag);
	      measure(("vue " + name + " patch"), startTag, endTag);
	    };
	  } else {
	    updateComponent = function () {
	      vm._update(vm._render(), hydrating);
	    };
	  }
	
	  // we set this to vm._watcher inside the watcher's constructor
	  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
	  // component's mounted hook), which relies on vm._watcher being already defined
	  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
	  hydrating = false;
	
	  // manually mounted instance, call mounted on self
	  // mounted is called for render-created child components in its inserted hook
	  if (vm.$vnode == null) {
	    vm._isMounted = true;
	    callHook(vm, 'mounted');
	  }
	  return vm
	}
	
	function updateChildComponent (
	  vm,
	  propsData,
	  listeners,
	  parentVnode,
	  renderChildren
	) {
	  if (false) {
	    isUpdatingChildComponent = true;
	  }
	
	  // determine whether component has slot children
	  // we need to do this before overwriting $options._renderChildren
	  var hasChildren = !!(
	    renderChildren ||               // has new static slots
	    vm.$options._renderChildren ||  // has old static slots
	    parentVnode.data.scopedSlots || // has new scoped slots
	    vm.$scopedSlots !== emptyObject // has old scoped slots
	  );
	
	  vm.$options._parentVnode = parentVnode;
	  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
	
	  if (vm._vnode) { // update child tree's parent
	    vm._vnode.parent = parentVnode;
	  }
	  vm.$options._renderChildren = renderChildren;
	
	  // update $attrs and $listeners hash
	  // these are also reactive so they may trigger child update if the child
	  // used them during render
	  vm.$attrs = parentVnode.data.attrs || emptyObject;
	  vm.$listeners = listeners || emptyObject;
	
	  // update props
	  if (propsData && vm.$options.props) {
	    toggleObserving(false);
	    var props = vm._props;
	    var propKeys = vm.$options._propKeys || [];
	    for (var i = 0; i < propKeys.length; i++) {
	      var key = propKeys[i];
	      var propOptions = vm.$options.props; // wtf flow?
	      props[key] = validateProp(key, propOptions, propsData, vm);
	    }
	    toggleObserving(true);
	    // keep a copy of raw propsData
	    vm.$options.propsData = propsData;
	  }
	
	  // update listeners
	  listeners = listeners || emptyObject;
	  var oldListeners = vm.$options._parentListeners;
	  vm.$options._parentListeners = listeners;
	  updateComponentListeners(vm, listeners, oldListeners);
	
	  // resolve slots + force update if has children
	  if (hasChildren) {
	    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
	    vm.$forceUpdate();
	  }
	
	  if (false) {
	    isUpdatingChildComponent = false;
	  }
	}
	
	function isInInactiveTree (vm) {
	  while (vm && (vm = vm.$parent)) {
	    if (vm._inactive) { return true }
	  }
	  return false
	}
	
	function activateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = false;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  } else if (vm._directInactive) {
	    return
	  }
	  if (vm._inactive || vm._inactive === null) {
	    vm._inactive = false;
	    for (var i = 0; i < vm.$children.length; i++) {
	      activateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'activated');
	  }
	}
	
	function deactivateChildComponent (vm, direct) {
	  if (direct) {
	    vm._directInactive = true;
	    if (isInInactiveTree(vm)) {
	      return
	    }
	  }
	  if (!vm._inactive) {
	    vm._inactive = true;
	    for (var i = 0; i < vm.$children.length; i++) {
	      deactivateChildComponent(vm.$children[i]);
	    }
	    callHook(vm, 'deactivated');
	  }
	}
	
	function callHook (vm, hook) {
	  // #7573 disable dep collection when invoking lifecycle hooks
	  pushTarget();
	  var handlers = vm.$options[hook];
	  if (handlers) {
	    for (var i = 0, j = handlers.length; i < j; i++) {
	      try {
	        handlers[i].call(vm);
	      } catch (e) {
	        handleError(e, vm, (hook + " hook"));
	      }
	    }
	  }
	  if (vm._hasHookEvent) {
	    vm.$emit('hook:' + hook);
	  }
	  popTarget();
	}
	
	/*  */
	
	
	var MAX_UPDATE_COUNT = 100;
	
	var queue = [];
	var activatedChildren = [];
	var has = {};
	var circular = {};
	var waiting = false;
	var flushing = false;
	var index = 0;
	
	/**
	 * Reset the scheduler's state.
	 */
	function resetSchedulerState () {
	  index = queue.length = activatedChildren.length = 0;
	  has = {};
	  if (false) {
	    circular = {};
	  }
	  waiting = flushing = false;
	}
	
	/**
	 * Flush both queues and run the watchers.
	 */
	function flushSchedulerQueue () {
	  flushing = true;
	  var watcher, id;
	
	  // Sort queue before flush.
	  // This ensures that:
	  // 1. Components are updated from parent to child. (because parent is always
	  //    created before the child)
	  // 2. A component's user watchers are run before its render watcher (because
	  //    user watchers are created before the render watcher)
	  // 3. If a component is destroyed during a parent component's watcher run,
	  //    its watchers can be skipped.
	  queue.sort(function (a, b) { return a.id - b.id; });
	
	  // do not cache length because more watchers might be pushed
	  // as we run existing watchers
	  for (index = 0; index < queue.length; index++) {
	    watcher = queue[index];
	    id = watcher.id;
	    has[id] = null;
	    watcher.run();
	    // in dev build, check and stop circular updates.
	    if (false) {
	      circular[id] = (circular[id] || 0) + 1;
	      if (circular[id] > MAX_UPDATE_COUNT) {
	        warn(
	          'You may have an infinite update loop ' + (
	            watcher.user
	              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
	              : "in a component render function."
	          ),
	          watcher.vm
	        );
	        break
	      }
	    }
	  }
	
	  // keep copies of post queues before resetting state
	  var activatedQueue = activatedChildren.slice();
	  var updatedQueue = queue.slice();
	
	  resetSchedulerState();
	
	  // call component updated and activated hooks
	  callActivatedHooks(activatedQueue);
	  callUpdatedHooks(updatedQueue);
	
	  // devtool hook
	  /* istanbul ignore if */
	  if (devtools && config.devtools) {
	    devtools.emit('flush');
	  }
	}
	
	function callUpdatedHooks (queue) {
	  var i = queue.length;
	  while (i--) {
	    var watcher = queue[i];
	    var vm = watcher.vm;
	    if (vm._watcher === watcher && vm._isMounted) {
	      callHook(vm, 'updated');
	    }
	  }
	}
	
	/**
	 * Queue a kept-alive component that was activated during patch.
	 * The queue will be processed after the entire tree has been patched.
	 */
	function queueActivatedComponent (vm) {
	  // setting _inactive to false here so that a render function can
	  // rely on checking whether it's in an inactive tree (e.g. router-view)
	  vm._inactive = false;
	  activatedChildren.push(vm);
	}
	
	function callActivatedHooks (queue) {
	  for (var i = 0; i < queue.length; i++) {
	    queue[i]._inactive = true;
	    activateChildComponent(queue[i], true /* true */);
	  }
	}
	
	/**
	 * Push a watcher into the watcher queue.
	 * Jobs with duplicate IDs will be skipped unless it's
	 * pushed when the queue is being flushed.
	 */
	function queueWatcher (watcher) {
	  var id = watcher.id;
	  if (has[id] == null) {
	    has[id] = true;
	    if (!flushing) {
	      queue.push(watcher);
	    } else {
	      // if already flushing, splice the watcher based on its id
	      // if already past its id, it will be run next immediately.
	      var i = queue.length - 1;
	      while (i > index && queue[i].id > watcher.id) {
	        i--;
	      }
	      queue.splice(i + 1, 0, watcher);
	    }
	    // queue the flush
	    if (!waiting) {
	      waiting = true;
	      nextTick(flushSchedulerQueue);
	    }
	  }
	}
	
	/*  */
	
	var uid$1 = 0;
	
	/**
	 * A watcher parses an expression, collects dependencies,
	 * and fires callback when the expression value changes.
	 * This is used for both the $watch() api and directives.
	 */
	var Watcher = function Watcher (
	  vm,
	  expOrFn,
	  cb,
	  options,
	  isRenderWatcher
	) {
	  this.vm = vm;
	  if (isRenderWatcher) {
	    vm._watcher = this;
	  }
	  vm._watchers.push(this);
	  // options
	  if (options) {
	    this.deep = !!options.deep;
	    this.user = !!options.user;
	    this.lazy = !!options.lazy;
	    this.sync = !!options.sync;
	  } else {
	    this.deep = this.user = this.lazy = this.sync = false;
	  }
	  this.cb = cb;
	  this.id = ++uid$1; // uid for batching
	  this.active = true;
	  this.dirty = this.lazy; // for lazy watchers
	  this.deps = [];
	  this.newDeps = [];
	  this.depIds = new _Set();
	  this.newDepIds = new _Set();
	  this.expression =  false
	    ? expOrFn.toString()
	    : '';
	  // parse expression for getter
	  if (typeof expOrFn === 'function') {
	    this.getter = expOrFn;
	  } else {
	    this.getter = parsePath(expOrFn);
	    if (!this.getter) {
	      this.getter = function () {};
	      ("production") !== 'production' && warn(
	        "Failed watching path: \"" + expOrFn + "\" " +
	        'Watcher only accepts simple dot-delimited paths. ' +
	        'For full control, use a function instead.',
	        vm
	      );
	    }
	  }
	  this.value = this.lazy
	    ? undefined
	    : this.get();
	};
	
	/**
	 * Evaluate the getter, and re-collect dependencies.
	 */
	Watcher.prototype.get = function get () {
	  pushTarget(this);
	  var value;
	  var vm = this.vm;
	  try {
	    value = this.getter.call(vm, vm);
	  } catch (e) {
	    if (this.user) {
	      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
	    } else {
	      throw e
	    }
	  } finally {
	    // "touch" every property so they are all tracked as
	    // dependencies for deep watching
	    if (this.deep) {
	      traverse(value);
	    }
	    popTarget();
	    this.cleanupDeps();
	  }
	  return value
	};
	
	/**
	 * Add a dependency to this directive.
	 */
	Watcher.prototype.addDep = function addDep (dep) {
	  var id = dep.id;
	  if (!this.newDepIds.has(id)) {
	    this.newDepIds.add(id);
	    this.newDeps.push(dep);
	    if (!this.depIds.has(id)) {
	      dep.addSub(this);
	    }
	  }
	};
	
	/**
	 * Clean up for dependency collection.
	 */
	Watcher.prototype.cleanupDeps = function cleanupDeps () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    var dep = this$1.deps[i];
	    if (!this$1.newDepIds.has(dep.id)) {
	      dep.removeSub(this$1);
	    }
	  }
	  var tmp = this.depIds;
	  this.depIds = this.newDepIds;
	  this.newDepIds = tmp;
	  this.newDepIds.clear();
	  tmp = this.deps;
	  this.deps = this.newDeps;
	  this.newDeps = tmp;
	  this.newDeps.length = 0;
	};
	
	/**
	 * Subscriber interface.
	 * Will be called when a dependency changes.
	 */
	Watcher.prototype.update = function update () {
	  /* istanbul ignore else */
	  if (this.lazy) {
	    this.dirty = true;
	  } else if (this.sync) {
	    this.run();
	  } else {
	    queueWatcher(this);
	  }
	};
	
	/**
	 * Scheduler job interface.
	 * Will be called by the scheduler.
	 */
	Watcher.prototype.run = function run () {
	  if (this.active) {
	    var value = this.get();
	    if (
	      value !== this.value ||
	      // Deep watchers and watchers on Object/Arrays should fire even
	      // when the value is the same, because the value may
	      // have mutated.
	      isObject(value) ||
	      this.deep
	    ) {
	      // set new value
	      var oldValue = this.value;
	      this.value = value;
	      if (this.user) {
	        try {
	          this.cb.call(this.vm, value, oldValue);
	        } catch (e) {
	          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
	        }
	      } else {
	        this.cb.call(this.vm, value, oldValue);
	      }
	    }
	  }
	};
	
	/**
	 * Evaluate the value of the watcher.
	 * This only gets called for lazy watchers.
	 */
	Watcher.prototype.evaluate = function evaluate () {
	  this.value = this.get();
	  this.dirty = false;
	};
	
	/**
	 * Depend on all deps collected by this watcher.
	 */
	Watcher.prototype.depend = function depend () {
	    var this$1 = this;
	
	  var i = this.deps.length;
	  while (i--) {
	    this$1.deps[i].depend();
	  }
	};
	
	/**
	 * Remove self from all dependencies' subscriber list.
	 */
	Watcher.prototype.teardown = function teardown () {
	    var this$1 = this;
	
	  if (this.active) {
	    // remove self from vm's watcher list
	    // this is a somewhat expensive operation so we skip it
	    // if the vm is being destroyed.
	    if (!this.vm._isBeingDestroyed) {
	      remove(this.vm._watchers, this);
	    }
	    var i = this.deps.length;
	    while (i--) {
	      this$1.deps[i].removeSub(this$1);
	    }
	    this.active = false;
	  }
	};
	
	/*  */
	
	var sharedPropertyDefinition = {
	  enumerable: true,
	  configurable: true,
	  get: noop,
	  set: noop
	};
	
	function proxy (target, sourceKey, key) {
	  sharedPropertyDefinition.get = function proxyGetter () {
	    return this[sourceKey][key]
	  };
	  sharedPropertyDefinition.set = function proxySetter (val) {
	    this[sourceKey][key] = val;
	  };
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function initState (vm) {
	  vm._watchers = [];
	  var opts = vm.$options;
	  if (opts.props) { initProps(vm, opts.props); }
	  if (opts.methods) { initMethods(vm, opts.methods); }
	  if (opts.data) {
	    initData(vm);
	  } else {
	    observe(vm._data = {}, true /* asRootData */);
	  }
	  if (opts.computed) { initComputed(vm, opts.computed); }
	  if (opts.watch && opts.watch !== nativeWatch) {
	    initWatch(vm, opts.watch);
	  }
	}
	
	function initProps (vm, propsOptions) {
	  var propsData = vm.$options.propsData || {};
	  var props = vm._props = {};
	  // cache prop keys so that future props updates can iterate using Array
	  // instead of dynamic object key enumeration.
	  var keys = vm.$options._propKeys = [];
	  var isRoot = !vm.$parent;
	  // root instance props should be converted
	  if (!isRoot) {
	    toggleObserving(false);
	  }
	  var loop = function ( key ) {
	    keys.push(key);
	    var value = validateProp(key, propsOptions, propsData, vm);
	    /* istanbul ignore else */
	    if (false) {
	      var hyphenatedKey = hyphenate(key);
	      if (isReservedAttribute(hyphenatedKey) ||
	          config.isReservedAttr(hyphenatedKey)) {
	        warn(
	          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
	          vm
	        );
	      }
	      defineReactive(props, key, value, function () {
	        if (vm.$parent && !isUpdatingChildComponent) {
	          warn(
	            "Avoid mutating a prop directly since the value will be " +
	            "overwritten whenever the parent component re-renders. " +
	            "Instead, use a data or computed property based on the prop's " +
	            "value. Prop being mutated: \"" + key + "\"",
	            vm
	          );
	        }
	      });
	    } else {
	      defineReactive(props, key, value);
	    }
	    // static props are already proxied on the component's prototype
	    // during Vue.extend(). We only need to proxy props defined at
	    // instantiation here.
	    if (!(key in vm)) {
	      proxy(vm, "_props", key);
	    }
	  };
	
	  for (var key in propsOptions) loop( key );
	  toggleObserving(true);
	}
	
	function initData (vm) {
	  var data = vm.$options.data;
	  data = vm._data = typeof data === 'function'
	    ? getData(data, vm)
	    : data || {};
	  if (!isPlainObject(data)) {
	    data = {};
	    ("production") !== 'production' && warn(
	      'data functions should return an object:\n' +
	      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
	      vm
	    );
	  }
	  // proxy data on instance
	  var keys = Object.keys(data);
	  var props = vm.$options.props;
	  var methods = vm.$options.methods;
	  var i = keys.length;
	  while (i--) {
	    var key = keys[i];
	    if (false) {
	      if (methods && hasOwn(methods, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a data property."),
	          vm
	        );
	      }
	    }
	    if (props && hasOwn(props, key)) {
	      ("production") !== 'production' && warn(
	        "The data property \"" + key + "\" is already declared as a prop. " +
	        "Use prop default value instead.",
	        vm
	      );
	    } else if (!isReserved(key)) {
	      proxy(vm, "_data", key);
	    }
	  }
	  // observe data
	  observe(data, true /* asRootData */);
	}
	
	function getData (data, vm) {
	  // #7573 disable dep collection when invoking data getters
	  pushTarget();
	  try {
	    return data.call(vm, vm)
	  } catch (e) {
	    handleError(e, vm, "data()");
	    return {}
	  } finally {
	    popTarget();
	  }
	}
	
	var computedWatcherOptions = { lazy: true };
	
	function initComputed (vm, computed) {
	  // $flow-disable-line
	  var watchers = vm._computedWatchers = Object.create(null);
	  // computed properties are just getters during SSR
	  var isSSR = isServerRendering();
	
	  for (var key in computed) {
	    var userDef = computed[key];
	    var getter = typeof userDef === 'function' ? userDef : userDef.get;
	    if (false) {
	      warn(
	        ("Getter is missing for computed property \"" + key + "\"."),
	        vm
	      );
	    }
	
	    if (!isSSR) {
	      // create internal watcher for the computed property.
	      watchers[key] = new Watcher(
	        vm,
	        getter || noop,
	        noop,
	        computedWatcherOptions
	      );
	    }
	
	    // component-defined computed properties are already defined on the
	    // component prototype. We only need to define computed properties defined
	    // at instantiation here.
	    if (!(key in vm)) {
	      defineComputed(vm, key, userDef);
	    } else if (false) {
	      if (key in vm.$data) {
	        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
	      } else if (vm.$options.props && key in vm.$options.props) {
	        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
	      }
	    }
	  }
	}
	
	function defineComputed (
	  target,
	  key,
	  userDef
	) {
	  var shouldCache = !isServerRendering();
	  if (typeof userDef === 'function') {
	    sharedPropertyDefinition.get = shouldCache
	      ? createComputedGetter(key)
	      : userDef;
	    sharedPropertyDefinition.set = noop;
	  } else {
	    sharedPropertyDefinition.get = userDef.get
	      ? shouldCache && userDef.cache !== false
	        ? createComputedGetter(key)
	        : userDef.get
	      : noop;
	    sharedPropertyDefinition.set = userDef.set
	      ? userDef.set
	      : noop;
	  }
	  if (false) {
	    sharedPropertyDefinition.set = function () {
	      warn(
	        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
	        this
	      );
	    };
	  }
	  Object.defineProperty(target, key, sharedPropertyDefinition);
	}
	
	function createComputedGetter (key) {
	  return function computedGetter () {
	    var watcher = this._computedWatchers && this._computedWatchers[key];
	    if (watcher) {
	      if (watcher.dirty) {
	        watcher.evaluate();
	      }
	      if (Dep.target) {
	        watcher.depend();
	      }
	      return watcher.value
	    }
	  }
	}
	
	function initMethods (vm, methods) {
	  var props = vm.$options.props;
	  for (var key in methods) {
	    if (false) {
	      if (methods[key] == null) {
	        warn(
	          "Method \"" + key + "\" has an undefined value in the component definition. " +
	          "Did you reference the function correctly?",
	          vm
	        );
	      }
	      if (props && hasOwn(props, key)) {
	        warn(
	          ("Method \"" + key + "\" has already been defined as a prop."),
	          vm
	        );
	      }
	      if ((key in vm) && isReserved(key)) {
	        warn(
	          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
	          "Avoid defining component methods that start with _ or $."
	        );
	      }
	    }
	    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
	  }
	}
	
	function initWatch (vm, watch) {
	  for (var key in watch) {
	    var handler = watch[key];
	    if (Array.isArray(handler)) {
	      for (var i = 0; i < handler.length; i++) {
	        createWatcher(vm, key, handler[i]);
	      }
	    } else {
	      createWatcher(vm, key, handler);
	    }
	  }
	}
	
	function createWatcher (
	  vm,
	  expOrFn,
	  handler,
	  options
	) {
	  if (isPlainObject(handler)) {
	    options = handler;
	    handler = handler.handler;
	  }
	  if (typeof handler === 'string') {
	    handler = vm[handler];
	  }
	  return vm.$watch(expOrFn, handler, options)
	}
	
	function stateMixin (Vue) {
	  // flow somehow has problems with directly declared definition object
	  // when using Object.defineProperty, so we have to procedurally build up
	  // the object here.
	  var dataDef = {};
	  dataDef.get = function () { return this._data };
	  var propsDef = {};
	  propsDef.get = function () { return this._props };
	  if (false) {
	    dataDef.set = function (newData) {
	      warn(
	        'Avoid replacing instance root $data. ' +
	        'Use nested data properties instead.',
	        this
	      );
	    };
	    propsDef.set = function () {
	      warn("$props is readonly.", this);
	    };
	  }
	  Object.defineProperty(Vue.prototype, '$data', dataDef);
	  Object.defineProperty(Vue.prototype, '$props', propsDef);
	
	  Vue.prototype.$set = set;
	  Vue.prototype.$delete = del;
	
	  Vue.prototype.$watch = function (
	    expOrFn,
	    cb,
	    options
	  ) {
	    var vm = this;
	    if (isPlainObject(cb)) {
	      return createWatcher(vm, expOrFn, cb, options)
	    }
	    options = options || {};
	    options.user = true;
	    var watcher = new Watcher(vm, expOrFn, cb, options);
	    if (options.immediate) {
	      cb.call(vm, watcher.value);
	    }
	    return function unwatchFn () {
	      watcher.teardown();
	    }
	  };
	}
	
	/*  */
	
	function initProvide (vm) {
	  var provide = vm.$options.provide;
	  if (provide) {
	    vm._provided = typeof provide === 'function'
	      ? provide.call(vm)
	      : provide;
	  }
	}
	
	function initInjections (vm) {
	  var result = resolveInject(vm.$options.inject, vm);
	  if (result) {
	    toggleObserving(false);
	    Object.keys(result).forEach(function (key) {
	      /* istanbul ignore else */
	      if (false) {
	        defineReactive(vm, key, result[key], function () {
	          warn(
	            "Avoid mutating an injected value directly since the changes will be " +
	            "overwritten whenever the provided component re-renders. " +
	            "injection being mutated: \"" + key + "\"",
	            vm
	          );
	        });
	      } else {
	        defineReactive(vm, key, result[key]);
	      }
	    });
	    toggleObserving(true);
	  }
	}
	
	function resolveInject (inject, vm) {
	  if (inject) {
	    // inject is :any because flow is not smart enough to figure out cached
	    var result = Object.create(null);
	    var keys = hasSymbol
	      ? Reflect.ownKeys(inject).filter(function (key) {
	        /* istanbul ignore next */
	        return Object.getOwnPropertyDescriptor(inject, key).enumerable
	      })
	      : Object.keys(inject);
	
	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];
	      var provideKey = inject[key].from;
	      var source = vm;
	      while (source) {
	        if (source._provided && hasOwn(source._provided, provideKey)) {
	          result[key] = source._provided[provideKey];
	          break
	        }
	        source = source.$parent;
	      }
	      if (!source) {
	        if ('default' in inject[key]) {
	          var provideDefault = inject[key].default;
	          result[key] = typeof provideDefault === 'function'
	            ? provideDefault.call(vm)
	            : provideDefault;
	        } else if (false) {
	          warn(("Injection \"" + key + "\" not found"), vm);
	        }
	      }
	    }
	    return result
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering v-for lists.
	 */
	function renderList (
	  val,
	  render
	) {
	  var ret, i, l, keys, key;
	  if (Array.isArray(val) || typeof val === 'string') {
	    ret = new Array(val.length);
	    for (i = 0, l = val.length; i < l; i++) {
	      ret[i] = render(val[i], i);
	    }
	  } else if (typeof val === 'number') {
	    ret = new Array(val);
	    for (i = 0; i < val; i++) {
	      ret[i] = render(i + 1, i);
	    }
	  } else if (isObject(val)) {
	    keys = Object.keys(val);
	    ret = new Array(keys.length);
	    for (i = 0, l = keys.length; i < l; i++) {
	      key = keys[i];
	      ret[i] = render(val[key], key, i);
	    }
	  }
	  if (isDef(ret)) {
	    (ret)._isVList = true;
	  }
	  return ret
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering <slot>
	 */
	function renderSlot (
	  name,
	  fallback,
	  props,
	  bindObject
	) {
	  var scopedSlotFn = this.$scopedSlots[name];
	  var nodes;
	  if (scopedSlotFn) { // scoped slot
	    props = props || {};
	    if (bindObject) {
	      if (false) {
	        warn(
	          'slot v-bind without argument expects an Object',
	          this
	        );
	      }
	      props = extend(extend({}, bindObject), props);
	    }
	    nodes = scopedSlotFn(props) || fallback;
	  } else {
	    var slotNodes = this.$slots[name];
	    // warn duplicate slot usage
	    if (slotNodes) {
	      if (false) {
	        warn(
	          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
	          "- this will likely cause render errors.",
	          this
	        );
	      }
	      slotNodes._rendered = true;
	    }
	    nodes = slotNodes || fallback;
	  }
	
	  var target = props && props.slot;
	  if (target) {
	    return this.$createElement('template', { slot: target }, nodes)
	  } else {
	    return nodes
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for resolving filters
	 */
	function resolveFilter (id) {
	  return resolveAsset(this.$options, 'filters', id, true) || identity
	}
	
	/*  */
	
	function isKeyNotMatch (expect, actual) {
	  if (Array.isArray(expect)) {
	    return expect.indexOf(actual) === -1
	  } else {
	    return expect !== actual
	  }
	}
	
	/**
	 * Runtime helper for checking keyCodes from config.
	 * exposed as Vue.prototype._k
	 * passing in eventKeyName as last argument separately for backwards compat
	 */
	function checkKeyCodes (
	  eventKeyCode,
	  key,
	  builtInKeyCode,
	  eventKeyName,
	  builtInKeyName
	) {
	  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
	  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
	    return isKeyNotMatch(builtInKeyName, eventKeyName)
	  } else if (mappedKeyCode) {
	    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
	  } else if (eventKeyName) {
	    return hyphenate(eventKeyName) !== key
	  }
	}
	
	/*  */
	
	/**
	 * Runtime helper for merging v-bind="object" into a VNode's data.
	 */
	function bindObjectProps (
	  data,
	  tag,
	  value,
	  asProp,
	  isSync
	) {
	  if (value) {
	    if (!isObject(value)) {
	      ("production") !== 'production' && warn(
	        'v-bind without argument expects an Object or Array value',
	        this
	      );
	    } else {
	      if (Array.isArray(value)) {
	        value = toObject(value);
	      }
	      var hash;
	      var loop = function ( key ) {
	        if (
	          key === 'class' ||
	          key === 'style' ||
	          isReservedAttribute(key)
	        ) {
	          hash = data;
	        } else {
	          var type = data.attrs && data.attrs.type;
	          hash = asProp || config.mustUseProp(tag, type, key)
	            ? data.domProps || (data.domProps = {})
	            : data.attrs || (data.attrs = {});
	        }
	        if (!(key in hash)) {
	          hash[key] = value[key];
	
	          if (isSync) {
	            var on = data.on || (data.on = {});
	            on[("update:" + key)] = function ($event) {
	              value[key] = $event;
	            };
	          }
	        }
	      };
	
	      for (var key in value) loop( key );
	    }
	  }
	  return data
	}
	
	/*  */
	
	/**
	 * Runtime helper for rendering static trees.
	 */
	function renderStatic (
	  index,
	  isInFor
	) {
	  var cached = this._staticTrees || (this._staticTrees = []);
	  var tree = cached[index];
	  // if has already-rendered static tree and not inside v-for,
	  // we can reuse the same tree.
	  if (tree && !isInFor) {
	    return tree
	  }
	  // otherwise, render a fresh tree.
	  tree = cached[index] = this.$options.staticRenderFns[index].call(
	    this._renderProxy,
	    null,
	    this // for render fns generated for functional component templates
	  );
	  markStatic(tree, ("__static__" + index), false);
	  return tree
	}
	
	/**
	 * Runtime helper for v-once.
	 * Effectively it means marking the node as static with a unique key.
	 */
	function markOnce (
	  tree,
	  index,
	  key
	) {
	  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
	  return tree
	}
	
	function markStatic (
	  tree,
	  key,
	  isOnce
	) {
	  if (Array.isArray(tree)) {
	    for (var i = 0; i < tree.length; i++) {
	      if (tree[i] && typeof tree[i] !== 'string') {
	        markStaticNode(tree[i], (key + "_" + i), isOnce);
	      }
	    }
	  } else {
	    markStaticNode(tree, key, isOnce);
	  }
	}
	
	function markStaticNode (node, key, isOnce) {
	  node.isStatic = true;
	  node.key = key;
	  node.isOnce = isOnce;
	}
	
	/*  */
	
	function bindObjectListeners (data, value) {
	  if (value) {
	    if (!isPlainObject(value)) {
	      ("production") !== 'production' && warn(
	        'v-on without argument expects an Object value',
	        this
	      );
	    } else {
	      var on = data.on = data.on ? extend({}, data.on) : {};
	      for (var key in value) {
	        var existing = on[key];
	        var ours = value[key];
	        on[key] = existing ? [].concat(existing, ours) : ours;
	      }
	    }
	  }
	  return data
	}
	
	/*  */
	
	function installRenderHelpers (target) {
	  target._o = markOnce;
	  target._n = toNumber;
	  target._s = toString;
	  target._l = renderList;
	  target._t = renderSlot;
	  target._q = looseEqual;
	  target._i = looseIndexOf;
	  target._m = renderStatic;
	  target._f = resolveFilter;
	  target._k = checkKeyCodes;
	  target._b = bindObjectProps;
	  target._v = createTextVNode;
	  target._e = createEmptyVNode;
	  target._u = resolveScopedSlots;
	  target._g = bindObjectListeners;
	}
	
	/*  */
	
	function FunctionalRenderContext (
	  data,
	  props,
	  children,
	  parent,
	  Ctor
	) {
	  var options = Ctor.options;
	  // ensure the createElement function in functional components
	  // gets a unique context - this is necessary for correct named slot check
	  var contextVm;
	  if (hasOwn(parent, '_uid')) {
	    contextVm = Object.create(parent);
	    // $flow-disable-line
	    contextVm._original = parent;
	  } else {
	    // the context vm passed in is a functional context as well.
	    // in this case we want to make sure we are able to get a hold to the
	    // real context instance.
	    contextVm = parent;
	    // $flow-disable-line
	    parent = parent._original;
	  }
	  var isCompiled = isTrue(options._compiled);
	  var needNormalization = !isCompiled;
	
	  this.data = data;
	  this.props = props;
	  this.children = children;
	  this.parent = parent;
	  this.listeners = data.on || emptyObject;
	  this.injections = resolveInject(options.inject, parent);
	  this.slots = function () { return resolveSlots(children, parent); };
	
	  // support for compiled functional template
	  if (isCompiled) {
	    // exposing $options for renderStatic()
	    this.$options = options;
	    // pre-resolve slots for renderSlot()
	    this.$slots = this.slots();
	    this.$scopedSlots = data.scopedSlots || emptyObject;
	  }
	
	  if (options._scopeId) {
	    this._c = function (a, b, c, d) {
	      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
	      if (vnode && !Array.isArray(vnode)) {
	        vnode.fnScopeId = options._scopeId;
	        vnode.fnContext = parent;
	      }
	      return vnode
	    };
	  } else {
	    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
	  }
	}
	
	installRenderHelpers(FunctionalRenderContext.prototype);
	
	function createFunctionalComponent (
	  Ctor,
	  propsData,
	  data,
	  contextVm,
	  children
	) {
	  var options = Ctor.options;
	  var props = {};
	  var propOptions = options.props;
	  if (isDef(propOptions)) {
	    for (var key in propOptions) {
	      props[key] = validateProp(key, propOptions, propsData || emptyObject);
	    }
	  } else {
	    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
	    if (isDef(data.props)) { mergeProps(props, data.props); }
	  }
	
	  var renderContext = new FunctionalRenderContext(
	    data,
	    props,
	    children,
	    contextVm,
	    Ctor
	  );
	
	  var vnode = options.render.call(null, renderContext._c, renderContext);
	
	  if (vnode instanceof VNode) {
	    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
	  } else if (Array.isArray(vnode)) {
	    var vnodes = normalizeChildren(vnode) || [];
	    var res = new Array(vnodes.length);
	    for (var i = 0; i < vnodes.length; i++) {
	      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
	    }
	    return res
	  }
	}
	
	function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
	  // #7817 clone node before setting fnContext, otherwise if the node is reused
	  // (e.g. it was from a cached normal slot) the fnContext causes named slots
	  // that should not be matched to match.
	  var clone = cloneVNode(vnode);
	  clone.fnContext = contextVm;
	  clone.fnOptions = options;
	  if (data.slot) {
	    (clone.data || (clone.data = {})).slot = data.slot;
	  }
	  return clone
	}
	
	function mergeProps (to, from) {
	  for (var key in from) {
	    to[camelize(key)] = from[key];
	  }
	}
	
	/*  */
	
	
	
	
	// Register the component hook to weex native render engine.
	// The hook will be triggered by native, not javascript.
	
	
	// Updates the state of the component to weex native render engine.
	
	/*  */
	
	// https://github.com/Hanks10100/weex-native-directive/tree/master/component
	
	// listening on native callback
	
	/*  */
	
	/*  */
	
	// inline hooks to be invoked on component VNodes during patch
	var componentVNodeHooks = {
	  init: function init (
	    vnode,
	    hydrating,
	    parentElm,
	    refElm
	  ) {
	    if (
	      vnode.componentInstance &&
	      !vnode.componentInstance._isDestroyed &&
	      vnode.data.keepAlive
	    ) {
	      // kept-alive components, treat as a patch
	      var mountedNode = vnode; // work around flow
	      componentVNodeHooks.prepatch(mountedNode, mountedNode);
	    } else {
	      var child = vnode.componentInstance = createComponentInstanceForVnode(
	        vnode,
	        activeInstance,
	        parentElm,
	        refElm
	      );
	      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
	    }
	  },
	
	  prepatch: function prepatch (oldVnode, vnode) {
	    var options = vnode.componentOptions;
	    var child = vnode.componentInstance = oldVnode.componentInstance;
	    updateChildComponent(
	      child,
	      options.propsData, // updated props
	      options.listeners, // updated listeners
	      vnode, // new parent vnode
	      options.children // new children
	    );
	  },
	
	  insert: function insert (vnode) {
	    var context = vnode.context;
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isMounted) {
	      componentInstance._isMounted = true;
	      callHook(componentInstance, 'mounted');
	    }
	    if (vnode.data.keepAlive) {
	      if (context._isMounted) {
	        // vue-router#1212
	        // During updates, a kept-alive component's child components may
	        // change, so directly walking the tree here may call activated hooks
	        // on incorrect children. Instead we push them into a queue which will
	        // be processed after the whole patch process ended.
	        queueActivatedComponent(componentInstance);
	      } else {
	        activateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  },
	
	  destroy: function destroy (vnode) {
	    var componentInstance = vnode.componentInstance;
	    if (!componentInstance._isDestroyed) {
	      if (!vnode.data.keepAlive) {
	        componentInstance.$destroy();
	      } else {
	        deactivateChildComponent(componentInstance, true /* direct */);
	      }
	    }
	  }
	};
	
	var hooksToMerge = Object.keys(componentVNodeHooks);
	
	function createComponent (
	  Ctor,
	  data,
	  context,
	  children,
	  tag
	) {
	  if (isUndef(Ctor)) {
	    return
	  }
	
	  var baseCtor = context.$options._base;
	
	  // plain options object: turn it into a constructor
	  if (isObject(Ctor)) {
	    Ctor = baseCtor.extend(Ctor);
	  }
	
	  // if at this stage it's not a constructor or an async component factory,
	  // reject.
	  if (typeof Ctor !== 'function') {
	    if (false) {
	      warn(("Invalid Component definition: " + (String(Ctor))), context);
	    }
	    return
	  }
	
	  // async component
	  var asyncFactory;
	  if (isUndef(Ctor.cid)) {
	    asyncFactory = Ctor;
	    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
	    if (Ctor === undefined) {
	      // return a placeholder node for async component, which is rendered
	      // as a comment node but preserves all the raw information for the node.
	      // the information will be used for async server-rendering and hydration.
	      return createAsyncPlaceholder(
	        asyncFactory,
	        data,
	        context,
	        children,
	        tag
	      )
	    }
	  }
	
	  data = data || {};
	
	  // resolve constructor options in case global mixins are applied after
	  // component constructor creation
	  resolveConstructorOptions(Ctor);
	
	  // transform component v-model data into props & events
	  if (isDef(data.model)) {
	    transformModel(Ctor.options, data);
	  }
	
	  // extract props
	  var propsData = extractPropsFromVNodeData(data, Ctor, tag);
	
	  // functional component
	  if (isTrue(Ctor.options.functional)) {
	    return createFunctionalComponent(Ctor, propsData, data, context, children)
	  }
	
	  // extract listeners, since these needs to be treated as
	  // child component listeners instead of DOM listeners
	  var listeners = data.on;
	  // replace with listeners with .native modifier
	  // so it gets processed during parent component patch.
	  data.on = data.nativeOn;
	
	  if (isTrue(Ctor.options.abstract)) {
	    // abstract components do not keep anything
	    // other than props & listeners & slot
	
	    // work around flow
	    var slot = data.slot;
	    data = {};
	    if (slot) {
	      data.slot = slot;
	    }
	  }
	
	  // install component management hooks onto the placeholder node
	  installComponentHooks(data);
	
	  // return a placeholder vnode
	  var name = Ctor.options.name || tag;
	  var vnode = new VNode(
	    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
	    data, undefined, undefined, undefined, context,
	    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
	    asyncFactory
	  );
	
	  // Weex specific: invoke recycle-list optimized @render function for
	  // extracting cell-slot template.
	  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
	  /* istanbul ignore if */
	  return vnode
	}
	
	function createComponentInstanceForVnode (
	  vnode, // we know it's MountedComponentVNode but flow doesn't
	  parent, // activeInstance in lifecycle state
	  parentElm,
	  refElm
	) {
	  var options = {
	    _isComponent: true,
	    parent: parent,
	    _parentVnode: vnode,
	    _parentElm: parentElm || null,
	    _refElm: refElm || null
	  };
	  // check inline-template render functions
	  var inlineTemplate = vnode.data.inlineTemplate;
	  if (isDef(inlineTemplate)) {
	    options.render = inlineTemplate.render;
	    options.staticRenderFns = inlineTemplate.staticRenderFns;
	  }
	  return new vnode.componentOptions.Ctor(options)
	}
	
	function installComponentHooks (data) {
	  var hooks = data.hook || (data.hook = {});
	  for (var i = 0; i < hooksToMerge.length; i++) {
	    var key = hooksToMerge[i];
	    hooks[key] = componentVNodeHooks[key];
	  }
	}
	
	// transform component v-model info (value and callback) into
	// prop and event handler respectively.
	function transformModel (options, data) {
	  var prop = (options.model && options.model.prop) || 'value';
	  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
	  var on = data.on || (data.on = {});
	  if (isDef(on[event])) {
	    on[event] = [data.model.callback].concat(on[event]);
	  } else {
	    on[event] = data.model.callback;
	  }
	}
	
	/*  */
	
	var SIMPLE_NORMALIZE = 1;
	var ALWAYS_NORMALIZE = 2;
	
	// wrapper function for providing a more flexible interface
	// without getting yelled at by flow
	function createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType,
	  alwaysNormalize
	) {
	  if (Array.isArray(data) || isPrimitive(data)) {
	    normalizationType = children;
	    children = data;
	    data = undefined;
	  }
	  if (isTrue(alwaysNormalize)) {
	    normalizationType = ALWAYS_NORMALIZE;
	  }
	  return _createElement(context, tag, data, children, normalizationType)
	}
	
	function _createElement (
	  context,
	  tag,
	  data,
	  children,
	  normalizationType
	) {
	  if (isDef(data) && isDef((data).__ob__)) {
	    ("production") !== 'production' && warn(
	      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
	      'Always create fresh vnode data objects in each render!',
	      context
	    );
	    return createEmptyVNode()
	  }
	  // object syntax in v-bind
	  if (isDef(data) && isDef(data.is)) {
	    tag = data.is;
	  }
	  if (!tag) {
	    // in case of component :is set to falsy value
	    return createEmptyVNode()
	  }
	  // warn against non-primitive key
	  if (false
	  ) {
	    {
	      warn(
	        'Avoid using non-primitive value as key, ' +
	        'use string/number value instead.',
	        context
	      );
	    }
	  }
	  // support single function children as default scoped slot
	  if (Array.isArray(children) &&
	    typeof children[0] === 'function'
	  ) {
	    data = data || {};
	    data.scopedSlots = { default: children[0] };
	    children.length = 0;
	  }
	  if (normalizationType === ALWAYS_NORMALIZE) {
	    children = normalizeChildren(children);
	  } else if (normalizationType === SIMPLE_NORMALIZE) {
	    children = simpleNormalizeChildren(children);
	  }
	  var vnode, ns;
	  if (typeof tag === 'string') {
	    var Ctor;
	    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
	    if (config.isReservedTag(tag)) {
	      // platform built-in elements
	      vnode = new VNode(
	        config.parsePlatformTagName(tag), data, children,
	        undefined, undefined, context
	      );
	    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
	      // component
	      vnode = createComponent(Ctor, data, context, children, tag);
	    } else {
	      // unknown or unlisted namespaced elements
	      // check at runtime because it may get assigned a namespace when its
	      // parent normalizes children
	      vnode = new VNode(
	        tag, data, children,
	        undefined, undefined, context
	      );
	    }
	  } else {
	    // direct component options / constructor
	    vnode = createComponent(tag, data, context, children);
	  }
	  if (Array.isArray(vnode)) {
	    return vnode
	  } else if (isDef(vnode)) {
	    if (isDef(ns)) { applyNS(vnode, ns); }
	    if (isDef(data)) { registerDeepBindings(data); }
	    return vnode
	  } else {
	    return createEmptyVNode()
	  }
	}
	
	function applyNS (vnode, ns, force) {
	  vnode.ns = ns;
	  if (vnode.tag === 'foreignObject') {
	    // use default namespace inside foreignObject
	    ns = undefined;
	    force = true;
	  }
	  if (isDef(vnode.children)) {
	    for (var i = 0, l = vnode.children.length; i < l; i++) {
	      var child = vnode.children[i];
	      if (isDef(child.tag) && (
	        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
	        applyNS(child, ns, force);
	      }
	    }
	  }
	}
	
	// ref #5318
	// necessary to ensure parent re-render when deep bindings like :style and
	// :class are used on slot nodes
	function registerDeepBindings (data) {
	  if (isObject(data.style)) {
	    traverse(data.style);
	  }
	  if (isObject(data.class)) {
	    traverse(data.class);
	  }
	}
	
	/*  */
	
	function initRender (vm) {
	  vm._vnode = null; // the root of the child tree
	  vm._staticTrees = null; // v-once cached trees
	  var options = vm.$options;
	  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
	  var renderContext = parentVnode && parentVnode.context;
	  vm.$slots = resolveSlots(options._renderChildren, renderContext);
	  vm.$scopedSlots = emptyObject;
	  // bind the createElement fn to this instance
	  // so that we get proper render context inside it.
	  // args order: tag, data, children, normalizationType, alwaysNormalize
	  // internal version is used by render functions compiled from templates
	  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
	  // normalization is always applied for the public version, used in
	  // user-written render functions.
	  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
	
	  // $attrs & $listeners are exposed for easier HOC creation.
	  // they need to be reactive so that HOCs using them are always updated
	  var parentData = parentVnode && parentVnode.data;
	
	  /* istanbul ignore else */
	  if (false) {
	    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
	    }, true);
	    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
	      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
	    }, true);
	  } else {
	    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
	    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
	  }
	}
	
	function renderMixin (Vue) {
	  // install runtime convenience helpers
	  installRenderHelpers(Vue.prototype);
	
	  Vue.prototype.$nextTick = function (fn) {
	    return nextTick(fn, this)
	  };
	
	  Vue.prototype._render = function () {
	    var vm = this;
	    var ref = vm.$options;
	    var render = ref.render;
	    var _parentVnode = ref._parentVnode;
	
	    // reset _rendered flag on slots for duplicate slot check
	    if (false) {
	      for (var key in vm.$slots) {
	        // $flow-disable-line
	        vm.$slots[key]._rendered = false;
	      }
	    }
	
	    if (_parentVnode) {
	      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
	    }
	
	    // set parent vnode. this allows render functions to have access
	    // to the data on the placeholder node.
	    vm.$vnode = _parentVnode;
	    // render self
	    var vnode;
	    try {
	      vnode = render.call(vm._renderProxy, vm.$createElement);
	    } catch (e) {
	      handleError(e, vm, "render");
	      // return error render result,
	      // or previous vnode to prevent render error causing blank component
	      /* istanbul ignore else */
	      if (false) {
	        if (vm.$options.renderError) {
	          try {
	            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
	          } catch (e) {
	            handleError(e, vm, "renderError");
	            vnode = vm._vnode;
	          }
	        } else {
	          vnode = vm._vnode;
	        }
	      } else {
	        vnode = vm._vnode;
	      }
	    }
	    // return empty vnode in case the render function errored out
	    if (!(vnode instanceof VNode)) {
	      if (false) {
	        warn(
	          'Multiple root nodes returned from render function. Render function ' +
	          'should return a single root node.',
	          vm
	        );
	      }
	      vnode = createEmptyVNode();
	    }
	    // set parent
	    vnode.parent = _parentVnode;
	    return vnode
	  };
	}
	
	/*  */
	
	var uid$3 = 0;
	
	function initMixin (Vue) {
	  Vue.prototype._init = function (options) {
	    var vm = this;
	    // a uid
	    vm._uid = uid$3++;
	
	    var startTag, endTag;
	    /* istanbul ignore if */
	    if (false) {
	      startTag = "vue-perf-start:" + (vm._uid);
	      endTag = "vue-perf-end:" + (vm._uid);
	      mark(startTag);
	    }
	
	    // a flag to avoid this being observed
	    vm._isVue = true;
	    // merge options
	    if (options && options._isComponent) {
	      // optimize internal component instantiation
	      // since dynamic options merging is pretty slow, and none of the
	      // internal component options needs special treatment.
	      initInternalComponent(vm, options);
	    } else {
	      vm.$options = mergeOptions(
	        resolveConstructorOptions(vm.constructor),
	        options || {},
	        vm
	      );
	    }
	    /* istanbul ignore else */
	    if (false) {
	      initProxy(vm);
	    } else {
	      vm._renderProxy = vm;
	    }
	    // expose real self
	    vm._self = vm;
	    initLifecycle(vm);
	    initEvents(vm);
	    initRender(vm);
	    callHook(vm, 'beforeCreate');
	    initInjections(vm); // resolve injections before data/props
	    initState(vm);
	    initProvide(vm); // resolve provide after data/props
	    callHook(vm, 'created');
	
	    /* istanbul ignore if */
	    if (false) {
	      vm._name = formatComponentName(vm, false);
	      mark(endTag);
	      measure(("vue " + (vm._name) + " init"), startTag, endTag);
	    }
	
	    if (vm.$options.el) {
	      vm.$mount(vm.$options.el);
	    }
	  };
	}
	
	function initInternalComponent (vm, options) {
	  var opts = vm.$options = Object.create(vm.constructor.options);
	  // doing this because it's faster than dynamic enumeration.
	  var parentVnode = options._parentVnode;
	  opts.parent = options.parent;
	  opts._parentVnode = parentVnode;
	  opts._parentElm = options._parentElm;
	  opts._refElm = options._refElm;
	
	  var vnodeComponentOptions = parentVnode.componentOptions;
	  opts.propsData = vnodeComponentOptions.propsData;
	  opts._parentListeners = vnodeComponentOptions.listeners;
	  opts._renderChildren = vnodeComponentOptions.children;
	  opts._componentTag = vnodeComponentOptions.tag;
	
	  if (options.render) {
	    opts.render = options.render;
	    opts.staticRenderFns = options.staticRenderFns;
	  }
	}
	
	function resolveConstructorOptions (Ctor) {
	  var options = Ctor.options;
	  if (Ctor.super) {
	    var superOptions = resolveConstructorOptions(Ctor.super);
	    var cachedSuperOptions = Ctor.superOptions;
	    if (superOptions !== cachedSuperOptions) {
	      // super option changed,
	      // need to resolve new options.
	      Ctor.superOptions = superOptions;
	      // check if there are any late-modified/attached options (#4976)
	      var modifiedOptions = resolveModifiedOptions(Ctor);
	      // update base extend options
	      if (modifiedOptions) {
	        extend(Ctor.extendOptions, modifiedOptions);
	      }
	      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
	      if (options.name) {
	        options.components[options.name] = Ctor;
	      }
	    }
	  }
	  return options
	}
	
	function resolveModifiedOptions (Ctor) {
	  var modified;
	  var latest = Ctor.options;
	  var extended = Ctor.extendOptions;
	  var sealed = Ctor.sealedOptions;
	  for (var key in latest) {
	    if (latest[key] !== sealed[key]) {
	      if (!modified) { modified = {}; }
	      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
	    }
	  }
	  return modified
	}
	
	function dedupe (latest, extended, sealed) {
	  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
	  // between merges
	  if (Array.isArray(latest)) {
	    var res = [];
	    sealed = Array.isArray(sealed) ? sealed : [sealed];
	    extended = Array.isArray(extended) ? extended : [extended];
	    for (var i = 0; i < latest.length; i++) {
	      // push original options and not sealed options to exclude duplicated options
	      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
	        res.push(latest[i]);
	      }
	    }
	    return res
	  } else {
	    return latest
	  }
	}
	
	function Vue (options) {
	  if (false
	  ) {
	    warn('Vue is a constructor and should be called with the `new` keyword');
	  }
	  this._init(options);
	}
	
	initMixin(Vue);
	stateMixin(Vue);
	eventsMixin(Vue);
	lifecycleMixin(Vue);
	renderMixin(Vue);
	
	/*  */
	
	function initUse (Vue) {
	  Vue.use = function (plugin) {
	    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
	    if (installedPlugins.indexOf(plugin) > -1) {
	      return this
	    }
	
	    // additional parameters
	    var args = toArray(arguments, 1);
	    args.unshift(this);
	    if (typeof plugin.install === 'function') {
	      plugin.install.apply(plugin, args);
	    } else if (typeof plugin === 'function') {
	      plugin.apply(null, args);
	    }
	    installedPlugins.push(plugin);
	    return this
	  };
	}
	
	/*  */
	
	function initMixin$1 (Vue) {
	  Vue.mixin = function (mixin) {
	    this.options = mergeOptions(this.options, mixin);
	    return this
	  };
	}
	
	/*  */
	
	function initExtend (Vue) {
	  /**
	   * Each instance constructor, including Vue, has a unique
	   * cid. This enables us to create wrapped "child
	   * constructors" for prototypal inheritance and cache them.
	   */
	  Vue.cid = 0;
	  var cid = 1;
	
	  /**
	   * Class inheritance
	   */
	  Vue.extend = function (extendOptions) {
	    extendOptions = extendOptions || {};
	    var Super = this;
	    var SuperId = Super.cid;
	    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
	    if (cachedCtors[SuperId]) {
	      return cachedCtors[SuperId]
	    }
	
	    var name = extendOptions.name || Super.options.name;
	    if (false) {
	      validateComponentName(name);
	    }
	
	    var Sub = function VueComponent (options) {
	      this._init(options);
	    };
	    Sub.prototype = Object.create(Super.prototype);
	    Sub.prototype.constructor = Sub;
	    Sub.cid = cid++;
	    Sub.options = mergeOptions(
	      Super.options,
	      extendOptions
	    );
	    Sub['super'] = Super;
	
	    // For props and computed properties, we define the proxy getters on
	    // the Vue instances at extension time, on the extended prototype. This
	    // avoids Object.defineProperty calls for each instance created.
	    if (Sub.options.props) {
	      initProps$1(Sub);
	    }
	    if (Sub.options.computed) {
	      initComputed$1(Sub);
	    }
	
	    // allow further extension/mixin/plugin usage
	    Sub.extend = Super.extend;
	    Sub.mixin = Super.mixin;
	    Sub.use = Super.use;
	
	    // create asset registers, so extended classes
	    // can have their private assets too.
	    ASSET_TYPES.forEach(function (type) {
	      Sub[type] = Super[type];
	    });
	    // enable recursive self-lookup
	    if (name) {
	      Sub.options.components[name] = Sub;
	    }
	
	    // keep a reference to the super options at extension time.
	    // later at instantiation we can check if Super's options have
	    // been updated.
	    Sub.superOptions = Super.options;
	    Sub.extendOptions = extendOptions;
	    Sub.sealedOptions = extend({}, Sub.options);
	
	    // cache constructor
	    cachedCtors[SuperId] = Sub;
	    return Sub
	  };
	}
	
	function initProps$1 (Comp) {
	  var props = Comp.options.props;
	  for (var key in props) {
	    proxy(Comp.prototype, "_props", key);
	  }
	}
	
	function initComputed$1 (Comp) {
	  var computed = Comp.options.computed;
	  for (var key in computed) {
	    defineComputed(Comp.prototype, key, computed[key]);
	  }
	}
	
	/*  */
	
	function initAssetRegisters (Vue) {
	  /**
	   * Create asset registration methods.
	   */
	  ASSET_TYPES.forEach(function (type) {
	    Vue[type] = function (
	      id,
	      definition
	    ) {
	      if (!definition) {
	        return this.options[type + 's'][id]
	      } else {
	        /* istanbul ignore if */
	        if (false) {
	          validateComponentName(id);
	        }
	        if (type === 'component' && isPlainObject(definition)) {
	          definition.name = definition.name || id;
	          definition = this.options._base.extend(definition);
	        }
	        if (type === 'directive' && typeof definition === 'function') {
	          definition = { bind: definition, update: definition };
	        }
	        this.options[type + 's'][id] = definition;
	        return definition
	      }
	    };
	  });
	}
	
	/*  */
	
	function getComponentName (opts) {
	  return opts && (opts.Ctor.options.name || opts.tag)
	}
	
	function matches (pattern, name) {
	  if (Array.isArray(pattern)) {
	    return pattern.indexOf(name) > -1
	  } else if (typeof pattern === 'string') {
	    return pattern.split(',').indexOf(name) > -1
	  } else if (isRegExp(pattern)) {
	    return pattern.test(name)
	  }
	  /* istanbul ignore next */
	  return false
	}
	
	function pruneCache (keepAliveInstance, filter) {
	  var cache = keepAliveInstance.cache;
	  var keys = keepAliveInstance.keys;
	  var _vnode = keepAliveInstance._vnode;
	  for (var key in cache) {
	    var cachedNode = cache[key];
	    if (cachedNode) {
	      var name = getComponentName(cachedNode.componentOptions);
	      if (name && !filter(name)) {
	        pruneCacheEntry(cache, key, keys, _vnode);
	      }
	    }
	  }
	}
	
	function pruneCacheEntry (
	  cache,
	  key,
	  keys,
	  current
	) {
	  var cached$$1 = cache[key];
	  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
	    cached$$1.componentInstance.$destroy();
	  }
	  cache[key] = null;
	  remove(keys, key);
	}
	
	var patternTypes = [String, RegExp, Array];
	
	var KeepAlive = {
	  name: 'keep-alive',
	  abstract: true,
	
	  props: {
	    include: patternTypes,
	    exclude: patternTypes,
	    max: [String, Number]
	  },
	
	  created: function created () {
	    this.cache = Object.create(null);
	    this.keys = [];
	  },
	
	  destroyed: function destroyed () {
	    var this$1 = this;
	
	    for (var key in this$1.cache) {
	      pruneCacheEntry(this$1.cache, key, this$1.keys);
	    }
	  },
	
	  mounted: function mounted () {
	    var this$1 = this;
	
	    this.$watch('include', function (val) {
	      pruneCache(this$1, function (name) { return matches(val, name); });
	    });
	    this.$watch('exclude', function (val) {
	      pruneCache(this$1, function (name) { return !matches(val, name); });
	    });
	  },
	
	  render: function render () {
	    var slot = this.$slots.default;
	    var vnode = getFirstComponentChild(slot);
	    var componentOptions = vnode && vnode.componentOptions;
	    if (componentOptions) {
	      // check pattern
	      var name = getComponentName(componentOptions);
	      var ref = this;
	      var include = ref.include;
	      var exclude = ref.exclude;
	      if (
	        // not included
	        (include && (!name || !matches(include, name))) ||
	        // excluded
	        (exclude && name && matches(exclude, name))
	      ) {
	        return vnode
	      }
	
	      var ref$1 = this;
	      var cache = ref$1.cache;
	      var keys = ref$1.keys;
	      var key = vnode.key == null
	        // same constructor may get registered as different local components
	        // so cid alone is not enough (#3269)
	        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
	        : vnode.key;
	      if (cache[key]) {
	        vnode.componentInstance = cache[key].componentInstance;
	        // make current key freshest
	        remove(keys, key);
	        keys.push(key);
	      } else {
	        cache[key] = vnode;
	        keys.push(key);
	        // prune oldest entry
	        if (this.max && keys.length > parseInt(this.max)) {
	          pruneCacheEntry(cache, keys[0], keys, this._vnode);
	        }
	      }
	
	      vnode.data.keepAlive = true;
	    }
	    return vnode || (slot && slot[0])
	  }
	}
	
	var builtInComponents = {
	  KeepAlive: KeepAlive
	}
	
	/*  */
	
	function initGlobalAPI (Vue) {
	  // config
	  var configDef = {};
	  configDef.get = function () { return config; };
	  if (false) {
	    configDef.set = function () {
	      warn(
	        'Do not replace the Vue.config object, set individual fields instead.'
	      );
	    };
	  }
	  Object.defineProperty(Vue, 'config', configDef);
	
	  // exposed util methods.
	  // NOTE: these are not considered part of the public API - avoid relying on
	  // them unless you are aware of the risk.
	  Vue.util = {
	    warn: warn,
	    extend: extend,
	    mergeOptions: mergeOptions,
	    defineReactive: defineReactive
	  };
	
	  Vue.set = set;
	  Vue.delete = del;
	  Vue.nextTick = nextTick;
	
	  Vue.options = Object.create(null);
	  ASSET_TYPES.forEach(function (type) {
	    Vue.options[type + 's'] = Object.create(null);
	  });
	
	  // this is used to identify the "base" constructor to extend all plain-object
	  // components with in Weex's multi-instance scenarios.
	  Vue.options._base = Vue;
	
	  extend(Vue.options.components, builtInComponents);
	
	  initUse(Vue);
	  initMixin$1(Vue);
	  initExtend(Vue);
	  initAssetRegisters(Vue);
	}
	
	initGlobalAPI(Vue);
	
	Object.defineProperty(Vue.prototype, '$isServer', {
	  get: isServerRendering
	});
	
	Object.defineProperty(Vue.prototype, '$ssrContext', {
	  get: function get () {
	    /* istanbul ignore next */
	    return this.$vnode && this.$vnode.ssrContext
	  }
	});
	
	// expose FunctionalRenderContext for ssr runtime helper installation
	Object.defineProperty(Vue, 'FunctionalRenderContext', {
	  value: FunctionalRenderContext
	});
	
	Vue.version = '2.5.16';
	
	/*  */
	
	// these are reserved for web because they are directly compiled away
	// during template compilation
	var isReservedAttr = makeMap('style,class');
	
	// attributes that should be using props for binding
	var acceptValue = makeMap('input,textarea,option,select,progress');
	var mustUseProp = function (tag, type, attr) {
	  return (
	    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
	    (attr === 'selected' && tag === 'option') ||
	    (attr === 'checked' && tag === 'input') ||
	    (attr === 'muted' && tag === 'video')
	  )
	};
	
	var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
	
	var isBooleanAttr = makeMap(
	  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
	  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
	  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
	  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
	  'required,reversed,scoped,seamless,selected,sortable,translate,' +
	  'truespeed,typemustmatch,visible'
	);
	
	var xlinkNS = 'http://www.w3.org/1999/xlink';
	
	var isXlink = function (name) {
	  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
	};
	
	var getXlinkProp = function (name) {
	  return isXlink(name) ? name.slice(6, name.length) : ''
	};
	
	var isFalsyAttrValue = function (val) {
	  return val == null || val === false
	};
	
	/*  */
	
	function genClassForVnode (vnode) {
	  var data = vnode.data;
	  var parentNode = vnode;
	  var childNode = vnode;
	  while (isDef(childNode.componentInstance)) {
	    childNode = childNode.componentInstance._vnode;
	    if (childNode && childNode.data) {
	      data = mergeClassData(childNode.data, data);
	    }
	  }
	  while (isDef(parentNode = parentNode.parent)) {
	    if (parentNode && parentNode.data) {
	      data = mergeClassData(data, parentNode.data);
	    }
	  }
	  return renderClass(data.staticClass, data.class)
	}
	
	function mergeClassData (child, parent) {
	  return {
	    staticClass: concat(child.staticClass, parent.staticClass),
	    class: isDef(child.class)
	      ? [child.class, parent.class]
	      : parent.class
	  }
	}
	
	function renderClass (
	  staticClass,
	  dynamicClass
	) {
	  if (isDef(staticClass) || isDef(dynamicClass)) {
	    return concat(staticClass, stringifyClass(dynamicClass))
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function concat (a, b) {
	  return a ? b ? (a + ' ' + b) : a : (b || '')
	}
	
	function stringifyClass (value) {
	  if (Array.isArray(value)) {
	    return stringifyArray(value)
	  }
	  if (isObject(value)) {
	    return stringifyObject(value)
	  }
	  if (typeof value === 'string') {
	    return value
	  }
	  /* istanbul ignore next */
	  return ''
	}
	
	function stringifyArray (value) {
	  var res = '';
	  var stringified;
	  for (var i = 0, l = value.length; i < l; i++) {
	    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
	      if (res) { res += ' '; }
	      res += stringified;
	    }
	  }
	  return res
	}
	
	function stringifyObject (value) {
	  var res = '';
	  for (var key in value) {
	    if (value[key]) {
	      if (res) { res += ' '; }
	      res += key;
	    }
	  }
	  return res
	}
	
	/*  */
	
	var namespaceMap = {
	  svg: 'http://www.w3.org/2000/svg',
	  math: 'http://www.w3.org/1998/Math/MathML'
	};
	
	var isHTMLTag = makeMap(
	  'html,body,base,head,link,meta,style,title,' +
	  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
	  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
	  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
	  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
	  'embed,object,param,source,canvas,script,noscript,del,ins,' +
	  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
	  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
	  'output,progress,select,textarea,' +
	  'details,dialog,menu,menuitem,summary,' +
	  'content,element,shadow,template,blockquote,iframe,tfoot'
	);
	
	// this map is intentionally selective, only covering SVG elements that may
	// contain child elements.
	var isSVG = makeMap(
	  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
	  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
	  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
	  true
	);
	
	var isPreTag = function (tag) { return tag === 'pre'; };
	
	var isReservedTag = function (tag) {
	  return isHTMLTag(tag) || isSVG(tag)
	};
	
	function getTagNamespace (tag) {
	  if (isSVG(tag)) {
	    return 'svg'
	  }
	  // basic support for MathML
	  // note it doesn't support other MathML elements being component roots
	  if (tag === 'math') {
	    return 'math'
	  }
	}
	
	var unknownElementCache = Object.create(null);
	function isUnknownElement (tag) {
	  /* istanbul ignore if */
	  if (!inBrowser) {
	    return true
	  }
	  if (isReservedTag(tag)) {
	    return false
	  }
	  tag = tag.toLowerCase();
	  /* istanbul ignore if */
	  if (unknownElementCache[tag] != null) {
	    return unknownElementCache[tag]
	  }
	  var el = document.createElement(tag);
	  if (tag.indexOf('-') > -1) {
	    // http://stackoverflow.com/a/28210364/1070244
	    return (unknownElementCache[tag] = (
	      el.constructor === window.HTMLUnknownElement ||
	      el.constructor === window.HTMLElement
	    ))
	  } else {
	    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
	  }
	}
	
	var isTextInputType = makeMap('text,number,password,search,email,tel,url');
	
	/*  */
	
	/**
	 * Query an element selector if it's not an element already.
	 */
	function query (el) {
	  if (typeof el === 'string') {
	    var selected = document.querySelector(el);
	    if (!selected) {
	      ("production") !== 'production' && warn(
	        'Cannot find element: ' + el
	      );
	      return document.createElement('div')
	    }
	    return selected
	  } else {
	    return el
	  }
	}
	
	/*  */
	
	function createElement$1 (tagName, vnode) {
	  var elm = document.createElement(tagName);
	  if (tagName !== 'select') {
	    return elm
	  }
	  // false or null will remove the attribute but undefined will not
	  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
	    elm.setAttribute('multiple', 'multiple');
	  }
	  return elm
	}
	
	function createElementNS (namespace, tagName) {
	  return document.createElementNS(namespaceMap[namespace], tagName)
	}
	
	function createTextNode (text) {
	  return document.createTextNode(text)
	}
	
	function createComment (text) {
	  return document.createComment(text)
	}
	
	function insertBefore (parentNode, newNode, referenceNode) {
	  parentNode.insertBefore(newNode, referenceNode);
	}
	
	function removeChild (node, child) {
	  node.removeChild(child);
	}
	
	function appendChild (node, child) {
	  node.appendChild(child);
	}
	
	function parentNode (node) {
	  return node.parentNode
	}
	
	function nextSibling (node) {
	  return node.nextSibling
	}
	
	function tagName (node) {
	  return node.tagName
	}
	
	function setTextContent (node, text) {
	  node.textContent = text;
	}
	
	function setStyleScope (node, scopeId) {
	  node.setAttribute(scopeId, '');
	}
	
	
	var nodeOps = Object.freeze({
		createElement: createElement$1,
		createElementNS: createElementNS,
		createTextNode: createTextNode,
		createComment: createComment,
		insertBefore: insertBefore,
		removeChild: removeChild,
		appendChild: appendChild,
		parentNode: parentNode,
		nextSibling: nextSibling,
		tagName: tagName,
		setTextContent: setTextContent,
		setStyleScope: setStyleScope
	});
	
	/*  */
	
	var ref = {
	  create: function create (_, vnode) {
	    registerRef(vnode);
	  },
	  update: function update (oldVnode, vnode) {
	    if (oldVnode.data.ref !== vnode.data.ref) {
	      registerRef(oldVnode, true);
	      registerRef(vnode);
	    }
	  },
	  destroy: function destroy (vnode) {
	    registerRef(vnode, true);
	  }
	}
	
	function registerRef (vnode, isRemoval) {
	  var key = vnode.data.ref;
	  if (!isDef(key)) { return }
	
	  var vm = vnode.context;
	  var ref = vnode.componentInstance || vnode.elm;
	  var refs = vm.$refs;
	  if (isRemoval) {
	    if (Array.isArray(refs[key])) {
	      remove(refs[key], ref);
	    } else if (refs[key] === ref) {
	      refs[key] = undefined;
	    }
	  } else {
	    if (vnode.data.refInFor) {
	      if (!Array.isArray(refs[key])) {
	        refs[key] = [ref];
	      } else if (refs[key].indexOf(ref) < 0) {
	        // $flow-disable-line
	        refs[key].push(ref);
	      }
	    } else {
	      refs[key] = ref;
	    }
	  }
	}
	
	/**
	 * Virtual DOM patching algorithm based on Snabbdom by
	 * Simon Friis Vindum (@paldepind)
	 * Licensed under the MIT License
	 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
	 *
	 * modified by Evan You (@yyx990803)
	 *
	 * Not type-checking this because this file is perf-critical and the cost
	 * of making flow understand it is not worth it.
	 */
	
	var emptyNode = new VNode('', {}, []);
	
	var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
	
	function sameVnode (a, b) {
	  return (
	    a.key === b.key && (
	      (
	        a.tag === b.tag &&
	        a.isComment === b.isComment &&
	        isDef(a.data) === isDef(b.data) &&
	        sameInputType(a, b)
	      ) || (
	        isTrue(a.isAsyncPlaceholder) &&
	        a.asyncFactory === b.asyncFactory &&
	        isUndef(b.asyncFactory.error)
	      )
	    )
	  )
	}
	
	function sameInputType (a, b) {
	  if (a.tag !== 'input') { return true }
	  var i;
	  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
	  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
	  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
	}
	
	function createKeyToOldIdx (children, beginIdx, endIdx) {
	  var i, key;
	  var map = {};
	  for (i = beginIdx; i <= endIdx; ++i) {
	    key = children[i].key;
	    if (isDef(key)) { map[key] = i; }
	  }
	  return map
	}
	
	function createPatchFunction (backend) {
	  var i, j;
	  var cbs = {};
	
	  var modules = backend.modules;
	  var nodeOps = backend.nodeOps;
	
	  for (i = 0; i < hooks.length; ++i) {
	    cbs[hooks[i]] = [];
	    for (j = 0; j < modules.length; ++j) {
	      if (isDef(modules[j][hooks[i]])) {
	        cbs[hooks[i]].push(modules[j][hooks[i]]);
	      }
	    }
	  }
	
	  function emptyNodeAt (elm) {
	    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
	  }
	
	  function createRmCb (childElm, listeners) {
	    function remove () {
	      if (--remove.listeners === 0) {
	        removeNode(childElm);
	      }
	    }
	    remove.listeners = listeners;
	    return remove
	  }
	
	  function removeNode (el) {
	    var parent = nodeOps.parentNode(el);
	    // element may have already been removed due to v-html / v-text
	    if (isDef(parent)) {
	      nodeOps.removeChild(parent, el);
	    }
	  }
	
	  function isUnknownElement$$1 (vnode, inVPre) {
	    return (
	      !inVPre &&
	      !vnode.ns &&
	      !(
	        config.ignoredElements.length &&
	        config.ignoredElements.some(function (ignore) {
	          return isRegExp(ignore)
	            ? ignore.test(vnode.tag)
	            : ignore === vnode.tag
	        })
	      ) &&
	      config.isUnknownElement(vnode.tag)
	    )
	  }
	
	  var creatingElmInVPre = 0;
	
	  function createElm (
	    vnode,
	    insertedVnodeQueue,
	    parentElm,
	    refElm,
	    nested,
	    ownerArray,
	    index
	  ) {
	    if (isDef(vnode.elm) && isDef(ownerArray)) {
	      // This vnode was used in a previous render!
	      // now it's used as a new node, overwriting its elm would cause
	      // potential patch errors down the road when it's used as an insertion
	      // reference node. Instead, we clone the node on-demand before creating
	      // associated DOM element for it.
	      vnode = ownerArray[index] = cloneVNode(vnode);
	    }
	
	    vnode.isRootInsert = !nested; // for transition enter check
	    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
	      return
	    }
	
	    var data = vnode.data;
	    var children = vnode.children;
	    var tag = vnode.tag;
	    if (isDef(tag)) {
	      if (false) {
	        if (data && data.pre) {
	          creatingElmInVPre++;
	        }
	        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
	          warn(
	            'Unknown custom element: <' + tag + '> - did you ' +
	            'register the component correctly? For recursive components, ' +
	            'make sure to provide the "name" option.',
	            vnode.context
	          );
	        }
	      }
	
	      vnode.elm = vnode.ns
	        ? nodeOps.createElementNS(vnode.ns, tag)
	        : nodeOps.createElement(tag, vnode);
	      setScope(vnode);
	
	      /* istanbul ignore if */
	      {
	        createChildren(vnode, children, insertedVnodeQueue);
	        if (isDef(data)) {
	          invokeCreateHooks(vnode, insertedVnodeQueue);
	        }
	        insert(parentElm, vnode.elm, refElm);
	      }
	
	      if (false) {
	        creatingElmInVPre--;
	      }
	    } else if (isTrue(vnode.isComment)) {
	      vnode.elm = nodeOps.createComment(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    } else {
	      vnode.elm = nodeOps.createTextNode(vnode.text);
	      insert(parentElm, vnode.elm, refElm);
	    }
	  }
	
	  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i = vnode.data;
	    if (isDef(i)) {
	      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
	      if (isDef(i = i.hook) && isDef(i = i.init)) {
	        i(vnode, false /* hydrating */, parentElm, refElm);
	      }
	      // after calling the init hook, if the vnode is a child component
	      // it should've created a child instance and mounted it. the child
	      // component also has set the placeholder vnode's elm.
	      // in that case we can just return the element and be done.
	      if (isDef(vnode.componentInstance)) {
	        initComponent(vnode, insertedVnodeQueue);
	        if (isTrue(isReactivated)) {
	          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
	        }
	        return true
	      }
	    }
	  }
	
	  function initComponent (vnode, insertedVnodeQueue) {
	    if (isDef(vnode.data.pendingInsert)) {
	      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
	      vnode.data.pendingInsert = null;
	    }
	    vnode.elm = vnode.componentInstance.$el;
	    if (isPatchable(vnode)) {
	      invokeCreateHooks(vnode, insertedVnodeQueue);
	      setScope(vnode);
	    } else {
	      // empty component root.
	      // skip all element-related modules except for ref (#3455)
	      registerRef(vnode);
	      // make sure to invoke the insert hook
	      insertedVnodeQueue.push(vnode);
	    }
	  }
	
	  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
	    var i;
	    // hack for #4339: a reactivated component with inner transition
	    // does not trigger because the inner node's created hooks are not called
	    // again. It's not ideal to involve module-specific logic in here but
	    // there doesn't seem to be a better way to do it.
	    var innerNode = vnode;
	    while (innerNode.componentInstance) {
	      innerNode = innerNode.componentInstance._vnode;
	      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
	        for (i = 0; i < cbs.activate.length; ++i) {
	          cbs.activate[i](emptyNode, innerNode);
	        }
	        insertedVnodeQueue.push(innerNode);
	        break
	      }
	    }
	    // unlike a newly created component,
	    // a reactivated keep-alive component doesn't insert itself
	    insert(parentElm, vnode.elm, refElm);
	  }
	
	  function insert (parent, elm, ref$$1) {
	    if (isDef(parent)) {
	      if (isDef(ref$$1)) {
	        if (ref$$1.parentNode === parent) {
	          nodeOps.insertBefore(parent, elm, ref$$1);
	        }
	      } else {
	        nodeOps.appendChild(parent, elm);
	      }
	    }
	  }
	
	  function createChildren (vnode, children, insertedVnodeQueue) {
	    if (Array.isArray(children)) {
	      if (false) {
	        checkDuplicateKeys(children);
	      }
	      for (var i = 0; i < children.length; ++i) {
	        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
	      }
	    } else if (isPrimitive(vnode.text)) {
	      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
	    }
	  }
	
	  function isPatchable (vnode) {
	    while (vnode.componentInstance) {
	      vnode = vnode.componentInstance._vnode;
	    }
	    return isDef(vnode.tag)
	  }
	
	  function invokeCreateHooks (vnode, insertedVnodeQueue) {
	    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	      cbs.create[i$1](emptyNode, vnode);
	    }
	    i = vnode.data.hook; // Reuse variable
	    if (isDef(i)) {
	      if (isDef(i.create)) { i.create(emptyNode, vnode); }
	      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
	    }
	  }
	
	  // set scope id attribute for scoped CSS.
	  // this is implemented as a special case to avoid the overhead
	  // of going through the normal attribute patching process.
	  function setScope (vnode) {
	    var i;
	    if (isDef(i = vnode.fnScopeId)) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    } else {
	      var ancestor = vnode;
	      while (ancestor) {
	        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
	          nodeOps.setStyleScope(vnode.elm, i);
	        }
	        ancestor = ancestor.parent;
	      }
	    }
	    // for slot content they should also get the scopeId from the host instance.
	    if (isDef(i = activeInstance) &&
	      i !== vnode.context &&
	      i !== vnode.fnContext &&
	      isDef(i = i.$options._scopeId)
	    ) {
	      nodeOps.setStyleScope(vnode.elm, i);
	    }
	  }
	
	  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
	    }
	  }
	
	  function invokeDestroyHook (vnode) {
	    var i, j;
	    var data = vnode.data;
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
	      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
	    }
	    if (isDef(i = vnode.children)) {
	      for (j = 0; j < vnode.children.length; ++j) {
	        invokeDestroyHook(vnode.children[j]);
	      }
	    }
	  }
	
	  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
	    for (; startIdx <= endIdx; ++startIdx) {
	      var ch = vnodes[startIdx];
	      if (isDef(ch)) {
	        if (isDef(ch.tag)) {
	          removeAndInvokeRemoveHook(ch);
	          invokeDestroyHook(ch);
	        } else { // Text node
	          removeNode(ch.elm);
	        }
	      }
	    }
	  }
	
	  function removeAndInvokeRemoveHook (vnode, rm) {
	    if (isDef(rm) || isDef(vnode.data)) {
	      var i;
	      var listeners = cbs.remove.length + 1;
	      if (isDef(rm)) {
	        // we have a recursively passed down rm callback
	        // increase the listeners count
	        rm.listeners += listeners;
	      } else {
	        // directly removing
	        rm = createRmCb(vnode.elm, listeners);
	      }
	      // recursively invoke hooks on child component root node
	      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
	        removeAndInvokeRemoveHook(i, rm);
	      }
	      for (i = 0; i < cbs.remove.length; ++i) {
	        cbs.remove[i](vnode, rm);
	      }
	      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
	        i(vnode, rm);
	      } else {
	        rm();
	      }
	    } else {
	      removeNode(vnode.elm);
	    }
	  }
	
	  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
	    var oldStartIdx = 0;
	    var newStartIdx = 0;
	    var oldEndIdx = oldCh.length - 1;
	    var oldStartVnode = oldCh[0];
	    var oldEndVnode = oldCh[oldEndIdx];
	    var newEndIdx = newCh.length - 1;
	    var newStartVnode = newCh[0];
	    var newEndVnode = newCh[newEndIdx];
	    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
	
	    // removeOnly is a special flag used only by <transition-group>
	    // to ensure removed elements stay in correct relative positions
	    // during leaving transitions
	    var canMove = !removeOnly;
	
	    if (false) {
	      checkDuplicateKeys(newCh);
	    }
	
	    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
	      if (isUndef(oldStartVnode)) {
	        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
	      } else if (isUndef(oldEndVnode)) {
	        oldEndVnode = oldCh[--oldEndIdx];
	      } else if (sameVnode(oldStartVnode, newStartVnode)) {
	        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
	        oldStartVnode = oldCh[++oldStartIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else if (sameVnode(oldEndVnode, newEndVnode)) {
	        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
	        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
	        oldStartVnode = oldCh[++oldStartIdx];
	        newEndVnode = newCh[--newEndIdx];
	      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
	        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
	        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
	        oldEndVnode = oldCh[--oldEndIdx];
	        newStartVnode = newCh[++newStartIdx];
	      } else {
	        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
	        idxInOld = isDef(newStartVnode.key)
	          ? oldKeyToIdx[newStartVnode.key]
	          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
	        if (isUndef(idxInOld)) { // New element
	          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	        } else {
	          vnodeToMove = oldCh[idxInOld];
	          if (sameVnode(vnodeToMove, newStartVnode)) {
	            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
	            oldCh[idxInOld] = undefined;
	            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
	          } else {
	            // same key but different element. treat as new element
	            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
	          }
	        }
	        newStartVnode = newCh[++newStartIdx];
	      }
	    }
	    if (oldStartIdx > oldEndIdx) {
	      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
	      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
	    } else if (newStartIdx > newEndIdx) {
	      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
	    }
	  }
	
	  function checkDuplicateKeys (children) {
	    var seenKeys = {};
	    for (var i = 0; i < children.length; i++) {
	      var vnode = children[i];
	      var key = vnode.key;
	      if (isDef(key)) {
	        if (seenKeys[key]) {
	          warn(
	            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
	            vnode.context
	          );
	        } else {
	          seenKeys[key] = true;
	        }
	      }
	    }
	  }
	
	  function findIdxInOld (node, oldCh, start, end) {
	    for (var i = start; i < end; i++) {
	      var c = oldCh[i];
	      if (isDef(c) && sameVnode(node, c)) { return i }
	    }
	  }
	
	  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
	    if (oldVnode === vnode) {
	      return
	    }
	
	    var elm = vnode.elm = oldVnode.elm;
	
	    if (isTrue(oldVnode.isAsyncPlaceholder)) {
	      if (isDef(vnode.asyncFactory.resolved)) {
	        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
	      } else {
	        vnode.isAsyncPlaceholder = true;
	      }
	      return
	    }
	
	    // reuse element for static trees.
	    // note we only do this if the vnode is cloned -
	    // if the new node is not cloned it means the render functions have been
	    // reset by the hot-reload-api and we need to do a proper re-render.
	    if (isTrue(vnode.isStatic) &&
	      isTrue(oldVnode.isStatic) &&
	      vnode.key === oldVnode.key &&
	      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
	    ) {
	      vnode.componentInstance = oldVnode.componentInstance;
	      return
	    }
	
	    var i;
	    var data = vnode.data;
	    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
	      i(oldVnode, vnode);
	    }
	
	    var oldCh = oldVnode.children;
	    var ch = vnode.children;
	    if (isDef(data) && isPatchable(vnode)) {
	      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
	      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
	    }
	    if (isUndef(vnode.text)) {
	      if (isDef(oldCh) && isDef(ch)) {
	        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
	      } else if (isDef(ch)) {
	        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
	        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
	      } else if (isDef(oldCh)) {
	        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
	      } else if (isDef(oldVnode.text)) {
	        nodeOps.setTextContent(elm, '');
	      }
	    } else if (oldVnode.text !== vnode.text) {
	      nodeOps.setTextContent(elm, vnode.text);
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
	    }
	  }
	
	  function invokeInsertHook (vnode, queue, initial) {
	    // delay insert hooks for component root nodes, invoke them after the
	    // element is really inserted
	    if (isTrue(initial) && isDef(vnode.parent)) {
	      vnode.parent.data.pendingInsert = queue;
	    } else {
	      for (var i = 0; i < queue.length; ++i) {
	        queue[i].data.hook.insert(queue[i]);
	      }
	    }
	  }
	
	  var hydrationBailed = false;
	  // list of modules that can skip create hook during hydration because they
	  // are already rendered on the client or has no need for initialization
	  // Note: style is excluded because it relies on initial clone for future
	  // deep updates (#7063).
	  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
	
	  // Note: this is a browser-only function so we can assume elms are DOM nodes.
	  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
	    var i;
	    var tag = vnode.tag;
	    var data = vnode.data;
	    var children = vnode.children;
	    inVPre = inVPre || (data && data.pre);
	    vnode.elm = elm;
	
	    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
	      vnode.isAsyncPlaceholder = true;
	      return true
	    }
	    // assert node match
	    if (false) {
	      if (!assertNodeMatch(elm, vnode, inVPre)) {
	        return false
	      }
	    }
	    if (isDef(data)) {
	      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
	      if (isDef(i = vnode.componentInstance)) {
	        // child component. it should have hydrated its own tree.
	        initComponent(vnode, insertedVnodeQueue);
	        return true
	      }
	    }
	    if (isDef(tag)) {
	      if (isDef(children)) {
	        // empty element, allow client to pick up and populate children
	        if (!elm.hasChildNodes()) {
	          createChildren(vnode, children, insertedVnodeQueue);
	        } else {
	          // v-html and domProps: innerHTML
	          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
	            if (i !== elm.innerHTML) {
	              /* istanbul ignore if */
	              if (false
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('server innerHTML: ', i);
	                console.warn('client innerHTML: ', elm.innerHTML);
	              }
	              return false
	            }
	          } else {
	            // iterate and compare children lists
	            var childrenMatch = true;
	            var childNode = elm.firstChild;
	            for (var i$1 = 0; i$1 < children.length; i$1++) {
	              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
	                childrenMatch = false;
	                break
	              }
	              childNode = childNode.nextSibling;
	            }
	            // if childNode is not null, it means the actual childNodes list is
	            // longer than the virtual children list.
	            if (!childrenMatch || childNode) {
	              /* istanbul ignore if */
	              if (false
	              ) {
	                hydrationBailed = true;
	                console.warn('Parent: ', elm);
	                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
	              }
	              return false
	            }
	          }
	        }
	      }
	      if (isDef(data)) {
	        var fullInvoke = false;
	        for (var key in data) {
	          if (!isRenderedModule(key)) {
	            fullInvoke = true;
	            invokeCreateHooks(vnode, insertedVnodeQueue);
	            break
	          }
	        }
	        if (!fullInvoke && data['class']) {
	          // ensure collecting deps for deep class bindings for future updates
	          traverse(data['class']);
	        }
	      }
	    } else if (elm.data !== vnode.text) {
	      elm.data = vnode.text;
	    }
	    return true
	  }
	
	  function assertNodeMatch (node, vnode, inVPre) {
	    if (isDef(vnode.tag)) {
	      return vnode.tag.indexOf('vue-component') === 0 || (
	        !isUnknownElement$$1(vnode, inVPre) &&
	        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
	      )
	    } else {
	      return node.nodeType === (vnode.isComment ? 8 : 3)
	    }
	  }
	
	  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
	    if (isUndef(vnode)) {
	      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
	      return
	    }
	
	    var isInitialPatch = false;
	    var insertedVnodeQueue = [];
	
	    if (isUndef(oldVnode)) {
	      // empty mount (likely as component), create new root element
	      isInitialPatch = true;
	      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
	    } else {
	      var isRealElement = isDef(oldVnode.nodeType);
	      if (!isRealElement && sameVnode(oldVnode, vnode)) {
	        // patch existing root node
	        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
	      } else {
	        if (isRealElement) {
	          // mounting to a real element
	          // check if this is server-rendered content and if we can perform
	          // a successful hydration.
	          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
	            oldVnode.removeAttribute(SSR_ATTR);
	            hydrating = true;
	          }
	          if (isTrue(hydrating)) {
	            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
	              invokeInsertHook(vnode, insertedVnodeQueue, true);
	              return oldVnode
	            } else if (false) {
	              warn(
	                'The client-side rendered virtual DOM tree is not matching ' +
	                'server-rendered content. This is likely caused by incorrect ' +
	                'HTML markup, for example nesting block-level elements inside ' +
	                '<p>, or missing <tbody>. Bailing hydration and performing ' +
	                'full client-side render.'
	              );
	            }
	          }
	          // either not server-rendered, or hydration failed.
	          // create an empty node and replace it
	          oldVnode = emptyNodeAt(oldVnode);
	        }
	
	        // replacing existing element
	        var oldElm = oldVnode.elm;
	        var parentElm$1 = nodeOps.parentNode(oldElm);
	
	        // create new node
	        createElm(
	          vnode,
	          insertedVnodeQueue,
	          // extremely rare edge case: do not insert if old element is in a
	          // leaving transition. Only happens when combining transition +
	          // keep-alive + HOCs. (#4590)
	          oldElm._leaveCb ? null : parentElm$1,
	          nodeOps.nextSibling(oldElm)
	        );
	
	        // update parent placeholder node element, recursively
	        if (isDef(vnode.parent)) {
	          var ancestor = vnode.parent;
	          var patchable = isPatchable(vnode);
	          while (ancestor) {
	            for (var i = 0; i < cbs.destroy.length; ++i) {
	              cbs.destroy[i](ancestor);
	            }
	            ancestor.elm = vnode.elm;
	            if (patchable) {
	              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
	                cbs.create[i$1](emptyNode, ancestor);
	              }
	              // #6513
	              // invoke insert hooks that may have been merged by create hooks.
	              // e.g. for directives that uses the "inserted" hook.
	              var insert = ancestor.data.hook.insert;
	              if (insert.merged) {
	                // start at index 1 to avoid re-invoking component mounted hook
	                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
	                  insert.fns[i$2]();
	                }
	              }
	            } else {
	              registerRef(ancestor);
	            }
	            ancestor = ancestor.parent;
	          }
	        }
	
	        // destroy old node
	        if (isDef(parentElm$1)) {
	          removeVnodes(parentElm$1, [oldVnode], 0, 0);
	        } else if (isDef(oldVnode.tag)) {
	          invokeDestroyHook(oldVnode);
	        }
	      }
	    }
	
	    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
	    return vnode.elm
	  }
	}
	
	/*  */
	
	var directives = {
	  create: updateDirectives,
	  update: updateDirectives,
	  destroy: function unbindDirectives (vnode) {
	    updateDirectives(vnode, emptyNode);
	  }
	}
	
	function updateDirectives (oldVnode, vnode) {
	  if (oldVnode.data.directives || vnode.data.directives) {
	    _update(oldVnode, vnode);
	  }
	}
	
	function _update (oldVnode, vnode) {
	  var isCreate = oldVnode === emptyNode;
	  var isDestroy = vnode === emptyNode;
	  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
	  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);
	
	  var dirsWithInsert = [];
	  var dirsWithPostpatch = [];
	
	  var key, oldDir, dir;
	  for (key in newDirs) {
	    oldDir = oldDirs[key];
	    dir = newDirs[key];
	    if (!oldDir) {
	      // new directive, bind
	      callHook$1(dir, 'bind', vnode, oldVnode);
	      if (dir.def && dir.def.inserted) {
	        dirsWithInsert.push(dir);
	      }
	    } else {
	      // existing directive, update
	      dir.oldValue = oldDir.value;
	      callHook$1(dir, 'update', vnode, oldVnode);
	      if (dir.def && dir.def.componentUpdated) {
	        dirsWithPostpatch.push(dir);
	      }
	    }
	  }
	
	  if (dirsWithInsert.length) {
	    var callInsert = function () {
	      for (var i = 0; i < dirsWithInsert.length; i++) {
	        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
	      }
	    };
	    if (isCreate) {
	      mergeVNodeHook(vnode, 'insert', callInsert);
	    } else {
	      callInsert();
	    }
	  }
	
	  if (dirsWithPostpatch.length) {
	    mergeVNodeHook(vnode, 'postpatch', function () {
	      for (var i = 0; i < dirsWithPostpatch.length; i++) {
	        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
	      }
	    });
	  }
	
	  if (!isCreate) {
	    for (key in oldDirs) {
	      if (!newDirs[key]) {
	        // no longer present, unbind
	        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
	      }
	    }
	  }
	}
	
	var emptyModifiers = Object.create(null);
	
	function normalizeDirectives$1 (
	  dirs,
	  vm
	) {
	  var res = Object.create(null);
	  if (!dirs) {
	    // $flow-disable-line
	    return res
	  }
	  var i, dir;
	  for (i = 0; i < dirs.length; i++) {
	    dir = dirs[i];
	    if (!dir.modifiers) {
	      // $flow-disable-line
	      dir.modifiers = emptyModifiers;
	    }
	    res[getRawDirName(dir)] = dir;
	    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
	  }
	  // $flow-disable-line
	  return res
	}
	
	function getRawDirName (dir) {
	  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
	}
	
	function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
	  var fn = dir.def && dir.def[hook];
	  if (fn) {
	    try {
	      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
	    } catch (e) {
	      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
	    }
	  }
	}
	
	var baseModules = [
	  ref,
	  directives
	]
	
	/*  */
	
	function updateAttrs (oldVnode, vnode) {
	  var opts = vnode.componentOptions;
	  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
	    return
	  }
	  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
	    return
	  }
	  var key, cur, old;
	  var elm = vnode.elm;
	  var oldAttrs = oldVnode.data.attrs || {};
	  var attrs = vnode.data.attrs || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(attrs.__ob__)) {
	    attrs = vnode.data.attrs = extend({}, attrs);
	  }
	
	  for (key in attrs) {
	    cur = attrs[key];
	    old = oldAttrs[key];
	    if (old !== cur) {
	      setAttr(elm, key, cur);
	    }
	  }
	  // #4391: in IE9, setting type can reset value for input[type=radio]
	  // #6666: IE/Edge forces progress value down to 1 before setting a max
	  /* istanbul ignore if */
	  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
	    setAttr(elm, 'value', attrs.value);
	  }
	  for (key in oldAttrs) {
	    if (isUndef(attrs[key])) {
	      if (isXlink(key)) {
	        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
	      } else if (!isEnumeratedAttr(key)) {
	        elm.removeAttribute(key);
	      }
	    }
	  }
	}
	
	function setAttr (el, key, value) {
	  if (el.tagName.indexOf('-') > -1) {
	    baseSetAttr(el, key, value);
	  } else if (isBooleanAttr(key)) {
	    // set attribute for blank value
	    // e.g. <option disabled>Select one</option>
	    if (isFalsyAttrValue(value)) {
	      el.removeAttribute(key);
	    } else {
	      // technically allowfullscreen is a boolean attribute for <iframe>,
	      // but Flash expects a value of "true" when used on <embed> tag
	      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
	        ? 'true'
	        : key;
	      el.setAttribute(key, value);
	    }
	  } else if (isEnumeratedAttr(key)) {
	    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
	  } else if (isXlink(key)) {
	    if (isFalsyAttrValue(value)) {
	      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
	    } else {
	      el.setAttributeNS(xlinkNS, key, value);
	    }
	  } else {
	    baseSetAttr(el, key, value);
	  }
	}
	
	function baseSetAttr (el, key, value) {
	  if (isFalsyAttrValue(value)) {
	    el.removeAttribute(key);
	  } else {
	    // #7138: IE10 & 11 fires input event when setting placeholder on
	    // <textarea>... block the first input event and remove the blocker
	    // immediately.
	    /* istanbul ignore if */
	    if (
	      isIE && !isIE9 &&
	      el.tagName === 'TEXTAREA' &&
	      key === 'placeholder' && !el.__ieph
	    ) {
	      var blocker = function (e) {
	        e.stopImmediatePropagation();
	        el.removeEventListener('input', blocker);
	      };
	      el.addEventListener('input', blocker);
	      // $flow-disable-line
	      el.__ieph = true; /* IE placeholder patched */
	    }
	    el.setAttribute(key, value);
	  }
	}
	
	var attrs = {
	  create: updateAttrs,
	  update: updateAttrs
	}
	
	/*  */
	
	function updateClass (oldVnode, vnode) {
	  var el = vnode.elm;
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	  if (
	    isUndef(data.staticClass) &&
	    isUndef(data.class) && (
	      isUndef(oldData) || (
	        isUndef(oldData.staticClass) &&
	        isUndef(oldData.class)
	      )
	    )
	  ) {
	    return
	  }
	
	  var cls = genClassForVnode(vnode);
	
	  // handle transition classes
	  var transitionClass = el._transitionClasses;
	  if (isDef(transitionClass)) {
	    cls = concat(cls, stringifyClass(transitionClass));
	  }
	
	  // set the class
	  if (cls !== el._prevClass) {
	    el.setAttribute('class', cls);
	    el._prevClass = cls;
	  }
	}
	
	var klass = {
	  create: updateClass,
	  update: updateClass
	}
	
	/*  */
	
	var validDivisionCharRE = /[\w).+\-_$\]]/;
	
	function parseFilters (exp) {
	  var inSingle = false;
	  var inDouble = false;
	  var inTemplateString = false;
	  var inRegex = false;
	  var curly = 0;
	  var square = 0;
	  var paren = 0;
	  var lastFilterIndex = 0;
	  var c, prev, i, expression, filters;
	
	  for (i = 0; i < exp.length; i++) {
	    prev = c;
	    c = exp.charCodeAt(i);
	    if (inSingle) {
	      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
	    } else if (inDouble) {
	      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
	    } else if (inTemplateString) {
	      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
	    } else if (inRegex) {
	      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
	    } else if (
	      c === 0x7C && // pipe
	      exp.charCodeAt(i + 1) !== 0x7C &&
	      exp.charCodeAt(i - 1) !== 0x7C &&
	      !curly && !square && !paren
	    ) {
	      if (expression === undefined) {
	        // first filter, end of expression
	        lastFilterIndex = i + 1;
	        expression = exp.slice(0, i).trim();
	      } else {
	        pushFilter();
	      }
	    } else {
	      switch (c) {
	        case 0x22: inDouble = true; break         // "
	        case 0x27: inSingle = true; break         // '
	        case 0x60: inTemplateString = true; break // `
	        case 0x28: paren++; break                 // (
	        case 0x29: paren--; break                 // )
	        case 0x5B: square++; break                // [
	        case 0x5D: square--; break                // ]
	        case 0x7B: curly++; break                 // {
	        case 0x7D: curly--; break                 // }
	      }
	      if (c === 0x2f) { // /
	        var j = i - 1;
	        var p = (void 0);
	        // find first non-whitespace prev char
	        for (; j >= 0; j--) {
	          p = exp.charAt(j);
	          if (p !== ' ') { break }
	        }
	        if (!p || !validDivisionCharRE.test(p)) {
	          inRegex = true;
	        }
	      }
	    }
	  }
	
	  if (expression === undefined) {
	    expression = exp.slice(0, i).trim();
	  } else if (lastFilterIndex !== 0) {
	    pushFilter();
	  }
	
	  function pushFilter () {
	    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
	    lastFilterIndex = i + 1;
	  }
	
	  if (filters) {
	    for (i = 0; i < filters.length; i++) {
	      expression = wrapFilter(expression, filters[i]);
	    }
	  }
	
	  return expression
	}
	
	function wrapFilter (exp, filter) {
	  var i = filter.indexOf('(');
	  if (i < 0) {
	    // _f: resolveFilter
	    return ("_f(\"" + filter + "\")(" + exp + ")")
	  } else {
	    var name = filter.slice(0, i);
	    var args = filter.slice(i + 1);
	    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
	  }
	}
	
	/*  */
	
	function baseWarn (msg) {
	  console.error(("[Vue compiler]: " + msg));
	}
	
	function pluckModuleFunction (
	  modules,
	  key
	) {
	  return modules
	    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
	    : []
	}
	
	function addProp (el, name, value) {
	  (el.props || (el.props = [])).push({ name: name, value: value });
	  el.plain = false;
	}
	
	function addAttr (el, name, value) {
	  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
	  el.plain = false;
	}
	
	// add a raw attr (use this in preTransforms)
	function addRawAttr (el, name, value) {
	  el.attrsMap[name] = value;
	  el.attrsList.push({ name: name, value: value });
	}
	
	function addDirective (
	  el,
	  name,
	  rawName,
	  value,
	  arg,
	  modifiers
	) {
	  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
	  el.plain = false;
	}
	
	function addHandler (
	  el,
	  name,
	  value,
	  modifiers,
	  important,
	  warn
	) {
	  modifiers = modifiers || emptyObject;
	  // warn prevent and passive modifier
	  /* istanbul ignore if */
	  if (
	    false
	  ) {
	    warn(
	      'passive and prevent can\'t be used together. ' +
	      'Passive handler can\'t prevent default event.'
	    );
	  }
	
	  // check capture modifier
	  if (modifiers.capture) {
	    delete modifiers.capture;
	    name = '!' + name; // mark the event as captured
	  }
	  if (modifiers.once) {
	    delete modifiers.once;
	    name = '~' + name; // mark the event as once
	  }
	  /* istanbul ignore if */
	  if (modifiers.passive) {
	    delete modifiers.passive;
	    name = '&' + name; // mark the event as passive
	  }
	
	  // normalize click.right and click.middle since they don't actually fire
	  // this is technically browser-specific, but at least for now browsers are
	  // the only target envs that have right/middle clicks.
	  if (name === 'click') {
	    if (modifiers.right) {
	      name = 'contextmenu';
	      delete modifiers.right;
	    } else if (modifiers.middle) {
	      name = 'mouseup';
	    }
	  }
	
	  var events;
	  if (modifiers.native) {
	    delete modifiers.native;
	    events = el.nativeEvents || (el.nativeEvents = {});
	  } else {
	    events = el.events || (el.events = {});
	  }
	
	  var newHandler = {
	    value: value.trim()
	  };
	  if (modifiers !== emptyObject) {
	    newHandler.modifiers = modifiers;
	  }
	
	  var handlers = events[name];
	  /* istanbul ignore if */
	  if (Array.isArray(handlers)) {
	    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
	  } else if (handlers) {
	    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
	  } else {
	    events[name] = newHandler;
	  }
	
	  el.plain = false;
	}
	
	function getBindingAttr (
	  el,
	  name,
	  getStatic
	) {
	  var dynamicValue =
	    getAndRemoveAttr(el, ':' + name) ||
	    getAndRemoveAttr(el, 'v-bind:' + name);
	  if (dynamicValue != null) {
	    return parseFilters(dynamicValue)
	  } else if (getStatic !== false) {
	    var staticValue = getAndRemoveAttr(el, name);
	    if (staticValue != null) {
	      return JSON.stringify(staticValue)
	    }
	  }
	}
	
	// note: this only removes the attr from the Array (attrsList) so that it
	// doesn't get processed by processAttrs.
	// By default it does NOT remove it from the map (attrsMap) because the map is
	// needed during codegen.
	function getAndRemoveAttr (
	  el,
	  name,
	  removeFromMap
	) {
	  var val;
	  if ((val = el.attrsMap[name]) != null) {
	    var list = el.attrsList;
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].name === name) {
	        list.splice(i, 1);
	        break
	      }
	    }
	  }
	  if (removeFromMap) {
	    delete el.attrsMap[name];
	  }
	  return val
	}
	
	/*  */
	
	/**
	 * Cross-platform code generation for component v-model
	 */
	function genComponentModel (
	  el,
	  value,
	  modifiers
	) {
	  var ref = modifiers || {};
	  var number = ref.number;
	  var trim = ref.trim;
	
	  var baseValueExpression = '$$v';
	  var valueExpression = baseValueExpression;
	  if (trim) {
	    valueExpression =
	      "(typeof " + baseValueExpression + " === 'string'" +
	      "? " + baseValueExpression + ".trim()" +
	      ": " + baseValueExpression + ")";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	  var assignment = genAssignmentCode(value, valueExpression);
	
	  el.model = {
	    value: ("(" + value + ")"),
	    expression: ("\"" + value + "\""),
	    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
	  };
	}
	
	/**
	 * Cross-platform codegen helper for generating v-model value assignment code.
	 */
	function genAssignmentCode (
	  value,
	  assignment
	) {
	  var res = parseModel(value);
	  if (res.key === null) {
	    return (value + "=" + assignment)
	  } else {
	    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
	  }
	}
	
	/**
	 * Parse a v-model expression into a base path and a final key segment.
	 * Handles both dot-path and possible square brackets.
	 *
	 * Possible cases:
	 *
	 * - test
	 * - test[key]
	 * - test[test1[key]]
	 * - test["a"][key]
	 * - xxx.test[a[a].test1[key]]
	 * - test.xxx.a["asa"][test1[key]]
	 *
	 */
	
	var len;
	var str;
	var chr;
	var index$1;
	var expressionPos;
	var expressionEndPos;
	
	
	
	function parseModel (val) {
	  // Fix https://github.com/vuejs/vue/pull/7730
	  // allow v-model="obj.val " (trailing whitespace)
	  val = val.trim();
	  len = val.length;
	
	  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
	    index$1 = val.lastIndexOf('.');
	    if (index$1 > -1) {
	      return {
	        exp: val.slice(0, index$1),
	        key: '"' + val.slice(index$1 + 1) + '"'
	      }
	    } else {
	      return {
	        exp: val,
	        key: null
	      }
	    }
	  }
	
	  str = val;
	  index$1 = expressionPos = expressionEndPos = 0;
	
	  while (!eof()) {
	    chr = next();
	    /* istanbul ignore if */
	    if (isStringStart(chr)) {
	      parseString(chr);
	    } else if (chr === 0x5B) {
	      parseBracket(chr);
	    }
	  }
	
	  return {
	    exp: val.slice(0, expressionPos),
	    key: val.slice(expressionPos + 1, expressionEndPos)
	  }
	}
	
	function next () {
	  return str.charCodeAt(++index$1)
	}
	
	function eof () {
	  return index$1 >= len
	}
	
	function isStringStart (chr) {
	  return chr === 0x22 || chr === 0x27
	}
	
	function parseBracket (chr) {
	  var inBracket = 1;
	  expressionPos = index$1;
	  while (!eof()) {
	    chr = next();
	    if (isStringStart(chr)) {
	      parseString(chr);
	      continue
	    }
	    if (chr === 0x5B) { inBracket++; }
	    if (chr === 0x5D) { inBracket--; }
	    if (inBracket === 0) {
	      expressionEndPos = index$1;
	      break
	    }
	  }
	}
	
	function parseString (chr) {
	  var stringQuote = chr;
	  while (!eof()) {
	    chr = next();
	    if (chr === stringQuote) {
	      break
	    }
	  }
	}
	
	/*  */
	
	var warn$1;
	
	// in some cases, the event used has to be determined at runtime
	// so we used some reserved tokens during compile.
	var RANGE_TOKEN = '__r';
	var CHECKBOX_RADIO_TOKEN = '__c';
	
	function model (
	  el,
	  dir,
	  _warn
	) {
	  warn$1 = _warn;
	  var value = dir.value;
	  var modifiers = dir.modifiers;
	  var tag = el.tag;
	  var type = el.attrsMap.type;
	
	  if (false) {
	    // inputs with type="file" are read only and setting the input's
	    // value will throw an error.
	    if (tag === 'input' && type === 'file') {
	      warn$1(
	        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
	        "File inputs are read only. Use a v-on:change listener instead."
	      );
	    }
	  }
	
	  if (el.component) {
	    genComponentModel(el, value, modifiers);
	    // component v-model doesn't need extra runtime
	    return false
	  } else if (tag === 'select') {
	    genSelect(el, value, modifiers);
	  } else if (tag === 'input' && type === 'checkbox') {
	    genCheckboxModel(el, value, modifiers);
	  } else if (tag === 'input' && type === 'radio') {
	    genRadioModel(el, value, modifiers);
	  } else if (tag === 'input' || tag === 'textarea') {
	    genDefaultModel(el, value, modifiers);
	  } else if (!config.isReservedTag(tag)) {
	    genComponentModel(el, value, modifiers);
	    // component v-model doesn't need extra runtime
	    return false
	  } else if (false) {
	    warn$1(
	      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	      "v-model is not supported on this element type. " +
	      'If you are working with contenteditable, it\'s recommended to ' +
	      'wrap a library dedicated for that purpose inside a custom component.'
	    );
	  }
	
	  // ensure runtime directive metadata
	  return true
	}
	
	function genCheckboxModel (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
	  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
	  addProp(el, 'checked',
	    "Array.isArray(" + value + ")" +
	    "?_i(" + value + "," + valueBinding + ")>-1" + (
	      trueValueBinding === 'true'
	        ? (":(" + value + ")")
	        : (":_q(" + value + "," + trueValueBinding + ")")
	    )
	  );
	  addHandler(el, 'change',
	    "var $$a=" + value + "," +
	        '$$el=$event.target,' +
	        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
	    'if(Array.isArray($$a)){' +
	      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
	          '$$i=_i($$a,$$v);' +
	      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
	      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
	    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
	    null, true
	  );
	}
	
	function genRadioModel (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var valueBinding = getBindingAttr(el, 'value') || 'null';
	  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
	  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
	  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
	}
	
	function genSelect (
	  el,
	  value,
	  modifiers
	) {
	  var number = modifiers && modifiers.number;
	  var selectedVal = "Array.prototype.filter" +
	    ".call($event.target.options,function(o){return o.selected})" +
	    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
	    "return " + (number ? '_n(val)' : 'val') + "})";
	
	  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
	  var code = "var $$selectedVal = " + selectedVal + ";";
	  code = code + " " + (genAssignmentCode(value, assignment));
	  addHandler(el, 'change', code, null, true);
	}
	
	function genDefaultModel (
	  el,
	  value,
	  modifiers
	) {
	  var type = el.attrsMap.type;
	
	  // warn if v-bind:value conflicts with v-model
	  // except for inputs with v-bind:type
	  if (false) {
	    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
	    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
	    if (value$1 && !typeBinding) {
	      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
	      warn$1(
	        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
	        'because the latter already expands to a value binding internally'
	      );
	    }
	  }
	
	  var ref = modifiers || {};
	  var lazy = ref.lazy;
	  var number = ref.number;
	  var trim = ref.trim;
	  var needCompositionGuard = !lazy && type !== 'range';
	  var event = lazy
	    ? 'change'
	    : type === 'range'
	      ? RANGE_TOKEN
	      : 'input';
	
	  var valueExpression = '$event.target.value';
	  if (trim) {
	    valueExpression = "$event.target.value.trim()";
	  }
	  if (number) {
	    valueExpression = "_n(" + valueExpression + ")";
	  }
	
	  var code = genAssignmentCode(value, valueExpression);
	  if (needCompositionGuard) {
	    code = "if($event.target.composing)return;" + code;
	  }
	
	  addProp(el, 'value', ("(" + value + ")"));
	  addHandler(el, event, code, null, true);
	  if (trim || number) {
	    addHandler(el, 'blur', '$forceUpdate()');
	  }
	}
	
	/*  */
	
	// normalize v-model event tokens that can only be determined at runtime.
	// it's important to place the event as the first in the array because
	// the whole point is ensuring the v-model callback gets called before
	// user-attached handlers.
	function normalizeEvents (on) {
	  /* istanbul ignore if */
	  if (isDef(on[RANGE_TOKEN])) {
	    // IE input[type=range] only supports `change` event
	    var event = isIE ? 'change' : 'input';
	    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
	    delete on[RANGE_TOKEN];
	  }
	  // This was originally intended to fix #4521 but no longer necessary
	  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
	  /* istanbul ignore if */
	  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
	    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
	    delete on[CHECKBOX_RADIO_TOKEN];
	  }
	}
	
	var target$1;
	
	function createOnceHandler (handler, event, capture) {
	  var _target = target$1; // save current target element in closure
	  return function onceHandler () {
	    var res = handler.apply(null, arguments);
	    if (res !== null) {
	      remove$2(event, onceHandler, capture, _target);
	    }
	  }
	}
	
	function add$1 (
	  event,
	  handler,
	  once$$1,
	  capture,
	  passive
	) {
	  handler = withMacroTask(handler);
	  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
	  target$1.addEventListener(
	    event,
	    handler,
	    supportsPassive
	      ? { capture: capture, passive: passive }
	      : capture
	  );
	}
	
	function remove$2 (
	  event,
	  handler,
	  capture,
	  _target
	) {
	  (_target || target$1).removeEventListener(
	    event,
	    handler._withTask || handler,
	    capture
	  );
	}
	
	function updateDOMListeners (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
	    return
	  }
	  var on = vnode.data.on || {};
	  var oldOn = oldVnode.data.on || {};
	  target$1 = vnode.elm;
	  normalizeEvents(on);
	  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
	  target$1 = undefined;
	}
	
	var events = {
	  create: updateDOMListeners,
	  update: updateDOMListeners
	}
	
	/*  */
	
	function updateDOMProps (oldVnode, vnode) {
	  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
	    return
	  }
	  var key, cur;
	  var elm = vnode.elm;
	  var oldProps = oldVnode.data.domProps || {};
	  var props = vnode.data.domProps || {};
	  // clone observed objects, as the user probably wants to mutate it
	  if (isDef(props.__ob__)) {
	    props = vnode.data.domProps = extend({}, props);
	  }
	
	  for (key in oldProps) {
	    if (isUndef(props[key])) {
	      elm[key] = '';
	    }
	  }
	  for (key in props) {
	    cur = props[key];
	    // ignore children if the node has textContent or innerHTML,
	    // as these will throw away existing DOM nodes and cause removal errors
	    // on subsequent patches (#3360)
	    if (key === 'textContent' || key === 'innerHTML') {
	      if (vnode.children) { vnode.children.length = 0; }
	      if (cur === oldProps[key]) { continue }
	      // #6601 work around Chrome version <= 55 bug where single textNode
	      // replaced by innerHTML/textContent retains its parentNode property
	      if (elm.childNodes.length === 1) {
	        elm.removeChild(elm.childNodes[0]);
	      }
	    }
	
	    if (key === 'value') {
	      // store value as _value as well since
	      // non-string values will be stringified
	      elm._value = cur;
	      // avoid resetting cursor position when value is the same
	      var strCur = isUndef(cur) ? '' : String(cur);
	      if (shouldUpdateValue(elm, strCur)) {
	        elm.value = strCur;
	      }
	    } else {
	      elm[key] = cur;
	    }
	  }
	}
	
	// check platforms/web/util/attrs.js acceptValue
	
	
	function shouldUpdateValue (elm, checkVal) {
	  return (!elm.composing && (
	    elm.tagName === 'OPTION' ||
	    isNotInFocusAndDirty(elm, checkVal) ||
	    isDirtyWithModifiers(elm, checkVal)
	  ))
	}
	
	function isNotInFocusAndDirty (elm, checkVal) {
	  // return true when textbox (.number and .trim) loses focus and its value is
	  // not equal to the updated value
	  var notInFocus = true;
	  // #6157
	  // work around IE bug when accessing document.activeElement in an iframe
	  try { notInFocus = document.activeElement !== elm; } catch (e) {}
	  return notInFocus && elm.value !== checkVal
	}
	
	function isDirtyWithModifiers (elm, newVal) {
	  var value = elm.value;
	  var modifiers = elm._vModifiers; // injected by v-model runtime
	  if (isDef(modifiers)) {
	    if (modifiers.lazy) {
	      // inputs with lazy should only be updated when not in focus
	      return false
	    }
	    if (modifiers.number) {
	      return toNumber(value) !== toNumber(newVal)
	    }
	    if (modifiers.trim) {
	      return value.trim() !== newVal.trim()
	    }
	  }
	  return value !== newVal
	}
	
	var domProps = {
	  create: updateDOMProps,
	  update: updateDOMProps
	}
	
	/*  */
	
	var parseStyleText = cached(function (cssText) {
	  var res = {};
	  var listDelimiter = /;(?![^(]*\))/g;
	  var propertyDelimiter = /:(.+)/;
	  cssText.split(listDelimiter).forEach(function (item) {
	    if (item) {
	      var tmp = item.split(propertyDelimiter);
	      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
	    }
	  });
	  return res
	});
	
	// merge static and dynamic style data on the same vnode
	function normalizeStyleData (data) {
	  var style = normalizeStyleBinding(data.style);
	  // static style is pre-processed into an object during compilation
	  // and is always a fresh object, so it's safe to merge into it
	  return data.staticStyle
	    ? extend(data.staticStyle, style)
	    : style
	}
	
	// normalize possible array / string values into Object
	function normalizeStyleBinding (bindingStyle) {
	  if (Array.isArray(bindingStyle)) {
	    return toObject(bindingStyle)
	  }
	  if (typeof bindingStyle === 'string') {
	    return parseStyleText(bindingStyle)
	  }
	  return bindingStyle
	}
	
	/**
	 * parent component style should be after child's
	 * so that parent component's style could override it
	 */
	function getStyle (vnode, checkChild) {
	  var res = {};
	  var styleData;
	
	  if (checkChild) {
	    var childNode = vnode;
	    while (childNode.componentInstance) {
	      childNode = childNode.componentInstance._vnode;
	      if (
	        childNode && childNode.data &&
	        (styleData = normalizeStyleData(childNode.data))
	      ) {
	        extend(res, styleData);
	      }
	    }
	  }
	
	  if ((styleData = normalizeStyleData(vnode.data))) {
	    extend(res, styleData);
	  }
	
	  var parentNode = vnode;
	  while ((parentNode = parentNode.parent)) {
	    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
	      extend(res, styleData);
	    }
	  }
	  return res
	}
	
	/*  */
	
	var cssVarRE = /^--/;
	var importantRE = /\s*!important$/;
	var setProp = function (el, name, val) {
	  /* istanbul ignore if */
	  if (cssVarRE.test(name)) {
	    el.style.setProperty(name, val);
	  } else if (importantRE.test(val)) {
	    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
	  } else {
	    var normalizedName = normalize(name);
	    if (Array.isArray(val)) {
	      // Support values array created by autoprefixer, e.g.
	      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
	      // Set them one by one, and the browser will only set those it can recognize
	      for (var i = 0, len = val.length; i < len; i++) {
	        el.style[normalizedName] = val[i];
	      }
	    } else {
	      el.style[normalizedName] = val;
	    }
	  }
	};
	
	var vendorNames = ['Webkit', 'Moz', 'ms'];
	
	var emptyStyle;
	var normalize = cached(function (prop) {
	  emptyStyle = emptyStyle || document.createElement('div').style;
	  prop = camelize(prop);
	  if (prop !== 'filter' && (prop in emptyStyle)) {
	    return prop
	  }
	  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
	  for (var i = 0; i < vendorNames.length; i++) {
	    var name = vendorNames[i] + capName;
	    if (name in emptyStyle) {
	      return name
	    }
	  }
	});
	
	function updateStyle (oldVnode, vnode) {
	  var data = vnode.data;
	  var oldData = oldVnode.data;
	
	  if (isUndef(data.staticStyle) && isUndef(data.style) &&
	    isUndef(oldData.staticStyle) && isUndef(oldData.style)
	  ) {
	    return
	  }
	
	  var cur, name;
	  var el = vnode.elm;
	  var oldStaticStyle = oldData.staticStyle;
	  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
	
	  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
	  var oldStyle = oldStaticStyle || oldStyleBinding;
	
	  var style = normalizeStyleBinding(vnode.data.style) || {};
	
	  // store normalized style under a different key for next diff
	  // make sure to clone it if it's reactive, since the user likely wants
	  // to mutate it.
	  vnode.data.normalizedStyle = isDef(style.__ob__)
	    ? extend({}, style)
	    : style;
	
	  var newStyle = getStyle(vnode, true);
	
	  for (name in oldStyle) {
	    if (isUndef(newStyle[name])) {
	      setProp(el, name, '');
	    }
	  }
	  for (name in newStyle) {
	    cur = newStyle[name];
	    if (cur !== oldStyle[name]) {
	      // ie9 setting to null has no effect, must use empty string
	      setProp(el, name, cur == null ? '' : cur);
	    }
	  }
	}
	
	var style = {
	  create: updateStyle,
	  update: updateStyle
	}
	
	/*  */
	
	/**
	 * Add class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function addClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
	    } else {
	      el.classList.add(cls);
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    if (cur.indexOf(' ' + cls + ' ') < 0) {
	      el.setAttribute('class', (cur + cls).trim());
	    }
	  }
	}
	
	/**
	 * Remove class with compatibility for SVG since classList is not supported on
	 * SVG elements in IE
	 */
	function removeClass (el, cls) {
	  /* istanbul ignore if */
	  if (!cls || !(cls = cls.trim())) {
	    return
	  }
	
	  /* istanbul ignore else */
	  if (el.classList) {
	    if (cls.indexOf(' ') > -1) {
	      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
	    } else {
	      el.classList.remove(cls);
	    }
	    if (!el.classList.length) {
	      el.removeAttribute('class');
	    }
	  } else {
	    var cur = " " + (el.getAttribute('class') || '') + " ";
	    var tar = ' ' + cls + ' ';
	    while (cur.indexOf(tar) >= 0) {
	      cur = cur.replace(tar, ' ');
	    }
	    cur = cur.trim();
	    if (cur) {
	      el.setAttribute('class', cur);
	    } else {
	      el.removeAttribute('class');
	    }
	  }
	}
	
	/*  */
	
	function resolveTransition (def) {
	  if (!def) {
	    return
	  }
	  /* istanbul ignore else */
	  if (typeof def === 'object') {
	    var res = {};
	    if (def.css !== false) {
	      extend(res, autoCssTransition(def.name || 'v'));
	    }
	    extend(res, def);
	    return res
	  } else if (typeof def === 'string') {
	    return autoCssTransition(def)
	  }
	}
	
	var autoCssTransition = cached(function (name) {
	  return {
	    enterClass: (name + "-enter"),
	    enterToClass: (name + "-enter-to"),
	    enterActiveClass: (name + "-enter-active"),
	    leaveClass: (name + "-leave"),
	    leaveToClass: (name + "-leave-to"),
	    leaveActiveClass: (name + "-leave-active")
	  }
	});
	
	var hasTransition = inBrowser && !isIE9;
	var TRANSITION = 'transition';
	var ANIMATION = 'animation';
	
	// Transition property/event sniffing
	var transitionProp = 'transition';
	var transitionEndEvent = 'transitionend';
	var animationProp = 'animation';
	var animationEndEvent = 'animationend';
	if (hasTransition) {
	  /* istanbul ignore if */
	  if (window.ontransitionend === undefined &&
	    window.onwebkittransitionend !== undefined
	  ) {
	    transitionProp = 'WebkitTransition';
	    transitionEndEvent = 'webkitTransitionEnd';
	  }
	  if (window.onanimationend === undefined &&
	    window.onwebkitanimationend !== undefined
	  ) {
	    animationProp = 'WebkitAnimation';
	    animationEndEvent = 'webkitAnimationEnd';
	  }
	}
	
	// binding to window is necessary to make hot reload work in IE in strict mode
	var raf = inBrowser
	  ? window.requestAnimationFrame
	    ? window.requestAnimationFrame.bind(window)
	    : setTimeout
	  : /* istanbul ignore next */ function (fn) { return fn(); };
	
	function nextFrame (fn) {
	  raf(function () {
	    raf(fn);
	  });
	}
	
	function addTransitionClass (el, cls) {
	  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
	  if (transitionClasses.indexOf(cls) < 0) {
	    transitionClasses.push(cls);
	    addClass(el, cls);
	  }
	}
	
	function removeTransitionClass (el, cls) {
	  if (el._transitionClasses) {
	    remove(el._transitionClasses, cls);
	  }
	  removeClass(el, cls);
	}
	
	function whenTransitionEnds (
	  el,
	  expectedType,
	  cb
	) {
	  var ref = getTransitionInfo(el, expectedType);
	  var type = ref.type;
	  var timeout = ref.timeout;
	  var propCount = ref.propCount;
	  if (!type) { return cb() }
	  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
	  var ended = 0;
	  var end = function () {
	    el.removeEventListener(event, onEnd);
	    cb();
	  };
	  var onEnd = function (e) {
	    if (e.target === el) {
	      if (++ended >= propCount) {
	        end();
	      }
	    }
	  };
	  setTimeout(function () {
	    if (ended < propCount) {
	      end();
	    }
	  }, timeout + 1);
	  el.addEventListener(event, onEnd);
	}
	
	var transformRE = /\b(transform|all)(,|$)/;
	
	function getTransitionInfo (el, expectedType) {
	  var styles = window.getComputedStyle(el);
	  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
	  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
	  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
	  var animationDelays = styles[animationProp + 'Delay'].split(', ');
	  var animationDurations = styles[animationProp + 'Duration'].split(', ');
	  var animationTimeout = getTimeout(animationDelays, animationDurations);
	
	  var type;
	  var timeout = 0;
	  var propCount = 0;
	  /* istanbul ignore if */
	  if (expectedType === TRANSITION) {
	    if (transitionTimeout > 0) {
	      type = TRANSITION;
	      timeout = transitionTimeout;
	      propCount = transitionDurations.length;
	    }
	  } else if (expectedType === ANIMATION) {
	    if (animationTimeout > 0) {
	      type = ANIMATION;
	      timeout = animationTimeout;
	      propCount = animationDurations.length;
	    }
	  } else {
	    timeout = Math.max(transitionTimeout, animationTimeout);
	    type = timeout > 0
	      ? transitionTimeout > animationTimeout
	        ? TRANSITION
	        : ANIMATION
	      : null;
	    propCount = type
	      ? type === TRANSITION
	        ? transitionDurations.length
	        : animationDurations.length
	      : 0;
	  }
	  var hasTransform =
	    type === TRANSITION &&
	    transformRE.test(styles[transitionProp + 'Property']);
	  return {
	    type: type,
	    timeout: timeout,
	    propCount: propCount,
	    hasTransform: hasTransform
	  }
	}
	
	function getTimeout (delays, durations) {
	  /* istanbul ignore next */
	  while (delays.length < durations.length) {
	    delays = delays.concat(delays);
	  }
	
	  return Math.max.apply(null, durations.map(function (d, i) {
	    return toMs(d) + toMs(delays[i])
	  }))
	}
	
	function toMs (s) {
	  return Number(s.slice(0, -1)) * 1000
	}
	
	/*  */
	
	function enter (vnode, toggleDisplay) {
	  var el = vnode.elm;
	
	  // call leave callback now
	  if (isDef(el._leaveCb)) {
	    el._leaveCb.cancelled = true;
	    el._leaveCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data)) {
	    return
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._enterCb) || el.nodeType !== 1) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var enterClass = data.enterClass;
	  var enterToClass = data.enterToClass;
	  var enterActiveClass = data.enterActiveClass;
	  var appearClass = data.appearClass;
	  var appearToClass = data.appearToClass;
	  var appearActiveClass = data.appearActiveClass;
	  var beforeEnter = data.beforeEnter;
	  var enter = data.enter;
	  var afterEnter = data.afterEnter;
	  var enterCancelled = data.enterCancelled;
	  var beforeAppear = data.beforeAppear;
	  var appear = data.appear;
	  var afterAppear = data.afterAppear;
	  var appearCancelled = data.appearCancelled;
	  var duration = data.duration;
	
	  // activeInstance will always be the <transition> component managing this
	  // transition. One edge case to check is when the <transition> is placed
	  // as the root node of a child component. In that case we need to check
	  // <transition>'s parent for appear check.
	  var context = activeInstance;
	  var transitionNode = activeInstance.$vnode;
	  while (transitionNode && transitionNode.parent) {
	    transitionNode = transitionNode.parent;
	    context = transitionNode.context;
	  }
	
	  var isAppear = !context._isMounted || !vnode.isRootInsert;
	
	  if (isAppear && !appear && appear !== '') {
	    return
	  }
	
	  var startClass = isAppear && appearClass
	    ? appearClass
	    : enterClass;
	  var activeClass = isAppear && appearActiveClass
	    ? appearActiveClass
	    : enterActiveClass;
	  var toClass = isAppear && appearToClass
	    ? appearToClass
	    : enterToClass;
	
	  var beforeEnterHook = isAppear
	    ? (beforeAppear || beforeEnter)
	    : beforeEnter;
	  var enterHook = isAppear
	    ? (typeof appear === 'function' ? appear : enter)
	    : enter;
	  var afterEnterHook = isAppear
	    ? (afterAppear || afterEnter)
	    : afterEnter;
	  var enterCancelledHook = isAppear
	    ? (appearCancelled || enterCancelled)
	    : enterCancelled;
	
	  var explicitEnterDuration = toNumber(
	    isObject(duration)
	      ? duration.enter
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitEnterDuration, 'enter', vnode);
	  }
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(enterHook);
	
	  var cb = el._enterCb = once(function () {
	    if (expectsCSS) {
	      removeTransitionClass(el, toClass);
	      removeTransitionClass(el, activeClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, startClass);
	      }
	      enterCancelledHook && enterCancelledHook(el);
	    } else {
	      afterEnterHook && afterEnterHook(el);
	    }
	    el._enterCb = null;
	  });
	
	  if (!vnode.data.show) {
	    // remove pending leave element on enter by injecting an insert hook
	    mergeVNodeHook(vnode, 'insert', function () {
	      var parent = el.parentNode;
	      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
	      if (pendingNode &&
	        pendingNode.tag === vnode.tag &&
	        pendingNode.elm._leaveCb
	      ) {
	        pendingNode.elm._leaveCb();
	      }
	      enterHook && enterHook(el, cb);
	    });
	  }
	
	  // start enter transition
	  beforeEnterHook && beforeEnterHook(el);
	  if (expectsCSS) {
	    addTransitionClass(el, startClass);
	    addTransitionClass(el, activeClass);
	    nextFrame(function () {
	      removeTransitionClass(el, startClass);
	      if (!cb.cancelled) {
	        addTransitionClass(el, toClass);
	        if (!userWantsControl) {
	          if (isValidDuration(explicitEnterDuration)) {
	            setTimeout(cb, explicitEnterDuration);
	          } else {
	            whenTransitionEnds(el, type, cb);
	          }
	        }
	      }
	    });
	  }
	
	  if (vnode.data.show) {
	    toggleDisplay && toggleDisplay();
	    enterHook && enterHook(el, cb);
	  }
	
	  if (!expectsCSS && !userWantsControl) {
	    cb();
	  }
	}
	
	function leave (vnode, rm) {
	  var el = vnode.elm;
	
	  // call enter callback now
	  if (isDef(el._enterCb)) {
	    el._enterCb.cancelled = true;
	    el._enterCb();
	  }
	
	  var data = resolveTransition(vnode.data.transition);
	  if (isUndef(data) || el.nodeType !== 1) {
	    return rm()
	  }
	
	  /* istanbul ignore if */
	  if (isDef(el._leaveCb)) {
	    return
	  }
	
	  var css = data.css;
	  var type = data.type;
	  var leaveClass = data.leaveClass;
	  var leaveToClass = data.leaveToClass;
	  var leaveActiveClass = data.leaveActiveClass;
	  var beforeLeave = data.beforeLeave;
	  var leave = data.leave;
	  var afterLeave = data.afterLeave;
	  var leaveCancelled = data.leaveCancelled;
	  var delayLeave = data.delayLeave;
	  var duration = data.duration;
	
	  var expectsCSS = css !== false && !isIE9;
	  var userWantsControl = getHookArgumentsLength(leave);
	
	  var explicitLeaveDuration = toNumber(
	    isObject(duration)
	      ? duration.leave
	      : duration
	  );
	
	  if (false) {
	    checkDuration(explicitLeaveDuration, 'leave', vnode);
	  }
	
	  var cb = el._leaveCb = once(function () {
	    if (el.parentNode && el.parentNode._pending) {
	      el.parentNode._pending[vnode.key] = null;
	    }
	    if (expectsCSS) {
	      removeTransitionClass(el, leaveToClass);
	      removeTransitionClass(el, leaveActiveClass);
	    }
	    if (cb.cancelled) {
	      if (expectsCSS) {
	        removeTransitionClass(el, leaveClass);
	      }
	      leaveCancelled && leaveCancelled(el);
	    } else {
	      rm();
	      afterLeave && afterLeave(el);
	    }
	    el._leaveCb = null;
	  });
	
	  if (delayLeave) {
	    delayLeave(performLeave);
	  } else {
	    performLeave();
	  }
	
	  function performLeave () {
	    // the delayed leave may have already been cancelled
	    if (cb.cancelled) {
	      return
	    }
	    // record leaving element
	    if (!vnode.data.show) {
	      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
	    }
	    beforeLeave && beforeLeave(el);
	    if (expectsCSS) {
	      addTransitionClass(el, leaveClass);
	      addTransitionClass(el, leaveActiveClass);
	      nextFrame(function () {
	        removeTransitionClass(el, leaveClass);
	        if (!cb.cancelled) {
	          addTransitionClass(el, leaveToClass);
	          if (!userWantsControl) {
	            if (isValidDuration(explicitLeaveDuration)) {
	              setTimeout(cb, explicitLeaveDuration);
	            } else {
	              whenTransitionEnds(el, type, cb);
	            }
	          }
	        }
	      });
	    }
	    leave && leave(el, cb);
	    if (!expectsCSS && !userWantsControl) {
	      cb();
	    }
	  }
	}
	
	// only used in dev mode
	function checkDuration (val, name, vnode) {
	  if (typeof val !== 'number') {
	    warn(
	      "<transition> explicit " + name + " duration is not a valid number - " +
	      "got " + (JSON.stringify(val)) + ".",
	      vnode.context
	    );
	  } else if (isNaN(val)) {
	    warn(
	      "<transition> explicit " + name + " duration is NaN - " +
	      'the duration expression might be incorrect.',
	      vnode.context
	    );
	  }
	}
	
	function isValidDuration (val) {
	  return typeof val === 'number' && !isNaN(val)
	}
	
	/**
	 * Normalize a transition hook's argument length. The hook may be:
	 * - a merged hook (invoker) with the original in .fns
	 * - a wrapped component method (check ._length)
	 * - a plain function (.length)
	 */
	function getHookArgumentsLength (fn) {
	  if (isUndef(fn)) {
	    return false
	  }
	  var invokerFns = fn.fns;
	  if (isDef(invokerFns)) {
	    // invoker
	    return getHookArgumentsLength(
	      Array.isArray(invokerFns)
	        ? invokerFns[0]
	        : invokerFns
	    )
	  } else {
	    return (fn._length || fn.length) > 1
	  }
	}
	
	function _enter (_, vnode) {
	  if (vnode.data.show !== true) {
	    enter(vnode);
	  }
	}
	
	var transition = inBrowser ? {
	  create: _enter,
	  activate: _enter,
	  remove: function remove$$1 (vnode, rm) {
	    /* istanbul ignore else */
	    if (vnode.data.show !== true) {
	      leave(vnode, rm);
	    } else {
	      rm();
	    }
	  }
	} : {}
	
	var platformModules = [
	  attrs,
	  klass,
	  events,
	  domProps,
	  style,
	  transition
	]
	
	/*  */
	
	// the directive module should be applied last, after all
	// built-in modules have been applied.
	var modules = platformModules.concat(baseModules);
	
	var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });
	
	/**
	 * Not type checking this file because flow doesn't like attaching
	 * properties to Elements.
	 */
	
	/* istanbul ignore if */
	if (isIE9) {
	  // http://www.matts411.com/post/internet-explorer-9-oninput/
	  document.addEventListener('selectionchange', function () {
	    var el = document.activeElement;
	    if (el && el.vmodel) {
	      trigger(el, 'input');
	    }
	  });
	}
	
	var directive = {
	  inserted: function inserted (el, binding, vnode, oldVnode) {
	    if (vnode.tag === 'select') {
	      // #6903
	      if (oldVnode.elm && !oldVnode.elm._vOptions) {
	        mergeVNodeHook(vnode, 'postpatch', function () {
	          directive.componentUpdated(el, binding, vnode);
	        });
	      } else {
	        setSelected(el, binding, vnode.context);
	      }
	      el._vOptions = [].map.call(el.options, getValue);
	    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
	      el._vModifiers = binding.modifiers;
	      if (!binding.modifiers.lazy) {
	        el.addEventListener('compositionstart', onCompositionStart);
	        el.addEventListener('compositionend', onCompositionEnd);
	        // Safari < 10.2 & UIWebView doesn't fire compositionend when
	        // switching focus before confirming composition choice
	        // this also fixes the issue where some browsers e.g. iOS Chrome
	        // fires "change" instead of "input" on autocomplete.
	        el.addEventListener('change', onCompositionEnd);
	        /* istanbul ignore if */
	        if (isIE9) {
	          el.vmodel = true;
	        }
	      }
	    }
	  },
	
	  componentUpdated: function componentUpdated (el, binding, vnode) {
	    if (vnode.tag === 'select') {
	      setSelected(el, binding, vnode.context);
	      // in case the options rendered by v-for have changed,
	      // it's possible that the value is out-of-sync with the rendered options.
	      // detect such cases and filter out values that no longer has a matching
	      // option in the DOM.
	      var prevOptions = el._vOptions;
	      var curOptions = el._vOptions = [].map.call(el.options, getValue);
	      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
	        // trigger change event if
	        // no matching option found for at least one value
	        var needReset = el.multiple
	          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
	          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
	        if (needReset) {
	          trigger(el, 'change');
	        }
	      }
	    }
	  }
	};
	
	function setSelected (el, binding, vm) {
	  actuallySetSelected(el, binding, vm);
	  /* istanbul ignore if */
	  if (isIE || isEdge) {
	    setTimeout(function () {
	      actuallySetSelected(el, binding, vm);
	    }, 0);
	  }
	}
	
	function actuallySetSelected (el, binding, vm) {
	  var value = binding.value;
	  var isMultiple = el.multiple;
	  if (isMultiple && !Array.isArray(value)) {
	    ("production") !== 'production' && warn(
	      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
	      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
	      vm
	    );
	    return
	  }
	  var selected, option;
	  for (var i = 0, l = el.options.length; i < l; i++) {
	    option = el.options[i];
	    if (isMultiple) {
	      selected = looseIndexOf(value, getValue(option)) > -1;
	      if (option.selected !== selected) {
	        option.selected = selected;
	      }
	    } else {
	      if (looseEqual(getValue(option), value)) {
	        if (el.selectedIndex !== i) {
	          el.selectedIndex = i;
	        }
	        return
	      }
	    }
	  }
	  if (!isMultiple) {
	    el.selectedIndex = -1;
	  }
	}
	
	function hasNoMatchingOption (value, options) {
	  return options.every(function (o) { return !looseEqual(o, value); })
	}
	
	function getValue (option) {
	  return '_value' in option
	    ? option._value
	    : option.value
	}
	
	function onCompositionStart (e) {
	  e.target.composing = true;
	}
	
	function onCompositionEnd (e) {
	  // prevent triggering an input event for no reason
	  if (!e.target.composing) { return }
	  e.target.composing = false;
	  trigger(e.target, 'input');
	}
	
	function trigger (el, type) {
	  var e = document.createEvent('HTMLEvents');
	  e.initEvent(type, true, true);
	  el.dispatchEvent(e);
	}
	
	/*  */
	
	// recursively search for possible transition defined inside the component root
	function locateNode (vnode) {
	  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
	    ? locateNode(vnode.componentInstance._vnode)
	    : vnode
	}
	
	var show = {
	  bind: function bind (el, ref, vnode) {
	    var value = ref.value;
	
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    var originalDisplay = el.__vOriginalDisplay =
	      el.style.display === 'none' ? '' : el.style.display;
	    if (value && transition$$1) {
	      vnode.data.show = true;
	      enter(vnode, function () {
	        el.style.display = originalDisplay;
	      });
	    } else {
	      el.style.display = value ? originalDisplay : 'none';
	    }
	  },
	
	  update: function update (el, ref, vnode) {
	    var value = ref.value;
	    var oldValue = ref.oldValue;
	
	    /* istanbul ignore if */
	    if (!value === !oldValue) { return }
	    vnode = locateNode(vnode);
	    var transition$$1 = vnode.data && vnode.data.transition;
	    if (transition$$1) {
	      vnode.data.show = true;
	      if (value) {
	        enter(vnode, function () {
	          el.style.display = el.__vOriginalDisplay;
	        });
	      } else {
	        leave(vnode, function () {
	          el.style.display = 'none';
	        });
	      }
	    } else {
	      el.style.display = value ? el.__vOriginalDisplay : 'none';
	    }
	  },
	
	  unbind: function unbind (
	    el,
	    binding,
	    vnode,
	    oldVnode,
	    isDestroy
	  ) {
	    if (!isDestroy) {
	      el.style.display = el.__vOriginalDisplay;
	    }
	  }
	}
	
	var platformDirectives = {
	  model: directive,
	  show: show
	}
	
	/*  */
	
	// Provides transition support for a single element/component.
	// supports transition mode (out-in / in-out)
	
	var transitionProps = {
	  name: String,
	  appear: Boolean,
	  css: Boolean,
	  mode: String,
	  type: String,
	  enterClass: String,
	  leaveClass: String,
	  enterToClass: String,
	  leaveToClass: String,
	  enterActiveClass: String,
	  leaveActiveClass: String,
	  appearClass: String,
	  appearActiveClass: String,
	  appearToClass: String,
	  duration: [Number, String, Object]
	};
	
	// in case the child is also an abstract component, e.g. <keep-alive>
	// we want to recursively retrieve the real component to be rendered
	function getRealChild (vnode) {
	  var compOptions = vnode && vnode.componentOptions;
	  if (compOptions && compOptions.Ctor.options.abstract) {
	    return getRealChild(getFirstComponentChild(compOptions.children))
	  } else {
	    return vnode
	  }
	}
	
	function extractTransitionData (comp) {
	  var data = {};
	  var options = comp.$options;
	  // props
	  for (var key in options.propsData) {
	    data[key] = comp[key];
	  }
	  // events.
	  // extract listeners and pass them directly to the transition methods
	  var listeners = options._parentListeners;
	  for (var key$1 in listeners) {
	    data[camelize(key$1)] = listeners[key$1];
	  }
	  return data
	}
	
	function placeholder (h, rawChild) {
	  if (/\d-keep-alive$/.test(rawChild.tag)) {
	    return h('keep-alive', {
	      props: rawChild.componentOptions.propsData
	    })
	  }
	}
	
	function hasParentTransition (vnode) {
	  while ((vnode = vnode.parent)) {
	    if (vnode.data.transition) {
	      return true
	    }
	  }
	}
	
	function isSameChild (child, oldChild) {
	  return oldChild.key === child.key && oldChild.tag === child.tag
	}
	
	var Transition = {
	  name: 'transition',
	  props: transitionProps,
	  abstract: true,
	
	  render: function render (h) {
	    var this$1 = this;
	
	    var children = this.$slots.default;
	    if (!children) {
	      return
	    }
	
	    // filter out text nodes (possible whitespaces)
	    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
	    /* istanbul ignore if */
	    if (!children.length) {
	      return
	    }
	
	    // warn multiple elements
	    if (false) {
	      warn(
	        '<transition> can only be used on a single element. Use ' +
	        '<transition-group> for lists.',
	        this.$parent
	      );
	    }
	
	    var mode = this.mode;
	
	    // warn invalid mode
	    if (false
	    ) {
	      warn(
	        'invalid <transition> mode: ' + mode,
	        this.$parent
	      );
	    }
	
	    var rawChild = children[0];
	
	    // if this is a component root node and the component's
	    // parent container node also has transition, skip.
	    if (hasParentTransition(this.$vnode)) {
	      return rawChild
	    }
	
	    // apply transition data to child
	    // use getRealChild() to ignore abstract components e.g. keep-alive
	    var child = getRealChild(rawChild);
	    /* istanbul ignore if */
	    if (!child) {
	      return rawChild
	    }
	
	    if (this._leaving) {
	      return placeholder(h, rawChild)
	    }
	
	    // ensure a key that is unique to the vnode type and to this transition
	    // component instance. This key will be used to remove pending leaving nodes
	    // during entering.
	    var id = "__transition-" + (this._uid) + "-";
	    child.key = child.key == null
	      ? child.isComment
	        ? id + 'comment'
	        : id + child.tag
	      : isPrimitive(child.key)
	        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
	        : child.key;
	
	    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
	    var oldRawChild = this._vnode;
	    var oldChild = getRealChild(oldRawChild);
	
	    // mark v-show
	    // so that the transition module can hand over the control to the directive
	    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
	      child.data.show = true;
	    }
	
	    if (
	      oldChild &&
	      oldChild.data &&
	      !isSameChild(child, oldChild) &&
	      !isAsyncPlaceholder(oldChild) &&
	      // #6687 component root is a comment node
	      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
	    ) {
	      // replace old child transition data with fresh one
	      // important for dynamic transitions!
	      var oldData = oldChild.data.transition = extend({}, data);
	      // handle transition mode
	      if (mode === 'out-in') {
	        // return placeholder node and queue update when leave finishes
	        this._leaving = true;
	        mergeVNodeHook(oldData, 'afterLeave', function () {
	          this$1._leaving = false;
	          this$1.$forceUpdate();
	        });
	        return placeholder(h, rawChild)
	      } else if (mode === 'in-out') {
	        if (isAsyncPlaceholder(child)) {
	          return oldRawChild
	        }
	        var delayedLeave;
	        var performLeave = function () { delayedLeave(); };
	        mergeVNodeHook(data, 'afterEnter', performLeave);
	        mergeVNodeHook(data, 'enterCancelled', performLeave);
	        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
	      }
	    }
	
	    return rawChild
	  }
	}
	
	/*  */
	
	// Provides transition support for list items.
	// supports move transitions using the FLIP technique.
	
	// Because the vdom's children update algorithm is "unstable" - i.e.
	// it doesn't guarantee the relative positioning of removed elements,
	// we force transition-group to update its children into two passes:
	// in the first pass, we remove all nodes that need to be removed,
	// triggering their leaving transition; in the second pass, we insert/move
	// into the final desired state. This way in the second pass removed
	// nodes will remain where they should be.
	
	var props = extend({
	  tag: String,
	  moveClass: String
	}, transitionProps);
	
	delete props.mode;
	
	var TransitionGroup = {
	  props: props,
	
	  render: function render (h) {
	    var tag = this.tag || this.$vnode.data.tag || 'span';
	    var map = Object.create(null);
	    var prevChildren = this.prevChildren = this.children;
	    var rawChildren = this.$slots.default || [];
	    var children = this.children = [];
	    var transitionData = extractTransitionData(this);
	
	    for (var i = 0; i < rawChildren.length; i++) {
	      var c = rawChildren[i];
	      if (c.tag) {
	        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
	          children.push(c);
	          map[c.key] = c
	          ;(c.data || (c.data = {})).transition = transitionData;
	        } else if (false) {
	          var opts = c.componentOptions;
	          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
	          warn(("<transition-group> children must be keyed: <" + name + ">"));
	        }
	      }
	    }
	
	    if (prevChildren) {
	      var kept = [];
	      var removed = [];
	      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
	        var c$1 = prevChildren[i$1];
	        c$1.data.transition = transitionData;
	        c$1.data.pos = c$1.elm.getBoundingClientRect();
	        if (map[c$1.key]) {
	          kept.push(c$1);
	        } else {
	          removed.push(c$1);
	        }
	      }
	      this.kept = h(tag, null, kept);
	      this.removed = removed;
	    }
	
	    return h(tag, null, children)
	  },
	
	  beforeUpdate: function beforeUpdate () {
	    // force removing pass
	    this.__patch__(
	      this._vnode,
	      this.kept,
	      false, // hydrating
	      true // removeOnly (!important, avoids unnecessary moves)
	    );
	    this._vnode = this.kept;
	  },
	
	  updated: function updated () {
	    var children = this.prevChildren;
	    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
	    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
	      return
	    }
	
	    // we divide the work into three loops to avoid mixing DOM reads and writes
	    // in each iteration - which helps prevent layout thrashing.
	    children.forEach(callPendingCbs);
	    children.forEach(recordPosition);
	    children.forEach(applyTranslation);
	
	    // force reflow to put everything in position
	    // assign to this to avoid being removed in tree-shaking
	    // $flow-disable-line
	    this._reflow = document.body.offsetHeight;
	
	    children.forEach(function (c) {
	      if (c.data.moved) {
	        var el = c.elm;
	        var s = el.style;
	        addTransitionClass(el, moveClass);
	        s.transform = s.WebkitTransform = s.transitionDuration = '';
	        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
	          if (!e || /transform$/.test(e.propertyName)) {
	            el.removeEventListener(transitionEndEvent, cb);
	            el._moveCb = null;
	            removeTransitionClass(el, moveClass);
	          }
	        });
	      }
	    });
	  },
	
	  methods: {
	    hasMove: function hasMove (el, moveClass) {
	      /* istanbul ignore if */
	      if (!hasTransition) {
	        return false
	      }
	      /* istanbul ignore if */
	      if (this._hasMove) {
	        return this._hasMove
	      }
	      // Detect whether an element with the move class applied has
	      // CSS transitions. Since the element may be inside an entering
	      // transition at this very moment, we make a clone of it and remove
	      // all other transition classes applied to ensure only the move class
	      // is applied.
	      var clone = el.cloneNode();
	      if (el._transitionClasses) {
	        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
	      }
	      addClass(clone, moveClass);
	      clone.style.display = 'none';
	      this.$el.appendChild(clone);
	      var info = getTransitionInfo(clone);
	      this.$el.removeChild(clone);
	      return (this._hasMove = info.hasTransform)
	    }
	  }
	}
	
	function callPendingCbs (c) {
	  /* istanbul ignore if */
	  if (c.elm._moveCb) {
	    c.elm._moveCb();
	  }
	  /* istanbul ignore if */
	  if (c.elm._enterCb) {
	    c.elm._enterCb();
	  }
	}
	
	function recordPosition (c) {
	  c.data.newPos = c.elm.getBoundingClientRect();
	}
	
	function applyTranslation (c) {
	  var oldPos = c.data.pos;
	  var newPos = c.data.newPos;
	  var dx = oldPos.left - newPos.left;
	  var dy = oldPos.top - newPos.top;
	  if (dx || dy) {
	    c.data.moved = true;
	    var s = c.elm.style;
	    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
	    s.transitionDuration = '0s';
	  }
	}
	
	var platformComponents = {
	  Transition: Transition,
	  TransitionGroup: TransitionGroup
	}
	
	/*  */
	
	// install platform specific utils
	Vue.config.mustUseProp = mustUseProp;
	Vue.config.isReservedTag = isReservedTag;
	Vue.config.isReservedAttr = isReservedAttr;
	Vue.config.getTagNamespace = getTagNamespace;
	Vue.config.isUnknownElement = isUnknownElement;
	
	// install platform runtime directives & components
	extend(Vue.options.directives, platformDirectives);
	extend(Vue.options.components, platformComponents);
	
	// install platform patch function
	Vue.prototype.__patch__ = inBrowser ? patch : noop;
	
	// public mount method
	Vue.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && inBrowser ? query(el) : undefined;
	  return mountComponent(this, el, hydrating)
	};
	
	// devtools global hook
	/* istanbul ignore next */
	if (inBrowser) {
	  setTimeout(function () {
	    if (config.devtools) {
	      if (devtools) {
	        devtools.emit('init', Vue);
	      } else if (
	        false
	      ) {
	        console[console.info ? 'info' : 'log'](
	          'Download the Vue Devtools extension for a better development experience:\n' +
	          'https://github.com/vuejs/vue-devtools'
	        );
	      }
	    }
	    if (false
	    ) {
	      console[console.info ? 'info' : 'log'](
	        "You are running Vue in development mode.\n" +
	        "Make sure to turn on production mode when deploying for production.\n" +
	        "See more tips at https://vuejs.org/guide/deployment.html"
	      );
	    }
	  }, 0);
	}
	
	/*  */
	
	var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
	var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
	
	var buildRegex = cached(function (delimiters) {
	  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
	  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
	  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
	});
	
	
	
	function parseText (
	  text,
	  delimiters
	) {
	  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
	  if (!tagRE.test(text)) {
	    return
	  }
	  var tokens = [];
	  var rawTokens = [];
	  var lastIndex = tagRE.lastIndex = 0;
	  var match, index, tokenValue;
	  while ((match = tagRE.exec(text))) {
	    index = match.index;
	    // push text token
	    if (index > lastIndex) {
	      rawTokens.push(tokenValue = text.slice(lastIndex, index));
	      tokens.push(JSON.stringify(tokenValue));
	    }
	    // tag token
	    var exp = parseFilters(match[1].trim());
	    tokens.push(("_s(" + exp + ")"));
	    rawTokens.push({ '@binding': exp });
	    lastIndex = index + match[0].length;
	  }
	  if (lastIndex < text.length) {
	    rawTokens.push(tokenValue = text.slice(lastIndex));
	    tokens.push(JSON.stringify(tokenValue));
	  }
	  return {
	    expression: tokens.join('+'),
	    tokens: rawTokens
	  }
	}
	
	/*  */
	
	function transformNode (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticClass = getAndRemoveAttr(el, 'class');
	  if (false) {
	    var res = parseText(staticClass, options.delimiters);
	    if (res) {
	      warn(
	        "class=\"" + staticClass + "\": " +
	        'Interpolation inside attributes has been removed. ' +
	        'Use v-bind or the colon shorthand instead. For example, ' +
	        'instead of <div class="{{ val }}">, use <div :class="val">.'
	      );
	    }
	  }
	  if (staticClass) {
	    el.staticClass = JSON.stringify(staticClass);
	  }
	  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
	  if (classBinding) {
	    el.classBinding = classBinding;
	  }
	}
	
	function genData (el) {
	  var data = '';
	  if (el.staticClass) {
	    data += "staticClass:" + (el.staticClass) + ",";
	  }
	  if (el.classBinding) {
	    data += "class:" + (el.classBinding) + ",";
	  }
	  return data
	}
	
	var klass$1 = {
	  staticKeys: ['staticClass'],
	  transformNode: transformNode,
	  genData: genData
	}
	
	/*  */
	
	function transformNode$1 (el, options) {
	  var warn = options.warn || baseWarn;
	  var staticStyle = getAndRemoveAttr(el, 'style');
	  if (staticStyle) {
	    /* istanbul ignore if */
	    if (false) {
	      var res = parseText(staticStyle, options.delimiters);
	      if (res) {
	        warn(
	          "style=\"" + staticStyle + "\": " +
	          'Interpolation inside attributes has been removed. ' +
	          'Use v-bind or the colon shorthand instead. For example, ' +
	          'instead of <div style="{{ val }}">, use <div :style="val">.'
	        );
	      }
	    }
	    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
	  }
	
	  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
	  if (styleBinding) {
	    el.styleBinding = styleBinding;
	  }
	}
	
	function genData$1 (el) {
	  var data = '';
	  if (el.staticStyle) {
	    data += "staticStyle:" + (el.staticStyle) + ",";
	  }
	  if (el.styleBinding) {
	    data += "style:(" + (el.styleBinding) + "),";
	  }
	  return data
	}
	
	var style$1 = {
	  staticKeys: ['staticStyle'],
	  transformNode: transformNode$1,
	  genData: genData$1
	}
	
	/*  */
	
	var decoder;
	
	var he = {
	  decode: function decode (html) {
	    decoder = decoder || document.createElement('div');
	    decoder.innerHTML = html;
	    return decoder.textContent
	  }
	}
	
	/*  */
	
	var isUnaryTag = makeMap(
	  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
	  'link,meta,param,source,track,wbr'
	);
	
	// Elements that you can, intentionally, leave open
	// (and which close themselves)
	var canBeLeftOpenTag = makeMap(
	  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
	);
	
	// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
	// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
	var isNonPhrasingTag = makeMap(
	  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
	  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
	  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
	  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
	  'title,tr,track'
	);
	
	/**
	 * Not type-checking this file because it's mostly vendor code.
	 */
	
	/*!
	 * HTML Parser By John Resig (ejohn.org)
	 * Modified by Juriy "kangax" Zaytsev
	 * Original code by Erik Arvidsson, Mozilla Public License
	 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
	 */
	
	// Regular Expressions for parsing tags and attributes
	var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
	// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
	// but for Vue templates we can enforce a simple charset
	var ncname = '[a-zA-Z_][\\w\\-\\.]*';
	var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
	var startTagOpen = new RegExp(("^<" + qnameCapture));
	var startTagClose = /^\s*(\/?)>/;
	var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
	var doctype = /^<!DOCTYPE [^>]+>/i;
	// #7298: escape - to avoid being pased as HTML comment when inlined in page
	var comment = /^<!\--/;
	var conditionalComment = /^<!\[/;
	
	var IS_REGEX_CAPTURING_BROKEN = false;
	'x'.replace(/x(.)?/g, function (m, g) {
	  IS_REGEX_CAPTURING_BROKEN = g === '';
	});
	
	// Special Elements (can contain anything)
	var isPlainTextElement = makeMap('script,style,textarea', true);
	var reCache = {};
	
	var decodingMap = {
	  '&lt;': '<',
	  '&gt;': '>',
	  '&quot;': '"',
	  '&amp;': '&',
	  '&#10;': '\n',
	  '&#9;': '\t'
	};
	var encodedAttr = /&(?:lt|gt|quot|amp);/g;
	var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;
	
	// #5992
	var isIgnoreNewlineTag = makeMap('pre,textarea', true);
	var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };
	
	function decodeAttr (value, shouldDecodeNewlines) {
	  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
	  return value.replace(re, function (match) { return decodingMap[match]; })
	}
	
	function parseHTML (html, options) {
	  var stack = [];
	  var expectHTML = options.expectHTML;
	  var isUnaryTag$$1 = options.isUnaryTag || no;
	  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
	  var index = 0;
	  var last, lastTag;
	  while (html) {
	    last = html;
	    // Make sure we're not in a plaintext content element like script/style
	    if (!lastTag || !isPlainTextElement(lastTag)) {
	      var textEnd = html.indexOf('<');
	      if (textEnd === 0) {
	        // Comment:
	        if (comment.test(html)) {
	          var commentEnd = html.indexOf('-->');
	
	          if (commentEnd >= 0) {
	            if (options.shouldKeepComment) {
	              options.comment(html.substring(4, commentEnd));
	            }
	            advance(commentEnd + 3);
	            continue
	          }
	        }
	
	        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
	        if (conditionalComment.test(html)) {
	          var conditionalEnd = html.indexOf(']>');
	
	          if (conditionalEnd >= 0) {
	            advance(conditionalEnd + 2);
	            continue
	          }
	        }
	
	        // Doctype:
	        var doctypeMatch = html.match(doctype);
	        if (doctypeMatch) {
	          advance(doctypeMatch[0].length);
	          continue
	        }
	
	        // End tag:
	        var endTagMatch = html.match(endTag);
	        if (endTagMatch) {
	          var curIndex = index;
	          advance(endTagMatch[0].length);
	          parseEndTag(endTagMatch[1], curIndex, index);
	          continue
	        }
	
	        // Start tag:
	        var startTagMatch = parseStartTag();
	        if (startTagMatch) {
	          handleStartTag(startTagMatch);
	          if (shouldIgnoreFirstNewline(lastTag, html)) {
	            advance(1);
	          }
	          continue
	        }
	      }
	
	      var text = (void 0), rest = (void 0), next = (void 0);
	      if (textEnd >= 0) {
	        rest = html.slice(textEnd);
	        while (
	          !endTag.test(rest) &&
	          !startTagOpen.test(rest) &&
	          !comment.test(rest) &&
	          !conditionalComment.test(rest)
	        ) {
	          // < in plain text, be forgiving and treat it as text
	          next = rest.indexOf('<', 1);
	          if (next < 0) { break }
	          textEnd += next;
	          rest = html.slice(textEnd);
	        }
	        text = html.substring(0, textEnd);
	        advance(textEnd);
	      }
	
	      if (textEnd < 0) {
	        text = html;
	        html = '';
	      }
	
	      if (options.chars && text) {
	        options.chars(text);
	      }
	    } else {
	      var endTagLength = 0;
	      var stackedTag = lastTag.toLowerCase();
	      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
	      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
	        endTagLength = endTag.length;
	        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
	          text = text
	            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
	            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
	        }
	        if (shouldIgnoreFirstNewline(stackedTag, text)) {
	          text = text.slice(1);
	        }
	        if (options.chars) {
	          options.chars(text);
	        }
	        return ''
	      });
	      index += html.length - rest$1.length;
	      html = rest$1;
	      parseEndTag(stackedTag, index - endTagLength, index);
	    }
	
	    if (html === last) {
	      options.chars && options.chars(html);
	      if (false) {
	        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
	      }
	      break
	    }
	  }
	
	  // Clean up any remaining tags
	  parseEndTag();
	
	  function advance (n) {
	    index += n;
	    html = html.substring(n);
	  }
	
	  function parseStartTag () {
	    var start = html.match(startTagOpen);
	    if (start) {
	      var match = {
	        tagName: start[1],
	        attrs: [],
	        start: index
	      };
	      advance(start[0].length);
	      var end, attr;
	      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
	        advance(attr[0].length);
	        match.attrs.push(attr);
	      }
	      if (end) {
	        match.unarySlash = end[1];
	        advance(end[0].length);
	        match.end = index;
	        return match
	      }
	    }
	  }
	
	  function handleStartTag (match) {
	    var tagName = match.tagName;
	    var unarySlash = match.unarySlash;
	
	    if (expectHTML) {
	      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
	        parseEndTag(lastTag);
	      }
	      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
	        parseEndTag(tagName);
	      }
	    }
	
	    var unary = isUnaryTag$$1(tagName) || !!unarySlash;
	
	    var l = match.attrs.length;
	    var attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      var args = match.attrs[i];
	      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
	      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
	        if (args[3] === '') { delete args[3]; }
	        if (args[4] === '') { delete args[4]; }
	        if (args[5] === '') { delete args[5]; }
	      }
	      var value = args[3] || args[4] || args[5] || '';
	      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
	        ? options.shouldDecodeNewlinesForHref
	        : options.shouldDecodeNewlines;
	      attrs[i] = {
	        name: args[1],
	        value: decodeAttr(value, shouldDecodeNewlines)
	      };
	    }
	
	    if (!unary) {
	      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
	      lastTag = tagName;
	    }
	
	    if (options.start) {
	      options.start(tagName, attrs, unary, match.start, match.end);
	    }
	  }
	
	  function parseEndTag (tagName, start, end) {
	    var pos, lowerCasedTagName;
	    if (start == null) { start = index; }
	    if (end == null) { end = index; }
	
	    if (tagName) {
	      lowerCasedTagName = tagName.toLowerCase();
	    }
	
	    // Find the closest opened tag of the same type
	    if (tagName) {
	      for (pos = stack.length - 1; pos >= 0; pos--) {
	        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
	          break
	        }
	      }
	    } else {
	      // If no tag name is provided, clean shop
	      pos = 0;
	    }
	
	    if (pos >= 0) {
	      // Close all the open elements, up the stack
	      for (var i = stack.length - 1; i >= pos; i--) {
	        if (false
	        ) {
	          options.warn(
	            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
	          );
	        }
	        if (options.end) {
	          options.end(stack[i].tag, start, end);
	        }
	      }
	
	      // Remove the open elements from the stack
	      stack.length = pos;
	      lastTag = pos && stack[pos - 1].tag;
	    } else if (lowerCasedTagName === 'br') {
	      if (options.start) {
	        options.start(tagName, [], true, start, end);
	      }
	    } else if (lowerCasedTagName === 'p') {
	      if (options.start) {
	        options.start(tagName, [], false, start, end);
	      }
	      if (options.end) {
	        options.end(tagName, start, end);
	      }
	    }
	  }
	}
	
	/*  */
	
	var onRE = /^@|^v-on:/;
	var dirRE = /^v-|^@|^:/;
	var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
	var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
	var stripParensRE = /^\(|\)$/g;
	
	var argRE = /:(.*)$/;
	var bindRE = /^:|^v-bind:/;
	var modifierRE = /\.[^.]+/g;
	
	var decodeHTMLCached = cached(he.decode);
	
	// configurable state
	var warn$2;
	var delimiters;
	var transforms;
	var preTransforms;
	var postTransforms;
	var platformIsPreTag;
	var platformMustUseProp;
	var platformGetTagNamespace;
	
	
	
	function createASTElement (
	  tag,
	  attrs,
	  parent
	) {
	  return {
	    type: 1,
	    tag: tag,
	    attrsList: attrs,
	    attrsMap: makeAttrsMap(attrs),
	    parent: parent,
	    children: []
	  }
	}
	
	/**
	 * Convert HTML string to AST.
	 */
	function parse (
	  template,
	  options
	) {
	  warn$2 = options.warn || baseWarn;
	
	  platformIsPreTag = options.isPreTag || no;
	  platformMustUseProp = options.mustUseProp || no;
	  platformGetTagNamespace = options.getTagNamespace || no;
	
	  transforms = pluckModuleFunction(options.modules, 'transformNode');
	  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
	  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
	
	  delimiters = options.delimiters;
	
	  var stack = [];
	  var preserveWhitespace = options.preserveWhitespace !== false;
	  var root;
	  var currentParent;
	  var inVPre = false;
	  var inPre = false;
	  var warned = false;
	
	  function warnOnce (msg) {
	    if (!warned) {
	      warned = true;
	      warn$2(msg);
	    }
	  }
	
	  function closeElement (element) {
	    // check pre state
	    if (element.pre) {
	      inVPre = false;
	    }
	    if (platformIsPreTag(element.tag)) {
	      inPre = false;
	    }
	    // apply post-transforms
	    for (var i = 0; i < postTransforms.length; i++) {
	      postTransforms[i](element, options);
	    }
	  }
	
	  parseHTML(template, {
	    warn: warn$2,
	    expectHTML: options.expectHTML,
	    isUnaryTag: options.isUnaryTag,
	    canBeLeftOpenTag: options.canBeLeftOpenTag,
	    shouldDecodeNewlines: options.shouldDecodeNewlines,
	    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
	    shouldKeepComment: options.comments,
	    start: function start (tag, attrs, unary) {
	      // check namespace.
	      // inherit parent ns if there is one
	      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
	
	      // handle IE svg bug
	      /* istanbul ignore if */
	      if (isIE && ns === 'svg') {
	        attrs = guardIESVGBug(attrs);
	      }
	
	      var element = createASTElement(tag, attrs, currentParent);
	      if (ns) {
	        element.ns = ns;
	      }
	
	      if (isForbiddenTag(element) && !isServerRendering()) {
	        element.forbidden = true;
	        ("production") !== 'production' && warn$2(
	          'Templates should only be responsible for mapping the state to the ' +
	          'UI. Avoid placing tags with side-effects in your templates, such as ' +
	          "<" + tag + ">" + ', as they will not be parsed.'
	        );
	      }
	
	      // apply pre-transforms
	      for (var i = 0; i < preTransforms.length; i++) {
	        element = preTransforms[i](element, options) || element;
	      }
	
	      if (!inVPre) {
	        processPre(element);
	        if (element.pre) {
	          inVPre = true;
	        }
	      }
	      if (platformIsPreTag(element.tag)) {
	        inPre = true;
	      }
	      if (inVPre) {
	        processRawAttrs(element);
	      } else if (!element.processed) {
	        // structural directives
	        processFor(element);
	        processIf(element);
	        processOnce(element);
	        // element-scope stuff
	        processElement(element, options);
	      }
	
	      function checkRootConstraints (el) {
	        if (false) {
	          if (el.tag === 'slot' || el.tag === 'template') {
	            warnOnce(
	              "Cannot use <" + (el.tag) + "> as component root element because it may " +
	              'contain multiple nodes.'
	            );
	          }
	          if (el.attrsMap.hasOwnProperty('v-for')) {
	            warnOnce(
	              'Cannot use v-for on stateful component root element because ' +
	              'it renders multiple elements.'
	            );
	          }
	        }
	      }
	
	      // tree management
	      if (!root) {
	        root = element;
	        checkRootConstraints(root);
	      } else if (!stack.length) {
	        // allow root elements with v-if, v-else-if and v-else
	        if (root.if && (element.elseif || element.else)) {
	          checkRootConstraints(element);
	          addIfCondition(root, {
	            exp: element.elseif,
	            block: element
	          });
	        } else if (false) {
	          warnOnce(
	            "Component template should contain exactly one root element. " +
	            "If you are using v-if on multiple elements, " +
	            "use v-else-if to chain them instead."
	          );
	        }
	      }
	      if (currentParent && !element.forbidden) {
	        if (element.elseif || element.else) {
	          processIfConditions(element, currentParent);
	        } else if (element.slotScope) { // scoped slot
	          currentParent.plain = false;
	          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
	        } else {
	          currentParent.children.push(element);
	          element.parent = currentParent;
	        }
	      }
	      if (!unary) {
	        currentParent = element;
	        stack.push(element);
	      } else {
	        closeElement(element);
	      }
	    },
	
	    end: function end () {
	      // remove trailing whitespace
	      var element = stack[stack.length - 1];
	      var lastNode = element.children[element.children.length - 1];
	      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
	        element.children.pop();
	      }
	      // pop stack
	      stack.length -= 1;
	      currentParent = stack[stack.length - 1];
	      closeElement(element);
	    },
	
	    chars: function chars (text) {
	      if (!currentParent) {
	        if (false) {
	          if (text === template) {
	            warnOnce(
	              'Component template requires a root element, rather than just text.'
	            );
	          } else if ((text = text.trim())) {
	            warnOnce(
	              ("text \"" + text + "\" outside root element will be ignored.")
	            );
	          }
	        }
	        return
	      }
	      // IE textarea placeholder bug
	      /* istanbul ignore if */
	      if (isIE &&
	        currentParent.tag === 'textarea' &&
	        currentParent.attrsMap.placeholder === text
	      ) {
	        return
	      }
	      var children = currentParent.children;
	      text = inPre || text.trim()
	        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
	        // only preserve whitespace if its not right after a starting tag
	        : preserveWhitespace && children.length ? ' ' : '';
	      if (text) {
	        var res;
	        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
	          children.push({
	            type: 2,
	            expression: res.expression,
	            tokens: res.tokens,
	            text: text
	          });
	        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
	          children.push({
	            type: 3,
	            text: text
	          });
	        }
	      }
	    },
	    comment: function comment (text) {
	      currentParent.children.push({
	        type: 3,
	        text: text,
	        isComment: true
	      });
	    }
	  });
	  return root
	}
	
	function processPre (el) {
	  if (getAndRemoveAttr(el, 'v-pre') != null) {
	    el.pre = true;
	  }
	}
	
	function processRawAttrs (el) {
	  var l = el.attrsList.length;
	  if (l) {
	    var attrs = el.attrs = new Array(l);
	    for (var i = 0; i < l; i++) {
	      attrs[i] = {
	        name: el.attrsList[i].name,
	        value: JSON.stringify(el.attrsList[i].value)
	      };
	    }
	  } else if (!el.pre) {
	    // non root node in pre blocks with no attributes
	    el.plain = true;
	  }
	}
	
	function processElement (element, options) {
	  processKey(element);
	
	  // determine whether this is a plain element after
	  // removing structural attributes
	  element.plain = !element.key && !element.attrsList.length;
	
	  processRef(element);
	  processSlot(element);
	  processComponent(element);
	  for (var i = 0; i < transforms.length; i++) {
	    element = transforms[i](element, options) || element;
	  }
	  processAttrs(element);
	}
	
	function processKey (el) {
	  var exp = getBindingAttr(el, 'key');
	  if (exp) {
	    if (false) {
	      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
	    }
	    el.key = exp;
	  }
	}
	
	function processRef (el) {
	  var ref = getBindingAttr(el, 'ref');
	  if (ref) {
	    el.ref = ref;
	    el.refInFor = checkInFor(el);
	  }
	}
	
	function processFor (el) {
	  var exp;
	  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
	    var res = parseFor(exp);
	    if (res) {
	      extend(el, res);
	    } else if (false) {
	      warn$2(
	        ("Invalid v-for expression: " + exp)
	      );
	    }
	  }
	}
	
	
	
	function parseFor (exp) {
	  var inMatch = exp.match(forAliasRE);
	  if (!inMatch) { return }
	  var res = {};
	  res.for = inMatch[2].trim();
	  var alias = inMatch[1].trim().replace(stripParensRE, '');
	  var iteratorMatch = alias.match(forIteratorRE);
	  if (iteratorMatch) {
	    res.alias = alias.replace(forIteratorRE, '');
	    res.iterator1 = iteratorMatch[1].trim();
	    if (iteratorMatch[2]) {
	      res.iterator2 = iteratorMatch[2].trim();
	    }
	  } else {
	    res.alias = alias;
	  }
	  return res
	}
	
	function processIf (el) {
	  var exp = getAndRemoveAttr(el, 'v-if');
	  if (exp) {
	    el.if = exp;
	    addIfCondition(el, {
	      exp: exp,
	      block: el
	    });
	  } else {
	    if (getAndRemoveAttr(el, 'v-else') != null) {
	      el.else = true;
	    }
	    var elseif = getAndRemoveAttr(el, 'v-else-if');
	    if (elseif) {
	      el.elseif = elseif;
	    }
	  }
	}
	
	function processIfConditions (el, parent) {
	  var prev = findPrevElement(parent.children);
	  if (prev && prev.if) {
	    addIfCondition(prev, {
	      exp: el.elseif,
	      block: el
	    });
	  } else if (false) {
	    warn$2(
	      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
	      "used on element <" + (el.tag) + "> without corresponding v-if."
	    );
	  }
	}
	
	function findPrevElement (children) {
	  var i = children.length;
	  while (i--) {
	    if (children[i].type === 1) {
	      return children[i]
	    } else {
	      if (false) {
	        warn$2(
	          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
	          "will be ignored."
	        );
	      }
	      children.pop();
	    }
	  }
	}
	
	function addIfCondition (el, condition) {
	  if (!el.ifConditions) {
	    el.ifConditions = [];
	  }
	  el.ifConditions.push(condition);
	}
	
	function processOnce (el) {
	  var once$$1 = getAndRemoveAttr(el, 'v-once');
	  if (once$$1 != null) {
	    el.once = true;
	  }
	}
	
	function processSlot (el) {
	  if (el.tag === 'slot') {
	    el.slotName = getBindingAttr(el, 'name');
	    if (false) {
	      warn$2(
	        "`key` does not work on <slot> because slots are abstract outlets " +
	        "and can possibly expand into multiple elements. " +
	        "Use the key on a wrapping element instead."
	      );
	    }
	  } else {
	    var slotScope;
	    if (el.tag === 'template') {
	      slotScope = getAndRemoveAttr(el, 'scope');
	      /* istanbul ignore if */
	      if (false) {
	        warn$2(
	          "the \"scope\" attribute for scoped slots have been deprecated and " +
	          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
	          "can also be used on plain elements in addition to <template> to " +
	          "denote scoped slots.",
	          true
	        );
	      }
	      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
	    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
	      /* istanbul ignore if */
	      if (false) {
	        warn$2(
	          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
	          "(v-for takes higher priority). Use a wrapper <template> for the " +
	          "scoped slot to make it clearer.",
	          true
	        );
	      }
	      el.slotScope = slotScope;
	    }
	    var slotTarget = getBindingAttr(el, 'slot');
	    if (slotTarget) {
	      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
	      // preserve slot as an attribute for native shadow DOM compat
	      // only for non-scoped slots.
	      if (el.tag !== 'template' && !el.slotScope) {
	        addAttr(el, 'slot', slotTarget);
	      }
	    }
	  }
	}
	
	function processComponent (el) {
	  var binding;
	  if ((binding = getBindingAttr(el, 'is'))) {
	    el.component = binding;
	  }
	  if (getAndRemoveAttr(el, 'inline-template') != null) {
	    el.inlineTemplate = true;
	  }
	}
	
	function processAttrs (el) {
	  var list = el.attrsList;
	  var i, l, name, rawName, value, modifiers, isProp;
	  for (i = 0, l = list.length; i < l; i++) {
	    name = rawName = list[i].name;
	    value = list[i].value;
	    if (dirRE.test(name)) {
	      // mark element as dynamic
	      el.hasBindings = true;
	      // modifiers
	      modifiers = parseModifiers(name);
	      if (modifiers) {
	        name = name.replace(modifierRE, '');
	      }
	      if (bindRE.test(name)) { // v-bind
	        name = name.replace(bindRE, '');
	        value = parseFilters(value);
	        isProp = false;
	        if (modifiers) {
	          if (modifiers.prop) {
	            isProp = true;
	            name = camelize(name);
	            if (name === 'innerHtml') { name = 'innerHTML'; }
	          }
	          if (modifiers.camel) {
	            name = camelize(name);
	          }
	          if (modifiers.sync) {
	            addHandler(
	              el,
	              ("update:" + (camelize(name))),
	              genAssignmentCode(value, "$event")
	            );
	          }
	        }
	        if (isProp || (
	          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
	        )) {
	          addProp(el, name, value);
	        } else {
	          addAttr(el, name, value);
	        }
	      } else if (onRE.test(name)) { // v-on
	        name = name.replace(onRE, '');
	        addHandler(el, name, value, modifiers, false, warn$2);
	      } else { // normal directives
	        name = name.replace(dirRE, '');
	        // parse arg
	        var argMatch = name.match(argRE);
	        var arg = argMatch && argMatch[1];
	        if (arg) {
	          name = name.slice(0, -(arg.length + 1));
	        }
	        addDirective(el, name, rawName, value, arg, modifiers);
	        if (false) {
	          checkForAliasModel(el, value);
	        }
	      }
	    } else {
	      // literal attribute
	      if (false) {
	        var res = parseText(value, delimiters);
	        if (res) {
	          warn$2(
	            name + "=\"" + value + "\": " +
	            'Interpolation inside attributes has been removed. ' +
	            'Use v-bind or the colon shorthand instead. For example, ' +
	            'instead of <div id="{{ val }}">, use <div :id="val">.'
	          );
	        }
	      }
	      addAttr(el, name, JSON.stringify(value));
	      // #6887 firefox doesn't update muted state if set via attribute
	      // even immediately after element creation
	      if (!el.component &&
	          name === 'muted' &&
	          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
	        addProp(el, name, 'true');
	      }
	    }
	  }
	}
	
	function checkInFor (el) {
	  var parent = el;
	  while (parent) {
	    if (parent.for !== undefined) {
	      return true
	    }
	    parent = parent.parent;
	  }
	  return false
	}
	
	function parseModifiers (name) {
	  var match = name.match(modifierRE);
	  if (match) {
	    var ret = {};
	    match.forEach(function (m) { ret[m.slice(1)] = true; });
	    return ret
	  }
	}
	
	function makeAttrsMap (attrs) {
	  var map = {};
	  for (var i = 0, l = attrs.length; i < l; i++) {
	    if (
	      false
	    ) {
	      warn$2('duplicate attribute: ' + attrs[i].name);
	    }
	    map[attrs[i].name] = attrs[i].value;
	  }
	  return map
	}
	
	// for script (e.g. type="x/template") or style, do not decode content
	function isTextTag (el) {
	  return el.tag === 'script' || el.tag === 'style'
	}
	
	function isForbiddenTag (el) {
	  return (
	    el.tag === 'style' ||
	    (el.tag === 'script' && (
	      !el.attrsMap.type ||
	      el.attrsMap.type === 'text/javascript'
	    ))
	  )
	}
	
	var ieNSBug = /^xmlns:NS\d+/;
	var ieNSPrefix = /^NS\d+:/;
	
	/* istanbul ignore next */
	function guardIESVGBug (attrs) {
	  var res = [];
	  for (var i = 0; i < attrs.length; i++) {
	    var attr = attrs[i];
	    if (!ieNSBug.test(attr.name)) {
	      attr.name = attr.name.replace(ieNSPrefix, '');
	      res.push(attr);
	    }
	  }
	  return res
	}
	
	function checkForAliasModel (el, value) {
	  var _el = el;
	  while (_el) {
	    if (_el.for && _el.alias === value) {
	      warn$2(
	        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
	        "You are binding v-model directly to a v-for iteration alias. " +
	        "This will not be able to modify the v-for source array because " +
	        "writing to the alias is like modifying a function local variable. " +
	        "Consider using an array of objects and use v-model on an object property instead."
	      );
	    }
	    _el = _el.parent;
	  }
	}
	
	/*  */
	
	/**
	 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
	 * Turn this:
	 *   <input v-model="data[type]" :type="type">
	 * into this:
	 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
	 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
	 *   <input v-else :type="type" v-model="data[type]">
	 */
	
	function preTransformNode (el, options) {
	  if (el.tag === 'input') {
	    var map = el.attrsMap;
	    if (!map['v-model']) {
	      return
	    }
	
	    var typeBinding;
	    if (map[':type'] || map['v-bind:type']) {
	      typeBinding = getBindingAttr(el, 'type');
	    }
	    if (!map.type && !typeBinding && map['v-bind']) {
	      typeBinding = "(" + (map['v-bind']) + ").type";
	    }
	
	    if (typeBinding) {
	      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
	      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
	      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
	      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
	      // 1. checkbox
	      var branch0 = cloneASTElement(el);
	      // process for on the main node
	      processFor(branch0);
	      addRawAttr(branch0, 'type', 'checkbox');
	      processElement(branch0, options);
	      branch0.processed = true; // prevent it from double-processed
	      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
	      addIfCondition(branch0, {
	        exp: branch0.if,
	        block: branch0
	      });
	      // 2. add radio else-if condition
	      var branch1 = cloneASTElement(el);
	      getAndRemoveAttr(branch1, 'v-for', true);
	      addRawAttr(branch1, 'type', 'radio');
	      processElement(branch1, options);
	      addIfCondition(branch0, {
	        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
	        block: branch1
	      });
	      // 3. other
	      var branch2 = cloneASTElement(el);
	      getAndRemoveAttr(branch2, 'v-for', true);
	      addRawAttr(branch2, ':type', typeBinding);
	      processElement(branch2, options);
	      addIfCondition(branch0, {
	        exp: ifCondition,
	        block: branch2
	      });
	
	      if (hasElse) {
	        branch0.else = true;
	      } else if (elseIfCondition) {
	        branch0.elseif = elseIfCondition;
	      }
	
	      return branch0
	    }
	  }
	}
	
	function cloneASTElement (el) {
	  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
	}
	
	var model$2 = {
	  preTransformNode: preTransformNode
	}
	
	var modules$1 = [
	  klass$1,
	  style$1,
	  model$2
	]
	
	/*  */
	
	function text (el, dir) {
	  if (dir.value) {
	    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	/*  */
	
	function html (el, dir) {
	  if (dir.value) {
	    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
	  }
	}
	
	var directives$1 = {
	  model: model,
	  text: text,
	  html: html
	}
	
	/*  */
	
	var baseOptions = {
	  expectHTML: true,
	  modules: modules$1,
	  directives: directives$1,
	  isPreTag: isPreTag,
	  isUnaryTag: isUnaryTag,
	  mustUseProp: mustUseProp,
	  canBeLeftOpenTag: canBeLeftOpenTag,
	  isReservedTag: isReservedTag,
	  getTagNamespace: getTagNamespace,
	  staticKeys: genStaticKeys(modules$1)
	};
	
	/*  */
	
	var isStaticKey;
	var isPlatformReservedTag;
	
	var genStaticKeysCached = cached(genStaticKeys$1);
	
	/**
	 * Goal of the optimizer: walk the generated template AST tree
	 * and detect sub-trees that are purely static, i.e. parts of
	 * the DOM that never needs to change.
	 *
	 * Once we detect these sub-trees, we can:
	 *
	 * 1. Hoist them into constants, so that we no longer need to
	 *    create fresh nodes for them on each re-render;
	 * 2. Completely skip them in the patching process.
	 */
	function optimize (root, options) {
	  if (!root) { return }
	  isStaticKey = genStaticKeysCached(options.staticKeys || '');
	  isPlatformReservedTag = options.isReservedTag || no;
	  // first pass: mark all non-static nodes.
	  markStatic$1(root);
	  // second pass: mark static roots.
	  markStaticRoots(root, false);
	}
	
	function genStaticKeys$1 (keys) {
	  return makeMap(
	    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
	    (keys ? ',' + keys : '')
	  )
	}
	
	function markStatic$1 (node) {
	  node.static = isStatic(node);
	  if (node.type === 1) {
	    // do not make component slot content static. this avoids
	    // 1. components not able to mutate slot nodes
	    // 2. static slot content fails for hot-reloading
	    if (
	      !isPlatformReservedTag(node.tag) &&
	      node.tag !== 'slot' &&
	      node.attrsMap['inline-template'] == null
	    ) {
	      return
	    }
	    for (var i = 0, l = node.children.length; i < l; i++) {
	      var child = node.children[i];
	      markStatic$1(child);
	      if (!child.static) {
	        node.static = false;
	      }
	    }
	    if (node.ifConditions) {
	      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
	        var block = node.ifConditions[i$1].block;
	        markStatic$1(block);
	        if (!block.static) {
	          node.static = false;
	        }
	      }
	    }
	  }
	}
	
	function markStaticRoots (node, isInFor) {
	  if (node.type === 1) {
	    if (node.static || node.once) {
	      node.staticInFor = isInFor;
	    }
	    // For a node to qualify as a static root, it should have children that
	    // are not just static text. Otherwise the cost of hoisting out will
	    // outweigh the benefits and it's better off to just always render it fresh.
	    if (node.static && node.children.length && !(
	      node.children.length === 1 &&
	      node.children[0].type === 3
	    )) {
	      node.staticRoot = true;
	      return
	    } else {
	      node.staticRoot = false;
	    }
	    if (node.children) {
	      for (var i = 0, l = node.children.length; i < l; i++) {
	        markStaticRoots(node.children[i], isInFor || !!node.for);
	      }
	    }
	    if (node.ifConditions) {
	      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
	        markStaticRoots(node.ifConditions[i$1].block, isInFor);
	      }
	    }
	  }
	}
	
	function isStatic (node) {
	  if (node.type === 2) { // expression
	    return false
	  }
	  if (node.type === 3) { // text
	    return true
	  }
	  return !!(node.pre || (
	    !node.hasBindings && // no dynamic bindings
	    !node.if && !node.for && // not v-if or v-for or v-else
	    !isBuiltInTag(node.tag) && // not a built-in
	    isPlatformReservedTag(node.tag) && // not a component
	    !isDirectChildOfTemplateFor(node) &&
	    Object.keys(node).every(isStaticKey)
	  ))
	}
	
	function isDirectChildOfTemplateFor (node) {
	  while (node.parent) {
	    node = node.parent;
	    if (node.tag !== 'template') {
	      return false
	    }
	    if (node.for) {
	      return true
	    }
	  }
	  return false
	}
	
	/*  */
	
	var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
	var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
	
	// KeyboardEvent.keyCode aliases
	var keyCodes = {
	  esc: 27,
	  tab: 9,
	  enter: 13,
	  space: 32,
	  up: 38,
	  left: 37,
	  right: 39,
	  down: 40,
	  'delete': [8, 46]
	};
	
	// KeyboardEvent.key aliases
	var keyNames = {
	  esc: 'Escape',
	  tab: 'Tab',
	  enter: 'Enter',
	  space: ' ',
	  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
	  up: ['Up', 'ArrowUp'],
	  left: ['Left', 'ArrowLeft'],
	  right: ['Right', 'ArrowRight'],
	  down: ['Down', 'ArrowDown'],
	  'delete': ['Backspace', 'Delete']
	};
	
	// #4868: modifiers that prevent the execution of the listener
	// need to explicitly return null so that we can determine whether to remove
	// the listener for .once
	var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };
	
	var modifierCode = {
	  stop: '$event.stopPropagation();',
	  prevent: '$event.preventDefault();',
	  self: genGuard("$event.target !== $event.currentTarget"),
	  ctrl: genGuard("!$event.ctrlKey"),
	  shift: genGuard("!$event.shiftKey"),
	  alt: genGuard("!$event.altKey"),
	  meta: genGuard("!$event.metaKey"),
	  left: genGuard("'button' in $event && $event.button !== 0"),
	  middle: genGuard("'button' in $event && $event.button !== 1"),
	  right: genGuard("'button' in $event && $event.button !== 2")
	};
	
	function genHandlers (
	  events,
	  isNative,
	  warn
	) {
	  var res = isNative ? 'nativeOn:{' : 'on:{';
	  for (var name in events) {
	    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
	  }
	  return res.slice(0, -1) + '}'
	}
	
	function genHandler (
	  name,
	  handler
	) {
	  if (!handler) {
	    return 'function(){}'
	  }
	
	  if (Array.isArray(handler)) {
	    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
	  }
	
	  var isMethodPath = simplePathRE.test(handler.value);
	  var isFunctionExpression = fnExpRE.test(handler.value);
	
	  if (!handler.modifiers) {
	    if (isMethodPath || isFunctionExpression) {
	      return handler.value
	    }
	    /* istanbul ignore if */
	    return ("function($event){" + (handler.value) + "}") // inline statement
	  } else {
	    var code = '';
	    var genModifierCode = '';
	    var keys = [];
	    for (var key in handler.modifiers) {
	      if (modifierCode[key]) {
	        genModifierCode += modifierCode[key];
	        // left/right
	        if (keyCodes[key]) {
	          keys.push(key);
	        }
	      } else if (key === 'exact') {
	        var modifiers = (handler.modifiers);
	        genModifierCode += genGuard(
	          ['ctrl', 'shift', 'alt', 'meta']
	            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
	            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
	            .join('||')
	        );
	      } else {
	        keys.push(key);
	      }
	    }
	    if (keys.length) {
	      code += genKeyFilter(keys);
	    }
	    // Make sure modifiers like prevent and stop get executed after key filtering
	    if (genModifierCode) {
	      code += genModifierCode;
	    }
	    var handlerCode = isMethodPath
	      ? ("return " + (handler.value) + "($event)")
	      : isFunctionExpression
	        ? ("return (" + (handler.value) + ")($event)")
	        : handler.value;
	    /* istanbul ignore if */
	    return ("function($event){" + code + handlerCode + "}")
	  }
	}
	
	function genKeyFilter (keys) {
	  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
	}
	
	function genFilterCode (key) {
	  var keyVal = parseInt(key, 10);
	  if (keyVal) {
	    return ("$event.keyCode!==" + keyVal)
	  }
	  var keyCode = keyCodes[key];
	  var keyName = keyNames[key];
	  return (
	    "_k($event.keyCode," +
	    (JSON.stringify(key)) + "," +
	    (JSON.stringify(keyCode)) + "," +
	    "$event.key," +
	    "" + (JSON.stringify(keyName)) +
	    ")"
	  )
	}
	
	/*  */
	
	function on (el, dir) {
	  if (false) {
	    warn("v-on without argument does not support modifiers.");
	  }
	  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
	}
	
	/*  */
	
	function bind$1 (el, dir) {
	  el.wrapData = function (code) {
	    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
	  };
	}
	
	/*  */
	
	var baseDirectives = {
	  on: on,
	  bind: bind$1,
	  cloak: noop
	}
	
	/*  */
	
	var CodegenState = function CodegenState (options) {
	  this.options = options;
	  this.warn = options.warn || baseWarn;
	  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
	  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
	  this.directives = extend(extend({}, baseDirectives), options.directives);
	  var isReservedTag = options.isReservedTag || no;
	  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
	  this.onceId = 0;
	  this.staticRenderFns = [];
	};
	
	
	
	function generate (
	  ast,
	  options
	) {
	  var state = new CodegenState(options);
	  var code = ast ? genElement(ast, state) : '_c("div")';
	  return {
	    render: ("with(this){return " + code + "}"),
	    staticRenderFns: state.staticRenderFns
	  }
	}
	
	function genElement (el, state) {
	  if (el.staticRoot && !el.staticProcessed) {
	    return genStatic(el, state)
	  } else if (el.once && !el.onceProcessed) {
	    return genOnce(el, state)
	  } else if (el.for && !el.forProcessed) {
	    return genFor(el, state)
	  } else if (el.if && !el.ifProcessed) {
	    return genIf(el, state)
	  } else if (el.tag === 'template' && !el.slotTarget) {
	    return genChildren(el, state) || 'void 0'
	  } else if (el.tag === 'slot') {
	    return genSlot(el, state)
	  } else {
	    // component or element
	    var code;
	    if (el.component) {
	      code = genComponent(el.component, el, state);
	    } else {
	      var data = el.plain ? undefined : genData$2(el, state);
	
	      var children = el.inlineTemplate ? null : genChildren(el, state, true);
	      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
	    }
	    // module transforms
	    for (var i = 0; i < state.transforms.length; i++) {
	      code = state.transforms[i](el, code);
	    }
	    return code
	  }
	}
	
	// hoist static sub-trees out
	function genStatic (el, state) {
	  el.staticProcessed = true;
	  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
	  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
	}
	
	// v-once
	function genOnce (el, state) {
	  el.onceProcessed = true;
	  if (el.if && !el.ifProcessed) {
	    return genIf(el, state)
	  } else if (el.staticInFor) {
	    var key = '';
	    var parent = el.parent;
	    while (parent) {
	      if (parent.for) {
	        key = parent.key;
	        break
	      }
	      parent = parent.parent;
	    }
	    if (!key) {
	      ("production") !== 'production' && state.warn(
	        "v-once can only be used inside v-for that is keyed. "
	      );
	      return genElement(el, state)
	    }
	    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
	  } else {
	    return genStatic(el, state)
	  }
	}
	
	function genIf (
	  el,
	  state,
	  altGen,
	  altEmpty
	) {
	  el.ifProcessed = true; // avoid recursion
	  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
	}
	
	function genIfConditions (
	  conditions,
	  state,
	  altGen,
	  altEmpty
	) {
	  if (!conditions.length) {
	    return altEmpty || '_e()'
	  }
	
	  var condition = conditions.shift();
	  if (condition.exp) {
	    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
	  } else {
	    return ("" + (genTernaryExp(condition.block)))
	  }
	
	  // v-if with v-once should generate code like (a)?_m(0):_m(1)
	  function genTernaryExp (el) {
	    return altGen
	      ? altGen(el, state)
	      : el.once
	        ? genOnce(el, state)
	        : genElement(el, state)
	  }
	}
	
	function genFor (
	  el,
	  state,
	  altGen,
	  altHelper
	) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	
	  if (false
	  ) {
	    state.warn(
	      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
	      "v-for should have explicit keys. " +
	      "See https://vuejs.org/guide/list.html#key for more info.",
	      true /* tip */
	    );
	  }
	
	  el.forProcessed = true; // avoid recursion
	  return (altHelper || '_l') + "((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + ((altGen || genElement)(el, state)) +
	    '})'
	}
	
	function genData$2 (el, state) {
	  var data = '{';
	
	  // directives first.
	  // directives may mutate the el's other properties before they are generated.
	  var dirs = genDirectives(el, state);
	  if (dirs) { data += dirs + ','; }
	
	  // key
	  if (el.key) {
	    data += "key:" + (el.key) + ",";
	  }
	  // ref
	  if (el.ref) {
	    data += "ref:" + (el.ref) + ",";
	  }
	  if (el.refInFor) {
	    data += "refInFor:true,";
	  }
	  // pre
	  if (el.pre) {
	    data += "pre:true,";
	  }
	  // record original tag name for components using "is" attribute
	  if (el.component) {
	    data += "tag:\"" + (el.tag) + "\",";
	  }
	  // module data generation functions
	  for (var i = 0; i < state.dataGenFns.length; i++) {
	    data += state.dataGenFns[i](el);
	  }
	  // attributes
	  if (el.attrs) {
	    data += "attrs:{" + (genProps(el.attrs)) + "},";
	  }
	  // DOM props
	  if (el.props) {
	    data += "domProps:{" + (genProps(el.props)) + "},";
	  }
	  // event handlers
	  if (el.events) {
	    data += (genHandlers(el.events, false, state.warn)) + ",";
	  }
	  if (el.nativeEvents) {
	    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
	  }
	  // slot target
	  // only for non-scoped slots
	  if (el.slotTarget && !el.slotScope) {
	    data += "slot:" + (el.slotTarget) + ",";
	  }
	  // scoped slots
	  if (el.scopedSlots) {
	    data += (genScopedSlots(el.scopedSlots, state)) + ",";
	  }
	  // component v-model
	  if (el.model) {
	    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
	  }
	  // inline-template
	  if (el.inlineTemplate) {
	    var inlineTemplate = genInlineTemplate(el, state);
	    if (inlineTemplate) {
	      data += inlineTemplate + ",";
	    }
	  }
	  data = data.replace(/,$/, '') + '}';
	  // v-bind data wrap
	  if (el.wrapData) {
	    data = el.wrapData(data);
	  }
	  // v-on data wrap
	  if (el.wrapListeners) {
	    data = el.wrapListeners(data);
	  }
	  return data
	}
	
	function genDirectives (el, state) {
	  var dirs = el.directives;
	  if (!dirs) { return }
	  var res = 'directives:[';
	  var hasRuntime = false;
	  var i, l, dir, needRuntime;
	  for (i = 0, l = dirs.length; i < l; i++) {
	    dir = dirs[i];
	    needRuntime = true;
	    var gen = state.directives[dir.name];
	    if (gen) {
	      // compile-time directive that manipulates AST.
	      // returns true if it also needs a runtime counterpart.
	      needRuntime = !!gen(el, dir, state.warn);
	    }
	    if (needRuntime) {
	      hasRuntime = true;
	      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
	    }
	  }
	  if (hasRuntime) {
	    return res.slice(0, -1) + ']'
	  }
	}
	
	function genInlineTemplate (el, state) {
	  var ast = el.children[0];
	  if (false) {
	    state.warn('Inline-template components must have exactly one child element.');
	  }
	  if (ast.type === 1) {
	    var inlineRenderFns = generate(ast, state.options);
	    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
	  }
	}
	
	function genScopedSlots (
	  slots,
	  state
	) {
	  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
	      return genScopedSlot(key, slots[key], state)
	    }).join(',')) + "])")
	}
	
	function genScopedSlot (
	  key,
	  el,
	  state
	) {
	  if (el.for && !el.forProcessed) {
	    return genForScopedSlot(key, el, state)
	  }
	  var fn = "function(" + (String(el.slotScope)) + "){" +
	    "return " + (el.tag === 'template'
	      ? el.if
	        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
	        : genChildren(el, state) || 'undefined'
	      : genElement(el, state)) + "}";
	  return ("{key:" + key + ",fn:" + fn + "}")
	}
	
	function genForScopedSlot (
	  key,
	  el,
	  state
	) {
	  var exp = el.for;
	  var alias = el.alias;
	  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
	  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
	  el.forProcessed = true; // avoid recursion
	  return "_l((" + exp + ")," +
	    "function(" + alias + iterator1 + iterator2 + "){" +
	      "return " + (genScopedSlot(key, el, state)) +
	    '})'
	}
	
	function genChildren (
	  el,
	  state,
	  checkSkip,
	  altGenElement,
	  altGenNode
	) {
	  var children = el.children;
	  if (children.length) {
	    var el$1 = children[0];
	    // optimize single v-for
	    if (children.length === 1 &&
	      el$1.for &&
	      el$1.tag !== 'template' &&
	      el$1.tag !== 'slot'
	    ) {
	      return (altGenElement || genElement)(el$1, state)
	    }
	    var normalizationType = checkSkip
	      ? getNormalizationType(children, state.maybeComponent)
	      : 0;
	    var gen = altGenNode || genNode;
	    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
	  }
	}
	
	// determine the normalization needed for the children array.
	// 0: no normalization needed
	// 1: simple normalization needed (possible 1-level deep nested array)
	// 2: full normalization needed
	function getNormalizationType (
	  children,
	  maybeComponent
	) {
	  var res = 0;
	  for (var i = 0; i < children.length; i++) {
	    var el = children[i];
	    if (el.type !== 1) {
	      continue
	    }
	    if (needsNormalization(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
	      res = 2;
	      break
	    }
	    if (maybeComponent(el) ||
	        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
	      res = 1;
	    }
	  }
	  return res
	}
	
	function needsNormalization (el) {
	  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
	}
	
	function genNode (node, state) {
	  if (node.type === 1) {
	    return genElement(node, state)
	  } if (node.type === 3 && node.isComment) {
	    return genComment(node)
	  } else {
	    return genText(node)
	  }
	}
	
	function genText (text) {
	  return ("_v(" + (text.type === 2
	    ? text.expression // no need for () because already wrapped in _s()
	    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
	}
	
	function genComment (comment) {
	  return ("_e(" + (JSON.stringify(comment.text)) + ")")
	}
	
	function genSlot (el, state) {
	  var slotName = el.slotName || '"default"';
	  var children = genChildren(el, state);
	  var res = "_t(" + slotName + (children ? ("," + children) : '');
	  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
	  var bind$$1 = el.attrsMap['v-bind'];
	  if ((attrs || bind$$1) && !children) {
	    res += ",null";
	  }
	  if (attrs) {
	    res += "," + attrs;
	  }
	  if (bind$$1) {
	    res += (attrs ? '' : ',null') + "," + bind$$1;
	  }
	  return res + ')'
	}
	
	// componentName is el.component, take it as argument to shun flow's pessimistic refinement
	function genComponent (
	  componentName,
	  el,
	  state
	) {
	  var children = el.inlineTemplate ? null : genChildren(el, state, true);
	  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
	}
	
	function genProps (props) {
	  var res = '';
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    /* istanbul ignore if */
	    {
	      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
	    }
	  }
	  return res.slice(0, -1)
	}
	
	// #3895, #4268
	function transformSpecialNewlines (text) {
	  return text
	    .replace(/\u2028/g, '\\u2028')
	    .replace(/\u2029/g, '\\u2029')
	}
	
	/*  */
	
	// these keywords should not appear inside expressions, but operators like
	// typeof, instanceof and in are allowed
	var prohibitedKeywordRE = new RegExp('\\b' + (
	  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
	  'super,throw,while,yield,delete,export,import,return,switch,default,' +
	  'extends,finally,continue,debugger,function,arguments'
	).split(',').join('\\b|\\b') + '\\b');
	
	// these unary operators should not be used as property/method names
	var unaryOperatorsRE = new RegExp('\\b' + (
	  'delete,typeof,void'
	).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');
	
	// strip strings in expressions
	var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
	
	// detect problematic expressions in a template
	function detectErrors (ast) {
	  var errors = [];
	  if (ast) {
	    checkNode(ast, errors);
	  }
	  return errors
	}
	
	function checkNode (node, errors) {
	  if (node.type === 1) {
	    for (var name in node.attrsMap) {
	      if (dirRE.test(name)) {
	        var value = node.attrsMap[name];
	        if (value) {
	          if (name === 'v-for') {
	            checkFor(node, ("v-for=\"" + value + "\""), errors);
	          } else if (onRE.test(name)) {
	            checkEvent(value, (name + "=\"" + value + "\""), errors);
	          } else {
	            checkExpression(value, (name + "=\"" + value + "\""), errors);
	          }
	        }
	      }
	    }
	    if (node.children) {
	      for (var i = 0; i < node.children.length; i++) {
	        checkNode(node.children[i], errors);
	      }
	    }
	  } else if (node.type === 2) {
	    checkExpression(node.expression, node.text, errors);
	  }
	}
	
	function checkEvent (exp, text, errors) {
	  var stipped = exp.replace(stripStringRE, '');
	  var keywordMatch = stipped.match(unaryOperatorsRE);
	  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
	    errors.push(
	      "avoid using JavaScript unary operator as property name: " +
	      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
	    );
	  }
	  checkExpression(exp, text, errors);
	}
	
	function checkFor (node, text, errors) {
	  checkExpression(node.for || '', text, errors);
	  checkIdentifier(node.alias, 'v-for alias', text, errors);
	  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
	  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
	}
	
	function checkIdentifier (
	  ident,
	  type,
	  text,
	  errors
	) {
	  if (typeof ident === 'string') {
	    try {
	      new Function(("var " + ident + "=_"));
	    } catch (e) {
	      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
	    }
	  }
	}
	
	function checkExpression (exp, text, errors) {
	  try {
	    new Function(("return " + exp));
	  } catch (e) {
	    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
	    if (keywordMatch) {
	      errors.push(
	        "avoid using JavaScript keyword as property name: " +
	        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
	      );
	    } else {
	      errors.push(
	        "invalid expression: " + (e.message) + " in\n\n" +
	        "    " + exp + "\n\n" +
	        "  Raw expression: " + (text.trim()) + "\n"
	      );
	    }
	  }
	}
	
	/*  */
	
	function createFunction (code, errors) {
	  try {
	    return new Function(code)
	  } catch (err) {
	    errors.push({ err: err, code: code });
	    return noop
	  }
	}
	
	function createCompileToFunctionFn (compile) {
	  var cache = Object.create(null);
	
	  return function compileToFunctions (
	    template,
	    options,
	    vm
	  ) {
	    options = extend({}, options);
	    var warn$$1 = options.warn || warn;
	    delete options.warn;
	
	    /* istanbul ignore if */
	    if (false) {
	      // detect possible CSP restriction
	      try {
	        new Function('return 1');
	      } catch (e) {
	        if (e.toString().match(/unsafe-eval|CSP/)) {
	          warn$$1(
	            'It seems you are using the standalone build of Vue.js in an ' +
	            'environment with Content Security Policy that prohibits unsafe-eval. ' +
	            'The template compiler cannot work in this environment. Consider ' +
	            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
	            'templates into render functions.'
	          );
	        }
	      }
	    }
	
	    // check cache
	    var key = options.delimiters
	      ? String(options.delimiters) + template
	      : template;
	    if (cache[key]) {
	      return cache[key]
	    }
	
	    // compile
	    var compiled = compile(template, options);
	
	    // check compilation errors/tips
	    if (false) {
	      if (compiled.errors && compiled.errors.length) {
	        warn$$1(
	          "Error compiling template:\n\n" + template + "\n\n" +
	          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
	          vm
	        );
	      }
	      if (compiled.tips && compiled.tips.length) {
	        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
	      }
	    }
	
	    // turn code into functions
	    var res = {};
	    var fnGenErrors = [];
	    res.render = createFunction(compiled.render, fnGenErrors);
	    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
	      return createFunction(code, fnGenErrors)
	    });
	
	    // check function generation errors.
	    // this should only happen if there is a bug in the compiler itself.
	    // mostly for codegen development use
	    /* istanbul ignore if */
	    if (false) {
	      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
	        warn$$1(
	          "Failed to generate render function:\n\n" +
	          fnGenErrors.map(function (ref) {
	            var err = ref.err;
	            var code = ref.code;
	
	            return ((err.toString()) + " in\n\n" + code + "\n");
	        }).join('\n'),
	          vm
	        );
	      }
	    }
	
	    return (cache[key] = res)
	  }
	}
	
	/*  */
	
	function createCompilerCreator (baseCompile) {
	  return function createCompiler (baseOptions) {
	    function compile (
	      template,
	      options
	    ) {
	      var finalOptions = Object.create(baseOptions);
	      var errors = [];
	      var tips = [];
	      finalOptions.warn = function (msg, tip) {
	        (tip ? tips : errors).push(msg);
	      };
	
	      if (options) {
	        // merge custom modules
	        if (options.modules) {
	          finalOptions.modules =
	            (baseOptions.modules || []).concat(options.modules);
	        }
	        // merge custom directives
	        if (options.directives) {
	          finalOptions.directives = extend(
	            Object.create(baseOptions.directives || null),
	            options.directives
	          );
	        }
	        // copy other options
	        for (var key in options) {
	          if (key !== 'modules' && key !== 'directives') {
	            finalOptions[key] = options[key];
	          }
	        }
	      }
	
	      var compiled = baseCompile(template, finalOptions);
	      if (false) {
	        errors.push.apply(errors, detectErrors(compiled.ast));
	      }
	      compiled.errors = errors;
	      compiled.tips = tips;
	      return compiled
	    }
	
	    return {
	      compile: compile,
	      compileToFunctions: createCompileToFunctionFn(compile)
	    }
	  }
	}
	
	/*  */
	
	// `createCompilerCreator` allows creating compilers that use alternative
	// parser/optimizer/codegen, e.g the SSR optimizing compiler.
	// Here we just export a default compiler using the default parts.
	var createCompiler = createCompilerCreator(function baseCompile (
	  template,
	  options
	) {
	  var ast = parse(template.trim(), options);
	  if (options.optimize !== false) {
	    optimize(ast, options);
	  }
	  var code = generate(ast, options);
	  return {
	    ast: ast,
	    render: code.render,
	    staticRenderFns: code.staticRenderFns
	  }
	});
	
	/*  */
	
	var ref$1 = createCompiler(baseOptions);
	var compileToFunctions = ref$1.compileToFunctions;
	
	/*  */
	
	// check whether current browser encodes a char inside attribute values
	var div;
	function getShouldDecode (href) {
	  div = div || document.createElement('div');
	  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
	  return div.innerHTML.indexOf('&#10;') > 0
	}
	
	// #3663: IE encodes newlines inside attribute values while other browsers don't
	var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
	// #6828: chrome encodes content in a[href]
	var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;
	
	/*  */
	
	var idToTemplate = cached(function (id) {
	  var el = query(id);
	  return el && el.innerHTML
	});
	
	var mount = Vue.prototype.$mount;
	Vue.prototype.$mount = function (
	  el,
	  hydrating
	) {
	  el = el && query(el);
	
	  /* istanbul ignore if */
	  if (el === document.body || el === document.documentElement) {
	    ("production") !== 'production' && warn(
	      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
	    );
	    return this
	  }
	
	  var options = this.$options;
	  // resolve template/el and convert to render function
	  if (!options.render) {
	    var template = options.template;
	    if (template) {
	      if (typeof template === 'string') {
	        if (template.charAt(0) === '#') {
	          template = idToTemplate(template);
	          /* istanbul ignore if */
	          if (false) {
	            warn(
	              ("Template element not found or is empty: " + (options.template)),
	              this
	            );
	          }
	        }
	      } else if (template.nodeType) {
	        template = template.innerHTML;
	      } else {
	        if (false) {
	          warn('invalid template option:' + template, this);
	        }
	        return this
	      }
	    } else if (el) {
	      template = getOuterHTML(el);
	    }
	    if (template) {
	      /* istanbul ignore if */
	      if (false) {
	        mark('compile');
	      }
	
	      var ref = compileToFunctions(template, {
	        shouldDecodeNewlines: shouldDecodeNewlines,
	        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
	        delimiters: options.delimiters,
	        comments: options.comments
	      }, this);
	      var render = ref.render;
	      var staticRenderFns = ref.staticRenderFns;
	      options.render = render;
	      options.staticRenderFns = staticRenderFns;
	
	      /* istanbul ignore if */
	      if (false) {
	        mark('compile end');
	        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
	      }
	    }
	  }
	  return mount.call(this, el, hydrating)
	};
	
	/**
	 * Get outerHTML of elements, taking care
	 * of SVG elements in IE as well.
	 */
	function getOuterHTML (el) {
	  if (el.outerHTML) {
	    return el.outerHTML
	  } else {
	    var container = document.createElement('div');
	    container.appendChild(el.cloneNode(true));
	    return container.innerHTML
	  }
	}
	
	Vue.compile = compileToFunctions;
	
	module.exports = Vue;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(86).setImmediate))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * vuex v3.0.1
	 * (c) 2017 Evan You
	 * @license MIT
	 */
	'use strict';
	
	var applyMixin = function (Vue) {
	  var version = Number(Vue.version.split('.')[0]);
	
	  if (version >= 2) {
	    Vue.mixin({ beforeCreate: vuexInit });
	  } else {
	    // override init and inject vuex init procedure
	    // for 1.x backwards compatibility.
	    var _init = Vue.prototype._init;
	    Vue.prototype._init = function (options) {
	      if ( options === void 0 ) options = {};
	
	      options.init = options.init
	        ? [vuexInit].concat(options.init)
	        : vuexInit;
	      _init.call(this, options);
	    };
	  }
	
	  /**
	   * Vuex init hook, injected into each instances init hooks list.
	   */
	
	  function vuexInit () {
	    var options = this.$options;
	    // store injection
	    if (options.store) {
	      this.$store = typeof options.store === 'function'
	        ? options.store()
	        : options.store;
	    } else if (options.parent && options.parent.$store) {
	      this.$store = options.parent.$store;
	    }
	  }
	};
	
	var devtoolHook =
	  typeof window !== 'undefined' &&
	  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
	
	function devtoolPlugin (store) {
	  if (!devtoolHook) { return }
	
	  store._devtoolHook = devtoolHook;
	
	  devtoolHook.emit('vuex:init', store);
	
	  devtoolHook.on('vuex:travel-to-state', function (targetState) {
	    store.replaceState(targetState);
	  });
	
	  store.subscribe(function (mutation, state) {
	    devtoolHook.emit('vuex:mutation', mutation, state);
	  });
	}
	
	/**
	 * Get the first item that pass the test
	 * by second argument function
	 *
	 * @param {Array} list
	 * @param {Function} f
	 * @return {*}
	 */
	/**
	 * Deep copy the given object considering circular structure.
	 * This function caches all nested objects and its copies.
	 * If it detects circular structure, use cached copy to avoid infinite loop.
	 *
	 * @param {*} obj
	 * @param {Array<Object>} cache
	 * @return {*}
	 */
	
	
	/**
	 * forEach for object
	 */
	function forEachValue (obj, fn) {
	  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
	}
	
	function isObject (obj) {
	  return obj !== null && typeof obj === 'object'
	}
	
	function isPromise (val) {
	  return val && typeof val.then === 'function'
	}
	
	function assert (condition, msg) {
	  if (!condition) { throw new Error(("[vuex] " + msg)) }
	}
	
	var Module = function Module (rawModule, runtime) {
	  this.runtime = runtime;
	  this._children = Object.create(null);
	  this._rawModule = rawModule;
	  var rawState = rawModule.state;
	  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
	};
	
	var prototypeAccessors$1 = { namespaced: { configurable: true } };
	
	prototypeAccessors$1.namespaced.get = function () {
	  return !!this._rawModule.namespaced
	};
	
	Module.prototype.addChild = function addChild (key, module) {
	  this._children[key] = module;
	};
	
	Module.prototype.removeChild = function removeChild (key) {
	  delete this._children[key];
	};
	
	Module.prototype.getChild = function getChild (key) {
	  return this._children[key]
	};
	
	Module.prototype.update = function update (rawModule) {
	  this._rawModule.namespaced = rawModule.namespaced;
	  if (rawModule.actions) {
	    this._rawModule.actions = rawModule.actions;
	  }
	  if (rawModule.mutations) {
	    this._rawModule.mutations = rawModule.mutations;
	  }
	  if (rawModule.getters) {
	    this._rawModule.getters = rawModule.getters;
	  }
	};
	
	Module.prototype.forEachChild = function forEachChild (fn) {
	  forEachValue(this._children, fn);
	};
	
	Module.prototype.forEachGetter = function forEachGetter (fn) {
	  if (this._rawModule.getters) {
	    forEachValue(this._rawModule.getters, fn);
	  }
	};
	
	Module.prototype.forEachAction = function forEachAction (fn) {
	  if (this._rawModule.actions) {
	    forEachValue(this._rawModule.actions, fn);
	  }
	};
	
	Module.prototype.forEachMutation = function forEachMutation (fn) {
	  if (this._rawModule.mutations) {
	    forEachValue(this._rawModule.mutations, fn);
	  }
	};
	
	Object.defineProperties( Module.prototype, prototypeAccessors$1 );
	
	var ModuleCollection = function ModuleCollection (rawRootModule) {
	  // register root module (Vuex.Store options)
	  this.register([], rawRootModule, false);
	};
	
	ModuleCollection.prototype.get = function get (path) {
	  return path.reduce(function (module, key) {
	    return module.getChild(key)
	  }, this.root)
	};
	
	ModuleCollection.prototype.getNamespace = function getNamespace (path) {
	  var module = this.root;
	  return path.reduce(function (namespace, key) {
	    module = module.getChild(key);
	    return namespace + (module.namespaced ? key + '/' : '')
	  }, '')
	};
	
	ModuleCollection.prototype.update = function update$1 (rawRootModule) {
	  update([], this.root, rawRootModule);
	};
	
	ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
	    var this$1 = this;
	    if ( runtime === void 0 ) runtime = true;
	
	  if (false) {
	    assertRawModule(path, rawModule);
	  }
	
	  var newModule = new Module(rawModule, runtime);
	  if (path.length === 0) {
	    this.root = newModule;
	  } else {
	    var parent = this.get(path.slice(0, -1));
	    parent.addChild(path[path.length - 1], newModule);
	  }
	
	  // register nested modules
	  if (rawModule.modules) {
	    forEachValue(rawModule.modules, function (rawChildModule, key) {
	      this$1.register(path.concat(key), rawChildModule, runtime);
	    });
	  }
	};
	
	ModuleCollection.prototype.unregister = function unregister (path) {
	  var parent = this.get(path.slice(0, -1));
	  var key = path[path.length - 1];
	  if (!parent.getChild(key).runtime) { return }
	
	  parent.removeChild(key);
	};
	
	function update (path, targetModule, newModule) {
	  if (false) {
	    assertRawModule(path, newModule);
	  }
	
	  // update target module
	  targetModule.update(newModule);
	
	  // update nested modules
	  if (newModule.modules) {
	    for (var key in newModule.modules) {
	      if (!targetModule.getChild(key)) {
	        if (false) {
	          console.warn(
	            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
	            'manual reload is needed'
	          );
	        }
	        return
	      }
	      update(
	        path.concat(key),
	        targetModule.getChild(key),
	        newModule.modules[key]
	      );
	    }
	  }
	}
	
	var functionAssert = {
	  assert: function (value) { return typeof value === 'function'; },
	  expected: 'function'
	};
	
	var objectAssert = {
	  assert: function (value) { return typeof value === 'function' ||
	    (typeof value === 'object' && typeof value.handler === 'function'); },
	  expected: 'function or object with "handler" function'
	};
	
	var assertTypes = {
	  getters: functionAssert,
	  mutations: functionAssert,
	  actions: objectAssert
	};
	
	function assertRawModule (path, rawModule) {
	  Object.keys(assertTypes).forEach(function (key) {
	    if (!rawModule[key]) { return }
	
	    var assertOptions = assertTypes[key];
	
	    forEachValue(rawModule[key], function (value, type) {
	      assert(
	        assertOptions.assert(value),
	        makeAssertionMessage(path, key, type, value, assertOptions.expected)
	      );
	    });
	  });
	}
	
	function makeAssertionMessage (path, key, type, value, expected) {
	  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
	  if (path.length > 0) {
	    buf += " in module \"" + (path.join('.')) + "\"";
	  }
	  buf += " is " + (JSON.stringify(value)) + ".";
	  return buf
	}
	
	var Vue; // bind on install
	
	var Store = function Store (options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = {};
	
	  // Auto install if it is not done yet and `window` has `Vue`.
	  // To allow users to avoid auto-installation in some cases,
	  // this code should be placed here. See #731
	  if (!Vue && typeof window !== 'undefined' && window.Vue) {
	    install(window.Vue);
	  }
	
	  if (false) {
	    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
	    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
	    assert(this instanceof Store, "Store must be called with the new operator.");
	  }
	
	  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
	  var strict = options.strict; if ( strict === void 0 ) strict = false;
	
	  var state = options.state; if ( state === void 0 ) state = {};
	  if (typeof state === 'function') {
	    state = state() || {};
	  }
	
	  // store internal state
	  this._committing = false;
	  this._actions = Object.create(null);
	  this._actionSubscribers = [];
	  this._mutations = Object.create(null);
	  this._wrappedGetters = Object.create(null);
	  this._modules = new ModuleCollection(options);
	  this._modulesNamespaceMap = Object.create(null);
	  this._subscribers = [];
	  this._watcherVM = new Vue();
	
	  // bind commit and dispatch to self
	  var store = this;
	  var ref = this;
	  var dispatch = ref.dispatch;
	  var commit = ref.commit;
	  this.dispatch = function boundDispatch (type, payload) {
	    return dispatch.call(store, type, payload)
	  };
	  this.commit = function boundCommit (type, payload, options) {
	    return commit.call(store, type, payload, options)
	  };
	
	  // strict mode
	  this.strict = strict;
	
	  // init root module.
	  // this also recursively registers all sub-modules
	  // and collects all module getters inside this._wrappedGetters
	  installModule(this, state, [], this._modules.root);
	
	  // initialize the store vm, which is responsible for the reactivity
	  // (also registers _wrappedGetters as computed properties)
	  resetStoreVM(this, state);
	
	  // apply plugins
	  plugins.forEach(function (plugin) { return plugin(this$1); });
	
	  if (Vue.config.devtools) {
	    devtoolPlugin(this);
	  }
	};
	
	var prototypeAccessors = { state: { configurable: true } };
	
	prototypeAccessors.state.get = function () {
	  return this._vm._data.$$state
	};
	
	prototypeAccessors.state.set = function (v) {
	  if (false) {
	    assert(false, "Use store.replaceState() to explicit replace store state.");
	  }
	};
	
	Store.prototype.commit = function commit (_type, _payload, _options) {
	    var this$1 = this;
	
	  // check object-style commit
	  var ref = unifyObjectStyle(_type, _payload, _options);
	    var type = ref.type;
	    var payload = ref.payload;
	    var options = ref.options;
	
	  var mutation = { type: type, payload: payload };
	  var entry = this._mutations[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown mutation type: " + type));
	    }
	    return
	  }
	  this._withCommit(function () {
	    entry.forEach(function commitIterator (handler) {
	      handler(payload);
	    });
	  });
	  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });
	
	  if (
	    false
	  ) {
	    console.warn(
	      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
	      'Use the filter functionality in the vue-devtools'
	    );
	  }
	};
	
	Store.prototype.dispatch = function dispatch (_type, _payload) {
	    var this$1 = this;
	
	  // check object-style dispatch
	  var ref = unifyObjectStyle(_type, _payload);
	    var type = ref.type;
	    var payload = ref.payload;
	
	  var action = { type: type, payload: payload };
	  var entry = this._actions[type];
	  if (!entry) {
	    if (false) {
	      console.error(("[vuex] unknown action type: " + type));
	    }
	    return
	  }
	
	  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });
	
	  return entry.length > 1
	    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
	    : entry[0](payload)
	};
	
	Store.prototype.subscribe = function subscribe (fn) {
	  return genericSubscribe(fn, this._subscribers)
	};
	
	Store.prototype.subscribeAction = function subscribeAction (fn) {
	  return genericSubscribe(fn, this._actionSubscribers)
	};
	
	Store.prototype.watch = function watch (getter, cb, options) {
	    var this$1 = this;
	
	  if (false) {
	    assert(typeof getter === 'function', "store.watch only accepts a function.");
	  }
	  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
	};
	
	Store.prototype.replaceState = function replaceState (state) {
	    var this$1 = this;
	
	  this._withCommit(function () {
	    this$1._vm._data.$$state = state;
	  });
	};
	
	Store.prototype.registerModule = function registerModule (path, rawModule, options) {
	    if ( options === void 0 ) options = {};
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	    assert(path.length > 0, 'cannot register the root module by using registerModule.');
	  }
	
	  this._modules.register(path, rawModule);
	  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
	  // reset store to update getters...
	  resetStoreVM(this, this.state);
	};
	
	Store.prototype.unregisterModule = function unregisterModule (path) {
	    var this$1 = this;
	
	  if (typeof path === 'string') { path = [path]; }
	
	  if (false) {
	    assert(Array.isArray(path), "module path must be a string or an Array.");
	  }
	
	  this._modules.unregister(path);
	  this._withCommit(function () {
	    var parentState = getNestedState(this$1.state, path.slice(0, -1));
	    Vue.delete(parentState, path[path.length - 1]);
	  });
	  resetStore(this);
	};
	
	Store.prototype.hotUpdate = function hotUpdate (newOptions) {
	  this._modules.update(newOptions);
	  resetStore(this, true);
	};
	
	Store.prototype._withCommit = function _withCommit (fn) {
	  var committing = this._committing;
	  this._committing = true;
	  fn();
	  this._committing = committing;
	};
	
	Object.defineProperties( Store.prototype, prototypeAccessors );
	
	function genericSubscribe (fn, subs) {
	  if (subs.indexOf(fn) < 0) {
	    subs.push(fn);
	  }
	  return function () {
	    var i = subs.indexOf(fn);
	    if (i > -1) {
	      subs.splice(i, 1);
	    }
	  }
	}
	
	function resetStore (store, hot) {
	  store._actions = Object.create(null);
	  store._mutations = Object.create(null);
	  store._wrappedGetters = Object.create(null);
	  store._modulesNamespaceMap = Object.create(null);
	  var state = store.state;
	  // init all modules
	  installModule(store, state, [], store._modules.root, true);
	  // reset vm
	  resetStoreVM(store, state, hot);
	}
	
	function resetStoreVM (store, state, hot) {
	  var oldVm = store._vm;
	
	  // bind store public getters
	  store.getters = {};
	  var wrappedGetters = store._wrappedGetters;
	  var computed = {};
	  forEachValue(wrappedGetters, function (fn, key) {
	    // use computed to leverage its lazy-caching mechanism
	    computed[key] = function () { return fn(store); };
	    Object.defineProperty(store.getters, key, {
	      get: function () { return store._vm[key]; },
	      enumerable: true // for local getters
	    });
	  });
	
	  // use a Vue instance to store the state tree
	  // suppress warnings just in case the user has added
	  // some funky global mixins
	  var silent = Vue.config.silent;
	  Vue.config.silent = true;
	  store._vm = new Vue({
	    data: {
	      $$state: state
	    },
	    computed: computed
	  });
	  Vue.config.silent = silent;
	
	  // enable strict mode for new vm
	  if (store.strict) {
	    enableStrictMode(store);
	  }
	
	  if (oldVm) {
	    if (hot) {
	      // dispatch changes in all subscribed watchers
	      // to force getter re-evaluation for hot reloading.
	      store._withCommit(function () {
	        oldVm._data.$$state = null;
	      });
	    }
	    Vue.nextTick(function () { return oldVm.$destroy(); });
	  }
	}
	
	function installModule (store, rootState, path, module, hot) {
	  var isRoot = !path.length;
	  var namespace = store._modules.getNamespace(path);
	
	  // register in namespace map
	  if (module.namespaced) {
	    store._modulesNamespaceMap[namespace] = module;
	  }
	
	  // set state
	  if (!isRoot && !hot) {
	    var parentState = getNestedState(rootState, path.slice(0, -1));
	    var moduleName = path[path.length - 1];
	    store._withCommit(function () {
	      Vue.set(parentState, moduleName, module.state);
	    });
	  }
	
	  var local = module.context = makeLocalContext(store, namespace, path);
	
	  module.forEachMutation(function (mutation, key) {
	    var namespacedType = namespace + key;
	    registerMutation(store, namespacedType, mutation, local);
	  });
	
	  module.forEachAction(function (action, key) {
	    var type = action.root ? key : namespace + key;
	    var handler = action.handler || action;
	    registerAction(store, type, handler, local);
	  });
	
	  module.forEachGetter(function (getter, key) {
	    var namespacedType = namespace + key;
	    registerGetter(store, namespacedType, getter, local);
	  });
	
	  module.forEachChild(function (child, key) {
	    installModule(store, rootState, path.concat(key), child, hot);
	  });
	}
	
	/**
	 * make localized dispatch, commit, getters and state
	 * if there is no namespace, just use root ones
	 */
	function makeLocalContext (store, namespace, path) {
	  var noNamespace = namespace === '';
	
	  var local = {
	    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      return store.dispatch(type, payload)
	    },
	
	    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
	      var args = unifyObjectStyle(_type, _payload, _options);
	      var payload = args.payload;
	      var options = args.options;
	      var type = args.type;
	
	      if (!options || !options.root) {
	        type = namespace + type;
	        if (false) {
	          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
	          return
	        }
	      }
	
	      store.commit(type, payload, options);
	    }
	  };
	
	  // getters and state object must be gotten lazily
	  // because they will be changed by vm update
	  Object.defineProperties(local, {
	    getters: {
	      get: noNamespace
	        ? function () { return store.getters; }
	        : function () { return makeLocalGetters(store, namespace); }
	    },
	    state: {
	      get: function () { return getNestedState(store.state, path); }
	    }
	  });
	
	  return local
	}
	
	function makeLocalGetters (store, namespace) {
	  var gettersProxy = {};
	
	  var splitPos = namespace.length;
	  Object.keys(store.getters).forEach(function (type) {
	    // skip if the target getter is not match this namespace
	    if (type.slice(0, splitPos) !== namespace) { return }
	
	    // extract local getter type
	    var localType = type.slice(splitPos);
	
	    // Add a port to the getters proxy.
	    // Define as getter property because
	    // we do not want to evaluate the getters in this time.
	    Object.defineProperty(gettersProxy, localType, {
	      get: function () { return store.getters[type]; },
	      enumerable: true
	    });
	  });
	
	  return gettersProxy
	}
	
	function registerMutation (store, type, handler, local) {
	  var entry = store._mutations[type] || (store._mutations[type] = []);
	  entry.push(function wrappedMutationHandler (payload) {
	    handler.call(store, local.state, payload);
	  });
	}
	
	function registerAction (store, type, handler, local) {
	  var entry = store._actions[type] || (store._actions[type] = []);
	  entry.push(function wrappedActionHandler (payload, cb) {
	    var res = handler.call(store, {
	      dispatch: local.dispatch,
	      commit: local.commit,
	      getters: local.getters,
	      state: local.state,
	      rootGetters: store.getters,
	      rootState: store.state
	    }, payload, cb);
	    if (!isPromise(res)) {
	      res = Promise.resolve(res);
	    }
	    if (store._devtoolHook) {
	      return res.catch(function (err) {
	        store._devtoolHook.emit('vuex:error', err);
	        throw err
	      })
	    } else {
	      return res
	    }
	  });
	}
	
	function registerGetter (store, type, rawGetter, local) {
	  if (store._wrappedGetters[type]) {
	    if (false) {
	      console.error(("[vuex] duplicate getter key: " + type));
	    }
	    return
	  }
	  store._wrappedGetters[type] = function wrappedGetter (store) {
	    return rawGetter(
	      local.state, // local state
	      local.getters, // local getters
	      store.state, // root state
	      store.getters // root getters
	    )
	  };
	}
	
	function enableStrictMode (store) {
	  store._vm.$watch(function () { return this._data.$$state }, function () {
	    if (false) {
	      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
	    }
	  }, { deep: true, sync: true });
	}
	
	function getNestedState (state, path) {
	  return path.length
	    ? path.reduce(function (state, key) { return state[key]; }, state)
	    : state
	}
	
	function unifyObjectStyle (type, payload, options) {
	  if (isObject(type) && type.type) {
	    options = payload;
	    payload = type;
	    type = type.type;
	  }
	
	  if (false) {
	    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
	  }
	
	  return { type: type, payload: payload, options: options }
	}
	
	function install (_Vue) {
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      console.error(
	        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
	      );
	    }
	    return
	  }
	  Vue = _Vue;
	  applyMixin(Vue);
	}
	
	var mapState = normalizeNamespace(function (namespace, states) {
	  var res = {};
	  normalizeMap(states).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedState () {
	      var state = this.$store.state;
	      var getters = this.$store.getters;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
	        if (!module) {
	          return
	        }
	        state = module.context.state;
	        getters = module.context.getters;
	      }
	      return typeof val === 'function'
	        ? val.call(this, state, getters)
	        : state[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapMutations = normalizeNamespace(function (namespace, mutations) {
	  var res = {};
	  normalizeMap(mutations).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedMutation () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var commit = this.$store.commit;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
	        if (!module) {
	          return
	        }
	        commit = module.context.commit;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [commit].concat(args))
	        : commit.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var mapGetters = normalizeNamespace(function (namespace, getters) {
	  var res = {};
	  normalizeMap(getters).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    val = namespace + val;
	    res[key] = function mappedGetter () {
	      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
	        return
	      }
	      if (false) {
	        console.error(("[vuex] unknown getter: " + val));
	        return
	      }
	      return this.$store.getters[val]
	    };
	    // mark vuex getter for devtools
	    res[key].vuex = true;
	  });
	  return res
	});
	
	var mapActions = normalizeNamespace(function (namespace, actions) {
	  var res = {};
	  normalizeMap(actions).forEach(function (ref) {
	    var key = ref.key;
	    var val = ref.val;
	
	    res[key] = function mappedAction () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	      var dispatch = this.$store.dispatch;
	      if (namespace) {
	        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
	        if (!module) {
	          return
	        }
	        dispatch = module.context.dispatch;
	      }
	      return typeof val === 'function'
	        ? val.apply(this, [dispatch].concat(args))
	        : dispatch.apply(this.$store, [val].concat(args))
	    };
	  });
	  return res
	});
	
	var createNamespacedHelpers = function (namespace) { return ({
	  mapState: mapState.bind(null, namespace),
	  mapGetters: mapGetters.bind(null, namespace),
	  mapMutations: mapMutations.bind(null, namespace),
	  mapActions: mapActions.bind(null, namespace)
	}); };
	
	function normalizeMap (map) {
	  return Array.isArray(map)
	    ? map.map(function (key) { return ({ key: key, val: key }); })
	    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
	}
	
	function normalizeNamespace (fn) {
	  return function (namespace, map) {
	    if (typeof namespace !== 'string') {
	      map = namespace;
	      namespace = '';
	    } else if (namespace.charAt(namespace.length - 1) !== '/') {
	      namespace += '/';
	    }
	    return fn(namespace, map)
	  }
	}
	
	function getModuleByNamespace (store, helper, namespace) {
	  var module = store._modulesNamespaceMap[namespace];
	  if (false) {
	    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
	  }
	  return module
	}
	
	var index = {
	  Store: Store,
	  install: install,
	  version: '3.0.1',
	  mapState: mapState,
	  mapMutations: mapMutations,
	  mapGetters: mapGetters,
	  mapActions: mapActions,
	  createNamespacedHelpers: createNamespacedHelpers
	};
	
	module.exports = index;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	var settle = __webpack_require__(33);
	var buildURL = __webpack_require__(36);
	var parseHeaders = __webpack_require__(42);
	var isURLSameOrigin = __webpack_require__(40);
	var createError = __webpack_require__(14);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(35);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(38);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(32);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.4' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(60);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(19);
	var defined = __webpack_require__(17);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.VueRecaptcha = factory());
	}(this, (function () { 'use strict';
	
	  var defer = function defer() {
	    var state = false; // Resolved or not
	    var callbacks = [];
	    var resolve = function resolve(val) {
	      if (state) {
	        return;
	      }
	
	      state = true;
	      for (var i = 0, len = callbacks.length; i < len; i++) {
	        callbacks[i](val);
	      }
	    };
	
	    var then = function then(cb) {
	      if (!state) {
	        callbacks.push(cb);
	        return;
	      }
	      cb();
	    };
	
	    var deferred = {
	      resolved: function resolved() {
	        return state;
	      },
	
	      resolve: resolve,
	      promise: {
	        then: then
	      }
	    };
	    return deferred;
	  };
	
	  function createRecaptcha() {
	    var deferred = defer();
	
	    return {
	      notify: function notify() {
	        deferred.resolve();
	      },
	      wait: function wait() {
	        return deferred.promise;
	      },
	      render: function render(ele, options, cb) {
	        this.wait().then(function () {
	          cb(window.grecaptcha.render(ele, options));
	        });
	      },
	      reset: function reset(widgetId) {
	        if (typeof widgetId === 'undefined') {
	          return;
	        }
	
	        this.assertLoaded();
	        this.wait().then(function () {
	          return window.grecaptcha.reset(widgetId);
	        });
	      },
	      execute: function execute(widgetId) {
	        if (typeof widgetId === 'undefined') {
	          return;
	        }
	
	        this.assertLoaded();
	        this.wait().then(function () {
	          return window.grecaptcha.execute(widgetId);
	        });
	      },
	      checkRecaptchaLoad: function checkRecaptchaLoad() {
	        if (window.hasOwnProperty('grecaptcha') && window.grecaptcha.hasOwnProperty('render')) {
	          this.notify();
	        }
	      },
	      assertLoaded: function assertLoaded() {
	        if (!deferred.resolved()) {
	          throw new Error('ReCAPTCHA has not been loaded');
	        }
	      }
	    };
	  }
	
	  var recaptcha = createRecaptcha();
	
	  if (typeof window !== 'undefined') {
	    window.vueRecaptchaApiLoaded = recaptcha.notify;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  var VueRecaptcha = {
	    name: 'VueRecaptcha',
	    props: {
	      sitekey: {
	        type: String,
	        required: true
	      },
	      theme: {
	        type: String
	      },
	      badge: {
	        type: String
	      },
	      type: {
	        type: String
	      },
	      size: {
	        type: String
	      },
	      tabindex: {
	        type: String
	      }
	    },
	    mounted: function mounted() {
	      var _this = this;
	
	      recaptcha.checkRecaptchaLoad();
	      var opts = _extends({}, this.$props, {
	        callback: this.emitVerify,
	        'expired-callback': this.emitExpired
	      });
	      var container = this.$slots.default ? this.$el.children[0] : this.$el;
	      recaptcha.render(container, opts, function (id) {
	        _this.$widgetId = id;
	        _this.$emit('render', id);
	      });
	    },
	
	    methods: {
	      reset: function reset() {
	        recaptcha.reset(this.$widgetId);
	      },
	      execute: function execute() {
	        recaptcha.execute(this.$widgetId);
	      },
	      emitVerify: function emitVerify(response) {
	        this.$emit('verify', response);
	      },
	      emitExpired: function emitExpired() {
	        this.$emit('expired');
	      }
	    },
	    render: function render(h) {
	      return h('div', {}, this.$slots.default);
	    }
	  };
	
	  return VueRecaptcha;
	
	})));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.5.1
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0, result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p = Promise$1.prototype;
	
	p.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p$1 = PromiseObj.prototype;
	
	p$1.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p$1.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p$1.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p$1.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return Promise.reject(reason);
	    }
	    );
	};
	
	/**
	 * Utility functions.
	 */
	
	var ref = {};
	var hasOwnProperty = ref.hasOwnProperty;
	var ref$1 = [];
	var slice = ref$1.slice;
	var debug = false, ntick;
	
	var inBrowser = typeof window !== 'undefined';
	
	function Util (ref) {
	    var config = ref.config;
	    var nextTick = ref.nextTick;
	
	    ntick = nextTick;
	    debug = config.debug || !config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return ntick(cb, ctx);
	}
	
	function trim(str) {
	    return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	
	function trimEnd(str, chars) {
	
	    if (str && chars === undefined) {
	        return str.replace(/\s+$/, '');
	    }
	
	    if (!str || !chars) {
	        return str;
	    }
	
	    return str.replace(new RegExp(("[" + chars + "]+$")), '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (isArray(obj)) {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (hasOwnProperty.call(obj, key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	function root (options$$1, next) {
	
	    var url = next(options$$1);
	
	    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	        url = trimEnd(options$$1.root, '/') + '/' + url;
	    }
	
	    return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	
	function query (options$$1, next) {
	
	    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);
	
	    each(options$$1.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url), expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];
	
	    return {
	        vars: variables,
	        expand: function expand(context) {
	            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null, values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key], result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	function template (options) {
	
	    var variables = [], url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	function Url(url, params) {
	
	    var self = this || {}, options$$1 = url, transform;
	
	    if (isString(url)) {
	        options$$1 = {url: url, params: params};
	    }
	
	    options$$1 = merge({}, Url.options, self.$options, options$$1);
	
	    Url.transforms.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Url.transform[handler];
	        }
	
	        if (isFunction(handler)) {
	            transform = factory(handler, transform, self.$vm);
	        }
	
	    });
	
	    return transform(options$$1);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transform = {template: template, query: query, root: root};
	Url.transforms = ['template', 'query', 'root'];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [], escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    var el = document.createElement('a');
	
	    if (document.documentMode) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options$$1) {
	        return handler.call(vm, options$$1, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj), plain = isPlainObject(obj), hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	function xdrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(), handler = function (ref) {
	                var type = ref.type;
	
	
	                var status = 0;
	
	                if (type === 'load') {
	                    status = 200;
	                } else if (type === 'error') {
	                    status = 500;
	                }
	
	                resolve(request.respondWith(xdr.responseText, {status: status}));
	            };
	
	        request.abort = function () { return xdr.abort(); };
	
	        xdr.open(request.method, request.getUrl());
	
	        if (request.timeout) {
	            xdr.timeout = request.timeout;
	        }
	
	        xdr.onload = handler;
	        xdr.onabort = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	/**
	 * CORS Interceptor.
	 */
	
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	
	function cors (request) {
	
	    if (inBrowser) {
	
	        var orgUrl = Url.parse(location.href);
	        var reqUrl = Url.parse(request.getUrl());
	
	        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	
	            request.crossOrigin = true;
	            request.emulateHTTP = false;
	
	            if (!SUPPORTS_CORS) {
	                request.client = xdrClient;
	            }
	        }
	    }
	
	}
	
	/**
	 * Form data Interceptor.
	 */
	
	function form (request) {
	
	    if (isFormData(request.body)) {
	        request.headers.delete('Content-Type');
	    } else if (isObject(request.body) && request.emulateJSON) {
	        request.body = Url.params(request.body);
	        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	    }
	
	}
	
	/**
	 * JSON Interceptor.
	 */
	
	function json (request) {
	
	    var type = request.headers.get('Content-Type') || '';
	
	    if (isObject(request.body) && type.indexOf('application/json') === 0) {
	        request.body = JSON.stringify(request.body);
	    }
	
	    return function (response) {
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            var type = response.headers.get('Content-Type') || '';
	
	            if (type.indexOf('application/json') === 0 || isJson(text)) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	
	            } else {
	                response.body = text;
	            }
	
	            return response;
	
	        }) : response;
	
	    };
	}
	
	function isJson(str) {
	
	    var start = str.match(/^\s*(\[|\{)/);
	    var end = {'[': /]\s*$/, '{': /}\s*$/};
	
	    return start && end[start[1]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	
	function jsonpClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;
	
	        handler = function (ref) {
	            var type = ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            if (status && window[callback]) {
	                delete window[callback];
	                document.body.removeChild(script);
	            }
	
	            resolve(request.respondWith(body, {status: status}));
	        };
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        request.abort = function () {
	            handler({type: 'abort'});
	        };
	
	        request.params[name] = callback;
	
	        if (request.timeout) {
	            setTimeout(request.abort, request.timeout);
	        }
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	
	function jsonp (request) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	}
	
	/**
	 * Before Interceptor.
	 */
	
	function before (request) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	}
	
	/**
	 * Header Interceptor.
	 */
	
	function header (request) {
	
	    var headers = assign({}, Http.headers.common,
	        !request.crossOrigin ? Http.headers.custom : {},
	        Http.headers[toLower(request.method)]
	    );
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	}
	
	/**
	 * XMLHttp client (Browser).
	 */
	
	function xhrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(), handler = function (event) {
	
	                var response = request.respondWith(
	                'response' in xhr ? xhr.response : xhr.responseText, {
	                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	                });
	
	                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	                });
	
	                resolve(response);
	            };
	
	        request.abort = function () { return xhr.abort(); };
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if (request.timeout) {
	            xhr.timeout = request.timeout;
	        }
	
	        if (request.responseType && 'responseType' in xhr) {
	            xhr.responseType = request.responseType;
	        }
	
	        if (request.withCredentials || request.credentials) {
	            xhr.withCredentials = true;
	        }
	
	        if (!request.crossOrigin) {
	            request.headers.set('X-Requested-With', 'XMLHttpRequest');
	        }
	
	        // deprecated use downloadProgress
	        if (isFunction(request.progress) && request.method === 'GET') {
	            xhr.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.downloadProgress)) {
	            xhr.addEventListener('progress', request.downloadProgress);
	        }
	
	        // deprecated use uploadProgress
	        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
	            xhr.upload.addEventListener('progress', request.progress);
	        }
	
	        if (isFunction(request.uploadProgress) && xhr.upload) {
	            xhr.upload.addEventListener('progress', request.uploadProgress);
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.onload = handler;
	        xhr.onabort = handler;
	        xhr.onerror = handler;
	        xhr.ontimeout = handler;
	        xhr.send(request.getBody());
	    });
	}
	
	/**
	 * Http client (Node).
	 */
	
	function nodeClient (request) {
	
	    var client = __webpack_require__(102);
	
	    return new PromiseObj(function (resolve) {
	
	        var url = request.getUrl();
	        var body = request.getBody();
	        var method = request.method;
	        var headers = {}, handler;
	
	        request.headers.forEach(function (value, name) {
	            headers[name] = value;
	        });
	
	        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {
	
	            var response = request.respondWith(resp.body, {
	                status: resp.statusCode,
	                statusText: trim(resp.statusMessage)
	            });
	
	            each(resp.headers, function (value, name) {
	                response.headers.set(name, value);
	            });
	
	            resolve(response);
	
	        }, function (error$$1) { return handler(error$$1.response); });
	    });
	}
	
	/**
	 * Base client.
	 */
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest], resHandlers = [];
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        while (reqHandlers.length) {
	
	            var handler = reqHandlers.pop();
	
	            if (isFunction(handler)) {
	
	                var response = (void 0), next = (void 0);
	
	                response = handler.call(context, request, function (val) { return next = val; }) || next;
	
	                if (isObject(response)) {
	                    return new PromiseObj(function (resolve, reject) {
	
	                        resHandlers.forEach(function (handler) {
	                            response = when(response, function (response) {
	                                return handler.call(context, response) || response;
	                            }, reject);
	                        });
	
	                        when(response, resolve, reject);
	
	                    }, context);
	                }
	
	                if (isFunction(response)) {
	                    resHandlers.unshift(response);
	                }
	
	            } else {
	                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
	            }
	        }
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request) {
	
	    var client = request.client || (inBrowser ? xhrClient : nodeClient);
	
	    return client(request);
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function Headers(headers) {
	    var this$1 = this;
	
	
	    this.map = {};
	
	    each(headers, function (value, name) { return this$1.append(name, value); });
	};
	
	Headers.prototype.has = function has (name) {
	    return getName(this.map, name) !== null;
	};
	
	Headers.prototype.get = function get (name) {
	
	    var list = this.map[getName(this.map, name)];
	
	    return list ? list.join() : null;
	};
	
	Headers.prototype.getAll = function getAll (name) {
	    return this.map[getName(this.map, name)] || [];
	};
	
	Headers.prototype.set = function set (name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	};
	
	Headers.prototype.append = function append (name, value) {
	
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	        list.push(trim(value));
	    } else {
	        this.set(name, value);
	    }
	};
	
	Headers.prototype.delete = function delete$1 (name) {
	    delete this.map[getName(this.map, name)];
	};
	
	Headers.prototype.deleteAll = function deleteAll () {
	    this.map = {};
	};
	
	Headers.prototype.forEach = function forEach (callback, thisArg) {
	        var this$1 = this;
	
	    each(this.map, function (list, name) {
	        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
	    });
	};
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function Response(body, ref) {
	    var url = ref.url;
	    var headers = ref.headers;
	    var status = ref.status;
	    var statusText = ref.statusText;
	
	
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	
	        this.bodyText = body;
	
	    } else if (isBlob(body)) {
	
	        this.bodyBlob = body;
	
	        if (isBlobText(body)) {
	            this.bodyText = blobText(body);
	        }
	    }
	};
	
	Response.prototype.blob = function blob () {
	    return when(this.bodyBlob);
	};
	
	Response.prototype.text = function text () {
	    return when(this.bodyText);
	};
	
	Response.prototype.json = function json () {
	    return when(this.text(), function (text) { return JSON.parse(text); });
	};
	
	Object.defineProperty(Response.prototype, 'data', {
	
	    get: function get() {
	        return this.body;
	    },
	
	    set: function set(body) {
	        this.body = body;
	    }
	
	});
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function Request(options$$1) {
	
	    this.body = null;
	    this.params = {};
	
	    assign(this, options$$1, {
	        method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	        this.headers = new Headers(this.headers);
	    }
	};
	
	Request.prototype.getUrl = function getUrl () {
	    return Url(this);
	};
	
	Request.prototype.getBody = function getBody () {
	    return this.body;
	};
	
	Request.prototype.respondWith = function respondWith (body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
	};
	
	/**
	 * Service for sending network requests.
	 */
	
	var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
	var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};
	
	function Http(options$$1) {
	
	    var self = this || {}, client = Client(self.$vm);
	
	    defaults(options$$1 || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	
	        if (isString(handler)) {
	            handler = Http.interceptor[handler];
	        }
	
	        if (isFunction(handler)) {
	            client.use(handler);
	        }
	
	    });
	
	    return client(new Request(options$$1)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    common: COMMON_HEADERS,
	    custom: {}
	};
	
	Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
	    };
	
	});
	
	['post', 'put', 'patch'].forEach(function (method$$1) {
	
	    Http[method$$1] = function (url, body, options$$1) {
	        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
	    };
	
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options$$1) {
	
	    var self = this || {}, resource = {};
	
	    actions = assign({},
	        Resource.actions,
	        actions
	    );
	
	    each(actions, function (action, name) {
	
	        action = merge({url: url, params: assign({}, params)}, options$$1, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options$$1 = assign({}, action), params = {}, body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options$$1.body = body;
	    options$$1.params = assign({}, options$$1.params, params);
	
	    return options$$1;
	}
	
	Resource.actions = {
	
	    get: {method: 'GET'},
	    save: {method: 'POST'},
	    query: {method: 'GET'},
	    update: {method: 'PUT'},
	    remove: {method: 'DELETE'},
	    delete: {method: 'DELETE'}
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function get() {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function get() {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function get() {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function get() {
	                var this$1 = this;
	
	                return function (executor) { return new Vue.Promise(executor, this$1); };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["vue-uppy-cloudinary"]=e():t["vue-uppy-cloudinary"]=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/vue-uppy-cloudinary/dist",e(e.s=14)}([function(t,e,n){"use strict";function o(){}function r(t,e){var n,r,i,s,a=j;for(s=arguments.length;s-- >2;)A.push(arguments[s]);for(e&&null!=e.children&&(A.length||A.push(e.children),delete e.children);A.length;)if((r=A.pop())&&void 0!==r.pop)for(s=r.length;s--;)A.push(r[s]);else"boolean"==typeof r&&(r=null),(i="function"!=typeof t)&&(null==r?r="":"number"==typeof r?r=String(r):"string"!=typeof r&&(i=!1)),i&&n?a[a.length-1]+=r:a===j?a=[r]:a.push(r),n=i;var l=new o;return l.nodeName=t,l.children=a,l.attributes=null==e?void 0:e,l.key=null==e?void 0:e.key,void 0!==M.vnode&&M.vnode(l),l}function i(t,e){for(var n in e)t[n]=e[n];return t}function s(t,e){return r(t.nodeName,i(i({},t.attributes),e),arguments.length>2?[].slice.call(arguments,2):t.children)}function a(t){!t._dirty&&(t._dirty=!0)&&1==z.push(t)&&(M.debounceRendering||L)(l)}function l(){var t,e=z;for(z=[];t=e.pop();)t._dirty&&F(t)}function u(t,e,n){return"string"==typeof e||"number"==typeof e?void 0!==t.splitText:"string"==typeof e.nodeName?!t._componentConstructor&&p(t,e.nodeName):n||t._componentConstructor===e.nodeName}function p(t,e){return t.normalizedNodeName===e||t.nodeName.toLowerCase()===e.toLowerCase()}function c(t){var e=i({},t.attributes);e.children=t.children;var n=t.nodeName.defaultProps;if(void 0!==n)for(var o in n)void 0===e[o]&&(e[o]=n[o]);return e}function d(t,e){var n=e?document.createElementNS("http://www.w3.org/2000/svg",t):document.createElement(t);return n.normalizedNodeName=t,n}function f(t){var e=t.parentNode;e&&e.removeChild(t)}function h(t,e,n,o,r){if("className"===e&&(e="class"),"key"===e);else if("ref"===e)n&&n(null),o&&o(t);else if("class"!==e||r)if("style"===e){if(o&&"string"!=typeof o&&"string"!=typeof n||(t.style.cssText=o||""),o&&"object"==typeof o){if("string"!=typeof n)for(var i in n)i in o||(t.style[i]="");for(var i in o)t.style[i]="number"==typeof o[i]&&!1===I.test(i)?o[i]+"px":o[i]}}else if("dangerouslySetInnerHTML"===e)o&&(t.innerHTML=o.__html||"");else if("o"==e[0]&&"n"==e[1]){var s=e!==(e=e.replace(/Capture$/,""));e=e.toLowerCase().substring(2),o?n||t.addEventListener(e,y,s):t.removeEventListener(e,y,s),(t._listeners||(t._listeners={}))[e]=o}else if("list"!==e&&"type"!==e&&!r&&e in t)m(t,e,null==o?"":o),null!=o&&!1!==o||t.removeAttribute(e);else{var a=r&&e!==(e=e.replace(/^xlink\:?/,""));null==o||!1===o?a?t.removeAttributeNS("http://www.w3.org/1999/xlink",e.toLowerCase()):t.removeAttribute(e):"function"!=typeof o&&(a?t.setAttributeNS("http://www.w3.org/1999/xlink",e.toLowerCase(),o):t.setAttribute(e,o))}else t.className=o||""}function m(t,e,n){try{t[e]=n}catch(t){}}function y(t){return this._listeners[t.type](M.event&&M.event(t)||t)}function g(){for(var t;t=B.pop();)M.afterMount&&M.afterMount(t),t.componentDidMount&&t.componentDidMount()}function v(t,e,n,o,r,i){R++||(N=null!=r&&void 0!==r.ownerSVGElement,W=null!=t&&!("__preactattr_"in t));var s=b(t,e,n,o,i);return r&&s.parentNode!==r&&r.appendChild(s),--R||(W=!1,i||g()),s}function b(t,e,n,o,r){var i=t,s=N;if(null!=e&&"boolean"!=typeof e||(e=""),"string"==typeof e||"number"==typeof e)return t&&void 0!==t.splitText&&t.parentNode&&(!t._component||r)?t.nodeValue!=e&&(t.nodeValue=e):(i=document.createTextNode(e),t&&(t.parentNode&&t.parentNode.replaceChild(i,t),x(t,!0))),i.__preactattr_=!0,i;var a=e.nodeName;if("function"==typeof a)return O(t,e,n,o);if(N="svg"===a||"foreignObject"!==a&&N,a=String(a),(!t||!p(t,a))&&(i=d(a,N),t)){for(;t.firstChild;)i.appendChild(t.firstChild);t.parentNode&&t.parentNode.replaceChild(i,t),x(t,!0)}var l=i.firstChild,u=i.__preactattr_,c=e.children;if(null==u){u=i.__preactattr_={};for(var f=i.attributes,h=f.length;h--;)u[f[h].name]=f[h].value}return!W&&c&&1===c.length&&"string"==typeof c[0]&&null!=l&&void 0!==l.splitText&&null==l.nextSibling?l.nodeValue!=c[0]&&(l.nodeValue=c[0]):(c&&c.length||null!=l)&&w(i,c,n,o,W||null!=u.dangerouslySetInnerHTML),P(i,e.attributes,u),N=s,i}function w(t,e,n,o,r){var i,s,a,l,p,c=t.childNodes,d=[],h={},m=0,y=0,g=c.length,v=0,w=e?e.length:0;if(0!==g)for(var S=0;S<g;S++){var P=c[S],_=P.__preactattr_,C=w&&_?P._component?P._component.__key:_.key:null;null!=C?(m++,h[C]=P):(_||(void 0!==P.splitText?!r||P.nodeValue.trim():r))&&(d[v++]=P)}if(0!==w)for(var S=0;S<w;S++){l=e[S],p=null;var C=l.key;if(null!=C)m&&void 0!==h[C]&&(p=h[C],h[C]=void 0,m--);else if(!p&&y<v)for(i=y;i<v;i++)if(void 0!==d[i]&&u(s=d[i],l,r)){p=s,d[i]=void 0,i===v-1&&v--,i===y&&y++;break}p=b(p,l,n,o),a=c[S],p&&p!==t&&p!==a&&(null==a?t.appendChild(p):p===a.nextSibling?f(a):t.insertBefore(p,a))}if(m)for(var S in h)void 0!==h[S]&&x(h[S],!1);for(;y<=v;)void 0!==(p=d[v--])&&x(p,!1)}function x(t,e){var n=t._component;n?E(n):(null!=t.__preactattr_&&t.__preactattr_.ref&&t.__preactattr_.ref(null),!1!==e&&null!=t.__preactattr_||f(t),S(t))}function S(t){for(t=t.lastChild;t;){var e=t.previousSibling;x(t,!0),t=e}}function P(t,e,n){var o;for(o in n)e&&null!=e[o]||null==n[o]||h(t,o,n[o],n[o]=void 0,N);for(o in e)"children"===o||"innerHTML"===o||o in n&&e[o]===("value"===o||"checked"===o?t[o]:n[o])||h(t,o,n[o],n[o]=e[o],N)}function _(t){var e=t.constructor.name;(H[e]||(H[e]=[])).push(t)}function C(t,e,n){var o,r=H[t.name];if(t.prototype&&t.prototype.render?(o=new t(e,n),D.call(o,e,n)):(o=new D(e,n),o.constructor=t,o.render=U),r)for(var i=r.length;i--;)if(r[i].constructor===t){o.nextBase=r[i].nextBase,r.splice(i,1);break}return o}function U(t,e,n){return this.constructor(t,n)}function T(t,e,n,o,r){t._disable||(t._disable=!0,(t.__ref=e.ref)&&delete e.ref,(t.__key=e.key)&&delete e.key,!t.base||r?t.componentWillMount&&t.componentWillMount():t.componentWillReceiveProps&&t.componentWillReceiveProps(e,o),o&&o!==t.context&&(t.prevContext||(t.prevContext=t.context),t.context=o),t.prevProps||(t.prevProps=t.props),t.props=e,t._disable=!1,0!==n&&(1!==n&&!1===M.syncComponentUpdates&&t.base?a(t):F(t,1,r)),t.__ref&&t.__ref(t))}function F(t,e,n,o){if(!t._disable){var r,s,a,l=t.props,u=t.state,p=t.context,d=t.prevProps||l,f=t.prevState||u,h=t.prevContext||p,m=t.base,y=t.nextBase,b=m||y,w=t._component,S=!1;if(m&&(t.props=d,t.state=f,t.context=h,2!==e&&t.shouldComponentUpdate&&!1===t.shouldComponentUpdate(l,u,p)?S=!0:t.componentWillUpdate&&t.componentWillUpdate(l,u,p),t.props=l,t.state=u,t.context=p),t.prevProps=t.prevState=t.prevContext=t.nextBase=null,t._dirty=!1,!S){r=t.render(l,u,p),t.getChildContext&&(p=i(i({},p),t.getChildContext()));var P,_,U=r&&r.nodeName;if("function"==typeof U){var O=c(r);s=w,s&&s.constructor===U&&O.key==s.__key?T(s,O,1,p,!1):(P=s,t._component=s=C(U,O,p),s.nextBase=s.nextBase||y,s._parentComponent=t,T(s,O,0,p,!1),F(s,1,n,!0)),_=s.base}else a=b,P=w,P&&(a=t._component=null),(b||1===e)&&(a&&(a._component=null),_=v(a,r,p,n||!m,b&&b.parentNode,!0));if(b&&_!==b&&s!==w){var D=b.parentNode;D&&_!==D&&(D.replaceChild(_,b),P||(b._component=null,x(b,!1)))}if(P&&E(P),t.base=_,_&&!o){for(var k=t,A=t;A=A._parentComponent;)(k=A).base=_;_._component=k,_._componentConstructor=k.constructor}}if(!m||n?B.unshift(t):S||(t.componentDidUpdate&&t.componentDidUpdate(d,f,h),M.afterUpdate&&M.afterUpdate(t)),null!=t._renderCallbacks)for(;t._renderCallbacks.length;)t._renderCallbacks.pop().call(t);R||o||g()}}function O(t,e,n,o){for(var r=t&&t._component,i=r,s=t,a=r&&t._componentConstructor===e.nodeName,l=a,u=c(e);r&&!l&&(r=r._parentComponent);)l=r.constructor===e.nodeName;return r&&l&&(!o||r._component)?(T(r,u,3,n,o),t=r.base):(i&&!a&&(E(i),t=s=null),r=C(e.nodeName,u,n),t&&!r.nextBase&&(r.nextBase=t,s=null),T(r,u,1,n,o),t=r.base,s&&t!==s&&(s._component=null,x(s,!1))),t}function E(t){M.beforeUnmount&&M.beforeUnmount(t);var e=t.base;t._disable=!0,t.componentWillUnmount&&t.componentWillUnmount(),t.base=null;var n=t._component;n?E(n):e&&(e.__preactattr_&&e.__preactattr_.ref&&e.__preactattr_.ref(null),t.nextBase=e,f(e),_(t),S(e)),t.__ref&&t.__ref(null)}function D(t,e){this._dirty=!0,this.context=e,this.props=t,this.state=this.state||{}}function k(t,e,n){return v(n,t,{},!1,e,!1)}Object.defineProperty(e,"__esModule",{value:!0}),n.d(e,"h",function(){return r}),n.d(e,"createElement",function(){return r}),n.d(e,"cloneElement",function(){return s}),n.d(e,"Component",function(){return D}),n.d(e,"render",function(){return k}),n.d(e,"rerender",function(){return l}),n.d(e,"options",function(){return M});var M={},A=[],j=[],L="function"==typeof Promise?Promise.resolve().then.bind(Promise.resolve()):setTimeout,I=/acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,z=[],B=[],R=0,N=!1,W=!1,H={};i(D.prototype,{setState:function(t,e){var n=this.state;this.prevState||(this.prevState=i({},n)),i(n,"function"==typeof t?t(n,this.props):t),e&&(this._renderCallbacks=this._renderCallbacks||[]).push(e),a(this)},forceUpdate:function(t){t&&(this._renderCallbacks=this._renderCallbacks||[]).push(t),F(this,2)},render:function(){}});var V={h:r,createElement:r,cloneElement:s,Component:D,render:k,rerender:l,options:M};e.default=V},function(t,e,n){"use strict";function o(){return"ontouchstart"in window||navigator.maxTouchPoints}function r(t,e){return t.length>e?t.substr(0,e/2)+"..."+t.substr(t.length-e/4,t.length):t}function i(t){return{hours:Math.floor(t/3600)%24,minutes:Math.floor(t/60)%60,seconds:Math.floor(t%60)}}function s(t){return Array.prototype.slice.call(t||[],0)}function a(){var t=new Date;return l(t.getHours().toString())+":"+l(t.getMinutes().toString())+":"+l(t.getSeconds().toString())}function l(t){return 2!==t.length?0+t:t}function u(t){return["uppy",t.name?t.name.toLowerCase().replace(/[^A-Z0-9]/gi,""):"",t.type,t.data.size,t.data.lastModified].filter(function(t){return t}).join("-")}function p(t){for(var e=arguments.length,n=Array(e>1?e-1:0),o=1;o<e;o++)n[o-1]=arguments[o];var r=Promise.resolve();return t.forEach(function(t){r=r.then(function(){return t.apply(void 0,n)})}),r}function c(t){return!!t&&!!/^(jpeg|gif|png|svg|svg\+xml|bmp)$/.test(t.split("/")[1])}function d(t){return new I(function(e,n){var o=new FileReader;o.addEventListener("load",function(t){e(t.target.result)}),o.addEventListener("error",function(t){console.error("FileReader error"+t),n(t)}),o.readAsArrayBuffer(t)})}function f(t){var e={md:"text/markdown",markdown:"text/markdown",mp4:"video/mp4",mp3:"audio/mp3",svg:"image/svg+xml",jpg:"image/jpeg",png:"image/png",gif:"image/gif"},n=t.name?m(t.name).extension:null;if(t.isRemote){var o=t.type?t.type:e[n];return Promise.resolve(o)}return d(t.data.slice(0,4100)).then(function(o){var r=B(o);return r&&r.mime?r.mime:t.type?t.type:n&&e[n]?e[n]:null}).catch(function(){return null})}function h(t){return R[t]||null}function m(t){var e=/(?:\.([^.]+))?$/,n=e.exec(t)[1];return{name:t.replace("."+n,""),extension:n}}function y(t){return 0===t.indexOf("blob:")}function g(t,e){var n=t.width/t.height;return Math.round(e/n)}function v(t,e){var n=URL.createObjectURL(t.data);return new I(function(t,e){var o=new Image;o.src=n,o.onload=function(){URL.revokeObjectURL(n),t(o)},o.onerror=function(){URL.revokeObjectURL(n),e(new Error("Could not create thumbnail"))}}).then(function(t){var n=g(t,e);return x(b(t,e,n),"image/png")}).then(function(t){return URL.createObjectURL(t)})}function b(t,e,n){var o=t.width,r=t.height;if(n<t.height/2){var i=Math.floor(Math.log(t.width/e)/Math.log(2)),s=w(t,i);t=s.image,o=s.sourceWidth,r=s.sourceHeight}var a=document.createElement("canvas");return a.width=e,a.height=n,a.getContext("2d").drawImage(t,0,0,o,r,0,0,e,n),a}function w(t,e){for(var n=t,o=n.width,r=n.height,i=0;i<e;i+=1){var s=document.createElement("canvas"),a=s.getContext("2d");s.width=o/2,s.height=r/2,a.drawImage(n,0,0,o,r,0,0,o/2,r/2),o/=2,r/=2,n=s}return{image:n,sourceWidth:o,sourceHeight:r}}function x(t,e,n){return t.toBlob?new I(function(o){t.toBlob(o,e,n)}):Promise.resolve().then(function(){return S(t.toDataURL(e,n),{})})}function S(t,e,n){var o=t.split(",")[1],r=e.mimeType||t.split(",")[0].split(":")[1].split(";")[0];null==r&&(r="plain/text");for(var i=atob(o),s=[],a=0;a<i.length;a++)s.push(i.charCodeAt(a));return n?new File([new Uint8Array(s)],e.name||"",{type:r}):new Blob([new Uint8Array(s)],{type:r})}function P(t,e){return S(t,e,!0)}function _(t,e){return e=e||"Copy the URL below",new I(function(n){var o=document.createElement("textarea");o.setAttribute("style",{position:"fixed",top:0,left:0,width:"2em",height:"2em",padding:0,border:"none",outline:"none",boxShadow:"none",background:"transparent"}),o.value=t,document.body.appendChild(o),o.select();var r=function(){document.body.removeChild(o),window.prompt(e,t),n()};try{return document.execCommand("copy")?(document.body.removeChild(o),n()):r()}catch(t){return document.body.removeChild(o),r()}})}function C(t){if(!t.bytesUploaded)return 0;var e=new Date-t.uploadStarted;return t.bytesUploaded/(e/1e3)}function U(t){return t.bytesTotal-t.bytesUploaded}function T(t){if(!t.bytesUploaded)return 0;var e=C(t),n=U(t);return Math.round(n/e*10)/10}function F(t){var e=i(t),n=e.hours?e.hours+"h ":"",o=e.hours?("0"+e.minutes).substr(-2):e.minutes;return n+(o?o+"m ":"")+(o?("0"+e.seconds).substr(-2):e.seconds)+"s"}function O(t){return t&&"object"===(void 0===t?"undefined":L(t))&&t.nodeType===Node.ELEMENT_NODE}function E(t){return"string"==typeof t?document.querySelector(t):"object"===(void 0===t?"undefined":L(t))&&O(t)?t:void 0}function D(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return e.length>0?e:null}if("object"===(void 0===t?"undefined":L(t))&&O(t))return[t]}function k(t){var e=/^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/,n=e.exec(t)[1];return("https:"===location.protocol?"wss":"ws")+"://"+n}function M(t,e,n){var o=e.progress,r=e.bytesUploaded,i=e.bytesTotal;o&&(t.uppy.log("Upload progress: "+o),t.uppy.emit("upload-progress",{uploader:t,id:n.id,bytesUploaded:r,bytesTotal:i}))}function A(t){function e(t){o.push(t)}function n(t){r.push(t)}var o=[],r=[];return Promise.all(t.map(function(t){return t.then(e,n)})).then(function(){return{successful:o,failed:r}})}function j(t){function e(){n--;var t=o.shift();t&&t()}var n=0,o=[];return function(r){return function(){for(var i=arguments.length,s=Array(i),a=0;a<i;a++)s[a]=arguments[a];var l=function(){n++;var t=r.apply(void 0,s);return t.then(e,e),t};return n>=t?new I(function(t,e){o.push(function(){l().then(t,e)})}):l()}}}var L="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},I="undefined"==typeof Promise?n(9).Promise:Promise,z=n(7),B=n(47),R={"video/ogg":"ogv","audio/ogg":"ogg","video/webm":"webm","audio/webm":"webm","video/mp4":"mp4","audio/mp3":"mp3"},N=z(M,300,{leading:!0,trailing:!0});t.exports={generateFileID:u,toArray:s,getTimeStamp:a,runPromiseSequence:p,isTouchDevice:o,getFileNameAndExtension:m,truncateString:r,getFileTypeExtension:h,getFileType:f,getArrayBuffer:d,isPreviewSupported:c,isObjectURL:y,createThumbnail:v,secondsToTime:i,dataURItoBlob:S,dataURItoFile:P,canvasToBlob:x,getSpeed:C,getBytesRemaining:U,getETA:T,copyToClipboard:_,prettyETA:F,findDOMElement:E,findAllDOMElements:D,getSocketHost:k,emitSocketProgress:N,settle:A,limitPromises:j}},function(t,e,n){"use strict";function o(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"30",height:"30",viewBox:"0 0 30 30"},x("path",{d:"M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"}))}function r(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"51",height:"51",viewBox:"0 0 51 51"},x("path",{d:"M17.21 45.765a5.394 5.394 0 0 1-7.62 0l-4.12-4.122a5.393 5.393 0 0 1 0-7.618l6.774-6.775-2.404-2.404-6.775 6.776c-3.424 3.427-3.424 9 0 12.426l4.12 4.123a8.766 8.766 0 0 0 6.216 2.57c2.25 0 4.5-.858 6.214-2.57l13.55-13.552a8.72 8.72 0 0 0 2.575-6.213 8.73 8.73 0 0 0-2.575-6.213l-4.123-4.12-2.404 2.404 4.123 4.12a5.352 5.352 0 0 1 1.58 3.81c0 1.438-.562 2.79-1.58 3.808l-13.55 13.55z"}),x("path",{d:"M44.256 2.858A8.728 8.728 0 0 0 38.043.283h-.002a8.73 8.73 0 0 0-6.212 2.574l-13.55 13.55a8.725 8.725 0 0 0-2.575 6.214 8.73 8.73 0 0 0 2.574 6.216l4.12 4.12 2.405-2.403-4.12-4.12a5.357 5.357 0 0 1-1.58-3.812c0-1.437.562-2.79 1.58-3.808l13.55-13.55a5.348 5.348 0 0 1 3.81-1.58c1.44 0 2.792.562 3.81 1.58l4.12 4.12c2.1 2.1 2.1 5.518 0 7.617L39.2 23.775l2.404 2.404 6.775-6.777c3.426-3.427 3.426-9 0-12.426l-4.12-4.12z"}))}function i(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"25",height:"25",viewBox:"0 0 44 44"},x("polygon",{class:"play",transform:"translate(6, 5.5)",points:"13 21.6666667 13 11 21 16.3333333"}))}function s(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"25px",height:"25px",viewBox:"0 0 44 44"},x("g",{transform:"translate(18, 17)",class:"pause"},x("rect",{x:"0",y:"0",width:"2",height:"10",rx:"0"}),x("rect",{x:"6",y:"0",width:"2",height:"10",rx:"0"})))}function a(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"28",height:"28",viewBox:"0 0 28 28"},x("path",{d:"M25.436 2.566a7.98 7.98 0 0 0-2.078-1.51C22.638.703 21.906.5 21.198.5a3 3 0 0 0-1.023.17 2.436 2.436 0 0 0-.893.562L2.292 18.217.5 27.5l9.28-1.796 16.99-16.99c.255-.254.444-.56.562-.888a3 3 0 0 0 .17-1.023c0-.708-.205-1.44-.555-2.16a8 8 0 0 0-1.51-2.077zM9.01 24.252l-4.313.834c0-.03.008-.06.012-.09.007-.944-.74-1.715-1.67-1.723-.04 0-.078.007-.118.01l.83-4.29L17.72 5.024l5.264 5.264L9.01 24.252zm16.84-16.96a.818.818 0 0 1-.194.31l-1.57 1.57-5.26-5.26 1.57-1.57a.82.82 0 0 1 .31-.194 1.45 1.45 0 0 1 .492-.074c.397 0 .917.126 1.468.397.55.27 1.13.678 1.656 1.21.53.53.94 1.11 1.208 1.655.272.55.397 1.07.393 1.468.004.193-.027.358-.074.488z"}))}function l(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"27",height:"25",viewBox:"0 0 27 25"},x("path",{d:"M5.586 9.288a.313.313 0 0 0 .282.176h4.84v3.922c0 1.514 1.25 2.24 2.792 2.24 1.54 0 2.79-.726 2.79-2.24V9.464h4.84c.122 0 .23-.068.284-.176a.304.304 0 0 0-.046-.324L13.735.106a.316.316 0 0 0-.472 0l-7.63 8.857a.302.302 0 0 0-.047.325z"}),x("path",{d:"M24.3 5.093c-.218-.76-.54-1.187-1.208-1.187h-4.856l1.018 1.18h3.948l2.043 11.038h-7.193v2.728H9.114v-2.725h-7.36l2.66-11.04h3.33l1.018-1.18H3.907c-.668 0-1.06.46-1.21 1.186L0 16.456v7.062C0 24.338.676 25 1.51 25h23.98c.833 0 1.51-.663 1.51-1.482v-7.062L24.3 5.093z"}))}function u(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"14px",height:"14px",viewBox:"0 0 19 19"},x("path",{d:"M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"}))}function p(){return x("svg",{class:"UppyIcon retry",width:"28",height:"31",viewBox:"0 0 16 19",xmlns:"http://www.w3.org/2000/svg"},x("path",{d:"M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"}),x("path",{d:"M7.9 3H10v2H7.9z"}),x("path",{d:"M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"}),x("path",{d:"M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"}))}function c(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"16px",height:"16px",viewBox:"0 0 32 30"},x("path",{d:"M6.6209894,11.1451162 C6.6823051,11.2751669 6.81374248,11.3572188 6.95463813,11.3572188 L12.6925482,11.3572188 L12.6925482,16.0630427 C12.6925482,17.880509 14.1726048,18.75 16.0000083,18.75 C17.8261072,18.75 19.3074684,17.8801847 19.3074684,16.0630427 L19.3074684,11.3572188 L25.0437478,11.3572188 C25.1875787,11.3572188 25.3164069,11.2751669 25.3790272,11.1451162 C25.4370814,11.0173358 25.4171865,10.8642587 25.3252129,10.7562615 L16.278212,0.127131837 C16.2093949,0.0463771751 16.1069846,0 15.9996822,0 C15.8910751,0 15.7886648,0.0463771751 15.718217,0.127131837 L6.6761083,10.7559371 C6.58250402,10.8642587 6.56293518,11.0173358 6.6209894,11.1451162 L6.6209894,11.1451162 Z"}),x("path",{d:"M28.8008722,6.11142645 C28.5417891,5.19831555 28.1583331,4.6875 27.3684848,4.6875 L21.6124454,4.6875 L22.8190234,6.10307874 L27.4986725,6.10307874 L29.9195817,19.3486449 L21.3943891,19.3502502 L21.3943891,22.622552 L10.8023461,22.622552 L10.8023461,19.3524977 L2.07815702,19.3534609 L5.22979699,6.10307874 L9.17871529,6.10307874 L10.3840011,4.6875 L4.6308691,4.6875 C3.83940559,4.6875 3.37421888,5.2390909 3.19815864,6.11142645 L0,19.7470874 L0,28.2212959 C0,29.2043992 0.801477937,30 1.78870751,30 L30.2096773,30 C31.198199,30 32,29.2043992 32,28.2212959 L32,19.7470874 L28.8008722,6.11142645 L28.8008722,6.11142645 Z"}))}function d(){return x("svg",{"aria-hidden":"true",class:"UppyIcon UppyIcon-check",width:"13px",height:"9px",viewBox:"0 0 13 9"},x("polygon",{points:"5 7.293 1.354 3.647 0.646 4.354 5 8.707 12.354 1.354 11.646 0.647"}))}function f(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",viewBox:"0 0 55 55"},x("path",{d:"M52.66.25c-.216-.19-.5-.276-.79-.242l-31 4.01a1 1 0 0 0-.87.992V40.622C18.174 38.428 15.273 37 12 37c-5.514 0-10 4.037-10 9s4.486 9 10 9 10-4.037 10-9c0-.232-.02-.46-.04-.687.014-.065.04-.124.04-.192V16.12l29-3.753v18.257C49.174 28.428 46.273 27 43 27c-5.514 0-10 4.037-10 9s4.486 9 10 9c5.464 0 9.913-3.966 9.993-8.867 0-.013.007-.024.007-.037V1a.998.998 0 0 0-.34-.75zM12 53c-4.41 0-8-3.14-8-7s3.59-7 8-7 8 3.14 8 7-3.59 7-8 7zm31-10c-4.41 0-8-3.14-8-7s3.59-7 8-7 8 3.14 8 7-3.59 7-8 7zM22 14.1V5.89l29-3.753v8.21l-29 3.754z"}))}function h(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",viewBox:"0 0 58 58"},x("path",{d:"M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"}),x("path",{d:"M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"}))}function m(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",viewBox:"0 0 342 335"},x("path",{d:"M329.337 227.84c-2.1 1.3-8.1 2.1-11.9 2.1-12.4 0-27.6-5.7-49.1-14.9 8.3-.6 15.8-.9 22.6-.9 12.4 0 16 0 28.2 3.1 12.1 3 12.2 9.3 10.2 10.6zm-215.1 1.9c4.8-8.4 9.7-17.3 14.7-26.8 12.2-23.1 20-41.3 25.7-56.2 11.5 20.9 25.8 38.6 42.5 52.8 2.1 1.8 4.3 3.5 6.7 5.3-34.1 6.8-63.6 15-89.6 24.9zm39.8-218.9c6.8 0 10.7 17.06 11 33.16.3 16-3.4 27.2-8.1 35.6-3.9-12.4-5.7-31.8-5.7-44.5 0 0-.3-24.26 2.8-24.26zm-133.4 307.2c3.9-10.5 19.1-31.3 41.6-49.8 1.4-1.1 4.9-4.4 8.1-7.4-23.5 37.6-39.3 52.5-49.7 57.2zm315.2-112.3c-6.8-6.7-22-10.2-45-10.5-15.6-.2-34.3 1.2-54.1 3.9-8.8-5.1-17.9-10.6-25.1-17.3-19.2-18-35.2-42.9-45.2-70.3.6-2.6 1.2-4.8 1.7-7.1 0 0 10.8-61.5 7.9-82.3-.4-2.9-.6-3.7-1.4-5.9l-.9-2.5c-2.9-6.76-8.7-13.96-17.8-13.57l-5.3-.17h-.1c-10.1 0-18.4 5.17-20.5 12.84-6.6 24.3.2 60.5 12.5 107.4l-3.2 7.7c-8.8 21.4-19.8 43-29.5 62l-1.3 2.5c-10.2 20-19.5 37-27.9 51.4l-8.7 4.6c-.6.4-15.5 8.2-19 10.3-29.6 17.7-49.28 37.8-52.54 53.8-1.04 5-.26 11.5 5.01 14.6l8.4 4.2c3.63 1.8 7.53 2.7 11.43 2.7 21.1 0 45.6-26.2 79.3-85.1 39-12.7 83.4-23.3 122.3-29.1 29.6 16.7 66 28.3 89 28.3 4.1 0 7.6-.4 10.5-1.2 4.4-1.1 8.1-3.6 10.4-7.1 4.4-6.7 5.4-15.9 4.1-25.4-.3-2.8-2.6-6.3-5-8.7z"}))}function y(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"44",height:"58",viewBox:"0 0 44 58"},x("path",{d:"M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"}))}function g(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"62",height:"62",viewBox:"0 0 62 62",xmlns:"http://www.w3.org/2000/svg"},x("path",{d:"M4.309 4.309h24.912v53.382h-6.525v3.559h16.608v-3.559h-6.525V4.309h24.912v10.676h3.559V.75H.75v14.235h3.559z","fill-rule":"nonzero",fill:"#000"}))}function v(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"37",height:"33",viewBox:"0 0 37 33"},x("path",{d:"M29.107 24.5c4.07 0 7.393-3.355 7.393-7.442 0-3.994-3.105-7.307-7.012-7.502l.468.415C29.02 4.52 24.34.5 18.886.5c-4.348 0-8.27 2.522-10.138 6.506l.446-.288C4.394 6.782.5 10.758.5 15.608c0 4.924 3.906 8.892 8.76 8.892h4.872c.635 0 1.095-.467 1.095-1.104 0-.636-.46-1.103-1.095-1.103H9.26c-3.644 0-6.63-3.035-6.63-6.744 0-3.71 2.926-6.685 6.57-6.685h.964l.14-.28.177-.362c1.477-3.4 4.744-5.576 8.347-5.576 4.58 0 8.45 3.452 9.01 8.072l.06.536.05.446h1.101c2.87 0 5.204 2.37 5.204 5.295s-2.333 5.296-5.204 5.296h-6.062c-.634 0-1.094.467-1.094 1.103 0 .637.46 1.104 1.094 1.104h6.12z"}),x("path",{d:"M23.196 18.92l-4.828-5.258-.366-.4-.368.398-4.828 5.196a1.13 1.13 0 0 0 0 1.546c.428.46 1.11.46 1.537 0l3.45-3.71-.868-.34v15.03c0 .64.445 1.118 1.075 1.118.63 0 1.075-.48 1.075-1.12V16.35l-.867.34 3.45 3.712a1 1 0 0 0 .767.345 1 1 0 0 0 .77-.345c.416-.33.416-1.036 0-1.485v.003z"}))}function b(){return x("svg",{"aria-hidden":"true",class:"UppyIcon",width:"48",height:"69",viewBox:"0 0 48 69"},x("path",{d:"M.5 1.5h5zM10.5 1.5h5zM20.5 1.5h5zM30.504 1.5h5zM45.5 11.5v5zM45.5 21.5v5zM45.5 31.5v5zM45.5 41.502v5zM45.5 51.502v5zM45.5 61.5v5zM45.5 66.502h-4.998zM35.503 66.502h-5zM25.5 66.502h-5zM15.5 66.502h-5zM5.5 66.502h-5zM.5 66.502v-5zM.5 56.502v-5zM.5 46.503V41.5zM.5 36.5v-5zM.5 26.5v-5zM.5 16.5v-5zM.5 6.5V1.498zM44.807 11H36V2.195z"}))}var w=n(0),x=w.h;t.exports={defaultTabIcon:o,iconCopy:r,iconResume:i,iconPause:s,iconRetry:p,iconEdit:a,localIcon:l,closeIcon:u,pluginIcon:c,checkIcon:d,iconAudio:f,iconVideo:h,iconPDF:m,iconFile:y,iconText:g,uploadIcon:v,dashboardBgIcon:b}},function(t,e){function n(t){if("number"!=typeof t||isNaN(t))throw new TypeError("Expected a number, got "+typeof t);var e=t<0,n=["B","KB","MB","GB","TB","PB","EB","ZB","YB"];if(e&&(t=-t),t<1)return(e?"-":"")+t+" B";var o=Math.min(Math.floor(Math.log(t)/Math.log(1e3)),n.length-1);t=Number(t/Math.pow(1e3,o));var r=n[o];return t>=10||t%1==0?(e?"-":"")+t.toFixed(0)+" "+r:(e?"-":"")+t.toFixed(1)+" "+r}t.exports=n},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},s=n(0),a=n(1),l=a.findDOMElement;t.exports=function(){function t(e,n){o(this,t),this.uppy=e,this.opts=n||{},this.update=this.update.bind(this),this.mount=this.mount.bind(this),this.install=this.install.bind(this),this.uninstall=this.uninstall.bind(this)}return t.prototype.getPluginState=function(){return this.uppy.state.plugins[this.id]},t.prototype.setPluginState=function(t){var e=i({},this.uppy.state.plugins);e[this.id]=i({},e[this.id],t),this.uppy.setState({plugins:e})},t.prototype.update=function(t){void 0!==this.el&&this.updateUI&&this.updateUI(t)},t.prototype.mount=function(e,n){var o=this,i=n.id,a=l(e);if(a)return this.updateUI=function(t){o.el=s.render(o.render(t),a,o.el)},this.uppy.log("Installing "+i+" to a DOM element"),this.opts.replaceTargetContent&&(a.innerHTML=""),this.el=s.render(this.render(this.uppy.state),a),this.el;var u=void 0;if("object"===(void 0===e?"undefined":r(e))&&e instanceof t)u=e;else if("function"==typeof e){var p=e;this.uppy.iteratePlugins(function(t){if(t instanceof p)return u=t,!1})}if(u){var c=u.id;return this.uppy.log("Installing "+i+" to "+c),this.el=u.addTarget(n),this.el}throw this.uppy.log("Not installing "+i),new Error("Invalid target option given to "+i)},t.prototype.render=function(t){throw new Error("Extend the render method to add your plugin to a DOM element")},t.prototype.addTarget=function(t){throw new Error("Extend the addTarget method to add your plugin to another plugin's target")},t.prototype.unmount=function(){this.el&&this.el.parentNode&&this.el.parentNode.removeChild(this.el)},t.prototype.install=function(){},t.prototype.uninstall=function(){this.unmount()},t}()},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};t.exports=function(){function t(e){o(this,t);var n={locale:{strings:{},pluralize:function(t){return 1===t?0:1}}};this.opts=r({},n,e),this.locale=r({},n.locale,e.locale)}/**
	   * Takes a string with placeholder variables like `%{smart_count} file selected`
	   * and replaces it with values from options `{smart_count: 5}`
	   *
	   * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
	   * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
	   *
	   * @param {string} phrase that needs interpolation, with placeholders
	   * @param {object} options with values that will be used to replace placeholders
	   * @return {string} interpolated
	   */
	return t.prototype.interpolate=function(t,e){var n=String.prototype.replace,o=/\$/g;for(var r in e)if("_"!==r&&e.hasOwnProperty(r)){var i=e[r];"string"==typeof i&&(i=n.call(e[r],o,"$$$$")),t=n.call(t,new RegExp("%\\{"+r+"\\}","g"),i)}return t},t.prototype.translate=function(t,e){if(e&&e.smart_count){var n=this.locale.pluralize(e.smart_count);return this.interpolate(this.opts.locale.strings[t][n],e)}return this.interpolate(this.opts.locale.strings[t],e)},t}()},function(t,e,n){var o,r;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	!function(){"use strict";function n(){for(var t=[],e=0;e<arguments.length;e++){var o=arguments[e];if(o){var r=typeof o;if("string"===r||"number"===r)t.push(o);else if(Array.isArray(o))t.push(n.apply(null,o));else if("object"===r)for(var s in o)i.call(o,s)&&o[s]&&t.push(s)}}return t.join(" ")}var i={}.hasOwnProperty;void 0!==t&&t.exports?t.exports=n:(o=[],void 0!==(r=function(){return n}.apply(e,o))&&(t.exports=r))}()},function(t,e,n){(function(e){function n(t,e,n){function o(e){var n=m,o=y;return m=y=void 0,_=e,v=t.apply(o,n)}function i(t){return _=t,b=setTimeout(p,e),C?o(t):v}function s(t){var n=t-w,o=t-_,r=e-n;return U?S(r,g-o):r}function u(t){var n=t-w,o=t-_;return void 0===w||n>=e||n<0||U&&o>=g}function p(){var t=P();if(u(t))return c(t);b=setTimeout(p,s(t))}function c(t){return b=void 0,T&&m?o(t):(m=y=void 0,v)}function d(){void 0!==b&&clearTimeout(b),_=0,m=w=y=b=void 0}function f(){return void 0===b?v:c(P())}function h(){var t=P(),n=u(t);if(m=arguments,y=this,w=t,n){if(void 0===b)return i(w);if(U)return b=setTimeout(p,e),o(w)}return void 0===b&&(b=setTimeout(p,e)),v}var m,y,g,v,b,w,_=0,C=!1,U=!1,T=!0;if("function"!=typeof t)throw new TypeError(l);return e=a(e)||0,r(n)&&(C=!!n.leading,U="maxWait"in n,g=U?x(a(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),h.cancel=d,h.flush=f,h}function o(t,e,o){var i=!0,s=!0;if("function"!=typeof t)throw new TypeError(l);return r(o)&&(i="leading"in o?!!o.leading:i,s="trailing"in o?!!o.trailing:s),n(t,e,{leading:i,maxWait:e,trailing:s})}function r(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function i(t){return!!t&&"object"==typeof t}function s(t){return"symbol"==typeof t||i(t)&&w.call(t)==p}function a(t){if("number"==typeof t)return t;if(s(t))return u;if(r(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=r(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(c,"");var n=f.test(t);return n||h.test(t)?m(t.slice(2),n?2:8):d.test(t)?u:+t}var l="Expected a function",u=NaN,p="[object Symbol]",c=/^\s+|\s+$/g,d=/^[-+]0x[0-9a-f]+$/i,f=/^0b[01]+$/i,h=/^0o[0-7]+$/i,m=parseInt,y="object"==typeof e&&e&&e.Object===Object&&e,g="object"==typeof self&&self&&self.Object===Object&&self,v=y||g||Function("return this")(),b=Object.prototype,w=b.toString,x=Math.max,S=Math.min,P=function(){return v.Date.now()};t.exports=o}).call(e,n(8))},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(o,r){var i;/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/jakearchibald/es6-promise/master/LICENSE
	 * @version   3.2.1
	 */
	(function(){"use strict";function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return"function"==typeof t}function l(t){$=t}function u(t){K=t}function p(){return function(){q(d)}}function c(){return function(){setTimeout(d,1)}}function d(){for(var t=0;t<G;t+=2){(0,nt[t])(nt[t+1]),nt[t]=void 0,nt[t+1]=void 0}G=0}function f(t,e){var n=this,o=new this.constructor(m);void 0===o[it]&&A(o);var r=n._state;if(r){var i=arguments[r-1];K(function(){D(r,o,i,n._result)})}else T(n,o,t,e);return o}function h(t){var e=this;if(t&&"object"==typeof t&&t.constructor===e)return t;var n=new e(m);return P(n,t),n}function m(){}function y(){return new TypeError("You cannot resolve a promise with itself")}function g(){return new TypeError("A promises callback cannot return that same promise.")}function v(t){try{return t.then}catch(t){return ut.error=t,ut}}function b(t,e,n,o){try{t.call(e,n,o)}catch(t){return t}}function w(t,e,n){K(function(t){var o=!1,r=b(n,e,function(n){o||(o=!0,e!==n?P(t,n):C(t,n))},function(e){o||(o=!0,U(t,e))},"Settle: "+(t._label||" unknown promise"));!o&&r&&(o=!0,U(t,r))},t)}function x(t,e){e._state===at?C(t,e._result):e._state===lt?U(t,e._result):T(e,void 0,function(e){P(t,e)},function(e){U(t,e)})}function S(t,e,n){e.constructor===t.constructor&&n===ot&&constructor.resolve===rt?x(t,e):n===ut?U(t,ut.error):void 0===n?C(t,e):a(n)?w(t,e,n):C(t,e)}function P(t,e){t===e?U(t,y()):s(e)?S(t,e,v(e)):C(t,e)}function _(t){t._onerror&&t._onerror(t._result),F(t)}function C(t,e){t._state===st&&(t._result=e,t._state=at,0!==t._subscribers.length&&K(F,t))}function U(t,e){t._state===st&&(t._state=lt,t._result=e,K(_,t))}function T(t,e,n,o){var r=t._subscribers,i=r.length;t._onerror=null,r[i]=e,r[i+at]=n,r[i+lt]=o,0===i&&t._state&&K(F,t)}function F(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var o,r,i=t._result,s=0;s<e.length;s+=3)o=e[s],r=e[s+n],o?D(n,o,r,i):r(i);t._subscribers.length=0}}function O(){this.error=null}function E(t,e){try{return t(e)}catch(t){return pt.error=t,pt}}function D(t,e,n,o){var r,i,s,l,u=a(n);if(u){if(r=E(n,o),r===pt?(l=!0,i=r.error,r=null):s=!0,e===r)return void U(e,g())}else r=o,s=!0;e._state!==st||(u&&s?P(e,r):l?U(e,i):t===at?C(e,r):t===lt&&U(e,r))}function k(t,e){try{e(function(e){P(t,e)},function(e){U(t,e)})}catch(e){U(t,e)}}function M(){return ct++}function A(t){t[it]=ct++,t._state=void 0,t._result=void 0,t._subscribers=[]}function j(t){return new yt(this,t).promise}function L(t){var e=this;return new e(X(t)?function(n,o){for(var r=t.length,i=0;i<r;i++)e.resolve(t[i]).then(n,o)}:function(t,e){e(new TypeError("You must pass an array to race."))})}function I(t){var e=this,n=new e(m);return U(n,t),n}function z(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}function B(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}function R(t){this[it]=M(),this._result=this._state=void 0,this._subscribers=[],m!==t&&("function"!=typeof t&&z(),this instanceof R?k(this,t):B())}function N(t,e){this._instanceConstructor=t,this.promise=new t(m),this.promise[it]||A(this.promise),X(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?C(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&C(this.promise,this._result))):U(this.promise,W())}function W(){return new Error("Array Methods must be provided an Array")}function H(){var t;if(void 0!==r)t=r;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;e&&"[object Promise]"===Object.prototype.toString.call(e.resolve())&&!e.cast||(t.Promise=mt)}var V;V=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)};var q,$,Y,X=V,G=0,K=function(t,e){nt[G]=t,nt[G+1]=e,2===(G+=2)&&($?$(d):Y())},Z="undefined"!=typeof window?window:void 0,J=Z||{},Q=J.MutationObserver||J.WebKitMutationObserver,tt="undefined"==typeof self&&void 0!==o&&"[object process]"==={}.toString.call(o),et="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel,nt=new Array(1e3);Y=tt?function(){return function(){o.nextTick(d)}}():Q?function(){var t=0,e=new Q(d),n=document.createTextNode("");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}():et?function(){var t=new MessageChannel;return t.port1.onmessage=d,function(){t.port2.postMessage(0)}}():void 0===Z?function(){try{var t=n(51);return q=t.runOnLoop||t.runOnContext,p()}catch(t){return c()}}():c();var ot=f,rt=h,it=Math.random().toString(36).substring(16),st=void 0,at=1,lt=2,ut=new O,pt=new O,ct=0,dt=j,ft=L,ht=I,mt=R;R.all=dt,R.race=ft,R.resolve=rt,R.reject=ht,R._setScheduler=l,R._setAsap=u,R._asap=K,R.prototype={constructor:R,then:ot,catch:function(t){return this.then(null,t)}};var yt=N;N.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===st&&n<t;n++)this._eachEntry(e[n],n)},N.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,o=n.resolve;if(o===rt){var r=v(t);if(r===ot&&t._state!==st)this._settledAt(t._state,e,t._result);else if("function"!=typeof r)this._remaining--,this._result[e]=t;else if(n===mt){var i=new n(m);S(i,t,r),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){e(t)}),e)}else this._willSettleAt(o(t),e)},N.prototype._settledAt=function(t,e,n){var o=this.promise;o._state===st&&(this._remaining--,t===lt?U(o,n):this._result[e]=n),0===this._remaining&&C(o,this._result)},N.prototype._willSettleAt=function(t,e){var n=this;T(t,void 0,function(t){n._settledAt(at,e,t)},function(t){n._settledAt(lt,e,t)})};var gt=H,vt={Promise:mt,polyfill:gt};void 0!==(i=function(){return vt}.call(e,n,e,t))&&(t.exports=i),gt()}).call(this)}).call(e,n(10),n(8))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(p===setTimeout)return setTimeout(t,0);if((p===n||!p)&&setTimeout)return p=setTimeout,setTimeout(t,0);try{return p(t,0)}catch(e){try{return p.call(null,t,0)}catch(e){return p.call(this,t,0)}}}function i(t){if(c===clearTimeout)return clearTimeout(t);if((c===o||!c)&&clearTimeout)return c=clearTimeout,clearTimeout(t);try{return c(t)}catch(e){try{return c.call(null,t)}catch(e){return c.call(this,t)}}}function s(){m&&f&&(m=!1,f.length?h=f.concat(h):y=-1,h.length&&a())}function a(){if(!m){var t=r(s);m=!0;for(var e=h.length;e;){for(f=h,h=[];++y<e;)f&&f[y].run();y=-1,e=h.length}f=null,m=!1,i(t)}}function l(t,e){this.fun=t,this.array=e}function u(){}var p,c,d=t.exports={};!function(){try{p="function"==typeof setTimeout?setTimeout:n}catch(t){p=n}try{c="function"==typeof clearTimeout?clearTimeout:o}catch(t){c=o}}();var f,h=[],m=!1,y=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];h.push(new l(t,e)),1!==h.length||m||r(a)},l.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.prependListener=u,d.prependOnceListener=u,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=n(0),a=s.h,l=s.Component,u=function(t){function e(n){o(this,e);var i=r(this,t.call(this,n));return i.handleClick=i.handleClick.bind(i),i}return i(e,t),e.prototype.handleClick=function(t){this.input.click()},e.prototype.render=function(){var t=this;return a("span",null,0===this.props.acquirers.length?this.props.i18n("dropPaste"):this.props.i18n("dropPasteImport")," ",a("button",{type:"button",class:"uppy-Dashboard-browse",onclick:this.handleClick},this.props.i18n("browse")),a("input",{class:"uppy-Dashboard-input",hidden:"true","aria-hidden":"true",tabindex:"-1",type:"file",name:"files[]",multiple:"true",onchange:this.props.handleInputChange,ref:function(e){t.input=e}}))},e}(l);t.exports=u},function(t,e,n){"use strict";var o=n(2),r=o.iconText,i=o.iconAudio,s=o.iconVideo,a=o.iconPDF;t.exports=function(t){var e={color:"#cbcbcb",icon:""};if(!t)return e;var n=t.split("/")[0],o=t.split("/")[1];return"text"===n?{color:"#cbcbcb",icon:r()}:"audio"===n?{color:"#1abc9c",icon:i()}:"video"===n?{color:"#2980b9",icon:s()}:"application"===n&&"pdf"===o?{color:"#e74c3c",icon:a()}:"image"===n?{color:"#f2f2f2",icon:""}:e}},function(t,e,n){function o(t){n(19)}var r=n(48)(n(15),n(49),o,"data-v-085860d1",null);t.exports=r.exports},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(13),r=n.n(o);e.default=r.a},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(25),r=n.n(o),i=n(32),s=n.n(i),a=n(44),l=n.n(a),u=n(18),p=(n.n(u),"https://api.cloudinary.com/v1_1/");e.default={props:{cloudName:{type:String,required:!0},preset:{type:String,required:!0},buttonText:{type:String,default:"Upload"},minNumberOfFiles:{type:Number,default:1},maxNumberOfFiles:{type:Number,default:10},maxFileSize:{type:Number,default:4e7},allowedFileTypes:{type:Array,default:function(){return["image/*","video/*"]}},tags:{type:Array,default:function(){return[]}},autoProceed:{type:Boolean,default:!1},showProgressDetails:{type:Boolean,default:!0},closeModalOnClickOutside:{type:Boolean,default:!0},buttonStyle:{type:String,default:"uploader"}},methods:{openUploader:function(){this.uppy.getPlugin("Dashboard").openModal()},uploadFile:function(t){var e=this,n=new FormData;n.append("file",t.data),n.append("upload_preset",this.preset),n.append("tags",this.tags);var o=new XMLHttpRequest;o.upload.addEventListener("loadstart",function(){e.uppy.emit("upload-started",t.id)}),o.addEventListener("load",function(n){200===n.target.status?(e.$emit("uploaded",JSON.parse(n.target.response)),e.uppy.emit("upload-success",t.id)):e.uppy.emit("upload-error",t.id,new Error("Failed to upload"))}),o.addEventListener("error",function(){e.uppy.emit("upload-error",t.id,new Error("Failed to upload"))}),o.upload.addEventListener("progress",function(n){if(n.lengthComputable){var o={uploader:e,id:t.id,bytesUploaded:n.loaded,bytesTotal:n.total};e.uppy.emit("upload-progress",o),e.$emit("upload-progress",o)}}),t.type.startsWith("video")?o.open("POST",""+p+this.cloudName+"/video/upload"):o.open("POST",""+p+this.cloudName+"/image/upload"),o.send(n)},createUppyInstance:function(){return r()({autoProceed:this.autoProceed,restrictions:{maxFileSize:this.maxFileSize,maxNumberOfFiles:this.maxNumberOfFiles,minNumberOfFiles:this.minNumberOfFiles,allowedFileTypes:this.allowedFileTypes}}).use(s.a,{target:"body",showProgressDetails:this.showProgressDetails,closeModalOnClickOutside:this.closeModalOnClickOutside}).use(l.a,{target:s.a}).run()},completeHandler:function(t){var e=this;t.successful.forEach(function(t){e.uploadFile(t)})}},mounted:function(){this.uppy=this.createUppyInstance(),this.uppy.on("complete",this.completeHandler)},data:function(){return{uppy:{}}}}},function(t,e,n){!function(e){"use strict";var n=0,o=Math.pow(36,4),r=function(t,e){var n="000000000"+t;return n.substr(n.length-e)},i=function(){return r((Math.random()*o<<0).toString(36),4)},s=function(){return n=n<o?n:0,++n-1},a=function(){var t,e=(new Date).getTime().toString(36),n=a.fingerprint(),o=i()+i();return t=r(s().toString(36),4),"c"+e+t+n+o};a.slug=function(){var t,e=(new Date).getTime().toString(36),n=a.fingerprint().slice(0,1)+a.fingerprint().slice(-1),o=i().slice(-2);return t=s().toString(36).slice(-4),e.slice(-2)+t+n+o},a.globalCount=function(){var t=function(){var t,e=0;for(t in window)e++;return e}();return a.globalCount=function(){return t},t},a.fingerprint=function(){return r((navigator.mimeTypes.length+navigator.userAgent.length).toString(36)+a.globalCount().toString(36),4)},e.register?e.register("cuid",a):t.exports=a}(this.applitude||this)},function(t,e,n){function o(t,e){function n(t){return e.onDragEnter&&e.onDragEnter(t),t.stopPropagation(),t.preventDefault(),!1}function o(n){if(n.stopPropagation(),n.preventDefault(),n.dataTransfer.items){var o=i(n.dataTransfer.items),r=o.filter(function(t){return"file"===t.kind}),s=o.filter(function(t){return"string"===t.kind});if(0===r.length&&!e.onDropText)return;if(0===s.length&&!e.onDrop)return;if(0===r.length&&0===s.length)return}return t.classList.add("drag"),clearTimeout(d),e.onDragOver&&e.onDragOver(n),n.dataTransfer.dropEffect="copy",!1}function l(t){return t.stopPropagation(),t.preventDefault(),e.onDragLeave&&e.onDragLeave(t),clearTimeout(d),d=setTimeout(p,50),!1}function u(t){t.stopPropagation(),t.preventDefault(),e.onDragLeave&&e.onDragLeave(t),clearTimeout(d),p();var n={x:t.clientX,y:t.clientY},o=t.dataTransfer.getData("text");if(o&&e.onDropText&&e.onDropText(o,n),t.dataTransfer.items){var l=i(t.dataTransfer.items).filter(function(t){return"file"===t.kind});if(0===l.length)return;a(l.map(function(t){return function(e){r(t.webkitGetAsEntry(),e)}}),function(t,o){if(t)throw t;e.onDrop&&e.onDrop(s(o),n)})}else{var u=i(t.dataTransfer.files);if(0===u.length)return;u.forEach(function(t){t.fullPath="/"+t.name}),e.onDrop&&e.onDrop(u,n)}return!1}function p(){t.classList.remove("drag")}if("string"==typeof t){var c=t;if(!(t=window.document.querySelector(t)))throw new Error('"'+c+'" does not match any HTML elements')}if(!t)throw new Error('"'+t+'" is not a valid HTML element');"function"==typeof e&&(e={onDrop:e});var d;return t.addEventListener("dragenter",n,!1),t.addEventListener("dragover",o,!1),t.addEventListener("dragleave",l,!1),t.addEventListener("drop",u,!1),function(){p(),t.removeEventListener("dragenter",n,!1),t.removeEventListener("dragover",o,!1),t.removeEventListener("dragleave",l,!1),t.removeEventListener("drop",u,!1)}}function r(t,e){function n(){l.readEntries(function(t){t.length>0?(s=s.concat(i(t)),n()):o()})}function o(){a(s.map(function(t){return function(e){r(t,e)}}),e)}var s=[];if(t.isFile)t.file(function(n){n.fullPath=t.fullPath,e(null,n)},function(t){e(t)});else if(t.isDirectory){var l=t.createReader();n()}}function i(t){return Array.prototype.slice.call(t||[],0)}t.exports=o;var s=n(20),a=n(23)},function(t,e){},function(t,e){},function(t,e){t.exports=function(t,e){function n(t,o){return t.reduce(function(t,r){return Array.isArray(r)&&o<e?t.concat(n(r,o+1)):t.concat(r)},[])}return e="number"==typeof e?e:1/0,e?n(t,1):Array.isArray(t)?t.map(function(t){return t}):t}},function(t,e,n){var o=n(50),r=/[\/\+\.]/;t.exports=function(t,e){function n(e){var n=o(e,t,r);return n&&n.length>=2}return e?n(e.split(";")[0]):n}},function(t,e){t.exports=function(){function t(t){var e=o[t]?o[t]:[],n=t.indexOf(":"),r=-1===n?[t]:[t.substring(0,n),t.substring(n+1)],i=Object.keys(o),s=0,a=i.length;for(s;s<a;s++){var l=i[s];if("*"===l&&(e=e.concat(o[l])),2===r.length&&r[0]===l){e=e.concat(o[l]);break}}return e}function e(t,e,n){var o=0,r=e.length;for(o;o<r&&e[o];o++)e[o].event=t,e[o].apply(e[o],n)}var n={},o=n._fns={};return n.emit=function(n,o,r,i,s,a,l){var u=t(n);u.length&&e(n,u,[o,r,i,s,a,l])},n.on=function(t,e){o[t]||(o[t]=[]),o[t].push(e)},n.once=function(t,e){function o(){e.apply(this,arguments),n.off(t,o)}this.on(t,o)},n.off=function(t,e){var n=[];if(t&&e){var o=this._fns[t],r=0,i=o.length;for(r;r<i;r++)o[r]!==e&&n.push(o[r])}n.length?this._fns[t]=n:delete this._fns[t]},n}},function(t,e,n){(function(e){t.exports=function(t,n){function o(t){function o(){n&&n(t,i),n=null}l?e.nextTick(o):o()}function r(t,e,n){i[t]=n,(0==--s||e)&&o(e)}var i,s,a,l=!0;Array.isArray(t)?(i=[],s=t.length):(a=Object.keys(t),i={},s=a.length),s?a?a.forEach(function(e){t[e](function(t,n){r(e,t,n)})}):t.forEach(function(t,e){t(function(t,n){r(e,t,n)})}):o(null),l=!1}}).call(e,n(10))},function(t,e,n){"use strict";(function(e){function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},i=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},s=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),a=n(1),l=n(5),u=n(22),p=n(16),c=n(7),d=n(3),f=n(21),h=n(46),m=function(){function t(n){var r=this;o(this,t);var s={strings:{youCanOnlyUploadX:{0:"You can only upload %{smart_count} file",1:"You can only upload %{smart_count} files"},youHaveToAtLeastSelectX:{0:"You have to select at least %{smart_count} file",1:"You have to select at least %{smart_count} files"},exceedsSize:"This file exceeds maximum allowed size of",youCanOnlyUploadFileTypes:"You can only upload:",uppyServerError:"Connection with Uppy Server failed"}},a={id:"uppy",autoProceed:!0,debug:!1,restrictions:{maxFileSize:!1,maxNumberOfFiles:!1,minNumberOfFiles:!1,allowedFileTypes:!1},meta:{},onBeforeFileAdded:function(t,e){return Promise.resolve()},onBeforeUpload:function(t,e){return Promise.resolve()},locale:s,store:new h,thumbnailGeneration:!0};this.opts=i({},a,n),this.locale=i({},s,this.opts.locale),this.locale.strings=i({},s.strings,this.opts.locale.strings),this.translator=new l({locale:this.locale}),this.i18n=this.translator.translate.bind(this.translator),this.plugins={},this.translator=new l({locale:this.opts.locale}),this.i18n=this.translator.translate.bind(this.translator),this.getState=this.getState.bind(this),this.getPlugin=this.getPlugin.bind(this),this.setFileMeta=this.setFileMeta.bind(this),this.setFileState=this.setFileState.bind(this),this.log=this.log.bind(this),this.info=this.info.bind(this),this.hideInfo=this.hideInfo.bind(this),this.addFile=this.addFile.bind(this),this.removeFile=this.removeFile.bind(this),this.pauseResume=this.pauseResume.bind(this),this._calculateProgress=this._calculateProgress.bind(this),this.updateOnlineStatus=this.updateOnlineStatus.bind(this),this.resetProgress=this.resetProgress.bind(this),this.pauseAll=this.pauseAll.bind(this),this.resumeAll=this.resumeAll.bind(this),this.retryAll=this.retryAll.bind(this),this.cancelAll=this.cancelAll.bind(this),this.retryUpload=this.retryUpload.bind(this),this.upload=this.upload.bind(this),this.emitter=u(),this.on=this.emitter.on.bind(this.emitter),this.off=this.emitter.off.bind(this.emitter),this.once=this.emitter.once.bind(this.emitter),this.emit=this.emitter.emit.bind(this.emitter),this.preProcessors=[],this.uploaders=[],this.postProcessors=[],this.store=this.opts.store,this.setState({plugins:{},files:{},currentUploads:{},capabilities:{resumableUploads:!1},totalProgress:0,meta:i({},this.opts.meta),info:{isHidden:!0,type:"info",message:""}}),this._storeUnsubscribe=this.store.subscribe(function(t,e,n){r.emit("state-update",t,e,n),r.updateAll(e)}),this.opts.debug&&(e.uppyLog="",e[this.opts.id]=this)}return t.prototype.updateAll=function(t){this.iteratePlugins(function(e){e.update(t)})},t.prototype.setState=function(t){this.store.setState(t)},t.prototype.getState=function(){return this.store.getState()},t.prototype.setFileState=function(t,e){var n;this.setState({files:i({},this.getState().files,(n={},n[t]=i({},this.getState().files[t],e),n))})},t.prototype.resetProgress=function(){var t={percentage:0,bytesUploaded:0,uploadComplete:!1,uploadStarted:!1},e=i({},this.getState().files),n={};Object.keys(e).forEach(function(o){var r=i({},e[o]);r.progress=i({},r.progress,t),n[o]=r}),this.setState({files:n,totalProgress:0}),this.emit("reset-progress")},t.prototype.addPreProcessor=function(t){this.preProcessors.push(t)},t.prototype.removePreProcessor=function(t){var e=this.preProcessors.indexOf(t);-1!==e&&this.preProcessors.splice(e,1)},t.prototype.addPostProcessor=function(t){this.postProcessors.push(t)},t.prototype.removePostProcessor=function(t){var e=this.postProcessors.indexOf(t);-1!==e&&this.postProcessors.splice(e,1)},t.prototype.addUploader=function(t){this.uploaders.push(t)},t.prototype.removeUploader=function(t){var e=this.uploaders.indexOf(t);-1!==e&&this.uploaders.splice(e,1)},t.prototype.setMeta=function(t){var e=i({},this.getState().meta,t),n=i({},this.getState().files);Object.keys(n).forEach(function(e){n[e]=i({},n[e],{meta:i({},n[e].meta,t)})}),this.log("Adding metadata:"),this.log(t),this.setState({meta:e,files:n})},t.prototype.setFileMeta=function(t,e){var n=i({},this.getState().files);if(!n[t])return void this.log("Was trying to set metadata for a file that’s not with us anymore: ",t);var o=i({},n[t].meta,e);n[t]=i({},n[t],{meta:o}),this.setState({files:n})},t.prototype.getFile=function(t){return this.getState().files[t]},t.prototype._checkMinNumberOfFiles=function(){var t=this.opts.restrictions.minNumberOfFiles;return!(Object.keys(this.getState().files).length<t)||(this.info(""+this.i18n("youHaveToAtLeastSelectX",{smart_count:t}),"error",5e3),!1)},t.prototype._checkRestrictions=function(t){var e=this.opts.restrictions,n=e.maxFileSize,o=e.maxNumberOfFiles,r=e.allowedFileTypes;if(o&&Object.keys(this.getState().files).length+1>o)return this.info(""+this.i18n("youCanOnlyUploadX",{smart_count:o}),"error",5e3),!1;if(r){if(!(r.filter(function(e){return!!t.type&&f(t.type,e)}).length>0)){var i=r.join(", ");return this.info(this.i18n("youCanOnlyUploadFileTypes")+" "+i,"error",5e3),!1}}return!(n&&t.data.size>n)||(this.info(this.i18n("exceedsSize")+" "+d(n),"error",5e3),!1)},t.prototype.addFile=function(t){var e=this;return Promise.resolve().then(function(){return e.opts.onBeforeFileAdded(t,e.getState().files)}).catch(function(t){var n="object"===(void 0===t?"undefined":r(t))?t.message:t;return e.info(n,"error",5e3),Promise.reject(new Error("onBeforeFileAdded: "+n))}).then(function(){return a.getFileType(t).then(function(n){var o=i({},e.getState().files),r=void 0;r=t.name?t.name:"image"===n.split("/")[0]?n.split("/")[0]+"."+n.split("/")[1]:"noname";var s=a.getFileNameAndExtension(r).extension,l=t.isRemote||!1,u=a.generateFileID(t),p={source:t.source||"",id:u,name:r,extension:s||"",meta:i({},e.getState().meta,{name:r,type:n}),type:n,data:t.data,progress:{percentage:0,bytesUploaded:0,bytesTotal:t.data.size||0,uploadComplete:!1,uploadStarted:!1},size:t.data.size||"N/A",isRemote:l,remote:t.remote||"",preview:t.preview};if(!e._checkRestrictions(p))return Promise.reject(new Error("File not allowed"));o[u]=p,e.setState({files:o}),e.emit("file-added",p),e.log("Added file: "+r+", "+u+", mime type: "+n),e.opts.autoProceed&&!e.scheduledAutoProceed&&(e.scheduledAutoProceed=setTimeout(function(){e.scheduledAutoProceed=null,e.upload().catch(function(t){console.error(t.stack||t.message||t)})},4))})})},t.prototype.removeFile=function(t){var e=this,n=this.state,o=n.files,r=n.currentUploads,s=i({},o),l=s[t];delete s[t];var u=i({},r),p=[];Object.keys(u).forEach(function(e){var n=r[e].fileIDs.filter(function(e){return e!==t});if(0===n.length)return void p.push(e);u[e]=i({},r[e],{fileIDs:n})}),this.setState({currentUploads:u,files:s}),p.forEach(function(t){e._removeUpload(t)}),this._calculateTotalProgress(),this.emit("file-removed",t),l.preview&&a.isObjectURL(l.preview)&&URL.revokeObjectURL(l.preview),this.log("Removed file: "+t)},t.prototype.generatePreview=function(t){var e=this;if(a.isPreviewSupported(t.type)&&!t.isRemote){var n=void 0;n=!0===this.opts.thumbnailGeneration?a.createThumbnail(t,280):Promise.resolve(URL.createObjectURL(t.data)),n.then(function(n){e.setPreviewURL(t.id,n)}).catch(function(t){console.warn(t.stack||t.message)})}},t.prototype.setPreviewURL=function(t,e){this.setFileState(t,{preview:e})},t.prototype.pauseResume=function(t){var e=i({},this.getState().files);if(!e[t].uploadComplete){var n=e[t].isPaused||!1,o=!n,r=i({},e[t],{isPaused:o});return e[t]=r,this.setState({files:e}),this.emit("upload-pause",t,o),o}},t.prototype.pauseAll=function(){var t=i({},this.getState().files);Object.keys(t).filter(function(e){return!t[e].progress.uploadComplete&&t[e].progress.uploadStarted}).forEach(function(e){var n=i({},t[e],{isPaused:!0});t[e]=n}),this.setState({files:t}),this.emit("pause-all")},t.prototype.resumeAll=function(){var t=i({},this.getState().files);Object.keys(t).filter(function(e){return!t[e].progress.uploadComplete&&t[e].progress.uploadStarted}).forEach(function(e){var n=i({},t[e],{isPaused:!1,error:null});t[e]=n}),this.setState({files:t}),this.emit("resume-all")},t.prototype.retryAll=function(){var t=i({},this.getState().files),e=Object.keys(t).filter(function(e){return t[e].error});e.forEach(function(e){var n=i({},t[e],{isPaused:!1,error:null});t[e]=n}),this.setState({files:t,error:null}),this.emit("retry-all",e);var n=this._createUpload(e);return this._runUpload(n)},t.prototype.cancelAll=function(){this.emit("cancel-all"),this.setState({files:{},totalProgress:0})},t.prototype.retryUpload=function(t){var e=i({},this.getState().files),n=i({},e[t],{error:null,isPaused:!1});e[t]=n,this.setState({files:e}),this.emit("upload-retry",t);var o=this._createUpload([t]);return this._runUpload(o)},t.prototype.reset=function(){this.cancelAll()},t.prototype._calculateProgress=function(t){var e=t.id;if(!this.getState().files[e])return void this.log("Trying to set progress for a file that’s been removed: ",e);this.setFileState(e,{progress:i({},this.getState().files[e].progress,{bytesUploaded:t.bytesUploaded,bytesTotal:t.bytesTotal,percentage:Math.floor((t.bytesUploaded/t.bytesTotal*100).toFixed(2))})}),this._calculateTotalProgress()},t.prototype._calculateTotalProgress=function(){var t=i({},this.getState().files),e=Object.keys(t).filter(function(e){return t[e].progress.uploadStarted}),n=100*e.length,o=0;e.forEach(function(e){o+=t[e].progress.percentage});var r=0===n?0:Math.floor((100*o/n).toFixed(2));this.setState({totalProgress:r})},t.prototype.actions=function(){var t=this;this.on("error",function(e){t.setState({error:e.message})}),this.on("upload-error",function(e,n){t.setFileState(e,{error:n.message}),t.setState({error:n.message});var o=t.getState().files[e].name,i="Failed to upload "+o;"object"===(void 0===n?"undefined":r(n))&&n.message&&(i={message:i,details:n.message}),t.info(i,"error",5e3)}),this.on("upload",function(){t.setState({error:null})}),this.on("file-added",function(e){t.generatePreview(e)}),this.on("file-remove",function(e){t.removeFile(e)}),this.on("upload-started",function(e,n){t.setFileState(e,{progress:i({},t.getState().files[e].progress,{uploadStarted:Date.now(),uploadComplete:!1,percentage:0,bytesUploaded:0})})});var e=c(this._calculateProgress,100,{leading:!0,trailing:!1});this.on("upload-progress",e),this.on("upload-success",function(e,n,o){t.setFileState(e,{progress:i({},t.getState().files[e].progress,{uploadComplete:!0,percentage:100}),uploadURL:o,isPaused:!1}),t._calculateTotalProgress()}),this.on("preprocess-progress",function(e,n){t.setFileState(e,{progress:i({},t.getState().files[e].progress,{preprocess:n})})}),this.on("preprocess-complete",function(e){var n=i({},t.getState().files);n[e]=i({},n[e],{progress:i({},n[e].progress)}),delete n[e].progress.preprocess,t.setState({files:n})}),this.on("postprocess-progress",function(e,n){t.setFileState(e,{progress:i({},t.getState().files[e].progress,{postprocess:n})})}),this.on("postprocess-complete",function(e){var n=i({},t.getState().files);n[e]=i({},n[e],{progress:i({},n[e].progress)}),delete n[e].progress.postprocess,t.setState({files:n})}),this.on("restored",function(){t._calculateTotalProgress()}),"undefined"!=typeof window&&(window.addEventListener("online",function(){return t.updateOnlineStatus()}),window.addEventListener("offline",function(){return t.updateOnlineStatus()}),setTimeout(function(){return t.updateOnlineStatus()},3e3))},t.prototype.updateOnlineStatus=function(){void 0===window.navigator.onLine||window.navigator.onLine?(this.emit("is-online"),this.wasOffline&&(this.emit("back-online"),this.info("Connected!","success",3e3),this.wasOffline=!1)):(this.emit("is-offline"),this.info("No internet connection","error",0),this.wasOffline=!0)},t.prototype.getID=function(){return this.opts.id},t.prototype.use=function(t,e){if("function"!=typeof t){var n="Expected a plugin class, but got "+(null===t?"null":void 0===t?"undefined":r(t))+". Please verify that the plugin was imported and spelled correctly.";throw new TypeError(n)}var o=new t(this,e),i=o.id;if(this.plugins[o.type]=this.plugins[o.type]||[],!i)throw new Error("Your plugin must have an id");if(!o.type)throw new Error("Your plugin must have a type");var s=this.getPlugin(i);if(s){var a="Already found a plugin named '"+s.id+"'.\n        Tried to use: '"+i+"'.\n        Uppy is currently limited to running one of every plugin.\n        Share your use case with us over at\n        https://github.com/transloadit/uppy/issues/\n        if you want us to reconsider.";throw new Error(a)}return this.plugins[o.type].push(o),o.install(),this},t.prototype.getPlugin=function(t){var e=!1;return this.iteratePlugins(function(n){if(n.id===t)return e=n,!1}),e},t.prototype.iteratePlugins=function(t){var e=this;Object.keys(this.plugins).forEach(function(n){e.plugins[n].forEach(t)})},t.prototype.removePlugin=function(t){var e=this.plugins[t.type];t.uninstall&&t.uninstall();var n=e.indexOf(t);-1!==n&&e.splice(n,1)},t.prototype.close=function(){this.reset(),this._storeUnsubscribe(),this.iteratePlugins(function(t){t.uninstall()})},t.prototype.info=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"info",n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:3e3,o="object"===(void 0===t?"undefined":r(t));if(this.setState({info:{isHidden:!1,type:e,message:o?t.message:t,details:o?t.details:null}}),this.emit("info-visible"),window.clearTimeout(this.infoTimeoutID),0===n)return void(this.infoTimeoutID=void 0);this.infoTimeoutID=setTimeout(this.hideInfo,n)},t.prototype.hideInfo=function(){var t=i({},this.getState().info,{isHidden:!0});this.setState({info:t}),this.emit("info-hidden")},t.prototype.log=function(t,n){if(this.opts.debug){var o="[Uppy] ["+a.getTimeStamp()+"] "+t;return e.uppyLog=e.uppyLog+"\nDEBUG LOG: "+t,"error"===n?void console.error(o):"warning"===n?void console.warn(o):void(t===""+t?console.log(o):(o="[Uppy] ["+a.getTimeStamp()+"]",console.log(o),console.dir(t)))}},t.prototype.run=function(){return this.log("Core is run, initializing actions..."),this.actions(),this},t.prototype.restore=function(t){return this.log('Core: attempting to restore upload "'+t+'"'),this.getState().currentUploads[t]?this._runUpload(t):(this._removeUpload(t),Promise.reject(new Error("Nonexistent upload")))},t.prototype._createUpload=function(t){var e,n=p();return this.emit("upload",{id:n,fileIDs:t}),this.setState({currentUploads:i({},this.getState().currentUploads,(e={},e[n]={fileIDs:t,step:0},e))}),n},t.prototype._removeUpload=function(t){var e=i({},this.getState().currentUploads);delete e[t],this.setState({currentUploads:e})},t.prototype._runUpload=function(t){var e=this,n=this.getState().currentUploads[t],o=n.fileIDs,r=n.step,s=[].concat(this.preProcessors,this.uploaders,this.postProcessors),a=Promise.resolve();return s.forEach(function(n,s){s<r||(a=a.then(function(){var r,a=e.getState(),l=a.currentUploads,u=i({},l[t],{step:s});return e.setState({currentUploads:i({},l,(r={},r[t]=u,r))}),n(o,t)}))}),a.catch(function(n){e.emit("error",n),e._removeUpload(t)}),a.then(function(){var n=o.map(function(t){return e.getFile(t)}),r=n.filter(function(t){return t&&!t.error}),i=n.filter(function(t){return t&&t.error});return e.emit("complete",{successful:r,failed:i}),e.emit("success",o),e._removeUpload(t),{successful:r,failed:i}})},t.prototype.upload=function(){var t=this;return this.plugins.uploader||this.log("No uploader type plugins are used","warning"),this._checkMinNumberOfFiles()?Promise.resolve().then(function(){return t.opts.onBeforeUpload(t.getState().files)}).catch(function(e){var n="object"===(void 0===e?"undefined":r(e))?e.message:e;return t.info(n,"error",5e3),Promise.reject(new Error("onBeforeUpload: "+n))}).then(function(){var e=[];Object.keys(t.getState().files).forEach(function(n){var o=t.getFile(n);o.progress.uploadStarted||e.push(o.id)});var n=t._createUpload(e);return t._runUpload(n)}):Promise.reject(new Error("Minimum number of files has not been reached"))},s(t,[{key:"state",get:function(){return this.getState()}}]),t}();t.exports=function(t){return new m(t)},t.exports.Uppy=m}).call(e,n(8))},function(t,e,n){"use strict";var o=n(24);t.exports=o},function(t,e,n){"use strict";var o=n(30),r=n(31),i=n(27),s=n(6),a=n(1),l=a.isTouchDevice,u=n(2),p=u.closeIcon,c=n(0),d=c.h,f=function(t){return d("div",{style:{width:"100%",height:"100%"}},d("div",{class:"uppy-DashboardContent-bar"},d("div",{class:"uppy-DashboardContent-title"},t.i18n("importFrom")," ",t.activePanel?t.activePanel.name:null),d("button",{class:"uppy-DashboardContent-back",type:"button",onclick:t.hideAllPanels},t.i18n("done"))),t.getPlugin(t.activePanel.id).render(t.state))};t.exports=function(t){var e=s("uppy","uppy-Dashboard",{"Uppy--isTouchDevice":l()},{"uppy-Dashboard--semiTransparent":t.semiTransparent},{"uppy-Dashboard--modal":!t.inline},{"uppy-Dashboard--wide":t.isWide});return d("div",{class:e,"aria-hidden":t.inline?"false":t.modal.isHidden,"aria-label":t.inline?t.i18n("dashboardTitle"):t.i18n("dashboardWindowTitle"),onpaste:t.handlePaste},d("div",{class:"uppy-Dashboard-overlay",tabindex:"-1",onclick:t.handleClickOutside}),d("div",{class:"uppy-Dashboard-inner","aria-modal":!t.inline&&"true",role:!t.inline&&"dialog",style:{maxWidth:t.inline&&t.maxWidth?t.maxWidth:"",maxHeight:t.inline&&t.maxHeight?t.maxHeight:""}},d("button",{class:"uppy-Dashboard-close",type:"button","aria-label":t.i18n("closeModal"),title:t.i18n("closeModal"),onclick:t.closeModal},p()),d("div",{class:"uppy-Dashboard-innerWrap"},d(r,t),d(i,t),d("div",{class:"uppy-Dashboard-filesContainer"},d(o,t)),d("div",{class:"uppy-DashboardContent-panel",role:"tabpanel",id:t.activePanel&&"uppy-DashboardContent-panel--"+t.activePanel.id,"aria-hidden":t.activePanel?"false":"true"},t.activePanel&&f(t)),d("div",{class:"uppy-Dashboard-progressindicators"},t.progressindicators.map(function(e){return t.getPlugin(e.id).render(t.state)})))))}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=n(12),a=n(2),l=a.checkIcon,u=n(0),p=u.h,c=u.Component;t.exports=function(t){function e(n){o(this,e);var i=r(this,t.call(this,n));return i.meta={},i.tempStoreMetaOrSubmit=i.tempStoreMetaOrSubmit.bind(i),i.renderMetaFields=i.renderMetaFields.bind(i),i.handleClick=i.handleClick.bind(i),i}return i(e,t),e.prototype.tempStoreMetaOrSubmit=function(t){var e=this.props.files[this.props.fileCardFor];if(13===t.keyCode)return t.stopPropagation(),t.preventDefault(),void this.props.fileCardDone(this.meta,e.id);var n=t.target.value,o=t.target.dataset.name;this.meta[o]=n},e.prototype.renderMetaFields=function(t){var e=this;return(this.props.metaFields||[]).map(function(n){return p("fieldset",{class:"uppy-DashboardFileCard-fieldset"},p("label",{class:"uppy-DashboardFileCard-label"},n.name),p("input",{class:"uppy-DashboardFileCard-input",type:"text","data-name":n.id,value:t.meta[n.id],placeholder:n.placeholder,onkeyup:e.tempStoreMetaOrSubmit,onkeydown:e.tempStoreMetaOrSubmit,onkeypress:e.tempStoreMetaOrSubmit}))})},e.prototype.handleClick=function(t){var e=this.props.files[this.props.fileCardFor];this.props.fileCardDone(this.meta,e.id)},e.prototype.render=function(){var t=this.props.files[this.props.fileCardFor];return p("div",{class:"uppy-DashboardFileCard","aria-hidden":!this.props.fileCardFor},this.props.fileCardFor&&p("div",{style:"width: 100%; height: 100%;"},p("div",{class:"uppy-DashboardContent-bar"},p("h2",{class:"uppy-DashboardContent-title"},"Editing ",p("span",{class:"uppy-DashboardContent-titleFile"},t.meta?t.meta.name:t.name)),p("button",{class:"uppy-DashboardContent-back",type:"button",title:"Finish editing file",onclick:this.handleClick},"Done")),p("div",{class:"uppy-DashboardFileCard-inner"},p("div",{class:"uppy-DashboardFileCard-preview",style:{backgroundColor:s(t.type).color}},t.preview?p("img",{alt:t.name,src:t.preview}):p("div",{class:"uppy-DashboardItem-previewIconWrap"},p("span",{class:"uppy-DashboardItem-previewIcon",style:{color:s(t.type).color}},s(t.type).icon),p("svg",{class:"uppy-DashboardItem-previewIconBg",width:"72",height:"93",viewBox:"0 0 72 93"},p("g",null,p("path",{d:"M24.08 5h38.922A2.997 2.997 0 0 1 66 8.003v74.994A2.997 2.997 0 0 1 63.004 86H8.996A2.998 2.998 0 0 1 6 83.01V22.234L24.08 5z",fill:"#FFF"}),p("path",{d:"M24 5L6 22.248h15.007A2.995 2.995 0 0 0 24 19.244V5z",fill:"#E4E4E4"}))))),p("div",{class:"uppy-DashboardFileCard-info"},p("fieldset",{class:"uppy-DashboardFileCard-fieldset"},p("label",{class:"uppy-DashboardFileCard-label"},"Name"),p("input",{class:"uppy-DashboardFileCard-input",type:"text","data-name":"name",value:t.meta.name||"",placeholder:"name",onkeyup:this.tempStoreMetaOrSubmit,onkeydown:this.tempStoreMetaOrSubmit,onkeypress:this.tempStoreMetaOrSubmit})),this.renderMetaFields(t))),p("div",{class:"uppy-Dashboard-actions"},p("button",{class:"UppyButton--circular UppyButton--blue uppy-DashboardFileCard-done",type:"button",title:"Finish editing file",onclick:this.handleClick},l()))))},e}(c)},function(t,e,n){"use strict";var o=n(1),r=o.getETA,i=o.getSpeed,s=o.prettyETA,a=o.getFileNameAndExtension,l=o.truncateString,u=o.copyToClipboard,p=n(3),c=n(29),d=n(12),f=n(2),h=f.iconEdit,m=f.iconCopy,y=f.iconRetry,g=n(6),v=n(0),b=v.h;t.exports=function(t){var e=t.file,n=t.acquirers,o=e.progress.preprocess||e.progress.postprocess,f=e.progress.uploadComplete&&!o&&!e.error,v=e.progress.uploadStarted||o,w=e.progress.uploadStarted&&!e.progress.uploadComplete||o,x=e.isPaused||!1,S=e.error||!1,P=a(e.meta.name).name,_=t.isWide?l(P,14):P,C=function(n){if(!f)return S?void t.retryUpload(e.id):void(t.resumableUploads?t.pauseUpload(e.id):t.cancelUpload(e.id))},U=g("uppy-DashboardItem",{"is-inprogress":w},{"is-processing":o},{"is-complete":f},{"is-paused":x},{"is-error":S},{"is-resumable":t.resumableUploads});return b("li",{class:U,id:"uppy_"+e.id,title:e.meta.name},b("div",{class:"uppy-DashboardItem-preview"},b("div",{class:"uppy-DashboardItem-previewInnerWrap",style:{backgroundColor:d(e.type).color}},e.preview?b("img",{alt:e.name,src:e.preview}):b("div",{class:"uppy-DashboardItem-previewIconWrap"},b("span",{class:"uppy-DashboardItem-previewIcon",style:{color:d(e.type).color}},d(e.type).icon),b("svg",{class:"uppy-DashboardItem-previewIconBg",width:"72",height:"93",viewBox:"0 0 72 93"},b("g",null,b("path",{d:"M24.08 5h38.922A2.997 2.997 0 0 1 66 8.003v74.994A2.997 2.997 0 0 1 63.004 86H8.996A2.998 2.998 0 0 1 6 83.01V22.234L24.08 5z",fill:"#FFF"}),b("path",{d:"M24 5L6 22.248h15.007A2.995 2.995 0 0 0 24 19.244V5z",fill:"#E4E4E4"}))))),b("div",{class:"uppy-DashboardItem-progress"},f?b("div",{class:"uppy-DashboardItem-progressIndicator"},c({progress:e.progress.percentage,fileID:e.id})):b("button",{class:"uppy-DashboardItem-progressIndicator",type:"button",title:f?"upload complete":t.resumableUploads?e.isPaused?"resume upload":"pause upload":"cancel upload",onclick:C},S?y():c({progress:e.progress.percentage,fileID:e.id})),t.showProgressDetails&&b("div",{class:"uppy-DashboardItem-progressInfo",title:t.i18n("fileProgress"),"aria-label":t.i18n("fileProgress")},!e.isPaused&&!f&&b("span",null,s(r(e.progress))," ・ ↑ ",p(i(e.progress)),"/s")))),b("div",{class:"uppy-DashboardItem-info"},b("h4",{class:"uppy-DashboardItem-name",title:P},e.uploadURL?b("a",{href:e.uploadURL,target:"_blank"},e.extension?_+"."+e.extension:_):e.extension?_+"."+e.extension:_),b("div",{class:"uppy-DashboardItem-status"},e.data.size&&b("div",{class:"uppy-DashboardItem-statusSize"},p(e.data.size)),e.source&&b("div",{class:"uppy-DashboardItem-sourceIcon"},n.map(function(n){if(n.id===e.source)return b("span",{title:t.i18n("fileSource")+": "+n.name},n.icon())}))),!v&&b("button",{class:"uppy-DashboardItem-edit",type:"button","aria-label":"Edit file",title:"Edit file",onclick:function(n){return t.showFileCard(e.id)}},h()),e.uploadURL&&b("button",{class:"uppy-DashboardItem-copyLink",type:"button","aria-label":"Copy link",title:"Copy link",onclick:function(){u(e.uploadURL,t.i18n("copyLinkToClipboardFallback")).then(function(){t.log("Link copied to clipboard."),t.info(t.i18n("copyLinkToClipboardSuccess"),"info",3e3)}).catch(t.log)}},m())),b("div",{class:"uppy-DashboardItem-action"},!f&&b("button",{class:"uppy-DashboardItem-remove",type:"button","aria-label":"Remove file",title:"Remove file",onclick:function(){return t.removeFile(e.id)}},b("svg",{"aria-hidden":"true",class:"UppyIcon",width:"60",height:"60",viewBox:"0 0 60 60",xmlns:"http://www.w3.org/2000/svg"},b("path",{stroke:"#FFF","stroke-width":"1","fill-rule":"nonzero","vector-effect":"non-scaling-stroke",d:"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z"}),b("path",{fill:"#FFF","vector-effect":"non-scaling-stroke",d:"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z"})))))}},function(t,e,n){"use strict";var o=n(0),r=o.h,i=2*Math.PI*15;t.exports=function(t){return r("svg",{width:"70",height:"70",viewBox:"0 0 36 36",class:"UppyIcon UppyIcon-progressCircle"},r("g",{class:"progress-group"},r("circle",{r:"15",cx:"18",cy:"18","stroke-width":"2",fill:"none",class:"bg"}),r("circle",{r:"15",cx:"18",cy:"18",transform:"rotate(-90, 18, 18)","stroke-width":"2",fill:"none",class:"progress","stroke-dasharray":i,"stroke-dashoffset":i-i/100*t.progress})),r("polygon",{transform:"translate(3, 3)",points:"12 20 12 10 20 15",class:"play"}),r("g",{transform:"translate(14.5, 13)",class:"pause"},r("rect",{x:"0",y:"0",width:"2",height:"10",rx:"0"}),r("rect",{x:"5",y:"0",width:"2",height:"10",rx:"0"})),r("polygon",{transform:"translate(2, 3)",points:"14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634",class:"check"}),r("polygon",{class:"cancel",transform:"translate(2, 2)",points:"19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"}))}},function(t,e,n){"use strict";var o=n(28),r=n(11),i=n(2),s=i.dashboardBgIcon,a=n(6),l=n(0),u=l.h;t.exports=function(t){var e=0===t.totalFileCount,n=a("uppy-Dashboard-files",{"uppy-Dashboard-files--noFiles":e});return u("ul",{class:n},e&&u("div",{class:"uppy-Dashboard-bgIcon"},s(),u("h3",{class:"uppy-Dashboard-dropFilesTitle"},u(r,{acquirers:t.acquirers,handleInputChange:t.handleInputChange,i18n:t.i18n})),t.note&&u("p",{class:"uppy-Dashboard-note"},t.note)),Object.keys(t.files).map(function(e){return o({acquirers:t.acquirers,file:t.files[e],showFileCard:t.showFileCard,showProgressDetails:t.showProgressDetails,info:t.info,log:t.log,i18n:t.i18n,removeFile:t.removeFile,pauseUpload:t.pauseUpload,cancelUpload:t.cancelUpload,retryUpload:t.retryUpload,resumableUploads:t.resumableUploads,isWide:t.isWide})}))}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=n(11),a=n(2),l=a.localIcon,u=n(0),p=u.h,c=u.Component,d=function(t){function e(n){o(this,e);var i=r(this,t.call(this,n));return i.handleClick=i.handleClick.bind(i),i}return i(e,t),e.prototype.handleClick=function(t){this.input.click()},e.prototype.render=function(){var t=this,e=0===Object.keys(this.props.files).length;return 0!==this.props.acquirers.length?p("div",{class:"uppy-DashboardTabs"},p("ul",{class:"uppy-DashboardTabs-list",role:"tablist"},p("li",{class:"uppy-DashboardTab",role:"presentation"},p("button",{type:"button",class:"uppy-DashboardTab-btn",role:"tab",tabindex:"0",onclick:this.handleClick},l(),p("div",{class:"uppy-DashboardTab-name"},this.props.i18n("myDevice"))),p("input",{class:"uppy-Dashboard-input",hidden:"true","aria-hidden":"true",tabindex:"-1",type:"file",name:"files[]",multiple:"true",onchange:this.props.handleInputChange,ref:function(e){t.input=e}})),this.props.acquirers.map(function(e){return p("li",{class:"uppy-DashboardTab",role:"presentation"},p("button",{class:"uppy-DashboardTab-btn",type:"button",role:"tab",tabindex:"0","aria-controls":"uppy-DashboardContent-panel--"+e.id,"aria-selected":t.props.activePanel.id===e.id,onclick:function(){return t.props.showPanel(e.id)}},e.icon(),p("h5",{class:"uppy-DashboardTab-name"},e.name)))}))):p("div",{class:"uppy-DashboardTabs","aria-hidden":e},p("div",{class:"uppy-DashboardTabs-title"},p(s,{acquirers:this.props.acquirers,handleInputChange:this.props.handleInputChange,i18n:this.props.i18n})))},e}(c);t.exports=d},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},a=n(4),l=n(5),u=n(17),p=n(26),c=n(35),d=n(33),f=n(1),h=f.findAllDOMElements,m=f.toArray,y=n(3),g=n(2),v=g.defaultTabIcon,b=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([hidden])',"select:not([disabled])","textarea:not([disabled])","button:not([disabled])","iframe","object","embed","[contenteditable]",'[tabindex]:not([tabindex^="-"])'];t.exports=function(t){function e(n,i){o(this,e);var a=r(this,t.call(this,n,i));a.id=a.opts.id||"Dashboard",a.title="Dashboard",a.type="orchestrator";var u={strings:{selectToUpload:"Select files to upload",closeModal:"Close Modal",upload:"Upload",importFrom:"Import files from",dashboardWindowTitle:"Uppy Dashboard Window (Press escape to close)",dashboardTitle:"Uppy Dashboard",copyLinkToClipboardSuccess:"Link copied to clipboard.",copyLinkToClipboardFallback:"Copy the URL below",fileSource:"File source",done:"Done",localDisk:"Local Disk",myDevice:"My Device",dropPasteImport:"Drop files here, paste, import from one of the locations above or",dropPaste:"Drop files here, paste or",browse:"browse",fileProgress:"File progress: upload speed and ETA",numberOfSelectedFiles:"Number of selected files",uploadAllNewFiles:"Upload all new files",emptyFolderAdded:"No files were added from empty folder",folderAdded:{0:"Added %{smart_count} file from %{folder}",1:"Added %{smart_count} files from %{folder}"}}},p={target:"body",metaFields:[],trigger:"#uppy-select-files",inline:!1,width:750,height:550,semiTransparent:!1,defaultTabIcon:v,showProgressDetails:!1,hideUploadButton:!1,hideProgressAfterFinish:!1,note:null,closeModalOnClickOutside:!1,locale:u,onRequestCloseModal:function(){return a.closeModal()}};return a.opts=s({},p,i),a.locale=s({},u,a.opts.locale),a.locale.strings=s({},u.strings,a.opts.locale.strings),a.translator=new l({locale:a.locale}),a.i18n=a.translator.translate.bind(a.translator),a.closeModal=a.closeModal.bind(a),a.requestCloseModal=a.requestCloseModal.bind(a),a.openModal=a.openModal.bind(a),a.isModalOpen=a.isModalOpen.bind(a),a.addTarget=a.addTarget.bind(a),a.hideAllPanels=a.hideAllPanels.bind(a),a.showPanel=a.showPanel.bind(a),a.getFocusableNodes=a.getFocusableNodes.bind(a),a.setFocusToFirstNode=a.setFocusToFirstNode.bind(a),a.maintainFocus=a.maintainFocus.bind(a),a.initEvents=a.initEvents.bind(a),a.onKeydown=a.onKeydown.bind(a),a.handleClickOutside=a.handleClickOutside.bind(a),a.handleFileCard=a.handleFileCard.bind(a),a.handleDrop=a.handleDrop.bind(a),a.handlePaste=a.handlePaste.bind(a),a.handleInputChange=a.handleInputChange.bind(a),a.updateDashboardElWidth=a.updateDashboardElWidth.bind(a),a.render=a.render.bind(a),a.install=a.install.bind(a),a}return i(e,t),e.prototype.addTarget=function(t){var e=t.id||t.constructor.name,n=t.title||e,o=t.type;if("acquirer"!==o&&"progressindicator"!==o&&"presenter"!==o){return void this.uppy.log("Dashboard: Modal can only be used by plugins of types: acquirer, progressindicator, presenter")}var r={id:e,name:n,type:o},i=this.getPluginState(),s=i.targets.slice();return s.push(r),this.setPluginState({targets:s}),this.el},e.prototype.hideAllPanels=function(){this.setPluginState({activePanel:!1})},e.prototype.showPanel=function(t){var e=this.getPluginState(),n=e.targets,o=n.filter(function(e){return"acquirer"===e.type&&e.id===t})[0];this.setPluginState({activePanel:o})},e.prototype.requestCloseModal=function(){if(this.opts.onRequestCloseModal)return this.opts.onRequestCloseModal();this.closeModal()},e.prototype.getFocusableNodes=function(){var t=this.el.querySelectorAll(b);return Object.keys(t).map(function(e){return t[e]})},e.prototype.setFocusToFirstNode=function(){var t=this.getFocusableNodes();t.length&&t[0].focus()},e.prototype.maintainFocus=function(t){var e=this.getFocusableNodes(),n=e.indexOf(document.activeElement);t.shiftKey&&0===n&&(e[e.length-1].focus(),t.preventDefault()),t.shiftKey||n!==e.length-1||(e[0].focus(),t.preventDefault())},e.prototype.openModal=function(){this.setPluginState({isHidden:!1}),this.savedDocumentScrollPosition=window.scrollY,document.body.classList.add("uppy-Dashboard-isOpen"),document.body.style.top="-"+this.savedDocumentScrollPosition+"px",this.updateDashboardElWidth(),this.setFocusToFirstNode()},e.prototype.closeModal=function(){this.setPluginState({isHidden:!0}),document.body.classList.remove("uppy-Dashboard-isOpen"),window.scrollTo(0,this.savedDocumentScrollPosition)},e.prototype.isModalOpen=function(){return!this.getPluginState().isHidden||!1},e.prototype.onKeydown=function(t){27===t.keyCode&&this.requestCloseModal(t),9===t.keyCode&&this.maintainFocus(t)},e.prototype.handleClickOutside=function(){this.opts.closeModalOnClickOutside&&this.requestCloseModal()},e.prototype.handlePaste=function(t){var e=this;m(t.clipboardData.items).forEach(function(t){if("file"===t.kind){var n=t.getAsFile();if(!n)return e.uppy.log("[Dashboard] File pasted, but the file blob is empty"),void e.uppy.info("Error pasting file","error");e.uppy.log("[Dashboard] File pasted"),e.uppy.addFile({source:e.id,name:t.name,type:t.type,data:n})}})},e.prototype.handleInputChange=function(t){var e=this;t.preventDefault(),m(t.target.files).forEach(function(t){e.uppy.addFile({source:e.id,name:t.name,type:t.type,data:t})})},e.prototype.initEvents=function(){var t=this,e=h(this.opts.trigger);!this.opts.inline&&e&&e.forEach(function(e){return e.addEventListener("click",t.openModal)}),this.opts.inline||e||this.uppy.log("Dashboard modal trigger not found, you won’t be able to select files. Make sure `trigger` is set correctly in Dashboard options","error"),this.opts.inline||document.addEventListener("keydown",this.onKeydown),this.removeDragDropListener=u(this.el,function(e){t.handleDrop(e)}),this.uppy.on("dashboard:file-card",this.handleFileCard),this.updateDashboardElWidth(),window.addEventListener("resize",this.updateDashboardElWidth)},e.prototype.removeEvents=function(){var t=this,e=h(this.opts.trigger);!this.opts.inline&&e&&e.forEach(function(e){return e.removeEventListener("click",t.openModal)}),this.opts.inline||document.removeEventListener("keydown",this.onKeydown),this.removeDragDropListener(),this.uppy.off("dashboard:file-card",this.handleFileCard),window.removeEventListener("resize",this.updateDashboardElWidth)},e.prototype.updateDashboardElWidth=function(){var t=this.el.querySelector(".uppy-Dashboard-inner");this.uppy.log("Dashboard width: "+t.offsetWidth),this.setPluginState({containerWidth:t.offsetWidth})},e.prototype.handleFileCard=function(t){this.setPluginState({fileCardFor:t||!1})},e.prototype.handleDrop=function(t){var e=this;this.uppy.log("[Dashboard] Files were dropped"),t.forEach(function(t){e.uppy.addFile({source:e.id,name:t.name,type:t.type,data:t})})},e.prototype.render=function(t){var e=this,n=this.getPluginState(),o=t.files,r=Object.keys(o).filter(function(t){return!o[t].progress.uploadStarted}),i=Object.keys(o).filter(function(t){return!o[t].progress.uploadComplete&&o[t].progress.uploadStarted&&!o[t].isPaused}),a=[];i.forEach(function(t){a.push(o[t])});var l=0,u=0;a.forEach(function(t){l+=t.progress.bytesTotal||0,u+=t.progress.bytesUploaded||0}),l=y(l),u=y(u);var c=function(t){var n=e.uppy.getPlugin(t.id);return s({},t,{icon:n.icon||e.opts.defaultTabIcon,render:n.render})},d=function(t){var n=e.uppy.getPlugin(t.id);return"function"!=typeof n.isSupported||n.isSupported()},f=n.targets.filter(function(t){return"acquirer"===t.type&&d(t)}).map(c),h=n.targets.filter(function(t){return"progressindicator"===t.type}).map(c),m=function(t){e.uppy.upload().catch(function(t){e.uppy.log(t.stack||t.message||t)})},g=function(t){e.uppy.emit("upload-cancel",t),e.uppy.removeFile(t)},v=function(t){e.uppy.emit("dashboard:file-card",t)},b=function(t,n){e.uppy.setFileMeta(n,t),e.uppy.emit("dashboard:file-card")};return p({state:t,modal:n,newFiles:r,files:o,totalFileCount:Object.keys(o).length,totalProgress:t.totalProgress,acquirers:f,activePanel:n.activePanel,getPlugin:this.uppy.getPlugin,progressindicators:h,autoProceed:this.uppy.opts.autoProceed,hideUploadButton:this.opts.hideUploadButton,id:this.id,closeModal:this.requestCloseModal,handleClickOutside:this.handleClickOutside,handleInputChange:this.handleInputChange,handlePaste:this.handlePaste,showProgressDetails:this.opts.showProgressDetails,inline:this.opts.inline,showPanel:this.showPanel,hideAllPanels:this.hideAllPanels,log:this.uppy.log,i18n:this.i18n,addFile:this.uppy.addFile,removeFile:this.uppy.removeFile,info:this.uppy.info,note:this.opts.note,metaFields:this.getPluginState().metaFields,resumableUploads:this.uppy.state.capabilities.resumableUploads||!1,startUpload:m,pauseUpload:this.uppy.pauseResume,retryUpload:this.uppy.retryUpload,cancelUpload:g,fileCardFor:n.fileCardFor,showFileCard:v,fileCardDone:b,updateDashboardElWidth:this.updateDashboardElWidth,maxWidth:this.opts.maxWidth,maxHeight:this.opts.maxHeight,currentWidth:n.containerWidth,isWide:n.containerWidth>400})},e.prototype.discoverProviderPlugins=function(){var t=this;this.uppy.iteratePlugins(function(e){e&&!e.target&&e.opts&&e.opts.target===t.constructor&&t.addTarget(e)})},e.prototype.install=function(){var t=this;this.setPluginState({isHidden:!0,showFileCard:!1,activePanel:!1,metaFields:this.opts.metaFields,targets:[]});var e=this.opts.target;e&&this.mount(e,this),(this.opts.plugins||[]).forEach(function(e){var n=t.uppy.getPlugin(e);n&&n.mount(t,n)}),this.opts.disableStatusBar||this.uppy.use(c,{target:this,hideUploadButton:this.opts.hideUploadButton,hideAfterFinish:this.opts.hideProgressAfterFinish}),this.opts.disableInformer||this.uppy.use(d,{target:this}),this.discoverProviderPlugins(),this.initEvents()},e.prototype.uninstall=function(){var t=this;if(!this.opts.disableInformer){var e=this.uppy.getPlugin("Informer");e&&this.uppy.removePlugin(e)}if(!this.opts.disableStatusBar){var n=this.uppy.getPlugin("StatusBar");n&&this.uppy.removePlugin(n)}(this.opts.plugins||[]).forEach(function(e){var n=t.uppy.getPlugin(e);n&&n.unmount()}),this.unmount(),this.removeEvents()},e}(a)},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},a=n(4),l=n(0),u=l.h;t.exports=function(t){function e(n,i){o(this,e);var a=r(this,t.call(this,n,i));a.type="progressindicator",a.id=a.opts.id||"Informer",a.title="Informer";var l={typeColors:{info:{text:"#fff",bg:"#000"},warning:{text:"#fff",bg:"#F6A623"},error:{text:"#fff",bg:"#e74c3c"},success:{text:"#fff",bg:"#7ac824"}}};return a.opts=s({},l,i),a.render=a.render.bind(a),a}return i(e,t),e.prototype.render=function(t){var e=t.info,n=e.isHidden,o=e.type,r=e.message,i=e.details,s={backgroundColor:this.opts.typeColors[o].bg,color:this.opts.typeColors[o].text};return u("div",{class:"uppy uppy-Informer",style:s,"aria-hidden":n},u("p",{role:"alert"},r," ",i&&u("span",{style:{color:this.opts.typeColors[o].bg},"data-balloon":i,"data-balloon-pos":"up","data-balloon-length":"large"},"?")))},e.prototype.install=function(){var t=this.opts.target;t&&this.mount(t,this)},e}(a)},function(t,e,n){"use strict";function o(t){return u("span",null,t.totalProgress||0,"%・",t.complete," / ",t.inProgress,"・",t.totalUploadedSize," / ",t.totalSize,"・↑ ",t.totalSpeed,"/s・",t.totalETA)}function r(t,e){if(t.isAllErrored)return c;if(t.isAllComplete)return y;for(var n=d,o=Object.keys(e),r=0;r<o.length;r++){var i=e[o[r]].progress;if(i.uploadStarted&&!i.uploadComplete)return h;i.preprocess&&n!==h&&(n=f),i.postprocess&&n!==h&&n!==f&&(n=m)}return n}function i(t){function e(t){return"determinate"===t.mode}var n=[];Object.keys(t).forEach(function(e){var o=t[e].progress;o.preprocess&&n.push(o.preprocess),o.postprocess&&n.push(o.postprocess)});var o=n[0];return{mode:o.mode,message:o.message,value:n.filter(e).reduce(function(t,e,n,o){return t+e.value/o.length},0)}}function s(t){if(!t.isAllComplete)return t.resumableUploads?t.isAllPaused?t.resumeAll():t.pauseAll():t.cancelAll()}var a=n(7),l=n(0),u=l.h,p=a(o,500,{leading:!0,trailing:!0}),c="error",d="waiting",f="preprocessing",h="uploading",m="postprocessing",y="complete";t.exports=function(t){t=t||{};var e=r(t,t.files||{}),n=t.totalProgress,o=void 0,s=void 0;if(e===f||e===m){var a=i(t.files);o=a.mode,"determinate"===o&&(n=100*a.value),s=b(a)}else e===y?s=x(t):e===h?s=w(t):e===c&&(n=void 0,s=S(t));var l="number"==typeof n?n:100,p=e===d&&t.hideUploadButton||e===d&&!t.newFiles>0||e===y&&t.hideAfterFinish;return u("div",{class:"uppy uppy-StatusBar is-"+e,"aria-hidden":p},u("div",{class:"uppy-StatusBar-progress\n                           "+(o?"is-"+o:""),style:{width:l+"%"},role:"progressbar","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":n}),s,u("div",{class:"uppy-StatusBar-actions"},t.newFiles&&!t.hideUploadButton?u(g,t):null,t.error?u(v,t):null))};var g=function(t){return u("button",{type:"button",class:"uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--upload","aria-label":t.i18n("uploadXFiles",{smart_count:t.newFiles}),onclick:t.startUpload},t.inProgress?t.i18n("uploadXNewFiles",{smart_count:t.newFiles}):t.i18n("uploadXFiles",{smart_count:t.newFiles}))},v=function(t){return u("button",{type:"button",class:"uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry","aria-label":t.i18n("retryUpload"),onclick:t.retryAll},t.i18n("retry"))},b=function(t){var e=Math.round(100*t.value);return u("div",{class:"uppy-StatusBar-content"},"determinate"===t.mode?e+"%・":"",t.message)},w=function(t){return u("div",{class:"uppy-StatusBar-content"},t.isUploadStarted&&!t.isAllComplete?t.isAllPaused?u("div",{title:"Paused"},u(P,t)," Paused・",t.totalProgress,"%"):u("div",{title:"Uploading"},u(P,t)," Uploading... ",u(p,t)):null)},x=function(t){var e=t.totalProgress,n=t.i18n;return u("div",{class:"uppy-StatusBar-content",role:"status"},u("span",{title:"Complete"},u("svg",{"aria-hidden":"true",class:"uppy-StatusBar-statusIndicator UppyIcon",width:"18",height:"17",viewBox:"0 0 23 17"},u("path",{d:"M8.944 17L0 7.865l2.555-2.61 6.39 6.525L20.41 0 23 2.645z"})),n("uploadComplete"),"・",e,"%"))},S=function(t){var e=t.error,n=(t.retryAll,t.i18n);return u("div",{class:"uppy-StatusBar-content",role:"alert"},u("strong",null,n("uploadFailed"),".")," ",u("span",null,n("pleasePressRetry")),u("span",{class:"uppy-StatusBar-details","data-balloon":e,"data-balloon-pos":"up","data-balloon-length":"large"},"?"))},P=function(t){var e=t.resumableUploads,n=t.isAllPaused,o=t.i18n,r=o(e?n?"resumeUpload":"pauseUpload":"cancelUpload");return u("button",{title:r,class:"uppy-StatusBar-statusIndicator",type:"button",onclick:function(){return s(t)}},e?n?u("svg",{"aria-hidden":"true",class:"UppyIcon",width:"15",height:"17",viewBox:"0 0 11 13"},u("path",{d:"M1.26 12.534a.67.67 0 0 1-.674.012.67.67 0 0 1-.336-.583v-11C.25.724.38.5.586.382a.658.658 0 0 1 .673.012l9.165 5.5a.66.66 0 0 1 .325.57.66.66 0 0 1-.325.573l-9.166 5.5z"})):u("svg",{"aria-hidden":"true",class:"UppyIcon",width:"16",height:"17",viewBox:"0 0 12 13"},u("path",{d:"M4.888.81v11.38c0 .446-.324.81-.722.81H2.722C2.324 13 2 12.636 2 12.19V.81c0-.446.324-.81.722-.81h1.444c.398 0 .722.364.722.81zM9.888.81v11.38c0 .446-.324.81-.722.81H7.722C7.324 13 7 12.636 7 12.19V.81c0-.446.324-.81.722-.81h1.444c.398 0 .722.364.722.81z"})):u("svg",{"aria-hidden":"true",class:"UppyIcon",width:"16px",height:"16px",viewBox:"0 0 19 19"},u("path",{d:"M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"})))}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}var s=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},a=n(4),l=n(5),u=n(34),p=n(1),c=p.getSpeed,d=n(1),f=d.getBytesRemaining,h=n(1),m=h.prettyETA,y=n(3);t.exports=function(t){function e(n,i){o(this,e);var a=r(this,t.call(this,n,i));a.id=a.opts.id||"StatusBar",a.title="StatusBar",a.type="progressindicator";var u={strings:{uploading:"Uploading",uploadComplete:"Upload complete",uploadFailed:"Upload failed",pleasePressRetry:"Please press Retry to upload again",paused:"Paused",error:"Error",retry:"Retry",pressToRetry:"Press to retry",retryUpload:"Retry upload",resumeUpload:"Resume upload",cancelUpload:"Cancel upload",pauseUpload:"Pause upload",uploadXFiles:{0:"Upload %{smart_count} file",1:"Upload %{smart_count} files"},uploadXNewFiles:{0:"Upload +%{smart_count} file",1:"Upload +%{smart_count} files"}}},p={target:"body",hideUploadButton:!1,showProgressDetails:!1,locale:u,hideAfterFinish:!0};return a.opts=s({},p,i),a.locale=s({},u,a.opts.locale),a.locale.strings=s({},u.strings,a.opts.locale.strings),a.translator=new l({locale:a.locale}),a.i18n=a.translator.translate.bind(a.translator),a.render=a.render.bind(a),a.install=a.install.bind(a),a}return i(e,t),e.prototype.getTotalSpeed=function(t){var e=0;return t.forEach(function(t){e+=c(t.progress)}),e},e.prototype.getTotalETA=function(t){var e=this.getTotalSpeed(t);if(0===e)return 0;var n=t.reduce(function(t,e){return t+f(e.progress)},0);return Math.round(n/e*10)/10},e.prototype.render=function(t){var e=t.files,n=Object.keys(e).filter(function(t){return e[t].progress.uploadStarted}),o=Object.keys(e).filter(function(t){return!e[t].progress.uploadStarted}),r=Object.keys(e).filter(function(t){return e[t].progress.uploadComplete}),i=Object.keys(e).filter(function(t){return e[t].error}),s=Object.keys(e).filter(function(t){return!e[t].progress.uploadComplete&&e[t].progress.uploadStarted&&!e[t].isPaused}),a=Object.keys(e).filter(function(t){return e[t].progress.preprocess||e[t].progress.postprocess}),l=[];s.forEach(function(t){l.push(e[t])});var p=y(this.getTotalSpeed(l)),c=m(this.getTotalETA(l)),d=0,f=0;l.forEach(function(t){d+=t.progress.bytesTotal||0,f+=t.progress.bytesUploaded||0}),d=y(d),f=y(f);var h=n.length>0,g=100===t.totalProgress&&r.length===Object.keys(e).length&&0===a.length,v=h&&i.length===n.length,b=0===s.length&&!g&&!v&&n.length>0,w=this.uppy.getState().capabilities.resumableUploads||!1;return u({error:t.error,totalProgress:t.totalProgress,totalSize:d,totalUploadedSize:f,uploadStartedFiles:n,isAllComplete:g,isAllPaused:b,isAllErrored:v,isUploadStarted:h,i18n:this.i18n,pauseAll:this.uppy.pauseAll,resumeAll:this.uppy.resumeAll,retryAll:this.uppy.retryAll,cancelAll:this.uppy.cancelAll,startUpload:this.uppy.upload,complete:r.length,newFiles:o.length,inProgress:n.length,totalSpeed:p,totalETA:c,files:t.files,resumableUploads:w,hideUploadButton:this.opts.hideUploadButton,hideAfterFinish:this.opts.hideAfterFinish})},e.prototype.install=function(){var t=this.opts.target;t&&this.mount(t,this)},e.prototype.uninstall=function(){this.unmount()},e}(a)},function(t,e,n){"use strict";var o=n(0),r=o.h;t.exports=function(t){return r("svg",{"aria-hidden":"true",class:"UppyIcon",width:"100",height:"77",viewBox:"0 0 100 77"},r("path",{d:"M50 32c-7.168 0-13 5.832-13 13s5.832 13 13 13 13-5.832 13-13-5.832-13-13-13z"}),r("path",{d:"M87 13H72c0-7.18-5.82-13-13-13H41c-7.18 0-13 5.82-13 13H13C5.82 13 0 18.82 0 26v38c0 7.18 5.82 13 13 13h74c7.18 0 13-5.82 13-13V26c0-7.18-5.82-13-13-13zM50 68c-12.683 0-23-10.318-23-23s10.317-23 23-23 23 10.318 23 23-10.317 23-23 23z"}))}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){return-1!==t.indexOf(e)}var a=n(0),l=a.h,u=a.Component,p=n(42),c=n(39),d=function(t){function e(){return o(this,e),r(this,t.apply(this,arguments))}return i(e,t),e.prototype.componentDidMount=function(){this.props.onFocus(),this.btnContainer.firstChild.focus()},e.prototype.componentWillUnmount=function(){this.props.onStop()},e.prototype.render=function(){var t=this,e=this.props.supportsRecording&&(s(this.props.modes,"video-only")||s(this.props.modes,"audio-only")||s(this.props.modes,"video-audio")),n=s(this.props.modes,"picture");return l("div",{class:"uppy uppy-Webcam-container"},l("div",{class:"uppy-Webcam-videoContainer"},l("video",{class:"uppy-Webcam-video",autoplay:!0,muted:!0,src:this.props.src||""})),l("div",{class:"uppy-Webcam-buttonContainer",ref:function(e){t.btnContainer=e}},n?p(this.props):null," ",e?c(this.props):null),l("canvas",{class:"uppy-Webcam-canvas",style:"display: none;"}))},e}(u);t.exports=d},function(t,e,n){"use strict";var o=n(0),r=o.h;t.exports=function(t){return r("div",{class:"uppy-Webcam-permissons"},r("h1",{class:"uppy-Webcam-Title"},"Please allow access to your camera"),r("p",null,"You have been prompted to allow camera access from this site.",r("br",null),"In order to take pictures with your camera you must approve this request."))}},function(t,e,n){"use strict";var o=n(40),r=n(41),i=n(0),s=i.h;t.exports=function(t){var e=t.recording,n=t.onStartRecording,i=t.onStopRecording;return e?s("button",{class:"UppyButton--circular UppyButton--red UppyButton--sizeM uppy-Webcam-recordButton",type:"button",title:"Stop Recording","aria-label":"Stop Recording",onclick:i},r()):s("button",{class:"UppyButton--circular UppyButton--red UppyButton--sizeM uppy-Webcam-recordButton",type:"button",title:"Begin Recording","aria-label":"Begin Recording",onclick:n},o())}},function(t,e,n){"use strict";var o=n(0),r=o.h;t.exports=function(t){return r("svg",{"aria-hidden":"true",class:"UppyIcon",width:"100",height:"100",viewBox:"0 0 100 100"},r("circle",{cx:"50",cy:"50",r:"40"}))}},function(t,e,n){"use strict";var o=n(0),r=o.h;t.exports=function(t){return r("svg",{"aria-hidden":"true",class:"UppyIcon",width:"100",height:"100",viewBox:"0 0 100 100"},r("rect",{x:"15",y:"15",width:"70",height:"70"}))}},function(t,e,n){"use strict";var o=n(0),r=o.h,i=n(36);t.exports=function(t){var e=t.onSnapshot;return r("button",{class:"UppyButton--circular UppyButton--red UppyButton--sizeM uppy-Webcam-recordButton",type:"button",title:"Take a snapshot","aria-label":"Take a snapshot",onclick:e},i())}},function(t,e,n){"use strict";var o=n(0),r=o.h;t.exports=function(t){return r("svg",{"aria-hidden":"true",class:"UppyIcon",width:"18",height:"21",viewBox:"0 0 18 21"},r("path",{d:"M14.8 16.9c1.9-1.7 3.2-4.1 3.2-6.9 0-5-4-9-9-9s-9 4-9 9c0 2.8 1.2 5.2 3.2 6.9C1.9 17.9.5 19.4 0 21h3c1-1.9 11-1.9 12 0h3c-.5-1.6-1.9-3.1-3.2-4.1zM9 4c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6z"}),r("path",{d:"M9 14c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zM8 8c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1c0-.5.4-1 1-1z"}))}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function r(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(){if(navigator.mediaDevices&&navigator.mediaDevices.getUserMedia)return navigator.mediaDevices;var t=navigator.mozGetUserMedia||navigator.webkitGetUserMedia;return t?{getUserMedia:function(e){return new u(function(n,o){t.call(navigator,e,n,o)})}}:null}var a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},l=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},u="undefined"==typeof Promise?n(9).Promise:Promise,p=n(0),c=p.h,d=n(4),f=n(5),h=n(1),m=h.getFileTypeExtension,y=h.canvasToBlob,g=n(45),v=n(43),b=n(37),w=n(38);t.exports=function(t){function e(n,i){o(this,e);var a=r(this,t.call(this,n,i));a.mediaDevices=s(),a.supportsUserMedia=!!a.mediaDevices,a.protocol=location.protocol.match(/https/i)?"https":"http",a.id=a.opts.id||"Webcam",a.title="Webcam",a.type="acquirer",a.icon=v;var u={strings:{smile:"Smile!"}},p={onBeforeSnapshot:function(){return Promise.resolve()},countdown:!1,locale:u,modes:["video-audio","video-only","audio-only","picture"]};return a.opts=l({},p,i),a.locale=l({},u,a.opts.locale),a.locale.strings=l({},u.strings,a.opts.locale.strings),a.translator=new f({locale:a.locale}),a.i18n=a.translator.translate.bind(a.translator),a.install=a.install.bind(a),a.setPluginState=a.setPluginState.bind(a),a.render=a.render.bind(a),a.start=a.start.bind(a),a.stop=a.stop.bind(a),a.takeSnapshot=a.takeSnapshot.bind(a),a.startRecording=a.startRecording.bind(a),a.stopRecording=a.stopRecording.bind(a),a.oneTwoThreeSmile=a.oneTwoThreeSmile.bind(a),a.focus=a.focus.bind(a),a.webcamActive=!1,a.opts.countdown&&(a.opts.onBeforeSnapshot=a.oneTwoThreeSmile),a}return i(e,t),e.prototype.isSupported=function(){return!!this.mediaDevices},e.prototype.getConstraints=function(){return{audio:-1!==this.opts.modes.indexOf("video-audio")||-1!==this.opts.modes.indexOf("audio-only"),video:-1!==this.opts.modes.indexOf("video-audio")||-1!==this.opts.modes.indexOf("video-only")||-1!==this.opts.modes.indexOf("picture")}},e.prototype.start=function(){var t=this;if(!this.isSupported())return Promise.reject(new Error("Webcam access not supported"));this.webcamActive=!0;var e=this.getConstraints();return this.mediaDevices.getUserMedia(e).then(function(e){t.stream=e,console.log(e),t.streamSrc=URL.createObjectURL(t.stream),t.setPluginState({cameraReady:!0})}).catch(function(e){t.setPluginState({cameraError:e})})},e.prototype.startRecording=function(){var t=this;this.recorder=new MediaRecorder(this.stream),this.recordingChunks=[],this.recorder.addEventListener("dataavailable",function(e){t.recordingChunks.push(e.data)}),this.recorder.start(),this.setPluginState({isRecording:!0})},e.prototype.stopRecording=function(){var t=this;return new u(function(e,n){t.recorder.addEventListener("stop",function(){e()}),t.recorder.stop()}).then(function(){return t.setPluginState({isRecording:!1}),t.getVideo()}).then(this.uppy.addFile).then(function(){t.recordingChunks=null,t.recorder=null;var e=t.uppy.getPlugin("Dashboard");e&&e.hideAllPanels()},function(e){throw t.recordingChunks=null,t.recorder=null,e})},e.prototype.stop=function(){this.stream.getAudioTracks().forEach(function(t){t.stop()}),this.stream.getVideoTracks().forEach(function(t){t.stop()}),this.webcamActive=!1,this.stream=null,this.streamSrc=null},e.prototype.getVideoElement=function(){return this.el.querySelector(".uppy-Webcam-video")},e.prototype.oneTwoThreeSmile=function(){var t=this;return new u(function(e,n){var o=t.opts.countdown,r=setInterval(function(){if(!t.webcamActive)return clearInterval(r),t.captureInProgress=!1,n(new Error("Webcam is not active"));o>0?(t.uppy.info(o+"...","warning",800),o--):(clearInterval(r),t.uppy.info(t.i18n("smile"),"success",1500),setTimeout(function(){return e()},1500))},1e3)})},e.prototype.takeSnapshot=function(){var t=this;this.captureInProgress||(this.captureInProgress=!0,this.opts.onBeforeSnapshot().catch(function(e){var n="object"===(void 0===e?"undefined":a(e))?e.message:e;return t.uppy.info(n,"error",5e3),Promise.reject(new Error("onBeforeSnapshot: "+n))}).then(function(){return t.getImage()}).then(function(e){t.captureInProgress=!1,t.uppy.addFile(e);var n=t.uppy.getPlugin("Dashboard");n&&n.hideAllPanels()},function(e){throw t.captureInProgress=!1,e}))},e.prototype.getImage=function(){var t=this,e=this.getVideoElement();if(!e)return Promise.reject(new Error("No video element found, likely due to the Webcam tab being closed."));var n="webcam-"+Date.now()+".jpg",o=document.createElement("canvas");return o.width=e.videoWidth,o.height=e.videoHeight,o.getContext("2d").drawImage(e,0,0),y(o,"image/jpeg").then(function(e){return{source:t.id,name:n,data:new File([e],n,{type:"image/jpeg"}),type:"image/jpeg"}})},e.prototype.getVideo=function(){var t=this.recordingChunks[0].type,e=m(t);if(!e)return Promise.reject(new Error('Could not retrieve recording: Unsupported media type "'+t+'"'));var n="webcam-"+Date.now()+"."+e,o=new Blob(this.recordingChunks,{type:t}),r={source:this.id,name:n,data:new File([o],n,{type:t}),type:t};return Promise.resolve(r)},e.prototype.focus=function(){var t=this;this.opts.countdown||setTimeout(function(){t.uppy.info(t.i18n("smile"),"success",1500)},1e3)},e.prototype.render=function(t){this.webcamActive||this.start();var e=this.getPluginState();return e.cameraReady?c(b,l({},e,{onSnapshot:this.takeSnapshot,onStartRecording:this.startRecording,onStopRecording:this.stopRecording,onFocus:this.focus,onStop:this.stop,modes:this.opts.modes,supportsRecording:g(),recording:e.isRecording,src:this.streamSrc})):w(e)},e.prototype.install=function(){this.setPluginState({cameraReady:!1});var t=this.opts.target;t&&this.mount(t,this)},e.prototype.uninstall=function(){this.stream&&this.stop(),this.unmount()},e}(d)},function(t,e,n){"use strict";t.exports=function(){return"function"==typeof MediaRecorder&&!!MediaRecorder.prototype&&"function"==typeof MediaRecorder.prototype.start}},function(t,e,n){"use strict";function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var r=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},i=function(){function t(){o(this,t),this.state={},this.callbacks=[]}return t.prototype.getState=function(){return this.state},t.prototype.setState=function(t){var e=r({},this.state),n=r({},this.state,t);this.state=n,this._publish(e,n,t)},t.prototype.subscribe=function(t){var e=this;return this.callbacks.push(t),function(){e.callbacks.splice(e.callbacks.indexOf(t),1)}},t.prototype._publish=function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];this.callbacks.forEach(function(t){t.apply(void 0,e)})},t}();t.exports=function(){return new i}},function(t,e,n){"use strict";var o=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t};t.exports=function(t){var e=new Uint8Array(t);if(!(e&&e.length>1))return null;var n=function(t,n){n=o({offset:0},n);for(var r=0;r<t.length;r++)if(t[r]!==e[r+n.offset])return!1;return!0};if(n([255,216,255]))return{ext:"jpg",mime:"image/jpeg"};if(n([137,80,78,71,13,10,26,10]))return{ext:"png",mime:"image/png"};if(n([71,73,70]))return{ext:"gif",mime:"image/gif"};if(n([87,69,66,80],{offset:8}))return{ext:"webp",mime:"image/webp"};if(n([70,76,73,70]))return{ext:"flif",mime:"image/flif"};if((n([73,73,42,0])||n([77,77,0,42]))&&n([67,82],{offset:8}))return{ext:"cr2",mime:"image/x-canon-cr2"};if(n([73,73,42,0])||n([77,77,0,42]))return{ext:"tif",mime:"image/tiff"};if(n([66,77]))return{ext:"bmp",mime:"image/bmp"};if(n([73,73,188]))return{ext:"jxr",mime:"image/vnd.ms-photo"};if(n([56,66,80,83]))return{ext:"psd",mime:"image/vnd.adobe.photoshop"};if(n([80,75,3,4])&&n([109,105,109,101,116,121,112,101,97,112,112,108,105,99,97,116,105,111,110,47,101,112,117,98,43,122,105,112],{offset:30}))return{ext:"epub",mime:"application/epub+zip"};if(n([80,75,3,4])&&n([77,69,84,65,45,73,78,70,47,109,111,122,105,108,108,97,46,114,115,97],{offset:30}))return{ext:"xpi",mime:"application/x-xpinstall"};if(n([80,75])&&(3===e[2]||5===e[2]||7===e[2])&&(4===e[3]||6===e[3]||8===e[3]))return{ext:"zip",mime:"application/zip"};if(n([117,115,116,97,114],{offset:257}))return{ext:"tar",mime:"application/x-tar"};if(n([82,97,114,33,26,7])&&(0===e[6]||1===e[6]))return{ext:"rar",mime:"application/x-rar-compressed"};if(n([31,139,8]))return{ext:"gz",mime:"application/gzip"};if(n([66,90,104]))return{ext:"bz2",mime:"application/x-bzip2"};if(n([55,122,188,175,39,28]))return{ext:"7z",mime:"application/x-7z-compressed"};if(n([120,1]))return{ext:"dmg",mime:"application/x-apple-diskimage"};if(n([0,0,0])&&(24===e[3]||32===e[3])&&n([102,116,121,112],{offset:4})||n([51,103,112,53])||n([0,0,0,28,102,116,121,112,109,112,52,50])&&n([109,112,52,49,109,112,52,50,105,115,111,109],{offset:16})||n([0,0,0,28,102,116,121,112,105,115,111,109])||n([0,0,0,28,102,116,121,112,109,112,52,50,0,0,0,0]))return{ext:"mp4",mime:"video/mp4"};if(n([0,0,0,28,102,116,121,112,77,52,86]))return{ext:"m4v",mime:"video/x-m4v"};if(n([77,84,104,100]))return{ext:"mid",mime:"audio/midi"};if(n([26,69,223,163])){var r=e.subarray(4,4100),i=r.findIndex(function(t,e,n){return 66===n[e]&&130===n[e+1]});if(i>=0){var s=i+3,a=function(t){return Array.from(t).every(function(t,e){return r[s+e]===t.charCodeAt(0)})};if(a("matroska"))return{ext:"mkv",mime:"video/x-matroska"};if(a("webm"))return{ext:"webm",mime:"video/webm"}}}return n([0,0,0,20,102,116,121,112,113,116,32,32])||n([102,114,101,101],{offset:4})||n([102,116,121,112,113,116,32,32],{offset:4})||n([109,100,97,116],{offset:4})||n([119,105,100,101],{offset:4})?{ext:"mov",mime:"video/quicktime"}:n([82,73,70,70])&&n([65,86,73],{offset:8})?{ext:"avi",mime:"video/x-msvideo"}:n([48,38,178,117,142,102,207,17,166,217])?{ext:"wmv",mime:"video/x-ms-wmv"}:n([0,0,1,186])?{ext:"mpg",mime:"video/mpeg"}:n([73,68,51])||n([255,251])?{ext:"mp3",mime:"audio/mpeg"}:n([102,116,121,112,77,52,65],{offset:4})||n([77,52,65,32])?{ext:"m4a",mime:"audio/m4a"}:n([79,112,117,115,72,101,97,100],{offset:28})?{ext:"opus",mime:"audio/opus"}:n([79,103,103,83])?{ext:"ogg",mime:"audio/ogg"}:n([102,76,97,67])?{ext:"flac",mime:"audio/x-flac"}:n([82,73,70,70])&&n([87,65,86,69],{offset:8})?{ext:"wav",mime:"audio/x-wav"}:n([35,33,65,77,82,10])?{ext:"amr",mime:"audio/amr"}:n([37,80,68,70])?{ext:"pdf",mime:"application/pdf"}:n([77,90])?{ext:"exe",mime:"application/x-msdownload"}:67!==e[0]&&70!==e[0]||!n([87,83],{offset:1})?n([123,92,114,116,102])?{ext:"rtf",mime:"application/rtf"}:n([0,97,115,109])?{ext:"wasm",mime:"application/wasm"}:n([119,79,70,70])&&(n([0,1,0,0],{offset:4})||n([79,84,84,79],{offset:4}))?{ext:"woff",mime:"font/woff"}:n([119,79,70,50])&&(n([0,1,0,0],{offset:4})||n([79,84,84,79],{offset:4}))?{ext:"woff2",mime:"font/woff2"}:n([76,80],{offset:34})&&(n([0,0,1],{offset:8})||n([1,0,2],{offset:8})||n([2,0,2],{offset:8}))?{ext:"eot",mime:"application/octet-stream"}:n([0,1,0,0,0])?{ext:"ttf",mime:"font/ttf"}:n([79,84,84,79,0])?{ext:"otf",mime:"font/otf"}:n([0,0,1,0])?{ext:"ico",mime:"image/x-icon"}:n([70,76,86,1])?{ext:"flv",mime:"video/x-flv"}:n([37,33])?{ext:"ps",mime:"application/postscript"}:n([253,55,122,88,90,0])?{ext:"xz",mime:"application/x-xz"}:n([83,81,76,105])?{ext:"sqlite",mime:"application/x-sqlite3"}:n([78,69,83,26])?{ext:"nes",mime:"application/x-nintendo-nes-rom"}:n([67,114,50,52])?{ext:"crx",mime:"application/x-google-chrome-extension"}:n([77,83,67,70])||n([73,83,99,40])?{ext:"cab",mime:"application/vnd.ms-cab-compressed"}:n([33,60,97,114,99,104,62,10,100,101,98,105,97,110,45,98,105,110,97,114,121])?{ext:"deb",mime:"application/x-deb"}:n([33,60,97,114,99,104,62])?{ext:"ar",mime:"application/x-unix-archive"}:n([237,171,238,219])?{ext:"rpm",mime:"application/x-rpm"}:n([31,160])||n([31,157])?{ext:"Z",mime:"application/x-compress"}:n([76,90,73,80])?{ext:"lz",mime:"application/x-lzip"}:n([208,207,17,224,161,177,26,225])?{ext:"msi",mime:"application/x-msi"}:n([6,14,43,52,2,5,1,1,13,1,2,1,1,2])?{ext:"mxf",mime:"application/mxf"}:n([71],{offset:4})&&(n([71],{offset:192})||n([71],{offset:196}))?{ext:"mts",mime:"video/mp2t"}:n([66,76,69,78,68,69,82])?{ext:"blend",mime:"application/x-blender"}:n([66,80,71,251])?{ext:"bpg",mime:"image/bpg"}:null:{ext:"swf",mime:"application/x-shockwave-flash"}}},function(t,e){t.exports=function(t,e,n,o,r){var i,s=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(i=t,s=t.default);var l="function"==typeof s?s.options:s;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns),o&&(l._scopeId=o);var u;if(r?(u=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},l._ssrRegister=u):n&&(u=n),u){var p=l.functional,c=p?l.render:l.beforeCreate;p?l.render=function(t,e){return u.call(e),c(t,e)}:l.beforeCreate=c?[].concat(c,u):[u]}return{esModule:i,exports:s,options:l}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement;return(t._self._c||e)("button",{class:[t.buttonStyle],on:{click:function(e){t.openUploader()}}},[t._v(t._s(t.buttonText)+"\n")])},staticRenderFns:[]}},function(t,e,n){"use strict";function o(t,e){this.text=t=t||"",this.hasWild=~t.indexOf("*"),this.separator=e,this.parts=t.split(e)}o.prototype.match=function(t){var e,n,o=!0,r=this.parts,i=r.length;if("string"==typeof t||t instanceof String)if(this.hasWild||this.text==t){for(n=(t||"").split(this.separator),e=0;o&&e<i;e++)"*"!==r[e]&&(o=e<n.length&&r[e]===n[e]);o=o&&n}else o=!1;else if("function"==typeof t.splice)for(o=[],e=t.length;e--;)this.match(t[e])&&(o[o.length]=t[e]);else if("object"==typeof t){o={};for(var s in t)this.match(s)&&(o[s]=t[s])}return o},t.exports=function(t,e,n){var r=new o(t,n||/[\/\.]/);return void 0!==e?r.match(e):r}},function(t,e){}])});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	var bind = __webpack_require__(15);
	var Axios = __webpack_require__(29);
	var defaults = __webpack_require__(3);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(12);
	axios.CancelToken = __webpack_require__(28);
	axios.isCancel = __webpack_require__(13);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(43);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(12);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(3);
	var utils = __webpack_require__(1);
	var InterceptorManager = __webpack_require__(30);
	var dispatchRequest = __webpack_require__(31);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	var transformData = __webpack_require__(34);
	var isCancel = __webpack_require__(13);
	var defaults = __webpack_require__(3);
	var isAbsoluteURL = __webpack_require__(39);
	var combineURLs = __webpack_require__(37);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(14);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(56), __esModule: true };

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(54);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	module.exports = __webpack_require__(16).Object.assign;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(21);
	var toLength = __webpack_require__(77);
	var toAbsoluteIndex = __webpack_require__(76);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(57);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(7);
	var document = __webpack_require__(6).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var core = __webpack_require__(16);
	var ctx = __webpack_require__(61);
	var hide = __webpack_require__(65);
	var has = __webpack_require__(18);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(68);
	var createDesc = __webpack_require__(73);
	module.exports = __webpack_require__(4) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(4) && !__webpack_require__(5)(function () {
	  return Object.defineProperty(__webpack_require__(62)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(71);
	var gOPS = __webpack_require__(69);
	var pIE = __webpack_require__(72);
	var toObject = __webpack_require__(78);
	var IObject = __webpack_require__(19);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(5)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(66);
	var toPrimitive = __webpack_require__(79);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(4) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(18);
	var toIObject = __webpack_require__(21);
	var arrayIndexOf = __webpack_require__(59)(false);
	var IE_PROTO = __webpack_require__(74)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(70);
	var enumBugKeys = __webpack_require__(63);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(75)('keys');
	var uid = __webpack_require__(80);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(6);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(20);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(20);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(17);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(7);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(64);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(67) });


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(23)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(85);
	// On some exotic environments, it's not clear which object `setimmeidate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vee-validate v2.0.6
	  * (c) 2018 Abdelrahman Awad
	  * @license MIT
	  */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.VeeValidate = factory());
	}(this, (function () { 'use strict';
	
	var MILLISECONDS_IN_HOUR = 3600000;
	var MILLISECONDS_IN_MINUTE = 60000;
	var DEFAULT_ADDITIONAL_DIGITS = 2;
	
	var patterns = {
	  dateTimeDelimeter: /[T ]/,
	  plainTime: /:/,
	
	  // year tokens
	  YY: /^(\d{2})$/,
	  YYY: [
	    /^([+-]\d{2})$/, // 0 additional digits
	    /^([+-]\d{3})$/, // 1 additional digit
	    /^([+-]\d{4})$/ // 2 additional digits
	  ],
	  YYYY: /^(\d{4})/,
	  YYYYY: [
	    /^([+-]\d{4})/, // 0 additional digits
	    /^([+-]\d{5})/, // 1 additional digit
	    /^([+-]\d{6})/ // 2 additional digits
	  ],
	
	  // date tokens
	  MM: /^-(\d{2})$/,
	  DDD: /^-?(\d{3})$/,
	  MMDD: /^-?(\d{2})-?(\d{2})$/,
	  Www: /^-?W(\d{2})$/,
	  WwwD: /^-?W(\d{2})-?(\d{1})$/,
	
	  HH: /^(\d{2}([.,]\d*)?)$/,
	  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	
	  // timezone tokens
	  timezone: /([Z+-].*)$/,
	  timezoneZ: /^(Z)$/,
	  timezoneHH: /^([+-])(\d{2})$/,
	  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
	};
	
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If an argument is a string, the function tries to parse it.
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument is null, it is treated as an invalid date.
	 *
	 * If all above fails, the function passes the given argument to Date constructor.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
	 *
	 * @param {*} argument - the value to convert
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * var result = toDate('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * var result = toDate('+02014101', {additionalDigits: 1})
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function toDate (argument, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
	  }
	
	  if (argument === null) {
	    return new Date(NaN)
	  }
	
	  var options = dirtyOptions || {};
	
	  var additionalDigits = options.additionalDigits === undefined ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2')
	  }
	
	  // Clone the date
	  if (argument instanceof Date) {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime())
	  } else if (typeof argument !== 'string') {
	    return new Date(argument)
	  }
	
	  var dateStrings = splitDateString(argument);
	
	  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	  var year = parseYearResult.year;
	  var restDateString = parseYearResult.restDateString;
	
	  var date = parseDate(restDateString, year);
	
	  if (date) {
	    var timestamp = date.getTime();
	    var time = 0;
	    var offset;
	
	    if (dateStrings.time) {
	      time = parseTime(dateStrings.time);
	    }
	
	    if (dateStrings.timezone) {
	      offset = parseTimezone(dateStrings.timezone);
	    } else {
	      // get offset accurate to hour in timezones that change offset
	      offset = new Date(timestamp + time).getTimezoneOffset();
	      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset();
	    }
	
	    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
	  } else {
	    return new Date(argument)
	  }
	}
	
	function splitDateString (dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimeter);
	  var timeString;
	
	  if (patterns.plainTime.test(array[0])) {
	    dateStrings.date = null;
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	  }
	
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	
	  return dateStrings
	}
	
	function parseYear (dateString, additionalDigits) {
	  var patternYYY = patterns.YYY[additionalDigits];
	  var patternYYYYY = patterns.YYYYY[additionalDigits];
	
	  var token;
	
	  // YYYY or ±YYYYY
	  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
	  if (token) {
	    var yearString = token[1];
	    return {
	      year: parseInt(yearString, 10),
	      restDateString: dateString.slice(yearString.length)
	    }
	  }
	
	  // YY or ±YYY
	  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
	  if (token) {
	    var centuryString = token[1];
	    return {
	      year: parseInt(centuryString, 10) * 100,
	      restDateString: dateString.slice(centuryString.length)
	    }
	  }
	
	  // Invalid ISO-formatted year
	  return {
	    year: null
	  }
	}
	
	function parseDate (dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) {
	    return null
	  }
	
	  var token;
	  var date;
	  var month;
	  var week;
	
	  // YYYY
	  if (dateString.length === 0) {
	    date = new Date(0);
	    date.setUTCFullYear(year);
	    return date
	  }
	
	  // YYYY-MM
	  token = patterns.MM.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    date.setUTCFullYear(year, month);
	    return date
	  }
	
	  // YYYY-DDD or YYYYDDD
	  token = patterns.DDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    var dayOfYear = parseInt(token[1], 10);
	    date.setUTCFullYear(year, 0, dayOfYear);
	    return date
	  }
	
	  // YYYY-MM-DD or YYYYMMDD
	  token = patterns.MMDD.exec(dateString);
	  if (token) {
	    date = new Date(0);
	    month = parseInt(token[1], 10) - 1;
	    var day = parseInt(token[2], 10);
	    date.setUTCFullYear(year, month, day);
	    return date
	  }
	
	  // YYYY-Www or YYYYWww
	  token = patterns.Www.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    return dayOfISOYear(year, week)
	  }
	
	  // YYYY-Www-D or YYYYWwwD
	  token = patterns.WwwD.exec(dateString);
	  if (token) {
	    week = parseInt(token[1], 10) - 1;
	    var dayOfWeek = parseInt(token[2], 10) - 1;
	    return dayOfISOYear(year, week, dayOfWeek)
	  }
	
	  // Invalid ISO-formatted date
	  return null
	}
	
	function parseTime (timeString) {
	  var token;
	  var hours;
	  var minutes;
	
	  // hh
	  token = patterns.HH.exec(timeString);
	  if (token) {
	    hours = parseFloat(token[1].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR
	  }
	
	  // hh:mm or hhmm
	  token = patterns.HHMM.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseFloat(token[2].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE
	  }
	
	  // hh:mm:ss or hhmmss
	  token = patterns.HHMMSS.exec(timeString);
	  if (token) {
	    hours = parseInt(token[1], 10);
	    minutes = parseInt(token[2], 10);
	    var seconds = parseFloat(token[3].replace(',', '.'));
	    return (hours % 24) * MILLISECONDS_IN_HOUR +
	      minutes * MILLISECONDS_IN_MINUTE +
	      seconds * 1000
	  }
	
	  // Invalid ISO-formatted time
	  return null
	}
	
	function parseTimezone (timezoneString) {
	  var token;
	  var absoluteOffset;
	
	  // Z
	  token = patterns.timezoneZ.exec(timezoneString);
	  if (token) {
	    return 0
	  }
	
	  // ±hh
	  token = patterns.timezoneHH.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60;
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  // ±hh:mm or ±hhmm
	  token = patterns.timezoneHHMM.exec(timezoneString);
	  if (token) {
	    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
	    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
	  }
	
	  return 0
	}
	
	function dayOfISOYear (isoYear, week, day) {
	  week = week || 0;
	  day = day || 0;
	  var date = new Date(0);
	  date.setUTCFullYear(isoYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds (dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var timestamp = toDate(dirtyDate, dirtyOptions).getTime();
	  var amount = Number(dirtyAmount);
	  return new Date(timestamp + amount)
	}
	
	function cloneObject (dirtyObject) {
	  dirtyObject = dirtyObject || {};
	  var object = {};
	
	  for (var property in dirtyObject) {
	    if (dirtyObject.hasOwnProperty(property)) {
	      object[property] = dirtyObject[property];
	    }
	  }
	
	  return object
	}
	
	var MILLISECONDS_IN_MINUTE$2 = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var amount = Number(dirtyAmount);
	  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$2, dirtyOptions)
	}
	
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // For the valid date:
	 * var result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * var result = isValid('2014-02-31')
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * var result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid (dirtyDate, dirtyOptions) {
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
	  }
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  return !isNaN(date)
	}
	
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	
	  halfAMinute: 'half a minute',
	
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	
	function formatDistance (token, count, options) {
	  options = options || {};
	
	  var result;
	  if (typeof formatDistanceLocale[token] === 'string') {
	    result = formatDistanceLocale[token];
	  } else if (count === 1) {
	    result = formatDistanceLocale[token].one;
	  } else {
	    result = formatDistanceLocale[token].other.replace('{{count}}', count);
	  }
	
	  if (options.addSuffix) {
	    if (options.comparison > 0) {
	      return 'in ' + result
	    } else {
	      return result + ' ago'
	    }
	  }
	
	  return result
	}
	
	var tokensToBeShortedPattern = /MMMM|MM|DD|dddd/g;
	
	function buildShortLongFormat (format) {
	  return format.replace(tokensToBeShortedPattern, function (token) {
	    return token.slice(1)
	  })
	}
	
	/**
	 * @name buildFormatLongFn
	 * @category Locale Helpers
	 * @summary Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 *
	 * @description
	 * Build `formatLong` property for locale used by `format`, `formatRelative` and `parse` functions.
	 * Returns a function which takes one of the following tokens as the argument:
	 * `'LTS'`, `'LT'`, `'L'`, `'LL'`, `'LLL'`, `'l'`, `'ll'`, `'lll'`, `'llll'`
	 * and returns a long format string written as `format` token strings.
	 * See [format]{@link https://date-fns.org/docs/format}
	 *
	 * `'l'`, `'ll'`, `'lll'` and `'llll'` formats are built automatically
	 * by shortening some of the tokens from corresponding unshortened formats
	 * (e.g., if `LL` is `'MMMM DD YYYY'` then `ll` will be `MMM D YYYY`)
	 *
	 * @param {Object} obj - the object with long formats written as `format` token strings
	 * @param {String} obj.LT - time format: hours and minutes
	 * @param {String} obj.LTS - time format: hours, minutes and seconds
	 * @param {String} obj.L - short date format: numeric day, month and year
	 * @param {String} [obj.l] - short date format: numeric day, month and year (shortened)
	 * @param {String} obj.LL - long date format: day, month in words, and year
	 * @param {String} [obj.ll] - long date format: day, month in words, and year (shortened)
	 * @param {String} obj.LLL - long date and time format
	 * @param {String} [obj.lll] - long date and time format (shortened)
	 * @param {String} obj.LLLL - long date, time and weekday format
	 * @param {String} [obj.llll] - long date, time and weekday format (shortened)
	 * @returns {Function} `formatLong` property of the locale
	 *
	 * @example
	 * // For `en-US` locale:
	 * locale.formatLong = buildFormatLongFn({
	 *   LT: 'h:mm aa',
	 *   LTS: 'h:mm:ss aa',
	 *   L: 'MM/DD/YYYY',
	 *   LL: 'MMMM D YYYY',
	 *   LLL: 'MMMM D YYYY h:mm aa',
	 *   LLLL: 'dddd, MMMM D YYYY h:mm aa'
	 * })
	 */
	function buildFormatLongFn (obj) {
	  var formatLongLocale = {
	    LTS: obj.LTS,
	    LT: obj.LT,
	    L: obj.L,
	    LL: obj.LL,
	    LLL: obj.LLL,
	    LLLL: obj.LLLL,
	    l: obj.l || buildShortLongFormat(obj.L),
	    ll: obj.ll || buildShortLongFormat(obj.LL),
	    lll: obj.lll || buildShortLongFormat(obj.LLL),
	    llll: obj.llll || buildShortLongFormat(obj.LLLL)
	  };
	
	  return function (token) {
	    return formatLongLocale[token]
	  }
	}
	
	var formatLong = buildFormatLongFn({
	  LT: 'h:mm aa',
	  LTS: 'h:mm:ss aa',
	  L: 'MM/DD/YYYY',
	  LL: 'MMMM D YYYY',
	  LLL: 'MMMM D YYYY h:mm aa',
	  LLLL: 'dddd, MMMM D YYYY h:mm aa'
	});
	
	var formatRelativeLocale = {
	  lastWeek: '[last] dddd [at] LT',
	  yesterday: '[yesterday at] LT',
	  today: '[today at] LT',
	  tomorrow: '[tomorrow at] LT',
	  nextWeek: 'dddd [at] LT',
	  other: 'L'
	};
	
	function formatRelative (token, date, baseDate, options) {
	  return formatRelativeLocale[token]
	}
	
	/**
	 * @name buildLocalizeFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekday`, `localize.month` and `localize.timeOfDay` properties for the locale
	 * used by `format` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * `localize.weekday` function takes the weekday index as argument (0 - Sunday).
	 * `localize.month` takes the month index (0 - January).
	 * `localize.timeOfDay` takes the hours. Use `indexCallback` to convert them to an array index (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @param {Function} [indexCallback] - the callback which takes the resulting function argument
	 *   and converts it into value array index
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var timeOfDayValues = {
	 *   uppercase: ['AM', 'PM'],
	 *   lowercase: ['am', 'pm'],
	 *   long: ['a.m.', 'p.m.']
	 * }
	 * locale.localize.timeOfDay = buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	 *   // 0 is a.m. array index, 1 is p.m. array index
	 *   return (hours / 12) >= 1 ? 1 : 0
	 * })
	 * locale.localize.timeOfDay(16, {type: 'uppercase'}) //=> 'PM'
	 * locale.localize.timeOfDay(5) //=> 'a.m.'
	 */
	function buildLocalizeFn (values, defaultType, indexCallback) {
	  return function (dirtyIndex, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var valuesArray = values[type] || values[defaultType];
	    var index = indexCallback ? indexCallback(Number(dirtyIndex)) : Number(dirtyIndex);
	    return valuesArray[index]
	  }
	}
	
	/**
	 * @name buildLocalizeArrayFn
	 * @category Locale Helpers
	 * @summary Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `localize.weekdays`, `localize.months` and `localize.timesOfDay` properties for the locale.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 *
	 * @param {Object} values - the object with arrays of values
	 * @param {String} defaultType - the default type for the localize function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var weekdayValues = {
	 *   narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	 *   short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	 *   long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	 * }
	 * locale.localize.weekdays = buildLocalizeArrayFn(weekdayValues, 'long')
	 * locale.localize.weekdays({type: 'narrow'}) //=> ['Su', 'Mo', ...]
	 * locale.localize.weekdays() //=> ['Sunday', 'Monday', ...]
	 */
	function buildLocalizeArrayFn (values, defaultType) {
	  return function (dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    return values[type] || values[defaultType]
	  }
	}
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var weekdayValues = {
	  narrow: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  short: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  long: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	
	var monthValues = {
	  short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  long: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var timeOfDayValues = {
	//     any: ['in the night', 'in the morning', 'in the afternoon', 'in the evening']
	//   }
	//
	// And later:
	//
	//   var localize = {
	//     // The callback takes the hours as the argument and returns the array index
	//     timeOfDay: buildLocalizeFn(timeOfDayValues, 'any', function (hours) {
	//       if (hours >= 17) {
	//         return 3
	//       } else if (hours >= 12) {
	//         return 2
	//       } else if (hours >= 4) {
	//         return 1
	//       } else {
	//         return 0
	//       }
	//     }),
	//     timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'any')
	//   }
	var timeOfDayValues = {
	  uppercase: ['AM', 'PM'],
	  lowercase: ['am', 'pm'],
	  long: ['a.m.', 'p.m.']
	};
	
	function ordinalNumber (dirtyNumber, dirtyOptions) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`:
	  //
	  //   var options = dirtyOptions || {}
	  //   var unit = String(options.unit)
	  //
	  // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
	  // 'dayOfMonth' or 'dayOfWeek'
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st'
	      case 2:
	        return number + 'nd'
	      case 3:
	        return number + 'rd'
	    }
	  }
	  return number + 'th'
	}
	
	var localize = {
	  ordinalNumber: ordinalNumber,
	  weekday: buildLocalizeFn(weekdayValues, 'long'),
	  weekdays: buildLocalizeArrayFn(weekdayValues, 'long'),
	  month: buildLocalizeFn(monthValues, 'long'),
	  months: buildLocalizeArrayFn(monthValues, 'long'),
	  timeOfDay: buildLocalizeFn(timeOfDayValues, 'long', function (hours) {
	    return (hours / 12) >= 1 ? 1 : 0
	  }),
	  timesOfDay: buildLocalizeArrayFn(timeOfDayValues, 'long')
	};
	
	/**
	 * @name buildMatchFn
	 * @category Locale Helpers
	 * @summary Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekdays`, `match.months` and `match.timesOfDay` properties for the locale used by `parse` function.
	 * If no `type` is supplied to the options of the resulting function, `defaultType` will be used (see example).
	 * The result of the match function will be passed into corresponding parser function
	 * (`match.weekday`, `match.month` or `match.timeOfDay` respectively. See `buildParseFn`).
	 *
	 * @param {Object} values - the object with RegExps
	 * @param {String} defaultType - the default type for the match function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var matchWeekdaysPatterns = {
	 *   narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	 *   short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	 *   long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	 * }
	 * locale.match.weekdays = buildMatchFn(matchWeekdaysPatterns, 'long')
	 * locale.match.weekdays('Sunday', {type: 'narrow'}) //=> ['Su', 'Su', ...]
	 * locale.match.weekdays('Sunday') //=> ['Sunday', 'Sunday', ...]
	 */
	function buildMatchFn (patterns, defaultType) {
	  return function (dirtyString, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var pattern = patterns[type] || patterns[defaultType];
	    var string = String(dirtyString);
	    return string.match(pattern)
	  }
	}
	
	/**
	 * @name buildParseFn
	 * @category Locale Helpers
	 * @summary Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale.
	 *
	 * @description
	 * Build `match.weekday`, `match.month` and `match.timeOfDay` properties for the locale used by `parse` function.
	 * The argument of the resulting function is the result of the corresponding match function
	 * (`match.weekdays`, `match.months` or `match.timesOfDay` respectively. See `buildMatchFn`).
	 *
	 * @param {Object} values - the object with arrays of RegExps
	 * @param {String} defaultType - the default type for the parser function
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * var parseWeekdayPatterns = {
	 *   any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	 * }
	 * locale.match.weekday = buildParseFn(matchWeekdaysPatterns, 'long')
	 * var matchResult = locale.match.weekdays('Friday')
	 * locale.match.weekday(matchResult) //=> 5
	 */
	function buildParseFn (patterns, defaultType) {
	  return function (matchResult, dirtyOptions) {
	    var options = dirtyOptions || {};
	    var type = options.type ? String(options.type) : defaultType;
	    var patternsArray = patterns[type] || patterns[defaultType];
	    var string = matchResult[1];
	
	    return patternsArray.findIndex(function (pattern) {
	      return pattern.test(string)
	    })
	  }
	}
	
	/**
	 * @name buildMatchPatternFn
	 * @category Locale Helpers
	 * @summary Build match function from a single RegExp.
	 *
	 * @description
	 * Build match function from a single RegExp.
	 * Usually used for building `match.ordinalNumbers` property of the locale.
	 *
	 * @param {Object} pattern - the RegExp
	 * @returns {Function} the resulting function
	 *
	 * @example
	 * locale.match.ordinalNumbers = buildMatchPatternFn(/^(\d+)(th|st|nd|rd)?/i)
	 * locale.match.ordinalNumbers('3rd') //=> ['3rd', '3', 'rd', ...]
	 */
	function buildMatchPatternFn (pattern) {
	  return function (dirtyString) {
	    var string = String(dirtyString);
	    return string.match(pattern)
	  }
	}
	
	/**
	 * @name parseDecimal
	 * @category Locale Helpers
	 * @summary Parses the match result into decimal number.
	 *
	 * @description
	 * Parses the match result into decimal number.
	 * Uses the string matched with the first set of parentheses of match RegExp.
	 *
	 * @param {Array} matchResult - the object returned by matching function
	 * @returns {Number} the parsed value
	 *
	 * @example
	 * locale.match = {
	 *   ordinalNumbers: (dirtyString) {
	 *     return String(dirtyString).match(/^(\d+)(th|st|nd|rd)?/i)
	 *   },
	 *   ordinalNumber: parseDecimal
	 * }
	 */
	function parseDecimal (matchResult) {
	  return parseInt(matchResult[1], 10)
	}
	
	var matchOrdinalNumbersPattern = /^(\d+)(th|st|nd|rd)?/i;
	
	var matchWeekdaysPatterns = {
	  narrow: /^(su|mo|tu|we|th|fr|sa)/i,
	  short: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  long: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	
	var parseWeekdayPatterns = {
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	
	var matchMonthsPatterns = {
	  short: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  long: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	
	var parseMonthPatterns = {
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	
	// `timeOfDay` is used to designate which part of the day it is, when used with 12-hour clock.
	// Use the system which is used the most commonly in the locale.
	// For example, if the country doesn't use a.m./p.m., you can use `night`/`morning`/`afternoon`/`evening`:
	//
	//   var matchTimesOfDayPatterns = {
	//     long: /^((in the)? (night|morning|afternoon|evening?))/i
	//   }
	//
	//   var parseTimeOfDayPatterns = {
	//     any: [/(night|morning)/i, /(afternoon|evening)/i]
	//   }
	var matchTimesOfDayPatterns = {
	  short: /^(am|pm)/i,
	  long: /^([ap]\.?\s?m\.?)/i
	};
	
	var parseTimeOfDayPatterns = {
	  any: [/^a/i, /^p/i]
	};
	
	var match = {
	  ordinalNumbers: buildMatchPatternFn(matchOrdinalNumbersPattern),
	  ordinalNumber: parseDecimal,
	  weekdays: buildMatchFn(matchWeekdaysPatterns, 'long'),
	  weekday: buildParseFn(parseWeekdayPatterns, 'any'),
	  months: buildMatchFn(matchMonthsPatterns, 'long'),
	  month: buildParseFn(parseMonthPatterns, 'any'),
	  timesOfDay: buildMatchFn(matchTimesOfDayPatterns, 'long'),
	  timeOfDay: buildParseFn(parseTimeOfDayPatterns, 'any')
	};
	
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 */
	var locale = {
	  formatDistance: formatDistance,
	  formatLong: formatLong,
	  formatRelative: formatRelative,
	  localize: localize,
	  match: match,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	
	var MILLISECONDS_IN_DAY$1 = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCDayOfYear (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeek (dirtyDate, dirtyOptions) {
	  var weekStartsOn = 1;
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeekYear (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var year = date.getUTCFullYear();
	
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear, dirtyOptions);
	
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear, dirtyOptions);
	
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year
	  } else {
	    return year - 1
	  }
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function startOfUTCISOWeekYear (dirtyDate, dirtyOptions) {
	  var year = getUTCISOWeekYear(dirtyDate, dirtyOptions);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = startOfUTCISOWeek(fourthOfJanuary, dirtyOptions);
	  return date
	}
	
	var MILLISECONDS_IN_WEEK$2 = 604800000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function getUTCISOWeek (dirtyDate, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var diff = startOfUTCISOWeek(date, dirtyOptions).getTime() - startOfUTCISOWeekYear(date, dirtyOptions).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1
	}
	
	var formatters = {
	  // Month: 1, 2, ..., 12
	  'M': function (date) {
	    return date.getUTCMonth() + 1
	  },
	
	  // Month: 1st, 2nd, ..., 12th
	  'Mo': function (date, options) {
	    var month = date.getUTCMonth() + 1;
	    return options.locale.localize.ordinalNumber(month, {unit: 'month'})
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': function (date) {
	    return addLeadingZeros(date.getUTCMonth() + 1, 2)
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': function (date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), {type: 'short'})
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': function (date, options) {
	    return options.locale.localize.month(date.getUTCMonth(), {type: 'long'})
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': function (date) {
	    return Math.ceil((date.getUTCMonth() + 1) / 3)
	  },
	
	  // Quarter: 1st, 2nd, 3rd, 4th
	  'Qo': function (date, options) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    return options.locale.localize.ordinalNumber(quarter, {unit: 'quarter'})
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': function (date) {
	    return date.getUTCDate()
	  },
	
	  // Day of month: 1st, 2nd, ..., 31st
	  'Do': function (date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDate(), {unit: 'dayOfMonth'})
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': function (date) {
	    return addLeadingZeros(date.getUTCDate(), 2)
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': function (date) {
	    return getUTCDayOfYear(date)
	  },
	
	  // Day of year: 1st, 2nd, ..., 366th
	  'DDDo': function (date, options) {
	    return options.locale.localize.ordinalNumber(getUTCDayOfYear(date), {unit: 'dayOfYear'})
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': function (date) {
	    return addLeadingZeros(getUTCDayOfYear(date), 3)
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'narrow'})
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'short'})
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': function (date, options) {
	    return options.locale.localize.weekday(date.getUTCDay(), {type: 'long'})
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': function (date) {
	    return date.getUTCDay()
	  },
	
	  // Day of week: 0th, 1st, 2nd, ..., 6th
	  'do': function (date, options) {
	    return options.locale.localize.ordinalNumber(date.getUTCDay(), {unit: 'dayOfWeek'})
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': function (date) {
	    return date.getUTCDay() || 7
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': function (date) {
	    return getUTCISOWeek(date)
	  },
	
	  // ISO week: 1st, 2nd, ..., 53th
	  'Wo': function (date, options) {
	    return options.locale.localize.ordinalNumber(getUTCISOWeek(date), {unit: 'isoWeek'})
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': function (date) {
	    return addLeadingZeros(getUTCISOWeek(date), 2)
	  },
	
	  // Year: 00, 01, ..., 99
	  'YY': function (date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4).substr(2)
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': function (date) {
	    return addLeadingZeros(date.getUTCFullYear(), 4)
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': function (date) {
	    return String(getUTCISOWeekYear(date)).substr(2)
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': function (date) {
	    return getUTCISOWeekYear(date)
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': function (date) {
	    return date.getUTCHours()
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': function (date) {
	    return addLeadingZeros(date.getUTCHours(), 2)
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': function (date) {
	    var hours = date.getUTCHours();
	    if (hours === 0) {
	      return 12
	    } else if (hours > 12) {
	      return hours % 12
	    } else {
	      return hours
	    }
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': function (date) {
	    return addLeadingZeros(formatters['h'](date), 2)
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': function (date) {
	    return date.getUTCMinutes()
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': function (date) {
	    return addLeadingZeros(date.getUTCMinutes(), 2)
	  },
	
	  // Second: 0, 1, ..., 59
	  's': function (date) {
	    return date.getUTCSeconds()
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': function (date) {
	    return addLeadingZeros(date.getUTCSeconds(), 2)
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': function (date) {
	    return Math.floor(date.getUTCMilliseconds() / 100)
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': function (date) {
	    return addLeadingZeros(Math.floor(date.getUTCMilliseconds() / 10), 2)
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': function (date) {
	    return addLeadingZeros(date.getUTCMilliseconds(), 3)
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset(), ':')
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return formatTimezone(originalDate.getTimezoneOffset())
	  },
	
	  // Seconds timestamp: 512969520
	  'X': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return Math.floor(originalDate.getTime() / 1000)
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': function (date, options) {
	    var originalDate = options._originalDate || date;
	    return originalDate.getTime()
	  },
	
	  // AM, PM
	  'A': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'uppercase'})
	  },
	
	  // am, pm
	  'a': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'lowercase'})
	  },
	
	  // a.m., p.m.
	  'aa': function (date, options) {
	    return options.locale.localize.timeOfDay(date.getUTCHours(), {type: 'long'})
	  }
	};
	
	function formatTimezone (offset, delimeter) {
	  delimeter = delimeter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
	}
	
	function addLeadingZeros (number, targetLength) {
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return output
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function addUTCMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var amount = Number(dirtyAmount);
	  date.setUTCMinutes(date.getUTCMinutes() + amount);
	  return date
	}
	
	var longFormattingTokensRegExp = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultFormattingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 *
	 * Accepted tokens:
	 * | Unit                    | Token | Result examples                  |
	 * |-------------------------|-------|----------------------------------|
	 * | Month                   | M     | 1, 2, ..., 12                    |
	 * |                         | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         | MM    | 01, 02, ..., 12                  |
	 * |                         | MMM   | Jan, Feb, ..., Dec               |
	 * |                         | MMMM  | January, February, ..., December |
	 * | Quarter                 | Q     | 1, 2, 3, 4                       |
	 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Day of month            | D     | 1, 2, ..., 31                    |
	 * |                         | Do    | 1st, 2nd, ..., 31st              |
	 * |                         | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | DDD   | 1, 2, ..., 366                   |
	 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         | DDDD  | 001, 002, ..., 366               |
	 * | Day of week             | d     | 0, 1, ..., 6                     |
	 * |                         | do    | 0th, 1st, ..., 6th               |
	 * |                         | dd    | Su, Mo, ..., Sa                  |
	 * |                         | ddd   | Sun, Mon, ..., Sat               |
	 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
	 * | ISO week                | W     | 1, 2, ..., 53                    |
	 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         | WW    | 01, 02, ..., 53                  |
	 * | Year                    | YY    | 00, 01, ..., 99                  |
	 * |                         | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
	 * |                         | GGGG  | 1900, 1901, ..., 2099            |
	 * | AM/PM                   | A     | AM, PM                           |
	 * |                         | a     | am, pm                           |
	 * |                         | aa    | a.m., p.m.                       |
	 * | Hour                    | H     | 0, 1, ... 23                     |
	 * |                         | HH    | 00, 01, ... 23                   |
	 * |                         | h     | 1, 2, ..., 12                    |
	 * |                         | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | m     | 0, 1, ..., 59                    |
	 * |                         | mm    | 00, 01, ..., 59                  |
	 * | Second                  | s     | 0, 1, ..., 59                    |
	 * |                         | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | X     | 512969520                        |
	 * | Milliseconds timestamp  | x     | 512969520900                     |
	 * | Long format             | LT    | 05:30 a.m.                       |
	 * |                         | LTS   | 05:30:15 a.m.                    |
	 * |                         | L     | 07/02/1995                       |
	 * |                         | l     | 7/2/1995                         |
	 * |                         | LL    | July 2 1995                      |
	 * |                         | ll    | Jul 2 1995                       |
	 * |                         | LLL   | July 2 1995 05:30 a.m.           |
	 * |                         | lll   | Jul 2 1995 05:30 a.m.            |
	 * |                         | LLLL  | Sunday, July 2 1995 05:30 a.m.   |
	 * |                         | llll  | Sun, Jul 2 1995 05:30 a.m.       |
	 *
	 * The characters wrapped in square brackets are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * @param {Date|String|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * var result = format(
	 *   new Date(2014, 1, 11),
	 *   'MM/DD/YYYY'
	 * )
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * var result = format(
	 *   new Date(2014, 6, 2),
	 *   'Do [de] MMMM YYYY',
	 *   {locale: eoLocale}
	 * )
	 * //=> '2-a de julio 2014'
	 */
	function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var formatStr = String(dirtyFormatStr);
	  var options = dirtyOptions || {};
	
	  var locale$$1 = options.locale || locale;
	
	  if (!locale$$1.localize) {
	    throw new RangeError('locale must contain localize property')
	  }
	
	  if (!locale$$1.formatLong) {
	    throw new RangeError('locale must contain formatLong property')
	  }
	
	  var localeFormatters = locale$$1.formatters || {};
	  var formattingTokensRegExp = locale$$1.formattingTokensRegExp || defaultFormattingTokensRegExp;
	  var formatLong = locale$$1.formatLong;
	
	  var originalDate = toDate(dirtyDate, options);
	
	  if (!isValid(originalDate, options)) {
	    return 'Invalid Date'
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = originalDate.getTimezoneOffset();
	  var utcDate = addUTCMinutes(originalDate, -timezoneOffset, options);
	
	  var formatterOptions = cloneObject(options);
	  formatterOptions.locale = locale$$1;
	  formatterOptions.formatters = formatters;
	
	  // When UTC functions will be implemented, options._originalDate will likely be a part of public API.
	  // Right now, please don't use it in locales. If you have to use an original date,
	  // please restore it from `date`, adding a timezone offset to it.
	  formatterOptions._originalDate = originalDate;
	
	  var result = formatStr
	    .replace(longFormattingTokensRegExp, function (substring) {
	      if (substring[0] === '[') {
	        return substring
	      }
	
	      if (substring[0] === '\\') {
	        return cleanEscapedString(substring)
	      }
	
	      return formatLong(substring)
	    })
	    .replace(formattingTokensRegExp, function (substring) {
	      var formatter = localeFormatters[substring] || formatters[substring];
	
	      if (formatter) {
	        return formatter(utcDate, formatterOptions)
	      } else {
	        return cleanEscapedString(substring)
	      }
	    });
	
	  return result
	}
	
	function cleanEscapedString (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|String|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the new date with the mintues subtracted
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes (dirtyDate, dirtyAmount, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var amount = Number(dirtyAmount);
	  return addMinutes(dirtyDate, -amount, dirtyOptions)
	}
	
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be after the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter (dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() > dateToCompare.getTime()
	}
	
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|String|Number} date - the date that should be before the other one to return true
	 * @param {Date|String|Number} dateToCompare - the date to compare with
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore (dirtyDate, dirtyDateToCompare, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var dateToCompare = toDate(dirtyDateToCompare, dirtyOptions);
	  return date.getTime() < dateToCompare.getTime()
	}
	
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|String|Number} dateLeft - the first date to compare
	 * @param {Date|String|Number} dateRight - the second date to compare
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * var result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0)
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual (dirtyLeftDate, dirtyRightDate, dirtyOptions) {
	  if (arguments.length < 2) {
	    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var dateLeft = toDate(dirtyLeftDate, dirtyOptions);
	  var dateRight = toDate(dirtyRightDate, dirtyOptions);
	  return dateLeft.getTime() === dateRight.getTime()
	}
	
	var patterns$1 = {
	  'M': /^(1[0-2]|0?\d)/, // 0 to 12
	  'D': /^(3[0-1]|[0-2]?\d)/, // 0 to 31
	  'DDD': /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
	  'W': /^(5[0-3]|[0-4]?\d)/, // 0 to 53
	  'YYYY': /^(\d{1,4})/, // 0 to 9999
	  'H': /^(2[0-3]|[0-1]?\d)/, // 0 to 23
	  'm': /^([0-5]?\d)/, // 0 to 59
	  'Z': /^([+-])(\d{2}):(\d{2})/,
	  'ZZ': /^([+-])(\d{2})(\d{2})/,
	  singleDigit: /^(\d)/,
	  twoDigits: /^(\d{2})/,
	  threeDigits: /^(\d{3})/,
	  fourDigits: /^(\d{4})/,
	  anyDigits: /^(\d+)/
	};
	
	function parseDecimal$1 (matchResult) {
	  return parseInt(matchResult[1], 10)
	}
	
	var parsers = {
	  // Year: 00, 01, ..., 99
	  'YY': {
	    unit: 'twoDigitYear',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult)
	    }
	  },
	
	  // Year: 1900, 1901, ..., 2099
	  'YYYY': {
	    unit: 'year',
	    match: patterns$1.YYYY,
	    parse: parseDecimal$1
	  },
	
	  // ISO week-numbering year: 00, 01, ..., 99
	  'GG': {
	    unit: 'isoYear',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) + 1900
	    }
	  },
	
	  // ISO week-numbering year: 1900, 1901, ..., 2099
	  'GGGG': {
	    unit: 'isoYear',
	    match: patterns$1.YYYY,
	    parse: parseDecimal$1
	  },
	
	  // Quarter: 1, 2, 3, 4
	  'Q': {
	    unit: 'quarter',
	    match: patterns$1.singleDigit,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal quarter
	  'Qo': {
	    unit: 'quarter',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'quarter'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'quarter'})
	    }
	  },
	
	  // Month: 1, 2, ..., 12
	  'M': {
	    unit: 'month',
	    match: patterns$1.M,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) - 1
	    }
	  },
	
	  // Ordinal month
	  'Mo': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'month'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'month'}) - 1
	    }
	  },
	
	  // Month: 01, 02, ..., 12
	  'MM': {
	    unit: 'month',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) - 1
	    }
	  },
	
	  // Month: Jan, Feb, ..., Dec
	  'MMM': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.months(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.month(matchResult, {type: 'short'})
	    }
	  },
	
	  // Month: January, February, ..., December
	  'MMMM': {
	    unit: 'month',
	    match: function (string, options) {
	      return options.locale.match.months(string, {type: 'long'}) ||
	        options.locale.match.months(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.month(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.month(matchResult, {type: 'short'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // ISO week: 1, 2, ..., 53
	  'W': {
	    unit: 'isoWeek',
	    match: patterns$1.W,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal ISO week
	  'Wo': {
	    unit: 'isoWeek',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'isoWeek'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'isoWeek'})
	    }
	  },
	
	  // ISO week: 01, 02, ..., 53
	  'WW': {
	    unit: 'isoWeek',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Day of week: 0, 1, ..., 6
	  'd': {
	    unit: 'dayOfWeek',
	    match: patterns$1.singleDigit,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of week
	  'do': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfWeek'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfWeek'})
	    }
	  },
	
	  // Day of week: Su, Mo, ..., Sa
	  'dd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.weekday(matchResult, {type: 'narrow'})
	    }
	  },
	
	  // Day of week: Sun, Mon, ..., Sat
	  'ddd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'short'}) ||
	        options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, {type: 'short'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // Day of week: Sunday, Monday, ..., Saturday
	  'dddd': {
	    unit: 'dayOfWeek',
	    match: function (string, options) {
	      return options.locale.match.weekdays(string, {type: 'long'}) ||
	        options.locale.match.weekdays(string, {type: 'short'}) ||
	        options.locale.match.weekdays(string, {type: 'narrow'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.weekday(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.weekday(matchResult, {type: 'short'});
	
	        if (parseResult == null) {
	          parseResult = options.locale.match.weekday(matchResult, {type: 'narrow'});
	        }
	      }
	
	      return parseResult
	    }
	  },
	
	  // Day of ISO week: 1, 2, ..., 7
	  'E': {
	    unit: 'dayOfISOWeek',
	    match: patterns$1.singleDigit,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult)
	    }
	  },
	
	  // Day of month: 1, 2, ..., 31
	  'D': {
	    unit: 'dayOfMonth',
	    match: patterns$1.D,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of month
	  'Do': {
	    unit: 'dayOfMonth',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfMonth'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfMonth'})
	    }
	  },
	
	  // Day of month: 01, 02, ..., 31
	  'DD': {
	    unit: 'dayOfMonth',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Day of year: 1, 2, ..., 366
	  'DDD': {
	    unit: 'dayOfYear',
	    match: patterns$1.DDD,
	    parse: parseDecimal$1
	  },
	
	  // Ordinal day of year
	  'DDDo': {
	    unit: 'dayOfYear',
	    match: function (string, options) {
	      return options.locale.match.ordinalNumbers(string, {unit: 'dayOfYear'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.ordinalNumber(matchResult, {unit: 'dayOfYear'})
	    }
	  },
	
	  // Day of year: 001, 002, ..., 366
	  'DDDD': {
	    unit: 'dayOfYear',
	    match: patterns$1.threeDigits,
	    parse: parseDecimal$1
	  },
	
	  // AM, PM
	  'A': {
	    unit: 'timeOfDay',
	    match: function (string, options) {
	      return options.locale.match.timesOfDay(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      return options.locale.match.timeOfDay(matchResult, {type: 'short'})
	    }
	  },
	
	  // a.m., p.m.
	  'aa': {
	    unit: 'timeOfDay',
	    match: function (string, options) {
	      return options.locale.match.timesOfDay(string, {type: 'long'}) ||
	        options.locale.match.timesOfDay(string, {type: 'short'})
	    },
	    parse: function (matchResult, options) {
	      var parseResult = options.locale.match.timeOfDay(matchResult, {type: 'long'});
	
	      if (parseResult == null) {
	        parseResult = options.locale.match.timeOfDay(matchResult, {type: 'short'});
	      }
	
	      return parseResult
	    }
	  },
	
	  // Hour: 0, 1, ... 23
	  'H': {
	    unit: 'hours',
	    match: patterns$1.H,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 00, 01, ..., 23
	  'HH': {
	    unit: 'hours',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 1, 2, ..., 12
	  'h': {
	    unit: 'timeOfDayHours',
	    match: patterns$1.M,
	    parse: parseDecimal$1
	  },
	
	  // Hour: 01, 02, ..., 12
	  'hh': {
	    unit: 'timeOfDayHours',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Minute: 0, 1, ..., 59
	  'm': {
	    unit: 'minutes',
	    match: patterns$1.m,
	    parse: parseDecimal$1
	  },
	
	  // Minute: 00, 01, ..., 59
	  'mm': {
	    unit: 'minutes',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // Second: 0, 1, ..., 59
	  's': {
	    unit: 'seconds',
	    match: patterns$1.m,
	    parse: parseDecimal$1
	  },
	
	  // Second: 00, 01, ..., 59
	  'ss': {
	    unit: 'seconds',
	    match: patterns$1.twoDigits,
	    parse: parseDecimal$1
	  },
	
	  // 1/10 of second: 0, 1, ..., 9
	  'S': {
	    unit: 'milliseconds',
	    match: patterns$1.singleDigit,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 100
	    }
	  },
	
	  // 1/100 of second: 00, 01, ..., 99
	  'SS': {
	    unit: 'milliseconds',
	    match: patterns$1.twoDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 10
	    }
	  },
	
	  // Millisecond: 000, 001, ..., 999
	  'SSS': {
	    unit: 'milliseconds',
	    match: patterns$1.threeDigits,
	    parse: parseDecimal$1
	  },
	
	  // Timezone: -01:00, +00:00, ... +12:00
	  'Z': {
	    unit: 'timezone',
	    match: patterns$1.Z,
	    parse: function (matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return (sign === '+') ? absoluteOffset : -absoluteOffset
	    }
	  },
	
	  // Timezone: -0100, +0000, ... +1200
	  'ZZ': {
	    unit: 'timezone',
	    match: patterns$1.ZZ,
	    parse: function (matchResult) {
	      var sign = matchResult[1];
	      var hours = parseInt(matchResult[2], 10);
	      var minutes = parseInt(matchResult[3], 10);
	      var absoluteOffset = hours * 60 + minutes;
	      return (sign === '+') ? absoluteOffset : -absoluteOffset
	    }
	  },
	
	  // Seconds timestamp: 512969520
	  'X': {
	    unit: 'timestamp',
	    match: patterns$1.anyDigits,
	    parse: function (matchResult) {
	      return parseDecimal$1(matchResult) * 1000
	    }
	  },
	
	  // Milliseconds timestamp: 512969520900
	  'x': {
	    unit: 'timestamp',
	    match: patterns$1.anyDigits,
	    parse: parseDecimal$1
	  }
	};
	
	parsers['a'] = parsers['A'];
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCDay (dirtyDate, dirtyDay, dirtyOptions) {
	  var options = dirtyOptions || {};
	  var locale = options.locale;
	  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
	  var defaultWeekStartsOn = localeWeekStartsOn === undefined ? 0 : Number(localeWeekStartsOn);
	  var weekStartsOn = options.weekStartsOn === undefined ? defaultWeekStartsOn : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
	  }
	
	  var date = toDate(dirtyDate, dirtyOptions);
	  var day = Number(dirtyDay);
	
	  var currentDay = date.getUTCDay();
	
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISODay (dirtyDate, dirtyDay, dirtyOptions) {
	  var day = Number(dirtyDay);
	
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	
	  var weekStartsOn = 1;
	  var date = toDate(dirtyDate, dirtyOptions);
	  var currentDay = date.getUTCDay();
	
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeek (dirtyDate, dirtyISOWeek, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var isoWeek = Number(dirtyISOWeek);
	  var diff = getUTCISOWeek(date, dirtyOptions) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date
	}
	
	var MILLISECONDS_IN_DAY$3 = 86400000;
	
	// This function will be a part of public API when UTC function will be implemented.
	// See issue: https://github.com/date-fns/date-fns/issues/376
	function setUTCISOWeekYear (dirtyDate, dirtyISOYear, dirtyOptions) {
	  var date = toDate(dirtyDate, dirtyOptions);
	  var isoYear = Number(dirtyISOYear);
	  var dateStartOfYear = startOfUTCISOWeekYear(date, dirtyOptions);
	  var diff = Math.floor((date.getTime() - dateStartOfYear.getTime()) / MILLISECONDS_IN_DAY$3);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(isoYear, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  date = startOfUTCISOWeekYear(fourthOfJanuary, dirtyOptions);
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date
	}
	
	var MILLISECONDS_IN_MINUTE$7 = 60000;
	
	function setTimeOfDay (hours, timeOfDay) {
	  var isAM = timeOfDay === 0;
	
	  if (isAM) {
	    if (hours === 12) {
	      return 0
	    }
	  } else {
	    if (hours !== 12) {
	      return 12 + hours
	    }
	  }
	
	  return hours
	}
	
	var units = {
	  twoDigitYear: {
	    priority: 10,
	    set: function (dateValues, value) {
	      var century = Math.floor(dateValues.date.getUTCFullYear() / 100);
	      var year = century * 100 + value;
	      dateValues.date.setUTCFullYear(year, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  year: {
	    priority: 10,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCFullYear(value, 0, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  isoYear: {
	    priority: 10,
	    set: function (dateValues, value, options) {
	      dateValues.date = startOfUTCISOWeekYear(setUTCISOWeekYear(dateValues.date, value, options), options);
	      return dateValues
	    }
	  },
	
	  quarter: {
	    priority: 20,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth((value - 1) * 3, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  month: {
	    priority: 30,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth(value, 1);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  isoWeek: {
	    priority: 40,
	    set: function (dateValues, value, options) {
	      dateValues.date = startOfUTCISOWeek(setUTCISOWeek(dateValues.date, value, options), options);
	      return dateValues
	    }
	  },
	
	  dayOfWeek: {
	    priority: 50,
	    set: function (dateValues, value, options) {
	      dateValues.date = setUTCDay(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfISOWeek: {
	    priority: 50,
	    set: function (dateValues, value, options) {
	      dateValues.date = setUTCISODay(dateValues.date, value, options);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfMonth: {
	    priority: 50,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCDate(value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  dayOfYear: {
	    priority: 50,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMonth(0, value);
	      dateValues.date.setUTCHours(0, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  timeOfDay: {
	    priority: 60,
	    set: function (dateValues, value, options) {
	      dateValues.timeOfDay = value;
	      return dateValues
	    }
	  },
	
	  hours: {
	    priority: 70,
	    set: function (dateValues, value, options) {
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  timeOfDayHours: {
	    priority: 70,
	    set: function (dateValues, value, options) {
	      var timeOfDay = dateValues.timeOfDay;
	      if (timeOfDay != null) {
	        value = setTimeOfDay(value, timeOfDay);
	      }
	      dateValues.date.setUTCHours(value, 0, 0, 0);
	      return dateValues
	    }
	  },
	
	  minutes: {
	    priority: 80,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMinutes(value, 0, 0);
	      return dateValues
	    }
	  },
	
	  seconds: {
	    priority: 90,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCSeconds(value, 0);
	      return dateValues
	    }
	  },
	
	  milliseconds: {
	    priority: 100,
	    set: function (dateValues, value) {
	      dateValues.date.setUTCMilliseconds(value);
	      return dateValues
	    }
	  },
	
	  timezone: {
	    priority: 110,
	    set: function (dateValues, value) {
	      dateValues.date = new Date(dateValues.date.getTime() - value * MILLISECONDS_IN_MINUTE$7);
	      return dateValues
	    }
	  },
	
	  timestamp: {
	    priority: 120,
	    set: function (dateValues, value) {
	      dateValues.date = new Date(value);
	      return dateValues
	    }
	  }
	};
	
	var TIMEZONE_UNIT_PRIORITY = 110;
	var MILLISECONDS_IN_MINUTE$6 = 60000;
	
	var longFormattingTokensRegExp$1 = /(\[[^[]*])|(\\)?(LTS|LT|LLLL|LLL|LL|L|llll|lll|ll|l)/g;
	var defaultParsingTokensRegExp = /(\[[^[]*])|(\\)?(x|ss|s|mm|m|hh|h|do|dddd|ddd|dd|d|aa|a|ZZ|Z|YYYY|YY|X|Wo|WW|W|SSS|SS|S|Qo|Q|Mo|MMMM|MMM|MM|M|HH|H|GGGG|GG|E|Do|DDDo|DDDD|DDD|DD|D|A|.)/g;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format.
	 *
	 * Accepted format tokens:
	 * | Unit                    | Priority | Token | Input examples                   |
	 * |-------------------------|----------|-------|----------------------------------|
	 * | Year                    | 10       | YY    | 00, 01, ..., 99                  |
	 * |                         |          | YYYY  | 1900, 1901, ..., 2099            |
	 * | ISO week-numbering year | 10       | GG    | 00, 01, ..., 99                  |
	 * |                         |          | GGGG  | 1900, 1901, ..., 2099            |
	 * | Quarter                 | 20       | Q     | 1, 2, 3, 4                       |
	 * |                         |          | Qo    | 1st, 2nd, 3rd, 4th               |
	 * | Month                   | 30       | M     | 1, 2, ..., 12                    |
	 * |                         |          | Mo    | 1st, 2nd, ..., 12th              |
	 * |                         |          | MM    | 01, 02, ..., 12                  |
	 * |                         |          | MMM   | Jan, Feb, ..., Dec               |
	 * |                         |          | MMMM  | January, February, ..., December |
	 * | ISO week                | 40       | W     | 1, 2, ..., 53                    |
	 * |                         |          | Wo    | 1st, 2nd, ..., 53rd              |
	 * |                         |          | WW    | 01, 02, ..., 53                  |
	 * | Day of week             | 50       | d     | 0, 1, ..., 6                     |
	 * |                         |          | do    | 0th, 1st, ..., 6th               |
	 * |                         |          | dd    | Su, Mo, ..., Sa                  |
	 * |                         |          | ddd   | Sun, Mon, ..., Sat               |
	 * |                         |          | dddd  | Sunday, Monday, ..., Saturday    |
	 * | Day of ISO week         | 50       | E     | 1, 2, ..., 7                     |
	 * | Day of month            | 50       | D     | 1, 2, ..., 31                    |
	 * |                         |          | Do    | 1st, 2nd, ..., 31st              |
	 * |                         |          | DD    | 01, 02, ..., 31                  |
	 * | Day of year             | 50       | DDD   | 1, 2, ..., 366                   |
	 * |                         |          | DDDo  | 1st, 2nd, ..., 366th             |
	 * |                         |          | DDDD  | 001, 002, ..., 366               |
	 * | Time of day             | 60       | A     | AM, PM                           |
	 * |                         |          | a     | am, pm                           |
	 * |                         |          | aa    | a.m., p.m.                       |
	 * | Hour                    | 70       | H     | 0, 1, ... 23                     |
	 * |                         |          | HH    | 00, 01, ... 23                   |
	 * | Time of day hour        | 70       | h     | 1, 2, ..., 12                    |
	 * |                         |          | hh    | 01, 02, ..., 12                  |
	 * | Minute                  | 80       | m     | 0, 1, ..., 59                    |
	 * |                         |          | mm    | 00, 01, ..., 59                  |
	 * | Second                  | 90       | s     | 0, 1, ..., 59                    |
	 * |                         |          | ss    | 00, 01, ..., 59                  |
	 * | 1/10 of second          | 100      | S     | 0, 1, ..., 9                     |
	 * | 1/100 of second         | 100      | SS    | 00, 01, ..., 99                  |
	 * | Millisecond             | 100      | SSS   | 000, 001, ..., 999               |
	 * | Timezone                | 110      | Z     | -01:00, +00:00, ... +12:00       |
	 * |                         |          | ZZ    | -0100, +0000, ..., +1200         |
	 * | Seconds timestamp       | 120      | X     | 512969520                        |
	 * | Milliseconds timestamp  | 120      | x     | 512969520900                     |
	 *
	 * Values will be assigned to the date in the ascending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `baseDate` which works as a context of parsing.
	 *
	 * `baseDate` must be passed for correct work of the function.
	 * If you're not sure which `baseDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/DD/YYYY', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `baseDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * Also, `parse` unfolds long formats like those in [format]{@link https://date-fns.org/docs/format}:
	 * | Token | Input examples                 |
	 * |-------|--------------------------------|
	 * | LT    | 05:30 a.m.                     |
	 * | LTS   | 05:30:15 a.m.                  |
	 * | L     | 07/02/1995                     |
	 * | l     | 7/2/1995                       |
	 * | LL    | July 2 1995                    |
	 * | ll    | Jul 2 1995                     |
	 * | LLL   | July 2 1995 05:30 a.m.         |
	 * | lll   | Jul 2 1995 05:30 a.m.          |
	 * | LLLL  | Sunday, July 2 1995 05:30 a.m. |
	 * | llll  | Sun, Jul 2 1995 05:30 a.m.     |
	 *
	 * The characters wrapped in square brackets in the format string are escaped.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `baseDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|String|Number} baseDate - the date to took the missing higher priority values from
	 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse(
	 *   '02/11/2014',
	 *   'MM/DD/YYYY',
	 *   new Date()
	 * )
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in English locale in the context of 2010 year:
	 * import eoLocale from 'date-fns/locale/eo'
	 * var result = parse(
	 *   '28-a de februaro',
	 *   'Do [de] MMMM',
	 *   new Date(2010, 0, 1)
	 *   {locale: eoLocale}
	 * )
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse (dirtyDateString, dirtyFormatString, dirtyBaseDate, dirtyOptions) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present')
	  }
	
	  var dateString = String(dirtyDateString);
	  var options = dirtyOptions || {};
	
	  var weekStartsOn = options.weekStartsOn === undefined ? 0 : Number(options.weekStartsOn);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
	  }
	
	  var locale$$1 = options.locale || locale;
	  var localeParsers = locale$$1.parsers || {};
	  var localeUnits = locale$$1.units || {};
	
	  if (!locale$$1.match) {
	    throw new RangeError('locale must contain match property')
	  }
	
	  if (!locale$$1.formatLong) {
	    throw new RangeError('locale must contain formatLong property')
	  }
	
	  var formatString = String(dirtyFormatString)
	    .replace(longFormattingTokensRegExp$1, function (substring) {
	      if (substring[0] === '[') {
	        return substring
	      }
	
	      if (substring[0] === '\\') {
	        return cleanEscapedString$1(substring)
	      }
	
	      return locale$$1.formatLong(substring)
	    });
	
	  if (formatString === '') {
	    if (dateString === '') {
	      return toDate(dirtyBaseDate, options)
	    } else {
	      return new Date(NaN)
	    }
	  }
	
	  var subFnOptions = cloneObject(options);
	  subFnOptions.locale = locale$$1;
	
	  var tokens = formatString.match(locale$$1.parsingTokensRegExp || defaultParsingTokensRegExp);
	  var tokensLength = tokens.length;
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [{
	    priority: TIMEZONE_UNIT_PRIORITY,
	    set: dateToSystemTimezone,
	    index: 0
	  }];
	
	  var i;
	  for (i = 0; i < tokensLength; i++) {
	    var token = tokens[i];
	    var parser = localeParsers[token] || parsers[token];
	    if (parser) {
	      var matchResult;
	
	      if (parser.match instanceof RegExp) {
	        matchResult = parser.match.exec(dateString);
	      } else {
	        matchResult = parser.match(dateString, subFnOptions);
	      }
	
	      if (!matchResult) {
	        return new Date(NaN)
	      }
	
	      var unitName = parser.unit;
	      var unit = localeUnits[unitName] || units[unitName];
	
	      setters.push({
	        priority: unit.priority,
	        set: unit.set,
	        value: parser.parse(matchResult, subFnOptions),
	        index: setters.length
	      });
	
	      var substring = matchResult[0];
	      dateString = dateString.slice(substring.length);
	    } else {
	      var head = tokens[i].match(/^\[.*]$/) ? tokens[i].replace(/^\[|]$/g, '') : tokens[i];
	      if (dateString.indexOf(head) === 0) {
	        dateString = dateString.slice(head.length);
	      } else {
	        return new Date(NaN)
	      }
	    }
	  }
	
	  var uniquePrioritySetters = setters
	    .map(function (setter) {
	      return setter.priority
	    })
	    .sort(function (a, b) {
	      return a - b
	    })
	    .filter(function (priority, index, array) {
	      return array.indexOf(priority) === index
	    })
	    .map(function (priority) {
	      return setters
	        .filter(function (setter) {
	          return setter.priority === priority
	        })
	        .reverse()
	    })
	    .map(function (setterArray) {
	      return setterArray[0]
	    });
	
	  var date = toDate(dirtyBaseDate, options);
	
	  if (isNaN(date)) {
	    return new Date(NaN)
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
	  var utcDate = subMinutes(date, date.getTimezoneOffset());
	
	  var dateValues = {date: utcDate};
	
	  var settersLength = uniquePrioritySetters.length;
	  for (i = 0; i < settersLength; i++) {
	    var setter = uniquePrioritySetters[i];
	    dateValues = setter.set(dateValues, setter.value, subFnOptions);
	  }
	
	  return dateValues.date
	}
	
	function dateToSystemTimezone (dateValues) {
	  var date = dateValues.date;
	  var time = date.getTime();
	
	  // Get the system timezone offset at (moment of time - offset)
	  var offset = date.getTimezoneOffset();
	
	  // Get the system timezone offset at the exact moment of time
	  offset = new Date(time + offset * MILLISECONDS_IN_MINUTE$6).getTimezoneOffset();
	
	  // Convert date in timezone "UTC+00:00" to the system timezone
	  dateValues.date = new Date(time + offset * MILLISECONDS_IN_MINUTE$6);
	
	  return dateValues
	}
	
	function cleanEscapedString$1 (input) {
	  if (input.match(/\[[\s\S]/)) {
	    return input.replace(/^\[|]$/g, '')
	  }
	  return input.replace(/\\/g, '')
	}
	
	// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
	
	// 
	
	/**
	 * Custom parse behavior on top of date-fns parse function.
	 */
	function parseDate$1 (date, format$$1) {
	  if (typeof date !== 'string') {
	    return isValid(date) ? date : null;
	  }
	
	  var parsed = parse(date, format$$1, new Date());
	
	  // if date is not valid or the formatted output after parsing does not match
	  // the string value passed in (avoids overflows)
	  if (!isValid(parsed) || format(parsed, format$$1) !== date) {
	    return null;
	  }
	
	  return parsed;
	}
	
	var after = function (value, ref) {
	  var otherValue = ref[0];
	  var inclusion = ref[1];
	  var format = ref[2];
	
	  if (typeof format === 'undefined') {
	    format = inclusion;
	    inclusion = false;
	  }
	  value = parseDate$1(value, format);
	  otherValue = parseDate$1(otherValue, format);
	
	  // if either is not valid.
	  if (!value || !otherValue) {
	    return false;
	  }
	
	  return isAfter(value, otherValue) || (inclusion && isEqual(value, otherValue));
	};
	
	/**
	 * Some Alpha Regex helpers.
	 * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
	 */
	
	var alpha$1 = {
	  en: /^[A-Z]*$/i,
	  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
	  da: /^[A-ZÆØÅ]*$/i,
	  de: /^[A-ZÄÖÜß]*$/i,
	  es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
	  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
	  lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
	  nl: /^[A-ZÉËÏÓÖÜ]*$/i,
	  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
	  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
	  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
	  ru: /^[А-ЯЁ]*$/i,
	  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
	  sr: /^[A-ZČĆŽŠĐ]*$/i,
	  tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
	  uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
	};
	
	var alphaSpaces = {
	  en: /^[A-Z\s]*$/i,
	  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
	  da: /^[A-ZÆØÅ\s]*$/i,
	  de: /^[A-ZÄÖÜß\s]*$/i,
	  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
	  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
	  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
	  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
	  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
	  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
	  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
	  ru: /^[А-ЯЁ\s]*$/i,
	  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
	  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
	  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
	  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
	  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/
	};
	
	var alphanumeric = {
	  en: /^[0-9A-Z]*$/i,
	  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
	  da: /^[0-9A-ZÆØÅ]$/i,
	  de: /^[0-9A-ZÄÖÜß]*$/i,
	  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
	  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
	  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
	  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
	  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
	  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
	  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
	  ru: /^[0-9А-ЯЁ]*$/i,
	  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
	  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
	  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
	  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/
	};
	
	var alphaDash = {
	  en: /^[0-9A-Z_-]*$/i,
	  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
	  da: /^[0-9A-ZÆØÅ_-]*$/i,
	  de: /^[0-9A-ZÄÖÜß_-]*$/i,
	  es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
	  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
	  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
	  nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
	  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
	  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
	  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
	  ru: /^[0-9А-ЯЁ_-]*$/i,
	  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
	  sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
	  tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
	  uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
	  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/
	};
	
	var validate = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var locale = ref[0]; if ( locale === void 0 ) locale = null;
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alpha$1).some(function (loc) { return alpha$1[loc].test(value); });
	  }
	
	  return (alpha$1[locale] || alpha$1.en).test(value);
	};
	
	var validate$1 = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var locale = ref[0]; if ( locale === void 0 ) locale = null;
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$1(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
	  }
	
	  return (alphaDash[locale] || alphaDash.en).test(value);
	};
	
	var validate$2 = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var locale = ref[0]; if ( locale === void 0 ) locale = null;
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$2(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
	  }
	
	  return (alphanumeric[locale] || alphanumeric.en).test(value);
	};
	
	var validate$3 = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var locale = ref[0]; if ( locale === void 0 ) locale = null;
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$3(val, [locale]); });
	  }
	
	  // Match at least one locale.
	  if (! locale) {
	    return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
	  }
	
	  return (alphaSpaces[locale] || alphaSpaces.en).test(value);
	};
	
	var before = function (value, ref) {
	  var otherValue = ref[0];
	  var inclusion = ref[1];
	  var format = ref[2];
	
	  if (typeof format === 'undefined') {
	    format = inclusion;
	    inclusion = false;
	  }
	  value = parseDate$1(value, format);
	  otherValue = parseDate$1(otherValue, format);
	
	  // if either is not valid.
	  if (!value || !otherValue) {
	    return false;
	  }
	
	  return isBefore(value, otherValue) || (inclusion && isEqual(value, otherValue));
	};
	
	var validate$4 = function (value, ref) {
	  var min = ref[0];
	  var max = ref[1];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$4(val, [min, max]); });
	  }
	
	  return Number(min) <= value && Number(max) >= value;
	};
	
	var confirmed = function (value, other) { return String(value) === String(other); };
	
	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var assertString_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assertString;
	function assertString(input) {
	  var isString = typeof input === 'string' || input instanceof String;
	
	  if (!isString) {
	    throw new TypeError('This library (validator.js) validates strings only');
	  }
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(assertString_1);
	
	var isCreditCard_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isCreditCard;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-len */
	var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
	/* eslint-enable max-len */
	
	function isCreditCard(str) {
	  (0, _assertString2.default)(str);
	  var sanitized = str.replace(/[- ]+/g, '');
	  if (!creditCard.test(sanitized)) {
	    return false;
	  }
	  var sum = 0;
	  var digit = void 0;
	  var tmpNum = void 0;
	  var shouldDouble = void 0;
	  for (var i = sanitized.length - 1; i >= 0; i--) {
	    digit = sanitized.substring(i, i + 1);
	    tmpNum = parseInt(digit, 10);
	    if (shouldDouble) {
	      tmpNum *= 2;
	      if (tmpNum >= 10) {
	        sum += tmpNum % 10 + 1;
	      } else {
	        sum += tmpNum;
	      }
	    } else {
	      sum += tmpNum;
	    }
	    shouldDouble = !shouldDouble;
	  }
	  return !!(sum % 10 === 0 ? sanitized : false);
	}
	module.exports = exports['default'];
	});
	
	var isCreditCard = unwrapExports(isCreditCard_1);
	
	var credit_card = function (value) { return isCreditCard(String(value)); };
	
	var validate$5 = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';
	  var separator = ref[1]; if ( separator === void 0 ) separator = '.';
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$5(val, [decimals, separator]); });
	  }
	
	  if (value === null || value === undefined || value === '') {
	    return true;
	  }
	
	  // if is 0.
	  if (Number(decimals) === 0) {
	    return /^-?\d*$/.test(value);
	  }
	
	  var regexPart = decimals === '*' ? '+' : ("{1," + decimals + "}");
	  var regex = new RegExp(("^-?\\d*(\\" + separator + "\\d" + regexPart + ")?$"));
	
	  if (! regex.test(value)) {
	    return false;
	  }
	
	  var parsedValue = parseFloat(value);
	
	  // eslint-disable-next-line
	    return parsedValue === parsedValue;
	};
	
	var date_between = function (value, params) {
	  var min;
	  var max;
	  var format;
	  var inclusivity = '()';
	
	  if (params.length > 3) {
	    var assign;
	    (assign = params, min = assign[0], max = assign[1], inclusivity = assign[2], format = assign[3]);
	  } else {
	    var assign$1;
	    (assign$1 = params, min = assign$1[0], max = assign$1[1], format = assign$1[2]);
	  }
	
	  var minDate = parseDate$1(String(min), format);
	  var maxDate = parseDate$1(String(max), format);
	  var dateVal = parseDate$1(String(value), format);
	
	  if (!minDate || !maxDate || !dateVal) {
	    return false;
	  }
	
	  if (inclusivity === '()') {
	    return isAfter(dateVal, minDate) && isBefore(dateVal, maxDate);
	  }
	
	  if (inclusivity === '(]') {
	    return isAfter(dateVal, minDate) && (isEqual(dateVal, maxDate) || isBefore(dateVal, maxDate));
	  }
	
	  if (inclusivity === '[)') {
	    return isBefore(dateVal, maxDate) && (isEqual(dateVal, minDate) || isAfter(dateVal, minDate));
	  }
	
	  return isEqual(dateVal, maxDate) || isEqual(dateVal, minDate) ||
	        (isBefore(dateVal, maxDate) && isAfter(dateVal, minDate));
	};
	
	var date_format = function (value, ref) {
	  var format = ref[0];
	
	  return !!parseDate$1(value, format);
	};
	
	var validate$6 = function (value, ref) {
	  var length = ref[0];
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$6(val, [length]); });
	  }
	  var strVal = String(value);
	
	  return /^[0-9]*$/.test(strVal) && strVal.length === Number(length);
	};
	
	var validateImage = function (file, width, height) {
	  var URL = window.URL || window.webkitURL;
	  return new Promise(function (resolve) {
	    var image = new Image();
	    image.onerror = function () { return resolve({ valid: false }); };
	    image.onload = function () { return resolve({
	      valid: image.width === Number(width) && image.height === Number(height)
	    }); };
	
	    image.src = URL.createObjectURL(file);
	  });
	};
	
	var dimensions = function (files, ref) {
	  var width = ref[0];
	  var height = ref[1];
	
	  var list = [];
	  for (var i = 0; i < files.length; i++) {
	    // if file is not an image, reject.
	    if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
	      return false;
	    }
	
	    list.push(files[i]);
	  }
	
	  return Promise.all(list.map(function (file) { return validateImage(file, width, height); }));
	};
	
	var merge_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = merge;
	function merge() {
	  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaults = arguments[1];
	
	  for (var key in defaults) {
	    if (typeof obj[key] === 'undefined') {
	      obj[key] = defaults[key];
	    }
	  }
	  return obj;
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(merge_1);
	
	var isByteLength_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isByteLength;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable prefer-rest-params */
	function isByteLength(str, options) {
	  (0, _assertString2.default)(str);
	  var min = void 0;
	  var max = void 0;
	  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	    min = options.min || 0;
	    max = options.max;
	  } else {
	    // backwards compatibility: isByteLength(str, min [, max])
	    min = arguments[1];
	    max = arguments[2];
	  }
	  var len = encodeURI(str).split(/%..|./).length - 1;
	  return len >= min && (typeof max === 'undefined' || len <= max);
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(isByteLength_1);
	
	var isFQDN = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFDQN;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_fqdn_options = {
	  require_tld: true,
	  allow_underscores: false,
	  allow_trailing_dot: false
	};
	
	function isFDQN(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_fqdn_options);
	
	  /* Remove the optional trailing dot before checking validity */
	  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
	    str = str.substring(0, str.length - 1);
	  }
	  var parts = str.split('.');
	  if (options.require_tld) {
	    var tld = parts.pop();
	    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
	      return false;
	    }
	    // disallow spaces
	    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
	      return false;
	    }
	  }
	  for (var part, i = 0; i < parts.length; i++) {
	    part = parts[i];
	    if (options.allow_underscores) {
	      part = part.replace(/_/g, '');
	    }
	    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
	      return false;
	    }
	    // disallow full-width chars
	    if (/[\uff01-\uff5e]/.test(part)) {
	      return false;
	    }
	    if (part[0] === '-' || part[part.length - 1] === '-') {
	      return false;
	    }
	  }
	  return true;
	}
	module.exports = exports['default'];
	});
	
	unwrapExports(isFQDN);
	
	var isEmail_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEmail;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	
	
	var _isByteLength2 = _interopRequireDefault(isByteLength_1);
	
	
	
	var _isFQDN2 = _interopRequireDefault(isFQDN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_email_options = {
	  allow_display_name: false,
	  require_display_name: false,
	  allow_utf8_local_part: true,
	  require_tld: true
	};
	
	/* eslint-disable max-len */
	/* eslint-disable no-control-regex */
	var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
	var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
	var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
	var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
	var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
	/* eslint-enable max-len */
	/* eslint-enable no-control-regex */
	
	function isEmail(str, options) {
	  (0, _assertString2.default)(str);
	  options = (0, _merge2.default)(options, default_email_options);
	
	  if (options.require_display_name || options.allow_display_name) {
	    var display_email = str.match(displayName);
	    if (display_email) {
	      str = display_email[1];
	    } else if (options.require_display_name) {
	      return false;
	    }
	  }
	
	  var parts = str.split('@');
	  var domain = parts.pop();
	  var user = parts.join('@');
	
	  var lower_domain = domain.toLowerCase();
	  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
	    user = user.replace(/\./g, '').toLowerCase();
	  }
	
	  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
	    return false;
	  }
	
	  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
	    return false;
	  }
	
	  if (user[0] === '"') {
	    user = user.slice(1, user.length - 1);
	    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
	  }
	
	  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
	
	  var user_parts = user.split('.');
	  for (var i = 0; i < user_parts.length; i++) {
	    if (!pattern.test(user_parts[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	module.exports = exports['default'];
	});
	
	var isEmail = unwrapExports(isEmail_1);
	
	var validate$7 = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isEmail(String(val)); });
	  }
	
	  return isEmail(String(value));
	};
	
	var ext = function (files, extensions) {
	  var regex = new RegExp((".(" + (extensions.join('|')) + ")$"), 'i');
	
	  return files.every(function (file) { return regex.test(file.name); });
	};
	
	var image = function (files) { return files.every(function (file) { return /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(file.name); }
	); };
	
	var validate$8 = function (value, options) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$8(val, options); });
	  }
	
	  // eslint-disable-next-line
	  return !! options.filter(function (option) { return option == value; }).length;
	};
	
	var isIP_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isIP;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
	var ipv6Block = /^[0-9A-F]{1,4}$/i;
	
	function isIP(str) {
	  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  (0, _assertString2.default)(str);
	  version = String(version);
	  if (!version) {
	    return isIP(str, 4) || isIP(str, 6);
	  } else if (version === '4') {
	    if (!ipv4Maybe.test(str)) {
	      return false;
	    }
	    var parts = str.split('.').sort(function (a, b) {
	      return a - b;
	    });
	    return parts[3] <= 255;
	  } else if (version === '6') {
	    var blocks = str.split(':');
	    var foundOmissionBlock = false; // marker to indicate ::
	
	    // At least some OS accept the last 32 bits of an IPv6 address
	    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
	    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
	    // and '::a.b.c.d' is deprecated, but also valid.
	    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
	    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;
	
	    if (blocks.length > expectedNumberOfBlocks) {
	      return false;
	    }
	    // initial or final ::
	    if (str === '::') {
	      return true;
	    } else if (str.substr(0, 2) === '::') {
	      blocks.shift();
	      blocks.shift();
	      foundOmissionBlock = true;
	    } else if (str.substr(str.length - 2) === '::') {
	      blocks.pop();
	      blocks.pop();
	      foundOmissionBlock = true;
	    }
	
	    for (var i = 0; i < blocks.length; ++i) {
	      // test for a :: which can not be at the string start/end
	      // since those cases have been handled above
	      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
	        if (foundOmissionBlock) {
	          return false; // multiple :: in address
	        }
	        foundOmissionBlock = true;
	      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {
	        // it has been checked before that the last
	        // block is a valid IPv4 address
	      } else if (!ipv6Block.test(blocks[i])) {
	        return false;
	      }
	    }
	    if (foundOmissionBlock) {
	      return blocks.length >= 1;
	    }
	    return blocks.length === expectedNumberOfBlocks;
	  }
	  return false;
	}
	module.exports = exports['default'];
	});
	
	var isIP = unwrapExports(isIP_1);
	
	// 
	
	/**
	 * Gets the data attribute. the name must be kebab-case.
	 */
	var getDataAttribute = function (el, name) { return el.getAttribute(("data-vv-" + name)); };
	
	/**
	 * Checks if the value is either null or undefined.
	 */
	var isNullOrUndefined = function (value) {
	  return value === null || value === undefined;
	};
	
	/**
	 * Sets the data attribute.
	 */
	var setDataAttribute = function (el, name, value) { return el.setAttribute(("data-vv-" + name), value); };
	
	/**
	 * Creates the default flags object.
	 */
	var createFlags = function () { return ({
	  untouched: true,
	  touched: false,
	  dirty: false,
	  pristine: true,
	  valid: null,
	  invalid: null,
	  validated: false,
	  pending: false,
	  required: false
	}); };
	
	/**
	 * Shallow object comparison.
	 */
	var isEqual$1 = function (lhs, rhs) {
	  if (lhs instanceof RegExp && rhs instanceof RegExp) {
	    return isEqual$1(lhs.source, rhs.source) && isEqual$1(lhs.flags, rhs.flags);
	  }
	
	  if (Array.isArray(lhs) && Array.isArray(rhs)) {
	    if (lhs.length !== rhs.length) { return false; }
	
	    for (var i = 0; i < lhs.length; i++) {
	      if (!isEqual$1(lhs[i], rhs[i])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  // if both are objects, compare each key recursively.
	  if (isObject(lhs) && isObject(rhs)) {
	    return Object.keys(lhs).every(function (key) {
	      return isEqual$1(lhs[key], rhs[key]);
	    }) && Object.keys(rhs).every(function (key) {
	      return isEqual$1(lhs[key], rhs[key]);
	    });
	  }
	
	  return lhs === rhs;
	};
	
	/**
	 * Determines the input field scope.
	 */
	var getScope = function (el) {
	  var scope = getDataAttribute(el, 'scope');
	  if (isNullOrUndefined(scope) && el.form) {
	    scope = getDataAttribute(el.form, 'scope');
	  }
	
	  return !isNullOrUndefined(scope) ? scope : null;
	};
	
	/**
	 * Gets the value in an object safely.
	 */
	var getPath = function (path, target, def) {
	  if ( def === void 0 ) def = undefined;
	
	  if (!path || !target) { return def; }
	
	  var value = target;
	  path.split('.').every(function (prop) {
	    if (! Object.prototype.hasOwnProperty.call(value, prop) && value[prop] === undefined) {
	      value = def;
	
	      return false;
	    }
	
	    value = value[prop];
	
	    return true;
	  });
	
	  return value;
	};
	
	/**
	 * Checks if path exists within an object.
	 */
	var hasPath = function (path, target) {
	  var obj = target;
	  return path.split('.').every(function (prop) {
	    if (! Object.prototype.hasOwnProperty.call(obj, prop)) {
	      return false;
	    }
	
	    obj = obj[prop];
	
	    return true;
	  });
	};
	
	/**
	 * Parses a rule string expression.
	 */
	var parseRule = function (rule) {
	  var params = [];
	  var name = rule.split(':')[0];
	
	  if (~rule.indexOf(':')) {
	    params = rule.split(':').slice(1).join(':').split(',');
	  }
	
	  return { name: name, params: params };
	};
	
	/**
	 * Debounces a function.
	 */
	var debounce = function (fn, wait, immediate) {
	  if ( wait === void 0 ) wait = 0;
	  if ( immediate === void 0 ) immediate = false;
	
	  if (wait === 0) {
	    return fn;
	  }
	
	  var timeout;
	
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    var later = function () {
	      timeout = null;
	      if (!immediate) { fn.apply(void 0, args); }
	    };
	    /* istanbul ignore next */
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    /* istanbul ignore next */
	    if (callNow) { fn.apply(void 0, args); }
	  };
	};
	
	/**
	 * Normalizes the given rules expression.
	 */
	var normalizeRules = function (rules) {
	  // if falsy value return an empty object.
	  if (!rules) {
	    return {};
	  }
	
	  if (isObject(rules)) {
	    // $FlowFixMe
	    return Object.keys(rules).reduce(function (prev, curr) {
	      var params = [];
	      // $FlowFixMe
	      if (rules[curr] === true) {
	        params = [];
	      } else if (Array.isArray(rules[curr])) {
	        params = rules[curr];
	      } else {
	        params = [rules[curr]];
	      }
	
	      // $FlowFixMe
	      if (rules[curr] !== false) {
	        prev[curr] = params;
	      }
	
	      return prev;
	    }, {});
	  }
	
	  if (typeof rules !== 'string') {
	    warn('rules must be either a string or an object.');
	    return {};
	  }
	
	  return rules.split('|').reduce(function (prev, rule) {
	    var parsedRule = parseRule(rule);
	    if (!parsedRule.name) {
	      return prev;
	    }
	
	    prev[parsedRule.name] = parsedRule.params;
	    return prev;
	  }, {});
	};
	
	/**
	 * Emits a warning to the console.
	 */
	var warn = function (message) {
	  console.warn(("[vee-validate] " + message)); // eslint-disable-line
	};
	
	/**
	 * Creates a branded error object.
	 */
	var createError = function (message) { return new Error(("[vee-validate] " + message)); };
	
	/**
	 * Checks if the value is an object.
	 */
	var isObject = function (obj) { return obj !== null && obj && typeof obj === 'object' && ! Array.isArray(obj); };
	
	/**
	 * Checks if a function is callable.
	 */
	var isCallable = function (func) { return typeof func === 'function'; };
	
	/**
	 * Check if element has the css class on it.
	 */
	var hasClass = function (el, className) {
	  if (el.classList) {
	    return el.classList.contains(className);
	  }
	
	  return !!el.className.match(new RegExp(("(\\s|^)" + className + "(\\s|$)")));
	};
	
	/**
	 * Adds the provided css className to the element.
	 */
	var addClass = function (el, className) {
	  if (el.classList) {
	    el.classList.add(className);
	    return;
	  }
	
	  if (!hasClass(el, className)) {
	    el.className += " " + className;
	  }
	};
	
	/**
	 * Remove the provided css className from the element.
	 */
	var removeClass = function (el, className) {
	  if (el.classList) {
	    el.classList.remove(className);
	    return;
	  }
	
	  if (hasClass(el, className)) {
	    var reg = new RegExp(("(\\s|^)" + className + "(\\s|$)"));
	    el.className = el.className.replace(reg, ' ');
	  }
	};
	
	/**
	 * Adds or removes a class name on the input depending on the status flag.
	 */
	var toggleClass = function (el, className, status) {
	  if (!el || !className) { return; }
	
	  if (Array.isArray(className)) {
	    className.forEach(function (item) { return toggleClass(el, item, status); });
	    return;
	  }
	
	  if (status) {
	    return addClass(el, className);
	  }
	
	  removeClass(el, className);
	};
	
	/**
	 * Converts an array-like object to array, provides a simple polyfill for Array.from
	 */
	var toArray = function (arrayLike) {
	  if (isCallable(Array.from)) {
	    return Array.from(arrayLike);
	  }
	
	  var array = [];
	  var length = arrayLike.length;
	  for (var i = 0; i < length; i++) {
	    array.push(arrayLike[i]);
	  }
	
	  return array;
	};
	
	/**
	 * Assign polyfill from the mdn.
	 */
	var assign = function (target) {
	  var others = [], len = arguments.length - 1;
	  while ( len-- > 0 ) others[ len ] = arguments[ len + 1 ];
	
	  /* istanbul ignore else */
	  if (isCallable(Object.assign)) {
	    return Object.assign.apply(Object, [ target ].concat( others ));
	  }
	
	  /* istanbul ignore next */
	  if (target == null) {
	    throw new TypeError('Cannot convert undefined or null to object');
	  }
	
	  /* istanbul ignore next */
	  var to = Object(target);
	  /* istanbul ignore next */
	  others.forEach(function (arg) {
	    // Skip over if undefined or null
	    if (arg != null) {
	      Object.keys(arg).forEach(function (key) {
	        to[key] = arg[key];
	      });
	    }
	  });
	  /* istanbul ignore next */
	  return to;
	};
	
	var id = 0;
	var idTemplate = '{id}';
	
	/**
	 * Generates a unique id.
	 */
	var uniqId = function () {
	  // handle too many uses of uniqId, although unlikely.
	  if (id >= 9999) {
	    id = 0;
	    // shift the template.
	    idTemplate = idTemplate.replace('{id}', '_{id}');
	  }
	
	  id++;
	  var newId = idTemplate.replace('{id}', String(id));
	
	  return newId;
	};
	
	/**
	 * finds the first element that satisfies the predicate callback, polyfills array.find
	 */
	var find = function (arrayLike, predicate) {
	  var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
	  for (var i = 0; i < array.length; i++) {
	    if (predicate(array[i])) {
	      return array[i];
	    }
	  }
	
	  return undefined;
	};
	
	/**
	 * Returns a suitable event name for the input element.
	 */
	var getInputEventName = function (el) {
	  if (el && (el.tagName === 'SELECT' || ~['radio', 'checkbox', 'file'].indexOf(el.type))) {
	    return 'change';
	  }
	
	  return 'input';
	};
	
	var isBuiltInComponent = function (vnode) {
	  if (!vnode) {
	    return false;
	  }
	
	  var tag = vnode.componentOptions.tag;
	
	  return /keep-alive|transition|transition-group/.test(tag);
	};
	
	var makeEventsArray = function (events) {
	  return (typeof events === 'string' && events.length) ? events.split('|') : [];
	};
	
	var makeDelayObject = function (events, delay, delayConfig) {
	  if (typeof delay === 'number') {
	    return events.reduce(function (prev, e) {
	      prev[e] = delay;
	      return prev;
	    }, {});
	  }
	
	  return events.reduce(function (prev, e) {
	    if (typeof delay === 'object' && e in delay) {
	      prev[e] = delay[e];
	      return prev;
	    }
	
	    if (typeof delayConfig === 'number') {
	      prev[e] = delayConfig;
	      return prev;
	    }
	
	    prev[e] = (delayConfig && delayConfig[e]) || 0;
	
	    return prev;
	  }, {});
	};
	
	var deepParseInt = function (input) {
	  if (typeof input === 'number') { return input; }
	
	  if (typeof input === 'string') { return parseInt(input); }
	
	  var map = {};
	  for (var element in input) {
	    map[element] = parseInt(input[element]);
	  }
	
	  return map;
	};
	
	var merge$1 = function (target, source) {
	  if (! (isObject(target) && isObject(source))) {
	    return target;
	  }
	
	  Object.keys(source).forEach(function (key) {
	    if (isObject(source[key])) {
	      if (! target[key]) {
	        assign(target, ( obj = {}, obj[key] = {}, obj ));
	        var obj;
	      }
	
	      merge$1(target[key], source[key]);
	      return;
	    }
	
	    assign(target, ( obj$1 = {}, obj$1[key] = source[key], obj$1 ));
	    var obj$1;
	  });
	
	  return target;
	};
	
	var ip = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var version = ref[0]; if ( version === void 0 ) version = 4;
	
	  if (isNullOrUndefined(value)) {
	    value = '';
	  }
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isIP(val, version); });
	  }
	
	  return isIP(value, version);
	};
	
	var is = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var other = ref[0];
	
	  return value === other;
	};
	
	var is_not = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var other = ref[0];
	
	  return value !== other;
	};
	
	/**
	 * @param {Array|String} value
	 * @param {Number} length
	 * @param {Number} max
	 */
	var compare = function (value, length, max) {
	  if (max === undefined) {
	    return value.length === length;
	  }
	
	  // cast to number.
	  max = Number(max);
	
	  return value.length >= length && value.length <= max;
	};
	
	var length = function (value, ref) {
	  var length = ref[0];
	  var max = ref[1]; if ( max === void 0 ) max = undefined;
	
	  length = Number(length);
	  if (value === undefined || value === null) {
	    return false;
	  }
	
	  if (typeof value === 'number') {
	    value = String(value);
	  }
	
	  if (!value.length) {
	    value = toArray(value);
	  }
	
	  return compare(value, length, max);
	};
	
	var integer = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
	  }
	
	  return /^-?[0-9]+$/.test(String(value));
	};
	
	var max$1 = function (value, ref) {
	  var length = ref[0];
	
	  if (value === undefined || value === null) {
	    return length >= 0;
	  }
	
	  return String(value).length <= length;
	};
	
	var max_value = function (value, ref) {
	  var max = ref[0];
	
	  if (Array.isArray(value) || value === null || value === undefined || value === '') {
	    return false;
	  }
	
	  return Number(value) <= max;
	};
	
	var mimes = function (files, mimes) {
	  var regex = new RegExp(((mimes.join('|').replace('*', '.+')) + "$"), 'i');
	
	  return files.every(function (file) { return regex.test(file.type); });
	};
	
	var min$1 = function (value, ref) {
	  var length = ref[0];
	
	  if (value === undefined || value === null) {
	    return false;
	  }
	  return String(value).length >= length;
	};
	
	var min_value = function (value, ref) {
	  var min = ref[0];
	
	  if (Array.isArray(value) || value === null || value === undefined || value === '') {
	    return false;
	  }
	
	  return Number(value) >= min;
	};
	
	var validate$9 = function (value, options) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return validate$9(val, options); });
	  }
	
	  // eslint-disable-next-line
	  return ! options.filter(function (option) { return option == value; }).length;
	};
	
	var numeric = function (value) {
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return /^[0-9]+$/.test(String(val)); });
	  }
	
	  return /^[0-9]+$/.test(String(value));
	};
	
	var regex = function (value, ref) {
	  var regex = ref[0];
	  var flags = ref.slice(1);
	
	  if (regex instanceof RegExp) {
	    return regex.test(value);
	  }
	
	  return new RegExp(regex, flags).test(String(value));
	};
	
	var required = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var invalidateFalse = ref[0]; if ( invalidateFalse === void 0 ) invalidateFalse = false;
	
	  if (Array.isArray(value)) {
	    return !! value.length;
	  }
	
	  // incase a field considers `false` as an empty value like checkboxes.
	  if (value === false && invalidateFalse) {
	    return false;
	  }
	
	  if (value === undefined || value === null) {
	    return false;
	  }
	
	  return !! String(value).trim().length;
	};
	
	var size = function (files, ref) {
	  var size = ref[0];
	
	  if (isNaN(size)) {
	    return false;
	  }
	
	  var nSize = Number(size) * 1024;
	  for (var i = 0; i < files.length; i++) {
	    if (files[i].size > nSize) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var isURL_1 = createCommonjsModule(function (module, exports) {
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isURL;
	
	
	
	var _assertString2 = _interopRequireDefault(assertString_1);
	
	
	
	var _isFQDN2 = _interopRequireDefault(isFQDN);
	
	
	
	var _isIP2 = _interopRequireDefault(isIP_1);
	
	
	
	var _merge2 = _interopRequireDefault(merge_1);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var default_url_options = {
	  protocols: ['http', 'https', 'ftp'],
	  require_tld: true,
	  require_protocol: false,
	  require_host: true,
	  require_valid_protocol: true,
	  allow_underscores: false,
	  allow_trailing_dot: false,
	  allow_protocol_relative_urls: false
	};
	
	var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
	
	function isRegExp(obj) {
	  return Object.prototype.toString.call(obj) === '[object RegExp]';
	}
	
	function checkHost(host, matches) {
	  for (var i = 0; i < matches.length; i++) {
	    var match = matches[i];
	    if (host === match || isRegExp(match) && match.test(host)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function isURL(url, options) {
	  (0, _assertString2.default)(url);
	  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
	    return false;
	  }
	  if (url.indexOf('mailto:') === 0) {
	    return false;
	  }
	  options = (0, _merge2.default)(options, default_url_options);
	  var protocol = void 0,
	      auth = void 0,
	      host = void 0,
	      hostname = void 0,
	      port = void 0,
	      port_str = void 0,
	      split = void 0,
	      ipv6 = void 0;
	
	  split = url.split('#');
	  url = split.shift();
	
	  split = url.split('?');
	  url = split.shift();
	
	  split = url.split('://');
	  if (split.length > 1) {
	    protocol = split.shift();
	    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
	      return false;
	    }
	  } else if (options.require_protocol) {
	    return false;
	  } else if (options.allow_protocol_relative_urls && url.substr(0, 2) === '//') {
	    split[0] = url.substr(2);
	  }
	  url = split.join('://');
	
	  if (url === '') {
	    return false;
	  }
	
	  split = url.split('/');
	  url = split.shift();
	
	  if (url === '' && !options.require_host) {
	    return true;
	  }
	
	  split = url.split('@');
	  if (split.length > 1) {
	    auth = split.shift();
	    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
	      return false;
	    }
	  }
	  hostname = split.join('@');
	
	  port_str = null;
	  ipv6 = null;
	  var ipv6_match = hostname.match(wrapped_ipv6);
	  if (ipv6_match) {
	    host = '';
	    ipv6 = ipv6_match[1];
	    port_str = ipv6_match[2] || null;
	  } else {
	    split = hostname.split(':');
	    host = split.shift();
	    if (split.length) {
	      port_str = split.join(':');
	    }
	  }
	
	  if (port_str !== null) {
	    port = parseInt(port_str, 10);
	    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
	      return false;
	    }
	  }
	
	  if (!(0, _isIP2.default)(host) && !(0, _isFQDN2.default)(host, options) && (!ipv6 || !(0, _isIP2.default)(ipv6, 6))) {
	    return false;
	  }
	
	  host = host || ipv6;
	
	  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
	    return false;
	  }
	  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
	    return false;
	  }
	
	  return true;
	}
	module.exports = exports['default'];
	});
	
	var isURL = unwrapExports(isURL_1);
	
	var url = function (value, ref) {
	  if ( ref === void 0 ) ref = [];
	  var requireProtocol = ref[0]; if ( requireProtocol === void 0 ) requireProtocol = false;
	
	  var options = { require_protocol: !!requireProtocol, allow_underscores: true };
	  if (isNullOrUndefined(value)) {
	    value = '';
	  }
	
	  if (Array.isArray(value)) {
	    return value.every(function (val) { return isURL(val, options); });
	  }
	
	  return isURL(value, options);
	};
	
	/* eslint-disable camelcase */
	var Rules = {
	  after: after,
	  alpha_dash: validate$1,
	  alpha_num: validate$2,
	  alpha_spaces: validate$3,
	  alpha: validate,
	  before: before,
	  between: validate$4,
	  confirmed: confirmed,
	  credit_card: credit_card,
	  date_between: date_between,
	  date_format: date_format,
	  decimal: validate$5,
	  digits: validate$6,
	  dimensions: dimensions,
	  email: validate$7,
	  ext: ext,
	  image: image,
	  in: validate$8,
	  integer: integer,
	  length: length,
	  ip: ip,
	  is_not: is_not,
	  is: is,
	  max: max$1,
	  max_value: max_value,
	  mimes: mimes,
	  min: min$1,
	  min_value: min_value,
	  not_in: validate$9,
	  numeric: numeric,
	  regex: regex,
	  required: required,
	  size: size,
	  url: url
	};
	
	/**
	 * Formates file size.
	 *
	 * @param {Number|String} size
	 */
	var formatFileSize = function (size) {
	  var units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	  var threshold = 1024;
	  size = Number(size) * threshold;
	  var i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
	  return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
	};
	
	/**
	 * Checks if vee-validate is defined globally.
	 */
	var isDefinedGlobally = function () {
	  return typeof VeeValidate !== 'undefined';
	};
	
	var messages = {
	  _default: function (field) { return ("The " + field + " value is not valid."); },
	  after: function (field, ref) {
	    var target = ref[0];
	    var inclusion = ref[1];
	
	    return ("The " + field + " must be after " + (inclusion ? 'or equal to ' : '') + target + ".");
	},
	  alpha_dash: function (field) { return ("The " + field + " field may contain alpha-numeric characters as well as dashes and underscores."); },
	  alpha_num: function (field) { return ("The " + field + " field may only contain alpha-numeric characters."); },
	  alpha_spaces: function (field) { return ("The " + field + " field may only contain alphabetic characters as well as spaces."); },
	  alpha: function (field) { return ("The " + field + " field may only contain alphabetic characters."); },
	  before: function (field, ref) {
	    var target = ref[0];
	    var inclusion = ref[1];
	
	    return ("The " + field + " must be before " + (inclusion ? 'or equal to ' : '') + target + ".");
	},
	  between: function (field, ref) {
	    var min = ref[0];
	    var max = ref[1];
	
	    return ("The " + field + " field must be between " + min + " and " + max + ".");
	},
	  confirmed: function (field) { return ("The " + field + " confirmation does not match."); },
	  credit_card: function (field) { return ("The " + field + " field is invalid."); },
	  date_between: function (field, ref) {
	    var min = ref[0];
	    var max = ref[1];
	
	    return ("The " + field + " must be between " + min + " and " + max + ".");
	},
	  date_format: function (field, ref) {
	    var format = ref[0];
	
	    return ("The " + field + " must be in the format " + format + ".");
	},
	  decimal: function (field, ref) {
	    if ( ref === void 0 ) ref = [];
	    var decimals = ref[0]; if ( decimals === void 0 ) decimals = '*';
	
	    return ("The " + field + " field must be numeric and may contain " + (!decimals || decimals === '*' ? '' : decimals) + " decimal points.");
	},
	  digits: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field must be numeric and exactly contain " + length + " digits.");
	},
	  dimensions: function (field, ref) {
	    var width = ref[0];
	    var height = ref[1];
	
	    return ("The " + field + " field must be " + width + " pixels by " + height + " pixels.");
	},
	  email: function (field) { return ("The " + field + " field must be a valid email."); },
	  ext: function (field) { return ("The " + field + " field must be a valid file."); },
	  image: function (field) { return ("The " + field + " field must be an image."); },
	  in: function (field) { return ("The " + field + " field must be a valid value."); },
	  integer: function (field) { return ("The " + field + " field must be an integer."); },
	  ip: function (field) { return ("The " + field + " field must be a valid ip address."); },
	  length: function (field, ref) {
	    var length = ref[0];
	    var max = ref[1];
	
	    if (max) {
	      return ("The " + field + " length must be between " + length + " and " + max + ".");
	    }
	
	    return ("The " + field + " length must be " + length + ".");
	  },
	  max: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field may not be greater than " + length + " characters.");
	},
	  max_value: function (field, ref) {
	    var max = ref[0];
	
	    return ("The " + field + " field must be " + max + " or less.");
	},
	  mimes: function (field) { return ("The " + field + " field must have a valid file type."); },
	  min: function (field, ref) {
	    var length = ref[0];
	
	    return ("The " + field + " field must be at least " + length + " characters.");
	},
	  min_value: function (field, ref) {
	    var min = ref[0];
	
	    return ("The " + field + " field must be " + min + " or more.");
	},
	  not_in: function (field) { return ("The " + field + " field must be a valid value."); },
	  numeric: function (field) { return ("The " + field + " field may only contain numeric characters."); },
	  regex: function (field) { return ("The " + field + " field format is invalid."); },
	  required: function (field) { return ("The " + field + " field is required."); },
	  size: function (field, ref) {
	    var size = ref[0];
	
	    return ("The " + field + " size must be less than " + (formatFileSize(size)) + ".");
	},
	  url: function (field) { return ("The " + field + " field is not a valid URL."); }
	};
	
	var locale$1 = {
	  name: 'en',
	  messages: messages,
	  attributes: {}
	};
	
	if (isDefinedGlobally()) {
	  // eslint-disable-next-line
	  VeeValidate.Validator.localize(( obj = {}, obj[locale$1.name] = locale$1, obj ));
	  var obj;
	}
	
	// 
	
	var ErrorBag = function ErrorBag () {
	  this.items = [];
	};
	
	ErrorBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
	    var this$1 = this;
	
	  var index = 0;
	  return {
	    next: function () {
	      return { value: this$1.items[index++], done: index > this$1.items.length };
	    }
	  };
	};
	
	/**
	 * Adds an error to the internal array.
	 */
	ErrorBag.prototype.add = function add (error) {
	  // handle old signature.
	  if (arguments.length > 1) {
	    error = {
	      field: arguments[0],
	      msg: arguments[1],
	      rule: arguments[2],
	      scope: !isNullOrUndefined(arguments[3]) ? arguments[3] : null,
	      regenerate: null
	    };
	  }
	
	  error.scope = !isNullOrUndefined(error.scope) ? error.scope : null;
	  this.items.push(error);
	};
	
	/**
	 * Regenrates error messages if they have a generator function.
	 */
	ErrorBag.prototype.regenerate = function regenerate () {
	  this.items.forEach(function (i) {
	    i.msg = isCallable(i.regenerate) ? i.regenerate() : i.msg;
	  });
	};
	
	/**
	 * Updates a field error with the new field scope.
	 */
	ErrorBag.prototype.update = function update (id, error) {
	  var item = find(this.items, function (i) { return i.id === id; });
	  if (!item) {
	    return;
	  }
	
	  var idx = this.items.indexOf(item);
	  this.items.splice(idx, 1);
	  item.scope = error.scope;
	  this.items.push(item);
	};
	
	/**
	 * Gets all error messages from the internal array.
	 */
	ErrorBag.prototype.all = function all (scope) {
	  if (isNullOrUndefined(scope)) {
	    return this.items.map(function (e) { return e.msg; });
	  }
	
	  return this.items.filter(function (e) { return e.scope === scope; }).map(function (e) { return e.msg; });
	};
	
	/**
	 * Checks if there are any errors in the internal array.
	 */
	ErrorBag.prototype.any = function any (scope) {
	  if (isNullOrUndefined(scope)) {
	    return !!this.items.length;
	  }
	
	  return !!this.items.filter(function (e) { return e.scope === scope; }).length;
	};
	
	/**
	 * Removes all items from the internal array.
	 */
	ErrorBag.prototype.clear = function clear (scope) {
	    var this$1 = this;
	
	  if (isNullOrUndefined(scope)) {
	    scope = null;
	  }
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (this$1.items[i].scope === scope) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	 * Collects errors into groups or for a specific field.
	 */
	ErrorBag.prototype.collect = function collect (field, scope, map) {
	    if ( map === void 0 ) map = true;
	
	  if (!field) {
	    var collection = {};
	    this.items.forEach(function (e) {
	      if (! collection[e.field]) {
	        collection[e.field] = [];
	      }
	
	      collection[e.field].push(map ? e.msg : e);
	    });
	
	    return collection;
	  }
	
	  field = !isNullOrUndefined(field) ? String(field) : field;
	  if (isNullOrUndefined(scope)) {
	    return this.items.filter(function (e) { return e.field === field; }).map(function (e) { return (map ? e.msg : e); });
	  }
	
	  return this.items.filter(function (e) { return e.field === field && e.scope === scope; })
	    .map(function (e) { return (map ? e.msg : e); });
	};
	/**
	 * Gets the internal array length.
	 */
	ErrorBag.prototype.count = function count () {
	  return this.items.length;
	};
	
	/**
	 * Finds and fetches the first error message for the specified field id.
	 */
	ErrorBag.prototype.firstById = function firstById (id) {
	  var error = find(this.items, function (i) { return i.id === id; });
	
	  return error ? error.msg : null;
	};
	
	/**
	 * Gets the first error message for a specific field.
	 */
	ErrorBag.prototype.first = function first (field, scope) {
	    var this$1 = this;
	    if ( scope === void 0 ) scope = null;
	
	  if (isNullOrUndefined(field)) {
	    return null;
	  }
	
	  field = String(field);
	  var selector = this._selector(field);
	  var scoped = this._scope(field);
	
	  if (scoped) {
	    var result = this.first(scoped.name, scoped.scope);
	    // if such result exist, return it. otherwise it could be a field.
	    // with dot in its name.
	    if (result) {
	      return result;
	    }
	  }
	
	  if (selector) {
	    return this.firstByRule(selector.name, selector.rule, scope);
	  }
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (this$1.items[i].field === field && (this$1.items[i].scope === scope)) {
	      return this$1.items[i].msg;
	    }
	  }
	
	  return null;
	};
	
	/**
	 * Returns the first error rule for the specified field
	 */
	ErrorBag.prototype.firstRule = function firstRule (field, scope) {
	  var errors = this.collect(field, scope, false);
	
	  return (errors.length && errors[0].rule) || null;
	};
	
	/**
	 * Checks if the internal array has at least one error for the specified field.
	 */
	ErrorBag.prototype.has = function has (field, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  return !!this.first(field, scope);
	};
	
	/**
	 * Gets the first error message for a specific field and a rule.
	 */
	ErrorBag.prototype.firstByRule = function firstByRule (name, rule, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  var error = this.collect(name, scope, false).filter(function (e) { return e.rule === rule; })[0];
	
	  return (error && error.msg) || null;
	};
	
	/**
	 * Gets the first error message for a specific field that not match the rule.
	 */
	ErrorBag.prototype.firstNot = function firstNot (name, rule, scope) {
	    if ( rule === void 0 ) rule = 'required';
	    if ( scope === void 0 ) scope = null;
	
	  var error = this.collect(name, scope, false).filter(function (e) { return e.rule !== rule; })[0];
	
	  return (error && error.msg) || null;
	};
	
	/**
	 * Removes errors by matching against the id.
	 */
	ErrorBag.prototype.removeById = function removeById (id) {
	    var this$1 = this;
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (this$1.items[i].id === id) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	 * Removes all error messages associated with a specific field.
	 */
	ErrorBag.prototype.remove = function remove (field, scope, id) {
	    var this$1 = this;
	
	  field = !isNullOrUndefined(field) ? String(field) : field;
	  var removeCondition = function (e) {
	    if (e.id && id) {
	      return e.id === id;
	    }
	
	    if (!isNullOrUndefined(scope)) {
	      return e.field === field && e.scope === scope;
	    }
	
	    return e.field === field && e.scope === null;
	  };
	
	  for (var i = 0; i < this.items.length; ++i) {
	    if (removeCondition(this$1.items[i])) {
	      this$1.items.splice(i, 1);
	      --i;
	    }
	  }
	};
	
	/**
	 * Get the field attributes if there's a rule selector.
	 */
	ErrorBag.prototype._selector = function _selector (field) {
	  if (field.indexOf(':') > -1) {
	    var ref = field.split(':');
	      var name = ref[0];
	      var rule = ref[1];
	
	    return { name: name, rule: rule };
	  }
	
	  return null;
	};
	
	/**
	 * Get the field scope if specified using dot notation.
	 */
	ErrorBag.prototype._scope = function _scope (field) {
	  if (field.indexOf('.') > -1) {
	    var ref = field.split('.');
	      var scope = ref[0];
	      var name = ref.slice(1);
	
	    return { name: name.join('.'), scope: scope };
	  }
	
	  return null;
	};
	
	// 
	
	var LOCALE = 'en';
	
	var Dictionary = function Dictionary (dictionary) {
	  if ( dictionary === void 0 ) dictionary = {};
	
	  this.container = {};
	  this.merge(dictionary);
	};
	
	var prototypeAccessors$2 = { locale: {} };
	
	prototypeAccessors$2.locale.get = function () {
	  return LOCALE;
	};
	
	prototypeAccessors$2.locale.set = function (value) {
	  LOCALE = value || 'en';
	};
	
	Dictionary.prototype.hasLocale = function hasLocale (locale) {
	  return !!this.container[locale];
	};
	
	Dictionary.prototype.setDateFormat = function setDateFormat (locale, format) {
	  if (!this.container[locale]) {
	    this.container[locale] = {};
	  }
	
	  this.container[locale].dateFormat = format;
	};
	
	Dictionary.prototype.getDateFormat = function getDateFormat (locale) {
	  if (!this.container[locale] || !this.container[locale].dateFormat) {
	    return null;
	  }
	
	  return this.container[locale].dateFormat;
	};
	
	Dictionary.prototype.getMessage = function getMessage (locale, key, data) {
	  var message = null;
	  if (!this.hasMessage(locale, key)) {
	    message = this._getDefaultMessage(locale);
	  } else {
	    message = this.container[locale].messages[key];
	  }
	
	  return isCallable(message) ? message.apply(void 0, data) : message;
	};
	
	/**
	 * Gets a specific message for field. falls back to the rule message.
	 */
	Dictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
	  if (!this.hasLocale(locale)) {
	    return this.getMessage(locale, key, data);
	  }
	
	  var dict = this.container[locale].custom && this.container[locale].custom[field];
	  if (!dict || !dict[key]) {
	    return this.getMessage(locale, key, data);
	  }
	
	  var message = dict[key];
	  return isCallable(message) ? message.apply(void 0, data) : message;
	};
	
	Dictionary.prototype._getDefaultMessage = function _getDefaultMessage (locale) {
	  if (this.hasMessage(locale, '_default')) {
	    return this.container[locale].messages._default;
	  }
	
	  return this.container.en.messages._default;
	};
	
	Dictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
	    if ( fallback === void 0 ) fallback = '';
	
	  if (!this.hasAttribute(locale, key)) {
	    return fallback;
	  }
	
	  return this.container[locale].attributes[key];
	};
	
	Dictionary.prototype.hasMessage = function hasMessage (locale, key) {
	  return !! (
	    this.hasLocale(locale) &&
	          this.container[locale].messages &&
	          this.container[locale].messages[key]
	  );
	};
	
	Dictionary.prototype.hasAttribute = function hasAttribute (locale, key) {
	  return !! (
	    this.hasLocale(locale) &&
	          this.container[locale].attributes &&
	          this.container[locale].attributes[key]
	  );
	};
	
	Dictionary.prototype.merge = function merge$1$$1 (dictionary) {
	  merge$1(this.container, dictionary);
	};
	
	Dictionary.prototype.setMessage = function setMessage (locale, key, message) {
	  if (! this.hasLocale(locale)) {
	    this.container[locale] = {
	      messages: {},
	      attributes: {}
	    };
	  }
	
	  this.container[locale].messages[key] = message;
	};
	
	Dictionary.prototype.setAttribute = function setAttribute (locale, key, attribute) {
	  if (! this.hasLocale(locale)) {
	    this.container[locale] = {
	      messages: {},
	      attributes: {}
	    };
	  }
	
	  this.container[locale].attributes[key] = attribute;
	};
	
	Object.defineProperties( Dictionary.prototype, prototypeAccessors$2 );
	
	// 
	
	var normalizeValue = function (value) {
	  if (isObject(value)) {
	    return Object.keys(value).reduce(function (prev, key) {
	      prev[key] = normalizeValue(value[key]);
	
	      return prev;
	    }, {});
	  }
	
	  if (isCallable(value)) {
	    return value('{0}', ['{1}', '{2}', '{3}']);
	  }
	
	  return value;
	};
	
	var normalizeFormat = function (locale) {
	  // normalize messages
	  var messages = normalizeValue(locale.messages);
	  var custom = normalizeValue(locale.custom);
	
	  return {
	    messages: messages,
	    custom: custom,
	    attributes: locale.attributes,
	    dateFormat: locale.dateFormat
	  };
	};
	
	var I18nDictionary = function I18nDictionary (i18n, rootKey) {
	  this.i18n = i18n;
	  this.rootKey = rootKey;
	};
	
	var prototypeAccessors$3 = { locale: {} };
	
	prototypeAccessors$3.locale.get = function () {
	  return this.i18n.locale;
	};
	
	prototypeAccessors$3.locale.set = function (value) {
	  warn('Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead');
	};
	
	I18nDictionary.prototype.getDateFormat = function getDateFormat (locale) {
	  return this.i18n.getDateTimeFormat(locale || this.locale);
	};
	
	I18nDictionary.prototype.setDateFormat = function setDateFormat (locale, value) {
	  this.i18n.setDateTimeFormat(locale || this.locale, value);
	};
	
	I18nDictionary.prototype.getMessage = function getMessage (locale, key, data) {
	  var path = (this.rootKey) + ".messages." + key;
	  if (!this.i18n.te(path)) {
	    return this.i18n.t(((this.rootKey) + ".messages._default"), locale, data);
	  }
	
	  return this.i18n.t(path, locale, data);
	};
	
	I18nDictionary.prototype.getAttribute = function getAttribute (locale, key, fallback) {
	    if ( fallback === void 0 ) fallback = '';
	
	  var path = (this.rootKey) + ".attributes." + key;
	  if (!this.i18n.te(path)) {
	    return fallback;
	  }
	
	  return this.i18n.t(path, locale);
	};
	
	I18nDictionary.prototype.getFieldMessage = function getFieldMessage (locale, field, key, data) {
	  var path = (this.rootKey) + ".custom." + field + "." + key;
	  if (this.i18n.te(path)) {
	    return this.i18n.t(path);
	  }
	
	  return this.getMessage(locale, key, data);
	};
	
	I18nDictionary.prototype.merge = function merge$1$$1 (dictionary) {
	    var this$1 = this;
	
	  Object.keys(dictionary).forEach(function (localeKey) {
	    // i18n doesn't deep merge
	    // first clone the existing locale (avoid mutations to locale)
	    var clone = merge$1({}, getPath((localeKey + "." + (this$1.rootKey)), this$1.i18n.messages, {}));
	    // Merge cloned locale with new one
	    var locale = merge$1(clone, normalizeFormat(dictionary[localeKey]));
	    this$1.i18n.mergeLocaleMessage(localeKey, ( obj = {}, obj[this$1.rootKey] = locale, obj ));
	      var obj;
	    if (locale.dateFormat) {
	      this$1.i18n.setDateTimeFormat(localeKey, locale.dateFormat);
	    }
	  });
	};
	
	I18nDictionary.prototype.setMessage = function setMessage (locale, key, value) {
	  this.merge(( obj$1 = {}, obj$1[locale] = {
	      messages: ( obj = {}, obj[key] = value, obj )
	    }, obj$1 ));
	    var obj;
	    var obj$1;
	};
	
	I18nDictionary.prototype.setAttribute = function setAttribute (locale, key, value) {
	  this.merge(( obj$1 = {}, obj$1[locale] = {
	      attributes: ( obj = {}, obj[key] = value, obj )
	    }, obj$1 ));
	    var obj;
	    var obj$1;
	};
	
	Object.defineProperties( I18nDictionary.prototype, prototypeAccessors$3 );
	
	// 
	
	var defaultConfig = {
	  locale: 'en',
	  delay: 0,
	  errorBagName: 'errors',
	  dictionary: null,
	  strict: true,
	  fieldsBagName: 'fields',
	  classes: false,
	  classNames: null,
	  events: 'input|blur',
	  inject: true,
	  fastExit: true,
	  aria: true,
	  validity: false,
	  i18n: null,
	  i18nRootKey: 'validation'
	};
	
	var currentConfig = assign({}, defaultConfig);
	var dependencies = {
	  dictionary: new Dictionary({
	    en: {
	      messages: {},
	      attributes: {},
	      custom: {}
	    }
	  })
	};
	
	var Config = function Config () {};
	
	var staticAccessors$1 = { default: {},current: {} };
	
	staticAccessors$1.default.get = function () {
	  return defaultConfig;
	};
	
	staticAccessors$1.current.get = function () {
	  return currentConfig;
	};
	
	Config.dependency = function dependency (key) {
	  return dependencies[key];
	};
	
	/**
	 * Merges the config with a new one.
	 */
	Config.merge = function merge (config) {
	  currentConfig = assign({}, currentConfig, config);
	  if (currentConfig.i18n) {
	    Config.register('dictionary', new I18nDictionary(currentConfig.i18n, currentConfig.i18nRootKey));
	  }
	};
	
	/**
	 * Registers a dependency.
	 */
	Config.register = function register (key, value) {
	  dependencies[key] = value;
	};
	
	/**
	 * Resolves the working config from a Vue instance.
	 */
	Config.resolve = function resolve (context) {
	  var selfConfig = getPath('$options.$_veeValidate', context, {});
	
	  return assign({}, Config.current, selfConfig);
	};
	
	Object.defineProperties( Config, staticAccessors$1 );
	
	/**
	 * Generates the options required to construct a field.
	 */
	var Generator = function Generator () {};
	
	Generator.generate = function generate (el, binding, vnode) {
	  var model = Generator.resolveModel(binding, vnode);
	  var options = Config.resolve(vnode.context);
	
	  return {
	    name: Generator.resolveName(el, vnode),
	    el: el,
	    listen: !binding.modifiers.disable,
	    scope: Generator.resolveScope(el, binding, vnode),
	    vm: Generator.makeVM(vnode.context),
	    expression: binding.value,
	    component: vnode.child,
	    classes: options.classes,
	    classNames: options.classNames,
	    getter: Generator.resolveGetter(el, vnode, model),
	    events: Generator.resolveEvents(el, vnode) || options.events,
	    model: model,
	    delay: Generator.resolveDelay(el, vnode, options),
	    rules: Generator.resolveRules(el, binding),
	    initial: !!binding.modifiers.initial,
	    validity: options.validity,
	    aria: options.aria,
	    initialValue: Generator.resolveInitialValue(vnode)
	  };
	};
	
	Generator.getCtorConfig = function getCtorConfig (vnode) {
	  if (!vnode.child) { return null; }
	
	  var config = getPath('child.$options.$_veeValidate', vnode);
	
	  return config;
	};
	
	/**
	 * Resolves the rules defined on an element.
	 */
	Generator.resolveRules = function resolveRules (el, binding) {
	  if (!binding.value && (!binding || !binding.expression)) {
	    return getDataAttribute(el, 'rules');
	  }
	
	  if (binding.value && ~['string', 'object'].indexOf(typeof binding.value.rules)) {
	    return binding.value.rules;
	  }
	
	  return binding.value;
	};
	
	/**
	 * @param {*} vnode
	 */
	Generator.resolveInitialValue = function resolveInitialValue (vnode) {
	  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
	
	  return model && model.value;
	};
	
	/**
	 * Creates a non-circular partial VM instance from a Vue instance.
	 * @param {*} vm
	 */
	Generator.makeVM = function makeVM (vm) {
	  return {
	    get $el () {
	      return vm.$el;
	    },
	    get $refs () {
	      return vm.$refs;
	    },
	    $watch: vm.$watch ? vm.$watch.bind(vm) : function () {},
	    $validator: vm.$validator ? {
	      errors: vm.$validator.errors,
	      validate: vm.$validator.validate.bind(vm.$validator),
	      update: vm.$validator.update.bind(vm.$validator)
	    } : null
	  };
	};
	
	/**
	 * Resolves the delay value.
	 * @param {*} el
	 * @param {*} vnode
	 * @param {Object} options
	 */
	Generator.resolveDelay = function resolveDelay (el, vnode, options) {
	  var delay = getDataAttribute(el, 'delay');
	  var globalDelay = (options && 'delay' in options) ? options.delay : 0;
	
	  if (!delay && vnode.child && vnode.child.$attrs) {
	    delay = vnode.child.$attrs['data-vv-delay'];
	  }
	
	  if (!isObject(globalDelay)) {
	    return deepParseInt(delay || globalDelay);
	  }
	
	  globalDelay.input = delay || 0;
	
	  return deepParseInt(globalDelay);
	};
	
	/**
	 * Resolves the events to validate in response to.
	 * @param {*} el
	 * @param {*} vnode
	 */
	Generator.resolveEvents = function resolveEvents (el, vnode) {
	  var events = getDataAttribute(el, 'validate-on');
	
	  if (!events && vnode.child && vnode.child.$attrs) {
	    events = vnode.child.$attrs['data-vv-validate-on'];
	  }
	
	  if (!events && vnode.child) {
	    var config = Generator.getCtorConfig(vnode);
	    events = config && config.events;
	  }
	
	  return events;
	};
	
	/**
	 * Resolves the scope for the field.
	 * @param {*} el
	 * @param {*} binding
	 */
	Generator.resolveScope = function resolveScope (el, binding, vnode) {
	    if ( vnode === void 0 ) vnode = {};
	
	  var scope = null;
	  if (vnode.child && isNullOrUndefined(scope)) {
	    scope = vnode.child.$attrs && vnode.child.$attrs['data-vv-scope'];
	  }
	
	  return !isNullOrUndefined(scope) ? scope : getScope(el);
	};
	
	/**
	 * Checks if the node directives contains a v-model or a specified arg.
	 * Args take priority over models.
	 *
	 * @return {Object}
	 */
	Generator.resolveModel = function resolveModel (binding, vnode) {
	  if (binding.arg) {
	    return { expression: binding.arg };
	  }
	
	  var model = vnode.data.model || find(vnode.data.directives, function (d) { return d.name === 'model'; });
	  if (!model) {
	    return null;
	  }
	
	  // https://github.com/vuejs/vue/blob/dev/src/core/util/lang.js#L26
	  var watchable = !/[^\w.$]/.test(model.expression) && hasPath(model.expression, vnode.context);
	  var lazy = !!(model.modifiers && model.modifiers.lazy);
	  if (!watchable) {
	    return { expression: null, lazy: lazy };
	  }
	
	  return { expression: model.expression, lazy: lazy };
	};
	
	/**
	 * Resolves the field name to trigger validations.
	 * @return {String} The field name.
	 */
	Generator.resolveName = function resolveName (el, vnode) {
	  var name = getDataAttribute(el, 'name');
	
	  if (!name && !vnode.child) {
	    return el.name;
	  }
	
	  if (!name && vnode.child && vnode.child.$attrs) {
	    name = vnode.child.$attrs['data-vv-name'] || vnode.child.$attrs['name'];
	  }
	
	  if (!name && vnode.child) {
	    var config = Generator.getCtorConfig(vnode);
	    if (config && isCallable(config.name)) {
	      var boundGetter = config.name.bind(vnode.child);
	
	      return boundGetter();
	    }
	
	    return vnode.child.name;
	  }
	
	  return name;
	};
	
	/**
	 * Returns a value getter input type.
	 */
	Generator.resolveGetter = function resolveGetter (el, vnode, model) {
	  if (model && model.expression) {
	    return function () {
	      return getPath(model.expression, vnode.context);
	    };
	  }
	
	  if (vnode.child) {
	    var path = getDataAttribute(el, 'value-path') || (vnode.child.$attrs && vnode.child.$attrs['data-vv-value-path']);
	    if (path) {
	      return function () {
	        return getPath(path, vnode.child);
	      };
	    }
	
	    var config = Generator.getCtorConfig(vnode);
	    if (config && isCallable(config.value)) {
	      var boundGetter = config.value.bind(vnode.child);
	
	      return function () {
	        return boundGetter();
	      };
	    }
	
	    return function () {
	      return vnode.child.value;
	    };
	  }
	
	  switch (el.type) {
	  case 'checkbox': return function () {
	    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
	
	    els = toArray(els).filter(function (el) { return el.checked; });
	    if (!els.length) { return undefined; }
	
	    return els.map(function (checkbox) { return checkbox.value; });
	  };
	  case 'radio': return function () {
	    var els = document.querySelectorAll(("input[name=\"" + (el.name) + "\"]"));
	    var elm = find(els, function (el) { return el.checked; });
	
	    return elm && elm.value;
	  };
	  case 'file': return function (context) {
	    return toArray(el.files);
	  };
	  case 'select-multiple': return function () {
	    return toArray(el.options).filter(function (opt) { return opt.selected; }).map(function (opt) { return opt.value; });
	  };
	  default: return function () {
	    return el && el.value;
	  };
	  }
	};
	
	// 
	
	var DEFAULT_OPTIONS = {
	  targetOf: null,
	  initial: false,
	  scope: null,
	  listen: true,
	  name: null,
	  rules: {},
	  vm: null,
	  classes: false,
	  validity: true,
	  aria: true,
	  events: 'input|blur',
	  delay: 0,
	  classNames: {
	    touched: 'touched', // the control has been blurred
	    untouched: 'untouched', // the control hasn't been blurred
	    valid: 'valid', // model is valid
	    invalid: 'invalid', // model is invalid
	    pristine: 'pristine', // control has not been interacted with
	    dirty: 'dirty' // control has been interacted with
	  }
	};
	
	var Field = function Field (el, options) {
	  if ( options === void 0 ) options = {};
	
	  this.id = uniqId();
	  this.el = el;
	  this.updated = false;
	  this.dependencies = [];
	  this.watchers = [];
	  this.events = [];
	  this.delay = 0;
	  this.rules = {};
	  this._cacheId(options);
	  this.classNames = assign({}, DEFAULT_OPTIONS.classNames);
	  options = assign({}, DEFAULT_OPTIONS, options);
	  this._delay = !isNullOrUndefined(options.delay) ? options.delay : 0; // cache initial delay
	  this.validity = options.validity;
	  this.aria = options.aria;
	  this.flags = createFlags();
	  this.vm = options.vm;
	  this.component = options.component;
	  this.ctorConfig = this.component ? getPath('$options.$_veeValidate', this.component) : undefined;
	  this.update(options);
	  this.updated = false;
	};
	
	var prototypeAccessors$1 = { validator: {},isRequired: {},isDisabled: {},alias: {},value: {},rejectsFalse: {} };
	
	prototypeAccessors$1.validator.get = function () {
	  if (!this.vm || !this.vm.$validator) {
	    warn('No validator instance detected.');
	    return { validate: function () {} };
	  }
	
	  return this.vm.$validator;
	};
	
	prototypeAccessors$1.isRequired.get = function () {
	  return !!this.rules.required;
	};
	
	prototypeAccessors$1.isDisabled.get = function () {
	  return !!(this.component && this.component.disabled) || !!(this.el && this.el.disabled);
	};
	
	/**
	 * Gets the display name (user-friendly name).
	 */
	prototypeAccessors$1.alias.get = function () {
	  if (this._alias) {
	    return this._alias;
	  }
	
	  var alias = null;
	  if (this.el) {
	    alias = getDataAttribute(this.el, 'as');
	  }
	
	  if (!alias && this.component) {
	    return this.component.$attrs && this.component.$attrs['data-vv-as'];
	  }
	
	  return alias;
	};
	
	/**
	 * Gets the input value.
	 */
	
	prototypeAccessors$1.value.get = function () {
	  if (!isCallable(this.getter)) {
	    return undefined;
	  }
	
	  return this.getter();
	};
	
	/**
	 * If the field rejects false as a valid value for the required rule.
	 */
	
	prototypeAccessors$1.rejectsFalse.get = function () {
	  if (this.component && this.ctorConfig) {
	    return !!this.ctorConfig.rejectsFalse;
	  }
	
	  if (!this.el) {
	    return false;
	  }
	
	  return this.el.type === 'checkbox';
	};
	
	/**
	 * Determines if the instance matches the options provided.
	 */
	Field.prototype.matches = function matches (options) {
	  if (options.id) {
	    return this.id === options.id;
	  }
	
	  if (options.name === undefined && options.scope === undefined) {
	    return true;
	  }
	
	  if (options.scope === undefined) {
	    return this.name === options.name;
	  }
	
	  if (options.name === undefined) {
	    return this.scope === options.scope;
	  }
	
	  return options.name === this.name && options.scope === this.scope;
	};
	
	/**
	 * Caches the field id.
	 */
	Field.prototype._cacheId = function _cacheId (options) {
	  if (this.el && !options.targetOf) {
	    setDataAttribute(this.el, 'id', this.id); // cache field id if it is independent and has a root element.
	  }
	};
	
	/**
	 * Updates the field with changed data.
	 */
	Field.prototype.update = function update (options) {
	  this.targetOf = options.targetOf || null;
	  this.initial = options.initial || this.initial || false;
	
	  // update errors scope if the field scope was changed.
	  if (!isNullOrUndefined(options.scope) && options.scope !== this.scope && isCallable(this.validator.update)) {
	    this.validator.update(this.id, { scope: options.scope });
	  }
	  this.scope = !isNullOrUndefined(options.scope) ? options.scope
	    : !isNullOrUndefined(this.scope) ? this.scope : null;
	  this.name = (!isNullOrUndefined(options.name) ? String(options.name) : options.name) || this.name || null;
	  this.rules = options.rules !== undefined ? normalizeRules(options.rules) : this.rules;
	  this.model = options.model || this.model;
	  this.listen = options.listen !== undefined ? options.listen : this.listen;
	  this.classes = (options.classes || this.classes || false) && !this.component;
	  this.classNames = isObject(options.classNames) ? merge$1(this.classNames, options.classNames) : this.classNames;
	  this.getter = isCallable(options.getter) ? options.getter : this.getter;
	  this._alias = options.alias || this._alias;
	  this.events = (options.events) ? makeEventsArray(options.events) : this.events;
	  this.delay = (options.delay) ? makeDelayObject(this.events, options.delay, this._delay) : makeDelayObject(this.events, this.delay, this._delay);
	  this.updateDependencies();
	  this.addActionListeners();
	
	  // update required flag flags
	  if (options.rules !== undefined) {
	    this.flags.required = this.isRequired;
	  }
	
	  // validate if it was validated before and field was updated and there was a rules mutation.
	  if (this.flags.validated && options.rules !== undefined && this.updated) {
	    this.validator.validate(("#" + (this.id)));
	  }
	
	  this.updated = true;
	  this.addValueListeners();
	
	  // no need to continue.
	  if (!this.el) {
	    return;
	  }
	
	  this.updateClasses();
	  this.updateAriaAttrs();
	};
	
	/**
	 * Resets field flags and errors.
	 */
	Field.prototype.reset = function reset () {
	    var this$1 = this;
	
	  var defaults = createFlags();
	  Object.keys(this.flags).filter(function (flag) { return flag !== 'required'; }).forEach(function (flag) {
	    this$1.flags[flag] = defaults[flag];
	  });
	
	  this.addActionListeners();
	  this.updateClasses();
	  this.updateAriaAttrs();
	  this.updateCustomValidity();
	};
	
	/**
	 * Sets the flags and their negated counterparts, and updates the classes and re-adds action listeners.
	 */
	Field.prototype.setFlags = function setFlags (flags) {
	    var this$1 = this;
	
	  var negated = {
	    pristine: 'dirty',
	    dirty: 'pristine',
	    valid: 'invalid',
	    invalid: 'valid',
	    touched: 'untouched',
	    untouched: 'touched'
	  };
	
	  Object.keys(flags).forEach(function (flag) {
	    this$1.flags[flag] = flags[flag];
	    // if it has a negation and was not specified, set it as well.
	    if (negated[flag] && flags[negated[flag]] === undefined) {
	      this$1.flags[negated[flag]] = !flags[flag];
	    }
	  });
	
	  if (
	    flags.untouched !== undefined ||
	    flags.touched !== undefined ||
	    flags.dirty !== undefined ||
	    flags.pristine !== undefined
	  ) {
	    this.addActionListeners();
	  }
	  this.updateClasses();
	  this.updateAriaAttrs();
	  this.updateCustomValidity();
	};
	
	/**
	 * Determines if the field requires references to target fields.
	*/
	Field.prototype.updateDependencies = function updateDependencies () {
	    var this$1 = this;
	
	  // reset dependencies.
	  this.dependencies.forEach(function (d) { return d.field.destroy(); });
	  this.dependencies = [];
	
	  // we get the selectors for each field.
	  var fields = Object.keys(this.rules).reduce(function (prev, r) {
	    if (Validator.isTargetRule(r)) {
	      var selector = this$1.rules[r][0];
	      if (r === 'confirmed' && !selector) {
	        selector = (this$1.name) + "_confirmation";
	      }
	
	      prev.push({ selector: selector, name: r });
	    }
	
	    return prev;
	  }, []);
	
	  if (!fields.length || !this.vm || !this.vm.$el) { return; }
	
	  // must be contained within the same component, so we use the vm root element constrain our dom search.
	  fields.forEach(function (ref) {
	      var selector = ref.selector;
	      var name = ref.name;
	
	    var el = null;
	    // vue ref selector.
	    if (selector[0] === '$') {
	      var ref$1 = this$1.vm.$refs[selector.slice(1)];
	      el = Array.isArray(ref$1) ? ref$1[0] : ref$1;
	    } else {
	      try {
	        // try query selector
	        el = this$1.vm.$el.querySelector(selector);
	      } catch (err) {
	        el = null;
	      }
	    }
	
	    if (!el) {
	      try {
	        el = this$1.vm.$el.querySelector(("input[name=\"" + selector + "\"]"));
	      } catch (err) {
	        el = null;
	      }
	    }
	
	    if (!el) {
	      return;
	    }
	
	    var options = {
	      vm: this$1.vm,
	      classes: this$1.classes,
	      classNames: this$1.classNames,
	      delay: this$1.delay,
	      scope: this$1.scope,
	      events: this$1.events.join('|'),
	      initial: this$1.initial,
	      targetOf: this$1.id
	    };
	
	    // probably a component.
	    if (isCallable(el.$watch)) {
	      options.component = el;
	      options.el = el.$el;
	      options.getter = Generator.resolveGetter(el.$el, { child: el });
	    } else {
	      options.el = el;
	      options.getter = Generator.resolveGetter(el, {});
	    }
	
	    this$1.dependencies.push({ name: name, field: new Field(options.el, options) });
	  });
	};
	
	/**
	 * Removes listeners.
	 */
	Field.prototype.unwatch = function unwatch (tag) {
	    if ( tag === void 0 ) tag = null;
	
	  if (!tag) {
	    this.watchers.forEach(function (w) { return w.unwatch(); });
	    this.watchers = [];
	    return;
	  }
	
	  this.watchers.filter(function (w) { return tag.test(w.tag); }).forEach(function (w) { return w.unwatch(); });
	  this.watchers = this.watchers.filter(function (w) { return !tag.test(w.tag); });
	};
	
	/**
	 * Updates the element classes depending on each field flag status.
	 */
	Field.prototype.updateClasses = function updateClasses () {
	  if (!this.classes || this.isDisabled) { return; }
	
	  toggleClass(this.el, this.classNames.dirty, this.flags.dirty);
	  toggleClass(this.el, this.classNames.pristine, this.flags.pristine);
	  toggleClass(this.el, this.classNames.touched, this.flags.touched);
	  toggleClass(this.el, this.classNames.untouched, this.flags.untouched);
	  // make sure we don't set any classes if the state is undetermined.
	  if (!isNullOrUndefined(this.flags.valid) && this.flags.validated) {
	    toggleClass(this.el, this.classNames.valid, this.flags.valid);
	  }
	
	  if (!isNullOrUndefined(this.flags.invalid) && this.flags.validated) {
	    toggleClass(this.el, this.classNames.invalid, this.flags.invalid);
	  }
	};
	
	/**
	 * Adds the listeners required for automatic classes and some flags.
	 */
	Field.prototype.addActionListeners = function addActionListeners () {
	    var this$1 = this;
	
	  // remove previous listeners.
	  this.unwatch(/class/);
	
	  var onBlur = function () {
	    this$1.flags.touched = true;
	    this$1.flags.untouched = false;
	    if (this$1.classes) {
	      toggleClass(this$1.el, this$1.classNames.touched, true);
	      toggleClass(this$1.el, this$1.classNames.untouched, false);
	    }
	
	    // only needed once.
	    this$1.unwatch(/^class_blur$/);
	  };
	
	  var inputEvent = getInputEventName(this.el);
	  var onInput = function () {
	    this$1.flags.dirty = true;
	    this$1.flags.pristine = false;
	    if (this$1.classes) {
	      toggleClass(this$1.el, this$1.classNames.pristine, false);
	      toggleClass(this$1.el, this$1.classNames.dirty, true);
	    }
	
	    // only needed once.
	    this$1.unwatch(/^class_input$/);
	  };
	
	  if (this.component && isCallable(this.component.$once)) {
	    this.component.$once('input', onInput);
	    this.component.$once('blur', onBlur);
	    this.watchers.push({
	      tag: 'class_input',
	      unwatch: function () {
	        this$1.component.$off('input', onInput);
	      }
	    });
	    this.watchers.push({
	      tag: 'class_blur',
	      unwatch: function () {
	        this$1.component.$off('blur', onBlur);
	      }
	    });
	    return;
	  }
	
	  if (!this.el) { return; }
	
	  this.el.addEventListener(inputEvent, onInput);
	  // Checkboxes and radio buttons on Mac don't emit blur naturally, so we listen on click instead.
	  var blurEvent = ['radio', 'checkbox'].indexOf(this.el.type) === -1 ? 'blur' : 'click';
	  this.el.addEventListener(blurEvent, onBlur);
	  this.watchers.push({
	    tag: 'class_input',
	    unwatch: function () {
	      this$1.el.removeEventListener(inputEvent, onInput);
	    }
	  });
	
	  this.watchers.push({
	    tag: 'class_blur',
	    unwatch: function () {
	      this$1.el.removeEventListener(blurEvent, onBlur);
	    }
	  });
	};
	
	/**
	 * Adds the listeners required for validation.
	 */
	Field.prototype.addValueListeners = function addValueListeners () {
	    var this$1 = this;
	
	  this.unwatch(/^input_.+/);
	  if (!this.listen) { return; }
	
	  var fn = this.targetOf ? function () {
	    this$1.validator.validate(("#" + (this$1.targetOf)));
	  } : function () {
	      var args = [], len = arguments.length;
	      while ( len-- ) args[ len ] = arguments[ len ];
	
	    // if its a DOM event, resolve the value, otherwise use the first parameter as the value.
	    if (args.length === 0 || (isCallable(Event) && args[0] instanceof Event) || (args[0] && args[0].srcElement)) {
	      args[0] = this$1.value;
	    }
	
	    this$1.validator.validate(("#" + (this$1.id)), args[0]);
	  };
	
	  var inputEvent = this.model && this.model.lazy ? 'change' : getInputEventName(this.el);
	  // replace input event with suitable one.
	  var events = this.events.map(function (e) {
	    return e === 'input' ? inputEvent : e;
	  });
	
	  // if there is a watchable model and an on input validation is requested.
	  if (this.model && this.model.expression && events.indexOf(inputEvent) !== -1) {
	    var debouncedFn = debounce(fn, this.delay[inputEvent]);
	    var unwatch = this.vm.$watch(this.model.expression, function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	      this$1.flags.pending = true;
	      debouncedFn.apply(void 0, args);
	    });
	    this.watchers.push({
	      tag: 'input_model',
	      unwatch: unwatch
	    });
	    // filter out input event as it is already handled by the watcher API.
	    events = events.filter(function (e) { return e !== inputEvent; });
	  }
	
	  // Add events.
	  events.forEach(function (e) {
	    var debouncedFn = debounce(fn, this$1.delay[e]);
	    var validate = function () {
	        var args = [], len = arguments.length;
	        while ( len-- ) args[ len ] = arguments[ len ];
	
	      this$1.flags.pending = true;
	      debouncedFn.apply(void 0, args);
	    };
	
	    this$1._addComponentEventListener(e, validate);
	    this$1._addHTMLEventListener(e, validate);
	  });
	};
	
	Field.prototype._addComponentEventListener = function _addComponentEventListener (evt, validate) {
	    var this$1 = this;
	
	  if (!this.component) { return; }
	
	  this.component.$on(evt, validate);
	  this.watchers.push({
	    tag: 'input_vue',
	    unwatch: function () {
	      this$1.component.$off(evt, validate);
	    }
	  });
	};
	
	Field.prototype._addHTMLEventListener = function _addHTMLEventListener (evt, validate) {
	    var this$1 = this;
	
	  if (!this.el) { return; }
	
	  if (~['radio', 'checkbox'].indexOf(this.el.type)) {
	    var els = document.querySelectorAll(("input[name=\"" + (this.el.name) + "\"]"));
	    toArray(els).forEach(function (el) {
	      el.addEventListener(evt, validate);
	      this$1.watchers.push({
	        tag: 'input_native',
	        unwatch: function () {
	          el.removeEventListener(evt, validate);
	        }
	      });
	    });
	
	    return;
	  }
	
	  this.el.addEventListener(evt, validate);
	  this.watchers.push({
	    tag: 'input_native',
	    unwatch: function () {
	      this$1.el.removeEventListener(evt, validate);
	    }
	  });
	};
	
	/**
	 * Updates aria attributes on the element.
	 */
	Field.prototype.updateAriaAttrs = function updateAriaAttrs () {
	  if (!this.aria || !this.el || !isCallable(this.el.setAttribute)) { return; }
	
	  this.el.setAttribute('aria-required', this.isRequired ? 'true' : 'false');
	  this.el.setAttribute('aria-invalid', this.flags.invalid ? 'true' : 'false');
	};
	
	/**
	 * Updates the custom validity for the field.
	 */
	Field.prototype.updateCustomValidity = function updateCustomValidity () {
	  if (!this.validity || !this.el || !isCallable(this.el.setCustomValidity)) { return; }
	
	  this.el.setCustomValidity(this.flags.valid ? '' : (this.validator.errors.firstById(this.id) || ''));
	};
	
	/**
	 * Removes all listeners.
	 */
	Field.prototype.destroy = function destroy () {
	  this.unwatch();
	  this.dependencies.forEach(function (d) { return d.field.destroy(); });
	  this.dependencies = [];
	};
	
	Object.defineProperties( Field.prototype, prototypeAccessors$1 );
	
	// 
	
	var FieldBag = function FieldBag () {
	  this.items = [];
	};
	
	var prototypeAccessors$4 = { length: {} };
	
	FieldBag.prototype[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'] = function () {
	    var this$1 = this;
	
	  var index = 0;
	  return {
	    next: function () {
	      return { value: this$1.items[index++], done: index > this$1.items.length };
	    }
	  };
	};
	
	/**
	 * Gets the current items length.
	 */
	
	prototypeAccessors$4.length.get = function () {
	  return this.items.length;
	};
	
	/**
	 * Finds the first field that matches the provided matcher object.
	 */
	FieldBag.prototype.find = function find$1 (matcher) {
	  return find(this.items, function (item) { return item.matches(matcher); });
	};
	
	/**
	 * Filters the items down to the matched fields.
	 */
	FieldBag.prototype.filter = function filter (matcher) {
	  // multiple matchers to be tried.
	  if (Array.isArray(matcher)) {
	    return this.items.filter(function (item) { return matcher.some(function (m) { return item.matches(m); }); });
	  }
	
	  return this.items.filter(function (item) { return item.matches(matcher); });
	};
	
	/**
	 * Maps the field items using the mapping function.
	 */
	FieldBag.prototype.map = function map (mapper) {
	  return this.items.map(mapper);
	};
	
	/**
	 * Finds and removes the first field that matches the provided matcher object, returns the removed item.
	 */
	FieldBag.prototype.remove = function remove (matcher) {
	  var item = null;
	  if (matcher instanceof Field) {
	    item = matcher;
	  } else {
	    item = this.find(matcher);
	  }
	
	  if (!item) { return null; }
	
	  var index = this.items.indexOf(item);
	  this.items.splice(index, 1);
	
	  return item;
	};
	
	/**
	 * Adds a field item to the list.
	 */
	FieldBag.prototype.push = function push (item) {
	  if (! (item instanceof Field)) {
	    throw createError('FieldBag only accepts instances of Field that has an id defined.');
	  }
	
	  if (!item.id) {
	    throw createError('Field id must be defined.');
	  }
	
	  if (this.find({ id: item.id })) {
	    throw createError(("Field with id " + (item.id) + " is already added."));
	  }
	
	  this.items.push(item);
	};
	
	Object.defineProperties( FieldBag.prototype, prototypeAccessors$4 );
	
	// 
	
	var RULES = {};
	var STRICT_MODE = true;
	var TARGET_RULES = ['confirmed', 'after', 'before'];
	var ERRORS = []; // HOLD errors references to trigger regeneration.
	
	var Validator = function Validator (validations, options) {
	  var this$1 = this;
	  if ( options === void 0 ) options = { vm: null, fastExit: true };
	
	  this.strict = STRICT_MODE;
	  this.errors = new ErrorBag();
	
	  // We are running in SSR Mode. Do not keep a reference. It prevent garbage collection.
	  if (typeof window !== 'undefined') {
	    ERRORS.push(this.errors);
	  }
	  this.fields = new FieldBag();
	  this.flags = {};
	  this._createFields(validations);
	  this.paused = false;
	  this.fastExit = options.fastExit || false;
	  this.ownerId = options.vm && options.vm._uid;
	  // create it statically since we don't need constant access to the vm.
	  this.reset = options.vm && isCallable(options.vm.$nextTick) ? function (matcher) {
	    return new Promise(function (resolve) {
	      options.vm.$nextTick(function () {
	        options.vm.$nextTick(function () {
	          resolve(this$1._reset(matcher));
	        });
	      });
	    });
	  } : this._reset;
	};
	
	var prototypeAccessors = { dictionary: {},locale: {},rules: {} };
	var staticAccessors = { dictionary: {},locale: {},rules: {} };
	
	/**
	 * Getter for the dictionary.
	 */
	prototypeAccessors.dictionary.get = function () {
	  return Config.dependency('dictionary');
	};
	
	/**
	 * Static Getter for the dictionary.
	 */
	staticAccessors.dictionary.get = function () {
	  return Config.dependency('dictionary');
	};
	
	/**
	 * Getter for the current locale.
	 */
	prototypeAccessors.locale.get = function () {
	  return this.dictionary.locale;
	};
	
	/**
	 * Setter for the validator locale.
	 */
	prototypeAccessors.locale.set = function (value) {
	  Validator.locale = value;
	};
	
	/**
	* Static getter for the validator locale.
	*/
	staticAccessors.locale.get = function () {
	  return Validator.dictionary.locale;
	};
	
	/**
	 * Static setter for the validator locale.
	 */
	staticAccessors.locale.set = function (value) {
	  var hasChanged = value !== Validator.dictionary.locale;
	  Validator.dictionary.locale = value;
	  if (hasChanged) {
	    Validator.regenerate();
	  }
	};
	
	/**
	 * Getter for the rules object.
	 */
	prototypeAccessors.rules.get = function () {
	  return RULES;
	};
	
	/**
	 * Static Getter for the rules object.
	 */
	staticAccessors.rules.get = function () {
	  return RULES;
	};
	
	/**
	 * Static constructor.
	 */
	Validator.create = function create (validations, options) {
	  return new Validator(validations, options);
	};
	
	/**
	 * Adds a custom validator to the list of validation rules.
	 */
	Validator.extend = function extend (name, validator, options) {
	    if ( options === void 0 ) options = {};
	
	  Validator._guardExtend(name, validator);
	  Validator._merge(name, validator);
	  if (options && options.hasTarget) {
	    TARGET_RULES.push(name);
	  }
	};
	
	/**
	 * Regenerates error messages across all validators.
	 */
	Validator.regenerate = function regenerate () {
	  ERRORS.forEach(function (errorBag) { return errorBag.regenerate(); });
	};
	
	/**
	 * Removes a rule from the list of validators.
	 */
	Validator.remove = function remove (name) {
	  delete RULES[name];
	  var idx = TARGET_RULES.indexOf(name);
	  if (idx === -1) { return; }
	
	  TARGET_RULES.splice(idx, 1);
	};
	
	/**
	 * Checks if the given rule name is a rule that targets other fields.
	 */
	Validator.isTargetRule = function isTargetRule (name) {
	  return TARGET_RULES.indexOf(name) !== -1;
	};
	
	/**
	 * Sets the operating mode for all newly created validators.
	 * strictMode = true: Values without a rule are invalid and cause failure.
	 * strictMode = false: Values without a rule are valid and are skipped.
	 */
	Validator.setStrictMode = function setStrictMode (strictMode) {
	    if ( strictMode === void 0 ) strictMode = true;
	
	  STRICT_MODE = strictMode;
	};
	
	/**
	 * Adds and sets the current locale for the validator.
	 */
	Validator.prototype.localize = function localize (lang, dictionary) {
	  Validator.localize(lang, dictionary);
	};
	
	/**
	 * Adds and sets the current locale for the validator.
	 */
	Validator.localize = function localize (lang, dictionary) {
	  if (isObject(lang)) {
	    Validator.dictionary.merge(lang);
	    return;
	  }
	
	  // merge the dictionary.
	  if (dictionary) {
	    var locale = lang || dictionary.name;
	    dictionary = assign({}, dictionary);
	    Validator.dictionary.merge(( obj = {}, obj[locale] = dictionary, obj ));
	      var obj;
	  }
	
	  if (lang) {
	    // set the locale.
	    Validator.locale = lang;
	  }
	};
	
	/**
	 * Registers a field to be validated.
	 */
	Validator.prototype.attach = function attach (field) {
	  // deprecate: handle old signature.
	  if (arguments.length > 1) {
	    warn('This signature of the attach method has been deprecated, please consult the docs.');
	    field = assign({}, {
	      name: arguments[0],
	      rules: arguments[1]
	    }, arguments[2] || { vm: { $validator: this } });
	  }
	
	  // fixes initial value detection with v-model and select elements.
	  var value = field.initialValue;
	  if (!(field instanceof Field)) {
	    field = new Field(field.el || null, field);
	  }
	
	  this.fields.push(field);
	
	  // validate the field initially
	  if (field.initial) {
	    this.validate(("#" + (field.id)), value || field.value);
	  } else {
	    this._validate(field, value || field.value, true).then(function (result) {
	      field.flags.valid = result.valid;
	      field.flags.invalid = !result.valid;
	    });
	  }
	
	  this._addFlag(field, field.scope);
	  return field;
	};
	
	/**
	 * Sets the flags on a field.
	 */
	Validator.prototype.flag = function flag (name, flags) {
	  var field = this._resolveField(name);
	  if (! field || !flags) {
	    return;
	  }
	
	  field.setFlags(flags);
	};
	
	/**
	 * Removes a field from the validator.
	 */
	Validator.prototype.detach = function detach (name, scope) {
	  var field = name instanceof Field ? name : this._resolveField(name, scope);
	  if (!field) { return; }
	
	  field.destroy();
	  this.errors.remove(field.name, field.scope, field.id);
	  this.fields.remove(field);
	  var flags = this.flags;
	  if (!isNullOrUndefined(field.scope) && flags[("$" + (field.scope))]) {
	    delete flags[("$" + (field.scope))][field.name];
	  } else if (isNullOrUndefined(field.scope)) {
	    delete flags[field.name];
	  }
	
	  this.flags = assign({}, flags);
	};
	
	/**
	 * Adds a custom validator to the list of validation rules.
	 */
	Validator.prototype.extend = function extend (name, validator, options) {
	    if ( options === void 0 ) options = {};
	
	  Validator.extend(name, validator, options);
	};
	
	/**
	 * Updates a field, updating both errors and flags.
	 */
	Validator.prototype.update = function update (id, ref) {
	    var scope = ref.scope;
	
	  var field = this._resolveField(("#" + id));
	  if (!field) { return; }
	
	  // remove old scope.
	  this.errors.update(id, { scope: scope });
	  if (!isNullOrUndefined(field.scope) && this.flags[("$" + (field.scope))]) {
	    delete this.flags[("$" + (field.scope))][field.name];
	  } else if (isNullOrUndefined(field.scope)) {
	    delete this.flags[field.name];
	  }
	
	  this._addFlag(field, scope);
	};
	
	/**
	 * Removes a rule from the list of validators.
	 */
	Validator.prototype.remove = function remove (name) {
	  Validator.remove(name);
	};
	
	/**
	 * Validates a value against a registered field validations.
	 */
	Validator.prototype.validate = function validate (name, value, scope) {
	    var this$1 = this;
	    if ( scope === void 0 ) scope = null;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  // overload to validate all.
	  if (arguments.length === 0) {
	    return this.validateScopes();
	  }
	
	  // overload to validate scope-less fields.
	  if (arguments.length === 1 && arguments[0] === '*') {
	    return this.validateAll();
	  }
	
	  // overload to validate a scope.
	  if (arguments.length === 1 && typeof arguments[0] === 'string' && /^(.+)\.\*$/.test(arguments[0])) {
	    var matched = arguments[0].match(/^(.+)\.\*$/)[1];
	    return this.validateAll(matched);
	  }
	
	  var field = this._resolveField(name, scope);
	  if (!field) {
	    return this._handleFieldNotFound(name, scope);
	  }
	
	  field.flags.pending = true;
	  if (arguments.length === 1) {
	    value = field.value;
	  }
	
	  var silentRun = field.isDisabled;
	
	  return this._validate(field, value, silentRun).then(function (result) {
	    this$1.errors.remove(field.name, field.scope, field.id);
	    if (silentRun) {
	      return Promise.resolve(true);
	    } else if (result.errors) {
	      result.errors.forEach(function (e) { return this$1.errors.add(e); });
	    }
	
	    field.setFlags({
	      pending: false,
	      valid: result.valid,
	      validated: true
	    });
	
	    return result.valid;
	  });
	};
	
	/**
	 * Pauses the validator.
	 */
	Validator.prototype.pause = function pause () {
	  this.paused = true;
	
	  return this;
	};
	
	/**
	 * Resumes the validator.
	 */
	Validator.prototype.resume = function resume () {
	  this.paused = false;
	
	  return this;
	};
	
	/**
	 * Validates each value against the corresponding field validations.
	 */
	Validator.prototype.validateAll = function validateAll (values) {
	    var arguments$1 = arguments;
	    var this$1 = this;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  var matcher = null;
	  var providedValues = false;
	
	  if (typeof values === 'string') {
	    matcher = { scope: values };
	  } else if (isObject(values)) {
	    matcher = Object.keys(values).map(function (key) {
	      return { name: key, scope: arguments$1[1] || null };
	    });
	    providedValues = true;
	  } else if (arguments.length === 0) {
	    matcher = { scope: null }; // global scope.
	  } else if (Array.isArray(values)) {
	    matcher = values.map(function (key) {
	      return { name: key, scope: arguments$1[1] || null };
	    });
	  }
	
	  var promises = this.fields.filter(matcher).map(function (field) { return this$1.validate(
	    ("#" + (field.id)),
	    providedValues ? values[field.name] : field.value
	  ); });
	
	  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
	};
	
	/**
	 * Validates all scopes.
	 */
	Validator.prototype.validateScopes = function validateScopes () {
	    var this$1 = this;
	
	  if (this.paused) { return Promise.resolve(true); }
	
	  var promises = this.fields.map(function (field) { return this$1.validate(
	    ("#" + (field.id)),
	    field.value
	  ); });
	
	  return Promise.all(promises).then(function (results) { return results.every(function (t) { return t; }); });
	};
	
	/**
	 * Perform cleanup.
	 */
	Validator.prototype.destroy = function destroy () {
	  // Remove ErrorBag instance.
	  var idx = ERRORS.indexOf(this.errors);
	  if (idx === -1) { return; }
	
	  ERRORS.splice(idx, 1);
	};
	
	/**
	 * Creates the fields to be validated.
	 */
	Validator.prototype._createFields = function _createFields (validations) {
	    var this$1 = this;
	
	  if (!validations) { return; }
	
	  Object.keys(validations).forEach(function (field) {
	    var options = assign({}, { name: field, rules: validations[field] });
	    this$1.attach(options);
	  });
	};
	
	/**
	 * Date rules need the existence of a format, so date_format must be supplied.
	 */
	Validator.prototype._getDateFormat = function _getDateFormat (validations) {
	  var format = null;
	  if (validations.date_format && Array.isArray(validations.date_format)) {
	    format = validations.date_format[0];
	  }
	
	  return format || this.dictionary.getDateFormat(this.locale);
	};
	
	/**
	 * Checks if the passed rule is a date rule.
	 */
	Validator.prototype._isADateRule = function _isADateRule (rule) {
	  return !! ~['after', 'before', 'date_between', 'date_format'].indexOf(rule);
	};
	
	/**
	 * Formats an error message for field and a rule.
	 */
	Validator.prototype._formatErrorMessage = function _formatErrorMessage (field, rule, data, targetName) {
	    if ( data === void 0 ) data = {};
	    if ( targetName === void 0 ) targetName = null;
	
	  var name = this._getFieldDisplayName(field);
	  var params = this._getLocalizedParams(rule, targetName);
	
	  return this.dictionary.getFieldMessage(this.locale, field.name, rule.name, [name, params, data]);
	};
	
	/**
	 * Translates the parameters passed to the rule (mainly for target fields).
	 */
	Validator.prototype._getLocalizedParams = function _getLocalizedParams (rule, targetName) {
	    if ( targetName === void 0 ) targetName = null;
	
	  if (~TARGET_RULES.indexOf(rule.name) && rule.params && rule.params[0]) {
	    var localizedName = targetName || this.dictionary.getAttribute(this.locale, rule.params[0], rule.params[0]);
	    return [localizedName].concat(rule.params.slice(1));
	  }
	
	  return rule.params;
	};
	
	/**
	 * Resolves an appropriate display name, first checking 'data-as' or the registered 'prettyName'
	 */
	Validator.prototype._getFieldDisplayName = function _getFieldDisplayName (field) {
	  return field.alias || this.dictionary.getAttribute(this.locale, field.name, field.name);
	};
	
	/**
	 * Adds a field flags to the flags collection.
	 */
	Validator.prototype._addFlag = function _addFlag (field, scope) {
	    if ( scope === void 0 ) scope = null;
	
	  if (isNullOrUndefined(scope)) {
	    this.flags = assign({}, this.flags, ( obj = {}, obj[("" + (field.name))] = field.flags, obj ));
	      var obj;
	    return;
	  }
	
	  var scopeObj = assign({}, this.flags[("$" + scope)] || {}, ( obj$1 = {}, obj$1[("" + (field.name))] = field.flags, obj$1 ));
	    var obj$1;
	  this.flags = assign({}, this.flags, ( obj$2 = {}, obj$2[("$" + scope)] = scopeObj, obj$2 ));
	    var obj$2;
	};
	
	/**
	 * Resets fields that matches the matcher options or all fields if not specified.
	 */
	Validator.prototype._reset = function _reset (matcher) {
	    var this$1 = this;
	
	  return new Promise(function (resolve) {
	    if (matcher) {
	      this$1.fields.filter(matcher).forEach(function (field) {
	        field.reset(); // reset field flags.
	        this$1.errors.remove(field.name, field.scope, field.id);
	      });
	
	      return resolve();
	    }
	
	    this$1.fields.items.forEach(function (i) { return i.reset(); });
	    this$1.errors.clear();
	    resolve();
	  });
	};
	
	/**
	 * Tests a single input value against a rule.
	 */
	Validator.prototype._test = function _test (field, value, rule) {
	    var this$1 = this;
	
	  var validator = RULES[rule.name];
	  var params = Array.isArray(rule.params) ? toArray(rule.params) : [];
	  var targetName = null;
	  if (!validator || typeof validator !== 'function') {
	    throw createError(("No such validator '" + (rule.name) + "' exists."));
	  }
	
	  // has field dependencies.
	  if (TARGET_RULES.indexOf(rule.name) !== -1) {
	    var target = find(field.dependencies, function (d) { return d.name === rule.name; });
	    if (target) {
	      targetName = target.field.alias;
	      params = [target.field.value].concat(params.slice(1));
	    }
	  } else if (rule.name === 'required' && field.rejectsFalse) {
	    // invalidate false if no args were specified and the field rejects false by default.
	    params = params.length ? params : [true];
	  }
	
	  if (this._isADateRule(rule.name)) {
	    var dateFormat = this._getDateFormat(field.rules);
	    if (rule.name !== 'date_format') {
	      params.push(dateFormat);
	    }
	  }
	
	  var result = validator(value, params);
	
	  // If it is a promise.
	  if (isCallable(result.then)) {
	    return result.then(function (values) {
	      var allValid = true;
	      var data = {};
	      if (Array.isArray(values)) {
	        allValid = values.every(function (t) { return (isObject(t) ? t.valid : t); });
	      } else { // Is a single object/boolean.
	        allValid = isObject(values) ? values.valid : values;
	        data = values.data;
	      }
	
	      return {
	        valid: allValid,
	        error: allValid ? undefined : this$1._createFieldError(field, rule, data, targetName)
	      };
	    });
	  }
	
	  if (!isObject(result)) {
	    result = { valid: result, data: {} };
	  }
	
	  return {
	    valid: result.valid,
	    error: result.valid ? undefined : this._createFieldError(field, rule, result.data, targetName)
	  };
	};
	
	/**
	 * Merges a validator object into the RULES and Messages.
	 */
	Validator._merge = function _merge (name, validator) {
	  if (isCallable(validator)) {
	    RULES[name] = validator;
	    return;
	  }
	
	  RULES[name] = validator.validate;
	  if (validator.getMessage) {
	    Validator.dictionary.setMessage(this.locale, name, validator.getMessage);
	  }
	};
	
	/**
	 * Guards from extension violations.
	 */
	Validator._guardExtend = function _guardExtend (name, validator) {
	  if (isCallable(validator)) {
	    return;
	  }
	
	  if (!isCallable(validator.validate)) {
	    throw createError(
	      ("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.")
	    );
	  }
	
	  if (!isCallable(validator.getMessage) && typeof validator.getMessage !== 'string') {
	    throw createError(
	      ("Extension Error: The validator '" + name + "' object must have a 'getMessage' method or string.")
	    );
	  }
	};
	
	/**
	 * Creates a Field Error Object.
	 */
	Validator.prototype._createFieldError = function _createFieldError (field, rule, data, targetName) {
	    var this$1 = this;
	
	  return {
	    id: field.id,
	    field: field.name,
	    msg: this._formatErrorMessage(field, rule, data, targetName),
	    rule: rule.name,
	    scope: field.scope,
	    regenerate: function () {
	      return this$1._formatErrorMessage(field, rule, data, targetName);
	    }
	  };
	};
	
	/**
	 * Tries different strategies to find a field.
	 */
	Validator.prototype._resolveField = function _resolveField (name, scope) {
	  if (!isNullOrUndefined(scope)) {
	    return this.fields.find({ name: name, scope: scope });
	  }
	
	  if (name[0] === '#') {
	    return this.fields.find({ id: name.slice(1) });
	  }
	
	  if (name.indexOf('.') > -1) {
	    var ref = name.split('.');
	      var fieldScope = ref[0];
	      var fieldName = ref.slice(1);
	    var field = this.fields.find({ name: fieldName.join('.'), scope: fieldScope });
	    if (field) {
	      return field;
	    }
	  }
	
	  return this.fields.find({ name: name, scope: null });
	};
	
	/**
	 * Handles when a field is not found depending on the strict flag.
	 */
	Validator.prototype._handleFieldNotFound = function _handleFieldNotFound (name, scope) {
	  if (!this.strict) { return Promise.resolve(true); }
	
	  var fullName = isNullOrUndefined(scope) ? name : ("" + (!isNullOrUndefined(scope) ? scope + '.' : '') + name);
	  throw createError(
	    ("Validating a non-existent field: \"" + fullName + "\". Use \"attach()\" first.")
	  );
	};
	
	/**
	 * Starts the validation process.
	 */
	Validator.prototype._validate = function _validate (field, value, silent) {
	    var this$1 = this;
	    if ( silent === void 0 ) silent = false;
	
	  if (!field.isRequired && (isNullOrUndefined(value) || value === '')) {
	    return Promise.resolve({ valid: true });
	  }
	
	  var promises = [];
	  var errors = [];
	  var isExitEarly = false;
	  // use of '.some()' is to break iteration in middle by returning true
	  Object.keys(field.rules).some(function (rule) {
	    var result = this$1._test(field, value, { name: rule, params: field.rules[rule] });
	    if (isCallable(result.then)) {
	      promises.push(result);
	    } else if (this$1.fastExit && !result.valid) {
	      errors.push(result.error);
	      isExitEarly = true;
	    } else {
	      // promisify the result.
	      promises.push(new Promise(function (resolve) {
	        resolve(result);
	      }));
	    }
	
	    return isExitEarly;
	  });
	
	  if (isExitEarly) {
	    return Promise.resolve({
	      valid: false,
	      errors: errors
	    });
	  }
	
	  return Promise.all(promises).then(function (values) { return values.map(function (v) {
	    if (!v.valid) {
	      errors.push(v.error);
	    }
	
	    return v.valid;
	  }).every(function (t) { return t; }); }
	  ).then(function (result) {
	    return {
	      valid: result,
	      errors: errors
	    };
	  });
	};
	
	Object.defineProperties( Validator.prototype, prototypeAccessors );
	Object.defineProperties( Validator, staticAccessors );
	
	// 
	
	/**
	 * Checks if a parent validator instance was requested.
	 */
	var requestsValidator = function (injections) {
	  if (isObject(injections) && injections.$validator) {
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * Creates a validator instance.
	 */
	var createValidator = function (vm, options) { return new Validator(null, { vm: vm, fastExit: options.fastExit }); };
	
	var mixin = {
	  provide: function provide () {
	    if (this.$validator && !isBuiltInComponent(this.$vnode)) {
	      return {
	        $validator: this.$validator
	      };
	    }
	
	    return {};
	  },
	  beforeCreate: function beforeCreate () {
	    // if built in do nothing.
	    if (isBuiltInComponent(this.$vnode)) {
	      return;
	    }
	
	    // if its a root instance set the config if it exists.
	    if (!this.$parent) {
	      Config.merge(this.$options.$_veeValidate || {});
	    }
	
	    var options = Config.resolve(this);
	    var Vue = this.$options._base; // the vue constructor.
	    // TODO: Deprecate
	    /* istanbul ignore next */
	    if (this.$options.$validates) {
	      warn('The ctor $validates option has been deprecated please set the $_veeValidate.validator option to "new" instead');
	      this.$validator = createValidator(this, options);
	    }
	
	    // if its a root instance, inject anyways, or if it requested a new instance.
	    if (!this.$parent || (this.$options.$_veeValidate && /new/.test(this.$options.$_veeValidate.validator))) {
	      this.$validator = createValidator(this, options);
	    }
	
	    var requested = requestsValidator(this.$options.inject);
	
	    // if automatic injection is enabled and no instance was requested.
	    if (! this.$validator && options.inject && !requested) {
	      this.$validator = createValidator(this, options);
	    }
	
	    // don't inject errors or fieldBag as no validator was resolved.
	    if (! requested && ! this.$validator) {
	      return;
	    }
	
	    // There is a validator but it isn't injected, mark as reactive.
	    if (! requested && this.$validator) {
	      Vue.util.defineReactive(this.$validator, 'errors', this.$validator.errors);
	      Vue.util.defineReactive(this.$validator, 'flags', this.$validator.flags);
	    }
	
	    if (! this.$options.computed) {
	      this.$options.computed = {};
	    }
	
	    this.$options.computed[options.errorBagName || 'errors'] = function errorBagGetter () {
	      return this.$validator.errors;
	    };
	    this.$options.computed[options.fieldsBagName || 'fields'] = function fieldBagGetter () {
	      return this.$validator.flags;
	    };
	  },
	  beforeDestroy: function beforeDestroy () {
	    if (isBuiltInComponent(this.$vnode)) { return; }
	
	    // mark the validator paused to prevent delayed validation.
	    if (this.$validator && this.$validator.ownerId === this._uid) {
	      this.$validator.pause();
	      this.$validator.destroy();
	    }
	  }
	};
	
	// 
	
	/**
	 * Finds the requested field by id from the context object.
	 */
	var findField = function (el, context) {
	  if (!context || !context.$validator) {
	    return null;
	  }
	
	  return context.$validator.fields.find({ id: getDataAttribute(el, 'id') });
	};
	
	var directive = {
	  bind: function bind (el, binding, vnode) {
	    var validator = vnode.context.$validator;
	    if (! validator) {
	      warn("No validator instance is present on vm, did you forget to inject '$validator'?");
	      return;
	    }
	
	    var fieldOptions = Generator.generate(el, binding, vnode);
	    validator.attach(fieldOptions);
	  },
	  inserted: function (el, binding, vnode) {
	    var field = findField(el, vnode.context);
	    var scope = Generator.resolveScope(el, binding, vnode);
	
	    // skip if scope hasn't changed.
	    if (!field || scope === field.scope) { return; }
	
	    // only update scope.
	    field.update({ scope: scope });
	
	    // allows the field to re-evaluated once more in the update hook.
	    field.updated = false;
	  },
	  update: function (el, binding, vnode) {
	    var field = findField(el, vnode.context);
	
	    // make sure we don't do unneccasary work if no important change was done.
	    if (!field || (field.updated && isEqual$1(binding.value, binding.oldValue))) { return; }
	    var scope = Generator.resolveScope(el, binding, vnode);
	    var rules = Generator.resolveRules(el, binding);
	
	    field.update({
	      scope: scope,
	      rules: rules
	    });
	  },
	  unbind: function unbind (el, binding, ref) {
	    var context = ref.context;
	
	    var field = findField(el, context);
	    if (!field) { return; }
	
	    context.$validator.detach(field);
	  }
	};
	
	var Vue;
	
	function install (_Vue, options) {
	  if ( options === void 0 ) options = {};
	
	  if (Vue && _Vue === Vue) {
	    if (false) {
	      warn('already installed, Vue.use(VeeValidate) should only be called once.');
	    }
	    return;
	  }
	
	  Vue = _Vue;
	  Config.merge(options);
	  var ref = Config.current;
	  var dictionary = ref.dictionary;
	  var i18n = ref.i18n;
	
	  if (dictionary) {
	    Validator.localize(dictionary); // merge the dictionary.
	  }
	
	  // try to watch locale changes.
	  if (i18n && i18n._vm && isCallable(i18n._vm.$watch)) {
	    i18n._vm.$watch('locale', function () {
	      Validator.regenerate();
	    });
	  }
	
	  if (!i18n && options.locale) {
	    Validator.localize(options.locale); // set the locale
	  }
	
	  Validator.setStrictMode(Config.current.strict);
	
	  Vue.mixin(mixin);
	  Vue.directive('validate', directive);
	}
	
	// 
	
	function use (plugin, options) {
	  if ( options === void 0 ) options = {};
	
	  if (!isCallable(plugin)) {
	    return warn('The plugin must be a callable function');
	  }
	
	  plugin({ Validator: Validator, ErrorBag: ErrorBag, Rules: Validator.rules }, options);
	}
	
	// 
	
	var normalize = function (fields) {
	  if (Array.isArray(fields)) {
	    return fields.reduce(function (prev, curr) {
	      if (~curr.indexOf('.')) {
	        prev[curr.split('.')[1]] = curr;
	      } else {
	        prev[curr] = curr;
	      }
	
	      return prev;
	    }, {});
	  }
	
	  return fields;
	};
	
	// Combines two flags using either AND or OR depending on the flag type.
	var combine = function (lhs, rhs) {
	  var mapper = {
	    pristine: function (lhs, rhs) { return lhs && rhs; },
	    dirty: function (lhs, rhs) { return lhs || rhs; },
	    touched: function (lhs, rhs) { return lhs || rhs; },
	    untouched: function (lhs, rhs) { return lhs && rhs; },
	    valid: function (lhs, rhs) { return lhs && rhs; },
	    invalid: function (lhs, rhs) { return lhs || rhs; },
	    pending: function (lhs, rhs) { return lhs || rhs; },
	    required: function (lhs, rhs) { return lhs || rhs; },
	    validated: function (lhs, rhs) { return lhs && rhs; }
	  };
	
	  return Object.keys(mapper).reduce(function (flags, flag) {
	    flags[flag] = mapper[flag](lhs[flag], rhs[flag]);
	
	    return flags;
	  }, {});
	};
	
	var mapScope = function (scope, deep) {
	  if ( deep === void 0 ) deep = true;
	
	  return Object.keys(scope).reduce(function (flags, field) {
	    if (!flags) {
	      flags = assign({}, scope[field]);
	      return flags;
	    }
	
	    // scope.
	    var isScope = field.indexOf('$') === 0;
	    if (deep && isScope) {
	      return combine(mapScope(scope[field]), flags);
	    } else if (!deep && isScope) {
	      return flags;
	    }
	
	    flags = combine(flags, scope[field]);
	
	    return flags;
	  }, null);
	};
	
	/**
	 * Maps fields to computed functions.
	 */
	var mapFields = function (fields) {
	  if (!fields) {
	    return function () {
	      return mapScope(this.$validator.flags);
	    };
	  }
	
	  var normalized = normalize(fields);
	  return Object.keys(normalized).reduce(function (prev, curr) {
	    var field = normalized[curr];
	    prev[curr] = function mappedField () {
	      // if field exists
	      if (this.$validator.flags[field]) {
	        return this.$validator.flags[field];
	      }
	
	      // scopeless fields were selected.
	      if (normalized[curr] === '*') {
	        return mapScope(this.$validator.flags, false);
	      }
	
	      // if it has a scope defined
	      var index = field.indexOf('.');
	      if (index <= 0) {
	        return {};
	      }
	
	      var ref = field.split('.');
	      var scope = ref[0];
	      var name = ref.slice(1);
	
	      scope = this.$validator.flags[("$" + scope)];
	      name = name.join('.');
	
	      // an entire scope was selected: scope.*
	      if (name === '*' && scope) {
	        return mapScope(scope);
	      }
	
	      if (scope && scope[name]) {
	        return scope[name];
	      }
	
	      return {};
	    };
	
	    return prev;
	  }, {});
	};
	
	var ErrorComponent = {
	  name: 'vv-error',
	  inject: ['$validator'],
	  functional: true,
	  props: {
	    for: {
	      type: String,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'span'
	    }
	  },
	  render: function render (createElement, ref) {
	    var props = ref.props;
	    var injections = ref.injections;
	
	    return createElement(props.tag, injections.$validator.errors.first(props.for));
	  }
	};
	
	var minimal$1 = {
	  install: install,
	  use: use,
	  directive: directive,
	  mixin: mixin,
	  mapFields: mapFields,
	  Validator: Validator,
	  ErrorBag: ErrorBag,
	  ErrorComponent: ErrorComponent,
	  version: '2.0.6'
	};
	
	// rules plugin definition.
	var rulesPlugin = function (ref) {
	  var Validator = ref.Validator;
	
	  Object.keys(Rules).forEach(function (rule) {
	    Validator.extend(rule, Rules[rule]);
	  });
	
	  // Merge the english messages.
	  Validator.localize('en', locale$1);
	};
	
	// install the rules via the plugin API.
	minimal$1.use(rulesPlugin);
	
	minimal$1.Rules = Rules;
	
	return minimal$1;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "01f9":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var LIBRARY = __webpack_require__("2d00");
	var $export = __webpack_require__("5ca1");
	var redefine = __webpack_require__("2aba");
	var hide = __webpack_require__("32e9");
	var Iterators = __webpack_require__("84f2");
	var $iterCreate = __webpack_require__("41a0");
	var setToStringTag = __webpack_require__("7f20");
	var getPrototypeOf = __webpack_require__("38fd");
	var ITERATOR = __webpack_require__("2b4c")('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};
	
	
	/***/ }),
	
	/***/ "0a49":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__("9b43");
	var IObject = __webpack_require__("626a");
	var toObject = __webpack_require__("4bf8");
	var toLength = __webpack_require__("9def");
	var asc = __webpack_require__("cd1c");
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};
	
	
	/***/ }),
	
	/***/ "0d58":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__("ce10");
	var enumBugKeys = __webpack_require__("e11e");
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};
	
	
	/***/ }),
	
	/***/ "1169":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__("2d95");
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};
	
	
	/***/ }),
	
	/***/ "1495":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc");
	var anObject = __webpack_require__("cb7c");
	var getKeys = __webpack_require__("0d58");
	
	module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "230e":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	var document = __webpack_require__("7726").document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};
	
	
	/***/ }),
	
	/***/ "2621":
	/***/ (function(module, exports) {
	
	exports.f = Object.getOwnPropertySymbols;
	
	
	/***/ }),
	
	/***/ "2aba":
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__("7726");
	var hide = __webpack_require__("32e9");
	var has = __webpack_require__("69a8");
	var SRC = __webpack_require__("ca5a")('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__("8378").inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});
	
	
	/***/ }),
	
	/***/ "2aeb":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__("cb7c");
	var dPs = __webpack_require__("1495");
	var enumBugKeys = __webpack_require__("e11e");
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__("230e")('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__("fab2").appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};
	
	
	/***/ }),
	
	/***/ "2b4c":
	/***/ (function(module, exports, __webpack_require__) {
	
	var store = __webpack_require__("5537")('wks');
	var uid = __webpack_require__("ca5a");
	var Symbol = __webpack_require__("7726").Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;
	
	
	/***/ }),
	
	/***/ "2d00":
	/***/ (function(module, exports) {
	
	module.exports = false;
	
	
	/***/ }),
	
	/***/ "2d95":
	/***/ (function(module, exports) {
	
	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};
	
	
	/***/ }),
	
	/***/ "2f21":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var fails = __webpack_require__("79e5");
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};
	
	
	/***/ }),
	
	/***/ "2fdb":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	
	var $export = __webpack_require__("5ca1");
	var context = __webpack_require__("d2c8");
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	
	/***/ }),
	
	/***/ "32e9":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc");
	var createDesc = __webpack_require__("4630");
	module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};
	
	
	/***/ }),
	
	/***/ "38fd":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__("69a8");
	var toObject = __webpack_require__("4bf8");
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};
	
	
	/***/ }),
	
	/***/ "41a0":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var create = __webpack_require__("2aeb");
	var descriptor = __webpack_require__("4630");
	var setToStringTag = __webpack_require__("7f20");
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};
	
	
	/***/ }),
	
	/***/ "456d":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__("4bf8");
	var $keys = __webpack_require__("0d58");
	
	__webpack_require__("5eda")('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});
	
	
	/***/ }),
	
	/***/ "4588":
	/***/ (function(module, exports) {
	
	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};
	
	
	/***/ }),
	
	/***/ "4630":
	/***/ (function(module, exports) {
	
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};
	
	
	/***/ }),
	
	/***/ "4bf8":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__("be13");
	module.exports = function (it) {
	  return Object(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "4fb4":
	/***/ (function(module) {
	
	module.exports = [{"countryName":"Afghanistan","countryShortCode":"AF","regions":[{"name":"Badakhshan","shortCode":"BDS"},{"name":"Badghis","shortCode":"BDG"},{"name":"Baghlan","shortCode":"BGL"},{"name":"Balkh","shortCode":"BAL"},{"name":"Bamyan","shortCode":"BAM"},{"name":"Daykundi","shortCode":"DAY"},{"name":"Farah","shortCode":"FRA"},{"name":"Faryab","shortCode":"FYB"},{"name":"Ghazni","shortCode":"GHA"},{"name":"Ghor","shortCode":"GHO"},{"name":"Helmand","shortCode":"HEL"},{"name":"Herat","shortCode":"HER"},{"name":"Jowzjan","shortCode":"JOW"},{"name":"Kabul","shortCode":"KAB"},{"name":"Kandahar","shortCode":"KAN"},{"name":"Kapisa","shortCode":"KAP"},{"name":"Khost","shortCode":"KHO"},{"name":"Kunar","shortCode":"KNR"},{"name":"Kunduz","shortCode":"KDZ"},{"name":"Laghman","shortCode":"LAG"},{"name":"Logar","shortCode":"LOW"},{"name":"Maidan Wardak","shortCode":"WAR"},{"name":"Nangarhar","shortCode":"NAN"},{"name":"Nimruz","shortCode":"NIM"},{"name":"Nuristan","shortCode":"NUR"},{"name":"Paktia","shortCode":"PIA"},{"name":"Paktika","shortCode":"PKA"},{"name":"Panjshir","shortCode":"PAN"},{"name":"Parwan","shortCode":"PAR"},{"name":"Samangan","shortCode":"SAM"},{"name":"Sar-e Pol","shortCode":"SAR"},{"name":"Takhar","shortCode":"TAK"},{"name":"Urozgan","shortCode":"ORU"},{"name":"Zabul","shortCode":"ZAB"}]},{"countryName":"Åland Islands","countryShortCode":"AX","regions":[{"name":"Brändö","shortCode":"BR"},{"name":"Eckerö","shortCode":"EC"},{"name":"Finström","shortCode":"FN"},{"name":"Föglö","shortCode":"FG"},{"name":"Geta","shortCode":"GT"},{"name":"Hammarland","shortCode":"HM"},{"name":"Jomala","shortCode":"JM"},{"name":"Kumlinge","shortCode":"KM"},{"name":"Kökar","shortCode":"KK"},{"name":"Lemland","shortCode":"LE"},{"name":"Lumparland","shortCode":"LU"},{"name":"Mariehamn","shortCode":"MH"},{"name":"Saltvik","shortCode":"SV"},{"name":"Sottunga","shortCode":"ST"},{"name":"Sund","shortCode":"SD"},{"name":"Vårdö","shortCode":"VR"}]},{"countryName":"Albania","countryShortCode":"AL","regions":[{"name":"Berat","shortCode":"01"},{"name":"Dibër","shortCode":"09"},{"name":"Durrës","shortCode":"02"},{"name":"Elbasan","shortCode":"03"},{"name":"Fier","shortCode":"04"},{"name":"Gjirokastër","shortCode":"05"},{"name":"Korçë","shortCode":"06"},{"name":"Kukës","shortCode":"07"},{"name":"Lezhë","shortCode":"08"},{"name":"Shkodër","shortCode":"10"},{"name":"Tirana","shortCode":"11"},{"name":"Vlorë","shortCode":"12"}]},{"countryName":"Algeria","countryShortCode":"DZ","regions":[{"name":"Adrar","shortCode":"01"},{"name":"Aïn Defla","shortCode":"44"},{"name":"Aïn Témouchent","shortCode":"46"},{"name":"Algiers","shortCode":"16"},{"name":"Annaba","shortCode":"23"},{"name":"Batna","shortCode":"05"},{"name":"Béchar","shortCode":"08"},{"name":"Béjaïa","shortCode":"06"},{"name":"Biskra","shortCode":"07"},{"name":"Blida","shortCode":"09"},{"name":"Bordj Bou Arréridj","shortCode":"34"},{"name":"Bouïra","shortCode":"10"},{"name":"Boumerdès","shortCode":"35"},{"name":"Chlef","shortCode":"02"},{"name":"Constantine","shortCode":"25"},{"name":"Djelfa","shortCode":"17"},{"name":"El Bayadh","shortCode":"32"},{"name":"El Oued","shortCode":"39"},{"name":"El Tarf","shortCode":"36"},{"name":"Ghardaïa","shortCode":"47"},{"name":"Guelma","shortCode":"24"},{"name":"Illizi","shortCode":"33"},{"name":"Jijel","shortCode":"18"},{"name":"Khenchela","shortCode":"40"},{"name":"Laghouat","shortCode":"03"},{"name":"Mascara","shortCode":"29"},{"name":"Médéa","shortCode":"26"},{"name":"Mila","shortCode":"43"},{"name":"Mostaganem","shortCode":"27"},{"name":"Msila","shortCode":"28"},{"name":"Naâma","shortCode":"45"},{"name":"Oran","shortCode":"31"},{"name":"Ouargla","shortCode":"30"},{"name":"Oum el Bouaghi","shortCode":"04"},{"name":"Relizane","shortCode":"48"},{"name":"Saïda","shortCode":"20"},{"name":"Sétif","shortCode":"19"},{"name":"Sidi Bel Abbès","shortCode":"22"},{"name":"Skikda","shortCode":"21"},{"name":"Souk Ahras","shortCode":"41"},{"name":"Tamanghasset","shortCode":"11"},{"name":"Tébessa","shortCode":"12"},{"name":"Tiaret","shortCode":"14"},{"name":"Tindouf","shortCode":"37"},{"name":"Tipaza","shortCode":"42"},{"name":"Tissemsilt","shortCode":"38"},{"name":"Tizi Ouzou","shortCode":"15"},{"name":"Tlemcen","shortCode":"13"}]},{"countryName":"American Samoa","countryShortCode":"AS","regions":[{"name":"Tutuila","shortCode":"01"},{"name":"Aunu'u","shortCode":"02"},{"name":"Ta'ū","shortCode":"03"},{"name":"Ofu‑Olosega","shortCode":"04"},{"name":"Rose Atoll","shortCode":"21"},{"name":"Swains Island","shortCode":"22"}]},{"countryName":"Andorra","countryShortCode":"AD","regions":[{"name":"Andorra la Vella","shortCode":"07"},{"name":"Canillo","shortCode":"02"},{"name":"Encamp","shortCode":"03"},{"name":"Escaldes-Engordany","shortCode":"08"},{"name":"La Massana","shortCode":"04"},{"name":"Ordino","shortCode":"05"},{"name":"Sant Julià de Lòria","shortCode":"06"}]},{"countryName":"Angola","countryShortCode":"AO","regions":[{"name":"Bengo","shortCode":"BGO"},{"name":"Benguela","shortCode":"BGU"},{"name":"Bié","shortCode":"BIE"},{"name":"Cabinda","shortCode":"CAB"},{"name":"Cuando Cubango","shortCode":"CCU"},{"name":"Cuanza Norte","shortCode":"CNO"},{"name":"Cuanza Sul","shortCode":"CUS"},{"name":"Cunene","shortCode":"CNN"},{"name":"Huambo","shortCode":"HUA"},{"name":"Huíla","shortCode":"HUI"},{"name":"Luanda","shortCode":"LUA"},{"name":"Lunda Norte","shortCode":"LNO"},{"name":"Lunda Sul","shortCode":"LSU"},{"name":"Malanje","shortCode":"MAL"},{"name":"Moxico","shortCode":"MOX"},{"name":"Namibe","shortCode":"NAM"},{"name":"Uíge","shortCode":"UIG"},{"name":"Zaire","shortCode":"ZAI"}]},{"countryName":"Anguilla","countryShortCode":"AI","regions":[{"name":"Anguilla","shortCode":"01"},{"name":"Anguillita Island","shortCode":"02"},{"name":"Blowing Rock","shortCode":"03"},{"name":"Cove Cay","shortCode":"04"},{"name":"Crocus Cay","shortCode":"05"},{"name":"Deadman's Cay","shortCode":"06"},{"name":"Dog Island","shortCode":"07"},{"name":"East Cay","shortCode":"08"},{"name":"Little Island","shortCode":"09"},{"name":"Little Scrub Island","shortCode":"10"},{"name":"Mid Cay","shortCode":"11"},{"name":"North Cay","shortCode":"12"},{"name":"Prickly Pear Cays","shortCode":"13"},{"name":"Rabbit Island","shortCode":"14"},{"name":"Sandy Island/Sand Island","shortCode":"15"},{"name":"Scilly Cay","shortCode":"16"},{"name":"Scrub Island","shortCode":"17"},{"name":"Seal Island","shortCode":"18"},{"name":"Sombrero/Hat Island","shortCode":"19"},{"name":"South Cay","shortCode":"20"},{"name":"South Wager Island","shortCode":"21"},{"name":"West Cay","shortCode":"22"}]},{"countryName":"Antarctica","countryShortCode":"AQ","regions":[{"name":"Antarctica","shortCode":"AQ"}]},{"countryName":"Antigua and Barbuda","countryShortCode":"AG","regions":[{"name":"Antigua Island","shortCode":"01"},{"name":"Barbuda Island","shortCode":"02"},{"name":"Bird Island","shortCode":"04"},{"name":"Bishop Island","shortCode":"05"},{"name":"Blake Island","shortCode":"06"},{"name":"Crump Island","shortCode":"09"},{"name":"Dulcina Island","shortCode":"10"},{"name":"Exchange Island","shortCode":"11"},{"name":"Five Islands","shortCode":"12"},{"name":"Great Bird Island","shortCode":"13"},{"name":"Green Island","shortCode":"14"},{"name":"Guiana Island","shortCode":"15"},{"name":"Hawes Island","shortCode":"17"},{"name":"Hells Gate Island","shortCode":"16"},{"name":"Henry Island","shortCode":"18"},{"name":"Johnson Island","shortCode":"19"},{"name":"Kid Island","shortCode":"20"},{"name":"Lobster Island","shortCode":"22"},{"name":"Maiden Island","shortCode":"24"},{"name":"Moor Island","shortCode":"25"},{"name":"Nanny Island","shortCode":"26"},{"name":"Pelican Island","shortCode":"27"},{"name":"Prickly Pear Island","shortCode":"28"},{"name":"Rabbit Island","shortCode":"29"},{"name":"Red Head Island","shortCode":"31"},{"name":"Redonda Island","shortCode":"03"},{"name":"Sandy Island","shortCode":"32"},{"name":"Smith Island","shortCode":"33"},{"name":"The Sisters","shortCode":"34"},{"name":"Vernon Island","shortCode":"35"},{"name":"Wicked Will Island","shortCode":"36"},{"name":"York Island","shortCode":"37"}]},{"countryName":"Argentina","countryShortCode":"AR","regions":[{"name":"Buenos Aires","shortCode":"B"},{"name":"Capital Federal","shortCode":"C"},{"name":"Catamarca","shortCode":"K"},{"name":"Chaco","shortCode":"H"},{"name":"Chubut","shortCode":"U"},{"name":"Córdoba","shortCode":"X"},{"name":"Corrientes","shortCode":"W"},{"name":"Entre Ríos","shortCode":"E"},{"name":"Formosa","shortCode":"P"},{"name":"Jujuy","shortCode":"Y"},{"name":"La Pampa","shortCode":"L"},{"name":"La Rioja","shortCode":"F"},{"name":"Mendoza","shortCode":"M"},{"name":"Misiones","shortCode":"N"},{"name":"Neuquén","shortCode":"Q"},{"name":"Río Negro","shortCode":"R"},{"name":"Salta","shortCode":"A"},{"name":"San Juan","shortCode":"J"},{"name":"San Luis","shortCode":"D"},{"name":"Santa Cruz","shortCode":"Z"},{"name":"Santa Fe","shortCode":"S"},{"name":"Santiago del Estero","shortCode":"G"},{"name":"Tierra del Fuego","shortCode":"V"},{"name":"Tucumán","shortCode":"T"}]},{"countryName":"Armenia","countryShortCode":"AM","regions":[{"name":"Aragatsotn","shortCode":"AG"},{"name":"Ararat","shortCode":"AR"},{"name":"Armavir","shortCode":"AV"},{"name":"Gegharkunik","shortCode":"GR"},{"name":"Kotayk","shortCode":"KT"},{"name":"Lori","shortCode":"LO"},{"name":"Shirak","shortCode":"SH"},{"name":"Syunik","shortCode":"SU"},{"name":"Tavush","shortCode":"TV"},{"name":"Vayots Dzor","shortCode":"VD"},{"name":"Yerevan","shortCode":"ER"}]},{"countryName":"Aruba","countryShortCode":"AW","regions":[{"name":"Aruba","shortCode":"AW"}]},{"countryName":"Australia","countryShortCode":"AU","regions":[{"name":"Australian Capital Territory","shortCode":"ACT"},{"name":"New South Wales","shortCode":"NSW"},{"name":"Northern Territory","shortCode":"NT"},{"name":"Queensland","shortCode":"QLD"},{"name":"South Australia","shortCode":"SA"},{"name":"Tasmania","shortCode":"TAS"},{"name":"Victoria","shortCode":"VIC"},{"name":"Western Australia","shortCode":"WA"}]},{"countryName":"Austria","countryShortCode":"AT","regions":[{"name":"Burgenland","shortCode":"1"},{"name":"Kärnten","shortCode":"2"},{"name":"Niederösterreich","shortCode":"3"},{"name":"Oberösterreich","shortCode":"4"},{"name":"Salzburg","shortCode":"5"},{"name":"Steiermark","shortCode":"6"},{"name":"Tirol","shortCode":"7"},{"name":"Vorarlberg","shortCode":"8"},{"name":"Wien","shortCode":"9"}]},{"countryName":"Azerbaijan","countryShortCode":"AZ","regions":[{"name":"Abşeron","shortCode":"ABS"},{"name":"Ağcabədi","shortCode":"AGC"},{"name":"Ağdam","shortCode":"AGM"},{"name":"Ağdaş","shortCode":"AGS"},{"name":"Ağstafa","shortCode":"AGA"},{"name":"Ağsu","shortCode":"AGU"},{"name":"Astara","shortCode":"AST"},{"name":"Babək","shortCode":"BAB"},{"name":"Balakən","shortCode":"BAL"},{"name":"Bərdə","shortCode":"BAR"},{"name":"Beyləqan","shortCode":"BEY"},{"name":"Biləsuvar","shortCode":"BIL"},{"name":"Cəbrayıl","shortCode":"CAB"},{"name":"Cəlilabad","shortCode":"CAL"},{"name":"Culfa","shortCode":"CUL"},{"name":"Daşkəsən","shortCode":"DAS"},{"name":"Füzuli","shortCode":"FUZ"},{"name":"Gədəbəy","shortCode":"GAD"},{"name":"Goranboy","shortCode":"GOR"},{"name":"Göyçay","shortCode":"GOY"},{"name":"Göygöl","shortCode":"GYG"},{"name":"Hacıqabul","shortCode":"HAC"},{"name":"İmişli","shortCode":"IMI"},{"name":"İsmayıllı","shortCode":"ISM"},{"name":"Kəlbəcər","shortCode":"KAL"},{"name":"Kǝngǝrli","shortCode":"KAN"},{"name":"Kürdəmir","shortCode":"KUR"},{"name":"Laçın","shortCode":"LAC"},{"name":"Lənkəran","shortCode":"LAN"},{"name":"Lerik","shortCode":"LER"},{"name":"Masallı","shortCode":"MAS"},{"name":"Neftçala","shortCode":"NEF"},{"name":"Oğuz","shortCode":"OGU"},{"name":"Ordubad","shortCode":"ORD"},{"name":"Qəbələ","shortCode":"QAB"},{"name":"Qax","shortCode":"QAX"},{"name":"Qazax","shortCode":"QAZ"},{"name":"Qobustan","shortCode":"QOB"},{"name":"Quba","shortCode":"QBA"},{"name":"Qubadli","shortCode":"QBI"},{"name":"Qusar","shortCode":"QUS"},{"name":"Saatlı","shortCode":"SAT"},{"name":"Sabirabad","shortCode":"SAB"},{"name":"Şabran","shortCode":"SBN"},{"name":"Sədərək","shortCode":"SAD"},{"name":"Şahbuz","shortCode":"SAH"},{"name":"Şəki","shortCode":"SAK"},{"name":"Salyan","shortCode":"SAL"},{"name":"Şamaxı","shortCode":"SMI"},{"name":"Şəmkir","shortCode":"SKR"},{"name":"Samux","shortCode":"SMX"},{"name":"Şərur","shortCode":"SAR"},{"name":"Siyəzən","shortCode":"SIY"},{"name":"Şuşa","shortCode":"SUS"},{"name":"Tərtər","shortCode":"TAR"},{"name":"Tovuz","shortCode":"TOV"},{"name":"Ucar","shortCode":"UCA"},{"name":"Xaçmaz","shortCode":"XAC"},{"name":"Xızı","shortCode":"XIZ"},{"name":"Xocalı","shortCode":"XCI"},{"name":"Xocavənd","shortCode":"XVD"},{"name":"Yardımlı","shortCode":"YAR"},{"name":"Yevlax","shortCode":"YEV"},{"name":"Zəngilan","shortCode":"ZAN"},{"name":"Zaqatala","shortCode":"ZAQ"},{"name":"Zərdab","shortCode":"ZAR"}]},{"countryName":"Bahamas","countryShortCode":"BS","regions":[{"name":"Acklins Island","shortCode":"01"},{"name":"Berry Islands","shortCode":"22"},{"name":"Bimini","shortCode":"02"},{"name":"Black Point","shortCode":"23"},{"name":"Cat Island","shortCode":"03"},{"name":"Central Abaco","shortCode":"24"},{"name":"Crooked Island and Long Cay","shortCode":"28"},{"name":"East Grand Bahama","shortCode":"29"},{"name":"Exuma","shortCode":"04"},{"name":"Freeport","shortCode":"05"},{"name":"Fresh Creek","shortCode":"06"},{"name":"Governor's Harbour","shortCode":"07"},{"name":"Green Turtle Cay","shortCode":"08"},{"name":"Harbour Island","shortCode":"09"},{"name":"High Rock","shortCode":"10"},{"name":"Inagua","shortCode":"11"},{"name":"Kemps Bay","shortCode":"12"},{"name":"Long Island","shortCode":"13"},{"name":"Marsh Harbour","shortCode":"14"},{"name":"Mayaguana","shortCode":"15"},{"name":"Moore’s Island","shortCode":"40"},{"name":"New Providence","shortCode":"16"},{"name":"Nichollstown and Berry Islands","shortCode":"17"},{"name":"North Abaco","shortCode":"42"},{"name":"North Andros","shortCode":"41"},{"name":"North Eleuthera","shortCode":"33"},{"name":"Ragged Island","shortCode":"18"},{"name":"Rock Sound","shortCode":"19"},{"name":"San Salvador and Rum Cay","shortCode":"20"},{"name":"Sandy Point","shortCode":"21"},{"name":"South Abaco","shortCode":"35"},{"name":"South Andros","shortCode":"36"},{"name":"South Eleuthera","shortCode":"37"},{"name":"West Grand Bahama","shortCode":"39"}]},{"countryName":"Bahrain","countryShortCode":"BH","regions":[{"name":"Al Janūbīyah","shortCode":"14"},{"name":"Al Manāmah","shortCode":"13"},{"name":"Al Muḩarraq","shortCode":"15"},{"name":"Al Wusţá","shortCode":"16"},{"name":"Ash Shamālīyah","shortCode":"17"}]},{"countryName":"Bangladesh","countryShortCode":"BD","regions":[{"name":"Barisal","shortCode":"A"},{"name":"Chittagong","shortCode":"B"},{"name":"Dhaka","shortCode":"C"},{"name":"Khulna","shortCode":"D"},{"name":"Mymensingh","shortCode":"M"},{"name":"Rajshahi","shortCode":"E"},{"name":"Rangpur","shortCode":"F"},{"name":"Sylhet","shortCode":"G"}]},{"countryName":"Barbados","countryShortCode":"BB","regions":[{"name":"Christ Church","shortCode":"01"},{"name":"Saint Andrew","shortCode":"02"},{"name":"Saint George","shortCode":"03"},{"name":"Saint James","shortCode":"04"},{"name":"Saint John","shortCode":"05"},{"name":"Saint Joseph","shortCode":"06"},{"name":"Saint Lucy","shortCode":"07"},{"name":"Saint Michael","shortCode":"08"},{"name":"Saint Peter","shortCode":"09"},{"name":"Saint Philip","shortCode":"10"},{"name":"Saint Thomas","shortCode":"11"}]},{"countryName":"Belarus","countryShortCode":"BY","regions":[{"name":"Brest voblast","shortCode":"BR"},{"name":"Gorod Minsk","shortCode":"HO"},{"name":"Homiel voblast","shortCode":"HO"},{"name":"Hrodna voblast","shortCode":"HR"},{"name":"Mahilyow voblast","shortCode":"MA"},{"name":"Minsk voblast","shortCode":"MI"},{"name":"Vitsebsk voblast","shortCode":"VI"}]},{"countryName":"Belgium","countryShortCode":"BE","regions":[{"name":"Bruxelles-Capitale","shortCode":"BRU"},{"name":"Région Flamande","shortCode":"VLG"},{"name":"Région Wallonië","shortCode":"WAL"}]},{"countryName":"Belize","countryShortCode":"BZ","regions":[{"name":"Belize District","shortCode":"BZ"},{"name":"Cayo District","shortCode":"CY"},{"name":"Corozal District","shortCode":"CZL"},{"name":"Orange Walk District","shortCode":"OW"},{"name":"Stann Creek District","shortCode":"SC"},{"name":"Toledo District","shortCode":"TOL"}]},{"countryName":"Benin","countryShortCode":"BJ","regions":[{"name":"Alibori","shortCode":"AL"},{"name":"Atakora","shortCode":"AK"},{"name":"Atlantique","shortCode":"AQ"},{"name":"Borgou","shortCode":"BO"},{"name":"Collines Department","shortCode":"CO"},{"name":"Donga","shortCode":"DO"},{"name":"Kouffo","shortCode":"KO"},{"name":"Littoral Department","shortCode":"LI"},{"name":"Mono Department","shortCode":"MO"},{"name":"Ouémé","shortCode":"OU"},{"name":"Plateau","shortCode":"PL"},{"name":"Zou","shortCode":"ZO"}]},{"countryName":"Bermuda","countryShortCode":"BM","regions":[{"name":"City of Hamilton","shortCode":"03"},{"name":"Devonshire Parish","shortCode":"01"},{"name":"Hamilton Parish","shortCode":"02"},{"name":"Paget Parish","shortCode":"04"},{"name":"Pembroke Parish","shortCode":"05"},{"name":"Sandys Parish","shortCode":"08"},{"name":"Smith's Parish","shortCode":"09"},{"name":"Southampton Parish","shortCode":"10"},{"name":"St. George's Parish","shortCode":"07"},{"name":"Town of St. George","shortCode":"06"},{"name":"Warwick Parish","shortCode":"11"}]},{"countryName":"Bhutan","countryShortCode":"BT","regions":[{"name":"Bumthang","shortCode":"33"},{"name":"Chhukha","shortCode":"12"},{"name":"Dagana","shortCode":"22"},{"name":"Gasa","shortCode":"GA"},{"name":"Haa","shortCode":"13"},{"name":"Lhuntse","shortCode":"44"},{"name":"Mongar","shortCode":"42"},{"name":"Paro","shortCode":"11"},{"name":"Pemagatshel","shortCode":"43"},{"name":"Punakha","shortCode":"23"},{"name":"Samdrup Jongkhar","shortCode":"45"},{"name":"Samtse","shortCode":"14"},{"name":"Sarpang","shortCode":"31"},{"name":"Thimphu","shortCode":"15"},{"name":"Trashigang","shortCode":"41"},{"name":"Trashiyangtse","shortCode":"TY"},{"name":"Trongsa","shortCode":"32"},{"name":"Tsirang","shortCode":"21"},{"name":"Wangdue Phodrang","shortCode":"24"},{"name":"Zhemgang","shortCode":"34"}]},{"countryName":"Bolivia","countryShortCode":"BO","regions":[{"name":"Beni","shortCode":"B"},{"name":"Chuquisaca","shortCode":"H"},{"name":"Cochabamba","shortCode":"C"},{"name":"La Paz","shortCode":"L"},{"name":"Oruro","shortCode":"O"},{"name":"Pando","shortCode":"N"},{"name":"Potosí","shortCode":"P"},{"name":"Santa Cruz","shortCode":"S"},{"name":"Tarija","shortCode":"T"}]},{"countryName":"Bonaire, Sint Eustatius and Saba","countryShortCode":"BQ","regions":[{"name":"Bonaire","shortCode":"BO"},{"name":"Saba Isand","shortCode":"SA"},{"name":"Sint Eustatius","shortCode":"SE"}]},{"countryName":"Bosnia and Herzegovina","countryShortCode":"BA","regions":[{"name":"Brčko Distrikt","shortCode":"BRC"},{"name":"Federacija Bosne i Hercegovine","shortCode":"BIH"},{"name":"Republika Srpska","shortCode":"SRP"}]},{"countryName":"Botswana","countryShortCode":"BW","regions":[{"name":"Central","shortCode":"CE"},{"name":"Ghanzi","shortCode":"GH"},{"name":"Kgalagadi","shortCode":"KG"},{"name":"Kgatleng","shortCode":"KL"},{"name":"Kweneng","shortCode":"KW"},{"name":"North West","shortCode":"NW"},{"name":"North-East","shortCode":"NE"},{"name":"South East","shortCode":"SE"},{"name":"Southern","shortCode":"SO"}]},{"countryName":"Bouvet Island","countryShortCode":"BV","regions":[{"name":"Bouvet Island","shortCode":"BV"}]},{"countryName":"Brazil","countryShortCode":"BR","regions":[{"name":"Acre","shortCode":"AC"},{"name":"Alagoas","shortCode":"AL"},{"name":"Amapá","shortCode":"AP"},{"name":"Amazonas","shortCode":"AM"},{"name":"Bahia","shortCode":"BA"},{"name":"Ceará","shortCode":"CE"},{"name":"Distrito Federal","shortCode":"DF"},{"name":"Espírito Santo","shortCode":"ES"},{"name":"Goiás","shortCode":"GO"},{"name":"Maranhão","shortCode":"MA"},{"name":"Mato Grosso","shortCode":"MT"},{"name":"Mato Grosso do Sul","shortCode":"MS"},{"name":"Minas Gerais","shortCode":"MG"},{"name":"Pará","shortCode":"PA"},{"name":"Paraíba","shortCode":"PB"},{"name":"Paraná","shortCode":"PR"},{"name":"Pernambuco","shortCode":"PE"},{"name":"Piauí","shortCode":"PI"},{"name":"Rio de Janeiro","shortCode":"RJ"},{"name":"Rio Grande do Norte","shortCode":"RN"},{"name":"Rio Grande do Sul","shortCode":"RS"},{"name":"Rondônia","shortCode":"RO"},{"name":"Roraima","shortCode":"RR"},{"name":"Santa Catarina","shortCode":"SC"},{"name":"São Paulo","shortCode":"SP"},{"name":"Sergipe","shortCode":"SE"},{"name":"Tocantins","shortCode":"TO"}]},{"countryName":"British Indian Ocean Territory","countryShortCode":"IO","regions":[{"name":"British Indian Ocean Territory","shortCode":"IO"}]},{"countryName":"Brunei Darussalam","countryShortCode":"BN","regions":[{"name":"Belait","shortCode":"BE"},{"name":"Brunei Muara","shortCode":"BM"},{"name":"Temburong","shortCode":"TE"},{"name":"Tutong","shortCode":"TU"}]},{"countryName":"Bulgaria","countryShortCode":"BG","regions":[{"name":"Blagoevgrad","shortCode":"01"},{"name":"Burgas","shortCode":"02"},{"name":"Dobrich","shortCode":"08"},{"name":"Gabrovo","shortCode":"07"},{"name":"Jambol","shortCode":"28"},{"name":"Khaskovo","shortCode":"26"},{"name":"Kjustendil","shortCode":"10"},{"name":"Kurdzhali","shortCode":"09"},{"name":"Lovech","shortCode":"11"},{"name":"Montana","shortCode":"12"},{"name":"Pazardzhik","shortCode":"13"},{"name":"Pernik","shortCode":"14"},{"name":"Pleven","shortCode":"15"},{"name":"Plovdiv","shortCode":"16"},{"name":"Razgrad","shortCode":"17"},{"name":"Ruse","shortCode":"18"},{"name":"Shumen","shortCode":"27"},{"name":"Silistra","shortCode":"19"},{"name":"Sliven","shortCode":"20"},{"name":"Smoljan","shortCode":"21"},{"name":"Sofija","shortCode":"23"},{"name":"Sofija-Grad","shortCode":"22"},{"name":"Stara Zagora","shortCode":"24"},{"name":"Turgovishhe","shortCode":"25"},{"name":"Varna","shortCode":"03"},{"name":"Veliko Turnovo","shortCode":"04"},{"name":"Vidin","shortCode":"05"},{"name":"Vraca","shortCode":"06"}]},{"countryName":"Burkina Faso","countryShortCode":"BF","regions":[{"name":"Balé","shortCode":"BAL"},{"name":"Bam/Lake Bam","shortCode":"BAM"},{"name":"Banwa Province","shortCode":"BAN"},{"name":"Bazèga","shortCode":"BAZ"},{"name":"Bougouriba","shortCode":"BGR"},{"name":"Boulgou Province","shortCode":"BLG"},{"name":"Boulkiemdé","shortCode":"BLK"},{"name":"Comoé/Komoe","shortCode":"COM"},{"name":"Ganzourgou Province","shortCode":"GAN"},{"name":"Gnagna","shortCode":"GNA"},{"name":"Gourma Province","shortCode":"GOU"},{"name":"Houet","shortCode":"HOU"},{"name":"Ioba","shortCode":"IOB"},{"name":"Kadiogo","shortCode":"KAD"},{"name":"Kénédougou","shortCode":"KEN"},{"name":"Komondjari","shortCode":"KMD"},{"name":"Kompienga","shortCode":"KMP"},{"name":"Kossi Province","shortCode":"KOS"},{"name":"Koulpélogo","shortCode":"KOP"},{"name":"Kouritenga","shortCode":"KOT"},{"name":"Kourwéogo","shortCode":"KOW"},{"name":"Léraba","shortCode":"LER"},{"name":"Loroum","shortCode":"LOR"},{"name":"Mouhoun","shortCode":"MOU"},{"name":"Namentenga","shortCode":"NAM"},{"name":"Naouri/Nahouri","shortCode":"NAO"},{"name":"Nayala","shortCode":"NAY"},{"name":"Noumbiel","shortCode":"NOU"},{"name":"Oubritenga","shortCode":"OUB"},{"name":"Oudalan","shortCode":"OUD"},{"name":"Passoré","shortCode":"PAS"},{"name":"Poni","shortCode":"PON"},{"name":"Sanguié","shortCode":"SNG"},{"name":"Sanmatenga","shortCode":"SMT"},{"name":"Séno","shortCode":"SEN"},{"name":"Sissili","shortCode":"SIS"},{"name":"Soum","shortCode":"SOM"},{"name":"Sourou","shortCode":"SOR"},{"name":"Tapoa","shortCode":"TAP"},{"name":"Tui/Tuy","shortCode":"TUI"},{"name":"Yagha","shortCode":"YAG"},{"name":"Yatenga","shortCode":"YAT"},{"name":"Ziro","shortCode":"ZIR"},{"name":"Zondoma","shortCode":"ZON"},{"name":"Zoundwéogo","shortCode":"ZOU"}]},{"countryName":"Burundi","countryShortCode":"BI","regions":[{"name":"Bubanza","shortCode":"BB"},{"name":"Bujumbura Mairie","shortCode":"BM"},{"name":"Bujumbura Rural","shortCode":"BL"},{"name":"Bururi","shortCode":"BR"},{"name":"Cankuzo","shortCode":"CA"},{"name":"Cibitoke","shortCode":"CI"},{"name":"Gitega","shortCode":"GI"},{"name":"Karuzi","shortCode":"KR"},{"name":"Kayanza","shortCode":"KY"},{"name":"Kirundo","shortCode":"KI"},{"name":"Makamba","shortCode":"MA"},{"name":"Muramvya","shortCode":"MU"},{"name":"Muyinga","shortCode":"MY"},{"name":"Mwaro","shortCode":"MW"},{"name":"Ngozi","shortCode":"NG"},{"name":"Rutana","shortCode":"RT"},{"name":"Ruyigi","shortCode":"RY"}]},{"countryName":"Cambodia","countryShortCode":"KH","regions":[{"name":"Baat Dambang","shortCode":"2"},{"name":"Banteay Mean Chey","shortCode":"1"},{"name":"Kampong Chaam","shortCode":"3"},{"name":"Kampong Chhnang","shortCode":"4"},{"name":"Kampong Spueu","shortCode":"5"},{"name":"Kampong Thum","shortCode":"6"},{"name":"Kampot","shortCode":"7"},{"name":"Kandaal","shortCode":"8"},{"name":"Kaoh Kong","shortCode":"9"},{"name":"Kracheh","shortCode":"10"},{"name":"Krong Kaeb","shortCode":"23"},{"name":"Krong Pailin","shortCode":"24"},{"name":"Krong Preah Sihanouk","shortCode":"18"},{"name":"Mondol Kiri","shortCode":"11"},{"name":"Otdar Mean Chey","shortCode":"22"},{"name":"Phnom Penh","shortCode":"12"},{"name":"Pousaat","shortCode":"15"},{"name":"Preah Vihear","shortCode":"13"},{"name":"Prey Veaeng","shortCode":"14"},{"name":"Rotanah Kiri","shortCode":"16"},{"name":"Siem Reab","shortCode":"17"},{"name":"Stueng Treng","shortCode":"19"},{"name":"Svaay Rieng","shortCode":"20"},{"name":"Taakaev","shortCode":"21"},{"name":"Tbong Khmum","shortCode":"25"}]},{"countryName":"Cameroon","countryShortCode":"CM","regions":[{"name":"Adamaoua","shortCode":"AD"},{"name":"Centre","shortCode":"CE"},{"name":"Est","shortCode":"ES"},{"name":"Extrême-Nord","shortCode":"EN"},{"name":"Littoral","shortCode":"LT"},{"name":"Nord","shortCode":"NO"},{"name":"Nord-Ouest","shortCode":"NW"},{"name":"Ouest","shortCode":"OU"},{"name":"Sud","shortCode":"SU"},{"name":"Sud-Ouest","shortCode":"SW"}]},{"countryName":"Canada","countryShortCode":"CA","regions":[{"name":"Alberta","shortCode":"AB"},{"name":"British Columbia","shortCode":"BC"},{"name":"Manitoba","shortCode":"MB"},{"name":"New Brunswick","shortCode":"NB"},{"name":"Newfoundland and Labrador","shortCode":"NL"},{"name":"Northwest Territories","shortCode":"NT"},{"name":"Nova Scotia","shortCode":"NS"},{"name":"Nunavut","shortCode":"NU"},{"name":"Ontario","shortCode":"ON"},{"name":"Prince Edward Island","shortCode":"PE"},{"name":"Quebec","shortCode":"QC"},{"name":"Saskatchewan","shortCode":"SK"},{"name":"Yukon","shortCode":"YT"}]},{"countryName":"Cape Verde","countryShortCode":"CV","regions":[{"name":"Boa Vista","shortCode":"BV"},{"name":"Brava","shortCode":"BR"},{"name":"Calheta de São Miguel","shortCode":"CS"},{"name":"Maio","shortCode":"MA"},{"name":"Mosteiros","shortCode":"MO"},{"name":"Paúl","shortCode":"PA"},{"name":"Porto Novo","shortCode":"PN"},{"name":"Praia","shortCode":"PR"},{"name":"Ribeira Brava","shortCode":"RB"},{"name":"Ribeira Grande","shortCode":"RG"},{"name":"Sal","shortCode":"SL"},{"name":"Santa Catarina","shortCode":"CA"},{"name":"Santa Cruz","shortCode":"CR"},{"name":"São Domingos","shortCode":"SD"},{"name":"São Filipe","shortCode":"SF"},{"name":"São Nicolau","shortCode":"SN"},{"name":"São Vicente","shortCode":"SV"},{"name":"Tarrafal","shortCode":"TA"},{"name":"Tarrafal de São Nicolau","shortCode":"TS"}]},{"countryName":"Cayman Islands","countryShortCode":"KY","regions":[{"name":"Creek"},{"name":"Eastern"},{"name":"Midland"},{"name":"South Town"},{"name":"Spot Bay"},{"name":"Stake Bay"},{"name":"West End"},{"name":"Western"}]},{"countryName":"Central African Republic","countryShortCode":"CF","regions":[{"name":"Bamingui-Bangoran","shortCode":"BB"},{"name":"Bangui","shortCode":"BGF"},{"name":"Basse-Kotto","shortCode":"BK"},{"name":"Haute-Kotto","shortCode":"HK"},{"name":"Haut-Mbomou","shortCode":"HM"},{"name":"Kémo","shortCode":"KG"},{"name":"Lobaye","shortCode":"LB"},{"name":"Mambéré-Kadéï","shortCode":"HS"},{"name":"Mbomou","shortCode":"MB"},{"name":"Nana-Grebizi","shortCode":"10"},{"name":"Nana-Mambéré","shortCode":"NM"},{"name":"Ombella-M'Poko","shortCode":"MP"},{"name":"Ouaka","shortCode":"UK"},{"name":"Ouham","shortCode":"AC"},{"name":"Ouham Péndé","shortCode":"OP"},{"name":"Sangha-Mbaéré","shortCode":"SE"},{"name":"Vakaga","shortCode":"VK"}]},{"countryName":"Chad","countryShortCode":"TD","regions":[{"name":"Bahr el Ghazal","shortCode":"BG"},{"name":"Batha","shortCode":"BA"},{"name":"Borkou","shortCode":"BO"},{"name":"Chari-Baguirmi","shortCode":"CB"},{"name":"Ennedi-Est","shortCode":"EE"},{"name":"Ennedi-Ouest","shortCode":"EO"},{"name":"Guéra","shortCode":"GR"},{"name":"Hadjer Lamis","shortCode":"HL"},{"name":"Kanem","shortCode":"KA"},{"name":"Lac","shortCode":"LC"},{"name":"Logone Occidental","shortCode":"LO"},{"name":"Logone Oriental","shortCode":"LR"},{"name":"Mondoul","shortCode":"MA"},{"name":"Mayo-Kébbi-Est","shortCode":"ME"},{"name":"Moyen-Chari","shortCode":"MC"},{"name":"Ouaddai","shortCode":"OD"},{"name":"Salamat","shortCode":"SA"},{"name":"Sila","shortCode":"SI"},{"name":"Tandjilé","shortCode":"TA"},{"name":"Tibesti","shortCode":"TI"},{"name":"Ville de Ndjamena","shortCode":"ND"},{"name":"Wadi Fira","shortCode":"WF"}]},{"countryName":"Chile","countryShortCode":"CL","regions":[{"name":"Aisén del General Carlos Ibáñez del Campo","shortCode":"AI"},{"name":"Antofagasta","shortCode":"AN"},{"name":"Araucanía","shortCode":"AR"},{"name":"Arica y Parinacota","shortCode":"AP"},{"name":"Atacama","shortCode":"AT"},{"name":"Bío-Bío","shortCode":"BI"},{"name":"Coquimbo","shortCode":"CO"},{"name":"Libertador General Bernardo O'Higgins","shortCode":"LI"},{"name":"Los Lagos","shortCode":"LL"},{"name":"Los Ríos","shortCode":"LR"},{"name":"Magallanes y Antartica Chilena","shortCode":"MA"},{"name":"Marga-Marga","shortCode":""},{"name":"Maule","shortCode":"ML"},{"name":"Región Metropolitana de Santiago","shortCode":"RM"},{"name":"Tarapacá","shortCode":"TA"},{"name":"Valparaíso","shortCode":"VS"}]},{"countryName":"China","countryShortCode":"CN","regions":[{"name":"Anhui","shortCode":"34"},{"name":"Beijing","shortCode":"11"},{"name":"Chongqing","shortCode":"50"},{"name":"Fujian","shortCode":"35"},{"name":"Gansu","shortCode":"62"},{"name":"Guangdong","shortCode":"44"},{"name":"Guangxi","shortCode":"45"},{"name":"Guizhou","shortCode":"52"},{"name":"Hainan","shortCode":"46"},{"name":"Hebei","shortCode":"13"},{"name":"Heilongjiang","shortCode":"23"},{"name":"Henan","shortCode":"41"},{"name":"Hong Kong","shortCode":"91"},{"name":"Hubei","shortCode":"42"},{"name":"Hunan","shortCode":"43"},{"name":"Inner Mongolia","shortCode":"15"},{"name":"Jiangsu","shortCode":"32"},{"name":"Jiangxi","shortCode":"36"},{"name":"Jilin","shortCode":"22"},{"name":"Liaoning","shortCode":"21"},{"name":"Macau","shortCode":"92"},{"name":"Ningxia","shortCode":"64"},{"name":"Qinghai","shortCode":"63"},{"name":"Shaanxi","shortCode":"61"},{"name":"Shandong","shortCode":"37"},{"name":"Shanghai","shortCode":"31"},{"name":"Shanxi","shortCode":"14"},{"name":"Sichuan","shortCode":"51"},{"name":"Tianjin","shortCode":"12"},{"name":"Tibet","shortCode":"54"},{"name":"Xinjiang","shortCode":"65"},{"name":"Yunnan","shortCode":"53"},{"name":"Zhejiang","shortCode":"33"}]},{"countryName":"Christmas Island","countryShortCode":"CX","regions":[{"name":"Christmas Island","shortCode":"CX"}]},{"countryName":"Cocos (Keeling) Islands","countryShortCode":"CC","regions":[{"name":"Direction Island","shortCode":"DI"},{"name":"Home Island","shortCode":"HM"},{"name":"Horsburgh Island","shortCode":"HR"},{"name":"North Keeling Island","shortCode":"NK"},{"name":"South Island","shortCode":"SI"},{"name":"West Island","shortCode":"WI"}]},{"countryName":"Colombia","countryShortCode":"CO","regions":[{"name":"Amazonas","shortCode":"AMA"},{"name":"Antioquia","shortCode":"ANT"},{"name":"Arauca","shortCode":"ARA"},{"name":"Archipiélago de San Andrés","shortCode":"SAP"},{"name":"Atlántico","shortCode":"ATL"},{"name":"Bogotá D.C.","shortCode":"DC"},{"name":"Bolívar","shortCode":"BOL"},{"name":"Boyacá","shortCode":"BOY"},{"name":"Caldas","shortCode":"CAL"},{"name":"Caquetá","shortCode":"CAQ"},{"name":"Casanare","shortCode":"CAS"},{"name":"Cauca","shortCode":"CAU"},{"name":"Cesar","shortCode":"CES"},{"name":"Chocó","shortCode":"CHO"},{"name":"Córdoba","shortCode":"COR"},{"name":"Cundinamarca","shortCode":"CUN"},{"name":"Guainía","shortCode":"GUA"},{"name":"Guaviare","shortCode":"GUV"},{"name":"Huila","shortCode":"HUI"},{"name":"La Guajira","shortCode":"LAG"},{"name":"Magdalena","shortCode":"MAG"},{"name":"Meta","shortCode":"MET"},{"name":"Nariño","shortCode":"NAR"},{"name":"Norte de Santander","shortCode":"NSA"},{"name":"Putumayo","shortCode":"PUT"},{"name":"Quindío","shortCode":"QUI"},{"name":"Risaralda","shortCode":"RIS"},{"name":"Santander","shortCode":"SAN"},{"name":"Sucre","shortCode":"SUC"},{"name":"Tolima","shortCode":"TOL"},{"name":"Valle del Cauca","shortCode":"VAC"},{"name":"Vaupés","shortCode":"VAU"},{"name":"Vichada","shortCode":"VID"}]},{"countryName":"Comoros","countryShortCode":"KM","regions":[{"name":"Andjazîdja","shortCode":"G"},{"name":"Andjouân","shortCode":"A"},{"name":"Moûhîlî","shortCode":"M"}]},{"countryName":"Congo, Republic of the (Brazzaville)","countryShortCode":"CG","regions":[{"name":"Bouenza","shortCode":"11"},{"name":"Brazzaville","shortCode":"BZV"},{"name":"Cuvette","shortCode":"8"},{"name":"Cuvette-Ouest","shortCode":"15"},{"name":"Kouilou","shortCode":"5"},{"name":"Lékoumou","shortCode":"2"},{"name":"Likouala","shortCode":"7"},{"name":"Niari","shortCode":"9"},{"name":"Plateaux","shortCode":"14"},{"name":"Pointe-Noire","shortCode":"16"},{"name":"Pool","shortCode":"12"},{"name":"Sangha","shortCode":"13"}]},{"countryName":"Congo, the Democratic Republic of the (Kinshasa)","countryShortCode":"CD","regions":[{"name":"Bandundu","shortCode":"BN"},{"name":"Bas-Congo","shortCode":"BC"},{"name":"Équateur","shortCode":"EQ"},{"name":"Kasaï-Occidental","shortCode":"KE"},{"name":"Kasaï-Oriental","shortCode":"KW"},{"name":"Katanga","shortCode":"KA"},{"name":"Kinshasa","shortCode":"KN"},{"name":"Maniema","shortCode":"MA"},{"name":"Nord-Kivu","shortCode":"NK"},{"name":"Orientale","shortCode":"OR"},{"name":"Sud-Kivu","shortCode":"SK"}]},{"countryName":"Cook Islands","countryShortCode":"CK","regions":[{"name":"Aitutaki"},{"name":"Atiu"},{"name":"Avarua"},{"name":"Mangaia"},{"name":"Manihiki"},{"name":"Ma'uke"},{"name":"Mitiaro"},{"name":"Nassau"},{"name":"Palmerston"},{"name":"Penrhyn"},{"name":"Pukapuka"},{"name":"Rakahanga"}]},{"countryName":"Costa Rica","countryShortCode":"CR","regions":[{"name":"Alajuela","shortCode":"2"},{"name":"Cartago","shortCode":"3"},{"name":"Guanacaste","shortCode":"5"},{"name":"Heredia","shortCode":"4"},{"name":"Limón","shortCode":"7"},{"name":"Puntarenas","shortCode":"6"},{"name":"San José","shortCode":"1"}]},{"countryName":"Côte d'Ivoire, Republic of","countryShortCode":"CI","regions":[{"name":"Agnéby","shortCode":"16"},{"name":"Bafing","shortCode":"17"},{"name":"Bas-Sassandra","shortCode":"09"},{"name":"Denguélé","shortCode":"10"},{"name":"Dix-Huit Montagnes","shortCode":"06"},{"name":"Fromager","shortCode":"18"},{"name":"Haut-Sassandra","shortCode":"02"},{"name":"Lacs","shortCode":"07"},{"name":"Lagunes","shortCode":"01"},{"name":"Marahoué","shortCode":"12"},{"name":"Moyen-Cavally","shortCode":"19"},{"name":"Moyen-Comoé","shortCode":"05"},{"name":"N'zi-Comoé","shortCode":"11"},{"name":"Savanes","shortCode":"03"},{"name":"Sud-Bandama","shortCode":"15"},{"name":"Sud-Comoé","shortCode":"13"},{"name":"Vallée du Bandama","shortCode":"04"},{"name":"Worodougou","shortCode":"14"},{"name":"Zanzan","shortCode":"08"}]},{"countryName":"Croatia","countryShortCode":"HR","regions":[{"name":"Bjelovarsko-Bilogorska Županija","shortCode":"07"},{"name":"Brodsko-Posavska Županija","shortCode":"12"},{"name":"Dubrovačko-Neretvanska Županija","shortCode":"19"},{"name":"Grad Zagreb","shortCode":"21"},{"name":"Istarska Županija","shortCode":"18"},{"name":"Karlovačka Županija","shortCode":"04"},{"name":"Koprivničko-Krizevačka Županija","shortCode":"06"},{"name":"Krapinsko-Zagorska Županija","shortCode":"02"},{"name":"Ličko-Senjska Županija","shortCode":"09"},{"name":"Međimurska Županija","shortCode":"20"},{"name":"Osječko-Baranjska Županija","shortCode":"14"},{"name":"Požeško-Slavonska Županija","shortCode":"11"},{"name":"Primorsko-Goranska Županija","shortCode":"08"},{"name":"Sisačko-Moslavačka Županija","shortCode":"03"},{"name":"Splitsko-Dalmatinska Županija","shortCode":"17"},{"name":"Sibensko-Kninska Županija","shortCode":"15"},{"name":"Varaždinska Županija","shortCode":"05"},{"name":"Virovitičko-Podravska Županija","shortCode":"10"},{"name":"Vukovarsko-Srijemska Županija","shortCode":"16"},{"name":"Zadarska Županija","shortCode":"13"},{"name":"Zagrebacka Zupanija","shortCode":"01"}]},{"countryName":"Cuba","countryShortCode":"CU","regions":[{"name":"Artemisa","shortCode":"15"},{"name":"Camagüey","shortCode":"09"},{"name":"Ciego de Ávila","shortCode":"08"},{"name":"Cienfuegos","shortCode":"06"},{"name":"Granma","shortCode":"12"},{"name":"Guantánamo","shortCode":"14"},{"name":"Holguín","shortCode":"11"},{"name":"Isla de la Juventud","shortCode":"99"},{"name":"La Habana","shortCode":"03"},{"name":"Las Tunas","shortCode":"10"},{"name":"Matanzas","shortCode":"04"},{"name":"Mayabeque","shortCode":"16"},{"name":"Pinar del Río","shortCode":"01"},{"name":"Sancti Spíritus","shortCode":"07"},{"name":"Santiago de Cuba","shortCode":"13"},{"name":"Villa Clara","shortCode":"05"}]},{"countryName":"Curaçao","countryShortCode":"CW","regions":[{"name":"Curaçao","shortCode":"CW"}]},{"countryName":"Cyprus","countryShortCode":"CY","regions":[{"name":"Ammochostos","shortCode":"04"},{"name":"Keryneia","shortCode":"05"},{"name":"Larnaka","shortCode":"03"},{"name":"Lefkosia","shortCode":"01"},{"name":"Lemesos","shortCode":"02"},{"name":"Pafos","shortCode":"05"}]},{"countryName":"Czech Republic","countryShortCode":"CZ","regions":[{"name":"Hlavní město Praha","shortCode":"PR"},{"name":"Jihočeský kraj","shortCode":"JC"},{"name":"Jihomoravský kraj","shortCode":"JM"},{"name":"Karlovarský kraj","shortCode":"KA"},{"name":"Královéhradecký kraj","shortCode":"KR"},{"name":"Liberecký kraj","shortCode":"LI"},{"name":"Moravskoslezský kraj","shortCode":"MO"},{"name":"Olomoucký kraj","shortCode":"OL"},{"name":"Pardubický kraj","shortCode":"PA"},{"name":"Plzeňský kraj","shortCode":"PL"},{"name":"Středočeský kraj","shortCode":"ST"},{"name":"Ústecký kraj","shortCode":"US"},{"name":"Vysočina","shortCode":"VY"},{"name":"Zlínský kraj","shortCode":"ZL"}]},{"countryName":"Denmark","countryShortCode":"DK","regions":[{"name":"Hovedstaden","shortCode":"84"},{"name":"Kujalleq","shortCode":"GL-KU"},{"name":"Midtjylland","shortCode":"82"},{"name":"Norderøerne","shortCode":"FO-01"},{"name":"Nordjylland","shortCode":"81"},{"name":"Østerø","shortCode":"FO-06"},{"name":"Qaasuitsup","shortCode":"GL-QA"},{"name":"Qeqqata","shortCode":"GL-QE"},{"name":"Sandø","shortCode":"FO-02"},{"name":"Sermersooq","shortCode":"GL-SM"},{"name":"Sjælland","shortCode":"85"},{"name":"Strømø","shortCode":"FO-03"},{"name":"Suderø","shortCode":"FO-04"},{"name":"Syddanmark","shortCode":"83"},{"name":"Vågø","shortCode":"FO-05"}]},{"countryName":"Djibouti","countryShortCode":"DJ","regions":[{"name":"Ali Sabieh","shortCode":"AS"},{"name":"Arta","shortCode":"AR"},{"name":"Dikhil","shortCode":"DI"},{"name":"Obock","shortCode":"OB"},{"name":"Tadjourah","shortCode":"TA"}]},{"countryName":"Dominica","countryShortCode":"DM","regions":[{"name":"Saint Andrew Parish","shortCode":"02"},{"name":"Saint David Parish","shortCode":"03"},{"name":"Saint George Parish","shortCode":"04"},{"name":"Saint John Parish","shortCode":"05"},{"name":"Saint Joseph Parish","shortCode":"06"},{"name":"Saint Luke Parish","shortCode":"07"},{"name":"Saint Mark Parish","shortCode":"08"},{"name":"Saint Patrick Parish","shortCode":"09"},{"name":"Saint Paul Parish","shortCode":"10"},{"name":"Saint Peter Parish","shortCode":"11"}]},{"countryName":"Dominican Republic","countryShortCode":"DO","regions":[{"name":"Cibao Central","shortCode":"02"},{"name":"Del Valle","shortCode":"37"},{"name":"Distrito Nacional","shortCode":"01"},{"name":"Enriquillo","shortCode":"38"},{"name":"Norcentral","shortCode":"04"},{"name":"Nordeste","shortCode":"34"},{"name":"Noroeste","shortCode":"34"},{"name":"Norte","shortCode":"35"},{"name":"Valdesia","shortCode":"42"}]},{"countryName":"Ecuador","countryShortCode":"EC","regions":[{"name":"Azuay","shortCode":"A"},{"name":"Bolívar","shortCode":"B"},{"name":"Cañar","shortCode":"F"},{"name":"Carchi","shortCode":"C"},{"name":"Chimborazo","shortCode":"H"},{"name":"Cotopaxi","shortCode":"X"},{"name":"El Oro","shortCode":"O"},{"name":"Esmeraldas","shortCode":"E"},{"name":"Galápagos","shortCode":"W"},{"name":"Guayas","shortCode":"G"},{"name":"Imbabura","shortCode":"I"},{"name":"Loja","shortCode":"L"},{"name":"Los Ríos","shortCode":"R"},{"name":"Manabí","shortCode":"M"},{"name":"Morona-Santiago","shortCode":"S"},{"name":"Napo","shortCode":"N"},{"name":"Orellana","shortCode":"D"},{"name":"Pastaza","shortCode":"Y"},{"name":"Pichincha","shortCode":"P"},{"name":"Santa Elena","shortCode":"SE"},{"name":"Santo Domingo de los Tsáchilas","shortCode":"SD"},{"name":"Sucumbíos","shortCode":"U"},{"name":"Tungurahua","shortCode":"T"},{"name":"Zamora-Chinchipe","shortCode":"Z"}]},{"countryName":"Egypt","countryShortCode":"EG","regions":[{"name":"Alexandria","shortCode":"ALX"},{"name":"Aswan","shortCode":"ASN"},{"name":"Asyout","shortCode":"AST"},{"name":"Bani Sueif","shortCode":"BNS"},{"name":"Beheira","shortCode":"BH"},{"name":"Cairo","shortCode":"C"},{"name":"Daqahlia","shortCode":"DK"},{"name":"Dumiat","shortCode":"DT"},{"name":"El Bahr El Ahmar","shortCode":"BA"},{"name":"El Ismailia","shortCode":"IS"},{"name":"El Suez","shortCode":"SUZ"},{"name":"El Wadi El Gedeed","shortCode":"WAD"},{"name":"Fayoum","shortCode":"FYM"},{"name":"Gharbia","shortCode":"GH"},{"name":"Giza","shortCode":"SUZ"},{"name":"Helwan","shortCode":"HU"},{"name":"Kafr El Sheikh","shortCode":"KFS"},{"name":"Luxor","shortCode":"LX"},{"name":"Matrouh","shortCode":"MT"},{"name":"Menia","shortCode":"MN"},{"name":"Menofia","shortCode":"MNF"},{"name":"North Sinai","shortCode":"SIN"},{"name":"Port Said","shortCode":"PTS"},{"name":"Qalubia","shortCode":"KB"},{"name":"Qena","shortCode":"KN"},{"name":"Sharqia","shortCode":"SHR"},{"name":"Sixth of October","shortCode":"SU"},{"name":"Sohag","shortCode":"SHG"},{"name":"South Sinai","shortCode":"JS"}]},{"countryName":"El Salvador","countryShortCode":"SV","regions":[{"name":"Ahuachapán","shortCode":"AH"},{"name":"Cabañas","shortCode":"CA"},{"name":"Cuscatlán","shortCode":"CU"},{"name":"Chalatenango","shortCode":"CH"},{"name":"La Libertad","shortCode":"LI"},{"name":"La Paz","shortCode":"PA"},{"name":"La Unión","shortCode":"UN"},{"name":"Morazán","shortCode":"MO"},{"name":"San Miguel","shortCode":"SM"},{"name":"San Salvador","shortCode":"SS"},{"name":"Santa Ana","shortCode":"SA"},{"name":"San Vicente","shortCode":"SV"},{"name":"Sonsonate","shortCode":"SO"},{"name":"Usulután","shortCode":"US"}]},{"countryName":"Equatorial Guinea","countryShortCode":"GQ","regions":[{"name":"Annobón","shortCode":"AN"},{"name":"Bioko Norte","shortCode":"BN"},{"name":"Bioko Sur","shortCode":"BS"},{"name":"Centro Sur","shortCode":"CS"},{"name":"Kié-Ntem","shortCode":"KN"},{"name":"Litoral","shortCode":"LI"},{"name":"Wele-Nzas","shortCode":"WN"}]},{"countryName":"Eritrea","countryShortCode":"ER","regions":[{"name":"Anseba","shortCode":"AN"},{"name":"Debub","shortCode":"DU"},{"name":"Debub-Keih-Bahri","shortCode":"DK"},{"name":"Gash-Barka","shortCode":"GB"},{"name":"Maekel","shortCode":"MA"},{"name":"Semien-Keih-Bahri","shortCode":"SK"}]},{"countryName":"Estonia","countryShortCode":"EE","regions":[{"name":"Harjumaa (Tallinn)","shortCode":"37"},{"name":"Hiiumaa (Kardla)","shortCode":"39"},{"name":"Ida-Virumaa (Johvi)","shortCode":"44"},{"name":"Järvamaa (Paide)","shortCode":"41"},{"name":"Jõgevamaa (Jogeva)","shortCode":"49"},{"name":"Läänemaa","shortCode":"57"},{"name":"Lääne-Virumaa (Rakvere)","shortCode":"59"},{"name":"Pärnumaa (Parnu)","shortCode":"67"},{"name":"Põlvamaa (Polva)","shortCode":"65"},{"name":"Raplamaa (Rapla)","shortCode":"70"},{"name":"Saaremaa (Kuessaare)","shortCode":"74"},{"name":"Tartumaa (Tartu)","shortCode":"78"},{"name":"Valgamaa (Valga)","shortCode":"82"},{"name":"Viljandimaa (Viljandi)","shortCode":"84"},{"name":"Võrumaa (Voru)","shortCode":"86"}]},{"countryName":"Ethiopia","countryShortCode":"ET","regions":[{"name":"Addis Ababa","shortCode":"AA"},{"name":"Afar","shortCode":"AF"},{"name":"Amhara","shortCode":"AM"},{"name":"Benshangul-Gumaz","shortCode":"BE"},{"name":"Dire Dawa","shortCode":"DD"},{"name":"Gambela","shortCode":"GA"},{"name":"Harari","shortCode":"HA"},{"name":"Oromia","shortCode":"OR"},{"name":"Somali","shortCode":"SO"},{"name":"Southern Nations Nationalities and People's Region","shortCode":"SN"},{"name":"Tigray","shortCode":"TI"}]},{"countryName":"Falkland Islands (Islas Malvinas)","countryShortCode":"FK","regions":[{"name":"Falkland Islands (Islas Malvinas)"}]},{"countryName":"Faroe Islands","countryShortCode":"FO","regions":[{"name":"Bordoy"},{"name":"Eysturoy"},{"name":"Mykines"},{"name":"Sandoy"},{"name":"Skuvoy"},{"name":"Streymoy"},{"name":"Suduroy"},{"name":"Tvoroyri"},{"name":"Vagar"}]},{"countryName":"Fiji","countryShortCode":"FJ","regions":[{"name":"Ba","shortCode":"01"},{"name":"Bua","shortCode":"01"},{"name":"Cakaudrove","shortCode":"03"},{"name":"Kadavu","shortCode":"04"},{"name":"Lau","shortCode":"05"},{"name":"Lomaiviti","shortCode":"06"},{"name":"Macuata","shortCode":"07"},{"name":"Nadroga and Navosa","shortCode":"08"},{"name":"Naitasiri","shortCode":"09"},{"name":"Namosi","shortCode":"10"},{"name":"Ra","shortCode":"011"},{"name":"Rewa","shortCode":"12"},{"name":"Rotuma","shortCode":"R"},{"name":"Serua","shortCode":"12"},{"name":"Tailevu","shortCode":"14"}]},{"countryName":"Finland","countryShortCode":"FI","regions":[{"name":"Ahvenanmaan lääni","shortCode":"AL"},{"name":"Etelä-Suomen lääni","shortCode":"ES"},{"name":"Itä-Suomen lääni","shortCode":"IS"},{"name":"Länsi-Suomen lääni","shortCode":"LS"},{"name":"Lapin lääni","shortCode":"LL"},{"name":"Oulun lääni","shortCode":"OL"}]},{"countryName":"France","countryShortCode":"FR","regions":[{"name":"Auvergne-Rhône-Alpes","shortCode":"ARA"},{"name":"Bourgogne-Franche-Comté","shortCode":"BFC"},{"name":"Bretagne","shortCode":"BRE"},{"name":"Centre-Val de Loire","shortCode":"CVL"},{"name":"Corse","shortCode":"COR"},{"name":"Grand Est","shortCode":"GES"},{"name":"Hauts-de-France","shortCode":"HDF"},{"name":"Île-de-France","shortCode":"IDF"},{"name":"Normandie","shortCode":"NOR"},{"name":"Nouvelle-Aquitaine","shortCode":"NAQ"},{"name":"Occitanie","shortCode":"OCC"},{"name":"Pays de la Loire","shortCode":"PDL"},{"name":"Provence-Alpes-Cote d'Azur","shortCode":"PAC"},{"name":"Clipperton","shortCode":"CP"},{"name":"Guadeloupe","shortCode":"GP"},{"name":"Guyane","shortCode":"GF"},{"name":"Martinique","shortCode":"MQ"},{"name":"Mayotte","shortCode":"YT"},{"name":"Novelle-Calédonie","shortCode":"NC"},{"name":"Polynésie","shortCode":"PF"},{"name":"Saint-Pierre-et-Miquelon","shortCode":"PM"},{"name":"Saint Barthélemy","shortCode":"BL"},{"name":"Saint Martin","shortCode":"MF"},{"name":"Réunion","shortCode":"RE"},{"name":"Terres Australes Françaises","shortCode":"TF"},{"name":"Wallis-et-Futuna","shortCode":"WF"}]},{"countryName":"French Guiana","countryShortCode":"GF","regions":[{"name":"French Guiana"}]},{"countryName":"French Polynesia","countryShortCode":"PF","regions":[{"name":"Archipel des Marquises"},{"name":"Archipel des Tuamotu"},{"name":"Archipel des Tubuai"},{"name":"Iles du Vent"},{"name":"Iles Sous-le-Vent"}]},{"countryName":"French Southern and Antarctic Lands","countryShortCode":"TF","regions":[{"name":"Adelie Land"},{"name":"Ile Crozet"},{"name":"Iles Kerguelen"},{"name":"Iles Saint-Paul et Amsterdam"}]},{"countryName":"Gabon","countryShortCode":"GA","regions":[{"name":"Estuaire","shortCode":"1"},{"name":"Haut-Ogooué","shortCode":"2"},{"name":"Moyen-Ogooué","shortCode":"3"},{"name":"Ngounié","shortCode":"4"},{"name":"Nyanga","shortCode":"5"},{"name":"Ogooué-Ivindo","shortCode":"6"},{"name":"Ogooué-Lolo","shortCode":"7"},{"name":"Ogooué-Maritime","shortCode":"8"},{"name":"Woleu-Ntem","shortCode":"9"}]},{"countryName":"Gambia, The","countryShortCode":"GM","regions":[{"name":"Banjul","shortCode":"B"},{"name":"Central River","shortCode":"M"},{"name":"Lower River","shortCode":"L"},{"name":"North Bank","shortCode":"N"},{"name":"Upper River","shortCode":"U"},{"name":"Western","shortCode":"W"}]},{"countryName":"Georgia","countryShortCode":"GE","regions":[{"name":"Abkhazia (Sokhumi)","shortCode":"AB"},{"name":"Ajaria (Bat'umi)","shortCode":"AJ"},{"name":"Guria","shortCode":"GU"},{"name":"Imereti","shortCode":"IM"},{"name":"K'akheti","shortCode":"KA"},{"name":"Kvemo Kartli","shortCode":"KK"},{"name":"Mtshkheta-Mtianeti","shortCode":"MM"},{"name":"Rach'a-Lexhkumi-KvemoSvaneti","shortCode":"RL"},{"name":"Samegrelo-Zemo Svaneti","shortCode":"SZ"},{"name":"Samtskhe-Javakheti","shortCode":"SJ"},{"name":"Shida Kartli","shortCode":"SK"},{"name":"Tbilisi","shortCode":"TB"}]},{"countryName":"Germany","countryShortCode":"DE","regions":[{"name":"Baden-Württemberg","shortCode":"BW"},{"name":"Bayern","shortCode":"BY"},{"name":"Berlin","shortCode":"BE"},{"name":"Brandenburg","shortCode":"BB"},{"name":"Bremen","shortCode":"HB"},{"name":"Hamburg","shortCode":"HH"},{"name":"Hessen","shortCode":"HE"},{"name":"Mecklenburg-Vorpommern","shortCode":"MV"},{"name":"Niedersachsen","shortCode":"NI"},{"name":"Nordrhein-Westfalen","shortCode":"NW"},{"name":"Rheinland-Pfalz","shortCode":"RP"},{"name":"Saarland","shortCode":"SL"},{"name":"Sachsen","shortCode":"SN"},{"name":"Sachsen-Anhalt","shortCode":"ST"},{"name":"Schleswig-Holstein","shortCode":"SH"},{"name":"Thüringen","shortCode":"TH"}]},{"countryName":"Ghana","countryShortCode":"GH","regions":[{"name":"Ashanti","shortCode":"AH"},{"name":"Brong-Ahafo","shortCode":"BA"},{"name":"Central","shortCode":"CP"},{"name":"Eastern","shortCode":"EP"},{"name":"Greater Accra","shortCode":"AA"},{"name":"Northern","shortCode":"NP"},{"name":"Upper East","shortCode":"UE"},{"name":"Upper West","shortCode":"UW"},{"name":"Volta","shortCode":"TV"},{"name":"Western","shortCode":"WP"}]},{"countryName":"Gibraltar","countryShortCode":"GI","regions":[{"name":"Gibraltar"}]},{"countryName":"Greece","countryShortCode":"GR","regions":[{"name":"Anatolikí Makedonía kai Thráki","shortCode":"A"},{"name":"Attikḯ","shortCode":"I"},{"name":"Dytikí Elláda","shortCode":"G"},{"name":"Dytikí Makedonía","shortCode":"C"},{"name":"Ionía Nísia","shortCode":"F"},{"name":"Kentrikí Makedonía","shortCode":"B"},{"name":"Krítí","shortCode":"M"},{"name":"Notío Aigaío","shortCode":"L"},{"name":"Peloponnísos","shortCode":"J"},{"name":"Stereá Elláda","shortCode":"H"},{"name":"Thessalía","shortCode":"E"},{"name":"Voreío Aigaío","shortCode":"K"},{"name":"Ípeiros","shortCode":"D"},{"name":"Ágion Óros","shortCode":"69"}]},{"countryName":"Greenland","countryShortCode":"GL","regions":[{"name":"Kommune Kujalleq","shortCode":"KU"},{"name":"Kommuneqarfik Sermersooq","shortCode":"SM"},{"name":"Qaasuitsup Kommunia","shortCode":"QA"},{"name":"Qeqqata Kommunia","shortCode":"QE"}]},{"countryName":"Grenada","countryShortCode":"GD","regions":[{"name":"Saint Andrew","shortCode":"01"},{"name":"Saint David","shortCode":"02"},{"name":"Saint George","shortCode":"03"},{"name":"Saint John","shortCode":"04"},{"name":"Saint Mark","shortCode":"05"},{"name":"Saint Patrick","shortCode":"06"},{"name":"Southern Grenadine Islands","shortCode":"10"}]},{"countryName":"Guadeloupe","countryShortCode":"GP","regions":[{"name":"Guadeloupe"}]},{"countryName":"Guam","countryShortCode":"GU","regions":[{"name":"Guam"}]},{"countryName":"Guatemala","countryShortCode":"GT","regions":[{"name":"Alta Verapaz","shortCode":"AV"},{"name":"Baja Verapaz","shortCode":"BV"},{"name":"Chimaltenango","shortCode":"CM"},{"name":"Chiquimula","shortCode":"CQ"},{"name":"El Progreso","shortCode":"PR"},{"name":"Escuintla","shortCode":"ES"},{"name":"Guatemala","shortCode":"GU"},{"name":"Huehuetenango","shortCode":"HU"},{"name":"Izabal","shortCode":"IZ"},{"name":"Jalapa","shortCode":"JA"},{"name":"Jutiapa","shortCode":"JU"},{"name":"Petén","shortCode":"PE"},{"name":"Quetzaltenango","shortCode":"QZ"},{"name":"Quiché","shortCode":"QC"},{"name":"Retalhuleu","shortCode":"Re"},{"name":"Sacatepéquez","shortCode":"SA"},{"name":"San Marcos","shortCode":"SM"},{"name":"Santa Rosa","shortCode":"SR"},{"name":"Sololá","shortCode":"SO"},{"name":"Suchitepéquez","shortCode":"SU"},{"name":"Totonicapán","shortCode":"TO"},{"name":"Zacapa","shortCode":"ZA"}]},{"countryName":"Guernsey","countryShortCode":"GG","regions":[{"name":"Castel"},{"name":"Forest"},{"name":"St. Andrew"},{"name":"St. Martin"},{"name":"St. Peter Port"},{"name":"St. Pierre du Bois"},{"name":"St. Sampson"},{"name":"St. Saviour"},{"name":"Torteval"},{"name":"Vale"}]},{"countryName":"Guinea","countryShortCode":"GN","regions":[{"name":"Boké","shortCode":"B"},{"name":"Conakry","shortCode":"C"},{"name":"Faranah","shortCode":"F"},{"name":"Kankan","shortCode":"K"},{"name":"Kindia","shortCode":"D"},{"name":"Labé","shortCode":"L"},{"name":"Mamou","shortCode":"M"},{"name":"Nzérékoré","shortCode":"N"}]},{"countryName":"Guinea-Bissau","countryShortCode":"GW","regions":[{"name":"Bafatá","shortCode":"BA"},{"name":"Biombo","shortCode":"BM"},{"name":"Bissau","shortCode":"BS"},{"name":"Bolama-Bijagos","shortCode":"BL"},{"name":"Cacheu","shortCode":"CA"},{"name":"Gabú","shortCode":"GA"},{"name":"Oio","shortCode":"OI"},{"name":"Quinara","shortCode":"QU"},{"name":"Tombali","shortCode":"TO"}]},{"countryName":"Guyana","countryShortCode":"GY","regions":[{"name":"Barima-Waini","shortCode":"BA"},{"name":"Cuyuni-Mazaruni","shortCode":"CU"},{"name":"Demerara-Mahaica","shortCode":"DE"},{"name":"East Berbice-Corentyne","shortCode":"EB"},{"name":"Essequibo Islands-West Demerara","shortCode":"ES"},{"name":"Mahaica-Berbice","shortCode":"MA"},{"name":"Pomeroon-Supenaam","shortCode":"PM"},{"name":"Potaro-Siparuni","shortCode":"PT"},{"name":"Upper Demerara-Berbice","shortCode":"UD"},{"name":"Upper Takutu-Upper Essequibo","shortCode":"UT"}]},{"countryName":"Haiti","countryShortCode":"HT","regions":[{"name":"Artibonite","shortCode":"AR"},{"name":"Centre","shortCode":"CE"},{"name":"Grand'Anse","shortCode":"GA"},{"name":"Nippes","shortCode":"NI"},{"name":"Nord","shortCode":"ND"},{"name":"Nord-Est","shortCode":"NE"},{"name":"Nord-Ouest","shortCode":"NO"},{"name":"Ouest","shortCode":"OU"},{"name":"Sud","shortCode":"SD"},{"name":"Sud-Est","shortCode":"SE"}]},{"countryName":"Heard Island and McDonald Islands","countryShortCode":"HM","regions":[{"name":"Heard Island and McDonald Islands"}]},{"countryName":"Holy See (Vatican City)","countryShortCode":"VA","regions":[{"name":"Holy See (Vatican City)","shortCode":"01"}]},{"countryName":"Honduras","countryShortCode":"HN","regions":[{"name":"Atlántida","shortCode":"AT"},{"name":"Choluteca","shortCode":"CH"},{"name":"Colón","shortCode":"CL"},{"name":"Comayagua","shortCode":"CM"},{"name":"Copán","shortCode":"CP"},{"name":"Cortés","shortCode":"CR"},{"name":"El Paraíso","shortCode":"EP"},{"name":"Francisco Morazan","shortCode":"FM"},{"name":"Gracias a Dios","shortCode":"GD"},{"name":"Intibucá","shortCode":"IN"},{"name":"Islas de la Bahía","shortCode":"IB"},{"name":"La Paz","shortCode":"LP"},{"name":"Lempira","shortCode":"LE"},{"name":"Ocotepeque","shortCode":"OC"},{"name":"Olancho","shortCode":"OL"},{"name":"Santa Bárbara","shortCode":"SB"},{"name":"Valle","shortCode":"VA"},{"name":"Yoro","shortCode":"YO"}]},{"countryName":"Hong Kong","countryShortCode":"HK","regions":[{"name":"Hong Kong"}]},{"countryName":"Hungary","countryShortCode":"HU","regions":[{"name":"Bács-Kiskun","shortCode":"BK"},{"name":"Baranya","shortCode":"BA"},{"name":"Békés","shortCode":"BE"},{"name":"Békéscsaba","shortCode":"BC"},{"name":"Borsod-Abauj-Zemplen","shortCode":"BZ"},{"name":"Budapest","shortCode":"BU"},{"name":"Csongrád","shortCode":"CS"},{"name":"Debrecen","shortCode":"DE"},{"name":"Dunaújváros","shortCode":"DU"},{"name":"Eger","shortCode":"EG"},{"name":"Érd","shortCode":"ER"},{"name":"Fejér","shortCode":"FE"},{"name":"Győr","shortCode":"GY"},{"name":"Győr-Moson-Sopron","shortCode":"GS"},{"name":"Hajdú-Bihar","shortCode":"HB"},{"name":"Heves","shortCode":"HE"},{"name":"Hódmezővásárhely","shortCode":"HV"},{"name":"Jász-Nagykun-Szolnok","shortCode":"N"},{"name":"Kaposvár","shortCode":"KV"},{"name":"Kecskemét","shortCode":"KM"},{"name":"Komárom-Esztergom","shortCode":"KE"},{"name":"Miskolc","shortCode":"MI"},{"name":"Nagykanizsa","shortCode":"NK"},{"name":"Nógrád","shortCode":"NO"},{"name":"Nyíregyháza","shortCode":"NY"},{"name":"Pécs","shortCode":"PS"},{"name":"Pest","shortCode":"PE"},{"name":"Salgótarján","shortCode":"ST"},{"name":"Somogy","shortCode":"SO"},{"name":"Sopron","shortCode":"SN"},{"name":"Szabolcs-á-Bereg","shortCode":"SZ"},{"name":"Szeged","shortCode":"SD"},{"name":"Székesfehérvár","shortCode":"SF"},{"name":"Szekszárd","shortCode":"SS"},{"name":"Szolnok","shortCode":"SK"},{"name":"Szombathely","shortCode":"SH"},{"name":"Tatabánya","shortCode":"TB"},{"name":"Tolna","shortCode":"TO"},{"name":"Vas","shortCode":"VA"},{"name":"Veszprém","shortCode":"VE"},{"name":"Veszprém (City)","shortCode":"VM"},{"name":"Zala","shortCode":"ZA"},{"name":"Zalaegerszeg","shortCode":"ZE"}]},{"countryName":"Iceland","countryShortCode":"IS","regions":[{"name":"Austurland","shortCode":"7"},{"name":"Höfuðborgarsvæði utan Reykjavíkur","shortCode":"1"},{"name":"Norðurland eystra","shortCode":"6"},{"name":"Norðurland vestra","shortCode":"5"},{"name":"Suðurland","shortCode":"8"},{"name":"Suðurnes","shortCode":"2"},{"name":"Vestfirðir","shortCode":"4"},{"name":"Vesturland","shortCode":"3"}]},{"countryName":"India","countryShortCode":"IN","regions":[{"name":"Andaman and Nicobar Islands","shortCode":"AN"},{"name":"Andhra Pradesh","shortCode":"AP"},{"name":"Arunachal Pradesh","shortCode":"AR"},{"name":"Assam","shortCode":"AS"},{"name":"Bihar","shortCode":"BR"},{"name":"Chandigarh","shortCode":"CH"},{"name":"Chhattisgarh","shortCode":"CT"},{"name":"Dadra and Nagar Haveli","shortCode":"DN"},{"name":"Daman and Diu","shortCode":"DD"},{"name":"Delhi","shortCode":"DL"},{"name":"Goa","shortCode":"GA"},{"name":"Gujarat","shortCode":"GJ"},{"name":"Haryana","shortCode":"HR"},{"name":"Himachal Pradesh","shortCode":"HP"},{"name":"Jammu and Kashmir","shortCode":"JK"},{"name":"Jharkhand","shortCode":"JH"},{"name":"Karnataka","shortCode":"KA"},{"name":"Kerala","shortCode":"KL"},{"name":"Lakshadweep","shortCode":"LD"},{"name":"Madhya Pradesh","shortCode":"MP"},{"name":"Maharashtra","shortCode":"MH"},{"name":"Manipur","shortCode":"MN"},{"name":"Meghalaya","shortCode":"ML"},{"name":"Mizoram","shortCode":"MZ"},{"name":"Nagaland","shortCode":"NL"},{"name":"Odisha","shortCode":"OR"},{"name":"Puducherry","shortCode":"PY"},{"name":"Punjab","shortCode":"PB"},{"name":"Rajasthan","shortCode":"RJ"},{"name":"Sikkim","shortCode":"WK"},{"name":"Tamil Nadu","shortCode":"TN"},{"name":"Telangana","shortCode":"TG"},{"name":"Tripura","shortCode":"TR"},{"name":"Uttarakhand","shortCode":"UT"},{"name":"Uttar Pradesh","shortCode":"UP"},{"name":"West Bengal","shortCode":"WB"}]},{"countryName":"Indonesia","countryShortCode":"ID","regions":[{"name":"Aceh","shortCode":"AC"},{"name":"Bali","shortCode":"BA"},{"name":"Bangka Belitung","shortCode":"BB"},{"name":"Banten","shortCode":"BT"},{"name":"Bengkulu","shortCode":"BE"},{"name":"Gorontalo","shortCode":"GO"},{"name":"Jakarta Raya","shortCode":"JK"},{"name":"Jambi","shortCode":"JA"},{"name":"Jawa Barat","shortCode":"JB"},{"name":"Jawa Tengah","shortCode":"JT"},{"name":"Jawa Timur","shortCode":"JI"},{"name":"Kalimantan Barat","shortCode":"KB"},{"name":"Kalimantan Selatan","shortCode":"KS"},{"name":"Kalimantan Tengah","shortCode":"KT"},{"name":"Kalimantan Timur","shortCode":"KI"},{"name":"Kalimantan Utara","shortCode":"KU"},{"name":"Kepulauan Riau","shortCode":"KR"},{"name":"Lampung","shortCode":"LA"},{"name":"Maluku","shortCode":"MA"},{"name":"Maluku Utara","shortCode":"MU"},{"name":"Nusa Tenggara Barat","shortCode":"NB"},{"name":"Nusa Tenggara Timur","shortCode":"NT"},{"name":"Papua","shortCode":"PA"},{"name":"Papua Barat","shortCode":"PB"},{"name":"Riau","shortCode":"RI"},{"name":"Sulawesi Selatan","shortCode":"SR"},{"name":"Sulawesi Tengah","shortCode":"ST"},{"name":"Sulawesi Tenggara","shortCode":"SG"},{"name":"Sulawesi Utara","shortCode":"SA"},{"name":"Sumatera Barat","shortCode":"SB"},{"name":"Sumatera Selatan","shortCode":"SS"},{"name":"Sumatera Utara","shortCode":"SU"},{"name":"Yogyakarta","shortCode":"YO"}]},{"countryName":"Iran, Islamic Republic of","countryShortCode":"IR","regions":[{"name":"Alborz","shortCode":"32"},{"name":"Ardabīl","shortCode":"03"},{"name":"Āz̄arbāyjān-e Gharbī","shortCode":"02"},{"name":"Āz̄arbāyjān-e Sharqī","shortCode":"01"},{"name":"Būshehr","shortCode":"06"},{"name":"Chahār Maḩāl va Bakhtīārī","shortCode":"08"},{"name":"Eşfahān","shortCode":"04"},{"name":"Fārs","shortCode":"14"},{"name":"Gīlān","shortCode":"19"},{"name":"Golestān","shortCode":"27"},{"name":"Hamadān","shortCode":"24"},{"name":"Hormozgān","shortCode":"23"},{"name":"Īlām","shortCode":"05"},{"name":"Kermān","shortCode":"15"},{"name":"Kermānshāh","shortCode":"17"},{"name":"Khorāsān-e Jonūbī","shortCode":"29"},{"name":"Khorāsān-e Raẕavī","shortCode":"30"},{"name":"Khorāsān-e Shomālī","shortCode":"61"},{"name":"Khūzestān","shortCode":"10"},{"name":"Kohgīlūyeh va Bowyer Aḩmad","shortCode":"18"},{"name":"Kordestān","shortCode":"16"},{"name":"Lorestān","shortCode":"20"},{"name":"Markazi","shortCode":"22"},{"name":"Māzandarān","shortCode":"21"},{"name":"Qazvīn","shortCode":"28"},{"name":"Qom","shortCode":"26"},{"name":"Semnān","shortCode":"12"},{"name":"Sīstān va Balūchestān","shortCode":"13"},{"name":"Tehrān","shortCode":"07"},{"name":"Yazd","shortCode":"25"},{"name":"Zanjān","shortCode":"11"}]},{"countryName":"Iraq","countryShortCode":"IQ","regions":[{"name":"Al Anbār","shortCode":"AN"},{"name":"Al Başrah","shortCode":"BA"},{"name":"Al Muthanná","shortCode":"MU"},{"name":"Al Qādisīyah","shortCode":"QA"},{"name":"An Najaf","shortCode":"NA"},{"name":"Arbīl","shortCode":"AR"},{"name":"As Sulaymānīyah","shortCode":"SU"},{"name":"Bābil","shortCode":"BB"},{"name":"Baghdād","shortCode":"BG"},{"name":"Dohuk","shortCode":"DA"},{"name":"Dhī Qār","shortCode":"DQ"},{"name":"Diyālá","shortCode":"DI"},{"name":"Karbalā'","shortCode":"KA"},{"name":"Kirkuk","shortCode":"KI"},{"name":"Maysān","shortCode":"MA"},{"name":"Nīnawá","shortCode":"NI"},{"name":"Şalāḩ ad Dīn","shortCode":"SD"},{"name":"Wāsiţ","shortCode":"WA"}]},{"countryName":"Ireland","countryShortCode":"IE","regions":[{"name":"Carlow","shortCode":"CW"},{"name":"Cavan","shortCode":"CN"},{"name":"Clare","shortCode":"CE"},{"name":"Cork","shortCode":"CO"},{"name":"Donegal","shortCode":"DL"},{"name":"Dublin","shortCode":"D"},{"name":"Galway","shortCode":"G"},{"name":"Kerry","shortCode":"KY"},{"name":"Kildare","shortCode":"KE"},{"name":"Kilkenny","shortCode":"KK"},{"name":"Laois","shortCode":"LS"},{"name":"Leitrim","shortCode":"LM"},{"name":"Limerick","shortCode":"LK"},{"name":"Longford","shortCode":"LD"},{"name":"Louth","shortCode":"LH"},{"name":"Mayo","shortCode":"MO"},{"name":"Meath","shortCode":"MH"},{"name":"Monaghan","shortCode":"MN"},{"name":"Offaly","shortCode":"OY"},{"name":"Roscommon","shortCode":"RN"},{"name":"Sligo","shortCode":"SO"},{"name":"Tipperary","shortCode":"TA"},{"name":"Waterford","shortCode":"WD"},{"name":"Westmeath","shortCode":"WH"},{"name":"Wexford","shortCode":"WX"},{"name":"Wicklow","shortCode":"WW"}]},{"countryName":"Isle of Man","countryShortCode":"IM","regions":[{"name":"Isle of Man"}]},{"countryName":"Israel","countryShortCode":"IL","regions":[{"name":"HaDarom","shortCode":"D"},{"name":"HaMerkaz","shortCode":"M"},{"name":"HaTsafon","shortCode":"Z"},{"name":"H̱efa","shortCode":"HA"},{"name":"Tel-Aviv","shortCode":"TA"},{"name":"Yerushalayim","shortCode":"JM"}]},{"countryName":"Italy","countryShortCode":"IT","regions":[{"name":"Abruzzo","shortCode":"65"},{"name":"Basilicata","shortCode":"77"},{"name":"Calabria","shortCode":"78"},{"name":"Campania","shortCode":"72"},{"name":"Emilia-Romagna","shortCode":"45"},{"name":"Friuli-Venezia Giulia","shortCode":"36"},{"name":"Lazio","shortCode":"62"},{"name":"Liguria","shortCode":"42"},{"name":"Lombardia","shortCode":"25"},{"name":"Marche","shortCode":"57"},{"name":"Molise","shortCode":"67"},{"name":"Piemonte","shortCode":"21"},{"name":"Puglia","shortCode":"75"},{"name":"Sardegna","shortCode":"88"},{"name":"Sicilia","shortCode":"82"},{"name":"Toscana","shortCode":"52"},{"name":"Trentino-Alto Adige","shortCode":"32"},{"name":"Umbria","shortCode":"55"},{"name":"Valle d'Aosta","shortCode":"23"},{"name":"Veneto","shortCode":"34"}]},{"countryName":"Jamaica","countryShortCode":"JM","regions":[{"name":"Clarendon","shortCode":"13"},{"name":"Hanover","shortCode":"09"},{"name":"Kingston","shortCode":"01"},{"name":"Manchester","shortCode":"12"},{"name":"Portland","shortCode":"04"},{"name":"Saint Andrew","shortCode":"02"},{"name":"Saint Ann","shortCode":"06"},{"name":"Saint Catherine","shortCode":"14"},{"name":"Saint Elizabeth","shortCode":"11"},{"name":"Saint James","shortCode":"08"},{"name":"Saint Mary","shortCode":"05"},{"name":"Saint Thomas","shortCode":"03"},{"name":"Trelawny","shortCode":"07"},{"name":"Westmoreland","shortCode":"10"}]},{"countryName":"Japan","countryShortCode":"JP","regions":[{"name":"Aichi","shortCode":"23"},{"name":"Akita","shortCode":"05"},{"name":"Aomori","shortCode":"02"},{"name":"Chiba","shortCode":"12"},{"name":"Ehime","shortCode":"38"},{"name":"Fukui","shortCode":"18"},{"name":"Fukuoka","shortCode":"40"},{"name":"Fukushima","shortCode":"07"},{"name":"Gifu","shortCode":"21"},{"name":"Gunma","shortCode":"10"},{"name":"Hiroshima","shortCode":"34"},{"name":"Hokkaido","shortCode":"01"},{"name":"Hyogo","shortCode":"28"},{"name":"Ibaraki","shortCode":"08"},{"name":"Ishikawa","shortCode":"17"},{"name":"Iwate","shortCode":"03"},{"name":"Kagawa","shortCode":"37"},{"name":"Kagoshima","shortCode":"46"},{"name":"Kanagawa","shortCode":"14"},{"name":"Kochi","shortCode":"39"},{"name":"Kumamoto","shortCode":"43"},{"name":"Kyoto","shortCode":"26"},{"name":"Mie","shortCode":"24"},{"name":"Miyagi","shortCode":"04"},{"name":"Miyazaki","shortCode":"45"},{"name":"Nagano","shortCode":"20"},{"name":"Nagasaki","shortCode":"42"},{"name":"Nara","shortCode":"29"},{"name":"Niigata","shortCode":"15"},{"name":"Oita","shortCode":"44"},{"name":"Okayama","shortCode":"33"},{"name":"Okinawa","shortCode":"47"},{"name":"Osaka","shortCode":"27"},{"name":"Saga","shortCode":"41"},{"name":"Saitama","shortCode":"11"},{"name":"Shiga","shortCode":"25"},{"name":"Shimane","shortCode":"32"},{"name":"Shizuoka","shortCode":"22"},{"name":"Tochigi","shortCode":"09"},{"name":"Tokushima","shortCode":"36"},{"name":"Tokyo","shortCode":"13"},{"name":"Tottori","shortCode":"31"},{"name":"Toyama","shortCode":"16"},{"name":"Wakayama","shortCode":"30"},{"name":"Yamagata","shortCode":"06"},{"name":"Yamaguchi","shortCode":"35"},{"name":"Yamanashi","shortCode":"19"}]},{"countryName":"Jersey","countryShortCode":"JE","regions":[{"name":"Jersey"}]},{"countryName":"Jordan","countryShortCode":"JO","regions":[{"name":"‘Ajlūn","shortCode":"AJ"},{"name":"Al 'Aqabah","shortCode":"AQ"},{"name":"Al Balqā’","shortCode":"BA"},{"name":"Al Karak","shortCode":"KA"},{"name":"Al Mafraq","shortCode":"MA"},{"name":"Al ‘A̅şimah","shortCode":"AM"},{"name":"Aţ Ţafīlah","shortCode":"AT"},{"name":"Az Zarqā’","shortCode":"AZ"},{"name":"Irbid","shortCode":"IR"},{"name":"Jarash","shortCode":"JA"},{"name":"Ma‘ān","shortCode":"MN"},{"name":"Mādabā","shortCode":"MD"}]},{"countryName":"Kazakhstan","countryShortCode":"KZ","regions":[{"name":"Almaty","shortCode":"ALA"},{"name":"Aqmola","shortCode":"AKM"},{"name":"Aqtobe","shortCode":"AKT"},{"name":"Astana","shortCode":"AST"},{"name":"Atyrau","shortCode":"ATY"},{"name":"Batys Qazaqstan","shortCode":"ZAP"},{"name":"Bayqongyr"},{"name":"Mangghystau","shortCode":"MAN"},{"name":"Ongtustik Qazaqstan","shortCode":"YUZ"},{"name":"Pavlodar","shortCode":"PAV"},{"name":"Qaraghandy","shortCode":"KAR"},{"name":"Qostanay","shortCode":"KUS"},{"name":"Qyzylorda","shortCode":"KZY"},{"name":"Shyghys Qazaqstan","shortCode":"VOS"},{"name":"Soltustik Qazaqstan","shortCode":"SEV"},{"name":"Zhambyl","shortCode":"ZHA"}]},{"countryName":"Kenya","countryShortCode":"KE","regions":[{"name":"Baringo","shortCode":"01"},{"name":"Bomet","shortCode":"02"},{"name":"Bungoma","shortCode":"03"},{"name":"Busia","shortCode":"04"},{"name":"Eleyo/Marakwet","shortCode":"05"},{"name":"Embu","shortCode":"06"},{"name":"Garissa","shortCode":"07"},{"name":"Homa Bay","shortCode":"08"},{"name":"Isiolo","shortCode":"09"},{"name":"Kajiado","shortCode":"10"},{"name":"Kakamega","shortCode":"11"},{"name":"Kericho","shortCode":"12"},{"name":"Kiambu","shortCode":"13"},{"name":"Kilifi","shortCode":"14"},{"name":"Kirinyaga","shortCode":"15"},{"name":"Kisii","shortCode":"16"},{"name":"Kisumu","shortCode":"17"},{"name":"Kitui","shortCode":"18"},{"name":"Kwale","shortCode":"19"},{"name":"Laikipia","shortCode":"20"},{"name":"Lamu","shortCode":"21"},{"name":"Machakos","shortCode":"22"},{"name":"Makueni","shortCode":"23"},{"name":"Mandera","shortCode":"24"},{"name":"Marsabit","shortCode":"25"},{"name":"Meru","shortCode":"26"},{"name":"Migori","shortCode":"27"},{"name":"Mombasa","shortCode":"28"},{"name":"Murang'a","shortCode":"29"},{"name":"Nairobi City","shortCode":"30"},{"name":"Nakuru","shortCode":"31"},{"name":"Nandi","shortCode":"32"},{"name":"Narok","shortCode":"33"},{"name":"Nyamira","shortCode":"34"},{"name":"Nyandarua","shortCode":"35"},{"name":"Nyeri","shortCode":"36"},{"name":"Samburu","shortCode":"37"},{"name":"Siaya","shortCode":"38"},{"name":"Taita/Taveta","shortCode":"39"},{"name":"Tana River","shortCode":"40"},{"name":"Tharaka-Nithi","shortCode":"41"},{"name":"Trans Nzoia","shortCode":"42"},{"name":"Turkana","shortCode":"43"},{"name":"Uasin Gishu","shortCode":"44"},{"name":"Vihiga","shortCode":"45"},{"name":"Wajir","shortCode":"46"},{"name":"West Pokot","shortCode":"47"}]},{"countryName":"Kiribati","countryShortCode":"KI","regions":[{"name":"Abaiang"},{"name":"Abemama"},{"name":"Aranuka"},{"name":"Arorae"},{"name":"Banaba"},{"name":"Beru"},{"name":"Butaritari"},{"name":"Central Gilberts"},{"name":"Gilbert Islands","shortCode":"G"},{"name":"Kanton"},{"name":"Kiritimati"},{"name":"Kuria"},{"name":"Line Islands","shortCode":"L"},{"name":"Maiana"},{"name":"Makin"},{"name":"Marakei"},{"name":"Nikunau"},{"name":"Nonouti"},{"name":"Northern Gilberts"},{"name":"Onotoa"},{"name":"Phoenix Islands","shortCode":"P"},{"name":"Southern Gilberts"},{"name":"Tabiteuea"},{"name":"Tabuaeran"},{"name":"Tamana"},{"name":"Tarawa"},{"name":"Teraina"}]},{"countryName":"Korea, Democratic People's Republic of","countryShortCode":"KP","regions":[{"name":"Chagang-do (Chagang Province)","shortCode":"04"},{"name":"Hamgyong-bukto (North Hamgyong Province)","shortCode":"09"},{"name":"Hamgyong-namdo (South Hamgyong Province)","shortCode":"08"},{"name":"Hwanghae-bukto (North Hwanghae Province)","shortCode":"06"},{"name":"Hwanghae-namdo (South Hwanghae Province)","shortCode":"05"},{"name":"Kangwon-do (Kangwon Province)","shortCode":"07"},{"name":"Nasŏn (Najin-Sŏnbong)","shortCode":"13"},{"name":"P'yongan-bukto (North P'yongan Province)","shortCode":"03"},{"name":"P'yongan-namdo (South P'yongan Province)","shortCode":"02"},{"name":"P'yongyang-si (P'yongyang City)","shortCode":"01"},{"name":"Yanggang-do (Yanggang Province)","shortCode":"10"}]},{"countryName":"Korea, Republic of","countryShortCode":"KR","regions":[{"name":"Ch'ungch'ongbuk-do","shortCode":"43"},{"name":"Ch'ungch'ongnam-do","shortCode":"44"},{"name":"Cheju-do","shortCode":"49"},{"name":"Chollabuk-do","shortCode":"45"},{"name":"Chollanam-do","shortCode":"46"},{"name":"Inch'on-Kwangyokhi","shortCode":"28"},{"name":"Kang-won-do","shortCode":"42"},{"name":"Kwangju-Kwangyokshi","shortCode":"28"},{"name":"Kyonggi-do","shortCode":"41"},{"name":"Kyongsangbuk-do","shortCode":"47"},{"name":"Kyongsangnam-do","shortCode":"48"},{"name":"Pusan-Kwangyokshi","shortCode":"26"},{"name":"Seoul-T'ukpyolshi","shortCode":"11"},{"name":"Sejong","shortCode":"50"},{"name":"Taegu-Kwangyokshi","shortCode":"27"},{"name":"Taejon-Kwangyokshi","shortCode":"30"},{"name":"Ulsan-Kwangyokshi","shortCode":"31"}]},{"countryName":"Kuwait","countryShortCode":"KW","regions":[{"name":"Al Aḩmadi","shortCode":"AH"},{"name":"Al Farwānīyah","shortCode":"FA"},{"name":"Al Jahrā’","shortCode":"JA"},{"name":"Al ‘Āşimah","shortCode":"KU"},{"name":"Ḩawallī","shortCode":"HA"},{"name":"Mubārak al Kabir","shortCode":"MU"}]},{"countryName":"Kyrgyzstan","countryShortCode":"KG","regions":[{"name":"Batken Oblasty","shortCode":"B"},{"name":"Bishkek Shaary","shortCode":"GB"},{"name":"Chuy Oblasty (Bishkek)","shortCode":"C"},{"name":"Jalal-Abad Oblasty","shortCode":"J"},{"name":"Naryn Oblasty","shortCode":"N"},{"name":"Osh Oblasty","shortCode":"O"},{"name":"Talas Oblasty","shortCode":"T"},{"name":"Ysyk-Kol Oblasty (Karakol)","shortCode":"Y"}]},{"countryName":"Laos","countryShortCode":"LA","regions":[{"name":"Attapu","shortCode":"AT"},{"name":"Bokèo","shortCode":"BK"},{"name":"Bolikhamxai","shortCode":"BL"},{"name":"Champasak","shortCode":"CH"},{"name":"Houaphan","shortCode":"HO"},{"name":"Khammouan","shortCode":"KH"},{"name":"Louang Namtha","shortCode":"LM"},{"name":"Louangphabang","shortCode":"LP"},{"name":"Oudômxai","shortCode":"OU"},{"name":"Phôngsali","shortCode":"PH"},{"name":"Salavan","shortCode":"SL"},{"name":"Savannakhét","shortCode":"SV"},{"name":"Vientiane","shortCode":"VI"},{"name":"Xaignabouli","shortCode":"XA"},{"name":"Xékong","shortCode":"XE"},{"name":"Xaisomboun","shortCode":"XS"},{"name":"Xiangkhouang","shortCode":"XI"}]},{"countryName":"Latvia","countryShortCode":"LV","regions":[{"name":"Aglona","shortCode":"001"},{"name":"Aizkraukle","shortCode":"002"},{"name":"Aizpute","shortCode":"003"},{"name":"Aknīste","shortCode":"004"},{"name":"Aloja","shortCode":"005"},{"name":"Alsunga","shortCode":"06"},{"name":"Alūksne","shortCode":"007"},{"name":"Amata","shortCode":"008"},{"name":"Ape","shortCode":"009"},{"name":"Auce","shortCode":"010"},{"name":"Ādaži","shortCode":"011"},{"name":"Babīte","shortCode":"012"},{"name":"Baldone","shortCode":"013"},{"name":"Baltinava","shortCode":"014"},{"name":"Balvi","shortCode":"015"},{"name":"Bauska","shortCode":"016"},{"name":"Beverīna","shortCode":"017"},{"name":"Brocēni","shortCode":"018"},{"name":"Burtnieki","shortCode":"019"},{"name":"Carnikava","shortCode":"020"},{"name":"Cesvaine","shortCode":"021"},{"name":"Cēsis","shortCode":"022"},{"name":"Cibla","shortCode":"023"},{"name":"Dagda","shortCode":"024"},{"name":"Daugavpils","shortCode":"025"},{"name":"Daugavpils (City)","shortCode":"DGV"},{"name":"Dobele","shortCode":"026"},{"name":"Dundaga","shortCode":"027"},{"name":"Durbe","shortCode":"028"},{"name":"Engure","shortCode":"029"},{"name":"Ērgļi","shortCode":"030"},{"name":"Garkalne","shortCode":"031"},{"name":"Grobiņa","shortCode":"032"},{"name":"Gulbene","shortCode":"033"},{"name":"Iecava","shortCode":"034"},{"name":"Ikšķile","shortCode":"035"},{"name":"Ilūkste","shortCode":"036"},{"name":"Inčukalns","shortCode":"037"},{"name":"Jaunjelgava","shortCode":"038"},{"name":"Jaunpiebalga","shortCode":"039"},{"name":"Jaunpils","shortCode":"040"},{"name":"Jelgava","shortCode":"041"},{"name":"Jelgava (City)","shortCode":"JEL"},{"name":"Jēkabpils","shortCode":"042"},{"name":"Jēkabpils (City)","shortCode":"JKB"},{"name":"Jūrmala (City)","shortCode":"JUR"},{"name":"Kandava","shortCode":"043"},{"name":"Kārsava","shortCode":"044"},{"name":"Kocēni","shortCode":"045"},{"name":"Koknese","shortCode":"046"},{"name":"Krāslava","shortCode":"047"},{"name":"Krimulda","shortCode":"048"},{"name":"Krustpils","shortCode":"049"},{"name":"Kuldīga","shortCode":"050"},{"name":"Ķegums","shortCode":"051"},{"name":"Ķekava","shortCode":"052"},{"name":"Lielvārde","shortCode":"053"},{"name":"Liepāja","shortCode":"LPX"},{"name":"Limbaži","shortCode":"054"},{"name":"Līgatne","shortCode":"055"},{"name":"Līvāni","shortCode":"056"},{"name":"Lubāna","shortCode":"057"},{"name":"Ludza","shortCode":"058"},{"name":"Madona","shortCode":"059"},{"name":"Mazsalaca","shortCode":"060"},{"name":"Mālpils","shortCode":"061"},{"name":"Mārupe","shortCode":"062"},{"name":"Mērsrags","shortCode":"063"},{"name":"Naukšēni","shortCode":"064"},{"name":"Nereta","shortCode":"065"},{"name":"Nīca","shortCode":"066"},{"name":"Ogre","shortCode":"067"},{"name":"Olaine","shortCode":"068"},{"name":"Ozolnieki","shortCode":"069"},{"name":"Pārgauja","shortCode":"070"},{"name":"Pāvilosta","shortCode":"071"},{"name":"Pļaviņas","shortCode":"072"},{"name":"Preiļi","shortCode":"073"},{"name":"Priekule","shortCode":"074"},{"name":"Priekuļi","shortCode":"075"},{"name":"Rauna","shortCode":"076"},{"name":"Rēzekne","shortCode":"077"},{"name":"Rēzekne (City)","shortCode":"REZ"},{"name":"Riebiņi","shortCode":"078"},{"name":"Rīga","shortCode":"RIX"},{"name":"Roja","shortCode":"079"},{"name":"Ropaži","shortCode":"080"},{"name":"Rucava","shortCode":"081"},{"name":"Rugāji","shortCode":"082"},{"name":"Rundāle","shortCode":"083"},{"name":"Rūjiena","shortCode":"084"},{"name":"Sala","shortCode":"085"},{"name":"Salacgrīva","shortCode":"086"},{"name":"Salaspils","shortCode":"087"},{"name":"Saldus","shortCode":"088"},{"name":"Saulkrasti","shortCode":"089"},{"name":"Sēja","shortCode":"090"},{"name":"Sigulda","shortCode":"091"},{"name":"Skrīveri","shortCode":"092"},{"name":"Skrunda","shortCode":"093"},{"name":"Smiltene","shortCode":"094"},{"name":"Stopiņi","shortCode":"095"},{"name":"Strenči","shortCode":"096"},{"name":"Talsi","shortCode":"097"},{"name":"Tērvete","shortCode":"098"},{"name":"Tukums","shortCode":"099"},{"name":"Vaiņode","shortCode":"100"},{"name":"Valka","shortCode":"101"},{"name":"Valmiera","shortCode":"VMR"},{"name":"Varakļāni","shortCode":"102"},{"name":"Vārkava","shortCode":"103"},{"name":"Vecpiebalga","shortCode":"104"},{"name":"Vecumnieki","shortCode":"105"},{"name":"Ventspils","shortCode":"106"},{"name":"Ventspils (City)","shortCode":"VEN"},{"name":"Viesīte","shortCode":"107"},{"name":"Viļaka","shortCode":"108"},{"name":"Viļāni","shortCode":"109"},{"name":"Zilupe","shortCode":"110"}]},{"countryName":"Lebanon","countryShortCode":"LB","regions":[{"name":"Aakkâr","shortCode":"AK"},{"name":"Baalbelk-Hermel","shortCode":"BH"},{"name":"Béqaa","shortCode":"BI"},{"name":"Beyrouth","shortCode":"BA"},{"name":"Liban-Nord","shortCode":"AS"},{"name":"Liban-Sud","shortCode":"JA"},{"name":"Mont-Liban","shortCode":"JL"},{"name":"Nabatîyé","shortCode":"NA"}]},{"countryName":"Lesotho","countryShortCode":"LS","regions":[{"name":"Berea","shortCode":"D"},{"name":"Butha-Buthe","shortCode":"B"},{"name":"Leribe","shortCode":"C"},{"name":"Mafeteng","shortCode":"E"},{"name":"Maseru","shortCode":"A"},{"name":"Mohales Hoek","shortCode":"F"},{"name":"Mokhotlong","shortCode":"J"},{"name":"Qacha's Nek","shortCode":"H"},{"name":"Quthing","shortCode":"G"},{"name":"Thaba-Tseka","shortCode":"K"}]},{"countryName":"Liberia","countryShortCode":"LR","regions":[{"name":"Bomi","shortCode":"BM"},{"name":"Bong","shortCode":"BG"},{"name":"Gbarpolu","shortCode":"GP"},{"name":"Grand Bassa","shortCode":"GB"},{"name":"Grand Cape Mount","shortCode":"CM"},{"name":"Grand Gedeh","shortCode":"GG"},{"name":"Grand Kru","shortCode":"GK"},{"name":"Lofa","shortCode":"LO"},{"name":"Margibi","shortCode":"MG"},{"name":"Maryland","shortCode":"MY"},{"name":"Montserrado","shortCode":"MO"},{"name":"Nimba","shortCode":"NI"},{"name":"River Cess","shortCode":"RI"},{"name":"River Geee","shortCode":"RG"},{"name":"Sinoe","shortCode":"SI"}]},{"countryName":"Libya","countryShortCode":"LY","regions":[{"name":"Al Buţnān","shortCode":"BU"},{"name":"Al Jabal al Akhḑar","shortCode":"JA"},{"name":"Al Jabal al Gharbī","shortCode":"JG"},{"name":"Al Jafārah","shortCode":"JA"},{"name":"Al Jufrah","shortCode":"JU"},{"name":"Al Kufrah","shortCode":"FK"},{"name":"Al Marj","shortCode":"MJ"},{"name":"Al Marquab","shortCode":"MB"},{"name":"Al Wāḩāt","shortCode":"WA"},{"name":"An Nuqaţ al Khams","shortCode":"NQ"},{"name":"Az Zāwiyah","shortCode":"ZA"},{"name":"Banghāzī","shortCode":"BA"},{"name":"Darnah","shortCode":"DR"},{"name":"Ghāt","shortCode":"GH"},{"name":"Mişrātah","shortCode":"MI"},{"name":"Murzuq","shortCode":"MQ"},{"name":"Nālūt","shortCode":"NL"},{"name":"Sabhā","shortCode":"SB"},{"name":"Surt","shortCode":"SR"},{"name":"Ţarābulus","shortCode":"TB"},{"name":"Yafran","shortCode":"WD"},{"name":"Wādī ash Shāţiʾ","shortCode":"WS"}]},{"countryName":"Liechtenstein","countryShortCode":"LI","regions":[{"name":"Balzers","shortCode":"01"},{"name":"Eschen","shortCode":"02"},{"name":"Gamprin","shortCode":"03"},{"name":"Mauren","shortCode":"04"},{"name":"Planken","shortCode":"05"},{"name":"Ruggell","shortCode":"06"},{"name":"Schaan","shortCode":"07"},{"name":"Schellenberg","shortCode":"08"},{"name":"Triesen","shortCode":"09"},{"name":"Triesenberg","shortCode":"10"},{"name":"Vaduz","shortCode":"11"}]},{"countryName":"Lithuania","countryShortCode":"LT","regions":[{"name":"Alytaus","shortCode":"AL"},{"name":"Kauno","shortCode":"KU"},{"name":"Klaipėdos","shortCode":"KL"},{"name":"Marijampolės","shortCode":"MR"},{"name":"Panevėžio","shortCode":"PN"},{"name":"Šiaulių","shortCode":"SA"},{"name":"Tauragės","shortCode":"TA"},{"name":"Telšių","shortCode":"TE"},{"name":"Utenos","shortCode":"UT"},{"name":"Vilniaus","shortCode":"VL"}]},{"countryName":"Luxembourg","countryShortCode":"LU","regions":[{"name":"Capellen","shortCode":"CA"},{"name":"Clevaux","shortCode":"CL"},{"name":"Diekirch","shortCode":"DI"},{"name":"Echternach","shortCode":"EC"},{"name":"Esch-sur-Alzette","shortCode":"ES"},{"name":"Grevenmacher","shortCode":"GR"},{"name":"Luxembourg","shortCode":"LU"},{"name":"Mersch","shortCode":"ME"},{"name":"Redange","shortCode":"RD"},{"name":"Remich","shortCode":"RM"},{"name":"Vianden","shortCode":"VD"},{"name":"Wiltz","shortCode":"WI"}]},{"countryName":"Macao","countryShortCode":"MO","regions":[{"name":"Macao"}]},{"countryName":"Macedonia, Republic of","countryShortCode":"MK","regions":[{"name":"Aračinovo","shortCode":"02"},{"name":"Berovo","shortCode":"03"},{"name":"Bitola","shortCode":"04"},{"name":"Bogdanci","shortCode":"05"},{"name":"Bogovinje","shortCode":"06"},{"name":"Bosilovo","shortCode":"07"},{"name":"Brvenica","shortCode":"08"},{"name":"Centar Župa","shortCode":"78"},{"name":"Čaška","shortCode":"08"},{"name":"Češinovo-Obleševo","shortCode":"81"},{"name":"Čučer Sandevo","shortCode":"82"},{"name":"Debar","shortCode":"21"},{"name":"Debarca","shortCode":"22"},{"name":"Delčevo","shortCode":"23"},{"name":"Demir Hisar","shortCode":"25"},{"name":"Demir Kapija","shortCode":"24"},{"name":"Doran","shortCode":"26"},{"name":"Dolneni","shortCode":"27"},{"name":"Gevgelija","shortCode":"18"},{"name":"Gostivar","shortCode":"19"},{"name":"Gradsko","shortCode":"20"},{"name":"Ilinden","shortCode":"34"},{"name":"Jegunovce","shortCode":"35"},{"name":"Karbinci","shortCode":"37"},{"name":"Kavadarci","shortCode":"36"},{"name":"Kičevo","shortCode":"40"},{"name":"Kočani","shortCode":"42"},{"name":"Konče","shortCode":"41"},{"name":"Kratovo","shortCode":"43"},{"name":"Kriva Palanka","shortCode":"44"},{"name":"Krivogaštani","shortCode":"45"},{"name":"Kruševo","shortCode":"46"},{"name":"Kumanovo","shortCode":"47"},{"name":"Lipkovo","shortCode":"48"},{"name":"Lozovo","shortCode":"49"},{"name":"Makedonska Kamenica","shortCode":"51"},{"name":"Makedonski Brod","shortCode":"52"},{"name":"Mavrovo i Rostuša","shortCode":"50"},{"name":"Mogila","shortCode":"53"},{"name":"Negotino","shortCode":"54"},{"name":"Novaci","shortCode":"55"},{"name":"Novo Selo","shortCode":"56"},{"name":"Ohrid","shortCode":"58"},{"name":"Pehčevo","shortCode":"60"},{"name":"Petrovec","shortCode":"59"},{"name":"Plasnica","shortCode":"61"},{"name":"Prilep","shortCode":"62"},{"name":"Probištip","shortCode":"63"},{"name":"Radoviš","shortCode":""},{"name":"Rankovce","shortCode":"65"},{"name":"Resen","shortCode":"66"},{"name":"Rosoman","shortCode":"67"},{"name":"Skopje","shortCode":"85"},{"name":"Sopište","shortCode":"70"},{"name":"Staro Nagoričane","shortCode":"71"},{"name":"Struga","shortCode":"72"},{"name":"Strumica","shortCode":"73"},{"name":"Studeničani","shortCode":"74"},{"name":"Sveti Nikole","shortCode":"69"},{"name":"Štip","shortCode":"83"},{"name":"Tearce","shortCode":"75"},{"name":"Tetovo","shortCode":"76"},{"name":"Valandovo","shortCode":"10"},{"name":"Vasilevo","shortCode":"11"},{"name":"Veles","shortCode":"13"},{"name":"Vevčani","shortCode":"12"},{"name":"Vinica","shortCode":"14"},{"name":"Vrapčište","shortCode":"16"},{"name":"Zelenikovo","shortCode":"32"},{"name":"Zrnovci","shortCode":"33"},{"name":"Želino","shortCode":"30"}]},{"countryName":"Madagascar","countryShortCode":"MG","regions":[{"name":"Antananarivo","shortCode":"T"},{"name":"Antsiranana","shortCode":"D"},{"name":"Fianarantsoa","shortCode":"F"},{"name":"Mahajanga","shortCode":"M"},{"name":"Toamasina","shortCode":"A"},{"name":"Toliara","shortCode":"U"}]},{"countryName":"Malawi","countryShortCode":"MW","regions":[{"name":"Balaka","shortCode":"BA"},{"name":"Blantyre","shortCode":"BL"},{"name":"Chikwawa","shortCode":"CK"},{"name":"Chiradzulu","shortCode":"CR"},{"name":"Chitipa","shortCode":"CT"},{"name":"Dedza","shortCode":"DE"},{"name":"Dowa","shortCode":"DO"},{"name":"Karonga","shortCode":"KR"},{"name":"Kasungu","shortCode":"KS"},{"name":"Likoma","shortCode":"LK"},{"name":"Lilongwe","shortCode":"LI"},{"name":"Machinga","shortCode":"MH"},{"name":"Mangochi","shortCode":"MG"},{"name":"Mchinji","shortCode":"MC"},{"name":"Mulanje","shortCode":"MU"},{"name":"Mwanza","shortCode":"MW"},{"name":"Mzimba","shortCode":"MZ"},{"name":"Nkhata Bay","shortCode":"NE"},{"name":"Nkhotakota","shortCode":"NB"},{"name":"Nsanje","shortCode":"NS"},{"name":"Ntcheu","shortCode":"NU"},{"name":"Ntchisi","shortCode":"NI"},{"name":"Phalombe","shortCode":"PH"},{"name":"Rumphi","shortCode":"RU"},{"name":"Salima","shortCode":"SA"},{"name":"Thyolo","shortCode":"TH"},{"name":"Zomba","shortCode":"ZO"}]},{"countryName":"Malaysia","countryShortCode":"MY","regions":[{"name":"Johor","shortCode":"01"},{"name":"Kedah","shortCode":"02"},{"name":"Kelantan","shortCode":"03"},{"name":"Melaka","shortCode":"04"},{"name":"Negeri Sembilan","shortCode":"05"},{"name":"Pahang","shortCode":"06"},{"name":"Perak","shortCode":"08"},{"name":"Perlis","shortCode":"09"},{"name":"Pulau Pinang","shortCode":"07"},{"name":"Sabah","shortCode":"12"},{"name":"Sarawak","shortCode":"13"},{"name":"Selangor","shortCode":"10"},{"name":"Terengganu","shortCode":"11"},{"name":"Wilayah Persekutuan (Kuala Lumpur)","shortCode":"14"},{"name":"Wilayah Persekutuan (Labuan)","shortCode":"15"},{"name":"Wilayah Persekutuan (Putrajaya)","shortCode":"16"}]},{"countryName":"Maldives","countryShortCode":"MV","regions":[{"name":"Alifu Alifu","shortCode":"02"},{"name":"Alifu Dhaalu","shortCode":"00"},{"name":"Baa","shortCode":"20"},{"name":"Dhaalu","shortCode":"17"},{"name":"Faafu","shortCode":"14"},{"name":"Gaafu Alifu","shortCode":"27"},{"name":"Gaafu Dhaalu","shortCode":"28"},{"name":"Gnaviyani","shortCode":"29"},{"name":"Haa Alifu","shortCode":"07"},{"name":"Haa Dhaalu","shortCode":"23"},{"name":"Kaafu","shortCode":"29"},{"name":"Laamu","shortCode":"05"},{"name":"Lhaviyani","shortCode":"03"},{"name":"Malé","shortCode":"MLE"},{"name":"Meemu","shortCode":"12"},{"name":"Noonu","shortCode":"25"},{"name":"Raa","shortCode":"13"},{"name":"Seenu","shortCode":"01"},{"name":"Shaviyani","shortCode":"24"},{"name":"Thaa","shortCode":"08"},{"name":"Vaavu","shortCode":"04"}]},{"countryName":"Mali","countryShortCode":"ML","regions":[{"name":"Bamako","shortCode":"BKO"},{"name":"Gao","shortCode":"7"},{"name":"Kayes","shortCode":"1"},{"name":"Kidal","shortCode":"8"},{"name":"Koulikoro","shortCode":"2"},{"name":"Mopti","shortCode":"5"},{"name":"Segou","shortCode":"4"},{"name":"Sikasso","shortCode":"3"},{"name":"Tombouctou","shortCode":"6"}]},{"countryName":"Malta","countryShortCode":"MT","regions":[{"name":"Attard","shortCode":"01"},{"name":"Balzan","shortCode":"02"},{"name":"Birgu","shortCode":"03"},{"name":"Birkirkara","shortCode":"04"},{"name":"Birżebbuġa","shortCode":"05"},{"name":"Bormla","shortCode":"06"},{"name":"Dingli","shortCode":"07"},{"name":"Fgura","shortCode":"08"},{"name":"Floriana","shortCode":"09"},{"name":"Fontana","shortCode":"10"},{"name":"Guda","shortCode":"11"},{"name":"Gżira","shortCode":"12"},{"name":"Għajnsielem","shortCode":"13"},{"name":"Għarb","shortCode":"14"},{"name":"Għargħur","shortCode":"15"},{"name":"Għasri","shortCode":"16"},{"name":"Għaxaq","shortCode":"17"},{"name":"Ħamrun","shortCode":"18"},{"name":"Iklin","shortCode":"19"},{"name":"Isla","shortCode":"20"},{"name":"Kalkara","shortCode":"21"},{"name":"Kerċem","shortCode":"22"},{"name":"Kirkop","shortCode":"23"},{"name":"Lija","shortCode":"24"},{"name":"Luqa","shortCode":"25"},{"name":"Marsa","shortCode":"26"},{"name":"Marsaskala","shortCode":"27"},{"name":"Marsaxlokk","shortCode":"28"},{"name":"Mdina","shortCode":"29"},{"name":"Mellieħa","shortCode":"30"},{"name":"Mġarr","shortCode":"31"},{"name":"Mosta","shortCode":"32"},{"name":"Mqabba","shortCode":"33"},{"name":"Msida","shortCode":"34"},{"name":"Mtarfa","shortCode":"35"},{"name":"Munxar","shortCode":"36"},{"name":"Nadur","shortCode":"37"},{"name":"Naxxar","shortCode":"38"},{"name":"Paola","shortCode":"39"},{"name":"Pembroke","shortCode":"40"},{"name":"Pietà","shortCode":"41"},{"name":"Qala","shortCode":"42"},{"name":"Qormi","shortCode":"43"},{"name":"Qrendi","shortCode":"44"},{"name":"Rabat Għawdex","shortCode":"45"},{"name":"Rabat Malta","shortCode":"46"},{"name":"Safi","shortCode":"47"},{"name":"San Ġiljan","shortCode":"48"},{"name":"San Ġwann","shortCode":"49"},{"name":"San Lawrenz","shortCode":"50"},{"name":"San Pawl il-Baħar","shortCode":"51"},{"name":"Sannat","shortCode":"52"},{"name":"Santa Luċija","shortCode":"53"},{"name":"Santa Venera","shortCode":"54"},{"name":"Siġġiewi","shortCode":"55"},{"name":"Sliema","shortCode":"56"},{"name":"Swieqi","shortCode":"57"},{"name":"Tai Xbiex","shortCode":"58"},{"name":"Tarzien","shortCode":"59"},{"name":"Valletta","shortCode":"60"},{"name":"Xagħra","shortCode":"61"},{"name":"Xewkija","shortCode":"62"},{"name":"Xgħajra","shortCode":"63"},{"name":"Żabbar","shortCode":"64"},{"name":"Żebbuġ Għawde","shortCode":"65"},{"name":"Żebbuġ Malta","shortCode":"66"},{"name":"Żejtun","shortCode":"67"},{"name":"Żurrieq","shortCode":"68"}]},{"countryName":"Marshall Islands","countryShortCode":"MH","regions":[{"name":"Ailinglaplap","shortCode":"ALL"},{"name":"Ailuk","shortCode":"ALK"},{"name":"Arno","shortCode":"ARN"},{"name":"Aur","shortCode":"AUR"},{"name":"Bikini and Kili","shortCode":"KIL"},{"name":"Ebon","shortCode":"EBO"},{"name":"Jabat","shortCode":"JAB"},{"name":"Jaluit","shortCode":"JAL"},{"name":"Kwajalein","shortCode":"KWA"},{"name":"Lae","shortCode":"LAE"},{"name":"Lib","shortCode":"LIB"},{"name":"Likiep","shortCode":"LIK"},{"name":"Majuro","shortCode":"MAJ"},{"name":"Maloelap","shortCode":"MAL"},{"name":"Mejit","shortCode":"MEJ"},{"name":"Namdrik","shortCode":"NMK"},{"name":"Namu","shortCode":"NMU"},{"name":"Rongelap","shortCode":"RON"},{"name":"Ujae","shortCode":"UJA"},{"name":"Utrik","shortCode":"UTI"},{"name":"Wotho","shortCode":"WTH"},{"name":"Wotje","shortCode":"WTJ"}]},{"countryName":"Martinique","countryShortCode":"MQ","regions":[{"name":"Martinique"}]},{"countryName":"Mauritania","countryShortCode":"MR","regions":[{"name":"Adrar","shortCode":"07"},{"name":"Assaba","shortCode":"03"},{"name":"Brakna","shortCode":"05"},{"name":"Dakhlet Nouadhibou","shortCode":"08"},{"name":"Gorgol","shortCode":"04"},{"name":"Guidimaka","shortCode":"10"},{"name":"Hodh Ech Chargui","shortCode":"01"},{"name":"Hodh El Gharbi","shortCode":"02"},{"name":"Inchiri","shortCode":"12"},{"name":"Nouakchott Nord","shortCode":"14"},{"name":"Nouakchott Ouest","shortCode":"13"},{"name":"Nouakchott Sud","shortCode":"15"},{"name":"Tagant","shortCode":"09"},{"name":"Tiris Zemmour","shortCode":"11"},{"name":"Trarza","shortCode":"06"}]},{"countryName":"Mauritius","countryShortCode":"MU","regions":[{"name":"Agalega Islands","shortCode":"AG"},{"name":"Beau Bassin-Rose Hill","shortCode":"BR"},{"name":"Black River","shortCode":"BL"},{"name":"Cargados Carajos Shoals","shortCode":"CC"},{"name":"Curepipe","shortCode":"CU"},{"name":"Flacq","shortCode":"FL"},{"name":"Grand Port","shortCode":"GP"},{"name":"Moka","shortCode":"MO"},{"name":"Pamplemousses","shortCode":"PA"},{"name":"Plaines Wilhems","shortCode":"PW"},{"name":"Port Louis (City)","shortCode":"PU"},{"name":"Port Louis","shortCode":"PL"},{"name":"Riviere du Rempart","shortCode":"RR"},{"name":"Rodrigues Island","shortCode":"RO"},{"name":"Savanne","shortCode":"SA"},{"name":"Vacoas-Phoenix","shortCode":"CP"}]},{"countryName":"Mayotte","countryShortCode":"YT","regions":[{"name":"Dzaoudzi","shortCode":"01"},{"name":"Pamandzi","shortCode":"02"},{"name":"Mamoudzou","shortCode":"03"},{"name":"Dembeni","shortCode":"04"},{"name":"Bandrélé","shortCode":"05"},{"name":"Kani-Kéli","shortCode":"06"},{"name":"Bouéni","shortCode":"07"},{"name":"Chirongui","shortCode":"08"},{"name":"Sada","shortCode":"09"},{"name":"Ouangani","shortCode":"10"},{"name":"Chiconi","shortCode":"11"},{"name":"Tsingoni","shortCode":"12"},{"name":"M'Tsangamouji","shortCode":"13"},{"name":"Acoua","shortCode":"14"},{"name":"Mtsamboro","shortCode":"15"},{"name":"Bandraboua","shortCode":"16"},{"name":"Koungou","shortCode":"17"}]},{"countryName":"Mexico","countryShortCode":"MX","regions":[{"name":"Aguascalientes","shortCode":"AGU"},{"name":"Baja California","shortCode":"BCN"},{"name":"Baja California Sur","shortCode":"BCS"},{"name":"Campeche","shortCode":"CAM"},{"name":"Ciudad de México","shortCode":"DIF"},{"name":"Chiapas","shortCode":"CHP"},{"name":"Chihuahua","shortCode":"CHH"},{"name":"Coahuila de Zaragoza","shortCode":"COA"},{"name":"Colima","shortCode":"COL"},{"name":"Durango","shortCode":"DUR"},{"name":"Estado de México","shortCode":"MEX"},{"name":"Guanajuato","shortCode":"GUA"},{"name":"Guerrero","shortCode":"GRO"},{"name":"Hidalgo","shortCode":"HID"},{"name":"Jalisco","shortCode":"JAL"},{"name":"Michoacán de Ocampo","shortCode":"MIC"},{"name":"Morelos","shortCode":"MOR"},{"name":"Nayarit","shortCode":"NAY"},{"name":"Nuevo León","shortCode":"NLE"},{"name":"Oaxaca","shortCode":"OAX"},{"name":"Puebla","shortCode":"PUE"},{"name":"Querétaro de Arteaga","shortCode":"QUE"},{"name":"Quintana Roo","shortCode":"ROO"},{"name":"San Luis Potosí","shortCode":"SLP"},{"name":"Sinaloa","shortCode":"SIN"},{"name":"Sonora","shortCode":"SON"},{"name":"Tabasco","shortCode":"TAB"},{"name":"Tamaulipas","shortCode":"TAM"},{"name":"Tlaxcala","shortCode":"TLA"},{"name":"Veracruz","shortCode":"VER"},{"name":"Yucatán","shortCode":"YUC"},{"name":"Zacatecas","shortCode":"ZAC"}]},{"countryName":"Micronesia, Federated States of","countryShortCode":"FM","regions":[{"name":"Chuuk (Truk)","shortCode":"TRK"},{"name":"Kosrae","shortCode":"KSA"},{"name":"Pohnpei","shortCode":"PNI"},{"name":"Yap","shortCode":"YAP"}]},{"countryName":"Moldova","countryShortCode":"MD","regions":[{"name":"Aenii Noi","shortCode":"AN"},{"name":"Basarabeasca","shortCode":"BS"},{"name":"Bălți","shortCode":"BA"},{"name":"Bender","shortCode":"BD"},{"name":"Briceni","shortCode":"BR"},{"name":"Cahul","shortCode":"CA"},{"name":"Cantemir","shortCode":"CT"},{"name":"Călărași","shortCode":"CL"},{"name":"Căușeni","shortCode":"CS"},{"name":"Chișinău","shortCode":"CU"},{"name":"Cimișlia","shortCode":"CM"},{"name":"Criuleni","shortCode":"CR"},{"name":"Dondușeni","shortCode":"DO"},{"name":"Drochia","shortCode":"DR"},{"name":"Dubăsari","shortCode":"DU"},{"name":"Edineț","shortCode":"ED"},{"name":"Fălești","shortCode":"FA"},{"name":"Florești","shortCode":"FL"},{"name":"Găgăuzia","shortCode":"GA"},{"name":"Glodeni","shortCode":"GL"},{"name":"Hîncești","shortCode":"HI"},{"name":"Ialoveni","shortCode":"IA"},{"name":"Leova","shortCode":"LE"},{"name":"Nisporeni","shortCode":"NI"},{"name":"Ocnița","shortCode":"OC"},{"name":"Orhei","shortCode":"OR"},{"name":"Rezina","shortCode":"RE"},{"name":"Rîșcani","shortCode":"RI"},{"name":"Sîngerei","shortCode":"SI"},{"name":"Soroca","shortCode":"SO"},{"name":"Stînga Nistrului","shortCode":"SN"},{"name":"Strășeni","shortCode":"ST"},{"name":"Șoldănești","shortCode":"SD"},{"name":"Ștefan Vodă","shortCode":"SV"},{"name":"Taraclia","shortCode":"TA"},{"name":"Telenești","shortCode":"TE"},{"name":"Ungheni","shortCode":"UN"}]},{"countryName":"Monaco","countryShortCode":"MC","regions":[{"name":"Colle","shortCode":"CL"},{"name":"Condamine","shortCode":"CO"},{"name":"Fontvieille","shortCode":"FO"},{"name":"Gare","shortCode":"GA"},{"name":"Jardin Exotique","shortCode":"JE"},{"name":"Larvotto","shortCode":"LA"},{"name":"Malbousquet","shortCode":"MA"},{"name":"Monaco-Ville","shortCode":"MO"},{"name":"Moneghetti","shortCode":"MG"},{"name":"Monte-Carlo","shortCode":"MC"},{"name":"Moulins","shortCode":"MU"},{"name":"Port-Hercule","shortCode":"PH"},{"name":"Saint-Roman","shortCode":"SR"},{"name":"Sainte-Dévote","shortCode":"SD"},{"name":"Source","shortCode":"SO"},{"name":"Spélugues","shortCode":"SP"},{"name":"Vallon de la Rousse","shortCode":"VR"}]},{"countryName":"Mongolia","countryShortCode":"MN","regions":[{"name":"Arhangay","shortCode":"073"},{"name":"Bayan-Olgiy","shortCode":"071"},{"name":"Bayanhongor","shortCode":"069"},{"name":"Bulgan","shortCode":"067"},{"name":"Darhan","shortCode":"037"},{"name":"Dornod","shortCode":"061"},{"name":"Dornogovi","shortCode":"063"},{"name":"Dundgovi","shortCode":"059"},{"name":"Dzavhan","shortCode":"065"},{"name":"Govi-Altay","shortCode":"065"},{"name":"Govi-Sumber","shortCode":"064"},{"name":"Hovd","shortCode":"043"},{"name":"Hovsgol","shortCode":"041"},{"name":"Omnogovi","shortCode":"053"},{"name":"Ovorhangay","shortCode":"055"},{"name":"Selenge","shortCode":"049"},{"name":"Suhbaatar","shortCode":"051"},{"name":"Tov","shortCode":"047"},{"name":"Ulaanbaatar","shortCode":"1"},{"name":"Uvs","shortCode":"046"}]},{"countryName":"Montenegro","countryShortCode":"ME","regions":[{"name":"Andrijevica","shortCode":"01"},{"name":"Bar","shortCode":"02"},{"name":"Berane","shortCode":"03"},{"name":"Bijelo Polje","shortCode":"04"},{"name":"Budva","shortCode":"05"},{"name":"Cetinje","shortCode":"06"},{"name":"Danilovgrad","shortCode":"07"},{"name":"Gusinje","shortCode":"22"},{"name":"Herceg Novi","shortCode":"08"},{"name":"Kolašin","shortCode":"09"},{"name":"Kotor","shortCode":"10"},{"name":"Mojkovac","shortCode":"11"},{"name":"Nikšić","shortCode":"12"},{"name":"Petnica","shortCode":"23"},{"name":"Plav","shortCode":"13"},{"name":"Plužine","shortCode":"14"},{"name":"Pljevlja","shortCode":"15"},{"name":"Podgorica","shortCode":"16"},{"name":"Rožaje","shortCode":"17"},{"name":"Šavnik","shortCode":"18"},{"name":"Tivat","shortCode":"19"},{"name":"Ulcinj","shortCode":"20"},{"name":"Žabljak","shortCode":"21"}]},{"countryName":"Montserrat","countryShortCode":"MS","regions":[{"name":"Saint Anthony"},{"name":"Saint Georges"},{"name":"Saint Peter's"}]},{"countryName":"Morocco","countryShortCode":"MA","regions":[{"name":"Chaouia-Ouardigha","shortCode":"09"},{"name":"Doukhala-Abda","shortCode":"10"},{"name":"Fès-Boulemane","shortCode":"05"},{"name":"Gharb-Chrarda-Beni Hssen","shortCode":"02"},{"name":"Grand Casablanca","shortCode":"08"},{"name":"Guelmim-Es Semara","shortCode":"14"},{"name":"Laâyoune-Boujdour-Sakia el Hamra","shortCode":"15"},{"name":"Marrakech-Tensift-Al Haouz","shortCode":"11"},{"name":"Meknès-Tafilalet","shortCode":"06"},{"name":"Oriental","shortCode":"04"},{"name":"Oued ed Dahab-Lagouira","shortCode":"16"},{"name":"Souss-Massa-Drâa","shortCode":"13"},{"name":"Tadla-Azilal","shortCode":"12"},{"name":"Tanger-Tétouan","shortCode":"01"},{"name":"Taza-Al Hoceima-Taounate","shortCode":"03"}]},{"countryName":"Mozambique","countryShortCode":"MZ","regions":[{"name":"Cabo Delgado","shortCode":"P"},{"name":"Gaza","shortCode":"G"},{"name":"Inhambane","shortCode":"I"},{"name":"Manica","shortCode":"B"},{"name":"Maputo","shortCode":"L"},{"name":"Maputo (City)","shortCode":"MPM"},{"name":"Nampula","shortCode":"N"},{"name":"Niassa","shortCode":"A"},{"name":"Sofala","shortCode":"S"},{"name":"Tete","shortCode":"T"},{"name":"Zambezia","shortCode":"Q"}]},{"countryName":"Myanmar","countryShortCode":"MM","regions":[{"name":"Ayeyarwady","shortCode":"07"},{"name":"Bago","shortCode":"02"},{"name":"Chin","shortCode":"14"},{"name":"Kachin","shortCode":"11"},{"name":"Kayah","shortCode":"12"},{"name":"Kayin","shortCode":"13"},{"name":"Magway","shortCode":"03"},{"name":"Mandalay","shortCode":"04"},{"name":"Mon","shortCode":"15"},{"name":"Nay Pyi Taw","shortCode":"18"},{"name":"Rakhine","shortCode":"16"},{"name":"Sagaing","shortCode":"01"},{"name":"Shan","shortCode":"17"},{"name":"Tanintharyi","shortCode":"05"},{"name":"Yangon","shortCode":"06"}]},{"countryName":"Namibia","countryShortCode":"NA","regions":[{"name":"Erongo","shortCode":"ER"},{"name":"Hardap","shortCode":"HA"},{"name":"Kavango East","shortCode":"KE"},{"name":"Kavango West","shortCode":"KW"},{"name":"Karas","shortCode":"KA"},{"name":"Khomas","shortCode":"KH"},{"name":"Kunene","shortCode":"KU"},{"name":"Ohangwena","shortCode":"OW"},{"name":"Omaheke","shortCode":"OH"},{"name":"Omusati","shortCode":"OS"},{"name":"Oshana","shortCode":"ON"},{"name":"Oshikoto","shortCode":"OT"},{"name":"Otjozondjupa","shortCode":"OD"},{"name":"Zambezi","shortCode":"CA"}]},{"countryName":"Nauru","countryShortCode":"NR","regions":[{"name":"Aiwo","shortCode":"01"},{"name":"Anabar","shortCode":"02"},{"name":"Anetan","shortCode":"03"},{"name":"Anibare","shortCode":"04"},{"name":"Baiti","shortCode":"05"},{"name":"Boe","shortCode":"06"},{"name":"Buada","shortCode":"07"},{"name":"Denigomodu","shortCode":"08"},{"name":"Ewa","shortCode":"09"},{"name":"Ijuw","shortCode":"10"},{"name":"Meneng","shortCode":"11"},{"name":"Nibok","shortCode":"12"},{"name":"Uaboe","shortCode":"13"},{"name":"Yaren","shortCode":"14"}]},{"countryName":"Nepal","countryShortCode":"NP","regions":[{"name":"Bagmati","shortCode":"BA"},{"name":"Bheri","shortCode":"BH"},{"name":"Dhawalagiri","shortCode":"DH"},{"name":"Gandaki","shortCode":"GA"},{"name":"Janakpur","shortCode":"JA"},{"name":"Karnali","shortCode":"KA"},{"name":"Kosi","shortCode":"KO"},{"name":"Lumbini","shortCode":"LU"},{"name":"Mahakali","shortCode":"MA"},{"name":"Mechi","shortCode":"ME"},{"name":"Narayani","shortCode":"NA"},{"name":"Rapti","shortCode":"RA"},{"name":"Sagarmatha","shortCode":"SA"},{"name":"Seti","shortCode":"SE"}]},{"countryName":"Netherlands","countryShortCode":"NL","regions":[{"name":"Drenthe","shortCode":"DR"},{"name":"Flevoland","shortCode":"FL"},{"name":"Friesland","shortCode":"FR"},{"name":"Gelderland","shortCode":"GE"},{"name":"Groningen","shortCode":"GR"},{"name":"Limburg","shortCode":"LI"},{"name":"Noord-Brabant","shortCode":"NB"},{"name":"Noord-Holland","shortCode":"NH"},{"name":"Overijssel","shortCode":"OV"},{"name":"Utrecht","shortCode":"UT"},{"name":"Zeeland","shortCode":"ZE"},{"name":"Zuid-Holland","shortCode":"ZH"}]},{"countryName":"New Caledonia","countryShortCode":"NC","regions":[{"name":"Iles Loyaute"},{"name":"Nord"},{"name":"Sud"}]},{"countryName":"New Zealand","countryShortCode":"NZ","regions":[{"name":"Auckland","shortCode":"AUK"},{"name":"Bay of Plenty","shortCode":"BOP"},{"name":"Canterbury","shortCode":"CAN"},{"name":"Gisborne","shortCode":"GIS"},{"name":"Hawke's Bay","shortCode":"HKB"},{"name":"Marlborough","shortCode":"MBH"},{"name":"Manawatu-Wanganui","shortCode":"MWT"},{"name":"Northland","shortCode":"NTL"},{"name":"Nelson","shortCode":"NSN"},{"name":"Otago","shortCode":"OTA"},{"name":"Southland","shortCode":"STL"},{"name":"Taranaki","shortCode":"TKI"},{"name":"Tasman","shortCode":"TAS"},{"name":"Waikato","shortCode":"WKO"},{"name":"Wellington","shortCode":"WGN"},{"name":"West Coast","shortCode":"WTC"},{"name":"Chatham Islands Territory","shortCode":"CIT"}]},{"countryName":"Nicaragua","countryShortCode":"NI","regions":[{"name":"Boaco","shortCode":"BO"},{"name":"Carazo","shortCode":"CA"},{"name":"Chinandega","shortCode":"CI"},{"name":"Chontales","shortCode":"CO"},{"name":"Estelí","shortCode":"ES"},{"name":"Granada","shortCode":"GR"},{"name":"Jinotega","shortCode":"JI"},{"name":"León","shortCode":"LE"},{"name":"Madriz","shortCode":"MD"},{"name":"Managua","shortCode":"MN"},{"name":"Masaya","shortCode":"MS"},{"name":"Matagalpa","shortCode":"MT"},{"name":"Nueva Segovia","shortCode":"NS"},{"name":"Río San Juan","shortCode":"SJ"},{"name":"Rivas","shortCode":"RI"},{"name":"Atlántico Norte","shortCode":"AN"},{"name":"Atlántico Sur","shortCode":"AS"}]},{"countryName":"Niger","countryShortCode":"NE","regions":[{"name":"Agadez","shortCode":"1"},{"name":"Diffa","shortCode":"2"},{"name":"Dosso","shortCode":"3"},{"name":"Maradi","shortCode":"4"},{"name":"Niamey","shortCode":"8"},{"name":"Tahoua","shortCode":"5"},{"name":"Tillabéri","shortCode":"6"},{"name":"Zinder","shortCode":"7"}]},{"countryName":"Nigeria","countryShortCode":"NG","regions":[{"name":"Abia","shortCode":"AB"},{"name":"Abuja Federal Capital Territory","shortCode":"FC"},{"name":"Adamawa","shortCode":"AD"},{"name":"Akwa Ibom","shortCode":"AK"},{"name":"Anambra","shortCode":"AN"},{"name":"Bauchi","shortCode":"BA"},{"name":"Bayelsa","shortCode":"BY"},{"name":"Benue","shortCode":"BE"},{"name":"Borno","shortCode":"BO"},{"name":"Cross River","shortCode":"CR"},{"name":"Delta","shortCode":"DE"},{"name":"Ebonyi","shortCode":"EB"},{"name":"Edo","shortCode":"ED"},{"name":"Ekiti","shortCode":"EK"},{"name":"Enugu","shortCode":"EN"},{"name":"Gombe","shortCode":"GO"},{"name":"Imo","shortCode":"IM"},{"name":"Jigawa","shortCode":"JI"},{"name":"Kaduna","shortCode":"KD"},{"name":"Kano","shortCode":"KN"},{"name":"Katsina","shortCode":"KT"},{"name":"Kebbi","shortCode":"KE"},{"name":"Kogi","shortCode":"KO"},{"name":"Kwara","shortCode":"KW"},{"name":"Lagos","shortCode":"LA"},{"name":"Nassarawa","shortCode":"NA"},{"name":"Niger","shortCode":"NI"},{"name":"Ogun","shortCode":"OG"},{"name":"Ondo","shortCode":"ON"},{"name":"Osun","shortCode":"OS"},{"name":"Oyo","shortCode":"OY"},{"name":"Plateau","shortCode":"PL"},{"name":"Rivers","shortCode":"RI"},{"name":"Sokoto","shortCode":"SO"},{"name":"Taraba","shortCode":"TA"},{"name":"Yobe","shortCode":"YO"},{"name":"Zamfara","shortCode":"ZA"}]},{"countryName":"Niue","countryShortCode":"NU","regions":[{"name":"Niue"}]},{"countryName":"Norfolk Island","countryShortCode":"NF","regions":[{"name":"Norfolk Island"}]},{"countryName":"Northern Mariana Islands","countryShortCode":"MP","regions":[{"name":"Northern Islands"},{"name":"Rota"},{"name":"Saipan"},{"name":"Tinian"}]},{"countryName":"Norway","countryShortCode":"NO","regions":[{"name":"Akershus","shortCode":"02"},{"name":"Aust-Agder","shortCode":"09"},{"name":"Buskerud","shortCode":"06"},{"name":"Finnmark","shortCode":"20"},{"name":"Hedmark","shortCode":"04"},{"name":"Hordaland","shortCode":"12"},{"name":"Møre og Romsdal","shortCode":"15"},{"name":"Nordland","shortCode":"18"},{"name":"Nord-Trøndelag","shortCode":"17"},{"name":"Oppland","shortCode":"05"},{"name":"Oslo","shortCode":"03"},{"name":"Rogaland","shortCode":"11"},{"name":"Sogn og Fjordane","shortCode":"14"},{"name":"Sør-Trøndelag","shortCode":"16"},{"name":"Telemark","shortCode":"08"},{"name":"Troms","shortCode":"19"},{"name":"Vest-Agder","shortCode":"10"},{"name":"Vestfold","shortCode":"07"},{"name":"Østfold","shortCode":"01"},{"name":"Jan Mayen","shortCode":"22"},{"name":"Svalbard","shortCode":"21"}]},{"countryName":"Oman","countryShortCode":"OM","regions":[{"name":"Ad Dakhiliyah","shortCode":"DA"},{"name":"Al Buraymi","shortCode":"BU"},{"name":"Al Wusta","shortCode":"WU"},{"name":"Az Zahirah","shortCode":"ZA"},{"name":"Janub al Batinah","shortCode":"BS"},{"name":"Janub ash Sharqiyah","shortCode":"SS"},{"name":"Masqat","shortCode":"MA"},{"name":"Musandam","shortCode":"MU"},{"name":"Shamal al Batinah","shortCode":"BJ"},{"name":"Shamal ash Sharqiyah","shortCode":"SJ"},{"name":"Zufar","shortCode":"ZU"}]},{"countryName":"Pakistan","countryShortCode":"PK","regions":[{"name":"Āzād Kashmīr","shortCode":"JK"},{"name":"Balōchistān","shortCode":"BA"},{"name":"Gilgit-Baltistān","shortCode":"GB"},{"name":"Islāmābād","shortCode":"IS"},{"name":"Khaībar Pakhtūnkhwās","shortCode":"KP"},{"name":"Punjāb","shortCode":"PB"},{"name":"Sindh","shortCode":"SD"},{"name":"Federally Administered Tribal Areas","shortCode":"TA"}]},{"countryName":"Palau","countryShortCode":"PW","regions":[{"name":"Aimeliik","shortCode":"002"},{"name":"Airai","shortCode":"004"},{"name":"Angaur","shortCode":"010"},{"name":"Hatobohei","shortCode":"050"},{"name":"Kayangel","shortCode":"100"},{"name":"Koror","shortCode":"150"},{"name":"Melekeok","shortCode":"212"},{"name":"Ngaraard","shortCode":"214"},{"name":"Ngarchelong","shortCode":"218"},{"name":"Ngardmau","shortCode":"222"},{"name":"Ngatpang","shortCode":"224"},{"name":"Ngchesar","shortCode":"226"},{"name":"Ngeremlengui","shortCode":"227"},{"name":"Ngiwal","shortCode":"228"},{"name":"Peleliu","shortCode":"350"},{"name":"Sonsoral","shortCode":"350"}]},{"countryName":"Palestine, State of","countryShortCode":"PS","regions":[{"name":"Ak Khalīl","shortCode":"HBN"},{"name":"Al Quds","shortCode":"JEM"},{"name":"Arīḩā wal Aghwār","shortCode":"JRH"},{"name":"Bayt Laḩm","shortCode":"BTH"},{"name":"Dayr al Balaḩ","shortCode":"DEB"},{"name":"Ghazzah","shortCode":"GZA"},{"name":"Janīn","shortCode":"JEN"},{"name":"Khān Yūnis","shortCode":"KYS"},{"name":"Nāblus","shortCode":"NBS"},{"name":"Qalqīyah","shortCode":"QQA"},{"name":"Rafaḩ","shortCode":"RFH"},{"name":"Rām Allāh wal Bīrah","shortCode":"RBH"},{"name":"Salfīt","shortCode":"SLT"},{"name":"Shamāl Ghazzah","shortCode":"NGZ"},{"name":"Ţūbās","shortCode":"TBS"},{"name":"Ţūlkarm","shortCode":"TKM"}]},{"countryName":"Panama","countryShortCode":"PA","regions":[{"name":"Bocas del Toro","shortCode":"1"},{"name":"Chiriquí","shortCode":"4"},{"name":"Coclé","shortCode":"2"},{"name":"Colón","shortCode":"3"},{"name":"Darién","shortCode":"5"},{"name":"Emberá","shortCode":"EM"},{"name":"Herrera","shortCode":"6"},{"name":"Kuna Yala","shortCode":"KY"},{"name":"Los Santos","shortCode":"7"},{"name":"Ngäbe-Buglé","shortCode":"NB"},{"name":"Panamá","shortCode":"8"},{"name":"Panamá Oeste","shortCode":"10"},{"name":"Veraguas","shortCode":"9"}]},{"countryName":"Papua New Guinea","countryShortCode":"PG","regions":[{"name":"Bougainville","shortCode":"NSB"},{"name":"Central","shortCode":"CPM"},{"name":"Chimbu","shortCode":"CPK"},{"name":"East New Britain","shortCode":"EBR"},{"name":"East Sepik","shortCode":"ESW"},{"name":"Eastern Highlands","shortCode":"EHG"},{"name":"Enga","shortCode":"EPW"},{"name":"Gulf","shortCode":"GPK"},{"name":"Hela","shortCode":"HLA"},{"name":"Jiwaka","shortCode":"JWK"},{"name":"Madang","shortCode":"MOM"},{"name":"Manus","shortCode":"MRL"},{"name":"Milne Bay","shortCode":"MBA"},{"name":"Morobe","shortCode":"MPL"},{"name":"Port Moresby","shortCode":"NCD"},{"name":"New Ireland","shortCode":"NIK"},{"name":"Northern","shortCode":"NPP"},{"name":"Southern Highlands","shortCode":"SHM"},{"name":"West New Britain","shortCode":"WBK"},{"name":"West Sepik","shortCode":"SAN"},{"name":"Western","shortCode":"WPD"},{"name":"Western Highlands","shortCode":"WHM"}]},{"countryName":"Paraguay","countryShortCode":"PY","regions":[{"name":"Alto Paraguay","shortCode":"16"},{"name":"Alto Parana","shortCode":"10"},{"name":"Amambay","shortCode":"13"},{"name":"Asuncion","shortCode":"ASU"},{"name":"Caaguazu","shortCode":"5"},{"name":"Caazapa","shortCode":"6"},{"name":"Canindeyu","shortCode":"14"},{"name":"Central","shortCode":"11"},{"name":"Concepcion","shortCode":"1"},{"name":"Cordillera","shortCode":"3"},{"name":"Guaira","shortCode":"4"},{"name":"Itapua","shortCode":"7"},{"name":"Misiones","shortCode":"8"},{"name":"Neembucu","shortCode":"12"},{"name":"Paraguari","shortCode":"9"},{"name":"Presidente Hayes","shortCode":"15"},{"name":"San Pedro","shortCode":"2"}]},{"countryName":"Peru","countryShortCode":"PE","regions":[{"name":"Amazonas","shortCode":"AMA"},{"name":"Ancash","shortCode":"ANC"},{"name":"Apurimac","shortCode":"APU"},{"name":"Arequipa","shortCode":"ARE"},{"name":"Ayacucho","shortCode":"AYA"},{"name":"Cajamarca","shortCode":"CAJ"},{"name":"Callao","shortCode":"CAL"},{"name":"Cusco","shortCode":"CUS"},{"name":"Huancavelica","shortCode":"HUV"},{"name":"Huanuco","shortCode":"HUC"},{"name":"Ica","shortCode":"ICA"},{"name":"Junin","shortCode":"JUN"},{"name":"La Libertad","shortCode":"LAL"},{"name":"Lambayeque","shortCode":"LAM"},{"name":"Lima","shortCode":"LIM"},{"name":"Loreto","shortCode":"LOR"},{"name":"Madre de Dios","shortCode":"MDD"},{"name":"Moquegua","shortCode":"MOQ"},{"name":"Municipalidad Metropolitana de Lima","shortCode":"LMA"},{"name":"Pasco","shortCode":"PAS"},{"name":"Piura","shortCode":"PIU"},{"name":"Puno","shortCode":"PUN"},{"name":"San Martin","shortCode":"SAM"},{"name":"Tacna","shortCode":"TAC"},{"name":"Tumbes","shortCode":"TUM"},{"name":"Ucayali","shortCode":"UCA"}]},{"countryName":"Philippines","countryShortCode":"PH","regions":[{"name":"Abra","shortCode":"ABR"},{"name":"Agusan del Norte","shortCode":"AGN"},{"name":"Agusan del Sur","shortCode":"AGS"},{"name":"Aklan","shortCode":"AKL"},{"name":"Albay","shortCode":"ALB"},{"name":"Antique","shortCode":"ANT"},{"name":"Apayao","shortCode":"APA"},{"name":"Aurora","shortCode":"AUR"},{"name":"Basilan","shortCode":"BAS"},{"name":"Bataan","shortCode":"BAN"},{"name":"Batanes","shortCode":"BTN"},{"name":"Batangas","shortCode":"BTG"},{"name":"Benguet","shortCode":"BEN"},{"name":"Biliran","shortCode":"BIL"},{"name":"Bohol","shortCode":"BOH"},{"name":"Bukidnon","shortCode":"BUK"},{"name":"Bulacan","shortCode":"BUL"},{"name":"Cagayan","shortCode":"CAG"},{"name":"Camarines Norte","shortCode":"CAN"},{"name":"Camarines Sur","shortCode":"CAS"},{"name":"Camiguin","shortCode":"CAM"},{"name":"Capiz","shortCode":"CAP"},{"name":"Catanduanes","shortCode":"CAT"},{"name":"Cavite","shortCode":"CAV"},{"name":"Cebu","shortCode":"CEB"},{"name":"Compostela","shortCode":"COM"},{"name":"Cotabato","shortCode":"NCO"},{"name":"Davao del Norte","shortCode":"DAV"},{"name":"Davao del Sur","shortCode":"DAS"},{"name":"Davao Occidental","shortCode":"DVO"},{"name":"Davao Oriental","shortCode":"DAO"},{"name":"Dinagat Islands","shortCode":"DIN"},{"name":"Eastern Samar","shortCode":"EAS"},{"name":"Guimaras","shortCode":"GUI"},{"name":"Ifugao","shortCode":"IFU"},{"name":"Ilocos Norte","shortCode":"ILN"},{"name":"Ilocos Sur","shortCode":"ILS"},{"name":"Iloilo","shortCode":"ILI"},{"name":"Isabela","shortCode":"ISA"},{"name":"Kalinga","shortCode":"KAL"},{"name":"La Union","shortCode":"LUN"},{"name":"Laguna","shortCode":"LAG"},{"name":"Lanao del Norte","shortCode":"LAN"},{"name":"Lanao del Sur","shortCode":"LAS"},{"name":"Leyte","shortCode":"LEY"},{"name":"Maguindanao","shortCode":"MAG"},{"name":"Masbate","shortCode":"MAS"},{"name":"Metro Manila","shortCode":"00"},{"name":"Mindoro Occidental","shortCode":"MDC"},{"name":"Mindoro Oriental","shortCode":"MDR"},{"name":"Misamis Occidental","shortCode":"MSC"},{"name":"Misamis Oriental","shortCode":"MSR"},{"name":"Mountain Province","shortCode":"MOU"},{"name":"Negros Occidental","shortCode":"NEC"},{"name":"Negros Oriental","shortCode":"NER"},{"name":"Northern Samar","shortCode":"NSA"},{"name":"Nueva Ecija","shortCode":"NUE"},{"name":"Nueva Vizcaya","shortCode":"NUV"},{"name":"Palawan","shortCode":"PLW"},{"name":"Pampanga","shortCode":"PAM"},{"name":"Pangasinan","shortCode":"PAN"},{"name":"Quezon","shortCode":"QUE"},{"name":"Quirino","shortCode":"QUI"},{"name":"Rizal","shortCode":"RIZ"},{"name":"Romblon","shortCode":"ROM"},{"name":"Samar","shortCode":"WSA"},{"name":"Sarangani","shortCode":"SAR"},{"name":"Siquijor","shortCode":"SIG"},{"name":"Sorsogon","shortCode":"SOR"},{"name":"Southern Leyte","shortCode":"SLE"},{"name":"Sultan Kudarat","shortCode":"AUK"},{"name":"Sulu","shortCode":"SLU"},{"name":"Surigao del Norte","shortCode":"SUN"},{"name":"Surigao del Sur","shortCode":"SUR"},{"name":"Tarlac","shortCode":"TAR"},{"name":"Tawi-Tawi","shortCode":"TAW"},{"name":"Zambales","shortCode":"ZMB"},{"name":"Zamboanga del Norte","shortCode":"ZAN"},{"name":"Zamboanga del Sur","shortCode":"ZAS"},{"name":"Zamboanga Sibugay","shortCode":"ZSI"}]},{"countryName":"Pitcairn","countryShortCode":"PN","regions":[{"name":"Pitcairn Islands"}]},{"countryName":"Poland","countryShortCode":"PL","regions":[{"name":"Dolnośląskie","shortCode":"DS"},{"name":"Kujawsko-pomorskie","shortCode":"KP"},{"name":"Łódzkie","shortCode":"LD"},{"name":"Lubelskie","shortCode":"LU"},{"name":"Lubuskie","shortCode":"LB"},{"name":"Malopolskie","shortCode":"MA"},{"name":"Mazowieckie","shortCode":"MZ"},{"name":"Opolskie","shortCode":"OP"},{"name":"Podkarpackie","shortCode":"PK"},{"name":"Podlaskie","shortCode":"PD"},{"name":"Pomorskie","shortCode":"PM"},{"name":"Śląskie","shortCode":"SL"},{"name":"Świętokrzyskie","shortCode":"SK"},{"name":"Warmińsko-mazurskie","shortCode":"WN"},{"name":"Wielkopolskie","shortCode":"WP"},{"name":"Zachodniopomorskie","shortCode":"ZP"}]},{"countryName":"Portugal","countryShortCode":"PT","regions":[{"name":"Acores","shortCode":"20"},{"name":"Aveiro","shortCode":"01"},{"name":"Beja","shortCode":"02"},{"name":"Braga","shortCode":"03"},{"name":"Braganca","shortCode":"04"},{"name":"Castelo Branco","shortCode":"05"},{"name":"Coimbra","shortCode":"06"},{"name":"Evora","shortCode":"07"},{"name":"Faro","shortCode":"08"},{"name":"Guarda","shortCode":"09"},{"name":"Leiria","shortCode":"10"},{"name":"Lisboa","shortCode":"11"},{"name":"Madeira","shortCode":"30"},{"name":"Portalegre","shortCode":"12"},{"name":"Porto","shortCode":"13"},{"name":"Santarem","shortCode":"14"},{"name":"Setubal","shortCode":"15"},{"name":"Viana do Castelo","shortCode":"16"},{"name":"Vila Real","shortCode":"17"},{"name":"Viseu","shortCode":"18"}]},{"countryName":"Puerto Rico","countryShortCode":"PR","regions":[{"name":"Adjuntas"},{"name":"Aguada"},{"name":"Aguadilla"},{"name":"Aguas Buenas"},{"name":"Aibonito"},{"name":"Anasco"},{"name":"Arecibo"},{"name":"Arroyo"},{"name":"Barceloneta"},{"name":"Barranquitas"},{"name":"Bayamon"},{"name":"Cabo Rojo"},{"name":"Caguas"},{"name":"Camuy"},{"name":"Canovanas"},{"name":"Carolina"},{"name":"Cat"},{"name":"Ceiba"},{"name":"Ciales"},{"name":"Cidra"},{"name":"Coamo"},{"name":"Comerio"},{"name":"Corozal"},{"name":"Culebra"},{"name":"Dorado"},{"name":"Fajardo"},{"name":"Florida"},{"name":"Guanica"},{"name":"Guayama"},{"name":"Guayanilla"},{"name":"Guaynabo"},{"name":"Gurabo"},{"name":"Hatillo"},{"name":"Hormigueros"},{"name":"Humacao"},{"name":"Isabe"},{"name":"Juana Diaz"},{"name":"Juncos"},{"name":"Lajas"},{"name":"Lares"},{"name":"Las Marias"},{"name":"Las oiza"},{"name":"Luquillo"},{"name":"Manati"},{"name":"Maricao"},{"name":"Maunabo"},{"name":"Mayaguez"},{"name":"Moca"},{"name":"Morovis"},{"name":"Naguabo"},{"name":"Naranjito"},{"name":"Orocovis"},{"name":"Patillas"},{"name":"Penuelas"},{"name":"Ponce"},{"name":"Quebradillas"},{"name":"Rincon"},{"name":"Rio Grande"},{"name":"Sabana linas"},{"name":"San German"},{"name":"San Juan"},{"name":"San Lorenzo"},{"name":"San Sebastian"},{"name":"Santa Isabel"},{"name":"Toa Alta"},{"name":"Toa Baja"},{"name":"Trujillo Alto"},{"name":"Utuado"},{"name":"Vega Alta"},{"name":"Vega ues"},{"name":"Villalba"},{"name":"Yabucoa"},{"name":"Yauco"}]},{"countryName":"Qatar","countryShortCode":"QA","regions":[{"name":"Ad Dawḩah","shortCode":"DA"},{"name":"Al Khawr wa adh Dhakhīrah","shortCode":"KH"},{"name":"Al Wakrah","shortCode":"WA"},{"name":"Ar Rayyān","shortCode":"RA"},{"name":"Ash Shamāl","shortCode":"MS"},{"name":"Az̧ Za̧`āyin","shortCode":"ZA"},{"name":"Umm Şalāl","shortCode":"US"}]},{"countryName":"Réunion","countryShortCode":"RE","regions":[{"name":"Réunion"}]},{"countryName":"Romania","countryShortCode":"RO","regions":[{"name":"Alba","shortCode":"AB"},{"name":"Arad","shortCode":"AR"},{"name":"Arges","shortCode":"AG"},{"name":"Bacau","shortCode":"BC"},{"name":"Bihor","shortCode":"BH"},{"name":"Bistrita-Nasaud","shortCode":"BN"},{"name":"Botosani","shortCode":"BT"},{"name":"Braila","shortCode":"BR"},{"name":"Brasov","shortCode":"BV"},{"name":"Bucuresti","shortCode":"B"},{"name":"Buzau","shortCode":"BZ"},{"name":"Calarasi","shortCode":"CL"},{"name":"Caras-Severin","shortCode":"CS"},{"name":"Cluj","shortCode":"CJ"},{"name":"Constanta","shortCode":"CT"},{"name":"Covasna","shortCode":"CV"},{"name":"Dambovita","shortCode":"DB"},{"name":"Dolj","shortCode":"DJ"},{"name":"Galati","shortCode":"GL"},{"name":"Giurgiu","shortCode":"GR"},{"name":"Gorj","shortCode":"GJ"},{"name":"Harghita","shortCode":"HR"},{"name":"Hunedoara","shortCode":"HD"},{"name":"Ialomita","shortCode":"IL"},{"name":"Iasi","shortCode":"IS"},{"name":"Maramures","shortCode":"MM"},{"name":"Mehedinti","shortCode":"MH"},{"name":"Mures","shortCode":"MS"},{"name":"Neamt","shortCode":"NT"},{"name":"Olt","shortCode":"OT"},{"name":"Prahova","shortCode":"PH"},{"name":"Salaj","shortCode":"SJ"},{"name":"Satu Mare","shortCode":"SM"},{"name":"Sibiu","shortCode":"SB"},{"name":"Suceava","shortCode":"SV"},{"name":"Teleorman","shortCode":"TR"},{"name":"Timis","shortCode":"TM"},{"name":"Tulcea","shortCode":"TL"},{"name":"Valcea","shortCode":"VL"},{"name":"Vaslui","shortCode":"VS"},{"name":"Vrancea","shortCode":"VN"}]},{"countryName":"Russian Federation","countryShortCode":"RU","regions":[{"name":"Republic of Adygea","shortCode":"AD"},{"name":"Republic of Altai (Gorno-Altaysk)","shortCode":"AL"},{"name":"Altai Krai","shortCode":"ALT"},{"name":"Amur Oblast","shortCode":"AMU"},{"name":"Arkhangelsk Oblast","shortCode":"ARK"},{"name":"Astrakhan Oblast","shortCode":"AST"},{"name":"Republic of Bashkortostan","shortCode":"BA"},{"name":"Belgorod Oblast","shortCode":"BEL"},{"name":"Bryansk Oblast","shortCode":"BRY"},{"name":"Republic of Buryatia","shortCode":"BU"},{"name":"Chechen Republic","shortCode":"CE"},{"name":"Chelyabinsk Oblast","shortCode":"CHE"},{"name":"Chukotka Autonomous Okrug","shortCode":"CHU"},{"name":"Chuvash Republic","shortCode":"CU"},{"name":"Republic of Dagestan","shortCode":"DA"},{"name":"Republic of Ingushetia","shortCode":"IN"},{"name":"Irkutsk Oblast","shortCode":"IRK"},{"name":"Ivanovo Oblast","shortCode":"IVA"},{"name":"Jewish Autonomous Oblast","shortCode":"JEW"},{"name":"Kabardino-Balkar Republic","shortCode":"KB"},{"name":"Kaliningrad Oblast","shortCode":"KLN"},{"name":"Republic of Kalmykia","shortCode":"KL"},{"name":"Kaluga Oblast","shortCode":"KLU"},{"name":"Kamchatka Krai","shortCode":"KAM"},{"name":"Karachay-Cherkess Republic","shortCode":"KC"},{"name":"Republic of Karelia","shortCode":"KR"},{"name":"Khabarovsk Krai","shortCode":"KHA"},{"name":"Republic of Khakassia","shortCode":"KK"},{"name":"Khanty-Mansi Autonomous Okrug - Yugra","shortCode":"KHM"},{"name":"Kemerovo Oblast","shortCode":"KEM"},{"name":"Kirov Oblast","shortCode":"KIR"},{"name":"Komi Republic","shortCode":"KO"},{"name":"Kostroma Oblast","shortCode":"KOS"},{"name":"Krasnodar Krai","shortCode":"KDA"},{"name":"Krasnoyarsk Krai","shortCode":"KYA"},{"name":"Kurgan Oblast","shortCode":"KGN"},{"name":"Kursk Oblast","shortCode":"KRS"},{"name":"Leningrad Oblast","shortCode":"LEN"},{"name":"Lipetsk Oblast","shortCode":"LIP"},{"name":"Magadan Oblast","shortCode":"MAG"},{"name":"Mari El Republic","shortCode":"ME"},{"name":"Republic of Mordovia","shortCode":"MO"},{"name":"Moscow Oblast","shortCode":"MOS"},{"name":"Moscow","shortCode":"MOW"},{"name":"Murmansk Oblast","shortCode":"MU"},{"name":"Nenets Autonomous Okrug","shortCode":"NEN"},{"name":"Nizhny Novgorod Oblast","shortCode":"NIZ"},{"name":"Novgorod Oblast","shortCode":"NGR"},{"name":"Novosibirsk Oblast","shortCode":"NVS"},{"name":"Omsk Oblast","shortCode":"OMS"},{"name":"Orenburg Oblast","shortCode":"ORE"},{"name":"Oryol Oblast","shortCode":"ORL"},{"name":"Penza Oblast","shortCode":"PNZ"},{"name":"Perm Krai","shortCode":"PER"},{"name":"Primorsky Krai","shortCode":"PRI"},{"name":"Pskov Oblast","shortCode":"PSK"},{"name":"Rostov Oblast","shortCode":"ROS"},{"name":"Ryazan Oblast","shortCode":"RYA"},{"name":"Saint Petersburg","shortCode":"SPE"},{"name":"Sakha (Yakutia) Republic","shortCode":"SA"},{"name":"Sakhalin Oblast","shortCode":"SAK"},{"name":"Samara Oblast","shortCode":"SAM"},{"name":"Saratov Oblast","shortCode":"SAR"},{"name":"Republic of North Ossetia-Alania","shortCode":"NOA"},{"name":"Smolensk Oblast","shortCode":"SMO"},{"name":"Stavropol Krai","shortCode":"STA"},{"name":"Sverdlovsk Oblast","shortCode":"SVE"},{"name":"Tambov Oblast","shortCode":"TAM"},{"name":"Republic of Tatarstan","shortCode":"TA"},{"name":"Tomsk Oblast","shortCode":"TOM"},{"name":"Tuva Republic","shortCode":"TU"},{"name":"Tula Oblast","shortCode":"TUL"},{"name":"Tver Oblast","shortCode":"TVE"},{"name":"Tyumen Oblast","shortCode":"TYU"},{"name":"Udmurt Republic","shortCode":"UD"},{"name":"Ulyanovsk Oblast","shortCode":"ULY"},{"name":"Vladimir Oblast","shortCode":"VLA"},{"name":"Volgograd Oblast","shortCode":"VGG"},{"name":"Vologda Oblast","shortCode":"VLG"},{"name":"Voronezh Oblast","shortCode":"VOR"},{"name":"Yamalo-Nenets Autonomous Okrug","shortCode":"YAN"},{"name":"Yaroslavl Oblast","shortCode":"YAR"},{"name":"Zabaykalsky Krai","shortCode":"ZAB"}]},{"countryName":"Rwanda","countryShortCode":"RW","regions":[{"name":"Kigali","shortCode":"01"},{"name":"Eastern","shortCode":"02"},{"name":"Northern","shortCode":"03"},{"name":"Western","shortCode":"04"},{"name":"Southern","shortCode":"05"}]},{"countryName":"Saint Barthélemy","countryShortCode":"BL","regions":[{"name":"Au Vent","shortCode":"02"},{"name":"Sous le Vent","shortCode":"01"}]},{"countryName":"Saint Helena, Ascension and Tristan da Cunha","countryShortCode":"SH","regions":[{"name":"Ascension","shortCode":"AC"},{"name":"Saint Helena","shortCode":"HL"},{"name":"Tristan da Cunha","shortCode":"TA"}]},{"countryName":"Saint Kitts and Nevis","countryShortCode":"KN","regions":[{"name":"Saint Kitts","shortCode":"K"},{"name":"Nevis","shortCode":"N"}]},{"countryName":"Saint Lucia","countryShortCode":"LC","regions":[{"name":"Anse-la-Raye","shortCode":"01"},{"name":"Canaries","shortCode":"12"},{"name":"Castries","shortCode":"02"},{"name":"Choiseul","shortCode":"03"},{"name":"Dennery","shortCode":"05"},{"name":"Gros Islet","shortCode":"06"},{"name":"Laborie","shortCode":"07"},{"name":"Micoud","shortCode":"08"},{"name":"Soufriere","shortCode":"10"},{"name":"Vieux Fort","shortCode":"11"}]},{"countryName":"Saint Martin","countryShortCode":"MF","regions":[{"name":"Saint Martin"}]},{"countryName":"Saint Pierre and Miquelon","countryShortCode":"PM","regions":[{"name":"Miquelon"},{"name":"Saint Pierre"}]},{"countryName":"Saint Vincent and the Grenadines","countryShortCode":"VC","regions":[{"name":"Charlotte","shortCode":"01"},{"name":"Grenadines","shortCode":"06"},{"name":"Saint Andrew","shortCode":"02"},{"name":"Saint David","shortCode":"03"},{"name":"Saint George","shortCode":"04"},{"name":"Saint Patrick","shortCode":"05"}]},{"countryName":"Samoa","countryShortCode":"WS","regions":[{"name":"A'ana","shortCode":"AA"},{"name":"Aiga-i-le-Tai","shortCode":"AL"},{"name":"Atua","shortCode":"AT"},{"name":"Fa'asaleleaga","shortCode":"FA"},{"name":"Gaga'emauga","shortCode":"GE"},{"name":"Gagaifomauga","shortCode":"GI"},{"name":"Palauli","shortCode":"PA"},{"name":"Satupa'itea","shortCode":"SA"},{"name":"Tuamasaga","shortCode":"TU"},{"name":"Va'a-o-Fonoti","shortCode":"VF"},{"name":"Vaisigano","shortCode":"VS"}]},{"countryName":"San Marino","countryShortCode":"SM","regions":[{"name":"Acquaviva","shortCode":"01"},{"name":"Borgo Maggiore","shortCode":"06"},{"name":"Chiesanuova","shortCode":"02"},{"name":"Domagnano","shortCode":"03"},{"name":"Faetano","shortCode":"04"},{"name":"Fiorentino","shortCode":"05"},{"name":"Montegiardino","shortCode":"08"},{"name":"San Marino","shortCode":"07"},{"name":"Serravalle","shortCode":"09"}]},{"countryName":"Sao Tome and Principe","countryShortCode":"ST","regions":[{"name":"Principe","shortCode":"P"},{"name":"Sao Tome","shortCode":"S"}]},{"countryName":"Saudi Arabia","countryShortCode":"SA","regions":[{"name":"'Asir","shortCode":"14"},{"name":"Al Bahah","shortCode":"11"},{"name":"Al Hudud ash Shamaliyah","shortCode":"08"},{"name":"Al Jawf","shortCode":"12"},{"name":"Al Madinah al Munawwarah","shortCode":"03"},{"name":"Al Qasim","shortCode":"05"},{"name":"Ar Riyad","shortCode":"01"},{"name":"Ash Sharqiyah","shortCode":"04"},{"name":"Ha'il","shortCode":"06"},{"name":"Jazan","shortCode":"09"},{"name":"Makkah al Mukarramah","shortCode":"02"},{"name":"Najran","shortCode":"10"},{"name":"Tabuk","shortCode":"07"}]},{"countryName":"Senegal","countryShortCode":"SN","regions":[{"name":"Dakar","shortCode":"DK"},{"name":"Diourbel","shortCode":"DB"},{"name":"Fatick","shortCode":"FK"},{"name":"Kaffrine","shortCode":"KA"},{"name":"Kaolack","shortCode":"KL"},{"name":"Kedougou","shortCode":"KE"},{"name":"Kolda","shortCode":"KD"},{"name":"Louga","shortCode":"LG"},{"name":"Matam","shortCode":"MT"},{"name":"Saint-Louis","shortCode":"SL"},{"name":"Sedhiou","shortCode":"SE"},{"name":"Tambacounda","shortCode":"TC"},{"name":"Thies","shortCode":"TH"},{"name":"Ziguinchor","shortCode":"ZG"}]},{"countryName":"Serbia","countryShortCode":"RS","regions":[{"name":"Beograd (Belgrade)","shortCode":"00"},{"name":"Borski","shortCode":"14"},{"name":"Braničevski","shortCode":"11"},{"name":"Jablanički","shortCode":"23"},{"name":"Južnobački","shortCode":"06"},{"name":"Južnobanatski","shortCode":"04"},{"name":"Kolubarski","shortCode":"09"},{"name":"Kosovski","shortCode":"25"},{"name":"Kosovsko-Mitrovački","shortCode":"28"},{"name":"Kosovsko-Pomoravski","shortCode":"29"},{"name":"Mačvanski","shortCode":"08"},{"name":"Moravički","shortCode":"17"},{"name":"Nišavski","shortCode":"20"},{"name":"Pčinjski","shortCode":"24"},{"name":"Pećki","shortCode":"26"},{"name":"Pirotski","shortCode":"22"},{"name":"Podunavski","shortCode":"10"},{"name":"Pomoravski","shortCode":"13"},{"name":"Prizrenski","shortCode":"27"},{"name":"Rasinski","shortCode":"19"},{"name":"Raški","shortCode":"18"},{"name":"Severnobački","shortCode":"01"},{"name":"Severnobanatski","shortCode":"03"},{"name":"Srednjebanatski","shortCode":"02"},{"name":"Sremski","shortCode":"07"},{"name":"Šumadijski","shortCode":"12"},{"name":"Toplički","shortCode":"21"},{"name":"Zaječarski","shortCode":"15"},{"name":"Zapadnobački","shortCode":"05"},{"name":"Zlatiborski","shortCode":"16"}]},{"countryName":"Seychelles","countryShortCode":"SC","regions":[{"name":"Anse aux Pins","shortCode":"01"},{"name":"Anse Boileau","shortCode":"02"},{"name":"Anse Etoile","shortCode":"03"},{"name":"Anse Royale","shortCode":"05"},{"name":"Anu Cap","shortCode":"04"},{"name":"Baie Lazare","shortCode":"06"},{"name":"Baie Sainte Anne","shortCode":"07"},{"name":"Beau Vallon","shortCode":"08"},{"name":"Bel Air","shortCode":"09"},{"name":"Bel Ombre","shortCode":"10"},{"name":"Cascade","shortCode":"11"},{"name":"Glacis","shortCode":"12"},{"name":"Grand'Anse Mahe","shortCode":"13"},{"name":"Grand'Anse Praslin","shortCode":"14"},{"name":"La Digue","shortCode":"15"},{"name":"La Riviere Anglaise","shortCode":"16"},{"name":"Les Mamelles","shortCode":"24"},{"name":"Mont Buxton","shortCode":"17"},{"name":"Mont Fleuri","shortCode":"18"},{"name":"Plaisance","shortCode":"19"},{"name":"Pointe La Rue","shortCode":"20"},{"name":"Port Glaud","shortCode":"21"},{"name":"Roche Caiman","shortCode":"25"},{"name":"Saint Louis","shortCode":"22"},{"name":"Takamaka","shortCode":"23"}]},{"countryName":"Sierra Leone","countryShortCode":"SL","regions":[{"name":"Eastern","shortCode":"E"},{"name":"Northern","shortCode":"N"},{"name":"Southern","shortCode":"S"},{"name":"Western","shortCode":"W"}]},{"countryName":"Singapore","countryShortCode":"SG","regions":[{"name":"Central Singapore","shortCode":"01"},{"name":"North East","shortCode":"02"},{"name":"North West","shortCode":"03"},{"name":"South East","shortCode":"04"},{"name":"South West","shortCode":"05"}]},{"countryName":"Sint Maarten (Dutch part)","countryShortCode":"SX","regions":[{"name":"Sint Maarten"}]},{"countryName":"Slovakia","countryShortCode":"SK","regions":[{"name":"Banskobystricky","shortCode":"BC"},{"name":"Bratislavsky","shortCode":"BL"},{"name":"Kosicky","shortCode":"KI"},{"name":"Nitriansky","shortCode":"NI"},{"name":"Presovsky","shortCode":"PV"},{"name":"Trenciansky","shortCode":"TC"},{"name":"Trnavsky","shortCode":"TA"},{"name":"Zilinsky","shortCode":"ZI"}]},{"countryName":"Slovenia","countryShortCode":"SI","regions":[{"name":"Ajdovscina","shortCode":"001"},{"name":"Apace","shortCode":"195"},{"name":"Beltinci","shortCode":"002"},{"name":"Benedikt","shortCode":"148"},{"name":"Bistrica ob Sotli","shortCode":"149"},{"name":"Bled","shortCode":"003"},{"name":"Bloke","shortCode":"150"},{"name":"Bohinj","shortCode":"004"},{"name":"Borovnica","shortCode":"005"},{"name":"Bovec","shortCode":"006"},{"name":"Braslovce","shortCode":"151"},{"name":"Brda","shortCode":"007"},{"name":"Brezice","shortCode":"009"},{"name":"Brezovica","shortCode":"008"},{"name":"Cankova","shortCode":"152"},{"name":"Celje","shortCode":"011"},{"name":"Cerklje na Gorenjskem","shortCode":"012"},{"name":"Cerknica","shortCode":"013"},{"name":"Cerkno","shortCode":"014"},{"name":"Cerkvenjak","shortCode":"153"},{"name":"Cirkulane","shortCode":"196"},{"name":"Crensovci","shortCode":"015"},{"name":"Crna na Koroskem","shortCode":"016"},{"name":"Crnomelj","shortCode":"017"},{"name":"Destrnik","shortCode":"018"},{"name":"Divaca","shortCode":"019"},{"name":"Dobje","shortCode":"154"},{"name":"Dobrepolje","shortCode":"020"},{"name":"Dobrna","shortCode":"155"},{"name":"Dobrova-Polhov Gradec","shortCode":"021"},{"name":"Dobrovnik","shortCode":"156"},{"name":"Dol pri Ljubljani","shortCode":"022"},{"name":"Dolenjske Toplice","shortCode":"157"},{"name":"Domzale","shortCode":"023"},{"name":"Dornava","shortCode":"024"},{"name":"Dravograd","shortCode":"025"},{"name":"Duplek","shortCode":"026"},{"name":"Gorenja Vas-Poljane","shortCode":"027"},{"name":"Gorisnica","shortCode":"028"},{"name":"Gorje","shortCode":"207"},{"name":"Gornja Radgona","shortCode":"029"},{"name":"Gornji Grad","shortCode":"030"},{"name":"Gornji Petrovci","shortCode":"031"},{"name":"Grad","shortCode":"158"},{"name":"Grosuplje","shortCode":"032"},{"name":"Hajdina","shortCode":"159"},{"name":"Hoce-Slivnica","shortCode":"160"},{"name":"Hodos","shortCode":"161"},{"name":"Horjul","shortCode":"162"},{"name":"Hrastnik","shortCode":"034"},{"name":"Hrpelje-Kozina","shortCode":"035"},{"name":"Idrija","shortCode":"036"},{"name":"Ig","shortCode":"037"},{"name":"Ilirska Bistrica","shortCode":"038"},{"name":"Ivancna Gorica","shortCode":"039"},{"name":"Izola","shortCode":"040s"},{"name":"Jesenice","shortCode":"041"},{"name":"Jursinci","shortCode":"042"},{"name":"Kamnik","shortCode":"043"},{"name":"Kanal","shortCode":"044"},{"name":"Kidricevo","shortCode":"045"},{"name":"Kobarid","shortCode":"046"},{"name":"Kobilje","shortCode":"047"},{"name":"Kocevje","shortCode":"048"},{"name":"Komen","shortCode":"049"},{"name":"Komenda","shortCode":"164"},{"name":"Koper","shortCode":"050"},{"name":"Kodanjevica na Krki","shortCode":"197"},{"name":"Kostel","shortCode":"165"},{"name":"Kozje","shortCode":"051"},{"name":"Kranj","shortCode":"052"},{"name":"Kranjska Gora","shortCode":"053"},{"name":"Krizevci","shortCode":"166"},{"name":"Krsko","shortCode":"054"},{"name":"Kungota","shortCode":"055"},{"name":"Kuzma","shortCode":"056"},{"name":"Lasko","shortCode":"057"},{"name":"Lenart","shortCode":"058"},{"name":"Lendava","shortCode":"059"},{"name":"Litija","shortCode":"068"},{"name":"Ljubljana","shortCode":"061"},{"name":"Ljubno","shortCode":"062"},{"name":"Ljutomer","shortCode":"063"},{"name":"Log-Dragomer","shortCode":"208"},{"name":"Logatec","shortCode":"064"},{"name":"Loska Dolina","shortCode":"065"},{"name":"Loski Potok","shortCode":"066"},{"name":"Lovrenc na Pohorju","shortCode":"167"},{"name":"Lukovica","shortCode":"068"},{"name":"Luce","shortCode":"067"},{"name":"Majsperk","shortCode":"069"},{"name":"Makole","shortCode":"198"},{"name":"Maribor","shortCode":"070"},{"name":"Markovci","shortCode":"168"},{"name":"Medvode","shortCode":"071"},{"name":"Menges","shortCode":"072"},{"name":"Metlika","shortCode":"073"},{"name":"Mezica","shortCode":"074"},{"name":"Miklavz na Dravskem Polju","shortCode":"169"},{"name":"Miren-Kostanjevica","shortCode":"075"},{"name":"Mirna","shortCode":"212"},{"name":"Mirna Pec","shortCode":"170"},{"name":"Mislinja","shortCode":"076"},{"name":"Mokronog-Trebelno","shortCode":"199"},{"name":"Moravce","shortCode":"077"},{"name":"Moravske Toplice","shortCode":"078"},{"name":"Mozirje","shortCode":"079"},{"name":"Murska Sobota","shortCode":"080"},{"name":"Naklo","shortCode":"082"},{"name":"Nazarje","shortCode":"083"},{"name":"Nova Gorica","shortCode":"084"},{"name":"Novo Mesto","shortCode":"085"},{"name":"Odranci","shortCode":"086"},{"name":"Ormoz","shortCode":"087"},{"name":"Osilnica","shortCode":"088"},{"name":"Pesnica","shortCode":"089"},{"name":"Piran","shortCode":"090"},{"name":"Pivka","shortCode":"091"},{"name":"Podcetrtek","shortCode":"092"},{"name":"Podlehnik","shortCode":"172"},{"name":"Podvelka","shortCode":"093"},{"name":"Poljcane","shortCode":"200"},{"name":"Postojna","shortCode":"094"},{"name":"Prebold","shortCode":"174"},{"name":"Preddvor","shortCode":"095"},{"name":"Prevalje","shortCode":"175"},{"name":"Ptuj","shortCode":"096"},{"name":"Race-Fram","shortCode":"098"},{"name":"Radece","shortCode":"099"},{"name":"Radenci","shortCode":"100"},{"name":"Radlje ob Dravi","shortCode":"101"},{"name":"Radovljica","shortCode":"102"},{"name":"Ravne na Koroskem","shortCode":"103"},{"name":"Razkrizje","shortCode":"176"},{"name":"Recica ob Savinji","shortCode":"209"},{"name":"Rence-Vogrsko","shortCode":"201"},{"name":"Ribnica","shortCode":"104"},{"name":"Ribnica na Poboriu","shortCode":"177"},{"name":"Rogaska Slatina","shortCode":"106"},{"name":"Rogasovci","shortCode":"105"},{"name":"Rogatec","shortCode":"107"},{"name":"Ruse","shortCode":"108"},{"name":"Salovci","shortCode":"033"},{"name":"Selnica ob Dravi","shortCode":"178"},{"name":"Semic","shortCode":"109"},{"name":"Sempeter-Vrtojba","shortCode":"183"},{"name":"Sencur","shortCode":"117"},{"name":"Sentilj","shortCode":"118"},{"name":"Sentjernej","shortCode":"119"},{"name":"Sentjur","shortCode":"120"},{"name":"Sentrupert","shortCode":"211"},{"name":"Sevnica","shortCode":"110"},{"name":"Sezana","shortCode":"111"},{"name":"Skocjan","shortCode":"121"},{"name":"Skofja Loka","shortCode":"122"},{"name":"Skofljica","shortCode":"123"},{"name":"Slovenj Gradec","shortCode":"112"},{"name":"Slovenska Bistrica","shortCode":"113"},{"name":"Slovenske Konjice","shortCode":"114"},{"name":"Smarje pri elsah","shortCode":"124"},{"name":"Smarjeske Toplice","shortCode":"206"},{"name":"Smartno ob Paki","shortCode":"125"},{"name":"Smartno pri Litiji","shortCode":"194"},{"name":"Sodrazica","shortCode":"179"},{"name":"Solcava","shortCode":"180"},{"name":"Sostanj","shortCode":"126"},{"name":"Sredisce ob Dravi","shortCode":"202"},{"name":"Starse","shortCode":"115"},{"name":"Store","shortCode":"127"},{"name":"Straza","shortCode":"203"},{"name":"Sveta Ana","shortCode":"181"},{"name":"Sveta Trojica v Slovenskih Goricah","shortCode":"204"},{"name":"Sveta Andraz v Slovenskih Goricah","shortCode":"182"},{"name":"Sveti Jurij","shortCode":"116"},{"name":"Sveti Jurij v Slovenskih Goricah","shortCode":"210"},{"name":"Sveti Tomaz","shortCode":"205"},{"name":"Tabor","shortCode":"184"},{"name":"Tisina","shortCode":"128"},{"name":"Tolmin","shortCode":"128"},{"name":"Trbovlje","shortCode":"129"},{"name":"Trebnje","shortCode":"130"},{"name":"Trnovska Vas","shortCode":"185"},{"name":"Trzin","shortCode":"186"},{"name":"Trzic","shortCode":"131"},{"name":"Turnisce","shortCode":"132"},{"name":"Velenje","shortCode":"133"},{"name":"Velika Polana","shortCode":"187"},{"name":"Velike Lasce","shortCode":"134"},{"name":"Verzej","shortCode":"188"},{"name":"Videm","shortCode":"135"},{"name":"Vipava","shortCode":"136"},{"name":"Vitanje","shortCode":"137"},{"name":"Vodice","shortCode":"138"},{"name":"Vojnik","shortCode":"139"},{"name":"Vransko","shortCode":"189"},{"name":"Vrhnika","shortCode":"140"},{"name":"Vuzenica","shortCode":"141"},{"name":"Zagorje ob Savi","shortCode":"142"},{"name":"Zavrc","shortCode":"143"},{"name":"Zrece","shortCode":"144"},{"name":"Zalec","shortCode":"190"},{"name":"Zelezniki","shortCode":"146"},{"name":"Zetale","shortCode":"191"},{"name":"Ziri","shortCode":"147"},{"name":"Zirovnica","shortCode":"192"},{"name":"Zuzemberk","shortCode":"193"}]},{"countryName":"Solomon Islands","countryShortCode":"SB","regions":[{"name":"Central","shortCode":"CE"},{"name":"Choiseul","shortCode":"CH"},{"name":"Guadalcanal","shortCode":"GU"},{"name":"Honiara","shortCode":"CT"},{"name":"Isabel","shortCode":"IS"},{"name":"Makira-Ulawa","shortCode":"MK"},{"name":"Malaita","shortCode":"ML"},{"name":"Rennell and Bellona","shortCode":"RB"},{"name":"Temotu","shortCode":"TE"},{"name":"Western","shortCode":"WE"}]},{"countryName":"Somalia","countryShortCode":"SO","regions":[{"name":"Awdal","shortCode":"AW"},{"name":"Bakool","shortCode":"BK"},{"name":"Banaadir","shortCode":"BN"},{"name":"Bari","shortCode":"BR"},{"name":"Bay","shortCode":"BY"},{"name":"Galguduud","shortCode":"GA"},{"name":"Gedo","shortCode":"GE"},{"name":"Hiiraan","shortCode":"HI"},{"name":"Jubbada Dhexe","shortCode":"JD"},{"name":"Jubbada Hoose","shortCode":"JH"},{"name":"Mudug","shortCode":"MU"},{"name":"Nugaal","shortCode":"NU"},{"name":"Sanaag","shortCode":"SA"},{"name":"Shabeellaha Dhexe","shortCode":"SD"},{"name":"Shabeellaha Hoose","shortCode":"SH"},{"name":"Sool","shortCode":"SO"},{"name":"Togdheer","shortCode":"TO"},{"name":"Woqooyi Galbeed","shortCode":"WO"}]},{"countryName":"South Africa","countryShortCode":"ZA","regions":[{"name":"Eastern Cape","shortCode":"EC"},{"name":"Free State","shortCode":"FS"},{"name":"Gauteng","shortCode":"GT"},{"name":"KwaZulu-Natal","shortCode":"NL"},{"name":"Limpopo","shortCode":"LP"},{"name":"Mpumalanga","shortCode":"MP"},{"name":"Northern Cape","shortCode":"NC"},{"name":"North West","shortCode":"NW"},{"name":"Western Cape","shortCode":"WC"}]},{"countryName":"South Georgia and South Sandwich Islands","countryShortCode":"GS","regions":[{"name":"Bird Island"},{"name":"Bristol Island"},{"name":"Clerke Rocks"},{"name":"Montagu Island"},{"name":"Saunders Island"},{"name":"South Georgia"},{"name":"Southern Thule"},{"name":"Traversay Islands"}]},{"countryName":"South Sudan","countryShortCode":"SS","regions":[{"name":"Central Equatoria","shortCode":"CE"},{"name":"Eastern Equatoria","shortCode":"EE"},{"name":"Jonglei","shortCode":"JG"},{"name":"Lakes","shortCode":"LK"},{"name":"Northern Bahr el Ghazal","shortCode":"BN"},{"name":"Unity","shortCode":"UY"},{"name":"Upper Nile","shortCode":"NU"},{"name":"Warrap","shortCode":"WR"},{"name":"Western Bahr el Ghazal","shortCode":"BW"},{"name":"Western Equatoria","shortCode":"EW"}]},{"countryName":"Spain","countryShortCode":"ES","regions":[{"name":"Albacete","shortCode":"CM"},{"name":"Alicante","shortCode":"VC"},{"name":"Almería","shortCode":"AN"},{"name":"Araba/Álava","shortCode":"VI"},{"name":"Asturias","shortCode":"O"},{"name":"Ávila","shortCode":"AV"},{"name":"Badajoz","shortCode":"BA"},{"name":"Barcelona","shortCode":"B"},{"name":"Bizkaia","shortCode":"BI"},{"name":"Burgos","shortCode":"BU"},{"name":"Cáceres","shortCode":"CC"},{"name":"Cádiz","shortCode":"CA"},{"name":"Cantabria","shortCode":"S"},{"name":"Castellón","shortCode":"CS"},{"name":"Cueta","shortCode":"CU"},{"name":"Ciudad Real","shortCode":"CR"},{"name":"Córdoba","shortCode":"CO"},{"name":"A Coruña","shortCode":"C"},{"name":"Cuenca","shortCode":"CU"},{"name":"Gipuzkoa","shortCode":"SS"},{"name":"Girona","shortCode":"GI"},{"name":"Granada","shortCode":"GR"},{"name":"Guadalajara","shortCode":"GU"},{"name":"Huelva","shortCode":"H"},{"name":"Huesca","shortCode":"HU"},{"name":"Illes Balears","shortCode":"PM"},{"name":"Jaén","shortCode":"J"},{"name":"León","shortCode":"LE"},{"name":"Lleida","shortCode":"L"},{"name":"Lugo","shortCode":"LU"},{"name":"Madrid","shortCode":"M"},{"name":"Málaga","shortCode":"MA"},{"name":"Melilla","shortCode":"ML"},{"name":"Murcia","shortCode":"MU"},{"name":"Navarre","shortCode":"NA"},{"name":"Ourense","shortCode":"OR"},{"name":"Palencia","shortCode":"P"},{"name":"Las Palmas","shortCode":"GC"},{"name":"Pontevedra","shortCode":"PO"},{"name":"La Rioja","shortCode":"LO"},{"name":"Salamanca","shortCode":"SA"},{"name":"Santa Cruz de Tenerife","shortCode":"TF"},{"name":"Segovia","shortCode":"SG"},{"name":"Sevilla","shortCode":"SE"},{"name":"Soria","shortCode":"SO"},{"name":"Tarragona","shortCode":"T"},{"name":"Teruel","shortCode":"TE"},{"name":"Toledo","shortCode":"TO"},{"name":"Valencia","shortCode":"V"},{"name":"Valladolid","shortCode":"VA"},{"name":"Zamora","shortCode":"ZA"},{"name":"Zaragoza","shortCode":"Z"}]},{"countryName":"Sri Lanka","countryShortCode":"LK","regions":[{"name":"Basnahira","shortCode":"1"},{"name":"Dakunu","shortCode":"3"},{"name":"Madhyama","shortCode":"2"},{"name":"Naegenahira","shortCode":"5"},{"name":"Sabaragamuwa","shortCode":"9"},{"name":"Uturu","shortCode":"4"},{"name":"Uturumaeda","shortCode":"7"},{"name":"Vayamba","shortCode":"6"},{"name":"Uva","shortCode":"8"}]},{"countryName":"Sudan","countryShortCode":"SD","regions":[{"name":"Al Bahr al Ahmar","shortCode":"RS"},{"name":"Al Jazirah","shortCode":"GZ"},{"name":"Al Khartum","shortCode":"KH"},{"name":"Al Qadarif","shortCode":"GD"},{"name":"An Nil al Abyad","shortCode":"NW"},{"name":"An Nil al Azraq","shortCode":"NB"},{"name":"Ash Shamaliyah","shortCode":"NO"},{"name":"Gharb Darfur","shortCode":"DW"},{"name":"Gharb Kurdufan","shortCode":"GK"},{"name":"Janub Darfur","shortCode":"DS"},{"name":"Janub Kurdufan","shortCode":"KS"},{"name":"Kassala","shortCode":"KA"},{"name":"Nahr an Nil","shortCode":"NR"},{"name":"Shamal Darfur","shortCode":"DN"},{"name":"Sharq Darfur","shortCode":"DE"},{"name":"Shiamal Kurdufan","shortCode":"KN"},{"name":"Sinnar","shortCode":"SI"},{"name":"Wasat Darfur Zalinjay","shortCode":"DC"}]},{"countryName":"Suriname","countryShortCode":"SR","regions":[{"name":"Brokopondo","shortCode":"BR"},{"name":"Commewijne","shortCode":"CM"},{"name":"Coronie","shortCode":"CR"},{"name":"Marowijne","shortCode":"MA"},{"name":"Nickerie","shortCode":"NI"},{"name":"Para","shortCode":"PR"},{"name":"Paramaribo","shortCode":"PM"},{"name":"Saramacca","shortCode":"SA"},{"name":"Sipaliwini","shortCode":"SI"},{"name":"Wanica","shortCode":"WA"}]},{"countryName":"Swaziland","countryShortCode":"SZ","regions":[{"name":"Hhohho","shortCode":"HH"},{"name":"Lubombo","shortCode":"LU"},{"name":"Manzini","shortCode":"MA"},{"name":"Shiselweni","shortCode":"SH"}]},{"countryName":"Sweden","countryShortCode":"SE","regions":[{"name":"Blekinge","shortCode":"K"},{"name":"Dalarnas","shortCode":"W"},{"name":"Gotlands","shortCode":"X"},{"name":"Gavleborgs","shortCode":"I"},{"name":"Hallands","shortCode":"N"},{"name":"Jamtlands","shortCode":"Z"},{"name":"Jonkopings","shortCode":"F"},{"name":"Kalmar","shortCode":"H"},{"name":"Kronobergs","shortCode":"G"},{"name":"Norrbottens","shortCode":"BD"},{"name":"Orebro","shortCode":"T"},{"name":"Ostergotlands","shortCode":"E"},{"name":"Skane","shortCode":"M"},{"name":"Sodermanlands","shortCode":"D"},{"name":"Stockholm","shortCode":"AB"},{"name":"Varmlands","shortCode":"S"},{"name":"Vasterbottens","shortCode":"AC"},{"name":"Vasternorrlands","shortCode":"Y"},{"name":"Vastmanlands","shortCode":"U"},{"name":"Vastra Gotalands","shortCode":"O"}]},{"countryName":"Switzerland","countryShortCode":"CH","regions":[{"name":"Aargau","shortCode":"AG"},{"name":"Appenzell Ausserrhoden","shortCode":"AR"},{"name":"Appenzell Innerhoden","shortCode":"AI"},{"name":"Basel-Landschaft","shortCode":"BL"},{"name":"Basel-Stadt","shortCode":"BS"},{"name":"Bern","shortCode":"BE"},{"name":"Fribourg","shortCode":"FR"},{"name":"Genève","shortCode":"GE"},{"name":"Glarus","shortCode":"GL"},{"name":"Graubünden","shortCode":"GR"},{"name":"Jura","shortCode":"JU"},{"name":"Luzern","shortCode":"LU"},{"name":"Neuchâtel","shortCode":"NE"},{"name":"Nidwalden","shortCode":"NW"},{"name":"Obwalden","shortCode":"OW"},{"name":"Sankt Gallen","shortCode":"SG"},{"name":"Schaffhausen","shortCode":"SH"},{"name":"Schwyz","shortCode":"SZ"},{"name":"Solothurn","shortCode":"SO"},{"name":"Thurgau","shortCode":"TG"},{"name":"Ticino","shortCode":"TI"},{"name":"Uri","shortCode":"UR"},{"name":"Valais","shortCode":"VS"},{"name":"Vaud","shortCode":"VD"},{"name":"Zug","shortCode":"ZG"},{"name":"Zürich","shortCode":"ZH"}]},{"countryName":"Syrian Arab Republic","countryShortCode":"SY","regions":[{"name":"Al Hasakah","shortCode":"HA"},{"name":"Al Ladhiqiyah","shortCode":"LA"},{"name":"Al Qunaytirah","shortCode":"QU"},{"name":"Ar Raqqah","shortCode":"RA"},{"name":"As Suwayda'","shortCode":"SU"},{"name":"Dar'a","shortCode":"DR"},{"name":"Dayr az Zawr","shortCode":"DY"},{"name":"Dimashq","shortCode":"DI"},{"name":"Halab","shortCode":"HL"},{"name":"Hamah","shortCode":"HM"},{"name":"Hims","shortCode":"HI"},{"name":"Idlib","shortCode":"ID"},{"name":"Rif Dimashq","shortCode":"RD"},{"name":"Tartus","shortCode":"TA"}]},{"countryName":"Taiwan","countryShortCode":"TW","regions":[{"name":"Chang-hua","shortCode":"CHA"},{"name":"Chia-i","shortCode":"CYQ"},{"name":"Hsin-chu","shortCode":"HSQ"},{"name":"Hua-lien","shortCode":"HUA"},{"name":"Kao-hsiung","shortCode":"KHH"},{"name":"Keelung","shortCode":"KEE"},{"name":"Kinmen","shortCode":"KIN"},{"name":"Lienchiang","shortCode":"LIE"},{"name":"Miao-li","shortCode":"MIA"},{"name":"Nan-t'ou","shortCode":"NAN"},{"name":"P'eng-hu","shortCode":"PEN"},{"name":"New Taipei","shortCode":"NWT"},{"name":"P'ing-chung","shortCode":"PIF"},{"name":"T'ai-chung","shortCode":"TXG"},{"name":"T'ai-nan","shortCode":"TNN"},{"name":"T'ai-pei","shortCode":"TPE"},{"name":"T'ai-tung","shortCode":"TTT"},{"name":"T'ao-yuan","shortCode":"TAO"},{"name":"Yi-lan","shortCode":"ILA"},{"name":"Yun-lin","shortCode":"YUN"}]},{"countryName":"Tajikistan","countryShortCode":"TJ","regions":[{"name":"Dushanbe","shortCode":"DU"},{"name":"Kŭhistoni Badakhshon","shortCode":"GB"},{"name":"Khatlon","shortCode":"KT"},{"name":"Sughd","shortCode":"SU"}]},{"countryName":"Tanzania, United Republic of","countryShortCode":"TZ","regions":[{"name":"Arusha","shortCode":"01"},{"name":"Coast","shortCode":"19"},{"name":"Dar es Salaam","shortCode":"02"},{"name":"Dodoma","shortCode":"03"},{"name":"Iringa","shortCode":"04"},{"name":"Kagera","shortCode":"05"},{"name":"Kigoma","shortCode":"08"},{"name":"Kilimanjaro","shortCode":"09"},{"name":"Lindi","shortCode":"12"},{"name":"Manyara","shortCode":"26"},{"name":"Mara","shortCode":"13"},{"name":"Mbeya","shortCode":"14"},{"name":"Morogoro","shortCode":"16"},{"name":"Mtwara","shortCode":"17"},{"name":"Mwanza","shortCode":"18"},{"name":"Pemba North","shortCode":"06"},{"name":"Pemba South","shortCode":"10"},{"name":"Rukwa","shortCode":"20"},{"name":"Ruvuma","shortCode":"21"},{"name":"Shinyanga","shortCode":"22"},{"name":"Singida","shortCode":"23"},{"name":"Tabora","shortCode":"24"},{"name":"Tanga","shortCode":"25"},{"name":"Zanzibar North","shortCode":"07"},{"name":"Zanzibar Central/South","shortCode":"11"},{"name":"Zanzibar Urban/West","shortCode":"15"}]},{"countryName":"Thailand","countryShortCode":"TH","regions":[{"name":"Amnat Charoen","shortCode":"37"},{"name":"Ang Thong","shortCode":"15"},{"name":"Bueng Kan","shortCode":"38"},{"name":"Buri Ram","shortCode":"31"},{"name":"Chachoengsao","shortCode":"24"},{"name":"Chai Nat","shortCode":"18"},{"name":"Chaiyaphum","shortCode":"36"},{"name":"Chanthaburi","shortCode":"22"},{"name":"Chiang Mai","shortCode":"50"},{"name":"Chiang Rai","shortCode":"57"},{"name":"Chon Buri","shortCode":"20"},{"name":"Chumphon","shortCode":"86"},{"name":"Kalasin","shortCode":"46"},{"name":"Kamphaeng Phet","shortCode":"62"},{"name":"Kanchanaburi","shortCode":"71"},{"name":"Khon Kaen","shortCode":"40"},{"name":"Krabi","shortCode":"81"},{"name":"Krung Thep Mahanakhon (Bangkok)","shortCode":"10"},{"name":"Lampang","shortCode":"52"},{"name":"Lamphun","shortCode":"51"},{"name":"Loei","shortCode":"42"},{"name":"Lop Buri","shortCode":"16"},{"name":"Mae Hong Son","shortCode":"58"},{"name":"Maha Sarakham","shortCode":"44"},{"name":"Mukdahan","shortCode":"49"},{"name":"Nakhon Nayok","shortCode":"26"},{"name":"Nakhon Phathom","shortCode":"73"},{"name":"Nakhon Phanom","shortCode":"48"},{"name":"Nakhon Ratchasima","shortCode":"30"},{"name":"Nakhon Sawan","shortCode":"60"},{"name":"Nakhon Si Thammarat","shortCode":"80"},{"name":"Nan","shortCode":"55"},{"name":"Narathiwat","shortCode":"96"},{"name":"Nong Bua Lam Phu","shortCode":"39"},{"name":"Nong Khai","shortCode":"43"},{"name":"Nonthaburi","shortCode":"12"},{"name":"Pathum Thani","shortCode":"13"},{"name":"Pattani","shortCode":"94"},{"name":"Phangnga","shortCode":"82"},{"name":"Phatthalung","shortCode":"93"},{"name":"Phayao","shortCode":"56"},{"name":"Phetchabun","shortCode":"76"},{"name":"Phetchaburi","shortCode":"76"},{"name":"Phichit","shortCode":"66"},{"name":"Phitsanulok","shortCode":"65"},{"name":"Phra Nakhon Si Ayutthaya","shortCode":"14"},{"name":"Phrae","shortCode":"54"},{"name":"Phuket","shortCode":"83"},{"name":"Prachin Buri","shortCode":"25"},{"name":"Prachuap Khiri Khan","shortCode":"77"},{"name":"Ranong","shortCode":"85"},{"name":"Ratchaburi","shortCode":"70"},{"name":"Rayong","shortCode":"21"},{"name":"Roi Et","shortCode":"45"},{"name":"Sa Kaeo","shortCode":"27"},{"name":"Sakon Nakhon","shortCode":"47"},{"name":"Samut Prakan","shortCode":"11"},{"name":"Samut Sakhon","shortCode":"74"},{"name":"Samut Songkhram","shortCode":"75"},{"name":"Saraburi","shortCode":"19"},{"name":"Satun","shortCode":"91"},{"name":"Sing Buri","shortCode":"17"},{"name":"Si Sa ket","shortCode":"33"},{"name":"Songkhla","shortCode":"90"},{"name":"Sukhothai","shortCode":"64"},{"name":"Suphan Buri","shortCode":"72"},{"name":"Surat Thani","shortCode":"84"},{"name":"Surin","shortCode":"32"},{"name":"Tak","shortCode":"63"},{"name":"Trang","shortCode":"92"},{"name":"Trat","shortCode":"23"},{"name":"Ubon Ratchathani","shortCode":"34"},{"name":"Udon Thani","shortCode":"41"},{"name":"Uthai Thani","shortCode":"61"},{"name":"Uttaradit","shortCode":"53"},{"name":"Yala","shortCode":"95"},{"name":"Yasothon","shortCode":"35"}]},{"countryName":"Timor-Leste","countryShortCode":"TL","regions":[{"name":"Aileu","shortCode":"AL"},{"name":"Ainaro","shortCode":"AN"},{"name":"Baucau","shortCode":"BA"},{"name":"Bobonaro","shortCode":"BO"},{"name":"Cova Lima","shortCode":"CO"},{"name":"Dili","shortCode":"DI"},{"name":"Ermera","shortCode":"ER"},{"name":"Lautem","shortCode":"LA"},{"name":"Liquica","shortCode":"LI"},{"name":"Manatuto","shortCode":"MT"},{"name":"Manufahi","shortCode":"MF"},{"name":"Oecussi","shortCode":"OE"},{"name":"Viqueque","shortCode":"VI"}]},{"countryName":"Togo","countryShortCode":"TG","regions":[{"name":"Centre","shortCode":"C"},{"name":"Kara","shortCode":"K"},{"name":"Maritime","shortCode":"M"},{"name":"Plateaux","shortCode":"P"},{"name":"Savannes","shortCode":"S"}]},{"countryName":"Tokelau","countryShortCode":"TK","regions":[{"name":"Atafu"},{"name":"Fakaofo"},{"name":"Nukunonu"}]},{"countryName":"Tonga","countryShortCode":"TO","regions":[{"name":"'Eua","shortCode":"01"},{"name":"Ha'apai","shortCode":"02"},{"name":"Niuas","shortCode":"03"},{"name":"Tongatapu","shortCode":"04"},{"name":"Vava'u","shortCode":"05"}]},{"countryName":"Trinidad and Tobago","countryShortCode":"TT","regions":[{"name":"Arima","shortCode":"ARI"},{"name":"Chaguanas","shortCode":"CHA"},{"name":"Couva-Tabaquite-Talparo","shortCode":"CTT"},{"name":"Diefo Martin","shortCode":"DMN"},{"name":"Mayaro-Rio Claro","shortCode":"MRC"},{"name":"Penal-Debe","shortCode":"PED"},{"name":"Point Fortin","shortCode":"PTF"},{"name":"Port-of-Spain","shortCode":"POS"},{"name":"Princes Town","shortCode":"PRT"},{"name":"San Fernando","shortCode":"SFO"},{"name":"San Juan-Laventille","shortCode":"SJL"},{"name":"Sangre Grande","shortCode":"SGE"},{"name":"Siparia","shortCode":"SIP"},{"name":"Tobago","shortCode":"TOB"},{"name":"Tunapuna-Piarco","shortCode":"TUP"}]},{"countryName":"Tunisia","countryShortCode":"TN","regions":[{"name":"Ariana","shortCode":"12"},{"name":"Beja","shortCode":"31"},{"name":"Ben Arous","shortCode":"13"},{"name":"Bizerte","shortCode":"23"},{"name":"Gabes","shortCode":"81"},{"name":"Gafsa","shortCode":"71"},{"name":"Jendouba","shortCode":"32"},{"name":"Kairouan","shortCode":"41"},{"name":"Kasserine","shortCode":"42"},{"name":"Kebili","shortCode":"73"},{"name":"Kef","shortCode":"33"},{"name":"Mahdia","shortCode":"53"},{"name":"Medenine","shortCode":"82"},{"name":"Monastir","shortCode":"52"},{"name":"Nabeul","shortCode":"21"},{"name":"Sfax","shortCode":"61"},{"name":"Sidi Bouzid","shortCode":"43"},{"name":"Siliana","shortCode":"34"},{"name":"Sousse","shortCode":"51"},{"name":"Tataouine","shortCode":"83"},{"name":"Tozeur","shortCode":"72"},{"name":"Tunis","shortCode":"11"},{"name":"Zaghouan","shortCode":"22"}]},{"countryName":"Turkey","countryShortCode":"TR","regions":[{"name":"Adana","shortCode":"01"},{"name":"Adiyaman","shortCode":"02"},{"name":"Afyonkarahisar","shortCode":"03"},{"name":"Agri","shortCode":"04"},{"name":"Aksaray","shortCode":"68"},{"name":"Amasya","shortCode":"05"},{"name":"Ankara","shortCode":"06"},{"name":"Antalya","shortCode":"07"},{"name":"Ardahan","shortCode":"75"},{"name":"Artvin","shortCode":"08"},{"name":"Aydin","shortCode":"09"},{"name":"Balikesir","shortCode":"10"},{"name":"Bartin","shortCode":"74"},{"name":"Batman","shortCode":"72"},{"name":"Bayburt","shortCode":"69"},{"name":"Bilecik","shortCode":"11"},{"name":"Bingol","shortCode":"12"},{"name":"Bitlis","shortCode":"13"},{"name":"Bolu","shortCode":"14"},{"name":"Burdur","shortCode":"15"},{"name":"Bursa","shortCode":"16"},{"name":"Canakkale","shortCode":"17"},{"name":"Cankiri","shortCode":"18"},{"name":"Corum","shortCode":"19"},{"name":"Denizli","shortCode":"20"},{"name":"Diyarbakir","shortCode":"21"},{"name":"Duzce","shortCode":"81"},{"name":"Edirne","shortCode":"22"},{"name":"Elazig","shortCode":"23"},{"name":"Erzincan","shortCode":"24"},{"name":"Erzurum","shortCode":"25"},{"name":"Eskisehir","shortCode":"26"},{"name":"Gaziantep","shortCode":"27"},{"name":"Giresun","shortCode":"28"},{"name":"Gumushane","shortCode":"29"},{"name":"Hakkari","shortCode":"30"},{"name":"Hatay","shortCode":"31"},{"name":"Igdir","shortCode":"76"},{"name":"Isparta","shortCode":"32"},{"name":"Istanbul","shortCode":"34"},{"name":"Izmir","shortCode":"35"},{"name":"Kahramanmaras","shortCode":"46"},{"name":"Karabuk","shortCode":"78"},{"name":"Karaman","shortCode":"70"},{"name":"Kars","shortCode":"36"},{"name":"Kastamonu","shortCode":"37"},{"name":"Kayseri","shortCode":"38"},{"name":"Kilis","shortCode":"79"},{"name":"Kirikkale","shortCode":"71"},{"name":"Kirklareli","shortCode":"39"},{"name":"Kirsehir","shortCode":"40"},{"name":"Kocaeli","shortCode":"41"},{"name":"Konya","shortCode":"42"},{"name":"Kutahya","shortCode":"43"},{"name":"Malatya","shortCode":"44"},{"name":"Manisa","shortCode":"45"},{"name":"Mardin","shortCode":"47"},{"name":"Mersin","shortCode":"33"},{"name":"Mugla","shortCode":"48"},{"name":"Mus","shortCode":"49"},{"name":"Nevsehir","shortCode":"50"},{"name":"Nigde","shortCode":"51"},{"name":"Ordu","shortCode":"52"},{"name":"Osmaniye","shortCode":"80"},{"name":"Rize","shortCode":"53"},{"name":"Sakarya","shortCode":"54"},{"name":"Samsun","shortCode":"55"},{"name":"Sanliurfa","shortCode":"63"},{"name":"Siirt","shortCode":"56"},{"name":"Sinop","shortCode":"57"},{"name":"Sirnak","shortCode":"73"},{"name":"Sivas","shortCode":"58"},{"name":"Tekirdag","shortCode":"59"},{"name":"Tokat","shortCode":"60"},{"name":"Trabzon","shortCode":"61"},{"name":"Tunceli","shortCode":"62"},{"name":"Usak","shortCode":"64"},{"name":"Van","shortCode":"65"},{"name":"Yalova","shortCode":"77"},{"name":"Yozgat","shortCode":"66"},{"name":"Zonguldak","shortCode":"67"}]},{"countryName":"Turkmenistan","countryShortCode":"TM","regions":[{"name":"Ahal","shortCode":"A"},{"name":"Asgabat","shortCode":"S"},{"name":"Balkan","shortCode":"B"},{"name":"Dashoguz","shortCode":"D"},{"name":"Lebap","shortCode":"L"},{"name":"Mary","shortCode":"M"}]},{"countryName":"Turks and Caicos Islands","countryShortCode":"TC","regions":[{"name":"Turks and Caicos Islands"}]},{"countryName":"Tuvalu","countryShortCode":"TV","regions":[{"name":"Funafuti","shortCode":"FUN"},{"name":"Nanumanga","shortCode":"NMG"},{"name":"Nanumea","shortCode":"NMA"},{"name":"Niutao","shortCode":"NIT"},{"name":"Nui","shortCode":"NUI"},{"name":"Nukufetau","shortCode":"NKF"},{"name":"Nukulaelae","shortCode":"NKL"},{"name":"Vaitupu","shortCode":"VAU"}]},{"countryName":"Uganda","countryShortCode":"UG","regions":[{"name":"Abim","shortCode":"317"},{"name":"Adjumani","shortCode":"301"},{"name":"Amolatar","shortCode":"314"},{"name":"Amuria","shortCode":"216"},{"name":"Amuru","shortCode":"319"},{"name":"Apac","shortCode":"302"},{"name":"Arua","shortCode":"303"},{"name":"Budaka","shortCode":"217"},{"name":"Bududa","shortCode":"223"},{"name":"Bugiri","shortCode":"201"},{"name":"Bukedea","shortCode":"224"},{"name":"Bukwa","shortCode":"218"},{"name":"Buliisa","shortCode":"419"},{"name":"Bundibugyo","shortCode":"401"},{"name":"Bushenyi","shortCode":"402"},{"name":"Busia","shortCode":"202"},{"name":"Butaleja","shortCode":"219"},{"name":"Dokolo","shortCode":"318"},{"name":"Gulu","shortCode":"304"},{"name":"Hoima","shortCode":"403"},{"name":"Ibanda","shortCode":"416"},{"name":"Iganga","shortCode":"203"},{"name":"Isingiro","shortCode":"417"},{"name":"Jinja","shortCode":"204"},{"name":"Kaabong","shortCode":"315"},{"name":"Kabale","shortCode":"404"},{"name":"Kabarole","shortCode":"405"},{"name":"Kaberamaido","shortCode":"213"},{"name":"Kalangala","shortCode":"101"},{"name":"Kaliro","shortCode":"220"},{"name":"Kampala","shortCode":"102"},{"name":"Kamuli","shortCode":"205"},{"name":"Kamwenge","shortCode":"413"},{"name":"Kanungu","shortCode":"414"},{"name":"Kapchorwa","shortCode":"206"},{"name":"Kasese","shortCode":"406"},{"name":"Katakwi","shortCode":"207"},{"name":"Kayunga","shortCode":"112"},{"name":"Kibaale","shortCode":"407"},{"name":"Kiboga","shortCode":"103"},{"name":"Kiruhura","shortCode":"418"},{"name":"Kisoro","shortCode":"408"},{"name":"Kitgum","shortCode":"305"},{"name":"Koboko","shortCode":"316"},{"name":"Kotido","shortCode":"306"},{"name":"Kumi","shortCode":"208"},{"name":"Kyenjojo","shortCode":"415"},{"name":"Lira","shortCode":"307"},{"name":"Luwero","shortCode":"104"},{"name":"Lyantonde","shortCode":"116"},{"name":"Manafwa","shortCode":"221"},{"name":"Maracha","shortCode":"320"},{"name":"Masaka","shortCode":"105"},{"name":"Masindi","shortCode":"409"},{"name":"Mayuge","shortCode":"214"},{"name":"Mbale","shortCode":"209"},{"name":"Mbarara","shortCode":"410"},{"name":"Mityana","shortCode":"114"},{"name":"Moroto","shortCode":"308"},{"name":"Moyo","shortCode":"309"},{"name":"Mpigi","shortCode":"106"},{"name":"Mubende","shortCode":"107"},{"name":"Mukono","shortCode":"108"},{"name":"Nakapiripirit","shortCode":"311"},{"name":"Nakaseke","shortCode":"115"},{"name":"Nakasongola","shortCode":"109"},{"name":"Namutumba","shortCode":"222"},{"name":"Nebbi","shortCode":"310"},{"name":"Ntungamo","shortCode":"411"},{"name":"Oyam","shortCode":"321"},{"name":"Pader","shortCode":"312"},{"name":"Pallisa","shortCode":"210"},{"name":"Rakai","shortCode":"110"},{"name":"Rukungiri","shortCode":"412"},{"name":"Sembabule","shortCode":"111"},{"name":"Sironko","shortCode":"215"},{"name":"Soroti","shortCode":"211"},{"name":"Tororo","shortCode":"212"},{"name":"Wakiso","shortCode":"113"},{"name":"Yumbe","shortCode":"313"}]},{"countryName":"Ukraine","countryShortCode":"UA","regions":[{"name":"Cherkasy","shortCode":"71"},{"name":"Chernihiv","shortCode":"74"},{"name":"Chernivtsi","shortCode":"77"},{"name":"Dnipropetrovsk","shortCode":"12"},{"name":"Donetsk","shortCode":"14"},{"name":"Ivano-Frankivsk","shortCode":"26"},{"name":"Kharkiv","shortCode":"63"},{"name":"Kherson","shortCode":"65"},{"name":"Khmelnytskyi","shortCode":"68"},{"name":"Kiev","shortCode":"32"},{"name":"Kirovohrad","shortCode":"35"},{"name":"Luhansk","shortCode":"09"},{"name":"Lviv","shortCode":"46"},{"name":"Mykolaiv","shortCode":"48"},{"name":"Odessa","shortCode":"51"},{"name":"Poltava","shortCode":"53"},{"name":"Rivne","shortCode":"56"},{"name":"Sumy","shortCode":"59"},{"name":"Ternopil","shortCode":"61"},{"name":"Vinnytsia","shortCode":"05"},{"name":"Volyn","shortCode":"07"},{"name":"Zakarpattia","shortCode":"21"},{"name":"Zaporizhia","shortCode":"23"},{"name":"Zhytomyr","shortCode":"18"},{"name":"Avtonomna Respublika Krym","shortCode":"43"},{"name":"Kyïv","shortCode":"30"},{"name":"Sevastopol","shortCode":"40"}]},{"countryName":"United Arab Emirates","countryShortCode":"AE","regions":[{"name":"Abu Dhabi","shortCode":"AZ"},{"name":"Ajman","shortCode":"AJ"},{"name":"Dubai","shortCode":"DU"},{"name":"Fujairah","shortCode":"FU"},{"name":"Ras al Khaimah","shortCode":"RK"},{"name":"Sharjah","shortCode":"SH"},{"name":"Umm Al Quwain","shortCode":"UQ"}]},{"countryName":"United Kingdom","countryShortCode":"GB","regions":[{"name":"Avon","shortCode":"AVN"},{"name":"Bedfordshire","shortCode":"BDF"},{"name":"Berkshire","shortCode":"BRK"},{"name":"Bristol, City of","shortCode":"COB"},{"name":"Buckinghamshire","shortCode":"BKM"},{"name":"Cambridgeshire","shortCode":"CAM"},{"name":"Cheshire","shortCode":"CHS"},{"name":"Cleveland","shortCode":"CLV"},{"name":"Cornwall","shortCode":"CON"},{"name":"Cumbria","shortCode":"CMA"},{"name":"Derbyshire","shortCode":"DBY"},{"name":"Devon","shortCode":"DEV"},{"name":"Dorset","shortCode":"DOR"},{"name":"Durham","shortCode":"DUR"},{"name":"East Sussex","shortCode":"SXE"},{"name":"Essex","shortCode":"ESS"},{"name":"Gloucestershire","shortCode":"GLS"},{"name":"Greater London","shortCode":"LND"},{"name":"Greater Manchester","shortCode":"GTM"},{"name":"Hampshire (County of Southampton)","shortCode":"HAM"},{"name":"Hereford and Worcester","shortCode":"HWR"},{"name":"Herefordshire","shortCode":"HEF"},{"name":"Hertfordshire","shortCode":"HRT"},{"name":"Isle of Wight","shortCode":"IOW"},{"name":"Kent","shortCode":"KEN"},{"name":"Lancashire","shortCode":"LAN"},{"name":"Leicestershire","shortCode":"LEI"},{"name":"Lincolnshire","shortCode":"LIN"},{"name":"London","shortCode":"LDN"},{"name":"Merseyside","shortCode":"MSY"},{"name":"Middlesex","shortCode":"MDX"},{"name":"Norfolk","shortCode":"NFK"},{"name":"Northamptonshire","shortCode":"NTH"},{"name":"Northumberland","shortCode":"NBL"},{"name":"North Humberside","shortCode":"NHM"},{"name":"North Yorkshire","shortCode":"NYK"},{"name":"Nottinghamshire","shortCode":"NTT"},{"name":"Oxfordshire","shortCode":"OXF"},{"name":"Rutland","shortCode":"RUT"},{"name":"Shropshire","shortCode":"SAL"},{"name":"Somerset","shortCode":"SOM"},{"name":"South Humberside","shortCode":"SHM"},{"name":"South Yorkshire","shortCode":"SYK"},{"name":"Staffordshire","shortCode":"STS"},{"name":"Suffolk","shortCode":"SFK"},{"name":"Surrey","shortCode":"SRY"},{"name":"Tyne and Wear","shortCode":"TWR"},{"name":"Warwickshire","shortCode":"WAR"},{"name":"West Midlands","shortCode":"WMD"},{"name":"West Sussex","shortCode":"SXW"},{"name":"West Yorkshire","shortCode":"WYK"},{"name":"Wiltshire","shortCode":"WIL"},{"name":"Worcestershire","shortCode":"WOR"},{"name":"Antrim","shortCode":"ANT"},{"name":"Armagh","shortCode":"ARM"},{"name":"Belfast, City of","shortCode":"BLF"},{"name":"Down","shortCode":"DOW"},{"name":"Fermanagh","shortCode":"FER"},{"name":"Londonderry","shortCode":"LDY"},{"name":"Derry, City of","shortCode":"DRY"},{"name":"Tyrone","shortCode":"TYR"},{"name":"Aberdeen, City of","shortCode":"AN"},{"name":"Aberdeenshire","shortCode":"ABD"},{"name":"Angus (Forfarshire)","shortCode":"ANS"},{"name":"Argyll","shortCode":"AGB"},{"name":"Ayrshire","shortCode":"ARG"},{"name":"Banffshire","shortCode":"BAN"},{"name":"Berwickshire","shortCode":"BEW"},{"name":"Bute","shortCode":"BUT"},{"name":"Caithness","shortCode":"CAI"},{"name":"Clackmannanshire","shortCode":"CLK"},{"name":"Cromartyshire","shortCode":"COC"},{"name":"Dumfriesshire","shortCode":"DFS"},{"name":"Dunbartonshire (Dumbarton)","shortCode":"DNB"},{"name":"Dundee, City of","shortCode":"DD"},{"name":"East Lothian (Haddingtonshire)","shortCode":"ELN"},{"name":"Edinburgh, City of","shortCode":"EB"},{"name":"Fife","shortCode":"FIF"},{"name":"Glasgow, City of","shortCode":"GLA"},{"name":"Inverness-shire","shortCode":"INV"},{"name":"Kincardineshire","shortCode":"KCD"},{"name":"Kinross-shire","shortCode":"KRS"},{"name":"Kirkcudbrightshire","shortCode":"KKD"},{"name":"Lanarkshire","shortCode":"LKS"},{"name":"Midlothian (County of Edinburgh)","shortCode":"MLN"},{"name":"Moray (Elginshire)","shortCode":"MOR"},{"name":"Nairnshire","shortCode":"NAI"},{"name":"Orkney","shortCode":"OKI"},{"name":"Peeblesshire","shortCode":"PEE"},{"name":"Perthshire","shortCode":"PER"},{"name":"Renfrewshire","shortCode":"RFW"},{"name":"Ross and Cromarty","shortCode":"ROC"},{"name":"Ross-shire","shortCode":"ROS"},{"name":"Roxburghshire","shortCode":"ROX"},{"name":"Selkirkshire","shortCode":"SEL"},{"name":"Shetland (Zetland)","shortCode":"SHI"},{"name":"Stirlingshire","shortCode":"STI"},{"name":"Sutherland","shortCode":"SUT"},{"name":"West Lothian (Linlithgowshire)","shortCode":"WLN"},{"name":"Wigtownshire","shortCode":"WIG"},{"name":"Clwyd","shortCode":"CWD"},{"name":"Dyfed","shortCode":"DFD"},{"name":"Gwent","shortCode":"GNT"},{"name":"Gwynedd","shortCode":"GWN"},{"name":"Mid Glamorgan","shortCode":"MGM"},{"name":"Powys","shortCode":"POW"},{"name":"South Glamorgan","shortCode":"SGM"},{"name":"West Glamorgan","shortCode":"WGM"}]},{"countryName":"United States","countryShortCode":"US","regions":[{"name":"Alabama","shortCode":"AL"},{"name":"Alaska","shortCode":"AK"},{"name":"American Samoa","shortCode":"AS"},{"name":"Arizona","shortCode":"AZ"},{"name":"Arkansas","shortCode":"AR"},{"name":"California","shortCode":"CA"},{"name":"Colorado","shortCode":"CO"},{"name":"Connecticut","shortCode":"CT"},{"name":"Delaware","shortCode":"DE"},{"name":"District of Columbia","shortCode":"DC"},{"name":"Micronesia","shortCode":"FM"},{"name":"Florida","shortCode":"FL"},{"name":"Georgia","shortCode":"GA"},{"name":"Guam","shortCode":"GU"},{"name":"Hawaii","shortCode":"HI"},{"name":"Idaho","shortCode":"ID"},{"name":"Illinois","shortCode":"IL"},{"name":"Indiana","shortCode":"IN"},{"name":"Iowa","shortCode":"IA"},{"name":"Kansas","shortCode":"KS"},{"name":"Kentucky","shortCode":"KY"},{"name":"Louisiana","shortCode":"LA"},{"name":"Maine","shortCode":"ME"},{"name":"Marshall Islands","shortCode":"MH"},{"name":"Maryland","shortCode":"MD"},{"name":"Massachusetts","shortCode":"MA"},{"name":"Michigan","shortCode":"MI"},{"name":"Minnesota","shortCode":"MN"},{"name":"Mississippi","shortCode":"MS"},{"name":"Missouri","shortCode":"MO"},{"name":"Montana","shortCode":"MT"},{"name":"Nebraska","shortCode":"NE"},{"name":"Nevada","shortCode":"NV"},{"name":"New Hampshire","shortCode":"NH"},{"name":"New Jersey","shortCode":"NJ"},{"name":"New Mexico","shortCode":"NM"},{"name":"New York","shortCode":"NY"},{"name":"North Carolina","shortCode":"NC"},{"name":"North Dakota","shortCode":"ND"},{"name":"Northern Mariana Islands","shortCode":"MP"},{"name":"Ohio","shortCode":"OH"},{"name":"Oklahoma","shortCode":"OK"},{"name":"Oregon","shortCode":"OR"},{"name":"Palau","shortCode":"PW"},{"name":"Pennsylvania","shortCode":"PA"},{"name":"Puerto Rico","shortCode":"PR"},{"name":"Rhode Island","shortCode":"RI"},{"name":"South Carolina","shortCode":"SC"},{"name":"South Dakota","shortCode":"SD"},{"name":"Tennessee","shortCode":"TN"},{"name":"Texas","shortCode":"TX"},{"name":"Utah","shortCode":"UT"},{"name":"Vermont","shortCode":"VT"},{"name":"Virgin Islands","shortCode":"VI"},{"name":"Virginia","shortCode":"VA"},{"name":"Washington","shortCode":"WA"},{"name":"West Virginia","shortCode":"WV"},{"name":"Wisconsin","shortCode":"WI"},{"name":"Wyoming","shortCode":"WY"},{"name":"Armed Forces Americas","shortCode":"AA"},{"name":"Armed Forces Europe, Canada, Africa and Middle East","shortCode":"AE"},{"name":"Armed Forces Pacific","shortCode":"AP"}]},{"countryName":"United States Minor Outlying Islands","countryShortCode":"UM","regions":[{"name":"Baker Island","shortCode":"81"},{"name":"Howland Island","shortCode":"84"},{"name":"Jarvis Island","shortCode":"86"},{"name":"Johnston Atoll","shortCode":"67"},{"name":"Kingman Reef","shortCode":"89"},{"name":"Midway Islands","shortCode":"71"},{"name":"Navassa Island","shortCode":"76"},{"name":"Palmyra Atoll","shortCode":"95"},{"name":"Wake Island","shortCode":"79"},{"name":"Bajo Nuevo Bank","shortCode":"BN"},{"name":"Serranilla Bank","shortCode":"SB"}]},{"countryName":"Uruguay","countryShortCode":"UY","regions":[{"name":"Artigas","shortCode":"AR"},{"name":"Canelones","shortCode":"CA"},{"name":"Cerro Largo","shortCode":"CL"},{"name":"Colonia","shortCode":"CO"},{"name":"Durazno","shortCode":"DU"},{"name":"Flores","shortCode":"FS"},{"name":"Florida","shortCode":"FD"},{"name":"Lavalleja","shortCode":"LA"},{"name":"Maldonado","shortCode":"MA"},{"name":"Montevideo","shortCode":"MO"},{"name":"Paysandú","shortCode":"PA"},{"name":"Río Negro","shortCode":"RN"},{"name":"Rivera","shortCode":"RV"},{"name":"Rocha","shortCode":"RO"},{"name":"Salto","shortCode":"SA"},{"name":"San José","shortCode":"SJ"},{"name":"Soriano","shortCode":"SO"},{"name":"Tacuarembó","shortCode":"TA"},{"name":"Treinta y Tres","shortCode":"TT"}]},{"countryName":"Uzbekistan","countryShortCode":"UZ","regions":[{"name":"Toshkent shahri","shortCode":"TK"},{"name":"Andijon","shortCode":"AN"},{"name":"Buxoro","shortCode":"BU"},{"name":"Farg‘ona","shortCode":"FA"},{"name":"Jizzax","shortCode":"JI"},{"name":"Namangan","shortCode":"NG"},{"name":"Navoiy","shortCode":"NW"},{"name":"Qashqadaryo (Qarshi)","shortCode":"QA"},{"name":"Samarqand","shortCode":"SA"},{"name":"Sirdaryo (Guliston)","shortCode":"SI"},{"name":"Surxondaryo (Termiz)","shortCode":"SU"},{"name":"Toshkent wiloyati","shortCode":"TO"},{"name":"Xorazm (Urganch)","shortCode":"XO"},{"name":"Qoraqalpog‘iston Respublikasi (Nukus)","shortCode":"QR"}]},{"countryName":"Vanuatu","countryShortCode":"VU","regions":[{"name":"Malampa","shortCode":"MAP"},{"name":"Pénama","shortCode":"PAM"},{"name":"Sanma","shortCode":"SAM"},{"name":"Shéfa","shortCode":"SEE"},{"name":"Taféa","shortCode":"TAE"},{"name":"Torba","shortCode":"TOB"}]},{"countryName":"Venezuela, Bolivarian Republic of","countryShortCode":"VE","regions":[{"name":"Dependencias Federales","shortCode":"W"},{"name":"Distrito Federal","shortCode":"A"},{"name":"Amazonas","shortCode":"Z"},{"name":"Anzoátegui","shortCode":"B"},{"name":"Apure","shortCode":"C"},{"name":"Aragua","shortCode":"D"},{"name":"Barinas","shortCode":"E"},{"name":"Bolívar","shortCode":"F"},{"name":"Carabobo","shortCode":"G"},{"name":"Cojedes","shortCode":"H"},{"name":"Delta Amacuro","shortCode":"Y"},{"name":"Falcón","shortCode":"I"},{"name":"Guárico","shortCode":"J"},{"name":"Lara","shortCode":"K"},{"name":"Mérida","shortCode":"L"},{"name":"Miranda","shortCode":"M"},{"name":"Monagas","shortCode":"N"},{"name":"Nueva Esparta","shortCode":"O"},{"name":"Portuguesa","shortCode":"P"},{"name":"Sucre","shortCode":"R"},{"name":"Táchira","shortCode":"S"},{"name":"Trujillo","shortCode":"T"},{"name":"Vargas","shortCode":"X"},{"name":"Yaracuy","shortCode":"U"},{"name":"Zulia","shortCode":"V"}]},{"countryName":"Vietnam","countryShortCode":"VN","regions":[{"name":"Đồng Nai","shortCode":"39"},{"name":"Đồng Tháp","shortCode":"45"},{"name":"Gia Lai","shortCode":"30"},{"name":"Hà Giang","shortCode":"03"},{"name":"Hà Nam","shortCode":"63"},{"name":"Hà Tây","shortCode":"15"},{"name":"Hà Tĩnh","shortCode":"23"},{"name":"Hải Dương","shortCode":"61"},{"name":"Hậu Giang","shortCode":"73"},{"name":"Hòa Bình","shortCode":"14"},{"name":"Hưng Yên","shortCode":"66"},{"name":"Khánh Hòa","shortCode":"34"},{"name":"Kiên Giang","shortCode":"47"},{"name":"Kon Tum","shortCode":"28"},{"name":"Lai Châu","shortCode":"01"},{"name":"Lâm Đồng","shortCode":"35"},{"name":"Lạng Sơn","shortCode":"09"},{"name":"Lào Cai","shortCode":"02"},{"name":"Long An","shortCode":"41"},{"name":"Nam Định","shortCode":"67"},{"name":"Nghệ An","shortCode":"22"},{"name":"Ninh Bình","shortCode":"18"},{"name":"Ninh Thuận","shortCode":"36"},{"name":"Phú Thọ","shortCode":"68"},{"name":"Phú Yên","shortCode":"32"},{"name":"Quảng Bình","shortCode":"24"},{"name":"Quảng Nam","shortCode":"27"},{"name":"Quảng Ngãi","shortCode":"29"},{"name":"Quảng Ninh","shortCode":"13"},{"name":"Quảng Trị","shortCode":"25"},{"name":"Sóc Trăng","shortCode":"52"},{"name":"Sơn La","shortCode":"05"},{"name":"Tây Ninh","shortCode":"37"},{"name":"Thái Bình","shortCode":"20"},{"name":"Thái Nguyên","shortCode":"69"},{"name":"Thanh Hóa","shortCode":"21"},{"name":"Thừa Thiên–Huế","shortCode":"26"},{"name":"Tiền Giang","shortCode":"46"},{"name":"Trà Vinh","shortCode":"51"},{"name":"Tuyên Quang","shortCode":"07"},{"name":"Vĩnh Long","shortCode":"49"},{"name":"Vĩnh Phúc","shortCode":"70"},{"name":"Yên Bái","shortCode":"06"},{"name":"Cần Thơ","shortCode":"CT"},{"name":"Đà Nẵng","shortCode":"DN"},{"name":"Hà Nội","shortCode":"HN"},{"name":"Hải Phòng","shortCode":"HP"},{"name":"Hồ Chí Minh (Sài Gòn)","shortCode":"SG"}]},{"countryName":"Virgin Islands, British","countryShortCode":"VG","regions":[{"name":"Anegada","shortCode":"ANG"},{"name":"Jost Van Dyke","shortCode":"JVD"},{"name":"Tortola","shortCode":"TTA"},{"name":"Virgin Gorda","shortCode":"VGD"}]},{"countryName":"Virgin Islands, U.S.","countryShortCode":"VI","regions":[{"name":"St. Thomas","shortCode":"STH"},{"name":"St. John","shortCode":"SJO"},{"name":"St. Croix","shortCode":"SCR"}]},{"countryName":"Wallis and Futuna","countryShortCode":"WF","regions":[{"name":"Alo","shortCode":"ALO"},{"name":"Sigave","shortCode":"SIG"},{"name":"Wallis","shortCode":"WAL"}]},{"countryName":"Western Sahara","countryShortCode":"EH","regions":[{"name":"Es Smara","shortCode":"ESM"},{"name":"Boujdour","shortCode":"BOD"},{"name":"Laâyoune","shortCode":"LAA"},{"name":"Aousserd","shortCode":"AOU"},{"name":"Oued ed Dahab","shortCode":"OUD"}]},{"countryName":"Yemen","countryShortCode":"YE","regions":[{"name":"Abyān","shortCode":"AB"},{"name":"'Adan","shortCode":"AD"},{"name":"Aḑ Ḑāli'","shortCode":"DA"},{"name":"Al Bayḑā'","shortCode":"BA"},{"name":"Al Ḩudaydah","shortCode":"HU"},{"name":"Al Jawf","shortCode":"JA"},{"name":"Al Mahrah","shortCode":"MR"},{"name":"Al Maḩwīt","shortCode":"MW"},{"name":"'Amrān","shortCode":"AM"},{"name":"Dhamār","shortCode":"DH"},{"name":"Ḩaḑramawt","shortCode":"HD"},{"name":"Ḩajjah","shortCode":"HJ"},{"name":"Ibb","shortCode":"IB"},{"name":"Laḩij","shortCode":"LA"},{"name":"Ma'rib","shortCode":"MA"},{"name":"Raymah","shortCode":"RA"},{"name":"Şā‘dah","shortCode":"SD"},{"name":"Şan‘ā'","shortCode":"SN"},{"name":"Shabwah","shortCode":"SH"},{"name":"Tā‘izz","shortCode":"TA"}]},{"countryName":"Zambia","countryShortCode":"ZM","regions":[{"name":"Central","shortCode":"02"},{"name":"Copperbelt","shortCode":"08"},{"name":"Eastern","shortCode":"03"},{"name":"Luapula","shortCode":"04"},{"name":"Lusaka","shortCode":"09"},{"name":"Northern","shortCode":"05"},{"name":"North-Western","shortCode":"06"},{"name":"Southern","shortCode":"07"},{"name":"Western","shortCode":"01"}]},{"countryName":"Zimbabwe","countryShortCode":"ZW","regions":[{"name":"Bulawayo","shortCode":"BU"},{"name":"Harare","shortCode":"HA"},{"name":"Manicaland","shortCode":"MA"},{"name":"Mashonaland Central","shortCode":"MC"},{"name":"Mashonaland East","shortCode":"ME"},{"name":"Mashonaland West","shortCode":"MW"},{"name":"Masvingo","shortCode":"MV"},{"name":"Matabeleland North","shortCode":"MN"},{"name":"Matabeleland South","shortCode":"MS"},{"name":"Midlands","shortCode":"MI"}]}];
	
	/***/ }),
	
	/***/ "5147":
	/***/ (function(module, exports, __webpack_require__) {
	
	var MATCH = __webpack_require__("2b4c")('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};
	
	
	/***/ }),
	
	/***/ "52a7":
	/***/ (function(module, exports) {
	
	exports.f = {}.propertyIsEnumerable;
	
	
	/***/ }),
	
	/***/ "5537":
	/***/ (function(module, exports, __webpack_require__) {
	
	var core = __webpack_require__("8378");
	var global = __webpack_require__("7726");
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__("2d00") ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});
	
	
	/***/ }),
	
	/***/ "55dd":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var $export = __webpack_require__("5ca1");
	var aFunction = __webpack_require__("d8e8");
	var toObject = __webpack_require__("4bf8");
	var fails = __webpack_require__("79e5");
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__("2f21")($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});
	
	
	/***/ }),
	
	/***/ "5ca1":
	/***/ (function(module, exports, __webpack_require__) {
	
	var global = __webpack_require__("7726");
	var core = __webpack_require__("8378");
	var hide = __webpack_require__("32e9");
	var redefine = __webpack_require__("2aba");
	var ctx = __webpack_require__("9b43");
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;
	
	
	/***/ }),
	
	/***/ "5eda":
	/***/ (function(module, exports, __webpack_require__) {
	
	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__("5ca1");
	var core = __webpack_require__("8378");
	var fails = __webpack_require__("79e5");
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};
	
	
	/***/ }),
	
	/***/ "613b":
	/***/ (function(module, exports, __webpack_require__) {
	
	var shared = __webpack_require__("5537")('keys');
	var uid = __webpack_require__("ca5a");
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};
	
	
	/***/ }),
	
	/***/ "626a":
	/***/ (function(module, exports, __webpack_require__) {
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__("2d95");
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};
	
	
	/***/ }),
	
	/***/ "6762":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__("5ca1");
	var $includes = __webpack_require__("c366")(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__("9c6c")('includes');
	
	
	/***/ }),
	
	/***/ "6821":
	/***/ (function(module, exports, __webpack_require__) {
	
	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__("626a");
	var defined = __webpack_require__("be13");
	module.exports = function (it) {
	  return IObject(defined(it));
	};
	
	
	/***/ }),
	
	/***/ "69a8":
	/***/ (function(module, exports) {
	
	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};
	
	
	/***/ }),
	
	/***/ "6a99":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__("d3f4");
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};
	
	
	/***/ }),
	
	/***/ "7333":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__("0d58");
	var gOPS = __webpack_require__("2621");
	var pIE = __webpack_require__("52a7");
	var toObject = __webpack_require__("4bf8");
	var IObject = __webpack_require__("626a");
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__("79e5")(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;
	
	
	/***/ }),
	
	/***/ "7514":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__("5ca1");
	var $find = __webpack_require__("0a49")(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__("9c6c")(KEY);
	
	
	/***/ }),
	
	/***/ "7726":
	/***/ (function(module, exports) {
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "77f1":
	/***/ (function(module, exports, __webpack_require__) {
	
	var toInteger = __webpack_require__("4588");
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};
	
	
	/***/ }),
	
	/***/ "79e5":
	/***/ (function(module, exports) {
	
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};
	
	
	/***/ }),
	
	/***/ "7f20":
	/***/ (function(module, exports, __webpack_require__) {
	
	var def = __webpack_require__("86cc").f;
	var has = __webpack_require__("69a8");
	var TAG = __webpack_require__("2b4c")('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};
	
	
	/***/ }),
	
	/***/ "7f7f":
	/***/ (function(module, exports, __webpack_require__) {
	
	var dP = __webpack_require__("86cc").f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});
	
	
	/***/ }),
	
	/***/ "8378":
	/***/ (function(module, exports) {
	
	var core = module.exports = { version: '2.5.7' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	
	
	/***/ }),
	
	/***/ "84f2":
	/***/ (function(module, exports) {
	
	module.exports = {};
	
	
	/***/ }),
	
	/***/ "86cc":
	/***/ (function(module, exports, __webpack_require__) {
	
	var anObject = __webpack_require__("cb7c");
	var IE8_DOM_DEFINE = __webpack_require__("c69a");
	var toPrimitive = __webpack_require__("6a99");
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	
	
	/***/ }),
	
	/***/ "9b43":
	/***/ (function(module, exports, __webpack_require__) {
	
	// optional / simple context binding
	var aFunction = __webpack_require__("d8e8");
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};
	
	
	/***/ }),
	
	/***/ "9c6c":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};
	
	
	/***/ }),
	
	/***/ "9def":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.1.15 ToLength
	var toInteger = __webpack_require__("4588");
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};
	
	
	/***/ }),
	
	/***/ "9e1e":
	/***/ (function(module, exports, __webpack_require__) {
	
	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__("79e5")(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "aae3":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__("d3f4");
	var cof = __webpack_require__("2d95");
	var MATCH = __webpack_require__("2b4c")('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};
	
	
	/***/ }),
	
	/***/ "ac6a":
	/***/ (function(module, exports, __webpack_require__) {
	
	var $iterators = __webpack_require__("cadf");
	var getKeys = __webpack_require__("0d58");
	var redefine = __webpack_require__("2aba");
	var global = __webpack_require__("7726");
	var hide = __webpack_require__("32e9");
	var Iterators = __webpack_require__("84f2");
	var wks = __webpack_require__("2b4c");
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}
	
	
	/***/ }),
	
	/***/ "be13":
	/***/ (function(module, exports) {
	
	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "c366":
	/***/ (function(module, exports, __webpack_require__) {
	
	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__("6821");
	var toLength = __webpack_require__("9def");
	var toAbsoluteIndex = __webpack_require__("77f1");
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	
	/***/ }),
	
	/***/ "c69a":
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
	  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
	});
	
	
	/***/ }),
	
	/***/ "ca5a":
	/***/ (function(module, exports) {
	
	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};
	
	
	/***/ }),
	
	/***/ "cadf":
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var addToUnscopables = __webpack_require__("9c6c");
	var step = __webpack_require__("d53b");
	var Iterators = __webpack_require__("84f2");
	var toIObject = __webpack_require__("6821");
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	
	/***/ }),
	
	/***/ "cb7c":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "cd1c":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__("e853");
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};
	
	
	/***/ }),
	
	/***/ "ce10":
	/***/ (function(module, exports, __webpack_require__) {
	
	var has = __webpack_require__("69a8");
	var toIObject = __webpack_require__("6821");
	var arrayIndexOf = __webpack_require__("c366")(false);
	var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};
	
	
	/***/ }),
	
	/***/ "d2c8":
	/***/ (function(module, exports, __webpack_require__) {
	
	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__("aae3");
	var defined = __webpack_require__("be13");
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};
	
	
	/***/ }),
	
	/***/ "d3f4":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};
	
	
	/***/ }),
	
	/***/ "d53b":
	/***/ (function(module, exports) {
	
	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};
	
	
	/***/ }),
	
	/***/ "d8e8":
	/***/ (function(module, exports) {
	
	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};
	
	
	/***/ }),
	
	/***/ "e11e":
	/***/ (function(module, exports) {
	
	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');
	
	
	/***/ }),
	
	/***/ "e853":
	/***/ (function(module, exports, __webpack_require__) {
	
	var isObject = __webpack_require__("d3f4");
	var isArray = __webpack_require__("1169");
	var SPECIES = __webpack_require__("2b4c")('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};
	
	
	/***/ }),
	
	/***/ "f751":
	/***/ (function(module, exports, __webpack_require__) {
	
	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__("5ca1");
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });
	
	
	/***/ }),
	
	/***/ "fab2":
	/***/ (function(module, exports, __webpack_require__) {
	
	var document = __webpack_require__("7726").document;
	module.exports = document && document.documentElement;
	
	
	/***/ }),
	
	/***/ "fb15":
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	
	// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
	// This file is imported into lib/wc client bundles.
	
	if (typeof window !== 'undefined') {
	  var i
	  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js$/))) {
	    __webpack_require__.p = i[1] // eslint-disable-line
	  }
	}
	
	// Indicate to webpack that this file can be concatenated
	/* harmony default export */ var setPublicPath = (null);
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
	var es6_function_name = __webpack_require__("7f7f");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
	var es6_array_iterator = __webpack_require__("cadf");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
	var es6_object_keys = __webpack_require__("456d");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
	var web_dom_iterable = __webpack_require__("ac6a");
	
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"545da000-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/country-select.vue?vue&type=template&id=2200f336&
	var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.className,on:{"change":function($event){_vm.onChange($event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.placeholder))]),(_vm.topCountry)?_c('option',{domProps:{"value":_vm.firstCountry,"selected":_vm.country === _vm.firstCountry}},[_vm._v(_vm._s(_vm.topCountryName()))]):_vm._e(),_vm._l((_vm.countries),function(region,index){return _c('option',{key:index,domProps:{"value":region[_vm.valueType],"selected":_vm.country === region[_vm.valueType]}},[_vm._v(_vm._s(region.countryName))])})],2)}
	var staticRenderFns = []
	
	
	// CONCATENATED MODULE: ./src/components/country-select.vue?vue&type=template&id=2200f336&
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
	var es6_array_find = __webpack_require__("7514");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.sort.js
	var es6_array_sort = __webpack_require__("55dd");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
	var es6_object_assign = __webpack_require__("f751");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
	var es7_array_includes = __webpack_require__("6762");
	
	// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
	var es6_string_includes = __webpack_require__("2fdb");
	
	// EXTERNAL MODULE: ./node_modules/country-region-data/data.json
	var country_region_data_data = __webpack_require__("4fb4");
	
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/country-select.vue?vue&type=script&lang=js&
	
	
	
	
	
	
	/* harmony default export */ var country_selectvue_type_script_lang_js_ = ({
	  name: 'CountrySelect',
	  props: {
	    country: String,
	    topCountry: String,
	    countryName: Boolean,
	    whiteList: Array,
	    blackList: Array,
	    className: String,
	    placeholder: {
	      type: String,
	      default: 'Select Country'
	    }
	  },
	  computed: {
	    countries: function countries() {
	      var _this = this;
	
	      var countryList = country_region_data_data.filter(function (region) {
	        if (_this.countryName) {
	          return region.countryName !== _this.firstCountry;
	        } else {
	          return region.countryShortCode !== _this.firstCountry;
	        }
	      });
	
	      if (this.whiteList) {
	        countryList = countryList.filter(function (country) {
	          return _this.whiteList.includes(country.countryShortCode);
	        });
	      }
	
	      if (this.blackList) {
	        countryList = countryList.filter(function (country) {
	          return !_this.blackList.includes(country.countryShortCode);
	        });
	      }
	
	      if (this.$i18n) {
	        countryList = countryList.map(function (country) {
	          var localeCountry = Object.assign({}, country);
	          localeCountry.countryName = _this.$t(country.countryName);
	          return localeCountry;
	        });
	        countryList.sort(function (country1, country2) {
	          return country1.countryName > country2.countryName ? 1 : -1;
	        });
	      }
	
	      return countryList;
	    },
	    firstCountry: function firstCountry() {
	      var _this2 = this;
	
	      if (this.countryName) {
	        if (this.topCountry.length === 2) {
	          var regionObj = country_region_data_data.find(function (region) {
	            return region.countryShortCode === _this2.topCountry;
	          });
	          return regionObj.countryName;
	        } else {
	          return this.topCountry;
	        }
	      }
	
	      if (this.topCountry) {
	        return this.topCountry;
	      }
	
	      return '';
	    },
	    valueType: function valueType() {
	      return this.countryName ? 'countryName' : 'countryShortCode';
	    }
	  },
	  methods: {
	    onChange: function onChange(country) {
	      this.$emit('input', country);
	    },
	    topCountryName: function topCountryName() {
	      var _this3 = this;
	
	      var regionObj = country_region_data_data.find(function (region) {
	        if (_this3.countryName) {
	          return region.countryName === _this3.firstCountry;
	        } else {
	          return region.countryShortCode === _this3.firstCountry;
	        }
	      });
	
	      if (this.$i18n) {
	        return this.$t(regionObj.countryName);
	      }
	
	      return regionObj.countryName;
	    }
	  }
	});
	// CONCATENATED MODULE: ./src/components/country-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_country_selectvue_type_script_lang_js_ = (country_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
	/* globals __VUE_SSR_CONTEXT__ */
	
	// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
	// This module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle.
	
	function normalizeComponent (
	  scriptExports,
	  render,
	  staticRenderFns,
	  functionalTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier, /* server only */
	  shadowMode /* vue-cli only */
	) {
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (render) {
	    options.render = render
	    options.staticRenderFns = staticRenderFns
	    options._compiled = true
	  }
	
	  // functional template
	  if (functionalTemplate) {
	    options.functional = true
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = 'data-v-' + scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = shadowMode
	      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
	      : injectStyles
	  }
	
	  if (hook) {
	    if (options.functional) {
	      // for template-only hot-reload because in that case the render fn doesn't
	      // go through the normalizer
	      options._injectStyles = hook
	      // register for functioal component in vue file
	      var originalRender = options.render
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return originalRender(h, context)
	      }
	    } else {
	      // inject component registration as beforeCreate hook
	      var existing = options.beforeCreate
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    }
	  }
	
	  return {
	    exports: scriptExports,
	    options: options
	  }
	}
	
	// CONCATENATED MODULE: ./src/components/country-select.vue
	
	
	
	
	
	/* normalize component */
	
	var component = normalizeComponent(
	  components_country_selectvue_type_script_lang_js_,
	  render,
	  staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	component.options.__file = "country-select.vue"
	/* harmony default export */ var country_select = (component.exports);
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"545da000-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/region-select.vue?vue&type=template&id=0967c2f5&
	var region_selectvue_type_template_id_0967c2f5_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{class:_vm.className,on:{"change":function($event){_vm.onChange($event.target.value)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.placeholder))]),_vm._l((_vm.shownRegions),function(place,index){return _c('option',{key:index,domProps:{"value":place[_vm.valueType],"selected":_vm.region === place[_vm.valueType]}},[_vm._v(_vm._s(place.name))])})],2)}
	var region_selectvue_type_template_id_0967c2f5_staticRenderFns = []
	
	
	// CONCATENATED MODULE: ./src/components/region-select.vue?vue&type=template&id=0967c2f5&
	
	// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/region-select.vue?vue&type=script&lang=js&
	
	
	
	
	
	/* harmony default export */ var region_selectvue_type_script_lang_js_ = ({
	  name: 'RegionSelect',
	  props: {
	    country: String,
	    region: String,
	    defaultRegion: String,
	    countryName: Boolean,
	    regionName: Boolean,
	    className: String,
	    placeholder: {
	      type: String,
	      default: 'Select Region'
	    }
	  },
	  data: function data() {
	    return {
	      shownRegions: [],
	      regions: country_region_data_data
	    };
	  },
	  mounted: function mounted() {
	    if (this.country) {
	      this.getRegionWithCountry();
	    } else {
	      var findRegion = '';
	
	      if (this.countryName) {
	        findRegion = this.defaultRegion ? this.defaultRegion : 'United States';
	      } else {
	        findRegion = this.defaultRegion ? this.defaultRegion : 'US';
	      }
	
	      this.getRegionWithCountry(findRegion);
	    }
	  },
	  computed: {
	    valueType: function valueType() {
	      return this.regionName ? 'name' : 'shortCode';
	    }
	  },
	  methods: {
	    onChange: function onChange(region) {
	      this.$emit('input', region);
	    },
	    getRegionWithCountry: function getRegionWithCountry(country) {
	      var _this = this;
	
	      country = country || this.country;
	      var countryRegions = country_region_data_data.find(function (elem) {
	        if (_this.countryName) {
	          return elem.countryName === country;
	        } else {
	          return elem.countryShortCode === country;
	        }
	      }).regions;
	
	      if (this.$i18n) {
	        countryRegions = countryRegions.map(function (region) {
	          var localeRegion = Object.assign({}, region);
	          localeRegion.name = _this.$t(region.name);
	          return localeRegion;
	        });
	        countryRegions.sort(function (region1, region2) {
	          return region1.name > region2.name ? 1 : -1;
	        });
	      }
	
	      this.shownRegions = countryRegions;
	    }
	  },
	  watch: {
	    country: function country(newVal, oldVal) {
	      if (oldVal !== '') {
	        this.onChange('');
	      }
	
	      if (this.country) {
	        this.getRegionWithCountry();
	      } else {
	        this.shownRegions = [];
	      }
	    }
	  }
	});
	// CONCATENATED MODULE: ./src/components/region-select.vue?vue&type=script&lang=js&
	 /* harmony default export */ var components_region_selectvue_type_script_lang_js_ = (region_selectvue_type_script_lang_js_); 
	// CONCATENATED MODULE: ./src/components/region-select.vue
	
	
	
	
	
	/* normalize component */
	
	var region_select_component = normalizeComponent(
	  components_region_selectvue_type_script_lang_js_,
	  region_selectvue_type_template_id_0967c2f5_render,
	  region_selectvue_type_template_id_0967c2f5_staticRenderFns,
	  false,
	  null,
	  null,
	  null
	  
	)
	
	region_select_component.options.__file = "region-select.vue"
	/* harmony default export */ var region_select = (region_select_component.exports);
	// CONCATENATED MODULE: ./src/index.js
	
	
	
	
	
	
	
	var src_install = function install(Vue) {
	  var components = {
	    CountrySelect: country_select,
	    RegionSelect: region_select
	  };
	  Object.keys(components).forEach(function (name) {
	    Vue.component(name, components[name]);
	  });
	};
	
	var VueCountryRegionSelect = {
	  CountrySelect: country_select,
	  RegionSelect: region_select,
	  install: src_install
	};
	/* harmony default export */ var src = (VueCountryRegionSelect);
	
	// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
	/* concated harmony reexport CountrySelect */__webpack_require__.d(__webpack_exports__, "CountrySelect", function() { return country_select; });
	/* concated harmony reexport RegionSelect */__webpack_require__.d(__webpack_exports__, "RegionSelect", function() { return region_select; });
	
	
	/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);
	
	
	
	/***/ })
	
	/******/ });
	//# sourceMappingURL=vueCountryRegionSelect.common.js.map

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(8));
		else if(typeof define === 'function' && define.amd)
			define(["vue"], factory);
		else if(typeof exports === 'object')
			exports["Vuetify"] = factory(require("vue"));
		else
			root["Vuetify"] = factory(root["Vue"]);
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_vue__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/dist/";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
	/******/ })
	/************************************************************************/
	/******/ ({
	
	/***/ "./src/components/VAlert/VAlert.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VAlert/VAlert.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_alerts.styl */ "./src/stylus/components/_alerts.styl");
	/* harmony import */ var _stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_alerts_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Components
	
	// Mixins
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
	    name: 'v-alert',
	    props: {
	        dismissible: Boolean,
	        icon: String,
	        outline: Boolean,
	        type: {
	            type: String,
	            validator: function validator(val) {
	                return ['info', 'error', 'success', 'warning'].includes(val);
	            }
	        }
	    },
	    computed: {
	        computedColor: function computedColor() {
	            return this.type && !this.color ? this.type : this.color || 'error';
	        },
	        computedIcon: function computedIcon() {
	            if (this.icon || !this.type) return this.icon;
	            switch (this.type) {
	                case 'info':
	                    return '$vuetify.icons.info';
	                case 'error':
	                    return '$vuetify.icons.error';
	                case 'success':
	                    return '$vuetify.icons.success';
	                case 'warning':
	                    return '$vuetify.icons.warning';
	            }
	        }
	    },
	    methods: {
	        genIcon: function genIcon() {
	            if (!this.computedIcon) return null;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                'class': 'v-alert__icon'
	            }, this.computedIcon);
	        },
	        genDismissible: function genDismissible() {
	            var _this = this;
	            if (!this.dismissible) return null;
	            return this.$createElement('a', {
	                'class': 'v-alert__dismissible',
	                on: { click: function click() {
	                        _this.isActive = false;
	                    } }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    right: true
	                }
	            }, '$vuetify.icons.cancel')]);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genIcon(), h('div', this.$slots.default), this.genDismissible()];
	        var setColor = this.outline ? this.setTextColor : this.setBackgroundColor;
	        var alert = h('div', setColor(this.computedColor, {
	            staticClass: 'v-alert',
	            'class': {
	                'v-alert--outline': this.outline
	            },
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        }), children);
	        if (!this.transition) return alert;
	        return h('transition', {
	            props: {
	                name: this.transition,
	                origin: this.origin,
	                mode: this.mode
	            }
	        }, [alert]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VAlert/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VAlert/index.ts ***!
	  \****************************************/
	/*! exports provided: VAlert, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAlert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAlert */ "./src/components/VAlert/VAlert.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return _VAlert__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAlert__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VApp/VApp.js":
	/*!*************************************!*\
	  !*** ./src/components/VApp/VApp.js ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_app.styl */ "./src/stylus/components/_app.styl");
	/* harmony import */ var _stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_app_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_app_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/app-theme */ "./src/components/VApp/mixins/app-theme.js");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Component level mixins
	
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-app',
	    directives: {
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_3__["default"]
	    },
	    mixins: [_mixins_app_theme__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        id: {
	            type: String,
	            default: 'app'
	        },
	        dark: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'application--is-rtl': this.$vuetify.rtl }, this.themeClasses);
	        }
	    },
	    watch: {
	        dark: function dark() {
	            this.$vuetify.dark = this.dark;
	        }
	    },
	    mounted: function mounted() {
	        this.$vuetify.dark = this.dark;
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'application',
	            'class': this.classes,
	            attrs: { 'data-app': true },
	            domProps: { id: this.id }
	        };
	        var wrapper = h('div', { staticClass: 'application--wrap' }, this.$slots.default);
	        return h('div', data, [wrapper]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VApp/index.js":
	/*!**************************************!*\
	  !*** ./src/components/VApp/index.js ***!
	  \**************************************/
	/*! exports provided: VApp, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VApp */ "./src/components/VApp/VApp.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return _VApp__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VApp__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VApp/mixins/app-theme.js":
	/*!*************************************************!*\
	  !*** ./src/components/VApp/mixins/app-theme.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/theme */ "./src/util/theme.ts");
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    data: function data() {
	        return {
	            style: null
	        };
	    },
	    computed: {
	        parsedTheme: function parsedTheme() {
	            return _util_theme__WEBPACK_IMPORTED_MODULE_0__["parse"](this.$vuetify.theme);
	        },
	        /** @return string */
	        generatedStyles: function generatedStyles() {
	            var theme = this.parsedTheme;
	            var css;
	            if (this.$vuetify.options.themeCache != null) {
	                css = this.$vuetify.options.themeCache.get(theme);
	                if (css != null) return css;
	            }
	            css = _util_theme__WEBPACK_IMPORTED_MODULE_0__["genStyles"](theme, this.$vuetify.options.customProperties);
	            if (this.$vuetify.options.minifyTheme != null) {
	                css = this.$vuetify.options.minifyTheme(css);
	            }
	            if (this.$vuetify.options.themeCache != null) {
	                this.$vuetify.options.themeCache.set(theme, css);
	            }
	            return css;
	        },
	        vueMeta: function vueMeta() {
	            if (this.$vuetify.theme === false) return {};
	            var options = {
	                cssText: this.generatedStyles,
	                id: 'vuetify-theme-stylesheet',
	                type: 'text/css'
	            };
	            if (this.$vuetify.options.cspNonce) {
	                options.nonce = this.$vuetify.options.cspNonce;
	            }
	            return {
	                style: [options]
	            };
	        }
	    },
	    // Regular vue-meta
	    metaInfo: function metaInfo() {
	        return this.vueMeta;
	    },
	    // Nuxt
	    head: function head() {
	        return this.vueMeta;
	    },
	    watch: {
	        generatedStyles: function generatedStyles() {
	            !this.meta && this.applyTheme();
	        }
	    },
	    created: function created() {
	        if (this.$vuetify.theme === false) return;
	        if (this.$meta) {
	            // Vue-meta
	            // Handled by metaInfo()/nuxt()
	        } else if (typeof document === 'undefined' && this.$ssrContext) {
	            // SSR
	            var nonce = this.$vuetify.options.cspNonce ? " nonce=\"" + this.$vuetify.options.cspNonce + "\"" : '';
	            this.$ssrContext.head = this.$ssrContext.head || '';
	            this.$ssrContext.head += "<style type=\"text/css\" id=\"vuetify-theme-stylesheet\"" + nonce + ">" + this.generatedStyles + "</style>";
	        } else if (typeof document !== 'undefined') {
	            // Client-side
	            this.genStyle();
	            this.applyTheme();
	        }
	    },
	    methods: {
	        applyTheme: function applyTheme() {
	            if (this.style) this.style.innerHTML = this.generatedStyles;
	        },
	        genStyle: function genStyle() {
	            var style = document.getElementById('vuetify-theme-stylesheet');
	            if (!style) {
	                style = document.createElement('style');
	                style.type = 'text/css';
	                style.id = 'vuetify-theme-stylesheet';
	                if (this.$vuetify.options.cspNonce) {
	                    style.setAttribute('nonce', this.$vuetify.options.cspNonce);
	                }
	                document.head.appendChild(style);
	            }
	            this.style = style;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VAutocomplete/VAutocomplete.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VAutocomplete/VAutocomplete.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_autocompletes.styl */ "./src/stylus/components/_autocompletes.styl");
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	
	// Utils
	
	var defaultMenuProps = __assign({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["defaultMenuProps"], { offsetY: true, offsetOverflow: true, transition: false });
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-autocomplete',
	    extends: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"],
	    props: {
	        allowOverflow: {
	            type: Boolean,
	            default: true
	        },
	        browserAutocomplete: {
	            type: String,
	            default: 'off'
	        },
	        filter: {
	            type: Function,
	            default: function _default(item, queryText, itemText) {
	                var hasValue = function hasValue(val) {
	                    return val != null ? val : '';
	                };
	                var text = hasValue(itemText);
	                var query = hasValue(queryText);
	                return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
	            }
	        },
	        hideNoData: Boolean,
	        noFilter: Boolean,
	        searchInput: {
	            default: undefined
	        },
	        menuProps: {
	            type: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].props.menuProps.type,
	            default: function _default() {
	                return defaultMenuProps;
	            }
	        }
	    },
	    data: function data(vm) {
	        return {
	            attrsInput: null,
	            lazySearch: vm.searchInput
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign({}, _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].computed.classes.call(this), {
	                'v-autocomplete': true,
	                'v-autocomplete--is-selecting-index': this.selectedIndex > -1
	            });
	        },
	        computedItems: function computedItems() {
	            return this.filteredItems;
	        },
	        displayedItemsCount: function displayedItemsCount() {
	            return this.hideSelected ? this.filteredItems.length - this.selectedItems.length : this.filteredItems.length;
	        },
	        /**
	         * The range of the current input text
	         *
	         * @return {Number}
	         */
	        currentRange: function currentRange() {
	            if (this.selectedItem == null) return 0;
	            return this.getText(this.selectedItem).toString().length;
	        },
	        filteredItems: function filteredItems() {
	            var _this = this;
	            if (!this.isSearching || this.noFilter) return this.allItems;
	            return this.allItems.filter(function (i) {
	                return _this.filter(i, _this.internalSearch, _this.getText(i));
	            });
	        },
	        internalSearch: {
	            get: function get() {
	                return this.lazySearch;
	            },
	            set: function set(val) {
	                this.lazySearch = val;
	                this.$emit('update:searchInput', val);
	            }
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return false;
	        },
	        isDirty: function isDirty() {
	            return this.searchIsDirty || this.selectedItems.length > 0;
	        },
	        isSearching: function isSearching() {
	            if (this.multiple) return this.searchIsDirty;
	            return this.searchIsDirty && this.internalSearch !== this.getText(this.selectedItem);
	        },
	        menuCanShow: function menuCanShow() {
	            if (!this.isFocused) return false;
	            return this.displayedItemsCount > 0 || !this.hideNoData;
	        },
	        $_menuProps: function $_menuProps() {
	            var props = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].computed.$_menuProps.call(this);
	            props.contentClass = ("v-autocomplete__content " + (props.contentClass || '')).trim();
	            return __assign({}, defaultMenuProps, props);
	        },
	        searchIsDirty: function searchIsDirty() {
	            return this.internalSearch != null && this.internalSearch !== '';
	        },
	        selectedItem: function selectedItem() {
	            var _this = this;
	            if (this.multiple) return null;
	            return this.selectedItems.find(function (i) {
	                return _this.valueComparator(_this.getValue(i), _this.getValue(_this.internalValue));
	            });
	        },
	        listData: function listData() {
	            var data = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].computed.listData.call(this);
	            Object.assign(data.props, {
	                items: this.virtualizedItems,
	                noFilter: this.noFilter || !this.isSearching || !this.filteredItems.length,
	                searchInput: this.internalSearch
	            });
	            return data;
	        }
	    },
	    watch: {
	        filteredItems: function filteredItems(val) {
	            this.onFilteredItemsChanged(val);
	        },
	        internalValue: function internalValue() {
	            this.setSearch();
	        },
	        isFocused: function isFocused(val) {
	            if (val) {
	                this.$refs.input && this.$refs.input.select();
	            } else {
	                this.updateSelf();
	            }
	        },
	        isMenuActive: function isMenuActive(val) {
	            if (val || !this.hasSlot) return;
	            this.lazySearch = null;
	        },
	        items: function items(val, oldVal) {
	            // If we are focused, the menu
	            // is not active, hide no data is enabled,
	            // and items change
	            // User is probably async loading
	            // items, try to activate the menu
	            if (!(oldVal && oldVal.length) && this.hideNoData && this.isFocused && !this.isMenuActive && val.length) this.activateMenu();
	        },
	        searchInput: function searchInput(val) {
	            this.lazySearch = val;
	        },
	        internalSearch: function internalSearch(val) {
	            this.onInternalSearchChanged(val);
	        }
	    },
	    created: function created() {
	        this.setSearch();
	    },
	    methods: {
	        onFilteredItemsChanged: function onFilteredItemsChanged(val) {
	            var _this = this;
	            this.setMenuIndex(-1);
	            this.$nextTick(function () {
	                _this.setMenuIndex(val.length === 1 ? 0 : -1);
	            });
	        },
	        onInternalSearchChanged: function onInternalSearchChanged(val) {
	            this.updateMenuDimensions();
	        },
	        updateMenuDimensions: function updateMenuDimensions() {
	            if (this.isMenuActive && this.$refs.menu) {
	                this.$refs.menu.updateDimensions();
	            }
	        },
	        changeSelectedIndex: function changeSelectedIndex(keyCode) {
	            // Do not allow changing of selectedIndex
	            // when search is dirty
	            if (this.searchIsDirty) return;
	            if (![_util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].backspace, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].right, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].delete].includes(keyCode)) return;
	            var indexes = this.selectedItems.length - 1;
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left) {
	                this.selectedIndex = this.selectedIndex === -1 ? indexes : this.selectedIndex - 1;
	            } else if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].right) {
	                this.selectedIndex = this.selectedIndex >= indexes ? -1 : this.selectedIndex + 1;
	            } else if (this.selectedIndex === -1) {
	                this.selectedIndex = indexes;
	                return;
	            }
	            var currentItem = this.selectedItems[this.selectedIndex];
	            if ([_util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].backspace, _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].delete].includes(keyCode) && !this.getDisabled(currentItem)) {
	                var newIndex = this.selectedIndex === indexes ? this.selectedIndex - 1 : this.selectedItems[this.selectedIndex + 1] ? this.selectedIndex : -1;
	                if (newIndex === -1) {
	                    this.setValue(this.multiple ? [] : undefined);
	                } else {
	                    this.selectItem(currentItem);
	                }
	                this.selectedIndex = newIndex;
	            }
	        },
	        clearableCallback: function clearableCallback() {
	            this.internalSearch = undefined;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.clearableCallback.call(this);
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_2__["default"].methods.genInput.call(this);
	            input.data.attrs.role = 'combobox';
	            input.data.domProps.value = this.internalSearch;
	            return input;
	        },
	        genSelections: function genSelections() {
	            return this.hasSlot || this.multiple ? _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genSelections.call(this) : [];
	        },
	        onClick: function onClick() {
	            if (this.isDisabled) return;
	            this.selectedIndex > -1 ? this.selectedIndex = -1 : this.onFocus();
	            this.activateMenu();
	        },
	        onEnterDown: function onEnterDown() {
	            // Avoid invoking this method
	            // will cause updateSelf to
	            // be called emptying search
	        },
	        onInput: function onInput(e) {
	            if (this.selectedIndex > -1) return;
	            // If typing and menu is not currently active
	            if (e.target.value) {
	                this.activateMenu();
	                if (!this.isAnyValueAllowed) this.setMenuIndex(0);
	            }
	            this.mask && this.resetSelections(e.target);
	            this.internalSearch = e.target.value;
	            this.badInput = e.target.validity && e.target.validity.badInput;
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onKeyDown.call(this, e);
	            // The ordering is important here
	            // allows new value to be updated
	            // and then moves the index to the
	            // proper location
	            this.changeSelectedIndex(keyCode);
	        },
	        onTabDown: function onTabDown(e) {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onTabDown.call(this, e);
	            this.updateSelf();
	        },
	        setSelectedItems: function setSelectedItems() {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.setSelectedItems.call(this);
	            // #4273 Don't replace if searching
	            // #4403 Don't replace if focused
	            if (!this.isFocused) this.setSearch();
	        },
	        setSearch: function setSearch() {
	            var _this = this;
	            // Wait for nextTick so selectedItem
	            // has had time to update
	            this.$nextTick(function () {
	                _this.internalSearch = !_this.selectedItems.length || _this.multiple || _this.hasSlot ? null : _this.getText(_this.selectedItem);
	            });
	        },
	        updateSelf: function updateSelf() {
	            this.updateAutocomplete();
	        },
	        updateAutocomplete: function updateAutocomplete() {
	            if (!this.searchIsDirty && !this.internalValue) return;
	            if (!this.valueComparator(this.internalSearch, this.getValue(this.internalValue))) {
	                this.setSearch();
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VAutocomplete/index.js":
	/*!***********************************************!*\
	  !*** ./src/components/VAutocomplete/index.js ***!
	  \***********************************************/
	/*! exports provided: VAutocomplete, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAutocomplete */ "./src/components/VAutocomplete/VAutocomplete.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() { return _VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAutocomplete__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VAvatar/VAvatar.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VAvatar/VAvatar.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_avatars.styl */ "./src/stylus/components/_avatars.styl");
	/* harmony import */ var _stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_avatars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-avatar',
	    functional: true,
	    props: {
	        // TODO: inherit these
	        color: String,
	        size: {
	            type: [Number, String],
	            default: 48
	        },
	        tile: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            props = _a.props,
	            children = _a.children;
	        data.staticClass = ("v-avatar " + (data.staticClass || '')).trim();
	        if (props.tile) data.staticClass += ' v-avatar--tile';
	        var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(props.size);
	        data.style = __assign({ height: size, width: size }, data.style);
	        return h('div', _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setBackgroundColor(props.color, data), children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VAvatar/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VAvatar/index.ts ***!
	  \*****************************************/
	/*! exports provided: VAvatar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VAvatar */ "./src/components/VAvatar/VAvatar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return _VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBadge/VBadge.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VBadge/VBadge.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_badges.styl */ "./src/stylus/components/_badges.styl");
	/* harmony import */ var _stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_badges_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Mixins
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_3__["factory"])(['left', 'bottom']), _mixins_transitionable__WEBPACK_IMPORTED_MODULE_4__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-badge',
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        overlap: Boolean,
	        transition: {
	            type: String,
	            default: 'fab-transition'
	        },
	        value: {
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-badge--bottom': this.bottom,
	                'v-badge--left': this.left,
	                'v-badge--overlap': this.overlap
	            };
	        }
	    },
	    render: function render(h) {
	        var badge = this.$slots.badge && [h('span', this.setBackgroundColor(this.color, {
	            staticClass: 'v-badge__badge',
	            attrs: this.$attrs,
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }]
	        }), this.$slots.badge)];
	        return h('span', {
	            staticClass: 'v-badge',
	            'class': this.classes
	        }, [this.$slots.default, h('transition', {
	            props: {
	                name: this.transition,
	                origin: this.origin,
	                mode: this.mode
	            }
	        }, badge)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBadge/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VBadge/index.ts ***!
	  \****************************************/
	/*! exports provided: VBadge, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBadge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBadge */ "./src/components/VBadge/VBadge.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return _VBadge__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBadge__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBottomNav/VBottomNav.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VBottomNav/VBottomNav.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_bottom-navs.styl */ "./src/stylus/components/_bottom-navs.styl");
	/* harmony import */ var _stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_bottom_navs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Mixins
	
	
	
	// Util
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('bottom', ['height', 'value']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-bottom-nav',
	    props: {
	        active: [Number, String],
	        mandatory: Boolean,
	        height: {
	            default: 56,
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        shift: Boolean,
	        value: null
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-bottom-nav--absolute': this.absolute,
	                'v-bottom-nav--fixed': !this.absolute && (this.app || this.fixed),
	                'v-bottom-nav--shift': this.shift,
	                'v-bottom-nav--active': this.value
	            };
	        },
	        computedHeight: function computedHeight() {
	            return parseInt(this.height);
	        }
	    },
	    methods: {
	        updateApplication: function updateApplication() {
	            return !this.value ? 0 : this.computedHeight;
	        },
	        updateValue: function updateValue(val) {
	            this.$emit('update:active', val);
	        }
	    },
	    render: function render(h) {
	        return h(_mixins_button_group__WEBPACK_IMPORTED_MODULE_2__["default"], this.setBackgroundColor(this.color, {
	            staticClass: 'v-bottom-nav',
	            class: this.classes,
	            style: {
	                height: parseInt(this.computedHeight) + "px"
	            },
	            props: {
	                mandatory: Boolean(this.mandatory || this.active !== undefined),
	                value: this.active
	            },
	            on: { change: this.updateValue }
	        }), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBottomNav/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VBottomNav/index.ts ***!
	  \********************************************/
	/*! exports provided: VBottomNav, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBottomNav__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBottomNav */ "./src/components/VBottomNav/VBottomNav.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return _VBottomNav__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBottomNav__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBottomSheet/VBottomSheet.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VBottomSheet/VBottomSheet.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_bottom-sheets.styl */ "./src/stylus/components/_bottom-sheets.styl");
	/* harmony import */ var _stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_bottom_sheets_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VDialog/VDialog */ "./src/components/VDialog/VDialog.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-bottom-sheet',
	    props: {
	        disabled: Boolean,
	        fullWidth: Boolean,
	        hideOverlay: Boolean,
	        inset: Boolean,
	        lazy: Boolean,
	        maxWidth: {
	            type: [String, Number],
	            default: 'auto'
	        },
	        persistent: Boolean,
	        value: null
	    },
	    render: function render(h) {
	        var activator = h('template', {
	            slot: 'activator'
	        }, this.$slots.activator);
	        var contentClass = ['v-bottom-sheet', this.inset ? 'v-bottom-sheet--inset' : ''].join(' ');
	        return h(_VDialog_VDialog__WEBPACK_IMPORTED_MODULE_1__["default"], {
	            attrs: __assign({}, this.$props),
	            on: __assign({}, this.$listeners),
	            props: {
	                contentClass: contentClass,
	                noClickAnimation: true,
	                transition: 'bottom-sheet-transition',
	                value: this.value
	            }
	        }, [activator, this.$slots.default]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VBottomSheet/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VBottomSheet/index.js ***!
	  \**********************************************/
	/*! exports provided: VBottomSheet, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBottomSheet */ "./src/components/VBottomSheet/VBottomSheet.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return _VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBottomSheet__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/VBreadcrumbs.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/VBreadcrumbs/VBreadcrumbs.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_breadcrumbs.styl */ "./src/stylus/components/_breadcrumbs.styl");
	/* harmony import */ var _stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_breadcrumbs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! . */ "./src/components/VBreadcrumbs/index.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// Mixins
	
	// Utils
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-breadcrumbs',
	    props: {
	        divider: {
	            type: String,
	            default: '/'
	        },
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        large: Boolean,
	        justifyCenter: Boolean,
	        justifyEnd: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-breadcrumbs--large': this.large, 'justify-center': this.justifyCenter, 'justify-end': this.justifyEnd }, this.themeClasses);
	        }
	    },
	    mounted: function mounted() {
	        if (this.justifyCenter) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('justify-center', 'class="justify-center"', this);
	        if (this.justifyEnd) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('justify-end', 'class="justify-end"', this);
	        if (this.$slots.default) Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["deprecate"])('default slot', ':items and scoped slot "item"', this);
	    },
	    methods: {
	        /* @deprecated */
	        genChildren /* istanbul ignore next */: function genChildren() {
	            if (!this.$slots.default) return undefined;
	            var children = [];
	            var createDividers = false;
	            for (var i = 0; i < this.$slots.default.length; i++) {
	                var elm = this.$slots.default[i];
	                if (!elm.componentOptions || elm.componentOptions.Ctor.options.name !== 'v-breadcrumbs-item') {
	                    children.push(elm);
	                } else {
	                    if (createDividers) {
	                        children.push(this.genDivider());
	                    }
	                    children.push(elm);
	                    createDividers = true;
	                }
	            }
	            return children;
	        },
	        genDivider: function genDivider() {
	            return this.$createElement(___WEBPACK_IMPORTED_MODULE_1__["VBreadcrumbsDivider"], this.$slots.divider ? this.$slots.divider : this.divider);
	        },
	        genItems: function genItems() {
	            var items = [];
	            var hasSlot = !!this.$scopedSlots.item;
	            for (var i = 0; i < this.items.length; i++) {
	                var item = this.items[i];
	                if (hasSlot) items.push(this.$scopedSlots.item({ item: item }));else items.push(this.$createElement(___WEBPACK_IMPORTED_MODULE_1__["VBreadcrumbsItem"], { key: item.text, props: item }, [item.text]));
	                if (i < this.items.length - 1) items.push(this.genDivider());
	            }
	            return items;
	        }
	    },
	    render: function render(h) {
	        var children = this.$slots.default ? this.genChildren() : this.genItems();
	        return h('ul', {
	            staticClass: 'v-breadcrumbs',
	            'class': this.classes
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts":
	/*!*********************************************************!*\
	  !*** ./src/components/VBreadcrumbs/VBreadcrumbsItem.ts ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_routable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    name: 'v-breadcrumbs-item',
	    props: {
	        // In a breadcrumb, the currently
	        // active item should be dimmed
	        activeClass: {
	            type: String,
	            default: 'v-breadcrumbs__item--disabled'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {
	                'v-breadcrumbs__item': true
	            }, _a[this.activeClass] = this.disabled, _a;
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        return h('li', [h(tag, data, this.$slots.default)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBreadcrumbs/index.ts":
	/*!**********************************************!*\
	  !*** ./src/components/VBreadcrumbs/index.ts ***!
	  \**********************************************/
	/*! exports provided: VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() { return VBreadcrumbsDivider; });
	/* harmony import */ var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBreadcrumbs */ "./src/components/VBreadcrumbs/VBreadcrumbs.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VBreadcrumbsItem */ "./src/components/VBreadcrumbs/VBreadcrumbsItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() { return _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	
	
	
	var VBreadcrumbsDivider = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createSimpleFunctional"])('v-breadcrumbs__divider', 'li');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VBreadcrumbs: _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VBreadcrumbsItem: _VBreadcrumbsItem__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VBreadcrumbsDivider: VBreadcrumbsDivider
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VBtn/VBtn.ts":
	/*!*************************************!*\
	  !*** ./src/components/VBtn/VBtn.ts ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_buttons.styl */ "./src/stylus/components/_buttons.styl");
	/* harmony import */ var _stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_buttons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VProgressCircular */ "./src/components/VProgressCircular/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	// Components
	
	// Mixins
	
	
	
	
	
	
	// Utilities
	
	var baseMixins = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_positionable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_7__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_4__["factory"])('btnToggle'), Object(_mixins_toggleable__WEBPACK_IMPORTED_MODULE_8__["factory"])('inputValue')
	/* @vue/component */
	);
	/* harmony default export */ __webpack_exports__["default"] = (baseMixins.extend().extend({
	    name: 'v-btn',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        },
	        block: Boolean,
	        depressed: Boolean,
	        fab: Boolean,
	        flat: Boolean,
	        icon: Boolean,
	        large: Boolean,
	        loading: Boolean,
	        outline: Boolean,
	        ripple: {
	            type: [Boolean, Object],
	            default: null
	        },
	        round: Boolean,
	        small: Boolean,
	        tag: {
	            type: String,
	            default: 'button'
	        },
	        type: {
	            type: String,
	            default: 'button'
	        },
	        value: null
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return __assign((_a = { 'v-btn': true }, _a[this.activeClass] = this.isActive, _a['v-btn--absolute'] = this.absolute, _a['v-btn--block'] = this.block, _a['v-btn--bottom'] = this.bottom, _a['v-btn--disabled'] = this.disabled, _a['v-btn--flat'] = this.flat, _a['v-btn--floating'] = this.fab, _a['v-btn--fixed'] = this.fixed, _a['v-btn--icon'] = this.icon, _a['v-btn--large'] = this.large, _a['v-btn--left'] = this.left, _a['v-btn--loader'] = this.loading, _a['v-btn--outline'] = this.outline, _a['v-btn--depressed'] = this.depressed && !this.flat || this.outline, _a['v-btn--right'] = this.right, _a['v-btn--round'] = this.round, _a['v-btn--router'] = this.to, _a['v-btn--small'] = this.small, _a['v-btn--top'] = this.top, _a), this.themeClasses);
	        },
	        computedRipple: function computedRipple() {
	            var defaultRipple = this.icon || this.fab ? { circle: true } : true;
	            if (this.disabled) return false;else return this.ripple !== null ? this.ripple : defaultRipple;
	        }
	    },
	    watch: {
	        '$route': 'onRouteChange'
	    },
	    methods: {
	        // Prevent focus to match md spec
	        click: function click(e) {
	            !this.fab && e.detail && this.$el.blur();
	            this.$emit('click', e);
	            this.btnToggle && this.toggle();
	        },
	        genContent: function genContent() {
	            return this.$createElement('div', { 'class': 'v-btn__content' }, this.$slots.default);
	        },
	        genLoader: function genLoader() {
	            return this.$createElement('span', {
	                class: 'v-btn__loading'
	            }, this.$slots.loader || [this.$createElement(_VProgressCircular__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    indeterminate: true,
	                    size: 23,
	                    width: 2
	                }
	            })]);
	        },
	        onRouteChange: function onRouteChange() {
	            var _this = this;
	            if (!this.to || !this.$refs.link) return;
	            var path = "_vnode.data.class." + this.activeClass;
	            this.$nextTick(function () {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getObjectValueByPath"])(_this.$refs.link, path)) {
	                    _this.toggle();
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        var setColor = !this.outline && !this.flat && !this.disabled ? this.setBackgroundColor : this.setTextColor;
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        var children = [this.genContent(), this.loading && this.genLoader()];
	        if (tag === 'button') data.attrs.type = this.type;
	        data.attrs.value = ['string', 'number'].includes(_typeof(this.value)) ? this.value : JSON.stringify(this.value);
	        if (this.btnToggle) {
	            data.ref = 'link';
	        }
	        return h(tag, setColor(this.color, data), children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBtn/index.ts":
	/*!**************************************!*\
	  !*** ./src/components/VBtn/index.ts ***!
	  \**************************************/
	/*! exports provided: VBtn, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBtn */ "./src/components/VBtn/VBtn.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return _VBtn__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VBtnToggle/VBtnToggle.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VBtnToggle/VBtnToggle.ts ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_button-toggle.styl */ "./src/stylus/components/_button-toggle.styl");
	/* harmony import */ var _stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_button_toggle_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-btn-toggle',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({}, _mixins_button_group__WEBPACK_IMPORTED_MODULE_1__["default"].options.computed.classes.call(this), { 'v-btn-toggle': true, 'v-btn-toggle--only-child': this.selectedItems.length === 1, 'v-btn-toggle--selected': this.selectedItems.length > 0 });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VBtnToggle/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VBtnToggle/index.ts ***!
	  \********************************************/
	/*! exports provided: VBtnToggle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VBtnToggle */ "./src/components/VBtnToggle/VBtnToggle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return _VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VBtnToggle__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCard.ts":
	/*!***************************************!*\
	  !*** ./src/components/VCard/VCard.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/measurable */ "./src/mixins/measurable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	
	// Helpers
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_measurable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]).extend({
	    name: 'v-card',
	    props: {
	        flat: Boolean,
	        hover: Boolean,
	        img: String,
	        raised: Boolean,
	        tag: {
	            type: String,
	            default: 'div'
	        },
	        tile: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-card': true, 'v-card--flat': this.flat, 'v-card--hover': this.hover, 'v-card--raised': this.raised, 'v-card--tile': this.tile }, this.themeClasses);
	        },
	        styles: function styles() {
	            var style = {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.height)
	            };
	            if (this.img) {
	                style.background = "url(\"" + this.img + "\") center center / cover no-repeat";
	            }
	            if (this.height) style.height = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.height);
	            if (this.maxHeight) style.maxHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.maxHeight);
	            if (this.maxWidth) style.maxWidth = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.maxWidth);
	            if (this.width) style.width = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.width);
	            return style;
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        data.style = this.styles;
	        return h(tag, this.setBackgroundColor(this.color, data), this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCardMedia.ts":
	/*!********************************************!*\
	  !*** ./src/components/VCard/VCardMedia.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VImg_VImg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VImg/VImg */ "./src/components/VImg/VImg.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Components
	
	// Utils
	
	/* istanbul ignore next */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VImg_VImg__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-card-media',
	    mounted: function mounted() {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["deprecate"])('v-card-media', this.src ? 'v-img' : 'v-responsive', this);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/VCardTitle.ts":
	/*!********************************************!*\
	  !*** ./src/components/VCard/VCardTitle.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	// Types
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'v-card-title',
	    functional: true,
	    props: {
	        primaryTitle: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            props = _a.props,
	            children = _a.children;
	        data.staticClass = ("v-card__title " + (data.staticClass || '')).trim();
	        if (props.primaryTitle) data.staticClass += ' v-card__title--primary';
	        return h('div', data, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCard/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VCard/index.ts ***!
	  \***************************************/
	/*! exports provided: VCard, VCardMedia, VCardTitle, VCardActions, VCardText, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCardActions", function() { return VCardActions; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCardText", function() { return VCardText; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCard */ "./src/components/VCard/VCard.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return _VCard__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VCardMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VCardMedia */ "./src/components/VCard/VCardMedia.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardMedia", function() { return _VCardMedia__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VCardTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VCardTitle */ "./src/components/VCard/VCardTitle.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardTitle", function() { return _VCardTitle__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	
	
	
	
	var VCardActions = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-card__actions');
	var VCardText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-card__text');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VCard: _VCard__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VCardMedia: _VCardMedia__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VCardTitle: _VCardTitle__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VCardActions: VCardActions,
	        VCardText: VCardText
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/VCarousel.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VCarousel/VCarousel.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_carousel.styl */ "./src/stylus/components/_carousel.styl");
	/* harmony import */ var _stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_carousel_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VWindow/VWindow */ "./src/components/VWindow/VWindow.ts");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_button_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/button-group */ "./src/mixins/button-group.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Styles
	
	// Extensions
	
	// Components
	
	
	// Mixins
	// TODO: Move this into core components v2.0
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-carousel',
	    props: {
	        cycle: {
	            type: Boolean,
	            default: true
	        },
	        delimiterIcon: {
	            type: String,
	            default: '$vuetify.icons.delimiter'
	        },
	        height: {
	            type: [Number, String],
	            default: 500
	        },
	        hideControls: Boolean,
	        hideDelimiters: Boolean,
	        interval: {
	            type: [Number, String],
	            default: 6000,
	            validator: function validator(value) {
	                return value > 0;
	            }
	        },
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        nextIcon: {
	            type: [Boolean, String],
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: [Boolean, String],
	            default: '$vuetify.icons.prev'
	        }
	    },
	    data: function data() {
	        return {
	            changedByControls: false,
	            internalHeight: this.height,
	            slideTimeout: undefined
	        };
	    },
	    computed: {
	        isDark: function isDark() {
	            return this.dark || !this.light;
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            this.restartTimeout();
	            /* @deprecate */
	            /* istanbul ignore else */
	            if (!this.$listeners['input']) return;
	            this.$emit('input', val);
	        },
	        interval: 'restartTimeout',
	        cycle: function cycle(val) {
	            if (val) {
	                this.restartTimeout();
	            } else {
	                clearTimeout(this.slideTimeout);
	                this.slideTimeout = undefined;
	            }
	        }
	    },
	    mounted: function mounted() {
	        /* @deprecate */
	        /* istanbul ignore next */
	        if (this.$listeners['input']) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('@input', '@change', this);
	        }
	        this.startTimeout();
	    },
	    methods: {
	        genDelimiters: function genDelimiters() {
	            return this.$createElement('div', {
	                staticClass: 'v-carousel__controls'
	            }, [this.genItems()]);
	        },
	        genIcon: function genIcon(direction, icon, fn) {
	            return this.$createElement('div', {
	                staticClass: "v-carousel__" + direction
	            }, [this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    icon: true
	                },
	                on: { click: fn }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: { 'size': '46px' }
	            }, icon)])]);
	        },
	        genIcons: function genIcons() {
	            var icons = [];
	            var prevIcon = this.$vuetify.rtl ? this.nextIcon : this.prevIcon;
	            if (prevIcon && typeof prevIcon === 'string') {
	                icons.push(this.genIcon('prev', prevIcon, this.prev));
	            }
	            var nextIcon = this.$vuetify.rtl ? this.prevIcon : this.nextIcon;
	            if (nextIcon && typeof nextIcon === 'string') {
	                icons.push(this.genIcon('next', nextIcon, this.next));
	            }
	            return icons;
	        },
	        genItems: function genItems() {
	            var _this = this;
	            var length = this.items.length;
	            var children = [];
	            for (var i = 0; i < length; i++) {
	                var child = this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                    class: {
	                        'v-carousel__controls__item': true
	                    },
	                    props: {
	                        icon: true,
	                        small: true,
	                        value: this.getValue(this.items[i], i)
	                    }
	                }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                    props: { size: 18 }
	                }, this.delimiterIcon)]);
	                children.push(child);
	            }
	            return this.$createElement(_mixins_button_group__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    value: this.internalValue
	                },
	                on: {
	                    change: function change(val) {
	                        _this.changedByControls = true;
	                        _this.internalValue = val;
	                    }
	                }
	            }, children);
	        },
	        restartTimeout: function restartTimeout() {
	            this.slideTimeout && clearTimeout(this.slideTimeout);
	            this.slideTimeout = undefined;
	            var raf = requestAnimationFrame || setTimeout;
	            raf(this.startTimeout);
	        },
	        startTimeout: function startTimeout() {
	            if (!this.cycle) return;
	            this.slideTimeout = window.setTimeout(this.next, +this.interval > 0 ? +this.interval : 6000);
	        },
	        updateReverse: function updateReverse(val, oldVal) {
	            if (this.changedByControls) {
	                this.changedByControls = false;
	                _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.updateReverse.call(this, val, oldVal);
	            }
	        }
	    },
	    render: function render(h) {
	        var children = [];
	        var data = {
	            staticClass: 'v-window v-carousel',
	            style: {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["convertToUnit"])(this.height)
	            },
	            directives: []
	        };
	        if (!this.touchless) {
	            data.directives.push({
	                name: 'touch',
	                value: {
	                    left: this.next,
	                    right: this.prev
	                }
	            });
	        }
	        if (!this.hideControls) {
	            children.push(this.genIcons());
	        }
	        if (!this.hideDelimiters) {
	            children.push(this.genDelimiters());
	        }
	        return h('div', data, [children, this.genContainer()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/VCarouselItem.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VCarousel/VCarouselItem.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VImg */ "./src/components/VImg/index.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Extensions
	
	// Components
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-carousel-item',
	    inheritAttrs: false,
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.$createElement(_VImg__WEBPACK_IMPORTED_MODULE_1__["VImg"], {
	                staticClass: 'v-carousel__item',
	                props: __assign({}, this.$attrs, { height: this.windowGroup.internalHeight }),
	                on: this.$listeners
	            }, this.$slots.default)];
	        },
	        onBeforeEnter: function onBeforeEnter() {},
	        onEnter: function onEnter() {},
	        onAfterEnter: function onAfterEnter() {},
	        onBeforeLeave: function onBeforeLeave() {},
	        onEnterCancelled: function onEnterCancelled() {}
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VCarousel/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VCarousel/index.ts ***!
	  \*******************************************/
	/*! exports provided: VCarousel, VCarouselItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCarousel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCarousel */ "./src/components/VCarousel/VCarousel.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VCarouselItem */ "./src/components/VCarousel/VCarouselItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() { return _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VCarousel: _VCarousel__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VCarouselItem: _VCarouselItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCheckbox/VCheckbox.js":
	/*!***********************************************!*\
	  !*** ./src/components/VCheckbox/VCheckbox.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// import { VFadeTransition } from '../transitions'
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-checkbox',
	    mixins: [_mixins_selectable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        indeterminate: Boolean,
	        indeterminateIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxIndeterminate'
	        },
	        onIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxOn'
	        },
	        offIcon: {
	            type: String,
	            default: '$vuetify.icons.checkboxOff'
	        }
	    },
	    data: function data(vm) {
	        return {
	            inputIndeterminate: vm.indeterminate
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls': true,
	                'v-input--checkbox': true
	            };
	        },
	        computedIcon: function computedIcon() {
	            if (this.inputIndeterminate) {
	                return this.indeterminateIcon;
	            } else if (this.isActive) {
	                return this.onIcon;
	            } else {
	                return this.offIcon;
	            }
	        }
	    },
	    watch: {
	        indeterminate: function indeterminate(val) {
	            this.inputIndeterminate = val;
	        }
	    },
	    methods: {
	        genCheckbox: function genCheckbox() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('checkbox', __assign({}, this.$attrs, { 'aria-checked': this.inputIndeterminate ? 'mixed' : this.isActive.toString() })), this.genRipple(this.setTextColor(this.computedColor)), this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.computedColor, {
	                props: {
	                    dark: this.dark,
	                    light: this.light
	                }
	            }), this.computedIcon)]);
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genCheckbox(), this.genLabel()];
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCheckbox/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VCheckbox/index.js ***!
	  \*******************************************/
	/*! exports provided: VCheckbox, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCheckbox */ "./src/components/VCheckbox/VCheckbox.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return _VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCheckbox__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VChip/VChip.ts":
	/*!***************************************!*\
	  !*** ./src/components/VChip/VChip.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_chips.styl */ "./src/stylus/components/_chips.styl");
	/* harmony import */ var _stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_chips_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Components
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
	    name: 'v-chip',
	    props: {
	        close: Boolean,
	        disabled: Boolean,
	        label: Boolean,
	        outline: Boolean,
	        // Used for selects/tagging
	        selected: Boolean,
	        small: Boolean,
	        textColor: String,
	        value: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-chip--disabled': this.disabled, 'v-chip--selected': this.selected && !this.disabled, 'v-chip--label': this.label, 'v-chip--outline': this.outline, 'v-chip--small': this.small, 'v-chip--removable': this.close }, this.themeClasses);
	        }
	    },
	    methods: {
	        genClose: function genClose(h) {
	            var _this = this;
	            var data = {
	                staticClass: 'v-chip__close',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('input', false);
	                    }
	                }
	            };
	            return h('div', data, [h(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], '$vuetify.icons.delete')]);
	        },
	        genContent: function genContent(h) {
	            return h('span', {
	                staticClass: 'v-chip__content'
	            }, [this.$slots.default, this.close && this.genClose(h)]);
	        }
	    },
	    render: function render(h) {
	        var data = this.setBackgroundColor(this.color, {
	            staticClass: 'v-chip',
	            'class': this.classes,
	            attrs: { tabindex: this.disabled ? -1 : 0 },
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        });
	        var color = this.textColor || this.outline && this.color;
	        return h('span', this.setTextColor(color, data), [this.genContent(h)]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VChip/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VChip/index.ts ***!
	  \***************************************/
	/*! exports provided: VChip, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VChip */ "./src/components/VChip/VChip.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return _VChip__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VChip__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCombobox/VCombobox.js":
	/*!***********************************************!*\
	  !*** ./src/components/VCombobox/VCombobox.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_autocompletes.styl */ "./src/stylus/components/_autocompletes.styl");
	/* harmony import */ var _stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_autocompletes_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete/VAutocomplete */ "./src/components/VAutocomplete/VAutocomplete.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Styles
	
	// Extensions
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-combobox',
	    extends: _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"],
	    props: {
	        delimiters: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        returnObject: {
	            type: Boolean,
	            default: true
	        }
	    },
	    data: function data() {
	        return {
	            editingIndex: -1
	        };
	    },
	    computed: {
	        counterValue: function counterValue() {
	            return this.multiple ? this.selectedItems.length : (this.internalSearch || '').toString().length;
	        },
	        hasSlot: function hasSlot() {
	            return _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].computed.hasSlot.call(this) || this.multiple;
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return true;
	        },
	        menuCanShow: function menuCanShow() {
	            if (!this.isFocused) return false;
	            return this.displayedItemsCount > 0 || !!this.$slots['no-data'] && !this.hideNoData;
	        }
	    },
	    methods: {
	        onFilteredItemsChanged: function onFilteredItemsChanged() {
	            // nop
	        },
	        onInternalSearchChanged: function onInternalSearchChanged(val) {
	            if (val && this.multiple && this.delimiters) {
	                var delimiter = this.delimiters.find(function (d) {
	                    return val.endsWith(d);
	                });
	                if (delimiter == null) return;
	                this.internalSearch = val.slice(0, val.length - delimiter.length);
	                this.updateTags();
	            }
	            this.updateMenuDimensions();
	        },
	        genChipSelection: function genChipSelection(item, index) {
	            var _this = this;
	            var chip = _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genChipSelection.call(this, item, index);
	            // Allow user to update an existing value
	            if (this.multiple) {
	                chip.componentOptions.listeners.dblclick = function () {
	                    _this.editingIndex = index;
	                    _this.internalSearch = _this.getText(item);
	                    _this.selectedIndex = -1;
	                };
	            }
	            return chip;
	        },
	        onChipInput: function onChipInput(item) {
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onChipInput.call(this, item);
	            this.editingIndex = -1;
	        },
	        // Requires a manual definition
	        // to overwrite removal in v-autocomplete
	        onEnterDown: function onEnterDown(e) {
	            e.preventDefault();
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onEnterDown.call(this);
	            // If has menu index, let v-select-list handle
	            if (this.getMenuIndex() > -1) return;
	            this.updateSelf();
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onKeyDown.call(this, e);
	            // If user is at selection index of 0
	            // create a new tag
	            if (this.multiple && keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].left && this.$refs.input.selectionStart === 0) {
	                this.updateSelf();
	            }
	            // The ordering is important here
	            // allows new value to be updated
	            // and then moves the index to the
	            // proper location
	            this.changeSelectedIndex(keyCode);
	        },
	        onTabDown: function onTabDown(e) {
	            // When adding tags, if searching and
	            // there is not a filtered options,
	            // add the value to the tags list
	            if (this.multiple && this.internalSearch && this.getMenuIndex() === -1) {
	                e.preventDefault();
	                e.stopPropagation();
	                return this.updateTags();
	            }
	            _VAutocomplete_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].methods.onTabDown.call(this, e);
	        },
	        selectItem: function selectItem(item) {
	            // Currently only supports items:<string[]>
	            if (this.editingIndex > -1) {
	                this.updateEditing();
	            } else {
	                _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.selectItem.call(this, item);
	            }
	        },
	        setSelectedItems: function setSelectedItems() {
	            if (this.internalValue == null || this.internalValue === '') {
	                this.selectedItems = [];
	            } else {
	                this.selectedItems = this.multiple ? this.internalValue : [this.internalValue];
	            }
	        },
	        setValue: function setValue(value) {
	            if (value === void 0) {
	                value = this.internalSearch;
	            }
	            _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.setValue.call(this, value);
	        },
	        updateEditing: function updateEditing() {
	            var value = this.internalValue.slice();
	            value[this.editingIndex] = this.internalSearch;
	            this.setValue(value);
	            this.editingIndex = -1;
	        },
	        updateCombobox: function updateCombobox() {
	            var isUsingSlot = Boolean(this.$scopedSlots.selection) || this.hasChips;
	            // If search is not dirty and is
	            // using slot, do nothing
	            if (isUsingSlot && !this.searchIsDirty) return;
	            // The internal search is not matching
	            // the internal value, update the input
	            if (this.internalSearch !== this.getText(this.internalValue)) this.setValue();
	            // Reset search if using slot
	            // to avoid a double input
	            if (isUsingSlot) this.internalSearch = undefined;
	        },
	        updateSelf: function updateSelf() {
	            this.multiple ? this.updateTags() : this.updateCombobox();
	        },
	        updateTags: function updateTags() {
	            var menuIndex = this.getMenuIndex();
	            // If the user is not searching
	            // and no menu item is selected
	            // do nothing
	            if (menuIndex < 0 && !this.searchIsDirty) return;
	            if (this.editingIndex > -1) {
	                return this.updateEditing();
	            }
	            var index = this.selectedItems.indexOf(this.internalSearch);
	            // If it already exists, do nothing
	            // this might need to change to bring
	            // the duplicated item to the last entered
	            if (index > -1) {
	                var internalValue = this.internalValue.slice();
	                internalValue.splice(index, 1);
	                this.setValue(internalValue);
	            }
	            // If menu index is greater than 1
	            // the selection is handled elsewhere
	            // TODO: find out where
	            if (menuIndex > -1) return this.internalSearch = null;
	            this.selectItem(this.internalSearch);
	            this.internalSearch = null;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCombobox/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VCombobox/index.js ***!
	  \*******************************************/
	/*! exports provided: VCombobox, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCombobox */ "./src/components/VCombobox/VCombobox.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCombobox", function() { return _VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCombobox__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VCounter/VCounter.js":
	/*!*********************************************!*\
	  !*** ./src/components/VCounter/VCounter.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_counters.styl */ "./src/stylus/components/_counters.styl");
	/* harmony import */ var _stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_counters_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-counter',
	    functional: true,
	    mixins: [_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        value: {
	            type: [Number, String],
	            default: ''
	        },
	        max: [Number, String]
	    },
	    render: function render(h, ctx) {
	        var props = ctx.props;
	        var max = parseInt(props.max, 10);
	        var value = parseInt(props.value, 10);
	        var content = max ? value + " / " + max : props.value;
	        var isGreater = max && value > max;
	        return h('div', {
	            staticClass: 'v-counter',
	            class: __assign({ 'error--text': isGreater }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["functionalThemeClasses"])(ctx))
	        }, content);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VCounter/index.js":
	/*!******************************************!*\
	  !*** ./src/components/VCounter/index.js ***!
	  \******************************************/
	/*! exports provided: VCounter, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VCounter */ "./src/components/VCounter/VCounter.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCounter", function() { return _VCounter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VCounter__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDataIterator/VDataIterator.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VDataIterator/VDataIterator.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_data-iterator.styl */ "./src/stylus/components/_data-iterator.styl");
	/* harmony import */ var _stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_data_iterator_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_data_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/data-iterable */ "./src/mixins/data-iterable.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-data-iterator',
	    mixins: [_mixins_data_iterable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    inheritAttrs: false,
	    props: {
	        contentTag: {
	            type: String,
	            default: 'div'
	        },
	        contentProps: {
	            type: Object,
	            required: false
	        },
	        contentClass: {
	            type: String,
	            required: false
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-data-iterator': true, 'v-data-iterator--select-all': this.selectAll !== false }, this.themeClasses);
	        }
	    },
	    created: function created() {
	        this.initPagination();
	    },
	    methods: {
	        genContent: function genContent() {
	            var children = this.genItems();
	            var data = {
	                'class': this.contentClass,
	                attrs: this.$attrs,
	                on: this.$listeners,
	                props: this.contentProps
	            };
	            return this.$createElement(this.contentTag, data, children);
	        },
	        genEmptyItems: function genEmptyItems(content) {
	            return [this.$createElement('div', {
	                'class': 'text-xs-center',
	                style: 'width: 100%'
	            }, content)];
	        },
	        genFilteredItems: function genFilteredItems() {
	            if (!this.$scopedSlots.item) {
	                return null;
	            }
	            var items = [];
	            for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
	                var item = this.filteredItems[index];
	                var props = this.createProps(item, index);
	                items.push(this.$scopedSlots.item(props));
	            }
	            return items;
	        },
	        genFooter: function genFooter() {
	            var children = [];
	            if (this.$slots.footer) {
	                children.push(this.$slots.footer);
	            }
	            if (!this.hideActions) {
	                children.push(this.genActions());
	            }
	            if (!children.length) return null;
	            return this.$createElement('div', children);
	        },
	        genHeader: function genHeader() {
	            var children = [];
	            if (this.$slots.header) {
	                children.push(this.$slots.header);
	            }
	            if (!children.length) return null;
	            return this.$createElement('div', children);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            'class': this.classes
	        }, [this.genHeader(), this.genContent(), this.genFooter()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataIterator/index.js":
	/*!***********************************************!*\
	  !*** ./src/components/VDataIterator/index.js ***!
	  \***********************************************/
	/*! exports provided: VDataIterator, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDataIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDataIterator */ "./src/components/VDataIterator/VDataIterator.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return _VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDataIterator__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/VDataTable.js":
	/*!*************************************************!*\
	  !*** ./src/components/VDataTable/VDataTable.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tables.styl */ "./src/stylus/components/_tables.styl");
	/* harmony import */ var _stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tables_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_data-table.styl */ "./src/stylus/components/_data-table.styl");
	/* harmony import */ var _stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_data_table_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_data_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/data-iterable */ "./src/mixins/data-iterable.js");
	/* harmony import */ var _mixins_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/head */ "./src/components/VDataTable/mixins/head.js");
	/* harmony import */ var _mixins_body__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/body */ "./src/components/VDataTable/mixins/body.js");
	/* harmony import */ var _mixins_foot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/foot */ "./src/components/VDataTable/mixins/foot.js");
	/* harmony import */ var _mixins_progress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/progress */ "./src/components/VDataTable/mixins/progress.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	
	
	
	
	// Importing does not work properly
	var VTableOverflow = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["createSimpleFunctional"])('v-table__overflow');
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-data-table',
	    mixins: [_mixins_data_iterable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_head__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_body__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_foot__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_progress__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        headers: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        headersLength: {
	            type: Number
	        },
	        headerText: {
	            type: String,
	            default: 'text'
	        },
	        headerKey: {
	            type: String,
	            default: null
	        },
	        hideHeaders: Boolean,
	        rowsPerPageText: {
	            type: String,
	            default: '$vuetify.dataTable.rowsPerPageText'
	        },
	        customFilter: {
	            type: Function,
	            default: function _default(items, search, filter, headers) {
	                search = search.toString().toLowerCase();
	                if (search.trim() === '') return items;
	                var props = headers.map(function (h) {
	                    return h.value;
	                });
	                return items.filter(function (item) {
	                    return props.some(function (prop) {
	                        return filter(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getObjectValueByPath"])(item, prop, item[prop]), search);
	                    });
	                });
	            }
	        }
	    },
	    data: function data() {
	        return {
	            actionsClasses: 'v-datatable__actions',
	            actionsRangeControlsClasses: 'v-datatable__actions__range-controls',
	            actionsSelectClasses: 'v-datatable__actions__select',
	            actionsPaginationClasses: 'v-datatable__actions__pagination'
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-datatable v-table': true, 'v-datatable--select-all': this.selectAll !== false }, this.themeClasses);
	        },
	        filteredItems: function filteredItems() {
	            return this.filteredItemsImpl(this.headers);
	        },
	        headerColumns: function headerColumns() {
	            return this.headersLength || this.headers.length + (this.selectAll !== false);
	        }
	    },
	    created: function created() {
	        var firstSortable = this.headers.find(function (h) {
	            return !('sortable' in h) || h.sortable;
	        });
	        this.defaultPagination.sortBy = !this.disableInitialSort && firstSortable ? firstSortable.value : null;
	        this.initPagination();
	    },
	    methods: {
	        hasTag: function hasTag(elements, tag) {
	            return Array.isArray(elements) && elements.find(function (e) {
	                return e.tag === tag;
	            });
	        },
	        genTR: function genTR(children, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            return this.$createElement('tr', data, children);
	        }
	    },
	    render: function render(h) {
	        var tableOverflow = h(VTableOverflow, {}, [h('table', {
	            'class': this.classes
	        }, [this.genTHead(), this.genTBody(), this.genTFoot()])]);
	        return h('div', [tableOverflow, this.genActionsFooter()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/VEditDialog.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/VEditDialog.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_small-dialog.styl */ "./src/stylus/components/_small-dialog.styl");
	/* harmony import */ var _stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_small_dialog_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VMenu */ "./src/components/VMenu/index.js");
	
	// Mixins
	
	
	// Utils
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-edit-dialog',
	    mixins: [_mixins_returnable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        cancelText: {
	            default: 'Cancel'
	        },
	        large: Boolean,
	        lazy: Boolean,
	        persistent: Boolean,
	        saveText: {
	            default: 'Save'
	        },
	        transition: {
	            type: String,
	            default: 'slide-x-reverse-transition'
	        }
	    },
	    data: function data() {
	        return {
	            isActive: false
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.$emit('open');
	                setTimeout(this.focus, 50); // Give DOM time to paint
	            } else {
	                this.$emit('close');
	            }
	        }
	    },
	    methods: {
	        cancel: function cancel() {
	            this.isActive = false;
	            this.$emit('cancel');
	        },
	        focus: function focus() {
	            var input = this.$refs.content.querySelector('input');
	            input && input.focus();
	        },
	        genButton: function genButton(fn, text) {
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    flat: true,
	                    color: 'primary',
	                    light: true
	                },
	                on: { click: fn }
	            }, text);
	        },
	        genActions: function genActions() {
	            var _this = this;
	            return this.$createElement('div', {
	                'class': 'v-small-dialog__actions'
	            }, [this.genButton(this.cancel, this.cancelText), this.genButton(function () {
	                _this.save(_this.returnValue);
	                _this.$emit('save');
	            }, this.saveText)]);
	        },
	        genContent: function genContent() {
	            var _this = this;
	            return this.$createElement('div', {
	                on: {
	                    keydown: function keydown(e) {
	                        var input = _this.$refs.content.querySelector('input');
	                        e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].esc && _this.cancel();
	                        if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_3__["keyCodes"].enter && input) {
	                            _this.save(input.value);
	                            _this.$emit('save');
	                        }
	                    }
	                },
	                ref: 'content'
	            }, [this.$slots.input]);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        return h(_VMenu__WEBPACK_IMPORTED_MODULE_5__["default"], {
	            staticClass: 'v-small-dialog',
	            class: this.themeClasses,
	            props: {
	                contentClass: 'v-small-dialog__content',
	                transition: this.transition,
	                origin: 'top right',
	                right: true,
	                value: this.isActive,
	                closeOnClick: !this.persistent,
	                closeOnContentClick: false,
	                lazy: this.lazy,
	                light: this.light,
	                dark: this.dark
	            },
	            on: {
	                input: function input(val) {
	                    return _this.isActive = val;
	                }
	            }
	        }, [h('a', {
	            slot: 'activator'
	        }, this.$slots.default), this.genContent(), this.large ? this.genActions() : null]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VDataTable/index.js ***!
	  \********************************************/
	/*! exports provided: VDataTable, VEditDialog, VTableOverflow, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() { return VTableOverflow; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VDataTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDataTable */ "./src/components/VDataTable/VDataTable.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VEditDialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VEditDialog */ "./src/components/VDataTable/VEditDialog.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VEditDialog", function() { return _VEditDialog__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	var VTableOverflow = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-table__overflow');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VDataTable: _VDataTable__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VEditDialog: _VEditDialog__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VTableOverflow: VTableOverflow
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/body.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/body.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions_expand_transition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../transitions/expand-transition */ "./src/components/transitions/expand-transition.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTBody: function genTBody() {
	            var children = this.genItems();
	            return this.$createElement('tbody', children);
	        },
	        genExpandedRow: function genExpandedRow(props) {
	            var children = [];
	            if (this.isExpanded(props.item)) {
	                var expand = this.$createElement('div', {
	                    class: 'v-datatable__expand-content',
	                    key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props.item, this.itemKey)
	                }, [this.$scopedSlots.expand(props)]);
	                children.push(expand);
	            }
	            var transition = this.$createElement('transition-group', {
	                class: 'v-datatable__expand-col',
	                attrs: { colspan: this.headerColumns },
	                props: {
	                    tag: 'td'
	                },
	                on: Object(_transitions_expand_transition__WEBPACK_IMPORTED_MODULE_0__["default"])('v-datatable__expand-col--expanded')
	            }, children);
	            return this.genTR([transition], { class: 'v-datatable__expand-row' });
	        },
	        genFilteredItems: function genFilteredItems() {
	            if (!this.$scopedSlots.items) {
	                return null;
	            }
	            var rows = [];
	            for (var index = 0, len = this.filteredItems.length; index < len; ++index) {
	                var item = this.filteredItems[index];
	                var props = this.createProps(item, index);
	                var row = this.$scopedSlots.items(props);
	                rows.push(this.hasTag(row, 'td') ? this.genTR(row, {
	                    key: this.itemKey ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(props.item, this.itemKey) : index,
	                    attrs: { active: this.isSelected(item) }
	                }) : row);
	                if (this.$scopedSlots.expand) {
	                    var expandRow = this.genExpandedRow(props);
	                    rows.push(expandRow);
	                }
	            }
	            return rows;
	        },
	        genEmptyItems: function genEmptyItems(content) {
	            if (this.hasTag(content, 'tr')) {
	                return content;
	            } else if (this.hasTag(content, 'td')) {
	                return this.genTR(content);
	            } else {
	                return this.genTR([this.$createElement('td', {
	                    class: {
	                        'text-xs-center': typeof content === 'string'
	                    },
	                    attrs: { colspan: this.headerColumns }
	                }, content)]);
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/foot.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/foot.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTFoot: function genTFoot() {
	            if (!this.$slots.footer) {
	                return null;
	            }
	            var footer = this.$slots.footer;
	            var row = this.hasTag(footer, 'td') ? this.genTR(footer) : footer;
	            return this.$createElement('tfoot', [row]);
	        },
	        genActionsFooter: function genActionsFooter() {
	            if (this.hideActions) {
	                return null;
	            }
	            return this.$createElement('div', {
	                'class': this.classes
	            }, this.genActions());
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/head.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDataTable/mixins/head.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../VIcon */ "./src/components/VIcon/index.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    props: {
	        sortIcon: {
	            type: String,
	            default: '$vuetify.icons.sort'
	        }
	    },
	    methods: {
	        genTHead: function genTHead() {
	            var _this = this;
	            if (this.hideHeaders) return; // Exit Early since no headers are needed.
	            var children = [];
	            if (this.$scopedSlots.headers) {
	                var row = this.$scopedSlots.headers({
	                    headers: this.headers,
	                    indeterminate: this.indeterminate,
	                    all: this.everyItem
	                });
	                children = [this.hasTag(row, 'th') ? this.genTR(row) : row, this.genTProgress()];
	            } else {
	                var row = this.headers.map(function (o, i) {
	                    return _this.genHeader(o, _this.headerKey ? o[_this.headerKey] : i);
	                });
	                var checkbox = this.$createElement(_VCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                    props: {
	                        dark: this.dark,
	                        light: this.light,
	                        color: this.selectAll === true ? '' : this.selectAll,
	                        hideDetails: true,
	                        inputValue: this.everyItem,
	                        indeterminate: this.indeterminate
	                    },
	                    on: { change: this.toggle }
	                });
	                this.hasSelectAll && row.unshift(this.$createElement('th', [checkbox]));
	                children = [this.genTR(row), this.genTProgress()];
	            }
	            return this.$createElement('thead', [children]);
	        },
	        genHeader: function genHeader(header, key) {
	            var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];
	            return this.$createElement.apply(this, __spread(['th'], this.genHeaderData(header, array, key)));
	        },
	        genHeaderData: function genHeaderData(header, children, key) {
	            var classes = ['column'];
	            var data = {
	                key: key,
	                attrs: {
	                    role: 'columnheader',
	                    scope: 'col',
	                    width: header.width || null,
	                    'aria-label': header[this.headerText] || '',
	                    'aria-sort': 'none'
	                }
	            };
	            if (header.sortable == null || header.sortable) {
	                this.genHeaderSortingData(header, children, data, classes);
	            } else {
	                data.attrs['aria-label'] += ': Not sorted.'; // TODO: Localization
	            }
	            classes.push("text-xs-" + (header.align || 'left'));
	            if (Array.isArray(header.class)) {
	                classes.push.apply(classes, __spread(header.class));
	            } else if (header.class) {
	                classes.push(header.class);
	            }
	            data.class = classes;
	            return [data, children];
	        },
	        genHeaderSortingData: function genHeaderSortingData(header, children, data, classes) {
	            var _this = this;
	            if (!('value' in header)) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])('Headers must have a value property that corresponds to a value in the v-model array', this);
	            }
	            data.attrs.tabIndex = 0;
	            data.on = {
	                click: function click() {
	                    _this.expanded = {};
	                    _this.sort(header.value);
	                },
	                keydown: function keydown(e) {
	                    // check for space
	                    if (e.keyCode === 32) {
	                        e.preventDefault();
	                        _this.sort(header.value);
	                    }
	                }
	            };
	            classes.push('sortable');
	            var icon = this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    small: true
	                }
	            }, this.sortIcon);
	            if (!header.align || header.align === 'left') {
	                children.push(icon);
	            } else {
	                children.unshift(icon);
	            }
	            var pagination = this.computedPagination;
	            var beingSorted = pagination.sortBy === header.value;
	            if (beingSorted) {
	                classes.push('active');
	                if (pagination.descending) {
	                    classes.push('desc');
	                    data.attrs['aria-sort'] = 'descending';
	                    data.attrs['aria-label'] += ': Sorted descending. Activate to remove sorting.'; // TODO: Localization
	                } else {
	                    classes.push('asc');
	                    data.attrs['aria-sort'] = 'ascending';
	                    data.attrs['aria-label'] += ': Sorted ascending. Activate to sort descending.'; // TODO: Localization
	                }
	            } else {
	                data.attrs['aria-label'] += ': Not sorted. Activate to sort ascending.'; // TODO: Localization
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDataTable/mixins/progress.js":
	/*!******************************************************!*\
	  !*** ./src/components/VDataTable/mixins/progress.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genTProgress: function genTProgress() {
	            var col = this.$createElement('th', {
	                staticClass: 'column',
	                attrs: {
	                    colspan: this.headerColumns
	                }
	            }, [this.genProgress()]);
	            return this.genTR([col], {
	                staticClass: 'v-datatable__progress'
	            });
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePicker.js":
	/*!***************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePicker.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDatePickerTitle */ "./src/components/VDatePicker/VDatePickerTitle.js");
	/* harmony import */ var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDatePickerHeader */ "./src/components/VDatePicker/VDatePickerHeader.js");
	/* harmony import */ var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VDatePickerDateTable */ "./src/components/VDatePicker/VDatePickerDateTable.js");
	/* harmony import */ var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VDatePickerMonthTable */ "./src/components/VDatePicker/VDatePickerMonthTable.js");
	/* harmony import */ var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VDatePickerYears */ "./src/components/VDatePicker/VDatePickerYears.js");
	/* harmony import */ var _mixins_picker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/picker */ "./src/mixins/picker.js");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.js");
	/* harmony import */ var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/isDateAllowed */ "./src/components/VDatePicker/util/isDateAllowed.js");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	// Components
	
	
	
	
	
	// Mixins
	
	// Utils
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker',
	    mixins: [_mixins_picker__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    props: {
	        allowedDates: Function,
	        // Function formatting the day in date picker table
	        dayFormat: {
	            type: Function,
	            default: null
	        },
	        events: {
	            type: [Array, Object, Function],
	            default: function _default() {
	                return null;
	            }
	        },
	        eventColor: {
	            type: [String, Function, Object],
	            default: 'warning'
	        },
	        firstDayOfWeek: {
	            type: [String, Number],
	            default: 0
	        },
	        // Function formatting the tableDate in the day/month table header
	        headerDateFormat: {
	            type: Function,
	            default: null
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        max: String,
	        min: String,
	        // Function formatting month in the months table
	        monthFormat: {
	            type: Function,
	            default: null
	        },
	        multiple: Boolean,
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        pickerDate: String,
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        reactive: Boolean,
	        readonly: Boolean,
	        scrollable: Boolean,
	        showCurrent: {
	            type: [Boolean, String],
	            default: true
	        },
	        // Function formatting currently selected date in the picker title
	        titleDateFormat: {
	            type: Function,
	            default: null
	        },
	        type: {
	            type: String,
	            default: 'date',
	            validator: function validator(type) {
	                return ['date', 'month'].includes(type);
	            } // TODO: year
	        },
	        value: [Array, String],
	        weekdayFormat: {
	            type: Function,
	            default: null
	        },
	        // Function formatting the year in table header and pickup title
	        yearFormat: {
	            type: Function,
	            default: null
	        },
	        yearIcon: String
	    },
	    data: function data() {
	        var _this = this;
	        var now = new Date();
	        return {
	            activePicker: this.type.toUpperCase(),
	            inputDay: null,
	            inputMonth: null,
	            inputYear: null,
	            isReversing: false,
	            now: now,
	            // tableDate is a string in 'YYYY' / 'YYYY-M' format (leading zero for month is not required)
	            tableDate: function () {
	                if (_this.pickerDate) {
	                    return _this.pickerDate;
	                }
	                var date = (_this.multiple ? _this.value[_this.value.length - 1] : _this.value) || now.getFullYear() + "-" + (now.getMonth() + 1);
	                var type = _this.type === 'date' ? 'month' : 'year';
	                return _this.sanitizeDateString(date, type);
	            }()
	        };
	    },
	    computed: {
	        lastValue: function lastValue() {
	            return this.multiple ? this.value[this.value.length - 1] : this.value;
	        },
	        selectedMonths: function selectedMonths() {
	            if (!this.value || !this.value.length || this.type === 'month') {
	                return this.value;
	            } else if (this.multiple) {
	                return this.value.map(function (val) {
	                    return val.substr(0, 7);
	                });
	            } else {
	                return this.value.substr(0, 7);
	            }
	        },
	        current: function current() {
	            if (this.showCurrent === true) {
	                return this.sanitizeDateString(this.now.getFullYear() + "-" + (this.now.getMonth() + 1) + "-" + this.now.getDate(), this.type);
	            }
	            return this.showCurrent || null;
	        },
	        inputDate: function inputDate() {
	            return this.type === 'date' ? this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputDay) : this.inputYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.inputMonth + 1);
	        },
	        tableMonth: function tableMonth() {
	            return (this.pickerDate || this.tableDate).split('-')[1] - 1;
	        },
	        tableYear: function tableYear() {
	            return (this.pickerDate || this.tableDate).split('-')[0] * 1;
	        },
	        minMonth: function minMonth() {
	            return this.min ? this.sanitizeDateString(this.min, 'month') : null;
	        },
	        maxMonth: function maxMonth() {
	            return this.max ? this.sanitizeDateString(this.max, 'month') : null;
	        },
	        minYear: function minYear() {
	            return this.min ? this.sanitizeDateString(this.min, 'year') : null;
	        },
	        maxYear: function maxYear() {
	            return this.max ? this.sanitizeDateString(this.max, 'year') : null;
	        },
	        formatters: function formatters() {
	            return {
	                year: this.yearFormat || Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 }),
	                titleDate: this.titleDateFormat || (this.multiple ? this.defaultTitleMultipleDateFormatter : this.defaultTitleDateFormatter)
	            };
	        },
	        defaultTitleMultipleDateFormatter: function defaultTitleMultipleDateFormatter() {
	            var _this = this;
	            if (this.value.length < 2) {
	                return function (dates) {
	                    return dates.length ? _this.defaultTitleDateFormatter(dates[0]) : '0 selected';
	                };
	            }
	            return function (dates) {
	                return dates.length + " selected";
	            };
	        },
	        defaultTitleDateFormatter: function defaultTitleDateFormatter() {
	            var titleFormats = {
	                year: { year: 'numeric', timeZone: 'UTC' },
	                month: { month: 'long', timeZone: 'UTC' },
	                date: { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' }
	            };
	            var titleDateFormatter = Object(_util__WEBPACK_IMPORTED_MODULE_6__["createNativeLocaleFormatter"])(this.locale, titleFormats[this.type], {
	                start: 0,
	                length: { date: 10, month: 7, year: 4 }[this.type]
	            });
	            var landscapeFormatter = function landscapeFormatter(date) {
	                return titleDateFormatter(date).replace(/([^\d\s])([\d])/g, function (match, nonDigit, digit) {
	                    return nonDigit + " " + digit;
	                }).replace(', ', ',<br>');
	            };
	            return this.landscape ? landscapeFormatter : titleDateFormatter;
	        }
	    },
	    watch: {
	        tableDate: function tableDate(val, prev) {
	            // Make a ISO 8601 strings from val and prev for comparision, otherwise it will incorrectly
	            // compare for example '2000-9' and '2000-10'
	            var sanitizeType = this.type === 'month' ? 'year' : 'month';
	            this.isReversing = this.sanitizeDateString(val, sanitizeType) < this.sanitizeDateString(prev, sanitizeType);
	            this.$emit('update:pickerDate', val);
	        },
	        pickerDate: function pickerDate(val) {
	            if (val) {
	                this.tableDate = val;
	            } else if (this.lastValue && this.type === 'date') {
	                this.tableDate = this.sanitizeDateString(this.lastValue, 'month');
	            } else if (this.lastValue && this.type === 'month') {
	                this.tableDate = this.sanitizeDateString(this.lastValue, 'year');
	            }
	        },
	        value: function value(newValue, oldValue) {
	            this.checkMultipleProp();
	            this.setInputDate();
	            if (!this.multiple && this.value && !this.pickerDate) {
	                this.tableDate = this.sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
	            } else if (this.multiple && this.value.length && !oldValue.length && !this.pickerDate) {
	                this.tableDate = this.sanitizeDateString(this.inputDate, this.type === 'month' ? 'year' : 'month');
	            }
	        },
	        type: function type(_type) {
	            var _this = this;
	            this.activePicker = _type.toUpperCase();
	            if (this.value && this.value.length) {
	                var output = (this.multiple ? this.value : [this.value]).map(function (val) {
	                    return _this.sanitizeDateString(val, _type);
	                }).filter(this.isDateAllowed);
	                this.$emit('input', this.multiple ? output : output[0]);
	            }
	        }
	    },
	    created: function created() {
	        this.checkMultipleProp();
	        if (this.pickerDate !== this.tableDate) {
	            this.$emit('update:pickerDate', this.tableDate);
	        }
	        this.setInputDate();
	    },
	    methods: {
	        emitInput: function emitInput(newInput) {
	            var output = this.multiple ? this.value.indexOf(newInput) === -1 ? this.value.concat([newInput]) : this.value.filter(function (x) {
	                return x !== newInput;
	            }) : newInput;
	            this.$emit('input', output);
	            this.multiple || this.$emit('change', newInput);
	        },
	        checkMultipleProp: function checkMultipleProp() {
	            if (this.value == null) return;
	            var valueType = this.value.constructor.name;
	            var expected = this.multiple ? 'Array' : 'String';
	            if (valueType !== expected) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleWarn"])("Value must be " + (this.multiple ? 'an' : 'a') + " " + expected + ", got " + valueType, this);
	            }
	        },
	        isDateAllowed: function isDateAllowed(value) {
	            return Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_7__["default"])(value, this.min, this.max, this.allowedDates);
	        },
	        yearClick: function yearClick(value) {
	            this.inputYear = value;
	            if (this.type === 'month') {
	                this.tableDate = "" + value;
	            } else {
	                this.tableDate = value + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableMonth + 1);
	            }
	            this.activePicker = 'MONTH';
	            this.reactive && !this.multiple && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
	        },
	        monthClick: function monthClick(value) {
	            this.inputYear = parseInt(value.split('-')[0], 10);
	            this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
	            if (this.type === 'date') {
	                this.tableDate = value;
	                this.activePicker = 'DATE';
	                this.reactive && !this.multiple && this.isDateAllowed(this.inputDate) && this.$emit('input', this.inputDate);
	            } else {
	                this.emitInput(this.inputDate);
	            }
	        },
	        dateClick: function dateClick(value) {
	            this.inputYear = parseInt(value.split('-')[0], 10);
	            this.inputMonth = parseInt(value.split('-')[1], 10) - 1;
	            this.inputDay = parseInt(value.split('-')[2], 10);
	            this.emitInput(this.inputDate);
	        },
	        genPickerTitle: function genPickerTitle() {
	            var _this = this;
	            return this.$createElement(_VDatePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    date: this.value ? this.formatters.titleDate(this.value) : '',
	                    selectingYear: this.activePicker === 'YEAR',
	                    year: this.formatters.year(this.value ? "" + this.inputYear : this.tableDate),
	                    yearIcon: this.yearIcon,
	                    value: this.multiple ? this.value[0] : this.value
	                },
	                slot: 'title',
	                style: this.readonly ? {
	                    'pointer-events': 'none'
	                } : undefined,
	                on: {
	                    'update:selectingYear': function updateSelectingYear(value) {
	                        return _this.activePicker = value ? 'YEAR' : _this.type.toUpperCase();
	                    }
	                }
	            });
	        },
	        genTableHeader: function genTableHeader() {
	            var _this = this;
	            return this.$createElement(_VDatePickerHeader__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    nextIcon: this.nextIcon,
	                    color: this.color,
	                    dark: this.dark,
	                    disabled: this.readonly,
	                    format: this.headerDateFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.activePicker === 'DATE' ? this.minMonth : this.minYear,
	                    max: this.activePicker === 'DATE' ? this.maxMonth : this.maxYear,
	                    prevIcon: this.prevIcon,
	                    value: this.activePicker === 'DATE' ? this.tableYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableMonth + 1) : "" + this.tableYear
	                },
	                on: {
	                    toggle: function toggle() {
	                        return _this.activePicker = _this.activePicker === 'DATE' ? 'MONTH' : 'YEAR';
	                    },
	                    input: function input(value) {
	                        return _this.tableDate = value;
	                    }
	                }
	            });
	        },
	        genDateTable: function genDateTable() {
	            var _this = this;
	            return this.$createElement(_VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    allowedDates: this.allowedDates,
	                    color: this.color,
	                    current: this.current,
	                    dark: this.dark,
	                    disabled: this.readonly,
	                    events: this.events,
	                    eventColor: this.eventColor,
	                    firstDayOfWeek: this.firstDayOfWeek,
	                    format: this.dayFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.min,
	                    max: this.max,
	                    tableDate: this.tableYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(this.tableMonth + 1),
	                    scrollable: this.scrollable,
	                    value: this.value,
	                    weekdayFormat: this.weekdayFormat
	                },
	                ref: 'table',
	                on: {
	                    input: this.dateClick,
	                    tableDate: function tableDate(value) {
	                        return _this.tableDate = value;
	                    }
	                }
	            });
	        },
	        genMonthTable: function genMonthTable() {
	            var _this = this;
	            return this.$createElement(_VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: {
	                    allowedDates: this.type === 'month' ? this.allowedDates : null,
	                    color: this.color,
	                    current: this.current ? this.sanitizeDateString(this.current, 'month') : null,
	                    dark: this.dark,
	                    disabled: this.readonly,
	                    format: this.monthFormat,
	                    light: this.light,
	                    locale: this.locale,
	                    min: this.minMonth,
	                    max: this.maxMonth,
	                    scrollable: this.scrollable,
	                    value: this.selectedMonths,
	                    tableDate: "" + this.tableYear
	                },
	                ref: 'table',
	                on: {
	                    input: this.monthClick,
	                    tableDate: function tableDate(value) {
	                        return _this.tableDate = value;
	                    }
	                }
	            });
	        },
	        genYears: function genYears() {
	            return this.$createElement(_VDatePickerYears__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: {
	                    color: this.color,
	                    format: this.yearFormat,
	                    locale: this.locale,
	                    min: this.minYear,
	                    max: this.maxYear,
	                    value: "" + this.tableYear
	                },
	                on: {
	                    input: this.yearClick
	                }
	            });
	        },
	        genPickerBody: function genPickerBody() {
	            var children = this.activePicker === 'YEAR' ? [this.genYears()] : [this.genTableHeader(), this.activePicker === 'DATE' ? this.genDateTable() : this.genMonthTable()];
	            return this.$createElement('div', {
	                key: this.activePicker,
	                style: this.readonly ? {
	                    'pointer-events': 'none'
	                } : undefined
	            }, children);
	        },
	        // Adds leading zero to month/day if necessary, returns 'YYYY' if type = 'year',
	        // 'YYYY-MM' if 'month' and 'YYYY-MM-DD' if 'date'
	        sanitizeDateString: function sanitizeDateString(dateString, type) {
	            var _a = __read(dateString.split('-'), 3),
	                year = _a[0],
	                _b = _a[1],
	                month = _b === void 0 ? 1 : _b,
	                _c = _a[2],
	                date = _c === void 0 ? 1 : _c;
	            return (year + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(month) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_6__["pad"])(date)).substr(0, { date: 10, month: 7, year: 4 }[type]);
	        },
	        setInputDate: function setInputDate() {
	            if (this.lastValue) {
	                var array = this.lastValue.split('-');
	                this.inputYear = parseInt(array[0], 10);
	                this.inputMonth = parseInt(array[1], 10) - 1;
	                if (this.type === 'date') {
	                    this.inputDay = parseInt(array[2], 10);
	                }
	            } else {
	                this.inputYear = this.inputYear || this.now.getFullYear();
	                this.inputMonth = this.inputMonth == null ? this.inputMonth : this.now.getMonth();
	                this.inputDay = this.inputDay || this.now.getDate();
	            }
	        }
	    },
	    render: function render() {
	        return this.genPicker('v-picker--date');
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerDateTable.js":
	/*!************************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerDateTable.js ***!
	  \************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/date-picker-table */ "./src/components/VDatePicker/mixins/date-picker-table.js");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Mixins
	
	
	
	// Utils
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker-date-table',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        events: {
	            type: [Array, Object, Function],
	            default: function _default() {
	                return null;
	            }
	        },
	        eventColor: {
	            type: [String, Function, Object],
	            default: 'warning'
	        },
	        firstDayOfWeek: {
	            type: [String, Number],
	            default: 0
	        },
	        weekdayFormat: {
	            type: Function,
	            default: null
	        }
	    },
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_3__["createNativeLocaleFormatter"])(this.locale, { day: 'numeric', timeZone: 'UTC' }, { start: 8, length: 2 });
	        },
	        weekdayFormatter: function weekdayFormatter() {
	            return this.weekdayFormat || Object(_util__WEBPACK_IMPORTED_MODULE_3__["createNativeLocaleFormatter"])(this.locale, { weekday: 'narrow', timeZone: 'UTC' });
	        },
	        weekDays: function weekDays() {
	            var _this = this;
	            var first = parseInt(this.firstDayOfWeek, 10);
	            return this.weekdayFormatter ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(7).map(function (i) {
	                return _this.weekdayFormatter("2017-01-" + (first + i + 15));
	            }) // 2017-01-15 is Sunday
	            : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(7).map(function (i) {
	                return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][(i + first) % 7];
	            });
	        }
	    },
	    methods: {
	        calculateTableDate: function calculateTableDate(delta) {
	            return Object(_util__WEBPACK_IMPORTED_MODULE_3__["monthChange"])(this.tableDate, Math.sign(delta || 1));
	        },
	        genTHead: function genTHead() {
	            var _this = this;
	            var days = this.weekDays.map(function (day) {
	                return _this.$createElement('th', day);
	            });
	            return this.$createElement('thead', this.genTR(days));
	        },
	        genEvent: function genEvent(date) {
	            var eventColor;
	            if (typeof this.eventColor === 'string') {
	                eventColor = this.eventColor;
	            } else if (typeof this.eventColor === 'function') {
	                eventColor = this.eventColor(date);
	            } else {
	                eventColor = this.eventColor[date];
	            }
	            return this.$createElement('div', this.setBackgroundColor(eventColor || this.color || 'accent', {
	                staticClass: 'v-date-picker-table__event'
	            }));
	        },
	        // Returns number of the days from the firstDayOfWeek to the first day of the current month
	        weekDaysBeforeFirstDayOfTheMonth: function weekDaysBeforeFirstDayOfTheMonth() {
	            var firstDayOfTheMonth = new Date(this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_3__["pad"])(this.displayedMonth + 1) + "-01T00:00:00+00:00");
	            var weekDay = firstDayOfTheMonth.getUTCDay();
	            return (weekDay - parseInt(this.firstDayOfWeek) + 7) % 7;
	        },
	        isEvent: function isEvent(date) {
	            if (Array.isArray(this.events)) {
	                return this.events.indexOf(date) > -1;
	            } else if (this.events instanceof Function) {
	                return this.events(date);
	            } else {
	                return false;
	            }
	        },
	        genTBody: function genTBody() {
	            var children = [];
	            var daysInMonth = new Date(this.displayedYear, this.displayedMonth + 1, 0).getDate();
	            var rows = [];
	            var day = this.weekDaysBeforeFirstDayOfTheMonth();
	            while (day--) {
	                rows.push(this.$createElement('td'));
	            }for (day = 1; day <= daysInMonth; day++) {
	                var date = this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_3__["pad"])(this.displayedMonth + 1) + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_3__["pad"])(day);
	                rows.push(this.$createElement('td', [this.genButton(date, true), this.isEvent(date) ? this.genEvent(date) : null]));
	                if (rows.length % 7 === 0) {
	                    children.push(this.genTR(rows));
	                    rows = [];
	                }
	            }
	            if (rows.length) {
	                children.push(this.genTR(rows));
	            }
	            return this.$createElement('tbody', children);
	        },
	        genTR: function genTR(children) {
	            return [this.$createElement('tr', children)];
	        }
	    },
	    render: function render() {
	        return this.genTable('v-date-picker-table v-date-picker-table--date', [this.genTHead(), this.genTBody()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerHeader.js":
	/*!*********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerHeader.js ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-header.styl */ "./src/stylus/components/_date-picker-header.styl");
	/* harmony import */ var _stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_header_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.js");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	// Components
	
	
	// Mixins
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker-header',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_4__["default"]],
	    props: {
	        disabled: Boolean,
	        format: {
	            type: Function,
	            default: null
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: String,
	        max: String,
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        value: {
	            type: [Number, String],
	            required: true
	        }
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        formatter: function formatter() {
	            if (this.format) {
	                return this.format;
	            } else if (String(this.value).split('-')[1]) {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["createNativeLocaleFormatter"])(this.locale, { month: 'long', year: 'numeric', timeZone: 'UTC' }, { length: 7 });
	            } else {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
	            }
	        }
	    },
	    watch: {
	        value: function value(newVal, oldVal) {
	            this.isReversing = newVal < oldVal;
	        }
	    },
	    methods: {
	        genBtn: function genBtn(change) {
	            var _this = this;
	            var disabled = this.disabled || change < 0 && this.min && this.calculateChange(change) < this.min || change > 0 && this.max && this.calculateChange(change) > this.max;
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    dark: this.dark,
	                    disabled: disabled,
	                    icon: true,
	                    light: this.light
	                },
	                nativeOn: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('input', _this.calculateChange(change));
	                    }
	                }
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], change < 0 === !this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
	        },
	        calculateChange: function calculateChange(sign) {
	            var _a = __read(String(this.value).split('-').map(function (v) {
	                return 1 * v;
	            }), 2),
	                year = _a[0],
	                month = _a[1];
	            if (month == null) {
	                return "" + (year + sign);
	            } else {
	                return Object(_util__WEBPACK_IMPORTED_MODULE_5__["monthChange"])(String(this.value), sign);
	            }
	        },
	        genHeader: function genHeader() {
	            var _this = this;
	            var color = !this.disabled && (this.color || 'accent');
	            var header = this.$createElement('strong', this.setTextColor(color, {
	                key: String(this.value),
	                on: {
	                    click: function click() {
	                        return _this.$emit('toggle');
	                    }
	                }
	            }), [this.$slots.default || this.formatter(String(this.value))]);
	            var transition = this.$createElement('transition', {
	                props: {
	                    name: this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition'
	                }
	            }, [header]);
	            return this.$createElement('div', {
	                staticClass: 'v-date-picker-header__value',
	                class: {
	                    'v-date-picker-header__value--disabled': this.disabled
	                }
	            }, [transition]);
	        }
	    },
	    render: function render() {
	        return this.$createElement('div', {
	            staticClass: 'v-date-picker-header',
	            class: this.themeClasses
	        }, [this.genBtn(-1), this.genHeader(), this.genBtn(+1)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerMonthTable.js":
	/*!*************************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerMonthTable.js ***!
	  \*************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/date-picker-table */ "./src/components/VDatePicker/mixins/date-picker-table.js");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.js");
	// Mixins
	
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker-month-table',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_date_picker_table__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_3__["createNativeLocaleFormatter"])(this.locale, { month: 'short', timeZone: 'UTC' }, { start: 5, length: 2 });
	        }
	    },
	    methods: {
	        calculateTableDate: function calculateTableDate(delta) {
	            return "" + (parseInt(this.tableDate, 10) + Math.sign(delta || 1));
	        },
	        genTBody: function genTBody() {
	            var _this = this;
	            var children = [];
	            var cols = Array(3).fill(null);
	            var rows = 12 / cols.length;
	            var _loop_1 = function _loop_1(row) {
	                var tds = cols.map(function (_, col) {
	                    var month = row * cols.length + col;
	                    return _this.$createElement('td', {
	                        key: month
	                    }, [_this.genButton(_this.displayedYear + "-" + Object(_util__WEBPACK_IMPORTED_MODULE_3__["pad"])(month + 1), false)]);
	                });
	                children.push(this_1.$createElement('tr', {
	                    key: row
	                }, tds));
	            };
	            var this_1 = this;
	            for (var row = 0; row < rows; row++) {
	                _loop_1(row);
	            }
	            return this.$createElement('tbody', children);
	        }
	    },
	    render: function render() {
	        return this.genTable('v-date-picker-table v-date-picker-table--month', [this.genTBody()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerTitle.js":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerTitle.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-title.styl */ "./src/stylus/components/_date-picker-title.styl");
	/* harmony import */ var _stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/picker-button */ "./src/mixins/picker-button.js");
	
	// Components
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker-title',
	    mixins: [_mixins_picker_button__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        date: {
	            type: String,
	            default: ''
	        },
	        selectingYear: Boolean,
	        year: {
	            type: [Number, String],
	            default: ''
	        },
	        yearIcon: {
	            type: String
	        },
	        value: {
	            type: String
	        }
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            return this.isReversing ? 'picker-reverse-transition' : 'picker-transition';
	        }
	    },
	    watch: {
	        value: function value(val, prev) {
	            this.isReversing = val < prev;
	        }
	    },
	    methods: {
	        genYearIcon: function genYearIcon() {
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    dark: true
	                }
	            }, this.yearIcon);
	        },
	        getYearBtn: function getYearBtn() {
	            return this.genPickerButton('selectingYear', true, [this.year, this.yearIcon ? this.genYearIcon() : null], false, 'v-date-picker-title__year');
	        },
	        genTitleText: function genTitleText() {
	            return this.$createElement('transition', {
	                props: {
	                    name: this.computedTransition
	                }
	            }, [this.$createElement('div', {
	                domProps: { innerHTML: this.date || '&nbsp;' },
	                key: this.value
	            })]);
	        },
	        genTitleDate: function genTitleDate(title) {
	            return this.genPickerButton('selectingYear', false, this.genTitleText(title), false, 'v-date-picker-title__date');
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-date-picker-title'
	        }, [this.getYearBtn(), this.genTitleDate()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/VDatePickerYears.js":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/VDatePickerYears.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_date-picker-years.styl */ "./src/stylus/components/_date-picker-years.styl");
	/* harmony import */ var _stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_years_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./util */ "./src/components/VDatePicker/util/index.js");
	
	// Mixins
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-date-picker-years',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        format: {
	            type: Function,
	            default: null
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: [Number, String],
	        max: [Number, String],
	        value: [Number, String]
	    },
	    data: function data() {
	        return {
	            defaultColor: 'primary'
	        };
	    },
	    computed: {
	        formatter: function formatter() {
	            return this.format || Object(_util__WEBPACK_IMPORTED_MODULE_2__["createNativeLocaleFormatter"])(this.locale, { year: 'numeric', timeZone: 'UTC' }, { length: 4 });
	        }
	    },
	    mounted: function mounted() {
	        var activeItem = this.$el.getElementsByClassName('active')[0];
	        if (activeItem) {
	            this.$el.scrollTop = activeItem.offsetTop - this.$el.offsetHeight / 2 + activeItem.offsetHeight / 2;
	        } else {
	            this.$el.scrollTop = this.$el.scrollHeight / 2 - this.$el.offsetHeight / 2;
	        }
	    },
	    methods: {
	        genYearItem: function genYearItem(year) {
	            var _this = this;
	            var formatted = this.formatter("" + year);
	            var active = parseInt(this.value, 10) === year;
	            var color = active && (this.color || 'primary');
	            return this.$createElement('li', this.setTextColor(color, {
	                key: year,
	                'class': { active: active },
	                on: {
	                    click: function click() {
	                        return _this.$emit('input', year);
	                    }
	                }
	            }), formatted);
	        },
	        genYearItems: function genYearItems() {
	            var children = [];
	            var selectedYear = this.value ? parseInt(this.value, 10) : new Date().getFullYear();
	            var maxYear = this.max ? parseInt(this.max, 10) : selectedYear + 100;
	            var minYear = Math.min(maxYear, this.min ? parseInt(this.min, 10) : selectedYear - 100);
	            for (var year = maxYear; year >= minYear; year--) {
	                children.push(this.genYearItem(year));
	            }
	            return children;
	        }
	    },
	    render: function render() {
	        return this.$createElement('ul', {
	            staticClass: 'v-date-picker-years',
	            ref: 'years'
	        }, this.genYearItems());
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/VDatePicker/index.js ***!
	  \*********************************************/
	/*! exports provided: VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDatePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDatePicker */ "./src/components/VDatePicker/VDatePicker.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VDatePickerTitle */ "./src/components/VDatePicker/VDatePickerTitle.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() { return _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VDatePickerHeader */ "./src/components/VDatePicker/VDatePickerHeader.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() { return _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VDatePickerDateTable */ "./src/components/VDatePicker/VDatePickerDateTable.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() { return _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VDatePickerMonthTable */ "./src/components/VDatePicker/VDatePickerMonthTable.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() { return _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	/* harmony import */ var _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VDatePickerYears */ "./src/components/VDatePicker/VDatePickerYears.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() { return _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"]; });
	
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VDatePicker: _VDatePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VDatePickerTitle: _VDatePickerTitle__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VDatePickerHeader: _VDatePickerHeader__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VDatePickerDateTable: _VDatePickerDateTable__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VDatePickerMonthTable: _VDatePickerMonthTable__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VDatePickerYears: _VDatePickerYears__WEBPACK_IMPORTED_MODULE_5__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/mixins/date-picker-table.js":
	/*!****************************************************************!*\
	  !*** ./src/components/VDatePicker/mixins/date-picker-table.js ***!
	  \****************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../stylus/components/_date-picker-table.styl */ "./src/stylus/components/_date-picker-table.styl");
	/* harmony import */ var _stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_date_picker_table_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_isDateAllowed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .././util/isDateAllowed */ "./src/components/VDatePicker/util/isDateAllowed.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Directives
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_1__["default"] },
	    props: {
	        allowedDates: Function,
	        current: String,
	        disabled: Boolean,
	        format: {
	            type: Function,
	            default: null
	        },
	        locale: {
	            type: String,
	            default: 'en-us'
	        },
	        min: String,
	        max: String,
	        scrollable: Boolean,
	        tableDate: {
	            type: String,
	            required: true
	        },
	        value: [String, Array]
	    },
	    data: function data() {
	        return {
	            isReversing: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            return this.isReversing === !this.$vuetify.rtl ? 'tab-reverse-transition' : 'tab-transition';
	        },
	        displayedMonth: function displayedMonth() {
	            return this.tableDate.split('-')[1] - 1;
	        },
	        displayedYear: function displayedYear() {
	            return this.tableDate.split('-')[0] * 1;
	        }
	    },
	    watch: {
	        tableDate: function tableDate(newVal, oldVal) {
	            this.isReversing = newVal < oldVal;
	        }
	    },
	    methods: {
	        genButtonClasses: function genButtonClasses(isAllowed, isFloating, isSelected, isCurrent) {
	            return __assign({ 'v-btn--active': isSelected, 'v-btn--flat': !isSelected, 'v-btn--icon': isSelected && isAllowed && isFloating, 'v-btn--floating': isFloating, 'v-btn--depressed': !isFloating && isSelected, 'v-btn--disabled': !isAllowed || this.disabled && isSelected, 'v-btn--outline': isCurrent && !isSelected }, this.themeClasses);
	        },
	        genButton: function genButton(value, isFloating) {
	            var _this = this;
	            var isAllowed = Object(_util_isDateAllowed__WEBPACK_IMPORTED_MODULE_2__["default"])(value, this.min, this.max, this.allowedDates);
	            var isSelected = value === this.value || Array.isArray(this.value) && this.value.indexOf(value) !== -1;
	            var isCurrent = value === this.current;
	            var setColor = isSelected ? this.setBackgroundColor : this.setTextColor;
	            var color = (isSelected || isCurrent) && (this.color || 'accent');
	            return this.$createElement('button', setColor(color, {
	                staticClass: 'v-btn',
	                'class': this.genButtonClasses(isAllowed, isFloating, isSelected, isCurrent),
	                attrs: {
	                    type: 'button'
	                },
	                domProps: {
	                    disabled: !isAllowed,
	                    innerHTML: "<div class=\"v-btn__content\">" + this.formatter(value) + "</div>"
	                },
	                on: this.disabled || !isAllowed ? {} : {
	                    click: function click() {
	                        return _this.$emit('input', value);
	                    }
	                }
	            }));
	        },
	        wheel: function wheel(e) {
	            e.preventDefault();
	            this.$emit('tableDate', this.calculateTableDate(e.deltaY));
	        },
	        touch: function touch(value) {
	            this.$emit('tableDate', this.calculateTableDate(value));
	        },
	        genTable: function genTable(staticClass, children) {
	            var _this = this;
	            var transition = this.$createElement('transition', {
	                props: { name: this.computedTransition }
	            }, [this.$createElement('table', { key: this.tableDate }, children)]);
	            var touchDirective = {
	                name: 'touch',
	                value: {
	                    left: function left(e) {
	                        return e.offsetX < -15 && _this.touch(1);
	                    },
	                    right: function right(e) {
	                        return e.offsetX > 15 && _this.touch(-1);
	                    }
	                }
	            };
	            return this.$createElement('div', {
	                staticClass: staticClass,
	                class: this.themeClasses,
	                on: this.scrollable ? { wheel: this.wheel } : undefined,
	                directives: [touchDirective]
	            }, [transition]);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/createNativeLocaleFormatter.js":
	/*!************************************************************************!*\
	  !*** ./src/components/VDatePicker/util/createNativeLocaleFormatter.js ***!
	  \************************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.js");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (function (locale, options, _a) {
	    var _b = _a === void 0 ? { start: 0, length: 0 } : _a,
	        start = _b.start,
	        length = _b.length;
	    var makeIsoString = function makeIsoString(dateString) {
	        var _a = __read(dateString.trim().split(' ')[0].split('-'), 3),
	            year = _a[0],
	            month = _a[1],
	            date = _a[2];
	        return [year, Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month || 1), Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(date || 1)].join('-');
	    };
	    try {
	        var intlFormatter_1 = new Intl.DateTimeFormat(locale || undefined, options);
	        return function (dateString) {
	            return intlFormatter_1.format(new Date(makeIsoString(dateString) + "T00:00:00+00:00"));
	        };
	    } catch (e) {
	        return start || length ? function (dateString) {
	            return makeIsoString(dateString).substr(start, length);
	        } : null;
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/index.js":
	/*!**************************************************!*\
	  !*** ./src/components/VDatePicker/util/index.js ***!
	  \**************************************************/
	/*! exports provided: createNativeLocaleFormatter, monthChange, pad */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./createNativeLocaleFormatter */ "./src/components/VDatePicker/util/createNativeLocaleFormatter.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createNativeLocaleFormatter", function() { return _createNativeLocaleFormatter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _monthChange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./monthChange */ "./src/components/VDatePicker/util/monthChange.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "monthChange", function() { return _monthChange__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "pad", function() { return _pad__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/isDateAllowed.js":
	/*!**********************************************************!*\
	  !*** ./src/components/VDatePicker/util/isDateAllowed.js ***!
	  \**********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return isDateAllowed; });
	function isDateAllowed(date, min, max, allowedFn) {
	    return (!allowedFn || allowedFn(date)) && (!min || date >= min) && (!max || date <= max);
	}
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/monthChange.js":
	/*!********************************************************!*\
	  !*** ./src/components/VDatePicker/util/monthChange.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _pad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./pad */ "./src/components/VDatePicker/util/pad.js");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	/**
	 * @param {String} value YYYY-MM format
	 * @param {Number} sign -1 or +1
	 */
	/* harmony default export */ __webpack_exports__["default"] = (function (value, sign) {
	    var _a = __read(value.split('-').map(function (v) {
	        return 1 * v;
	    }), 2),
	        year = _a[0],
	        month = _a[1];
	    if (month + sign === 0) {
	        return year - 1 + "-12";
	    } else if (month + sign === 13) {
	        return year + 1 + "-01";
	    } else {
	        return year + "-" + Object(_pad__WEBPACK_IMPORTED_MODULE_0__["default"])(month + sign);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDatePicker/util/pad.js":
	/*!************************************************!*\
	  !*** ./src/components/VDatePicker/util/pad.js ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var padStart = function padStart(string, targetLength, padString) {
	    targetLength = targetLength >> 0;
	    string = String(string);
	    padString = String(padString);
	    if (string.length > targetLength) {
	        return String(string);
	    }
	    targetLength = targetLength - string.length;
	    if (targetLength > padString.length) {
	        padString += padString.repeat(targetLength / padString.length);
	    }
	    return padString.slice(0, targetLength) + String(string);
	};
	/* harmony default export */ __webpack_exports__["default"] = (function (n, length) {
	    if (length === void 0) {
	        length = 2;
	    }
	    return padStart(n, length, '0');
	});
	
	/***/ }),
	
	/***/ "./src/components/VDialog/VDialog.js":
	/*!*******************************************!*\
	  !*** ./src/components/VDialog/VDialog.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_dialogs.styl */ "./src/stylus/components/_dialogs.styl");
	/* harmony import */ var _stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_dialogs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/overlayable */ "./src/mixins/overlayable.js");
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_stackable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/stackable */ "./src/mixins/stackable.js");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	
	
	
	// Directives
	
	// Helpers
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-dialog',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_7__["default"]
	    },
	    mixins: [_mixins_dependent__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_stackable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        disabled: Boolean,
	        persistent: Boolean,
	        fullscreen: Boolean,
	        fullWidth: Boolean,
	        noClickAnimation: Boolean,
	        light: Boolean,
	        dark: Boolean,
	        maxWidth: {
	            type: [String, Number],
	            default: 'none'
	        },
	        origin: {
	            type: String,
	            default: 'center center'
	        },
	        width: {
	            type: [String, Number],
	            default: 'auto'
	        },
	        scrollable: Boolean,
	        transition: {
	            type: [String, Boolean],
	            default: 'dialog-transition'
	        }
	    },
	    data: function data() {
	        return {
	            animate: false,
	            animateTimeout: null,
	            stackClass: 'v-dialog__content--active',
	            stackMinZIndex: 200
	        };
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {}, _a[("v-dialog " + this.contentClass).trim()] = true, _a['v-dialog--active'] = this.isActive, _a['v-dialog--persistent'] = this.persistent, _a['v-dialog--fullscreen'] = this.fullscreen, _a['v-dialog--scrollable'] = this.scrollable, _a['v-dialog--animated'] = this.animate, _a;
	        },
	        contentClasses: function contentClasses() {
	            return {
	                'v-dialog__content': true,
	                'v-dialog__content--active': this.isActive
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.show();
	                this.hideScroll();
	            } else {
	                this.removeOverlay();
	                this.unbind();
	            }
	        },
	        fullscreen: function fullscreen(val) {
	            if (!this.isActive) return;
	            if (val) {
	                this.hideScroll();
	                this.removeOverlay(false);
	            } else {
	                this.showScroll();
	                this.genOverlay();
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.isBooted = this.isActive;
	        this.isActive && this.show();
	    },
	    beforeDestroy: function beforeDestroy() {
	        if (typeof window !== 'undefined') this.unbind();
	    },
	    methods: {
	        animateClick: function animateClick() {
	            var _this = this;
	            this.animate = false;
	            // Needed for when clicking very fast
	            // outside of the dialog
	            this.$nextTick(function () {
	                _this.animate = true;
	                clearTimeout(_this.animateTimeout);
	                _this.animateTimeout = setTimeout(function () {
	                    return _this.animate = false;
	                }, 150);
	            });
	        },
	        closeConditional: function closeConditional(e) {
	            // If the dialog content contains
	            // the click event, or if the
	            // dialog is not active
	            if (this.$refs.content.contains(e.target) || !this.isActive) return false;
	            // If we made it here, the click is outside
	            // and is active. If persistent, and the
	            // click is on the overlay, animate
	            if (this.persistent) {
	                if (!this.noClickAnimation && this.overlay === e.target) this.animateClick();
	                return false;
	            }
	            // close dialog if !persistent, clicked outside and we're the topmost dialog.
	            // Since this should only be called in a capture event (bottom up), we shouldn't need to stop propagation
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["getZIndex"])(this.$refs.content) >= this.getMaxZIndex();
	        },
	        hideScroll: function hideScroll() {
	            if (this.fullscreen) {
	                document.documentElement.classList.add('overflow-y-hidden');
	            } else {
	                _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"].methods.hideScroll.call(this);
	            }
	        },
	        show: function show() {
	            !this.fullscreen && !this.hideOverlay && this.genOverlay();
	            this.$refs.content.focus();
	            this.$listeners.keydown && this.bind();
	        },
	        bind: function bind() {
	            window.addEventListener('keydown', this.onKeydown);
	        },
	        unbind: function unbind() {
	            window.removeEventListener('keydown', this.onKeydown);
	        },
	        onKeydown: function onKeydown(e) {
	            this.$emit('keydown', e);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = [];
	        var data = {
	            'class': this.classes,
	            ref: 'dialog',
	            directives: [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: this.getOpenDependentElements
	                }
	            }, { name: 'show', value: this.isActive }],
	            on: {
	                click: function click(e) {
	                    e.stopPropagation();
	                }
	            }
	        };
	        if (!this.fullscreen) {
	            data.style = {
	                maxWidth: this.maxWidth === 'none' ? undefined : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.maxWidth),
	                width: this.width === 'auto' ? undefined : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_8__["convertToUnit"])(this.width)
	            };
	        }
	        if (this.$slots.activator) {
	            children.push(h('div', {
	                staticClass: 'v-dialog__activator',
	                'class': {
	                    'v-dialog__activator--disabled': this.disabled
	                },
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (!_this.disabled) _this.isActive = !_this.isActive;
	                    }
	                }
	            }, [this.$slots.activator]));
	        }
	        var dialog = h('div', data, this.showLazyContent(this.$slots.default));
	        if (this.transition) {
	            dialog = h('transition', {
	                props: {
	                    name: this.transition,
	                    origin: this.origin
	                }
	            }, [dialog]);
	        }
	        children.push(h('div', {
	            'class': this.contentClasses,
	            attrs: __assign({ tabIndex: '-1' }, this.getScopeIdAttrs()),
	            style: { zIndex: this.activeZIndex },
	            ref: 'content'
	        }, [this.$createElement(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_9__["default"], {
	            props: {
	                root: true,
	                light: this.light,
	                dark: this.dark
	            }
	        }, [dialog])]));
	        return h('div', {
	            staticClass: 'v-dialog__container',
	            style: {
	                display: !this.$slots.activator || this.fullWidth ? 'block' : 'inline-block'
	            }
	        }, children);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VDialog/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VDialog/index.js ***!
	  \*****************************************/
	/*! exports provided: VDialog, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDialog__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDialog */ "./src/components/VDialog/VDialog.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return _VDialog__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDialog__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VDivider/VDivider.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VDivider/VDivider.ts ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_dividers.styl */ "./src/stylus/components/_dividers.styl");
	/* harmony import */ var _stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_dividers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	/* harmony default export */ __webpack_exports__["default"] = (_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-divider',
	    props: {
	        inset: Boolean,
	        vertical: Boolean
	    },
	    render: function render(h) {
	        return h('hr', {
	            class: __assign({ 'v-divider': true, 'v-divider--inset': this.inset, 'v-divider--vertical': this.vertical }, this.themeClasses),
	            attrs: this.$attrs,
	            on: this.$listeners
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VDivider/index.ts":
	/*!******************************************!*\
	  !*** ./src/components/VDivider/index.ts ***!
	  \******************************************/
	/*! exports provided: VDivider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VDivider */ "./src/components/VDivider/VDivider.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return _VDivider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VDivider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/VExpansionPanel.ts":
	/*!***********************************************************!*\
	  !*** ./src/components/VExpansionPanel/VExpansionPanel.ts ***!
	  \***********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_expansion-panel.styl */ "./src/stylus/components/_expansion-panel.styl");
	/* harmony import */ var _stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_expansion_panel_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])('expansionPanel')).extend({
	    name: 'v-expansion-panel',
	    provide: function provide() {
	        return {
	            expansionPanel: this
	        };
	    },
	    props: {
	        disabled: Boolean,
	        readonly: Boolean,
	        expand: Boolean,
	        focusable: Boolean,
	        inset: Boolean,
	        popout: Boolean,
	        value: {
	            type: [Number, Array],
	            default: function _default() {
	                return null;
	            }
	        }
	    },
	    data: function data() {
	        return {
	            items: [],
	            open: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-expansion-panel--focusable': this.focusable, 'v-expansion-panel--popout': this.popout, 'v-expansion-panel--inset': this.inset }, this.themeClasses);
	        }
	    },
	    watch: {
	        expand: function expand(v) {
	            var openIndex = -1;
	            if (!v) {
	                // Close all panels unless only one is open
	                var openCount = this.open.reduce(function (acc, val) {
	                    return val ? acc + 1 : acc;
	                }, 0);
	                var open = Array(this.items.length).fill(false);
	                if (openCount === 1) {
	                    openIndex = this.open.indexOf(true);
	                }
	                if (openIndex > -1) {
	                    open[openIndex] = true;
	                }
	                this.open = open;
	            }
	            this.$emit('input', v ? this.open : openIndex > -1 ? openIndex : null);
	        },
	        value: function value(v) {
	            this.updateFromValue(v);
	        }
	    },
	    mounted: function mounted() {
	        this.value !== null && this.updateFromValue(this.value);
	    },
	    methods: {
	        updateFromValue: function updateFromValue(v) {
	            if (Array.isArray(v) && !this.expand) return;
	            var open = Array(this.items.length).fill(false);
	            if (typeof v === 'number') {
	                open[v] = true;
	            } else if (v !== null) {
	                open = v;
	            }
	            this.updatePanels(open);
	        },
	        updatePanels: function updatePanels(open) {
	            this.open = open;
	            for (var i = 0; i < this.items.length; i++) {
	                this.items[i].toggle(open && open[i]);
	            }
	        },
	        panelClick: function panelClick(uid) {
	            var open = this.expand ? this.open.slice() : Array(this.items.length).fill(false);
	            for (var i = 0; i < this.items.length; i++) {
	                if (this.items[i]._uid === uid) {
	                    open[i] = !this.open[i];
	                    !this.expand && this.$emit('input', open[i] ? i : null);
	                }
	            }
	            this.updatePanels(open);
	            if (this.expand) this.$emit('input', open);
	        },
	        register: function register(content) {
	            var i = this.items.push(content) - 1;
	            this.value !== null && this.updateFromValue(this.value);
	            content.toggle(!!this.open[i]);
	        },
	        unregister: function unregister(content) {
	            var index = this.items.findIndex(function (i) {
	                return i._uid === content._uid;
	            });
	            this.items.splice(index, 1);
	            this.open.splice(index, 1);
	        }
	    },
	    render: function render(h) {
	        return h('ul', {
	            staticClass: 'v-expansion-panel',
	            class: this.classes
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/VExpansionPanelContent.ts":
	/*!******************************************************************!*\
	  !*** ./src/components/VExpansionPanel/VExpansionPanelContent.ts ***!
	  \******************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_4__["inject"])('expansionPanel', 'v-expansion-panel-content', 'v-expansion-panel')
	/* @vue/component */
	).extend({
	    name: 'v-expansion-panel-content',
	    props: {
	        disabled: Boolean,
	        readonly: Boolean,
	        expandIcon: {
	            type: String,
	            default: '$vuetify.icons.expand'
	        },
	        hideActions: Boolean,
	        ripple: {
	            type: [Boolean, Object],
	            default: false
	        }
	    },
	    data: function data() {
	        return {
	            height: 'auto'
	        };
	    },
	    computed: {
	        containerClasses: function containerClasses() {
	            return {
	                'v-expansion-panel__container--active': this.isActive,
	                'v-expansion-panel__container--disabled': this.isDisabled
	            };
	        },
	        isDisabled: function isDisabled() {
	            return this.expansionPanel.disabled || this.disabled;
	        },
	        isReadonly: function isReadonly() {
	            return this.expansionPanel.readonly || this.readonly;
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.expansionPanel.register(this);
	        // Can be removed once fully deprecated
	        if (typeof this.value !== 'undefined') Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])('v-model has been deprecated', this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.expansionPanel.unregister(this);
	    },
	    methods: {
	        onKeydown: function onKeydown(e) {
	            // Ensure element is the activeElement
	            if (e.keyCode === 13 && this.$el === document.activeElement) this.expansionPanel.panelClick(this._uid);
	        },
	        onHeaderClick: function onHeaderClick() {
	            this.isReadonly || this.expansionPanel.panelClick(this._uid);
	        },
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                ref: 'body',
	                class: 'v-expansion-panel__body',
	                directives: [{
	                    name: 'show',
	                    value: this.isActive
	                }]
	            }, this.showLazyContent(this.$slots.default));
	        },
	        genHeader: function genHeader() {
	            var children = __spread(this.$slots.header);
	            if (!this.hideActions) children.push(this.genIcon());
	            return this.$createElement('div', {
	                staticClass: 'v-expansion-panel__header',
	                directives: [{
	                    name: 'ripple',
	                    value: this.ripple
	                }],
	                on: {
	                    click: this.onHeaderClick
	                }
	            }, children);
	        },
	        genIcon: function genIcon() {
	            var icon = this.$slots.actions || [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_5__["default"], this.expandIcon)];
	            return this.$createElement('transition', {
	                attrs: { name: 'fade-transition' }
	            }, [this.$createElement('div', {
	                staticClass: 'v-expansion-panel__header__icon',
	                directives: [{
	                    name: 'show',
	                    value: !this.isDisabled
	                }]
	            }, icon)]);
	        },
	        toggle: function toggle(active) {
	            if (active) this.isBooted = true;
	            this.isActive = active;
	        }
	    },
	    render: function render(h) {
	        return h('li', {
	            staticClass: 'v-expansion-panel__container',
	            class: this.containerClasses,
	            attrs: {
	                tabindex: this.isReadonly || this.isDisabled ? null : 0
	            },
	            on: {
	                keydown: this.onKeydown
	            }
	        }, [this.$slots.header && this.genHeader(), h(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], [this.genBody()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VExpansionPanel/index.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VExpansionPanel/index.ts ***!
	  \*************************************************/
	/*! exports provided: VExpansionPanel, VExpansionPanelContent, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VExpansionPanel */ "./src/components/VExpansionPanel/VExpansionPanel.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VExpansionPanelContent */ "./src/components/VExpansionPanel/VExpansionPanelContent.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() { return _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VExpansionPanel: _VExpansionPanel__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VExpansionPanelContent: _VExpansionPanelContent__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VFooter/VFooter.js":
	/*!*******************************************!*\
	  !*** ./src/components/VFooter/VFooter.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_footer.styl */ "./src/stylus/components/_footer.styl");
	/* harmony import */ var _stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_footer_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-footer',
	    mixins: [Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])(null, ['height', 'inset']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        height: {
	            default: 32,
	            type: [Number, String]
	        },
	        inset: Boolean
	    },
	    computed: {
	        applicationProperty: function applicationProperty() {
	            return this.inset ? 'insetFooter' : 'footer';
	        },
	        computedMarginBottom: function computedMarginBottom() {
	            if (!this.app) return;
	            return this.$vuetify.application.bottom;
	        },
	        computedPaddingLeft: function computedPaddingLeft() {
	            return !this.app || !this.inset ? 0 : this.$vuetify.application.left;
	        },
	        computedPaddingRight: function computedPaddingRight() {
	            return !this.app ? 0 : this.$vuetify.application.right;
	        },
	        styles: function styles() {
	            var styles = {
	                height: isNaN(this.height) ? this.height : this.height + "px"
	            };
	            if (this.computedPaddingLeft) {
	                styles.paddingLeft = this.computedPaddingLeft + "px";
	            }
	            if (this.computedPaddingRight) {
	                styles.paddingRight = this.computedPaddingRight + "px";
	            }
	            if (this.computedMarginBottom) {
	                styles.marginBottom = this.computedMarginBottom + "px";
	            }
	            return styles;
	        }
	    },
	    methods: {
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            var height = parseInt(this.height);
	            return isNaN(height) ? this.$el ? this.$el.clientHeight : 0 : height;
	        }
	    },
	    render: function render(h) {
	        var data = this.setBackgroundColor(this.color, {
	            staticClass: 'v-footer',
	            'class': __assign({ 'v-footer--absolute': this.absolute, 'v-footer--fixed': !this.absolute && (this.app || this.fixed), 'v-footer--inset': this.inset }, this.themeClasses),
	            style: this.styles,
	            ref: 'content'
	        });
	        return h('footer', data, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VFooter/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VFooter/index.js ***!
	  \*****************************************/
	/*! exports provided: VFooter, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VFooter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VFooter */ "./src/components/VFooter/VFooter.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return _VFooter__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VFooter__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VForm/VForm.js":
	/*!***************************************!*\
	  !*** ./src/components/VForm/VForm.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_forms.styl */ "./src/stylus/components/_forms.styl");
	/* harmony import */ var _stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_forms_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	// Styles
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-form',
	    mixins: [Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["provide"])('form')],
	    inheritAttrs: false,
	    props: {
	        value: Boolean,
	        lazyValidation: Boolean
	    },
	    data: function data() {
	        return {
	            inputs: [],
	            watchers: [],
	            errorBag: {}
	        };
	    },
	    watch: {
	        errorBag: {
	            handler: function handler() {
	                var errors = Object.values(this.errorBag).includes(true);
	                this.$emit('input', !errors);
	            },
	            deep: true,
	            immediate: true
	        }
	    },
	    methods: {
	        watchInput: function watchInput(input) {
	            var _this = this;
	            var watcher = function watcher(input) {
	                return input.$watch('hasError', function (val) {
	                    _this.$set(_this.errorBag, input._uid, val);
	                }, { immediate: true });
	            };
	            var watchers = {
	                _uid: input._uid,
	                valid: undefined,
	                shouldValidate: undefined
	            };
	            if (this.lazyValidation) {
	                // Only start watching inputs if we need to
	                watchers.shouldValidate = input.$watch('shouldValidate', function (val) {
	                    if (!val) return;
	                    // Only watch if we're not already doing it
	                    if (_this.errorBag.hasOwnProperty(input._uid)) return;
	                    watchers.valid = watcher(input);
	                });
	            } else {
	                watchers.valid = watcher(input);
	            }
	            return watchers;
	        },
	        /** @public */
	        validate: function validate() {
	            var errors = this.inputs.filter(function (input) {
	                return !input.validate(true);
	            }).length;
	            return !errors;
	        },
	        /** @public */
	        reset: function reset() {
	            var _this = this;
	            for (var i = this.inputs.length; i--;) {
	                this.inputs[i].reset();
	            }
	            if (this.lazyValidation) {
	                // Account for timeout in validatable
	                setTimeout(function () {
	                    _this.errorBag = {};
	                }, 0);
	            }
	        },
	        /** @public */
	        resetValidation: function resetValidation() {
	            var _this = this;
	            for (var i = this.inputs.length; i--;) {
	                this.inputs[i].resetValidation();
	            }
	            if (this.lazyValidation) {
	                // Account for timeout in validatable
	                setTimeout(function () {
	                    _this.errorBag = {};
	                }, 0);
	            }
	        },
	        register: function register(input) {
	            var unwatch = this.watchInput(input);
	            this.inputs.push(input);
	            this.watchers.push(unwatch);
	        },
	        unregister: function unregister(input) {
	            var found = this.inputs.find(function (i) {
	                return i._uid === input._uid;
	            });
	            if (!found) return;
	            var unwatch = this.watchers.find(function (i) {
	                return i._uid === found._uid;
	            });
	            unwatch.valid && unwatch.valid();
	            unwatch.shouldValidate && unwatch.shouldValidate();
	            this.watchers = this.watchers.filter(function (i) {
	                return i._uid !== found._uid;
	            });
	            this.inputs = this.inputs.filter(function (i) {
	                return i._uid !== found._uid;
	            });
	            this.$delete(this.errorBag, found._uid);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        return h('form', {
	            staticClass: 'v-form',
	            attrs: Object.assign({
	                novalidate: true
	            }, this.$attrs),
	            on: {
	                submit: function submit(e) {
	                    return _this.$emit('submit', e);
	                }
	            }
	        }, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VForm/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VForm/index.js ***!
	  \***************************************/
	/*! exports provided: VForm, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VForm */ "./src/components/VForm/VForm.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return _VForm__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VForm__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VContainer.js":
	/*!********************************************!*\
	  !*** ./src/components/VGrid/VContainer.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('container'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VContent.js":
	/*!******************************************!*\
	  !*** ./src/components/VGrid/VContent.js ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_content.styl */ "./src/stylus/components/_content.styl");
	/* harmony import */ var _stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_content_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	// Styles
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-content',
	    mixins: [_mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        tag: {
	            type: String,
	            default: 'main'
	        }
	    },
	    computed: {
	        styles: function styles() {
	            var _a = this.$vuetify.application,
	                bar = _a.bar,
	                top = _a.top,
	                right = _a.right,
	                footer = _a.footer,
	                insetFooter = _a.insetFooter,
	                bottom = _a.bottom,
	                left = _a.left;
	            return {
	                paddingTop: top + bar + "px",
	                paddingRight: right + "px",
	                paddingBottom: footer + insetFooter + bottom + "px",
	                paddingLeft: left + "px"
	            };
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-content',
	            style: this.styles,
	            ref: 'content'
	        };
	        return h(this.tag, data, [h('div', { staticClass: 'v-content__wrap' }, this.$slots.default)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VFlex.js":
	/*!***************************************!*\
	  !*** ./src/components/VGrid/VFlex.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('flex'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/VLayout.js":
	/*!*****************************************!*\
	  !*** ./src/components/VGrid/VLayout.js ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_grid.styl */ "./src/stylus/components/_grid.styl");
	/* harmony import */ var _stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_grid_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./grid */ "./src/components/VGrid/grid.js");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_grid__WEBPACK_IMPORTED_MODULE_1__["default"])('layout'));
	
	/***/ }),
	
	/***/ "./src/components/VGrid/grid.js":
	/*!**************************************!*\
	  !*** ./src/components/VGrid/grid.js ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Grid; });
	function Grid(name) {
	    /* @vue/component */
	    return {
	        name: "v-" + name,
	        functional: true,
	        props: {
	            id: String,
	            tag: {
	                type: String,
	                default: 'div'
	            }
	        },
	        render: function render(h, _a) {
	            var props = _a.props,
	                data = _a.data,
	                children = _a.children;
	            data.staticClass = (name + " " + (data.staticClass || '')).trim();
	            if (data.attrs) {
	                var classes = Object.keys(data.attrs).filter(function (key) {
	                    // TODO: Remove once resolved
	                    // https://github.com/vuejs/vue/issues/7841
	                    if (key === 'slot') return false;
	                    var value = data.attrs[key];
	                    return value || typeof value === 'string';
	                });
	                if (classes.length) data.staticClass += " " + classes.join(' ');
	                delete data.attrs;
	            }
	            if (props.id) {
	                data.domProps = data.domProps || {};
	                data.domProps.id = props.id;
	            }
	            return h(props.tag, data, children);
	        }
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/VGrid/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VGrid/index.js ***!
	  \***************************************/
	/*! exports provided: VContainer, VContent, VFlex, VLayout, VSpacer, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSpacer", function() { return VSpacer; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VContainer */ "./src/components/VGrid/VContainer.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContainer", function() { return _VContainer__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VContent */ "./src/components/VGrid/VContent.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContent", function() { return _VContent__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VFlex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VFlex */ "./src/components/VGrid/VFlex.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFlex", function() { return _VFlex__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VLayout */ "./src/components/VGrid/VLayout.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLayout", function() { return _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	var VSpacer = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('spacer', 'div', 'v-spacer');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VContainer: _VContainer__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VContent: _VContent__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VFlex: _VFlex__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VLayout: _VLayout__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VSpacer: VSpacer
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VHover/VHover.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VHover/VHover.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Mixins
	
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_delayable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-hover',
	    props: {
	        disabled: {
	            type: Boolean,
	            default: false
	        },
	        value: {
	            type: Boolean,
	            default: undefined
	        }
	    },
	    methods: {
	        onMouseEnter: function onMouseEnter() {
	            this.runDelay('open');
	        },
	        onMouseLeave: function onMouseLeave() {
	            this.runDelay('close');
	        }
	    },
	    render: function render() {
	        if (!this.$scopedSlots.default && this.value === undefined) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])('v-hover is missing a default scopedSlot or bound value', this);
	            return null;
	        }
	        var element;
	        if (this.$scopedSlots.default) {
	            element = this.$scopedSlots.default({ hover: this.isActive });
	        } else if (this.$slots.default && this.$slots.default.length === 1) {
	            element = this.$slots.default[0];
	        }
	        if (!element || typeof element === 'string' || Array.isArray(element)) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_3__["consoleWarn"])('v-hover should only contain a single element', this);
	            return element;
	        }
	        if (!this.disabled) {
	            this._g(element.data, {
	                mouseenter: this.onMouseEnter,
	                mouseleave: this.onMouseLeave
	            });
	        }
	        return element;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VHover/index.ts":
	/*!****************************************!*\
	  !*** ./src/components/VHover/index.ts ***!
	  \****************************************/
	/*! exports provided: VHover, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VHover__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VHover */ "./src/components/VHover/VHover.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VHover", function() { return _VHover__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VHover__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VIcon/VIcon.ts":
	/*!***************************************!*\
	  !*** ./src/components/VIcon/VIcon.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_icons.styl */ "./src/stylus/components/_icons.styl");
	/* harmony import */ var _stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_icons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/sizeable */ "./src/mixins/sizeable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_5__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	// Util
	
	// Types
	
	
	var SIZE_MAP;
	(function (SIZE_MAP) {
	    SIZE_MAP["small"] = "16px";
	    SIZE_MAP["default"] = "24px";
	    SIZE_MAP["medium"] = "28px";
	    SIZE_MAP["large"] = "36px";
	    SIZE_MAP["xLarge"] = "40px";
	})(SIZE_MAP || (SIZE_MAP = {}));
	function isFontAwesome5(iconType) {
	    return ['fas', 'far', 'fal', 'fab'].some(function (val) {
	        return iconType.includes(val);
	    });
	}
	var VIcon = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_6__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-icon',
	    props: {
	        disabled: Boolean,
	        left: Boolean,
	        right: Boolean
	    },
	    render: function render(h) {
	        var _a;
	        var sizes = {
	            small: this.small,
	            medium: this.medium,
	            large: this.large,
	            xLarge: this.xLarge
	        };
	        var explicitSize = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["keys"])(sizes).find(function (key) {
	            return sizes[key] && !!key;
	        });
	        var fontSize = explicitSize && SIZE_MAP[explicitSize] || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.size);
	        var newChildren = [];
	        var data = {
	            staticClass: 'v-icon',
	            attrs: __assign({ 'aria-hidden': true }, this.$attrs),
	            on: this.$listeners
	        };
	        if (fontSize) data.style = { fontSize: fontSize };
	        var iconName = '';
	        if (this.$slots.default) iconName = this.$slots.default[0].text;
	        // Remap internal names like '$vuetify.icons.cancel' to the current name for that icon
	        iconName = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["remapInternalIcon"])(this, iconName);
	        var iconType = 'material-icons';
	        // Material Icon delimiter is _
	        // https://material.io/icons/
	        var delimiterIndex = iconName.indexOf('-');
	        var isCustomIcon = delimiterIndex > -1;
	        if (isCustomIcon) {
	            iconType = iconName.slice(0, delimiterIndex);
	            if (isFontAwesome5(iconType)) iconType = '';
	            // Assume if not a custom icon
	            // is Material Icon font
	        } else newChildren.push(iconName);
	        data.class = __assign((_a = { 'v-icon--disabled': this.disabled, 'v-icon--left': this.left, 'v-icon--link': this.$listeners.click || this.$listeners['!click'], 'v-icon--right': this.right }, _a[iconType] = true, _a[iconName] = isCustomIcon, _a), this.themeClasses);
	        return h('i', this.setTextColor(this.color, data), newChildren);
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_5___default.a.extend({
	    name: 'v-icon',
	    $_wrapperFor: VIcon,
	    functional: true,
	    render: function render(h, _a) {
	        var data = _a.data,
	            children = _a.children;
	        var iconName = '';
	        // Support usage of v-text and v-html
	        if (data.domProps) {
	            iconName = data.domProps.textContent || data.domProps.innerHTML || iconName;
	            // Remove nodes so it doesn't
	            // overwrite our changes
	            delete data.domProps.textContent;
	            delete data.domProps.innerHTML;
	        }
	        return h(VIcon, data, iconName ? [iconName] : children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VIcon/index.ts":
	/*!***************************************!*\
	  !*** ./src/components/VIcon/index.ts ***!
	  \***************************************/
	/*! exports provided: VIcon, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VIcon */ "./src/components/VIcon/VIcon.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return _VIcon__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VImg/VImg.ts":
	/*!*************************************!*\
	  !*** ./src/components/VImg/VImg.ts ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_images.styl */ "./src/stylus/components/_images.styl");
	/* harmony import */ var _stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_images_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VResponsive */ "./src/components/VResponsive/index.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	// Components
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VResponsive__WEBPACK_IMPORTED_MODULE_1__["default"].extend({
	    name: 'v-img',
	    props: {
	        alt: String,
	        contain: Boolean,
	        src: {
	            type: [String, Object],
	            default: ''
	        },
	        gradient: String,
	        lazySrc: String,
	        srcset: String,
	        sizes: String,
	        position: {
	            type: String,
	            default: 'center center'
	        },
	        transition: {
	            type: [Boolean, String],
	            default: 'fade-transition'
	        }
	    },
	    data: function data() {
	        return {
	            currentSrc: '',
	            image: null,
	            isLoading: true,
	            calculatedAspectRatio: undefined
	        };
	    },
	    computed: {
	        computedAspectRatio: function computedAspectRatio() {
	            return this.normalisedSrc.aspect;
	        },
	        normalisedSrc: function normalisedSrc() {
	            return typeof this.src === 'string' ? {
	                src: this.src,
	                srcset: this.srcset,
	                lazySrc: this.lazySrc,
	                aspect: Number(this.aspectRatio || this.calculatedAspectRatio)
	            } : {
	                src: this.src.src,
	                srcset: this.srcset || this.src.srcset,
	                lazySrc: this.lazySrc || this.src.lazySrc,
	                aspect: Number(this.aspectRatio || this.src.aspect || this.calculatedAspectRatio)
	            };
	        },
	        __cachedImage: function __cachedImage() {
	            if (!(this.normalisedSrc.src || this.normalisedSrc.lazySrc)) return [];
	            var backgroundImage = [];
	            var src = this.isLoading ? this.normalisedSrc.lazySrc : this.currentSrc;
	            if (this.gradient) backgroundImage.push("linear-gradient(" + this.gradient + ")");
	            if (src) backgroundImage.push("url(\"" + src + "\")");
	            var image = this.$createElement('div', {
	                staticClass: 'v-image__image',
	                class: {
	                    'v-image__image--preload': this.isLoading,
	                    'v-image__image--contain': this.contain,
	                    'v-image__image--cover': !this.contain
	                },
	                style: {
	                    backgroundImage: backgroundImage.join(', '),
	                    backgroundPosition: this.position
	                },
	                key: +this.isLoading
	            });
	            if (!this.transition) return image;
	            return this.$createElement('transition', {
	                attrs: {
	                    name: this.transition,
	                    mode: 'in-out'
	                }
	            }, [image]);
	        }
	    },
	    watch: {
	        src: function src() {
	            if (!this.isLoading) this.init();else this.loadImage();
	        },
	        '$vuetify.breakpoint.width': 'getSrc'
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            if (this.normalisedSrc.lazySrc) {
	                var lazyImg = new Image();
	                lazyImg.src = this.normalisedSrc.lazySrc;
	                this.pollForSize(lazyImg, null);
	            }
	            /* istanbul ignore else */
	            if (this.normalisedSrc.src) this.loadImage();
	        },
	        onLoad: function onLoad() {
	            this.getSrc();
	            this.isLoading = false;
	            this.$emit('load', this.src);
	        },
	        onError: function onError() {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])("Image load failed\n\n" + ("src: " + this.normalisedSrc.src), this);
	            this.$emit('error', this.src);
	        },
	        getSrc: function getSrc() {
	            /* istanbul ignore else */
	            if (this.image) this.currentSrc = this.image.currentSrc || this.image.src;
	        },
	        loadImage: function loadImage() {
	            var _this = this;
	            var image = new Image();
	            this.image = image;
	            image.onload = function () {
	                /* istanbul ignore if */
	                if (image.decode) {
	                    image.decode().catch(function (err) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])("Failed to decode image, trying to render anyway\n\n" + ("src: " + _this.normalisedSrc.src) + (err.message ? "\nOriginal error: " + err.message : ''), _this);
	                    }).then(_this.onLoad);
	                } else {
	                    _this.onLoad();
	                }
	            };
	            image.onerror = this.onError;
	            image.src = this.normalisedSrc.src;
	            this.sizes && (image.sizes = this.sizes);
	            this.normalisedSrc.srcset && (image.srcset = this.normalisedSrc.srcset);
	            this.aspectRatio || this.pollForSize(image);
	            this.getSrc();
	        },
	        pollForSize: function pollForSize(img, timeout) {
	            var _this = this;
	            if (timeout === void 0) {
	                timeout = 100;
	            }
	            var poll = function poll() {
	                var naturalHeight = img.naturalHeight,
	                    naturalWidth = img.naturalWidth;
	                if (naturalHeight || naturalWidth) {
	                    _this.calculatedAspectRatio = naturalWidth / naturalHeight;
	                } else {
	                    timeout != null && setTimeout(poll, timeout);
	                }
	            };
	            poll();
	        },
	        __genPlaceholder: function __genPlaceholder() {
	            if (this.$slots.placeholder) {
	                var placeholder = this.isLoading ? [this.$createElement('div', {
	                    staticClass: 'v-image__placeholder'
	                }, this.$slots.placeholder)] : [];
	                if (!this.transition) return placeholder[0];
	                return this.$createElement('transition', {
	                    attrs: { name: this.transition }
	                }, placeholder);
	            }
	        }
	    },
	    render: function render(h) {
	        var node = _VResponsive__WEBPACK_IMPORTED_MODULE_1__["default"].options.render.call(this, h);
	        node.data.staticClass += ' v-image';
	        node.data.attrs = {
	            role: this.alt ? 'img' : undefined,
	            'aria-label': this.alt
	        };
	        node.children = [this.__cachedSizer, this.__cachedImage, this.__genPlaceholder(), this.genContent()];
	        return h(node.tag, node.data, node.children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VImg/index.ts":
	/*!**************************************!*\
	  !*** ./src/components/VImg/index.ts ***!
	  \**************************************/
	/*! exports provided: VImg, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VImg */ "./src/components/VImg/VImg.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VImg", function() { return _VImg__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VImg__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VInput/VInput.js":
	/*!*****************************************!*\
	  !*** ./src/components/VInput/VInput.js ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_inputs.styl */ "./src/stylus/components/_inputs.styl");
	/* harmony import */ var _stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_inputs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.js");
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VMessages */ "./src/components/VMessages/index.js");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/validatable */ "./src/mixins/validatable.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	
	
	// Mixins
	
	
	
	// Utilities
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-input',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_validatable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        appendIcon: String,
	        /** @deprecated */
	        appendIconCb: Function,
	        backgroundColor: {
	            type: String,
	            default: ''
	        },
	        height: [Number, String],
	        hideDetails: Boolean,
	        hint: String,
	        label: String,
	        persistentHint: Boolean,
	        prependIcon: String,
	        /** @deprecated */
	        prependIconCb: Function,
	        value: { required: false }
	    },
	    data: function data(vm) {
	        return {
	            lazyValue: vm.value,
	            hasMouseDown: false
	        };
	    },
	    computed: {
	        classesInput: function classesInput() {
	            return __assign({}, this.classes, { 'v-input--has-state': this.hasState, 'v-input--hide-details': this.hideDetails, 'v-input--is-label-active': this.isLabelActive, 'v-input--is-dirty': this.isDirty, 'v-input--is-disabled': this.disabled, 'v-input--is-focused': this.isFocused, 'v-input--is-loading': this.loading !== false && this.loading !== undefined, 'v-input--is-readonly': this.readonly }, this.themeClasses);
	        },
	        directivesInput: function directivesInput() {
	            return [];
	        },
	        hasHint: function hasHint() {
	            return !this.hasMessages && this.hint && (this.persistentHint || this.isFocused);
	        },
	        hasLabel: function hasLabel() {
	            return Boolean(this.$slots.label || this.label);
	        },
	        // Proxy for `lazyValue`
	        // This allows an input
	        // to function without
	        // a provided model
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                this.lazyValue = val;
	                this.$emit(this.$_modelEvent, val);
	            }
	        },
	        isDirty: function isDirty() {
	            return !!this.lazyValue;
	        },
	        isDisabled: function isDisabled() {
	            return Boolean(this.disabled || this.readonly);
	        },
	        isLabelActive: function isLabelActive() {
	            return this.isDirty;
	        }
	    },
	    watch: {
	        value: function value(val) {
	            this.lazyValue = val;
	        }
	    },
	    beforeCreate: function beforeCreate() {
	        // v-radio-group needs to emit a different event
	        // https://github.com/vuetifyjs/vuetify/issues/4752
	        this.$_modelEvent = this.$options.model && this.$options.model.event || 'input';
	    },
	    methods: {
	        genContent: function genContent() {
	            return [this.genPrependSlot(), this.genControl(), this.genAppendSlot()];
	        },
	        genControl: function genControl() {
	            return this.$createElement('div', {
	                staticClass: 'v-input__control'
	            }, [this.genInputSlot(), this.genMessages()]);
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genLabel(), this.$slots.default];
	        },
	        // TODO: remove shouldDeprecate (2.0), used for clearIcon
	        genIcon: function genIcon(type, cb, shouldDeprecate) {
	            var _this = this;
	            if (shouldDeprecate === void 0) {
	                shouldDeprecate = true;
	            }
	            var icon = this[type + "Icon"];
	            var eventName = "click:" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["kebabCase"])(type);
	            cb = cb || this[type + "IconCb"];
	            if (shouldDeprecate && type && cb) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["deprecate"])(":" + type + "-icon-cb", "@" + eventName, this);
	            }
	            var data = {
	                props: {
	                    color: this.validationState,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    light: this.light
	                },
	                on: !(this.$listeners[eventName] || cb) ? null : {
	                    click: function click(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        _this.$emit(eventName, e);
	                        cb && cb(e);
	                    },
	                    // Container has mouseup event that will
	                    // trigger menu open if enclosed
	                    mouseup: function mouseup(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                    }
	                }
	            };
	            return this.$createElement('div', {
	                staticClass: "v-input__icon v-input__icon--" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["kebabCase"])(type),
	                key: "" + type + icon
	            }, [this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], data, icon)]);
	        },
	        genInputSlot: function genInputSlot() {
	            return this.$createElement('div', this.setBackgroundColor(this.backgroundColor, {
	                staticClass: 'v-input__slot',
	                style: { height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.height) },
	                directives: this.directivesInput,
	                on: {
	                    click: this.onClick,
	                    mousedown: this.onMouseDown,
	                    mouseup: this.onMouseUp
	                },
	                ref: 'input-slot'
	            }), [this.genDefaultSlot()]);
	        },
	        genLabel: function genLabel() {
	            if (!this.hasLabel) return null;
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    color: this.validationState,
	                    dark: this.dark,
	                    focused: this.hasState,
	                    for: this.$attrs.id,
	                    light: this.light
	                }
	            }, this.$slots.label || this.label);
	        },
	        genMessages: function genMessages() {
	            if (this.hideDetails) return null;
	            var messages = this.hasHint ? [this.hint] : this.validations;
	            return this.$createElement(_VMessages__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: {
	                    color: this.hasHint ? '' : this.validationState,
	                    dark: this.dark,
	                    light: this.light,
	                    value: this.hasMessages || this.hasHint ? messages : []
	                }
	            });
	        },
	        genSlot: function genSlot(type, location, slot) {
	            if (!slot.length) return null;
	            var ref = type + "-" + location;
	            return this.$createElement('div', {
	                staticClass: "v-input__" + ref,
	                ref: ref
	            }, slot);
	        },
	        genPrependSlot: function genPrependSlot() {
	            var slot = [];
	            if (this.$slots['prepend']) {
	                slot.push(this.$slots['prepend']);
	            } else if (this.prependIcon) {
	                slot.push(this.genIcon('prepend'));
	            }
	            return this.genSlot('prepend', 'outer', slot);
	        },
	        genAppendSlot: function genAppendSlot() {
	            var slot = [];
	            // Append icon for text field was really
	            // an appended inner icon, v-text-field
	            // will overwrite this method in order to obtain
	            // backwards compat
	            if (this.$slots['append']) {
	                slot.push(this.$slots['append']);
	            } else if (this.appendIcon) {
	                slot.push(this.genIcon('append'));
	            }
	            return this.genSlot('append', 'outer', slot);
	        },
	        onClick: function onClick(e) {
	            this.$emit('click', e);
	        },
	        onMouseDown: function onMouseDown(e) {
	            this.hasMouseDown = true;
	            this.$emit('mousedown', e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            this.hasMouseDown = false;
	            this.$emit('mouseup', e);
	        }
	    },
	    render: function render(h) {
	        return h('div', this.setTextColor(this.validationState, {
	            staticClass: 'v-input',
	            attrs: this.attrsInput,
	            'class': this.classesInput
	        }), this.genContent());
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VInput/index.js":
	/*!****************************************!*\
	  !*** ./src/components/VInput/index.js ***!
	  \****************************************/
	/*! exports provided: VInput, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VInput */ "./src/components/VInput/VInput.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VInput", function() { return _VInput__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VInput__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/VItem.ts":
	/*!********************************************!*\
	  !*** ./src/components/VItemGroup/VItem.ts ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Mixins
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])('itemGroup', 'v-item', 'v-item-group')
	/* @vue/component */
	).extend({
	    name: 'v-item',
	    props: {
	        value: {
	            required: false
	        }
	    },
	    render: function render() {
	        var _a;
	        if (!this.$scopedSlots.default) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])('v-item is missing a default scopedSlot', this);
	            return null;
	        }
	        var element;
	        /* istanbul ignore else */
	        if (this.$scopedSlots.default) {
	            element = this.$scopedSlots.default({
	                active: this.isActive,
	                toggle: this.toggle
	            });
	        }
	        if (!element || typeof element === 'string' || Array.isArray(element)) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])('v-item should only contain a single element', this);
	            return element;
	        }
	        element.data = element.data || {};
	        element.data.class = [element.data.class, (_a = {}, _a[this.activeClass] = this.isActive, _a)];
	        return element;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/VItemGroup.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VItemGroup/VItemGroup.ts ***!
	  \*************************************************/
	/*! exports provided: BaseItemGroup, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseItemGroup", function() { return BaseItemGroup; });
	/* harmony import */ var _stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_item-group.styl */ "./src/stylus/components/_item-group.styl");
	/* harmony import */ var _stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_item_group_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_proxyable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/proxyable */ "./src/mixins/proxyable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	
	// Utilities
	
	
	var BaseItemGroup = Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_proxyable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]).extend({
	    name: 'base-item-group',
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-item--active'
	        },
	        mandatory: Boolean,
	        max: {
	            type: [Number, String],
	            default: null
	        },
	        multiple: Boolean
	    },
	    data: function data() {
	        return {
	            // As long as a value is defined, show it
	            // Otherwise, check if multiple
	            // to determine which default to provide
	            internalLazyValue: this.value !== undefined ? this.value : this.multiple ? [] : undefined,
	            items: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({}, this.themeClasses);
	        },
	        selectedItems: function selectedItems() {
	            var _this = this;
	            return this.items.filter(function (item, index) {
	                return _this.toggleMethod(_this.getValue(item, index));
	            });
	        },
	        selectedValues: function selectedValues() {
	            return Array.isArray(this.internalValue) ? this.internalValue : [this.internalValue];
	        },
	        toggleMethod: function toggleMethod() {
	            var _this = this;
	            if (!this.multiple) {
	                return function (v) {
	                    return _this.internalValue === v;
	                };
	            }
	            var internalValue = this.internalValue;
	            if (Array.isArray(internalValue)) {
	                return function (v) {
	                    return internalValue.includes(v);
	                };
	            }
	            return function () {
	                return false;
	            };
	        }
	    },
	    watch: {
	        internalValue: function internalValue() {
	            // https://github.com/vuetifyjs/vuetify/issues/5352
	            this.$nextTick(this.updateItemsState);
	        }
	    },
	    created: function created() {
	        if (this.multiple && !Array.isArray(this.internalValue)) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["consoleWarn"])('Model must be bound to an array if the multiple property is true.', this);
	        }
	    },
	    methods: {
	        getValue: function getValue(item, i) {
	            return item.value == null || item.value === '' ? i : item.value;
	        },
	        onClick: function onClick(item, index) {
	            this.updateInternalValue(this.getValue(item, index));
	        },
	        register: function register(item) {
	            var _this = this;
	            var index = this.items.push(item) - 1;
	            item.$on('change', function () {
	                return _this.onClick(item, index);
	            });
	            // If no value provided and mandatory,
	            // assign first registered item
	            if (this.mandatory && this.internalLazyValue == null) {
	                this.updateMandatory();
	            }
	            this.updateItem(item, index);
	        },
	        unregister: function unregister(item) {
	            if (this._isDestroyed) return;
	            var index = this.items.indexOf(item);
	            var value = this.getValue(item, index);
	            this.items.splice(index, 1);
	            var valueIndex = this.selectedValues.indexOf(value);
	            // Items is not selected, do nothing
	            if (valueIndex < 0) return;
	            // If not mandatory, use regular update process
	            if (!this.mandatory) {
	                return this.updateInternalValue(value);
	            }
	            // Remove the value
	            if (this.multiple && Array.isArray(this.internalValue)) {
	                this.internalValue = this.internalValue.filter(function (v) {
	                    return v !== value;
	                });
	            } else {
	                this.internalValue = undefined;
	            }
	            // If mandatory and we have no selection
	            // add the last item as value
	            /* istanbul ignore else */
	            if (!this.selectedItems.length) {
	                this.updateMandatory(true);
	            }
	        },
	        updateItem: function updateItem(item, index) {
	            var value = this.getValue(item, index);
	            item.isActive = this.toggleMethod(value);
	        },
	        updateItemsState: function updateItemsState() {
	            if (this.mandatory && !this.selectedItems.length) {
	                return this.updateMandatory();
	            }
	            // TODO: Make this smarter so it
	            // doesn't have to iterate every
	            // child in an update
	            this.items.forEach(this.updateItem);
	        },
	        updateInternalValue: function updateInternalValue(value) {
	            this.multiple ? this.updateMultiple(value) : this.updateSingle(value);
	        },
	        updateMandatory: function updateMandatory(last) {
	            if (!this.items.length) return;
	            var index = last ? this.items.length - 1 : 0;
	            this.updateInternalValue(this.getValue(this.items[index], index));
	        },
	        updateMultiple: function updateMultiple(value) {
	            var defaultValue = Array.isArray(this.internalValue) ? this.internalValue : [];
	            var internalValue = defaultValue.slice();
	            var index = internalValue.findIndex(function (val) {
	                return val === value;
	            });
	            if (this.mandatory &&
	            // Item already exists
	            index > -1 &&
	            // value would be reduced below min
	            internalValue.length - 1 < 1) return;
	            if (
	            // Max is set
	            this.max != null &&
	            // Item doesn't exist
	            index < 0 &&
	            // value woudl be increased above max
	            internalValue.length + 1 > this.max) return;
	            index > -1 ? internalValue.splice(index, 1) : internalValue.push(value);
	            this.internalValue = internalValue;
	        },
	        updateSingle: function updateSingle(value) {
	            var isSame = value === this.internalValue;
	            if (this.mandatory && isSame) return;
	            this.internalValue = isSame ? undefined : value;
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-item-group',
	            class: this.classes
	        }, this.$slots.default);
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (BaseItemGroup.extend({
	    name: 'v-item-group',
	    provide: function provide() {
	        return {
	            itemGroup: this
	        };
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VItemGroup/index.ts":
	/*!********************************************!*\
	  !*** ./src/components/VItemGroup/index.ts ***!
	  \********************************************/
	/*! exports provided: VItem, VItemGroup, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VItem */ "./src/components/VItemGroup/VItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItem", function() { return _VItem__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItemGroup", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VItem: _VItem__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VItemGroup: _VItemGroup__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VJumbotron/VJumbotron.js":
	/*!*************************************************!*\
	  !*** ./src/components/VJumbotron/VJumbotron.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_jumbotrons.styl */ "./src/stylus/components/_jumbotrons.styl");
	/* harmony import */ var _stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_jumbotrons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	// Mixins
	
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-jumbotron',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        gradient: String,
	        height: {
	            type: [Number, String],
	            default: '400px'
	        },
	        src: String,
	        tag: {
	            type: String,
	            default: 'div'
	        }
	    },
	    computed: {
	        backgroundStyles: function backgroundStyles() {
	            var styles = {};
	            if (this.gradient) {
	                styles.background = "linear-gradient(" + this.gradient + ")";
	            }
	            return styles;
	        },
	        classes: function classes() {
	            return this.themeClasses;
	        },
	        styles: function styles() {
	            return {
	                height: this.height
	            };
	        }
	    },
	    mounted: function mounted() {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('v-jumbotron', this.src ? 'v-img' : 'v-responsive', this);
	    },
	    methods: {
	        genBackground: function genBackground() {
	            return this.$createElement('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-jumbotron__background',
	                style: this.backgroundStyles
	            }));
	        },
	        genContent: function genContent() {
	            return this.$createElement('div', {
	                staticClass: 'v-jumbotron__content'
	            }, this.$slots.default);
	        },
	        genImage: function genImage() {
	            if (!this.src) return null;
	            if (this.$slots.img) return this.$slots.img({ src: this.src });
	            return this.$createElement('img', {
	                staticClass: 'v-jumbotron__image',
	                attrs: { src: this.src }
	            });
	        },
	        genWrapper: function genWrapper() {
	            return this.$createElement('div', {
	                staticClass: 'v-jumbotron__wrapper'
	            }, [this.genImage(), this.genBackground(), this.genContent()]);
	        }
	    },
	    render: function render(h) {
	        var _a = this.generateRouteLink(this.classes),
	            tag = _a.tag,
	            data = _a.data;
	        data.staticClass = 'v-jumbotron';
	        data.style = this.styles;
	        return h(tag, data, [this.genWrapper()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VJumbotron/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VJumbotron/index.js ***!
	  \********************************************/
	/*! exports provided: VJumbotron, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VJumbotron__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VJumbotron */ "./src/components/VJumbotron/VJumbotron.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return _VJumbotron__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VJumbotron__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VLabel/VLabel.js":
	/*!*****************************************!*\
	  !*** ./src/components/VLabel/VLabel.js ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_labels.styl */ "./src/stylus/components/_labels.styl");
	/* harmony import */ var _stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_labels_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-label',
	    functional: true,
	    mixins: [_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        absolute: Boolean,
	        color: {
	            type: [Boolean, String],
	            default: 'primary'
	        },
	        disabled: Boolean,
	        focused: Boolean,
	        for: String,
	        left: {
	            type: [Number, String],
	            default: 0
	        },
	        right: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        value: Boolean
	    },
	    render: function render(h, ctx) {
	        var children = ctx.children,
	            listeners = ctx.listeners,
	            props = ctx.props;
	        var data = {
	            staticClass: 'v-label',
	            'class': __assign({ 'v-label--active': props.value, 'v-label--is-disabled': props.disabled }, Object(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["functionalThemeClasses"])(ctx)),
	            attrs: {
	                for: props.for,
	                'aria-hidden': !props.for
	            },
	            on: listeners,
	            style: {
	                left: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(props.left),
	                right: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(props.right),
	                position: props.absolute ? 'absolute' : 'relative'
	            }
	        };
	        return h('label', _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.setTextColor(props.focused && props.color, data), children);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VLabel/index.js":
	/*!****************************************!*\
	  !*** ./src/components/VLabel/index.js ***!
	  \****************************************/
	/*! exports provided: VLabel, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VLabel */ "./src/components/VLabel/VLabel.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLabel", function() { return _VLabel__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VLabel__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VList/VList.js":
	/*!***************************************!*\
	  !*** ./src/components/VList/VList.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_lists.styl */ "./src/stylus/components/_lists.styl");
	/* harmony import */ var _stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_lists_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-list',
	    mixins: [Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["provide"])('list'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    provide: function provide() {
	        return {
	            'listClick': this.listClick
	        };
	    },
	    props: {
	        dense: Boolean,
	        expand: Boolean,
	        subheader: Boolean,
	        threeLine: Boolean,
	        twoLine: Boolean
	    },
	    data: function data() {
	        return {
	            groups: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-list--dense': this.dense, 'v-list--subheader': this.subheader, 'v-list--two-line': this.twoLine, 'v-list--three-line': this.threeLine }, this.themeClasses);
	        }
	    },
	    methods: {
	        register: function register(uid, cb) {
	            this.groups.push({ uid: uid, cb: cb });
	        },
	        unregister: function unregister(uid) {
	            var index = this.groups.findIndex(function (g) {
	                return g.uid === uid;
	            });
	            if (index > -1) {
	                this.groups.splice(index, 1);
	            }
	        },
	        listClick: function listClick(uid) {
	            if (this.expand) return;
	            for (var i = this.groups.length; i--;) {
	                this.groups[i].cb(uid);
	            }
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-list',
	            'class': this.classes
	        };
	        return h('div', data, [this.$slots.default]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VList/VListGroup.js":
	/*!********************************************!*\
	  !*** ./src/components/VList/VListGroup.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Components
	
	// Mixins
	
	
	
	// Transitions
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-list-group',
	    mixins: [_mixins_bootable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])('list', 'v-list-group', 'v-list'), _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    inject: ['listClick'],
	    props: {
	        activeClass: {
	            type: String,
	            default: 'primary--text'
	        },
	        appendIcon: {
	            type: String,
	            default: '$vuetify.icons.expand'
	        },
	        disabled: Boolean,
	        group: String,
	        noAction: Boolean,
	        prependIcon: String,
	        subGroup: Boolean
	    },
	    data: function data() {
	        return {
	            groups: []
	        };
	    },
	    computed: {
	        groupClasses: function groupClasses() {
	            return {
	                'v-list__group--active': this.isActive,
	                'v-list__group--disabled': this.disabled
	            };
	        },
	        headerClasses: function headerClasses() {
	            return {
	                'v-list__group__header--active': this.isActive,
	                'v-list__group__header--sub-group': this.subGroup
	            };
	        },
	        itemsClasses: function itemsClasses() {
	            return {
	                'v-list__group__items--no-action': this.noAction
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (!this.subGroup && val) {
	                this.listClick(this._uid);
	            }
	        },
	        $route: function $route(to) {
	            var isActive = this.matchRoute(to.path);
	            if (this.group) {
	                if (isActive && this.isActive !== isActive) {
	                    this.listClick(this._uid);
	                }
	                this.isActive = isActive;
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.list.register(this._uid, this.toggle);
	        if (this.group && this.$route && this.value == null) {
	            this.isActive = this.matchRoute(this.$route.path);
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.list.unregister(this._uid);
	    },
	    methods: {
	        click: function click(e) {
	            if (this.disabled) return;
	            this.$emit('click', e);
	            this.isActive = !this.isActive;
	        },
	        genIcon: function genIcon(icon) {
	            return this.$createElement(_components_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], icon);
	        },
	        genAppendIcon: function genAppendIcon() {
	            var icon = !this.subGroup ? this.appendIcon : false;
	            if (!icon && !this.$slots.appendIcon) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header__append-icon'
	            }, [this.$slots.appendIcon || this.genIcon(icon)]);
	        },
	        genGroup: function genGroup() {
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header',
	                'class': this.headerClasses,
	                on: __assign({}, this.$listeners, { click: this.click }),
	                ref: 'item'
	            }, [this.genPrependIcon(), this.$slots.activator, this.genAppendIcon()]);
	        },
	        genItems: function genItems() {
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__items',
	                'class': this.itemsClasses,
	                directives: [{
	                    name: 'show',
	                    value: this.isActive
	                }],
	                ref: 'group'
	            }, this.showLazyContent(this.$slots.default));
	        },
	        genPrependIcon: function genPrependIcon() {
	            var _a;
	            var icon = this.prependIcon ? this.prependIcon : this.subGroup ? '$vuetify.icons.subgroup' : false;
	            if (!icon && !this.$slots.prependIcon) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-list__group__header__prepend-icon',
	                'class': (_a = {}, _a[this.activeClass] = this.isActive, _a)
	            }, [this.$slots.prependIcon || this.genIcon(icon)]);
	        },
	        toggle: function toggle(uid) {
	            this.isActive = this._uid === uid;
	        },
	        matchRoute: function matchRoute(to) {
	            if (!this.group) return false;
	            return to.match(this.group) !== null;
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-list__group',
	            'class': this.groupClasses
	        }, [this.genGroup(), h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VExpandTransition"], [this.genItems()])]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTile.js":
	/*!*******************************************!*\
	  !*** ./src/components/VList/VListTile.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	
	
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-list-tile',
	    directives: {
	        Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_4__["default"]
	    },
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"], _mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    inheritAttrs: false,
	    props: {
	        activeClass: {
	            type: String,
	            default: 'primary--text'
	        },
	        avatar: Boolean,
	        inactive: Boolean,
	        tag: String
	    },
	    data: function data() {
	        return {
	            proxyClass: 'v-list__tile--active'
	        };
	    },
	    computed: {
	        listClasses: function listClasses() {
	            return this.disabled ? { 'v-list--disabled': true } : undefined;
	        },
	        classes: function classes() {
	            var _a;
	            return __assign({ 'v-list__tile': true, 'v-list__tile--link': this.isLink && !this.inactive, 'v-list__tile--avatar': this.avatar, 'v-list__tile--disabled': this.disabled, 'v-list__tile--active': !this.to && this.isActive }, this.themeClasses, (_a = {}, _a[this.activeClass] = this.isActive, _a));
	        },
	        isLink: function isLink() {
	            return this.href || this.to || this.$listeners && (this.$listeners.click || this.$listeners['!click']);
	        }
	    },
	    render: function render(h) {
	        var isRouteLink = !this.inactive && this.isLink;
	        var _a = isRouteLink ? this.generateRouteLink(this.classes) : {
	            tag: this.tag || 'div',
	            data: {
	                class: this.classes
	            }
	        },
	            tag = _a.tag,
	            data = _a.data;
	        data.attrs = Object.assign({}, data.attrs, this.$attrs);
	        return h('div', this.setTextColor(!this.disabled && this.color, {
	            class: this.listClasses,
	            attrs: {
	                disabled: this.disabled
	            }
	        }), [h(tag, data, this.$slots.default)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTileAction.js":
	/*!*************************************************!*\
	  !*** ./src/components/VList/VListTileAction.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-list-tile-action',
	    functional: true,
	    render: function render(h, _a) {
	        var data = _a.data,
	            _b = _a.children,
	            children = _b === void 0 ? [] : _b;
	        data.staticClass = data.staticClass ? "v-list__tile__action " + data.staticClass : 'v-list__tile__action';
	        var filteredChild = children.filter(function (VNode) {
	            return VNode.isComment === false && VNode.text !== ' ';
	        });
	        if (filteredChild.length > 1) data.staticClass += ' v-list__tile__action--stack';
	        return h('div', data, children);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VList/VListTileAvatar.js":
	/*!*************************************************!*\
	  !*** ./src/components/VList/VListTileAvatar.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VAvatar */ "./src/components/VAvatar/index.ts");
	// Components
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-list-tile-avatar',
	    functional: true,
	    props: {
	        color: String,
	        size: {
	            type: [Number, String],
	            default: 40
	        },
	        tile: Boolean
	    },
	    render: function render(h, _a) {
	        var data = _a.data,
	            children = _a.children,
	            props = _a.props;
	        data.staticClass = ("v-list__tile__avatar " + (data.staticClass || '')).trim();
	        var avatar = h(_VAvatar__WEBPACK_IMPORTED_MODULE_0__["default"], {
	            props: {
	                color: props.color,
	                size: props.size,
	                tile: props.tile
	            }
	        }, [children]);
	        return h('div', data, [avatar]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VList/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VList/index.js ***!
	  \***************************************/
	/*! exports provided: VList, VListGroup, VListTile, VListTileAction, VListTileAvatar, VListTileActionText, VListTileContent, VListTileTitle, VListTileSubTitle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileActionText", function() { return VListTileActionText; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileContent", function() { return VListTileContent; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileTitle", function() { return VListTileTitle; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VListTileSubTitle", function() { return VListTileSubTitle; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VList */ "./src/components/VList/VList.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return _VList__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VListGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VListGroup */ "./src/components/VList/VListGroup.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListGroup", function() { return _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VListTile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VListTile */ "./src/components/VList/VListTile.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTile", function() { return _VListTile__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VListTileAction__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VListTileAction */ "./src/components/VList/VListTileAction.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAction", function() { return _VListTileAction__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	/* harmony import */ var _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VListTileAvatar */ "./src/components/VList/VListTileAvatar.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAvatar", function() { return _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__["default"]; });
	
	
	
	
	
	
	
	
	var VListTileActionText = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__action-text', 'span');
	var VListTileContent = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__content', 'div');
	var VListTileTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__title', 'div');
	var VListTileSubTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-list__tile__sub-title', 'div');
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VList: _VList__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VListGroup: _VListGroup__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VListTile: _VListTile__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VListTileAction: _VListTileAction__WEBPACK_IMPORTED_MODULE_4__["default"],
	        VListTileActionText: VListTileActionText,
	        VListTileAvatar: _VListTileAvatar__WEBPACK_IMPORTED_MODULE_5__["default"],
	        VListTileContent: VListTileContent,
	        VListTileSubTitle: VListTileSubTitle,
	        VListTileTitle: VListTileTitle
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/VMenu.js":
	/*!***************************************!*\
	  !*** ./src/components/VMenu/VMenu.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_menus.styl */ "./src/stylus/components/_menus.styl");
	/* harmony import */ var _stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_menus_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_menuable_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/menuable.js */ "./src/mixins/menuable.js");
	/* harmony import */ var _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/returnable */ "./src/mixins/returnable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_menu_activator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./mixins/menu-activator */ "./src/components/VMenu/mixins/menu-activator.js");
	/* harmony import */ var _mixins_menu_generators__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./mixins/menu-generators */ "./src/components/VMenu/mixins/menu-generators.js");
	/* harmony import */ var _mixins_menu_keyable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./mixins/menu-keyable */ "./src/components/VMenu/mixins/menu-keyable.js");
	/* harmony import */ var _mixins_menu_position__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./mixins/menu-position */ "./src/components/VMenu/mixins/menu-position.js");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	
	
	// Mixins
	
	
	
	
	
	
	
	// Component level mixins
	
	
	
	
	// Directives
	
	
	// Helpers
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'v-menu',
	    provide: function provide() {
	        return {
	            // Pass theme through to default slot
	            theme: this.theme
	        };
	    },
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_13__["default"],
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_14__["default"]
	    },
	    mixins: [_mixins_menu_activator__WEBPACK_IMPORTED_MODULE_9__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_menu_generators__WEBPACK_IMPORTED_MODULE_10__["default"], _mixins_menu_keyable__WEBPACK_IMPORTED_MODULE_11__["default"], _mixins_menuable_js__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_menu_position__WEBPACK_IMPORTED_MODULE_12__["default"], _mixins_returnable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_8__["default"]],
	    props: {
	        auto: Boolean,
	        closeOnClick: {
	            type: Boolean,
	            default: true
	        },
	        closeOnContentClick: {
	            type: Boolean,
	            default: true
	        },
	        disabled: Boolean,
	        fullWidth: Boolean,
	        maxHeight: { default: 'auto' },
	        offsetX: Boolean,
	        offsetY: Boolean,
	        openOnClick: {
	            type: Boolean,
	            default: true
	        },
	        openOnHover: Boolean,
	        origin: {
	            type: String,
	            default: 'top left'
	        },
	        transition: {
	            type: [Boolean, String],
	            default: 'v-menu-transition'
	        }
	    },
	    data: function data() {
	        return {
	            defaultOffset: 8,
	            hasJustFocused: false,
	            resizeTimeout: null
	        };
	    },
	    computed: {
	        calculatedLeft: function calculatedLeft() {
	            if (!this.auto) return this.calcLeft();
	            return this.calcXOverflow(this.calcLeftAuto()) + "px";
	        },
	        calculatedMaxHeight: function calculatedMaxHeight() {
	            return this.auto ? '200px' : Object(_util_helpers__WEBPACK_IMPORTED_MODULE_15__["convertToUnit"])(this.maxHeight);
	        },
	        calculatedMaxWidth: function calculatedMaxWidth() {
	            return isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth + "px";
	        },
	        calculatedMinWidth: function calculatedMinWidth() {
	            if (this.minWidth) {
	                return isNaN(this.minWidth) ? this.minWidth : this.minWidth + "px";
	            }
	            var minWidth = this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);
	            var calculatedMaxWidth = isNaN(parseInt(this.calculatedMaxWidth)) ? minWidth : parseInt(this.calculatedMaxWidth);
	            return Math.min(calculatedMaxWidth, minWidth) + "px";
	        },
	        calculatedTop: function calculatedTop() {
	            if (!this.auto || this.isAttached) return this.calcTop();
	            return this.calcYOverflow(this.calculatedTopAuto) + "px";
	        },
	        styles: function styles() {
	            return {
	                maxHeight: this.calculatedMaxHeight,
	                minWidth: this.calculatedMinWidth,
	                maxWidth: this.calculatedMaxWidth,
	                top: this.calculatedTop,
	                left: this.calculatedLeft,
	                transformOrigin: this.origin,
	                zIndex: this.zIndex || this.activeZIndex
	            };
	        }
	    },
	    watch: {
	        activator: function activator(newActivator, oldActivator) {
	            this.removeActivatorEvents(oldActivator);
	            this.addActivatorEvents(newActivator);
	        },
	        isContentActive: function isContentActive(val) {
	            this.hasJustFocused = val;
	        }
	    },
	    methods: {
	        activate: function activate() {
	            var _this = this;
	            // This exists primarily for v-select
	            // helps determine which tiles to activate
	            this.getTiles();
	            // Update coordinates and dimensions of menu
	            // and its activator
	            this.updateDimensions();
	            // Start the transition
	            requestAnimationFrame(function () {
	                // Once transitioning, calculate scroll and top position
	                _this.startTransition().then(function () {
	                    if (_this.$refs.content) {
	                        _this.calculatedTopAuto = _this.calcTopAuto();
	                        _this.auto && (_this.$refs.content.scrollTop = _this.calcScrollPosition());
	                    }
	                });
	            });
	        },
	        closeConditional: function closeConditional() {
	            return this.isActive && this.closeOnClick;
	        },
	        onResize: function onResize() {
	            if (!this.isActive) return;
	            // Account for screen resize
	            // and orientation change
	            // eslint-disable-next-line no-unused-expressions
	            this.$refs.content.offsetWidth;
	            this.updateDimensions();
	            // When resizing to a smaller width
	            // content width is evaluated before
	            // the new activator width has been
	            // set, causing it to not size properly
	            // hacky but will revisit in the future
	            clearTimeout(this.resizeTimeout);
	            this.resizeTimeout = setTimeout(this.updateDimensions, 100);
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-menu',
	            class: { 'v-menu--inline': !this.fullWidth && this.$slots.activator },
	            directives: [{
	                arg: 500,
	                name: 'resize',
	                value: this.onResize
	            }],
	            on: {
	                keydown: this.onKeyDown
	            }
	        };
	        return h('div', data, [this.genActivator(), this.$createElement(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_16__["default"], {
	            props: {
	                root: true,
	                light: this.light,
	                dark: this.dark
	            }
	        }, [this.genTransition()])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VMenu/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VMenu/index.js ***!
	  \***************************************/
	/*! exports provided: VMenu, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VMenu */ "./src/components/VMenu/VMenu.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return _VMenu__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VMenu__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-activator.js":
	/*!*******************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-activator.js ***!
	  \*******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Menu activator
	 *
	 * @mixin
	 *
	 * Handles the click and hover activation
	 * Supports slotted and detached activators
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        activatorClickHandler: function activatorClickHandler(e) {
	            if (this.disabled) return;
	            if (this.openOnClick && !this.isActive) {
	                this.getActivator().focus();
	                this.isActive = true;
	                this.absoluteX = e.clientX;
	                this.absoluteY = e.clientY;
	            } else if (this.closeOnClick && this.isActive) {
	                this.getActivator().blur();
	                this.isActive = false;
	            }
	        },
	        mouseEnterHandler: function mouseEnterHandler() {
	            var _this = this;
	            this.runDelay('open', function () {
	                if (_this.hasJustFocused) return;
	                _this.hasJustFocused = true;
	                _this.isActive = true;
	            });
	        },
	        mouseLeaveHandler: function mouseLeaveHandler(e) {
	            var _this = this;
	            // Prevent accidental re-activation
	            this.runDelay('close', function () {
	                if (_this.$refs.content.contains(e.relatedTarget)) return;
	                requestAnimationFrame(function () {
	                    _this.isActive = false;
	                    _this.callDeactivate();
	                });
	            });
	        },
	        addActivatorEvents: function addActivatorEvents(activator) {
	            if (activator === void 0) {
	                activator = null;
	            }
	            if (!activator) return;
	            activator.addEventListener('click', this.activatorClickHandler);
	        },
	        removeActivatorEvents: function removeActivatorEvents(activator) {
	            if (activator === void 0) {
	                activator = null;
	            }
	            if (!activator) return;
	            activator.removeEventListener('click', this.activatorClickHandler);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-generators.js":
	/*!********************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-generators.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genActivator: function genActivator() {
	            if (!this.$slots.activator) return null;
	            var options = {
	                staticClass: 'v-menu__activator',
	                'class': {
	                    'v-menu__activator--active': this.hasJustFocused || this.isActive,
	                    'v-menu__activator--disabled': this.disabled
	                },
	                ref: 'activator',
	                on: {}
	            };
	            if (this.openOnHover) {
	                options.on['mouseenter'] = this.mouseEnterHandler;
	                options.on['mouseleave'] = this.mouseLeaveHandler;
	            } else if (this.openOnClick) {
	                options.on['click'] = this.activatorClickHandler;
	            }
	            return this.$createElement('div', options, this.$slots.activator);
	        },
	        genTransition: function genTransition() {
	            if (!this.transition) return this.genContent();
	            return this.$createElement('transition', {
	                props: {
	                    name: this.transition
	                }
	            }, [this.genContent()]);
	        },
	        genDirectives: function genDirectives() {
	            var _this = this;
	            // Do not add click outside for hover menu
	            var directives = !this.openOnHover && this.closeOnClick ? [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: function include() {
	                        return __spread([_this.$el], _this.getOpenDependentElements());
	                    }
	                }
	            }] : [];
	            directives.push({
	                name: 'show',
	                value: this.isContentActive
	            });
	            return directives;
	        },
	        genContent: function genContent() {
	            var _this = this;
	            var _a;
	            var options = {
	                attrs: this.getScopeIdAttrs(),
	                staticClass: 'v-menu__content',
	                'class': __assign({}, this.rootThemeClasses, (_a = { 'v-menu__content--auto': this.auto, 'menuable__content__active': this.isActive }, _a[this.contentClass.trim()] = true, _a)),
	                style: this.styles,
	                directives: this.genDirectives(),
	                ref: 'content',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (e.target.getAttribute('disabled')) return;
	                        if (_this.closeOnContentClick) _this.isActive = false;
	                    }
	                }
	            };
	            !this.disabled && this.openOnHover && (options.on.mouseenter = this.mouseEnterHandler);
	            this.openOnHover && (options.on.mouseleave = this.mouseLeaveHandler);
	            return this.$createElement('div', options, this.showLazyContent(this.$slots.default));
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-keyable.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-keyable.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	/**
	 * Menu keyable
	 *
	 * @mixin
	 *
	 * Primarily used to support VSelect
	 * Handles opening and closing of VMenu from keystrokes
	 * Will conditionally highlight VListTiles for VSelect
	 */
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    data: function data() {
	        return {
	            listIndex: -1,
	            tiles: []
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (!val) this.listIndex = -1;
	        },
	        listIndex: function listIndex(next, prev) {
	            if (next in this.tiles) {
	                var tile = this.tiles[next];
	                tile.classList.add('v-list__tile--highlighted');
	                this.$refs.content.scrollTop = tile.offsetTop - tile.clientHeight;
	            }
	            prev in this.tiles && this.tiles[prev].classList.remove('v-list__tile--highlighted');
	        }
	    },
	    methods: {
	        onKeyDown: function onKeyDown(e) {
	            if ([_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].enter].includes(e.keyCode)) e.preventDefault();
	            if ([_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].esc, _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].tab].includes(e.keyCode)) {
	                return this.isActive = false;
	            }
	            this.changeListIndex(e);
	        },
	        changeListIndex: function changeListIndex(e) {
	            // For infinite scroll and autocomplete, re-evaluate children
	            this.getTiles();
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].down && this.listIndex < this.tiles.length - 1) {
	                this.listIndex++;
	                // Allow user to set listIndex to -1 so
	                // that the list can be un-highlighted
	            } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].up && this.listIndex > -1) {
	                this.listIndex--;
	            } else if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_0__["keyCodes"].enter && this.listIndex !== -1) {
	                this.tiles[this.listIndex].click();
	            }
	        },
	        getTiles: function getTiles() {
	            this.tiles = this.$refs.content.querySelectorAll('.v-list__tile');
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMenu/mixins/menu-position.js":
	/*!******************************************************!*\
	  !*** ./src/components/VMenu/mixins/menu-position.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Menu position
	 *
	 * @mixin
	 *
	 * Used for calculating an automatic position (used for VSelect)
	 * Will position the VMenu content properly over the VSelect
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    data: function data() {
	        return {
	            calculatedTopAuto: 0
	        };
	    },
	    methods: {
	        calcScrollPosition: function calcScrollPosition() {
	            var $el = this.$refs.content;
	            var activeTile = $el.querySelector('.v-list__tile--active');
	            var maxScrollTop = $el.scrollHeight - $el.offsetHeight;
	            return activeTile ? Math.min(maxScrollTop, Math.max(0, activeTile.offsetTop - $el.offsetHeight / 2 + activeTile.offsetHeight / 2)) : $el.scrollTop;
	        },
	        calcLeftAuto: function calcLeftAuto() {
	            if (this.isAttached) return 0;
	            return parseInt(this.dimensions.activator.left - this.defaultOffset * 2);
	        },
	        calcTopAuto: function calcTopAuto() {
	            var $el = this.$refs.content;
	            var activeTile = $el.querySelector('.v-list__tile--active');
	            if (!activeTile) {
	                this.selectedIndex = null;
	            }
	            if (this.offsetY || !activeTile) {
	                return this.computedTop;
	            }
	            this.selectedIndex = Array.from(this.tiles).indexOf(activeTile);
	            var tileDistanceFromMenuTop = activeTile.offsetTop - this.calcScrollPosition();
	            var firstTileOffsetTop = $el.querySelector('.v-list__tile').offsetTop;
	            return this.computedTop - tileDistanceFromMenuTop - firstTileOffsetTop;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMessages/VMessages.js":
	/*!***********************************************!*\
	  !*** ./src/components/VMessages/VMessages.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_messages.styl */ "./src/stylus/components/_messages.styl");
	/* harmony import */ var _stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_messages_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	// Styles
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-messages',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    methods: {
	        genChildren: function genChildren() {
	            return this.$createElement('transition-group', {
	                staticClass: 'v-messages__wrapper',
	                attrs: {
	                    name: 'message-transition',
	                    tag: 'div'
	                }
	            }, this.value.map(this.genMessage));
	        },
	        genMessage: function genMessage(message, key) {
	            return this.$createElement('div', {
	                staticClass: 'v-messages__message',
	                key: key,
	                domProps: {
	                    innerHTML: message
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        return h('div', this.setTextColor(this.color, {
	            staticClass: 'v-messages',
	            class: this.themeClasses
	        }), [this.genChildren()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VMessages/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VMessages/index.js ***!
	  \*******************************************/
	/*! exports provided: VMessages, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VMessages */ "./src/components/VMessages/VMessages.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMessages", function() { return _VMessages__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VMessages__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VNavigationDrawer/VNavigationDrawer.js":
	/*!***************************************************************!*\
	  !*** ./src/components/VNavigationDrawer/VNavigationDrawer.js ***!
	  \***************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_navigation-drawer.styl */ "./src/stylus/components/_navigation-drawer.styl");
	/* harmony import */ var _stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_navigation_drawer_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/overlayable */ "./src/mixins/overlayable.js");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	
	
	
	// Directives
	
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-navigation-drawer',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_6__["default"],
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_7__["default"],
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_8__["default"]
	    },
	    mixins: [Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])(null, ['miniVariant', 'right', 'width']), _mixins_dependent__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_overlayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    props: {
	        clipped: Boolean,
	        disableRouteWatcher: Boolean,
	        disableResizeWatcher: Boolean,
	        height: {
	            type: [Number, String],
	            default: '100%'
	        },
	        floating: Boolean,
	        miniVariant: Boolean,
	        miniVariantWidth: {
	            type: [Number, String],
	            default: 80
	        },
	        mobileBreakPoint: {
	            type: [Number, String],
	            default: 1264
	        },
	        permanent: Boolean,
	        right: Boolean,
	        stateless: Boolean,
	        temporary: Boolean,
	        touchless: Boolean,
	        width: {
	            type: [Number, String],
	            default: 300
	        },
	        value: { required: false }
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            touchArea: {
	                left: 0,
	                right: 0
	            }
	        };
	    },
	    computed: {
	        /**
	         * Used for setting an app
	         * value from a dynamic
	         * property. Called from
	         * applicationable.js
	         *
	         * @return {string}
	         */
	        applicationProperty: function applicationProperty() {
	            return this.right ? 'right' : 'left';
	        },
	        calculatedTransform: function calculatedTransform() {
	            if (this.isActive) return 0;
	            return this.right ? this.calculatedWidth : -this.calculatedWidth;
	        },
	        calculatedWidth: function calculatedWidth() {
	            return this.miniVariant ? this.miniVariantWidth : this.width;
	        },
	        classes: function classes() {
	            return __assign({ 'v-navigation-drawer': true, 'v-navigation-drawer--absolute': this.absolute, 'v-navigation-drawer--clipped': this.clipped, 'v-navigation-drawer--close': !this.isActive, 'v-navigation-drawer--fixed': !this.absolute && (this.app || this.fixed), 'v-navigation-drawer--floating': this.floating, 'v-navigation-drawer--is-mobile': this.isMobile, 'v-navigation-drawer--mini-variant': this.miniVariant, 'v-navigation-drawer--open': this.isActive, 'v-navigation-drawer--right': this.right, 'v-navigation-drawer--temporary': this.temporary }, this.themeClasses);
	        },
	        hasApp: function hasApp() {
	            return this.app && !this.isMobile && !this.temporary;
	        },
	        isMobile: function isMobile() {
	            return !this.stateless && !this.permanent && !this.temporary && this.$vuetify.breakpoint.width < parseInt(this.mobileBreakPoint, 10);
	        },
	        marginTop: function marginTop() {
	            if (!this.hasApp) return 0;
	            var marginTop = this.$vuetify.application.bar;
	            marginTop += this.clipped ? this.$vuetify.application.top : 0;
	            return marginTop;
	        },
	        maxHeight: function maxHeight() {
	            if (!this.hasApp) return null;
	            var maxHeight = this.$vuetify.application.bottom + this.$vuetify.application.footer + this.$vuetify.application.bar;
	            if (!this.clipped) return maxHeight;
	            return maxHeight + this.$vuetify.application.top;
	        },
	        reactsToClick: function reactsToClick() {
	            return !this.stateless && !this.permanent && (this.isMobile || this.temporary);
	        },
	        reactsToMobile: function reactsToMobile() {
	            return !this.disableResizeWatcher && !this.stateless && !this.permanent && !this.temporary;
	        },
	        reactsToRoute: function reactsToRoute() {
	            return !this.disableRouteWatcher && !this.stateless && (this.temporary || this.isMobile);
	        },
	        resizeIsDisabled: function resizeIsDisabled() {
	            return this.disableResizeWatcher || this.stateless;
	        },
	        showOverlay: function showOverlay() {
	            return this.isActive && (this.isMobile || this.temporary);
	        },
	        styles: function styles() {
	            var styles = {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["convertToUnit"])(this.height),
	                marginTop: this.marginTop + "px",
	                maxHeight: "calc(100% - " + +this.maxHeight + "px)",
	                transform: "translateX(" + this.calculatedTransform + "px)",
	                width: this.calculatedWidth + "px"
	            };
	            return styles;
	        }
	    },
	    watch: {
	        $route: function $route() {
	            if (this.reactsToRoute && this.closeConditional()) {
	                this.isActive = false;
	            }
	        },
	        isActive: function isActive(val) {
	            this.$emit('input', val);
	            this.callUpdate();
	        },
	        /**
	         * When mobile changes, adjust
	         * the active state only when
	         * there has been a previous
	         * value
	         */
	        isMobile: function isMobile(val, prev) {
	            !val && this.isActive && !this.temporary && this.removeOverlay();
	            if (prev == null || this.resizeIsDisabled || !this.reactsToMobile) return;
	            this.isActive = !val;
	            this.callUpdate();
	        },
	        permanent: function permanent(val) {
	            // If enabling prop
	            // enable the drawer
	            if (val) {
	                this.isActive = true;
	            }
	            this.callUpdate();
	        },
	        showOverlay: function showOverlay(val) {
	            if (val) this.genOverlay();else this.removeOverlay();
	        },
	        temporary: function temporary() {
	            this.callUpdate();
	        },
	        value: function value(val) {
	            if (this.permanent) return;
	            if (val == null) return this.init();
	            if (val !== this.isActive) this.isActive = val;
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.init();
	    },
	    methods: {
	        calculateTouchArea: function calculateTouchArea() {
	            if (!this.$el.parentNode) return;
	            var parentRect = this.$el.parentNode.getBoundingClientRect();
	            this.touchArea = {
	                left: parentRect.left + 50,
	                right: parentRect.right - 50
	            };
	        },
	        closeConditional: function closeConditional() {
	            return this.isActive && this.reactsToClick;
	        },
	        genDirectives: function genDirectives() {
	            var _this = this;
	            var directives = [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this.isActive = false;
	                },
	                args: {
	                    closeConditional: this.closeConditional,
	                    include: this.getOpenDependentElements
	                }
	            }];
	            !this.touchless && directives.push({
	                name: 'touch',
	                value: {
	                    parent: true,
	                    left: this.swipeLeft,
	                    right: this.swipeRight
	                }
	            });
	            return directives;
	        },
	        /**
	         * Sets state before mount to avoid
	         * entry transitions in SSR
	         *
	         * @return {void}
	         */
	        init: function init() {
	            if (this.permanent) {
	                this.isActive = true;
	            } else if (this.stateless || this.value != null) {
	                this.isActive = this.value;
	            } else if (!this.temporary) {
	                this.isActive = !this.isMobile;
	            }
	        },
	        swipeRight: function swipeRight(e) {
	            if (this.isActive && !this.right) return;
	            this.calculateTouchArea();
	            if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
	            if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
	        },
	        swipeLeft: function swipeLeft(e) {
	            if (this.isActive && this.right) return;
	            this.calculateTouchArea();
	            if (Math.abs(e.touchendX - e.touchstartX) < 100) return;
	            if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
	        },
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            return !this.isActive || this.temporary || this.isMobile ? 0 : this.calculatedWidth;
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var data = {
	            'class': this.classes,
	            style: this.styles,
	            directives: this.genDirectives(),
	            on: {
	                click: function click() {
	                    if (!_this.miniVariant) return;
	                    _this.$emit('update:miniVariant', false);
	                },
	                transitionend: function transitionend(e) {
	                    if (e.target !== e.currentTarget) return;
	                    _this.$emit('transitionend', e);
	                    // IE11 does not support new Event('resize')
	                    var resizeEvent = document.createEvent('UIEvents');
	                    resizeEvent.initUIEvent('resize', true, false, window, 0);
	                    window.dispatchEvent(resizeEvent);
	                }
	            }
	        };
	        return h('aside', data, [this.$slots.default, h('div', { 'class': 'v-navigation-drawer__border' })]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VNavigationDrawer/index.js":
	/*!***************************************************!*\
	  !*** ./src/components/VNavigationDrawer/index.js ***!
	  \***************************************************/
	/*! exports provided: VNavigationDrawer, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VNavigationDrawer */ "./src/components/VNavigationDrawer/VNavigationDrawer.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VNavigationDrawer__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VOverflowBtn/VOverflowBtn.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VOverflowBtn/VOverflowBtn.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_overflow-buttons.styl */ "./src/stylus/components/_overflow-buttons.styl");
	/* harmony import */ var _stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_overflow_buttons_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSelect/VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Styles
	
	// Extensions
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-overflow-btn',
	    extends: _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"],
	    props: {
	        segmented: Boolean,
	        editable: Boolean,
	        transition: _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].props.transition
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign(_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].computed.classes.call(this), {
	                'v-overflow-btn': true,
	                'v-overflow-btn--segmented': this.segmented,
	                'v-overflow-btn--editable': this.editable
	            });
	        },
	        isAnyValueAllowed: function isAnyValueAllowed() {
	            return this.editable || _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].computed.isAnyValueAllowed.call(this);
	        },
	        isSingle: function isSingle() {
	            return true;
	        },
	        computedItems: function computedItems() {
	            return this.segmented ? this.allItems : this.filteredItems;
	        },
	        $_menuProps: function $_menuProps() {
	            var props = _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].computed.$_menuProps.call(this);
	            props.transition = props.transition || 'v-menu-transition';
	            return props;
	        }
	    },
	    methods: {
	        genSelections: function genSelections() {
	            return this.editable ? _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"].methods.genSelections.call(this) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genSelections.call(this); // Override v-autocomplete's override
	        },
	        genCommaSelection: function genCommaSelection(item, index, last) {
	            return this.segmented ? this.genSegmentedBtn(item) : _VSelect_VSelect__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genCommaSelection.call(this, item, index, last);
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].methods.genInput.call(this);
	            input.data.domProps.value = this.editable ? this.internalSearch : '';
	            input.data.attrs.readonly = !this.isAnyValueAllowed;
	            return input;
	        },
	        genLabel: function genLabel() {
	            if (this.editable && this.isFocused) return null;
	            var label = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_3__["default"].methods.genLabel.call(this);
	            if (!label) return label;
	            // Reset previously set styles from parent
	            label.data.style = {};
	            return label;
	        },
	        genSegmentedBtn: function genSegmentedBtn(item) {
	            var _this = this;
	            var itemValue = this.getValue(item);
	            var itemObj = this.computedItems.find(function (i) {
	                return _this.getValue(i) === itemValue;
	            }) || item;
	            if (!itemObj.text || !itemObj.callback) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])('When using \'segmented\' prop without a selection slot, items must contain both a text and callback property', this);
	                return null;
	            }
	            return this.$createElement(_VBtn__WEBPACK_IMPORTED_MODULE_4__["default"], {
	                props: { flat: true },
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        itemObj.callback(e);
	                    }
	                }
	            }, [itemObj.text]);
	        },
	        setSelectedItems: function setSelectedItems() {
	            if (this.internalValue == null) {
	                this.selectedItems = [];
	            } else {
	                this.selectedItems = [this.internalValue];
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VOverflowBtn/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VOverflowBtn/index.js ***!
	  \**********************************************/
	/*! exports provided: VOverflowBtn, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VOverflowBtn */ "./src/components/VOverflowBtn/VOverflowBtn.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() { return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VOverflowBtn__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VPagination/VPagination.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VPagination/VPagination.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_pagination.styl */ "./src/stylus/components/_pagination.styl");
	/* harmony import */ var _stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_pagination_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	// Directives
	
	// Mixins
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]).extend({
	    name: 'v-pagination',
	    directives: { Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_2__["default"] },
	    props: {
	        circle: Boolean,
	        disabled: Boolean,
	        length: {
	            type: Number,
	            default: 0,
	            validator: function validator(val) {
	                return val % 1 === 0;
	            }
	        },
	        totalVisible: [Number, String],
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        value: {
	            type: Number,
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            maxButtons: 0,
	            selected: null
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-pagination': true, 'v-pagination--circle': this.circle, 'v-pagination--disabled': this.disabled }, this.themeClasses);
	        },
	        items: function items() {
	            var maxLength = parseInt(this.totalVisible, 10) || this.maxButtons;
	            if (this.length <= maxLength) {
	                return this.range(1, this.length);
	            }
	            var even = maxLength % 2 === 0 ? 1 : 0;
	            var left = Math.floor(maxLength / 2);
	            var right = this.length - left + 1 + even;
	            if (this.value > left && this.value < right) {
	                var start = this.value - left + 2;
	                var end = this.value + left - 2 - even;
	                return __spread([1, '...'], this.range(start, end), ['...', this.length]);
	            } else if (this.value === left) {
	                var end = this.value + left - 1 - even;
	                return __spread(this.range(1, end), ['...', this.length]);
	            } else if (this.value === right) {
	                var start = this.value - left + 1;
	                return __spread([1, '...'], this.range(start, this.length));
	            } else {
	                return __spread(this.range(1, left), ['...'], this.range(right, this.length));
	            }
	        }
	    },
	    watch: {
	        value: function value() {
	            this.init();
	        }
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            var _this = this;
	            this.selected = null;
	            this.$nextTick(this.onResize);
	            // TODO: Change this (f75dee3a, cbdf7caa)
	            setTimeout(function () {
	                return _this.selected = _this.value;
	            }, 100);
	        },
	        onResize: function onResize() {
	            var width = this.$el && this.$el.parentElement ? this.$el.parentElement.clientWidth : window.innerWidth;
	            this.maxButtons = Math.floor((width - 96) / 42);
	        },
	        next: function next(e) {
	            e.preventDefault();
	            this.$emit('input', this.value + 1);
	            this.$emit('next');
	        },
	        previous: function previous(e) {
	            e.preventDefault();
	            this.$emit('input', this.value - 1);
	            this.$emit('previous');
	        },
	        range: function range(from, to) {
	            var range = [];
	            from = from > 0 ? from : 1;
	            for (var i = from; i <= to; i++) {
	                range.push(i);
	            }
	            return range;
	        },
	        genIcon: function genIcon(h, icon, disabled, fn) {
	            return h('li', [h('button', {
	                staticClass: 'v-pagination__navigation',
	                class: {
	                    'v-pagination__navigation--disabled': disabled
	                },
	                attrs: {
	                    type: 'button'
	                },
	                on: disabled ? {} : { click: fn }
	            }, [h(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], [icon])])]);
	        },
	        genItem: function genItem(h, i) {
	            var _this = this;
	            var color = i === this.value && (this.color || 'primary');
	            return h('button', this.setBackgroundColor(color, {
	                staticClass: 'v-pagination__item',
	                class: {
	                    'v-pagination__item--active': i === this.value
	                },
	                attrs: {
	                    type: 'button'
	                },
	                on: {
	                    click: function click() {
	                        return _this.$emit('input', i);
	                    }
	                }
	            }), [i.toString()]);
	        },
	        genItems: function genItems(h) {
	            var _this = this;
	            return this.items.map(function (i, index) {
	                return h('li', { key: index }, [isNaN(Number(i)) ? h('span', { class: 'v-pagination__more' }, [i.toString()]) : _this.genItem(h, i)]);
	            });
	        }
	    },
	    render: function render(h) {
	        var children = [this.genIcon(h, this.$vuetify.rtl ? this.nextIcon : this.prevIcon, this.value <= 1, this.previous), this.genItems(h), this.genIcon(h, this.$vuetify.rtl ? this.prevIcon : this.nextIcon, this.value >= this.length, this.next)];
	        return h('ul', {
	            directives: [{
	                modifiers: { quiet: true },
	                name: 'resize',
	                value: this.onResize
	            }],
	            class: this.classes
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VPagination/index.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VPagination/index.ts ***!
	  \*********************************************/
	/*! exports provided: VPagination, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VPagination__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VPagination */ "./src/components/VPagination/VPagination.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return _VPagination__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VPagination__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VParallax/VParallax.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VParallax/VParallax.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_parallax.styl */ "./src/stylus/components/_parallax.styl");
	/* harmony import */ var _stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_parallax_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_translatable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/translatable */ "./src/mixins/translatable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Style
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_translatable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-parallax',
	    props: {
	        alt: String,
	        height: {
	            type: [String, Number],
	            default: 500
	        },
	        src: String
	    },
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    computed: {
	        styles: function styles() {
	            return {
	                display: 'block',
	                opacity: this.isBooted ? 1 : 0,
	                transform: "translate(-50%, " + this.parallax + "px)"
	            };
	        }
	    },
	    watch: {
	        parallax: function parallax() {
	            this.isBooted = true;
	        }
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        init: function init() {
	            var _this = this;
	            var img = this.$refs.img;
	            if (!img) return;
	            if (img.complete) {
	                this.translate();
	                this.listeners();
	            } else {
	                img.addEventListener('load', function () {
	                    _this.translate();
	                    _this.listeners();
	                }, false);
	            }
	        },
	        objHeight: function objHeight() {
	            return this.$refs.img.naturalHeight;
	        }
	    },
	    render: function render(h) {
	        var imgData = {
	            staticClass: 'v-parallax__image',
	            style: this.styles,
	            attrs: {
	                src: this.src
	            },
	            ref: 'img'
	        };
	        if (this.alt) imgData.attrs.alt = this.alt;
	        var container = h('div', {
	            staticClass: 'v-parallax__image-container'
	        }, [h('img', imgData)]);
	        var content = h('div', {
	            staticClass: 'v-parallax__content'
	        }, this.$slots.default);
	        return h('div', {
	            staticClass: 'v-parallax',
	            style: {
	                height: this.height + "px"
	            },
	            on: this.$listeners
	        }, [container, content]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VParallax/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VParallax/index.ts ***!
	  \*******************************************/
	/*! exports provided: VParallax, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VParallax__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VParallax */ "./src/components/VParallax/VParallax.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return _VParallax__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VParallax__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VPicker/VPicker.js":
	/*!*******************************************!*\
	  !*** ./src/components/VPicker/VPicker.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_pickers.styl */ "./src/stylus/components/_pickers.styl");
	/* harmony import */ var _stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_pickers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Mixins
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-picker',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        fullWidth: Boolean,
	        landscape: Boolean,
	        transition: {
	            type: String,
	            default: 'fade-transition'
	        },
	        width: {
	            type: [Number, String],
	            default: 290
	        }
	    },
	    computed: {
	        computedTitleColor: function computedTitleColor() {
	            var defaultTitleColor = this.isDark ? null : this.color || 'primary';
	            return this.color || defaultTitleColor;
	        }
	    },
	    methods: {
	        genTitle: function genTitle() {
	            return this.$createElement('div', this.setBackgroundColor(this.computedTitleColor, {
	                staticClass: 'v-picker__title',
	                'class': {
	                    'v-picker__title--landscape': this.landscape
	                }
	            }), this.$slots.title);
	        },
	        genBodyTransition: function genBodyTransition() {
	            return this.$createElement('transition', {
	                props: {
	                    name: this.transition
	                }
	            }, this.$slots.default);
	        },
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-picker__body',
	                'class': this.themeClasses,
	                style: this.fullWidth ? undefined : {
	                    width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.width)
	                }
	            }, [this.genBodyTransition()]);
	        },
	        genActions: function genActions() {
	            return this.$createElement('div', {
	                staticClass: 'v-picker__actions v-card__actions'
	            }, this.$slots.actions);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-picker v-card',
	            'class': __assign({ 'v-picker--landscape': this.landscape, 'v-picker--full-width': this.fullWidth }, this.themeClasses)
	        }, [this.$slots.title ? this.genTitle() : null, this.genBody(), this.$slots.actions ? this.genActions() : null]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VPicker/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VPicker/index.js ***!
	  \*****************************************/
	/*! exports provided: VPicker, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VPicker */ "./src/components/VPicker/VPicker.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return _VPicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VPicker__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VProgressCircular/VProgressCircular.ts":
	/*!***************************************************************!*\
	  !*** ./src/components/VProgressCircular/VProgressCircular.ts ***!
	  \***************************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_progress-circular.styl */ "./src/stylus/components/_progress-circular.styl");
	/* harmony import */ var _stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_progress_circular_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-progress-circular',
	    props: {
	        button: Boolean,
	        indeterminate: Boolean,
	        rotate: {
	            type: [Number, String],
	            default: 0
	        },
	        size: {
	            type: [Number, String],
	            default: 32
	        },
	        width: {
	            type: [Number, String],
	            default: 4
	        },
	        value: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    computed: {
	        calculatedSize: function calculatedSize() {
	            return Number(this.size) + (this.button ? 8 : 0);
	        },
	        circumference: function circumference() {
	            return 2 * Math.PI * this.radius;
	        },
	        classes: function classes() {
	            return {
	                'v-progress-circular--indeterminate': this.indeterminate,
	                'v-progress-circular--button': this.button
	            };
	        },
	        normalizedValue: function normalizedValue() {
	            if (this.value < 0) {
	                return 0;
	            }
	            if (this.value > 100) {
	                return 100;
	            }
	            return parseFloat(this.value);
	        },
	        radius: function radius() {
	            return 20;
	        },
	        strokeDashArray: function strokeDashArray() {
	            return Math.round(this.circumference * 1000) / 1000;
	        },
	        strokeDashOffset: function strokeDashOffset() {
	            return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
	        },
	        strokeWidth: function strokeWidth() {
	            return Number(this.width) / +this.size * this.viewBoxSize * 2;
	        },
	        styles: function styles() {
	            return {
	                height: this.calculatedSize + "px",
	                width: this.calculatedSize + "px"
	            };
	        },
	        svgStyles: function svgStyles() {
	            return {
	                transform: "rotate(" + Number(this.rotate) + "deg)"
	            };
	        },
	        viewBoxSize: function viewBoxSize() {
	            return this.radius / (1 - Number(this.width) / +this.size);
	        }
	    },
	    methods: {
	        genCircle: function genCircle(h, name, offset) {
	            return h('circle', {
	                class: "v-progress-circular__" + name,
	                attrs: {
	                    fill: 'transparent',
	                    cx: 2 * this.viewBoxSize,
	                    cy: 2 * this.viewBoxSize,
	                    r: this.radius,
	                    'stroke-width': this.strokeWidth,
	                    'stroke-dasharray': this.strokeDashArray,
	                    'stroke-dashoffset': offset
	                }
	            });
	        },
	        genSvg: function genSvg(h) {
	            var children = [this.indeterminate || this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];
	            return h('svg', {
	                style: this.svgStyles,
	                attrs: {
	                    xmlns: 'http://www.w3.org/2000/svg',
	                    viewBox: this.viewBoxSize + " " + this.viewBoxSize + " " + 2 * this.viewBoxSize + " " + 2 * this.viewBoxSize
	                }
	            }, children);
	        }
	    },
	    render: function render(h) {
	        var info = h('div', { staticClass: 'v-progress-circular__info' }, this.$slots.default);
	        var svg = this.genSvg(h);
	        return h('div', this.setTextColor(this.color, {
	            staticClass: 'v-progress-circular',
	            attrs: {
	                'role': 'progressbar',
	                'aria-valuemin': 0,
	                'aria-valuemax': 100,
	                'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
	            },
	            class: this.classes,
	            style: this.styles,
	            on: this.$listeners
	        }), [svg, info]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VProgressCircular/index.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VProgressCircular/index.ts ***!
	  \***************************************************/
	/*! exports provided: VProgressCircular, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VProgressCircular */ "./src/components/VProgressCircular/VProgressCircular.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return _VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VProgressCircular__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VProgressLinear/VProgressLinear.ts":
	/*!***********************************************************!*\
	  !*** ./src/components/VProgressLinear/VProgressLinear.ts ***!
	  \***********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_progress-linear.styl */ "./src/stylus/components/_progress-linear.styl");
	/* harmony import */ var _stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_progress_linear_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	
	// Mixins
	
	// Helpers
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_3__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-progress-linear',
	    props: {
	        active: {
	            type: Boolean,
	            default: true
	        },
	        backgroundColor: {
	            type: String,
	            default: null
	        },
	        backgroundOpacity: {
	            type: [Number, String],
	            default: null
	        },
	        bufferValue: {
	            type: [Number, String],
	            default: 100
	        },
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        height: {
	            type: [Number, String],
	            default: 7
	        },
	        indeterminate: Boolean,
	        query: Boolean,
	        value: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    computed: {
	        backgroundStyle: function backgroundStyle() {
	            var backgroundOpacity = this.backgroundOpacity == null ? this.backgroundColor ? 1 : 0.3 : parseFloat(this.backgroundOpacity);
	            return {
	                height: this.active ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height) : 0,
	                opacity: backgroundOpacity,
	                width: this.normalizedBufer + "%"
	            };
	        },
	        effectiveWidth: function effectiveWidth() {
	            if (!this.normalizedBufer) {
	                return 0;
	            }
	            return +this.normalizedValue * 100 / +this.normalizedBufer;
	        },
	        normalizedBufer: function normalizedBufer() {
	            if (this.bufferValue < 0) {
	                return 0;
	            }
	            if (this.bufferValue > 100) {
	                return 100;
	            }
	            return parseFloat(this.bufferValue);
	        },
	        normalizedValue: function normalizedValue() {
	            if (this.value < 0) {
	                return 0;
	            }
	            if (this.value > 100) {
	                return 100;
	            }
	            return parseFloat(this.value);
	        },
	        styles: function styles() {
	            var styles = {};
	            if (!this.active) {
	                styles.height = 0;
	            }
	            if (!this.indeterminate && parseFloat(this.normalizedBufer) !== 100) {
	                styles.width = this.normalizedBufer + "%";
	            }
	            return styles;
	        }
	    },
	    methods: {
	        genDeterminate: function genDeterminate(h) {
	            return h('div', this.setBackgroundColor(this.color, {
	                ref: 'front',
	                staticClass: "v-progress-linear__bar__determinate",
	                style: {
	                    width: this.effectiveWidth + "%"
	                }
	            }));
	        },
	        genBar: function genBar(h, name) {
	            var _a;
	            return h('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-progress-linear__bar__indeterminate',
	                class: (_a = {}, _a[name] = true, _a)
	            }));
	        },
	        genIndeterminate: function genIndeterminate(h) {
	            return h('div', {
	                ref: 'front',
	                staticClass: 'v-progress-linear__bar__indeterminate',
	                class: {
	                    'v-progress-linear__bar__indeterminate--active': this.active
	                }
	            }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
	        }
	    },
	    render: function render(h) {
	        var fade = h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VFadeTransition"], this.indeterminate ? [this.genIndeterminate(h)] : []);
	        var slide = h(_transitions__WEBPACK_IMPORTED_MODULE_4__["VSlideXTransition"], this.indeterminate ? [] : [this.genDeterminate(h)]);
	        var bar = h('div', {
	            staticClass: 'v-progress-linear__bar',
	            style: this.styles
	        }, [fade, slide]);
	        var background = h('div', this.setBackgroundColor(this.backgroundColor || this.color, {
	            staticClass: 'v-progress-linear__background',
	            style: this.backgroundStyle
	        }));
	        return h('div', {
	            staticClass: 'v-progress-linear',
	            attrs: {
	                'role': 'progressbar',
	                'aria-valuemin': 0,
	                'aria-valuemax': this.normalizedBufer,
	                'aria-valuenow': this.indeterminate ? undefined : this.normalizedValue
	            },
	            class: {
	                'v-progress-linear--query': this.query
	            },
	            style: {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height)
	            },
	            on: this.$listeners
	        }, [background, bar]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VProgressLinear/index.ts":
	/*!*************************************************!*\
	  !*** ./src/components/VProgressLinear/index.ts ***!
	  \*************************************************/
	/*! exports provided: VProgressLinear, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VProgressLinear */ "./src/components/VProgressLinear/VProgressLinear.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return _VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VProgressLinear__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/VRadio.js":
	/*!**********************************************!*\
	  !*** ./src/components/VRadioGroup/VRadio.js ***!
	  \**********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_radios.styl */ "./src/stylus/components/_radios.styl");
	/* harmony import */ var _stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_radios_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.js");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	// Styles
	
	// Components
	
	
	// Mixins
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-radio',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_4__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_7__["inject"])('radio', 'v-radio', 'v-radio-group'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    inheritAttrs: false,
	    props: {
	        color: {
	            type: String,
	            default: 'accent'
	        },
	        disabled: Boolean,
	        label: String,
	        onIcon: {
	            type: String,
	            default: '$vuetify.icons.radioOn'
	        },
	        offIcon: {
	            type: String,
	            default: '$vuetify.icons.radioOff'
	        },
	        readonly: Boolean,
	        value: null
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            isFocused: false,
	            parentError: false
	        };
	    },
	    computed: {
	        computedData: function computedData() {
	            return this.setTextColor(!this.parentError && this.isActive && this.color, {
	                staticClass: 'v-radio',
	                'class': __assign({ 'v-radio--is-disabled': this.isDisabled, 'v-radio--is-focused': this.isFocused }, this.themeClasses)
	            });
	        },
	        computedColor: function computedColor() {
	            return this.isActive ? this.color : this.radio.validationState || false;
	        },
	        computedIcon: function computedIcon() {
	            return this.isActive ? this.onIcon : this.offIcon;
	        },
	        hasState: function hasState() {
	            return this.isActive || !!this.radio.validationState;
	        },
	        isDisabled: function isDisabled() {
	            return this.disabled || !!this.radio.disabled;
	        },
	        isReadonly: function isReadonly() {
	            return this.readonly || !!this.radio.readonly;
	        }
	    },
	    mounted: function mounted() {
	        this.radio.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.radio.unregister(this);
	    },
	    methods: {
	        genInput: function genInput() {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i] = arguments[_i];
	            }
	            var _a;
	            // We can't actually use the mixin directly because
	            // it's made for standalone components, but its
	            // genInput method is exactly what we need
	            return (_a = _mixins_selectable__WEBPACK_IMPORTED_MODULE_6__["default"].methods.genInput).call.apply(_a, __spread([this], args));
	        },
	        genLabel: function genLabel() {
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                on: { click: this.onChange },
	                attrs: {
	                    for: this.id
	                },
	                props: {
	                    color: this.radio.validationState || false,
	                    dark: this.dark,
	                    focused: this.hasState,
	                    light: this.light
	                }
	            }, this.$slots.label || this.label);
	        },
	        genRadio: function genRadio() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('radio', __assign({ name: this.radio.name || (this.radio._uid ? 'v-radio-' + this.radio._uid : false), value: this.value }, this.$attrs)), this.genRipple(this.setTextColor(this.computedColor)), this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.computedColor, {
	                props: {
	                    dark: this.dark,
	                    light: this.light
	                }
	            }), this.computedIcon)]);
	        },
	        onFocus: function onFocus() {
	            this.isFocused = true;
	        },
	        onBlur: function onBlur(e) {
	            this.isFocused = false;
	            this.$emit('blur', e);
	        },
	        onChange: function onChange() {
	            if (this.isDisabled || this.isReadonly) return;
	            if (!this.isDisabled && (!this.isActive || !this.radio.mandatory)) {
	                this.$emit('change', this.value);
	            }
	        },
	        onKeydown: function onKeydown() {}
	    },
	    render: function render(h) {
	        return h('div', this.computedData, [this.genRadio(), this.genLabel()]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/VRadioGroup.js":
	/*!***************************************************!*\
	  !*** ./src/components/VRadioGroup/VRadioGroup.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_radio-group.styl */ "./src/stylus/components/_radio-group.styl");
	/* harmony import */ var _stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_radio_group_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.js");
	/* harmony import */ var _mixins_comparable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/comparable */ "./src/mixins/comparable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	// Styles
	
	
	// Components
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-radio-group',
	    extends: _VInput__WEBPACK_IMPORTED_MODULE_2__["default"],
	    mixins: [_mixins_comparable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_4__["provide"])('radio')],
	    model: {
	        prop: 'value',
	        event: 'change'
	    },
	    provide: function provide() {
	        return {
	            radio: this
	        };
	    },
	    props: {
	        column: {
	            type: Boolean,
	            default: true
	        },
	        height: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        name: String,
	        row: Boolean,
	        // If no value set on VRadio
	        // will match valueComparator
	        // force default to null
	        value: {
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            internalTabIndex: -1,
	            radios: []
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls v-input--radio-group': true,
	                'v-input--radio-group--column': this.column && !this.row,
	                'v-input--radio-group--row': this.row
	            };
	        }
	    },
	    watch: {
	        hasError: 'setErrorState',
	        internalValue: 'setActiveRadio'
	    },
	    mounted: function mounted() {
	        this.setErrorState(this.hasError);
	        this.setActiveRadio();
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--radio-group__input',
	                attrs: {
	                    role: 'radiogroup'
	                }
	            }, _VInput__WEBPACK_IMPORTED_MODULE_2__["default"].methods.genDefaultSlot.call(this));
	        },
	        onRadioChange: function onRadioChange(value) {
	            if (this.disabled) return;
	            this.hasInput = true;
	            this.internalValue = value;
	            this.setActiveRadio();
	            this.$nextTick(this.validate);
	        },
	        onRadioBlur: function onRadioBlur(e) {
	            if (!e.relatedTarget || !e.relatedTarget.classList.contains('v-radio')) {
	                this.hasInput = true;
	                this.$emit('blur', e);
	            }
	        },
	        register: function register(radio) {
	            radio.isActive = this.valueComparator(this.internalValue, radio.value);
	            radio.$on('change', this.onRadioChange);
	            radio.$on('blur', this.onRadioBlur);
	            this.radios.push(radio);
	        },
	        setErrorState: function setErrorState(val) {
	            for (var index = this.radios.length; --index >= 0;) {
	                this.radios[index].parentError = val;
	            }
	        },
	        setActiveRadio: function setActiveRadio() {
	            for (var index = this.radios.length; --index >= 0;) {
	                var radio = this.radios[index];
	                radio.isActive = this.valueComparator(this.internalValue, radio.value);
	            }
	        },
	        unregister: function unregister(radio) {
	            radio.$off('change', this.onRadioChange);
	            radio.$off('blur', this.onRadioBlur);
	            var index = this.radios.findIndex(function (r) {
	                return r === radio;
	            });
	            /* istanbul ignore else */
	            if (index > -1) this.radios.splice(index, 1);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRadioGroup/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/VRadioGroup/index.js ***!
	  \*********************************************/
	/*! exports provided: VRadioGroup, VRadio, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRadioGroup */ "./src/components/VRadioGroup/VRadioGroup.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VRadio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VRadio */ "./src/components/VRadioGroup/VRadio.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadio", function() { return _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VRadioGroup: _VRadioGroup__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VRadio: _VRadio__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRangeSlider/VRangeSlider.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VRangeSlider/VRangeSlider.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_range-sliders.styl */ "./src/stylus/components/_range-sliders.styl");
	/* harmony import */ var _stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_range_sliders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VSlider */ "./src/components/VSlider/index.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Styles
	
	// Extensions
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-range-slider',
	    extends: _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"],
	    props: {
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    data: function data(vm) {
	        return {
	            activeThumb: null,
	            lazyValue: !vm.value.length ? [0, 0] : vm.value
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return Object.assign({}, {
	                'v-input--range-slider': true
	            }, _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].computed.classes.call(this));
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                var _this = this;
	                var _a = this,
	                    min = _a.min,
	                    max = _a.max;
	                // Round value to ensure the
	                // entire slider range can
	                // be selected with step
	                var value = val.map(function (v) {
	                    return _this.roundValue(Math.min(Math.max(v, min), max));
	                });
	                // Switch values if range and wrong order
	                if (value[0] > value[1] || value[1] < value[0]) {
	                    if (this.activeThumb !== null) this.activeThumb = this.activeThumb === 1 ? 0 : 1;
	                    value = [value[1], value[0]];
	                }
	                this.lazyValue = value;
	                if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["deepEqual"])(value, this.value)) this.$emit('input', value);
	                this.validate();
	            }
	        },
	        inputWidth: function inputWidth() {
	            var _this = this;
	            return this.internalValue.map(function (v) {
	                return (_this.roundValue(v) - _this.min) / (_this.max - _this.min) * 100;
	            });
	        },
	        isDirty: function isDirty() {
	            var _this = this;
	            return this.internalValue.some(function (v) {
	                return v !== _this.min;
	            }) || this.alwaysDirty;
	        },
	        trackFillStyles: function trackFillStyles() {
	            var styles = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].computed.trackFillStyles.call(this);
	            var fillPercent = Math.abs(this.inputWidth[0] - this.inputWidth[1]);
	            styles.width = "calc(" + fillPercent + "% - " + this.trackPadding + "px)";
	            styles[this.$vuetify.rtl ? 'right' : 'left'] = this.inputWidth[0] + "%";
	            return styles;
	        },
	        trackPadding: function trackPadding() {
	            if (this.isDirty || this.internalValue[0]) return 0;
	            return _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].computed.trackPadding.call(this);
	        }
	    },
	    methods: {
	        getIndexOfClosestValue: function getIndexOfClosestValue(arr, v) {
	            if (Math.abs(arr[0] - v) < Math.abs(arr[1] - v)) return 0;else return 1;
	        },
	        genInput: function genInput() {
	            var _this = this;
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function (i) {
	                var input = _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genInput.call(_this);
	                input.data.attrs.value = _this.internalValue[i];
	                input.data.on.focus = function (e) {
	                    _this.activeThumb = i;
	                    _VSlider__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onFocus.call(_this, e);
	                };
	                return input;
	            });
	        },
	        genChildren: function genChildren() {
	            var _this = this;
	            return [this.genInput(), this.genTrackContainer(), this.genSteps(), Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["createRange"])(2).map(function (i) {
	                var value = _this.internalValue[i];
	                var onDrag = function onDrag(e) {
	                    _this.isActive = true;
	                    _this.activeThumb = i;
	                    _this.onThumbMouseDown(e);
	                };
	                var valueWidth = _this.inputWidth[i];
	                var isActive = (_this.isFocused || _this.isActive) && _this.activeThumb === i;
	                return _this.genThumbContainer(value, valueWidth, isActive, onDrag);
	            })];
	        },
	        onSliderClick: function onSliderClick(e) {
	            if (!this.isActive) {
	                this.isFocused = true;
	                this.onMouseMove(e, true);
	                this.$emit('change', this.internalValue);
	            }
	        },
	        onMouseMove: function onMouseMove(e, trackClick) {
	            if (trackClick === void 0) {
	                trackClick = false;
	            }
	            var _a = this.parseMouseMove(e),
	                value = _a.value,
	                isInsideTrack = _a.isInsideTrack;
	            if (isInsideTrack) {
	                if (trackClick) this.activeThumb = this.getIndexOfClosestValue(this.internalValue, value);
	                this.setInternalValue(value);
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            var value = this.parseKeyDown(e, this.internalValue[this.activeThumb]);
	            if (value == null) return;
	            this.setInternalValue(value);
	        },
	        setInternalValue: function setInternalValue(value) {
	            var _this = this;
	            this.internalValue = this.internalValue.map(function (v, i) {
	                if (i === _this.activeThumb) return value;else return Number(v);
	            });
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VRangeSlider/index.js":
	/*!**********************************************!*\
	  !*** ./src/components/VRangeSlider/index.js ***!
	  \**********************************************/
	/*! exports provided: VRangeSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRangeSlider */ "./src/components/VRangeSlider/VRangeSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() { return _VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VRangeSlider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VRating/VRating.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VRating/VRating.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_rating.styl */ "./src/stylus/components/_rating.styl");
	/* harmony import */ var _stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_rating_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/sizeable */ "./src/mixins/sizeable.ts");
	/* harmony import */ var _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Styles
	
	// Components
	
	// Mixins
	
	
	
	
	
	// Utilities
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_8__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_rippleable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_sizeable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]).extend({
	    name: 'v-rating',
	    props: {
	        backgroundColor: {
	            type: String,
	            default: 'accent'
	        },
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        dense: Boolean,
	        emptyIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingEmpty'
	        },
	        fullIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingFull'
	        },
	        halfIcon: {
	            type: String,
	            default: '$vuetify.icons.ratingHalf'
	        },
	        halfIncrements: Boolean,
	        length: {
	            type: [Number, String],
	            default: 5
	        },
	        clearable: Boolean,
	        readonly: Boolean,
	        hover: Boolean,
	        value: {
	            type: Number,
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            hoverIndex: -1,
	            internalValue: this.value
	        };
	    },
	    computed: {
	        directives: function directives() {
	            if (this.readonly || !this.ripple) return [];
	            return [{
	                name: 'ripple',
	                value: { circle: true }
	            }];
	        },
	        iconProps: function iconProps() {
	            var _a = this.$props,
	                dark = _a.dark,
	                medium = _a.medium,
	                large = _a.large,
	                light = _a.light,
	                small = _a.small,
	                size = _a.size,
	                xLarge = _a.xLarge;
	            return {
	                dark: dark,
	                medium: medium,
	                large: large,
	                light: light,
	                size: size,
	                small: small,
	                xLarge: xLarge
	            };
	        },
	        isHovering: function isHovering() {
	            return this.hover && this.hoverIndex >= 0;
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            val !== this.value && this.$emit('input', val);
	        },
	        value: function value(val) {
	            this.internalValue = val;
	        }
	    },
	    methods: {
	        createClickFn: function createClickFn(i) {
	            var _this = this;
	            return function (e) {
	                if (_this.readonly) return;
	                var newValue = _this.genHoverIndex(e, i);
	                if (_this.clearable && _this.internalValue === newValue) {
	                    _this.internalValue = 0;
	                } else {
	                    _this.internalValue = newValue;
	                }
	            };
	        },
	        createProps: function createProps(i) {
	            var props = {
	                index: i,
	                value: this.internalValue,
	                click: this.createClickFn(i),
	                isFilled: Math.floor(this.internalValue) > i,
	                isHovered: Math.floor(this.hoverIndex) > i
	            };
	            if (this.halfIncrements) {
	                props.isHalfHovered = !props.isHovered && (this.hoverIndex - i) % 1 > 0;
	                props.isHalfFilled = !props.isFilled && (this.internalValue - i) % 1 > 0;
	            }
	            return props;
	        },
	        genHoverIndex: function genHoverIndex(e, i) {
	            return i + (this.isHalfEvent(e) ? 0.5 : 1);
	        },
	        getIconName: function getIconName(props) {
	            var isFull = this.isHovering ? props.isHovered : props.isFilled;
	            var isHalf = this.isHovering ? props.isHalfHovered : props.isHalfFilled;
	            return isFull ? this.fullIcon : isHalf ? this.halfIcon : this.emptyIcon;
	        },
	        getColor: function getColor(props) {
	            if (this.isHovering) {
	                if (props.isHovered || props.isHalfHovered) return this.color;
	            } else {
	                if (props.isFilled || props.isHalfFilled) return this.color;
	            }
	            return this.backgroundColor;
	        },
	        isHalfEvent: function isHalfEvent(e) {
	            if (this.halfIncrements) {
	                var rect = e.target && e.target.getBoundingClientRect();
	                if (rect && e.pageX - rect.left < rect.width / 2) return true;
	            }
	            return false;
	        },
	        onMouseEnter: function onMouseEnter(e, i) {
	            var _this = this;
	            this.runDelay('open', function () {
	                _this.hoverIndex = _this.genHoverIndex(e, i);
	            });
	        },
	        onMouseLeave: function onMouseLeave() {
	            var _this = this;
	            this.runDelay('close', function () {
	                return _this.hoverIndex = -1;
	            });
	        },
	        genItem: function genItem(i) {
	            var _this = this;
	            var props = this.createProps(i);
	            if (this.$scopedSlots.item) return this.$scopedSlots.item(props);
	            var listeners = {
	                click: props.click
	            };
	            if (this.hover) {
	                listeners.mouseenter = function (e) {
	                    return _this.onMouseEnter(e, i);
	                };
	                listeners.mouseleave = this.onMouseLeave;
	                if (this.halfIncrements) {
	                    listeners.mousemove = function (e) {
	                        return _this.onMouseEnter(e, i);
	                    };
	                }
	            }
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.setTextColor(this.getColor(props), {
	                directives: this.directives,
	                props: this.iconProps,
	                on: listeners
	            }), [this.getIconName(props)]);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["createRange"])(Number(this.length)).map(function (i) {
	            return _this.genItem(i);
	        });
	        return h('div', {
	            staticClass: 'v-rating',
	            class: {
	                'v-rating--readonly': this.readonly,
	                'v-rating--dense': this.dense
	            }
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VRating/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VRating/index.ts ***!
	  \*****************************************/
	/*! exports provided: VRating, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VRating__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VRating */ "./src/components/VRating/VRating.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRating", function() { return _VRating__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VRating__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VResponsive/VResponsive.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VResponsive/VResponsive.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_responsive.styl */ "./src/stylus/components/_responsive.styl");
	/* harmony import */ var _stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_responsive_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_measurable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/measurable */ "./src/mixins/measurable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	
	// Mixins
	
	// Utils
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_2__["default"])(_mixins_measurable__WEBPACK_IMPORTED_MODULE_1__["default"]).extend({
	    name: 'v-responsive',
	    props: {
	        aspectRatio: [String, Number]
	    },
	    computed: {
	        computedAspectRatio: function computedAspectRatio() {
	            return Number(this.aspectRatio);
	        },
	        aspectStyle: function aspectStyle() {
	            return this.computedAspectRatio ? { paddingBottom: 1 / this.computedAspectRatio * 100 + '%' } : undefined;
	        },
	        __cachedSizer: function __cachedSizer() {
	            if (!this.aspectStyle) return [];
	            return this.$createElement('div', {
	                style: this.aspectStyle,
	                staticClass: 'v-responsive__sizer'
	            });
	        }
	    },
	    methods: {
	        genContent: function genContent() {
	            return this.$createElement('div', {
	                staticClass: 'v-responsive__content'
	            }, this.$slots.default);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-responsive',
	            style: {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.height),
	                maxHeight: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.maxHeight),
	                maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.maxWidth),
	                width: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(this.width)
	            },
	            on: this.$listeners
	        }, [this.__cachedSizer, this.genContent()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VResponsive/index.ts":
	/*!*********************************************!*\
	  !*** ./src/components/VResponsive/index.ts ***!
	  \*********************************************/
	/*! exports provided: VResponsive, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VResponsive */ "./src/components/VResponsive/VResponsive.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VResponsive", function() { return _VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VResponsive__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSelect/VSelect.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSelect/VSelect.js ***!
	  \*******************************************/
	/*! exports provided: defaultMenuProps, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuProps", function() { return defaultMenuProps; });
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_text-fields.styl */ "./src/stylus/components/_text-fields.styl");
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_select.styl */ "./src/stylus/components/_select.styl");
	/* harmony import */ var _stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_select_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VChip */ "./src/components/VChip/index.ts");
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VMenu */ "./src/components/VMenu/index.js");
	/* harmony import */ var _VSelectList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VSelectList */ "./src/components/VSelect/VSelectList.js");
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _mixins_comparable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/comparable */ "./src/mixins/comparable.ts");
	/* harmony import */ var _mixins_filterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/filterable */ "./src/mixins/filterable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	// Styles
	
	
	// Components
	
	
	
	// Extensions
	
	// Mixins
	
	
	// Directives
	
	// Helpers
	
	
	var defaultMenuProps = {
	    closeOnClick: false,
	    closeOnContentClick: false,
	    openOnClick: false,
	    maxHeight: 300
	};
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-select',
	    directives: {
	        ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_8__["default"]
	    },
	    extends: _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"],
	    mixins: [_mixins_comparable__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_filterable__WEBPACK_IMPORTED_MODULE_7__["default"]],
	    props: {
	        appendIcon: {
	            type: String,
	            default: '$vuetify.icons.dropdown'
	        },
	        appendIconCb: Function,
	        attach: {
	            type: null,
	            default: false
	        },
	        browserAutocomplete: {
	            type: String,
	            default: 'on'
	        },
	        cacheItems: Boolean,
	        chips: Boolean,
	        clearable: Boolean,
	        deletableChips: Boolean,
	        dense: Boolean,
	        hideSelected: Boolean,
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        itemAvatar: {
	            type: [String, Array, Function],
	            default: 'avatar'
	        },
	        itemDisabled: {
	            type: [String, Array, Function],
	            default: 'disabled'
	        },
	        itemText: {
	            type: [String, Array, Function],
	            default: 'text'
	        },
	        itemValue: {
	            type: [String, Array, Function],
	            default: 'value'
	        },
	        menuProps: {
	            type: [String, Array, Object],
	            default: function _default() {
	                return defaultMenuProps;
	            }
	        },
	        multiple: Boolean,
	        openOnClear: Boolean,
	        returnObject: Boolean,
	        searchInput: {
	            default: null
	        },
	        smallChips: Boolean
	    },
	    data: function data(vm) {
	        return {
	            attrsInput: { role: 'combobox' },
	            cachedItems: vm.cacheItems ? vm.items : [],
	            content: null,
	            isBooted: false,
	            isMenuActive: false,
	            lastItem: 20,
	            // As long as a value is defined, show it
	            // Otherwise, check if multiple
	            // to determine which default to provide
	            lazyValue: vm.value !== undefined ? vm.value : vm.multiple ? [] : undefined,
	            selectedIndex: -1,
	            selectedItems: []
	        };
	    },
	    computed: {
	        /* All items that the select has */
	        allItems: function allItems() {
	            return this.filterDuplicates(this.cachedItems.concat(this.items));
	        },
	        classes: function classes() {
	            return Object.assign({}, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].computed.classes.call(this), {
	                'v-select': true,
	                'v-select--chips': this.hasChips,
	                'v-select--chips--small': this.smallChips,
	                'v-select--is-menu-active': this.isMenuActive
	            });
	        },
	        /* Used by other components to overwrite */
	        computedItems: function computedItems() {
	            return this.allItems;
	        },
	        counterValue: function counterValue() {
	            return this.multiple ? this.selectedItems.length : (this.getText(this.selectedItems[0]) || '').toString().length;
	        },
	        directives: function directives() {
	            return this.isFocused ? [{
	                name: 'click-outside',
	                value: this.blur,
	                args: {
	                    closeConditional: this.closeConditional
	                }
	            }] : undefined;
	        },
	        dynamicHeight: function dynamicHeight() {
	            return 'auto';
	        },
	        hasChips: function hasChips() {
	            return this.chips || this.smallChips;
	        },
	        hasSlot: function hasSlot() {
	            return Boolean(this.hasChips || this.$scopedSlots.selection);
	        },
	        isDirty: function isDirty() {
	            return this.selectedItems.length > 0;
	        },
	        listData: function listData() {
	            var _a;
	            var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
	            return {
	                attrs: scopeId ? (_a = {}, _a[scopeId] = true, _a) : null,
	                props: {
	                    action: this.multiple && !this.isHidingSelected,
	                    color: this.color,
	                    dense: this.dense,
	                    hideSelected: this.hideSelected,
	                    items: this.virtualizedItems,
	                    noDataText: this.$vuetify.t(this.noDataText),
	                    selectedItems: this.selectedItems,
	                    itemAvatar: this.itemAvatar,
	                    itemDisabled: this.itemDisabled,
	                    itemValue: this.itemValue,
	                    itemText: this.itemText
	                },
	                on: {
	                    select: this.selectItem
	                },
	                scopedSlots: {
	                    item: this.$scopedSlots.item
	                }
	            };
	        },
	        staticList: function staticList() {
	            if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["consoleError"])('assert: staticList should not be called if slots are used');
	            }
	            return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], this.listData);
	        },
	        virtualizedItems: function virtualizedItems() {
	            return this.$_menuProps.auto ? this.computedItems : this.computedItems.slice(0, this.lastItem);
	        },
	        menuCanShow: function menuCanShow() {
	            return true;
	        },
	        $_menuProps: function $_menuProps() {
	            var normalisedProps;
	            normalisedProps = typeof this.menuProps === 'string' ? this.menuProps.split(',') : this.menuProps;
	            if (Array.isArray(normalisedProps)) {
	                normalisedProps = normalisedProps.reduce(function (acc, p) {
	                    acc[p.trim()] = true;
	                    return acc;
	                }, {});
	            }
	            return __assign({}, defaultMenuProps, { value: this.menuCanShow && this.isMenuActive, nudgeBottom: this.nudgeBottom ? this.nudgeBottom : normalisedProps.offsetY ? 1 : 0 }, normalisedProps);
	        }
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            this.initialValue = val;
	            this.setSelectedItems();
	        },
	        isBooted: function isBooted() {
	            var _this = this;
	            this.$nextTick(function () {
	                if (_this.content && _this.content.addEventListener) {
	                    _this.content.addEventListener('scroll', _this.onScroll, false);
	                }
	            });
	        },
	        isMenuActive: function isMenuActive(val) {
	            if (!val) return;
	            this.isBooted = true;
	        },
	        items: {
	            immediate: true,
	            handler: function handler(val) {
	                if (this.cacheItems) {
	                    this.cachedItems = this.filterDuplicates(this.cachedItems.concat(val));
	                }
	                this.setSelectedItems();
	            }
	        }
	    },
	    mounted: function mounted() {
	        this.content = this.$refs.menu && this.$refs.menu.$refs.content;
	    },
	    methods: {
	        /** @public */
	        blur: function blur(e) {
	            this.isMenuActive = false;
	            this.isFocused = false;
	            this.$refs.input && this.$refs.input.blur();
	            this.selectedIndex = -1;
	            this.onBlur(e);
	        },
	        /** @public */
	        activateMenu: function activateMenu() {
	            this.isMenuActive = true;
	        },
	        clearableCallback: function clearableCallback() {
	            var _this = this;
	            this.setValue(this.multiple ? [] : undefined);
	            this.$nextTick(function () {
	                return _this.$refs.input.focus();
	            });
	            if (this.openOnClear) this.isMenuActive = true;
	        },
	        closeConditional: function closeConditional(e) {
	            return (
	                // Click originates from outside the menu content
	                !!this.content && !this.content.contains(e.target) &&
	                // Click originates from outside the element
	                !!this.$el && !this.$el.contains(e.target) && e.target !== this.$el
	            );
	        },
	        filterDuplicates: function filterDuplicates(arr) {
	            var uniqueValues = new Map();
	            for (var index = 0; index < arr.length; ++index) {
	                var item = arr[index];
	                var val = this.getValue(item);
	                // TODO: comparator
	                !uniqueValues.has(val) && uniqueValues.set(val, item);
	            }
	            return Array.from(uniqueValues.values());
	        },
	        findExistingIndex: function findExistingIndex(item) {
	            var _this = this;
	            var itemValue = this.getValue(item);
	            return (this.internalValue || []).findIndex(function (i) {
	                return _this.valueComparator(_this.getValue(i), itemValue);
	            });
	        },
	        genChipSelection: function genChipSelection(item, index) {
	            var _this = this;
	            var isDisabled = this.disabled || this.readonly || this.getDisabled(item);
	            var focus = function focus(e, cb) {
	                if (isDisabled) return;
	                e.stopPropagation();
	                _this.onFocus();
	                cb && cb();
	            };
	            return this.$createElement(_VChip__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                staticClass: 'v-chip--select-multi',
	                props: {
	                    close: this.deletableChips && !isDisabled,
	                    disabled: isDisabled,
	                    selected: index === this.selectedIndex,
	                    small: this.smallChips
	                },
	                on: {
	                    click: function click(e) {
	                        focus(e, function () {
	                            _this.selectedIndex = index;
	                        });
	                    },
	                    focus: focus,
	                    input: function input() {
	                        return _this.onChipInput(item);
	                    }
	                },
	                key: this.getValue(item)
	            }, this.getText(item));
	        },
	        genCommaSelection: function genCommaSelection(item, index, last) {
	            // Item may be an object
	            // TODO: Remove JSON.stringify
	            var key = JSON.stringify(this.getValue(item));
	            var color = index === this.selectedIndex && this.color;
	            var isDisabled = this.disabled || this.getDisabled(item);
	            return this.$createElement('div', this.setTextColor(color, {
	                staticClass: 'v-select__selection v-select__selection--comma',
	                'class': {
	                    'v-select__selection--disabled': isDisabled
	                },
	                key: key
	            }), "" + this.getText(item) + (last ? '' : ', '));
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            var selections = this.genSelections();
	            var input = this.genInput();
	            // If the return is an empty array
	            // push the input
	            if (Array.isArray(selections)) {
	                selections.push(input);
	                // Otherwise push it into children
	            } else {
	                selections.children = selections.children || [];
	                selections.children.push(input);
	            }
	            return [this.$createElement('div', {
	                staticClass: 'v-select__slot',
	                directives: this.directives
	            }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, selections, this.suffix ? this.genAffix('suffix') : null, this.genClearIcon(), this.genIconSlot()]), this.genMenu(), this.genProgress()];
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].methods.genInput.call(this);
	            input.data.domProps.value = null;
	            input.data.attrs.readonly = true;
	            input.data.attrs['aria-readonly'] = String(this.readonly);
	            return input;
	        },
	        genList: function genList() {
	            // If there's no slots, we can use a cached VNode to improve performance
	            if (this.$slots['no-data'] || this.$slots['prepend-item'] || this.$slots['append-item']) {
	                return this.genListWithSlot();
	            } else {
	                return this.staticList;
	            }
	        },
	        genListWithSlot: function genListWithSlot() {
	            var _this = this;
	            var slots = ['prepend-item', 'no-data', 'append-item'].filter(function (slotName) {
	                return _this.$slots[slotName];
	            }).map(function (slotName) {
	                return _this.$createElement('template', {
	                    slot: slotName
	                }, _this.$slots[slotName]);
	            });
	            // Requires destructuring due to Vue
	            // modifying the `on` property when passed
	            // as a referenced object
	            return this.$createElement(_VSelectList__WEBPACK_IMPORTED_MODULE_4__["default"], __assign({}, this.listData), slots);
	        },
	        genMenu: function genMenu() {
	            var _this = this;
	            var e_1, _a;
	            var props = this.$_menuProps;
	            props.activator = this.$refs['input-slot'];
	            // Deprecate using menu props directly
	            // TODO: remove (2.0)
	            var inheritedProps = Object.keys(_VMenu__WEBPACK_IMPORTED_MODULE_3__["default"].options.props);
	            var deprecatedProps = Object.keys(this.$attrs).reduce(function (acc, attr) {
	                if (inheritedProps.includes(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(attr))) acc.push(attr);
	                return acc;
	            }, []);
	            try {
	                for (var deprecatedProps_1 = __values(deprecatedProps), deprecatedProps_1_1 = deprecatedProps_1.next(); !deprecatedProps_1_1.done; deprecatedProps_1_1 = deprecatedProps_1.next()) {
	                    var prop = deprecatedProps_1_1.value;
	                    props[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(prop)] = this.$attrs[prop];
	                }
	            } catch (e_1_1) {
	                e_1 = { error: e_1_1 };
	            } finally {
	                try {
	                    if (deprecatedProps_1_1 && !deprecatedProps_1_1.done && (_a = deprecatedProps_1.return)) _a.call(deprecatedProps_1);
	                } finally {
	                    if (e_1) throw e_1.error;
	                }
	            }
	            if (true) {
	                if (deprecatedProps.length) {
	                    var multiple = deprecatedProps.length > 1;
	                    var replacement_1 = deprecatedProps.reduce(function (acc, p) {
	                        acc[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["camelize"])(p)] = _this.$attrs[p];
	                        return acc;
	                    }, {});
	                    var props_1 = deprecatedProps.map(function (p) {
	                        return "'" + p + "'";
	                    }).join(', ');
	                    var separator = multiple ? '\n' : '\'';
	                    var onlyBools = Object.keys(replacement_1).every(function (prop) {
	                        var propType = _VMenu__WEBPACK_IMPORTED_MODULE_3__["default"].options.props[prop];
	                        var value = replacement_1[prop];
	                        return value === true || (propType.type || propType) === Boolean && value === '';
	                    });
	                    if (onlyBools) {
	                        replacement_1 = Object.keys(replacement_1).join(', ');
	                    } else {
	                        replacement_1 = JSON.stringify(replacement_1, null, multiple ? 2 : 0).replace(/"([^(")"]+)":/g, '$1:').replace(/"/g, '\'');
	                    }
	                    Object(_util_console__WEBPACK_IMPORTED_MODULE_10__["consoleWarn"])(props_1 + " " + (multiple ? 'are' : 'is') + " deprecated, use " + ("" + separator + (onlyBools ? '' : ':') + "menu-props=\"" + replacement_1 + "\"" + separator + " instead"), this);
	                }
	            }
	            // Attach to root el so that
	            // menu covers prepend/append icons
	            if (
	            // TODO: make this a computed property or helper or something
	            this.attach === '' || // If used as a boolean prop (<v-menu attach>)
	            this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
	            this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
	            ) {
	                    props.attach = this.$el;
	                } else {
	                props.attach = this.attach;
	            }
	            return this.$createElement(_VMenu__WEBPACK_IMPORTED_MODULE_3__["default"], {
	                props: props,
	                on: {
	                    input: function input(val) {
	                        _this.isMenuActive = val;
	                        _this.isFocused = val;
	                    }
	                },
	                ref: 'menu'
	            }, [this.genList()]);
	        },
	        genSelections: function genSelections() {
	            var length = this.selectedItems.length;
	            var children = new Array(length);
	            var genSelection;
	            if (this.$scopedSlots.selection) {
	                genSelection = this.genSlotSelection;
	            } else if (this.hasChips) {
	                genSelection = this.genChipSelection;
	            } else {
	                genSelection = this.genCommaSelection;
	            }
	            while (length--) {
	                children[length] = genSelection(this.selectedItems[length], length, length === children.length - 1);
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-select__selections'
	            }, children);
	        },
	        genSlotSelection: function genSlotSelection(item, index) {
	            return this.$scopedSlots.selection({
	                parent: this,
	                item: item,
	                index: index,
	                selected: index === this.selectedIndex,
	                disabled: this.disabled || this.readonly
	            });
	        },
	        getMenuIndex: function getMenuIndex() {
	            return this.$refs.menu ? this.$refs.menu.listIndex : -1;
	        },
	        getDisabled: function getDisabled(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemDisabled, false);
	        },
	        getText: function getText(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemText, item);
	        },
	        getValue: function getValue(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_9__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
	        },
	        onBlur: function onBlur(e) {
	            this.$emit('blur', e);
	        },
	        onChipInput: function onChipInput(item) {
	            if (this.multiple) this.selectItem(item);else this.setValue(null);
	            // If all items have been deleted,
	            // open `v-menu`
	            if (this.selectedItems.length === 0) {
	                this.isMenuActive = true;
	            }
	            this.selectedIndex = -1;
	        },
	        onClick: function onClick() {
	            if (this.isDisabled) return;
	            this.isMenuActive = true;
	            if (!this.isFocused) {
	                this.isFocused = true;
	                this.$emit('focus');
	            }
	        },
	        onEnterDown: function onEnterDown() {
	            this.onBlur();
	        },
	        onEscDown: function onEscDown(e) {
	            e.preventDefault();
	            if (this.isMenuActive) {
	                e.stopPropagation();
	                this.isMenuActive = false;
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            var keyCode = e.keyCode;
	            // If enter, space, up, or down is pressed, open menu
	            if (!this.readonly && !this.isMenuActive && [_util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].enter, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].space, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].down].includes(keyCode)) this.activateMenu();
	            if (this.isMenuActive && this.$refs.menu) this.$refs.menu.changeListIndex(e);
	            // This should do something different
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].enter) return this.onEnterDown(e);
	            // If escape deactivate the menu
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].esc) return this.onEscDown(e);
	            // If tab - select item or close menu
	            if (keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_9__["keyCodes"].tab) return this.onTabDown(e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            var _this = this;
	            if (this.hasMouseDown) {
	                var appendInner = this.$refs['append-inner'];
	                // If append inner is present
	                // and the target is itself
	                // or inside, toggle menu
	                if (this.isMenuActive && appendInner && (appendInner === e.target || appendInner.contains(e.target))) {
	                    this.$nextTick(function () {
	                        return _this.isMenuActive = !_this.isMenuActive;
	                    });
	                    // If user is clicking in the container
	                    // and field is enclosed, activate it
	                } else if (this.isEnclosed && !this.isDisabled) {
	                    this.isMenuActive = true;
	                }
	            }
	            _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_5__["default"].methods.onMouseUp.call(this, e);
	        },
	        onScroll: function onScroll() {
	            var _this = this;
	            if (!this.isMenuActive) {
	                requestAnimationFrame(function () {
	                    return _this.content.scrollTop = 0;
	                });
	            } else {
	                if (this.lastItem >= this.computedItems.length) return;
	                var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;
	                if (showMoreItems) {
	                    this.lastItem += 20;
	                }
	            }
	        },
	        onTabDown: function onTabDown(e) {
	            var menuIndex = this.getMenuIndex();
	            var listTile = this.$refs.menu.tiles[menuIndex];
	            // An item that is selected by
	            // menu-index should toggled
	            if (listTile && listTile.className.indexOf('v-list__tile--highlighted') > -1 && this.isMenuActive && menuIndex > -1) {
	                e.preventDefault();
	                e.stopPropagation();
	                listTile.click();
	            } else {
	                // If we make it here,
	                // the user has no selected indexes
	                // and is probably tabbing out
	                this.blur(e);
	            }
	        },
	        selectItem: function selectItem(item) {
	            var _this = this;
	            if (!this.multiple) {
	                this.setValue(this.returnObject ? item : this.getValue(item));
	                this.isMenuActive = false;
	            } else {
	                var internalValue = (this.internalValue || []).slice();
	                var i = this.findExistingIndex(item);
	                i !== -1 ? internalValue.splice(i, 1) : internalValue.push(item);
	                this.setValue(internalValue.map(function (i) {
	                    return _this.returnObject ? i : _this.getValue(i);
	                }));
	                // When selecting multiple
	                // adjust menu after each
	                // selection
	                this.$nextTick(function () {
	                    _this.$refs.menu && _this.$refs.menu.updateDimensions();
	                });
	            }
	        },
	        setMenuIndex: function setMenuIndex(index) {
	            this.$refs.menu && (this.$refs.menu.listIndex = index);
	        },
	        setSelectedItems: function setSelectedItems() {
	            var _this = this;
	            var e_2, _a;
	            var selectedItems = [];
	            var values = !this.multiple || !Array.isArray(this.internalValue) ? [this.internalValue] : this.internalValue;
	            var _loop_1 = function _loop_1(value) {
	                var index = this_1.allItems.findIndex(function (v) {
	                    return _this.valueComparator(_this.getValue(v), _this.getValue(value));
	                });
	                if (index > -1) {
	                    selectedItems.push(this_1.allItems[index]);
	                }
	            };
	            var this_1 = this;
	            try {
	                for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
	                    var value = values_1_1.value;
	                    _loop_1(value);
	                }
	            } catch (e_2_1) {
	                e_2 = { error: e_2_1 };
	            } finally {
	                try {
	                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
	                } finally {
	                    if (e_2) throw e_2.error;
	                }
	            }
	            this.selectedItems = selectedItems;
	        },
	        setValue: function setValue(value) {
	            this.internalValue = value;
	            this.$emit('change', value);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSelect/VSelectList.js":
	/*!***********************************************!*\
	  !*** ./src/components/VSelect/VSelectList.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_cards.styl */ "./src/stylus/components/_cards.styl");
	/* harmony import */ var _stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_cards_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VDivider */ "./src/components/VDivider/index.ts");
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VSubheader */ "./src/components/VSubheader/index.js");
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VList */ "./src/components/VList/index.js");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	
	// Components
	
	
	
	
	// Mixins
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-select-list',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        action: Boolean,
	        dense: Boolean,
	        hideSelected: Boolean,
	        items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        itemAvatar: {
	            type: [String, Array, Function],
	            default: 'avatar'
	        },
	        itemDisabled: {
	            type: [String, Array, Function],
	            default: 'disabled'
	        },
	        itemText: {
	            type: [String, Array, Function],
	            default: 'text'
	        },
	        itemValue: {
	            type: [String, Array, Function],
	            default: 'value'
	        },
	        noDataText: String,
	        noFilter: Boolean,
	        searchInput: {
	            default: null
	        },
	        selectedItems: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }
	    },
	    computed: {
	        parsedItems: function parsedItems() {
	            var _this = this;
	            return this.selectedItems.map(function (item) {
	                return _this.getValue(item);
	            });
	        },
	        tileActiveClass: function tileActiveClass() {
	            return Object.keys(this.setTextColor(this.color).class || {}).join(' ');
	        },
	        staticNoDataTile: function staticNoDataTile() {
	            var tile = {
	                on: {
	                    mousedown: function mousedown(e) {
	                        return e.preventDefault();
	                    } // Prevent onBlur from being called
	                }
	            };
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, [this.genTileContent(this.noDataText)]);
	        }
	    },
	    methods: {
	        genAction: function genAction(item, inputValue) {
	            var _this = this;
	            var data = {
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        _this.$emit('select', item);
	                    }
	                }
	            };
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileAction"], data, [this.$createElement(_VCheckbox__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.color,
	                    inputValue: inputValue
	                }
	            })]);
	        },
	        genDivider: function genDivider(props) {
	            return this.$createElement(_VDivider__WEBPACK_IMPORTED_MODULE_2__["default"], { props: props });
	        },
	        genFilteredText: function genFilteredText(text) {
	            text = (text || '').toString();
	            if (!this.searchInput || this.noFilter) return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(text);
	            var _a = this.getMaskedCharacters(text),
	                start = _a.start,
	                middle = _a.middle,
	                end = _a.end;
	            return "" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(start) + this.genHighlight(middle) + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(end);
	        },
	        genHeader: function genHeader(props) {
	            return this.$createElement(_VSubheader__WEBPACK_IMPORTED_MODULE_3__["default"], { props: props }, props.header);
	        },
	        genHighlight: function genHighlight(text) {
	            return "<span class=\"v-list__tile__mask\">" + Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["escapeHTML"])(text) + "</span>";
	        },
	        getMaskedCharacters: function getMaskedCharacters(text) {
	            var searchInput = (this.searchInput || '').toString().toLowerCase();
	            var index = text.toLowerCase().indexOf(searchInput);
	            if (index < 0) return { start: '', middle: text, end: '' };
	            var start = text.slice(0, index);
	            var middle = text.slice(index, index + searchInput.length);
	            var end = text.slice(index + searchInput.length);
	            return { start: start, middle: middle, end: end };
	        },
	        genTile: function genTile(item, disabled, avatar, value) {
	            var _this = this;
	            if (disabled === void 0) {
	                disabled = null;
	            }
	            if (avatar === void 0) {
	                avatar = false;
	            }
	            if (value === void 0) {
	                value = this.hasItem(item);
	            }
	            if (item === Object(item)) {
	                avatar = this.getAvatar(item);
	                disabled = disabled !== null ? disabled : this.getDisabled(item);
	            }
	            var tile = {
	                on: {
	                    mousedown: function mousedown(e) {
	                        // Prevent onBlur from being called
	                        e.preventDefault();
	                    },
	                    click: function click() {
	                        return disabled || _this.$emit('select', item);
	                    }
	                },
	                props: {
	                    activeClass: this.tileActiveClass,
	                    avatar: avatar,
	                    disabled: disabled,
	                    ripple: true,
	                    value: value
	                }
	            };
	            if (!this.$scopedSlots.item) {
	                return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, [this.action && !this.hideSelected && this.items.length > 0 ? this.genAction(item, value) : null, this.genTileContent(item)]);
	            }
	            var parent = this;
	            var scopedSlot = this.$scopedSlots.item({ parent: parent, item: item, tile: tile });
	            return this.needsTile(scopedSlot) ? this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTile"], tile, [scopedSlot]) : scopedSlot;
	        },
	        genTileContent: function genTileContent(item) {
	            var innerHTML = this.genFilteredText(this.getText(item));
	            return this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileContent"], [this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VListTileTitle"], {
	                domProps: { innerHTML: innerHTML }
	            })]);
	        },
	        hasItem: function hasItem(item) {
	            return this.parsedItems.indexOf(this.getValue(item)) > -1;
	        },
	        needsTile: function needsTile(tile) {
	            return tile.componentOptions == null || tile.componentOptions.Ctor.options.name !== 'v-list-tile';
	        },
	        getAvatar: function getAvatar(item) {
	            return Boolean(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemAvatar, false));
	        },
	        getDisabled: function getDisabled(item) {
	            return Boolean(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemDisabled, false));
	        },
	        getText: function getText(item) {
	            return String(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemText, item));
	        },
	        getValue: function getValue(item) {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["getPropertyFromItem"])(item, this.itemValue, this.getText(item));
	        }
	    },
	    render: function render() {
	        var e_1, _a;
	        var children = [];
	        try {
	            for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var item = _c.value;
	                if (this.hideSelected && this.hasItem(item)) continue;
	                if (item == null) children.push(this.genTile(item));else if (item.header) children.push(this.genHeader(item));else if (item.divider) children.push(this.genDivider(item));else children.push(this.genTile(item));
	            }
	        } catch (e_1_1) {
	            e_1 = { error: e_1_1 };
	        } finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            } finally {
	                if (e_1) throw e_1.error;
	            }
	        }
	        children.length || children.push(this.$slots['no-data'] || this.staticNoDataTile);
	        this.$slots['prepend-item'] && children.unshift(this.$slots['prepend-item']);
	        this.$slots['append-item'] && children.push(this.$slots['append-item']);
	        return this.$createElement('div', {
	            staticClass: 'v-select-list v-card',
	            'class': this.themeClasses
	        }, [this.$createElement(_VList__WEBPACK_IMPORTED_MODULE_4__["VList"], {
	            props: {
	                dense: this.dense
	            }
	        }, children)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSelect/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSelect/index.js ***!
	  \*****************************************/
	/*! exports provided: VSelect, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return wrapper; });
	/* harmony import */ var _VSelect__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSelect */ "./src/components/VSelect/VSelect.js");
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VOverflowBtn */ "./src/components/VOverflowBtn/index.js");
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VCombobox */ "./src/components/VCombobox/index.js");
	/* harmony import */ var _util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/rebuildFunctionalSlots */ "./src/util/rebuildFunctionalSlots.js");
	/* harmony import */ var _util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/dedupeModelListeners */ "./src/util/dedupeModelListeners.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	
	
	/* @vue/component */
	var wrapper = {
	    functional: true,
	    $_wrapperFor: _VSelect__WEBPACK_IMPORTED_MODULE_0__["default"],
	    props: {
	        // VAutoComplete
	        /** @deprecated */
	        autocomplete: Boolean,
	        /** @deprecated */
	        combobox: Boolean,
	        multiple: Boolean,
	        /** @deprecated */
	        tags: Boolean,
	        // VOverflowBtn
	        /** @deprecated */
	        editable: Boolean,
	        /** @deprecated */
	        overflow: Boolean,
	        /** @deprecated */
	        segmented: Boolean
	    },
	    render: function render(h, _a) {
	        var props = _a.props,
	            data = _a.data,
	            slots = _a.slots,
	            parent = _a.parent;
	        Object(_util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_5__["default"])(data);
	        var children = Object(_util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_4__["default"])(slots(), h);
	        if (props.autocomplete) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select autocomplete>', '<v-autocomplete>', wrapper, parent);
	        }
	        if (props.combobox) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select combobox>', '<v-combobox>', wrapper, parent);
	        }
	        if (props.tags) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select tags>', '<v-combobox multiple>', wrapper, parent);
	        }
	        if (props.overflow) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select overflow>', '<v-overflow-btn>', wrapper, parent);
	        }
	        if (props.segmented) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select segmented>', '<v-overflow-btn segmented>', wrapper, parent);
	        }
	        if (props.editable) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('<v-select editable>', '<v-overflow-btn editable>', wrapper, parent);
	        }
	        if (props.combobox || props.tags) {
	            data.attrs.multiple = props.tags;
	            return h(_VCombobox__WEBPACK_IMPORTED_MODULE_3__["default"], data, children);
	        } else if (props.autocomplete) {
	            data.attrs.multiple = props.multiple;
	            return h(_VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["default"], data, children);
	        } else if (props.overflow || props.segmented || props.editable) {
	            data.attrs.segmented = props.segmented;
	            data.attrs.editable = props.editable;
	            return h(_VOverflowBtn__WEBPACK_IMPORTED_MODULE_1__["default"], data, children);
	        } else {
	            data.attrs.multiple = props.multiple;
	            return h(_VSelect__WEBPACK_IMPORTED_MODULE_0__["default"], data, children);
	        }
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (wrapper);
	
	/***/ }),
	
	/***/ "./src/components/VSlider/VSlider.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSlider/VSlider.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_sliders.styl */ "./src/stylus/components/_sliders.styl");
	/* harmony import */ var _stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_sliders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.js");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/loadable */ "./src/mixins/loadable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Components
	
	// Extensions
	
	// Directives
	
	// Utilities
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-slider',
	    directives: { ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    extends: _VInput__WEBPACK_IMPORTED_MODULE_2__["default"],
	    mixins: [_mixins_loadable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        alwaysDirty: Boolean,
	        inverseLabel: Boolean,
	        label: String,
	        min: {
	            type: [Number, String],
	            default: 0
	        },
	        max: {
	            type: [Number, String],
	            default: 100
	        },
	        range: Boolean,
	        step: {
	            type: [Number, String],
	            default: 1
	        },
	        ticks: {
	            type: [Boolean, String],
	            default: false,
	            validator: function validator(v) {
	                return typeof v === 'boolean' || v === 'always';
	            }
	        },
	        tickLabels: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        tickSize: {
	            type: [Number, String],
	            default: 1
	        },
	        thumbColor: {
	            type: String,
	            default: null
	        },
	        thumbLabel: {
	            type: [Boolean, String],
	            default: null,
	            validator: function validator(v) {
	                return typeof v === 'boolean' || v === 'always';
	            }
	        },
	        thumbSize: {
	            type: [Number, String],
	            default: 32
	        },
	        trackColor: {
	            type: String,
	            default: null
	        },
	        value: [Number, String]
	    },
	    data: function data(vm) {
	        return {
	            app: {},
	            isActive: false,
	            keyPressed: 0,
	            lazyValue: typeof vm.value !== 'undefined' ? vm.value : Number(vm.min),
	            oldValue: null
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--slider': true,
	                'v-input--slider--ticks': this.showTicks,
	                'v-input--slider--inverse-label': this.inverseLabel,
	                'v-input--slider--ticks-labels': this.tickLabels.length > 0,
	                'v-input--slider--thumb-label': this.thumbLabel || this.$scopedSlots.thumbLabel
	            };
	        },
	        showTicks: function showTicks() {
	            return this.tickLabels.length > 0 || !this.disabled && this.stepNumeric && !!this.ticks;
	        },
	        showThumbLabel: function showThumbLabel() {
	            return !this.disabled && (!!this.thumbLabel || this.thumbLabel === '' || this.$scopedSlots['thumb-label']);
	        },
	        computedColor: function computedColor() {
	            if (this.disabled) return null;
	            return this.validationState || this.color || 'primary';
	        },
	        computedTrackColor: function computedTrackColor() {
	            return this.disabled ? null : this.trackColor || null;
	        },
	        computedThumbColor: function computedThumbColor() {
	            if (this.disabled || !this.isDirty) return null;
	            return this.validationState || this.thumbColor || this.color || 'primary';
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                var _a = this,
	                    min = _a.min,
	                    max = _a.max;
	                // Round value to ensure the
	                // entire slider range can
	                // be selected with step
	                var value = this.roundValue(Math.min(Math.max(val, min), max));
	                if (value === this.lazyValue) return;
	                this.lazyValue = value;
	                this.$emit('input', value);
	                this.validate();
	            }
	        },
	        stepNumeric: function stepNumeric() {
	            return this.step > 0 ? parseFloat(this.step) : 0;
	        },
	        trackFillStyles: function trackFillStyles() {
	            var left = this.$vuetify.rtl ? 'auto' : 0;
	            var right = this.$vuetify.rtl ? 0 : 'auto';
	            var width = this.inputWidth + "%";
	            if (this.disabled) width = "calc(" + this.inputWidth + "% - 8px)";
	            return {
	                transition: this.trackTransition,
	                left: left,
	                right: right,
	                width: width
	            };
	        },
	        trackPadding: function trackPadding() {
	            return this.isActive || this.inputWidth > 0 || this.disabled ? 0 : 7;
	        },
	        trackStyles: function trackStyles() {
	            var trackPadding = this.disabled ? "calc(" + this.inputWidth + "% + 8px)" : this.trackPadding + "px";
	            var left = this.$vuetify.rtl ? 'auto' : trackPadding;
	            var right = this.$vuetify.rtl ? trackPadding : 'auto';
	            var width = this.disabled ? "calc(" + (100 - this.inputWidth) + "% - 8px)" : '100%';
	            return {
	                transition: this.trackTransition,
	                left: left,
	                right: right,
	                width: width
	            };
	        },
	        tickStyles: function tickStyles() {
	            var size = Number(this.tickSize);
	            return {
	                'border-width': size + "px",
	                'border-radius': size > 1 ? '50%' : null,
	                transform: size > 1 ? "translateX(-" + size + "px) translateY(-" + (size - 1) + "px)" : null
	            };
	        },
	        trackTransition: function trackTransition() {
	            return this.keyPressed >= 2 ? 'none' : '';
	        },
	        numTicks: function numTicks() {
	            return Math.ceil((this.max - this.min) / this.stepNumeric);
	        },
	        inputWidth: function inputWidth() {
	            return (this.roundValue(this.internalValue) - this.min) / (this.max - this.min) * 100;
	        },
	        isDirty: function isDirty() {
	            return this.internalValue > this.min || this.alwaysDirty;
	        }
	    },
	    watch: {
	        min: function min(val) {
	            val > this.internalValue && this.$emit('input', parseFloat(val));
	        },
	        max: function max(val) {
	            val < this.internalValue && this.$emit('input', parseFloat(val));
	        },
	        value: function value(val) {
	            this.internalValue = val;
	        }
	    },
	    mounted: function mounted() {
	        // Without a v-app, iOS does not work with body selectors
	        this.app = document.querySelector('[data-app]') || Object(_util_console__WEBPACK_IMPORTED_MODULE_5__["consoleWarn"])('Missing v-app or a non-body wrapping element with the [data-app] attribute', this);
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            var children = [this.genLabel()];
	            var slider = this.genSlider();
	            this.inverseLabel ? children.unshift(slider) : children.push(slider);
	            children.push(this.genProgress());
	            return children;
	        },
	        genListeners: function genListeners() {
	            return {
	                blur: this.onBlur,
	                click: this.onSliderClick,
	                focus: this.onFocus,
	                keydown: this.onKeyDown,
	                keyup: this.onKeyUp
	            };
	        },
	        genInput: function genInput() {
	            return this.$createElement('input', {
	                attrs: __assign({ 'aria-label': this.label, name: this.name, role: 'slider', tabindex: this.disabled ? -1 : this.$attrs.tabindex, value: this.internalValue, readonly: true, 'aria-readonly': String(this.readonly), 'aria-valuemin': this.min, 'aria-valuemax': this.max, 'aria-valuenow': this.internalValue }, this.$attrs),
	                on: this.genListeners(),
	                ref: 'input'
	            });
	        },
	        genSlider: function genSlider() {
	            return this.$createElement('div', {
	                staticClass: 'v-slider',
	                'class': {
	                    'v-slider--is-active': this.isActive
	                },
	                directives: [{
	                    name: 'click-outside',
	                    value: this.onBlur
	                }]
	            }, this.genChildren());
	        },
	        genChildren: function genChildren() {
	            return [this.genInput(), this.genTrackContainer(), this.genSteps(), this.genThumbContainer(this.internalValue, this.inputWidth, this.isFocused || this.isActive, this.onThumbMouseDown)];
	        },
	        genSteps: function genSteps() {
	            var _this = this;
	            if (!this.step || !this.showTicks) return null;
	            var ticks = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["createRange"])(this.numTicks + 1).map(function (i) {
	                var children = [];
	                if (_this.tickLabels[i]) {
	                    children.push(_this.$createElement('span', _this.tickLabels[i]));
	                }
	                return _this.$createElement('span', {
	                    key: i,
	                    staticClass: 'v-slider__ticks',
	                    class: {
	                        'v-slider__ticks--always-show': _this.ticks === 'always' || _this.tickLabels.length > 0
	                    },
	                    style: __assign({}, _this.tickStyles, { left: i * (100 / _this.numTicks) + "%" })
	                }, children);
	            });
	            return this.$createElement('div', {
	                staticClass: 'v-slider__ticks-container'
	            }, ticks);
	        },
	        genThumb: function genThumb() {
	            return this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb'
	            }));
	        },
	        genThumbContainer: function genThumbContainer(value, valueWidth, isActive, onDrag) {
	            var children = [this.genThumb()];
	            var thumbLabelContent = this.getLabel(value);
	            this.showThumbLabel && children.push(this.genThumbLabel(thumbLabelContent));
	            return this.$createElement('div', this.setTextColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb-container',
	                'class': {
	                    'v-slider__thumb-container--is-active': isActive,
	                    'v-slider__thumb-container--show-label': this.showThumbLabel
	                },
	                style: {
	                    transition: this.trackTransition,
	                    left: (this.$vuetify.rtl ? 100 - valueWidth : valueWidth) + "%"
	                },
	                on: {
	                    touchstart: onDrag,
	                    mousedown: onDrag
	                }
	            }), children);
	        },
	        genThumbLabel: function genThumbLabel(content) {
	            var size = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["convertToUnit"])(this.thumbSize);
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_1__["VScaleTransition"], {
	                props: { origin: 'bottom center' }
	            }, [this.$createElement('div', {
	                staticClass: 'v-slider__thumb-label__container',
	                directives: [{
	                    name: 'show',
	                    value: this.isFocused || this.isActive || this.thumbLabel === 'always'
	                }]
	            }, [this.$createElement('div', this.setBackgroundColor(this.computedThumbColor, {
	                staticClass: 'v-slider__thumb-label',
	                style: {
	                    height: size,
	                    width: size
	                }
	            }), [content])])]);
	        },
	        genTrackContainer: function genTrackContainer() {
	            var children = [this.$createElement('div', this.setBackgroundColor(this.computedTrackColor, {
	                staticClass: 'v-slider__track',
	                style: this.trackStyles
	            })), this.$createElement('div', this.setBackgroundColor(this.computedColor, {
	                staticClass: 'v-slider__track-fill',
	                style: this.trackFillStyles
	            }))];
	            return this.$createElement('div', {
	                staticClass: 'v-slider__track__container',
	                ref: 'track'
	            }, children);
	        },
	        getLabel: function getLabel(value) {
	            return this.$scopedSlots['thumb-label'] ? this.$scopedSlots['thumb-label']({ value: value }) : this.$createElement('span', value);
	        },
	        onBlur: function onBlur(e) {
	            if (this.keyPressed === 2) return;
	            this.isActive = false;
	            this.isFocused = false;
	            this.$emit('blur', e);
	        },
	        onFocus: function onFocus(e) {
	            this.isFocused = true;
	            this.$emit('focus', e);
	        },
	        onThumbMouseDown: function onThumbMouseDown(e) {
	            this.oldValue = this.internalValue;
	            this.keyPressed = 2;
	            var options = { passive: true };
	            this.isActive = true;
	            this.isFocused = false;
	            if ('touches' in e) {
	                this.app.addEventListener('touchmove', this.onMouseMove, options);
	                Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["addOnceEventListener"])(this.app, 'touchend', this.onSliderMouseUp);
	            } else {
	                this.app.addEventListener('mousemove', this.onMouseMove, options);
	                Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["addOnceEventListener"])(this.app, 'mouseup', this.onSliderMouseUp);
	            }
	            this.$emit('start', this.internalValue);
	        },
	        onSliderMouseUp: function onSliderMouseUp() {
	            this.keyPressed = 0;
	            var options = { passive: true };
	            this.isActive = false;
	            this.isFocused = false;
	            this.app.removeEventListener('touchmove', this.onMouseMove, options);
	            this.app.removeEventListener('mousemove', this.onMouseMove, options);
	            this.$emit('end', this.internalValue);
	            if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(this.oldValue, this.internalValue)) {
	                this.$emit('change', this.internalValue);
	            }
	        },
	        onMouseMove: function onMouseMove(e) {
	            var _a = this.parseMouseMove(e),
	                value = _a.value,
	                isInsideTrack = _a.isInsideTrack;
	            if (isInsideTrack) {
	                this.setInternalValue(value);
	            }
	        },
	        onKeyDown: function onKeyDown(e) {
	            if (this.disabled || this.readonly) return;
	            var value = this.parseKeyDown(e);
	            if (value == null) return;
	            this.setInternalValue(value);
	            this.$emit('change', value);
	        },
	        onKeyUp: function onKeyUp() {
	            this.keyPressed = 0;
	        },
	        onSliderClick: function onSliderClick(e) {
	            this.isFocused = true;
	            this.onMouseMove(e);
	            this.$emit('change', this.internalValue);
	        },
	        parseMouseMove: function parseMouseMove(e) {
	            var _a = this.$refs.track.getBoundingClientRect(),
	                offsetLeft = _a.left,
	                trackWidth = _a.width;
	            var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
	            // It is possible for left to be NaN, force to number
	            var left = Math.min(Math.max((clientX - offsetLeft) / trackWidth, 0), 1) || 0;
	            if (this.$vuetify.rtl) left = 1 - left;
	            var isInsideTrack = clientX >= offsetLeft - 8 && clientX <= offsetLeft + trackWidth + 8;
	            var value = parseFloat(this.min) + left * (this.max - this.min);
	            return { value: value, isInsideTrack: isInsideTrack };
	        },
	        parseKeyDown: function parseKeyDown(e, value) {
	            if (value === void 0) {
	                value = this.internalValue;
	            }
	            if (this.disabled) return;
	            var pageup = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].pageup,
	                pagedown = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].pagedown,
	                end = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].end,
	                home = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].home,
	                left = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].left,
	                right = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].right,
	                down = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].down,
	                up = _util_helpers__WEBPACK_IMPORTED_MODULE_4__["keyCodes"].up;
	            if (![pageup, pagedown, end, home, left, right, down, up].includes(e.keyCode)) return;
	            e.preventDefault();
	            var step = this.stepNumeric || 1;
	            var steps = (this.max - this.min) / step;
	            if ([left, right, down, up].includes(e.keyCode)) {
	                this.keyPressed += 1;
	                var increase = this.$vuetify.rtl ? [left, up] : [right, up];
	                var direction = increase.includes(e.keyCode) ? 1 : -1;
	                var multiplier = e.shiftKey ? 3 : e.ctrlKey ? 2 : 1;
	                value = value + direction * step * multiplier;
	            } else if (e.keyCode === home) {
	                value = parseFloat(this.min);
	            } else if (e.keyCode === end) {
	                value = parseFloat(this.max);
	            } else /* if (e.keyCode === keyCodes.pageup || e.keyCode === pagedown) */{
	                    // Page up/down
	                    var direction = e.keyCode === pagedown ? 1 : -1;
	                    value = value - direction * step * (steps > 100 ? steps / 10 : 10);
	                }
	            return value;
	        },
	        roundValue: function roundValue(value) {
	            if (!this.stepNumeric) return value;
	            // Format input value using the same number
	            // of decimals places as in the step prop
	            var trimmedStep = this.step.toString().trim();
	            var decimals = trimmedStep.indexOf('.') > -1 ? trimmedStep.length - trimmedStep.indexOf('.') - 1 : 0;
	            var offset = this.min % this.stepNumeric;
	            var newValue = Math.round((value - offset) / this.stepNumeric) * this.stepNumeric + offset;
	            return parseFloat(Math.min(newValue, this.max).toFixed(decimals));
	        },
	        setInternalValue: function setInternalValue(value) {
	            this.internalValue = value;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSlider/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSlider/index.js ***!
	  \*****************************************/
	/*! exports provided: VSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSlider */ "./src/components/VSlider/VSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return _VSlider__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSlider__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSnackbar/VSnackbar.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VSnackbar/VSnackbar.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_snackbars.styl */ "./src/stylus/components/_snackbars.styl");
	/* harmony import */ var _stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_snackbars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_2__["default"], Object(_mixins_positionable__WEBPACK_IMPORTED_MODULE_3__["factory"])(['absolute', 'top', 'bottom', 'left', 'right'])
	/* @vue/component */
	).extend({
	    name: 'v-snackbar',
	    props: {
	        autoHeight: Boolean,
	        multiLine: Boolean,
	        // TODO: change this to closeDelay to match other API in delayable.js
	        timeout: {
	            type: Number,
	            default: 6000
	        },
	        vertical: Boolean
	    },
	    data: function data() {
	        return {
	            activeTimeout: -1
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-snack--active': this.isActive,
	                'v-snack--absolute': this.absolute,
	                'v-snack--auto-height': this.autoHeight,
	                'v-snack--bottom': this.bottom || !this.top,
	                'v-snack--left': this.left,
	                'v-snack--multi-line': this.multiLine && !this.vertical,
	                'v-snack--right': this.right,
	                'v-snack--top': this.top,
	                'v-snack--vertical': this.vertical
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive() {
	            this.setTimeout();
	        }
	    },
	    mounted: function mounted() {
	        this.setTimeout();
	    },
	    methods: {
	        setTimeout: function setTimeout() {
	            var _this = this;
	            window.clearTimeout(this.activeTimeout);
	            if (this.isActive && this.timeout) {
	                this.activeTimeout = window.setTimeout(function () {
	                    _this.isActive = false;
	                }, this.timeout);
	            }
	        }
	    },
	    render: function render(h) {
	        return h('transition', {
	            attrs: { name: 'v-snack-transition' }
	        }, this.isActive && [h('div', {
	            staticClass: 'v-snack',
	            class: this.classes,
	            on: this.$listeners
	        }, [h('div', this.setBackgroundColor(this.color, {
	            staticClass: 'v-snack__wrapper'
	        }), [h('div', {
	            staticClass: 'v-snack__content'
	        }, this.$slots.default)])])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VSnackbar/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VSnackbar/index.ts ***!
	  \*******************************************/
	/*! exports provided: VSnackbar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSnackbar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSnackbar */ "./src/components/VSnackbar/VSnackbar.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return _VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSnackbar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSpeedDial/VSpeedDial.js":
	/*!*************************************************!*\
	  !*** ./src/components/VSpeedDial/VSpeedDial.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_speed-dial.styl */ "./src/stylus/components/_speed-dial.styl");
	/* harmony import */ var _stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_speed_dial_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _mixins_positionable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/transitionable */ "./src/mixins/transitionable.ts");
	/* harmony import */ var _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../directives/click-outside */ "./src/directives/click-outside.ts");
	
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-speed-dial',
	    directives: { ClickOutside: _directives_click_outside__WEBPACK_IMPORTED_MODULE_4__["default"] },
	    mixins: [_mixins_positionable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_transitionable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        direction: {
	            type: String,
	            default: 'top',
	            validator: function validator(val) {
	                return ['top', 'right', 'bottom', 'left'].includes(val);
	            }
	        },
	        openOnHover: Boolean,
	        transition: {
	            type: String,
	            default: 'scale-transition'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            var _a;
	            return _a = {
	                'v-speed-dial': true,
	                'v-speed-dial--top': this.top,
	                'v-speed-dial--right': this.right,
	                'v-speed-dial--bottom': this.bottom,
	                'v-speed-dial--left': this.left,
	                'v-speed-dial--absolute': this.absolute,
	                'v-speed-dial--fixed': this.fixed
	            }, _a["v-speed-dial--direction-" + this.direction] = true, _a;
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var children = [];
	        var data = {
	            'class': this.classes,
	            directives: [{
	                name: 'click-outside',
	                value: function value() {
	                    return _this.isActive = false;
	                }
	            }],
	            on: {
	                click: function click() {
	                    return _this.isActive = !_this.isActive;
	                }
	            }
	        };
	        if (this.openOnHover) {
	            data.on.mouseenter = function () {
	                return _this.isActive = true;
	            };
	            data.on.mouseleave = function () {
	                return _this.isActive = false;
	            };
	        }
	        if (this.isActive) {
	            children = (this.$slots.default || []).map(function (b, i) {
	                b.key = i;
	                return b;
	            });
	        }
	        var list = h('transition-group', {
	            'class': 'v-speed-dial__list',
	            props: {
	                name: this.transition,
	                mode: this.mode,
	                origin: this.origin,
	                tag: 'div'
	            }
	        }, children);
	        return h('div', data, [this.$slots.activator, list]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSpeedDial/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VSpeedDial/index.js ***!
	  \********************************************/
	/*! exports provided: VSpeedDial, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSpeedDial */ "./src/components/VSpeedDial/VSpeedDial.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return _VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSpeedDial__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepper.js":
	/*!*********************************************!*\
	  !*** ./src/components/VStepper/VStepper.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_steppers.styl */ "./src/stylus/components/_steppers.styl");
	/* harmony import */ var _stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_steppers_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-stepper',
	    mixins: [Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["provide"])('stepper'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    provide: function provide() {
	        return {
	            stepClick: this.stepClick,
	            isVertical: this.vertical
	        };
	    },
	    props: {
	        nonLinear: Boolean,
	        altLabels: Boolean,
	        vertical: Boolean,
	        value: [Number, String]
	    },
	    data: function data() {
	        return {
	            inputValue: null,
	            isBooted: false,
	            steps: [],
	            content: [],
	            isReverse: false
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-stepper': true, 'v-stepper--is-booted': this.isBooted, 'v-stepper--vertical': this.vertical, 'v-stepper--alt-labels': this.altLabels, 'v-stepper--non-linear': this.nonLinear }, this.themeClasses);
	        }
	    },
	    watch: {
	        inputValue: function inputValue(val, prev) {
	            this.isReverse = Number(val) < Number(prev);
	            for (var index = this.steps.length; --index >= 0;) {
	                this.steps[index].toggle(this.inputValue);
	            }
	            for (var index = this.content.length; --index >= 0;) {
	                this.content[index].toggle(this.inputValue, this.isReverse);
	            }
	            this.$emit('input', this.inputValue);
	            prev && (this.isBooted = true);
	        },
	        value: function value() {
	            var _this = this;
	            this.$nextTick(function () {
	                return _this.inputValue = _this.value;
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.inputValue = this.value || this.steps[0].step || 1;
	    },
	    methods: {
	        register: function register(item) {
	            if (item.$options.name === 'v-stepper-step') {
	                this.steps.push(item);
	            } else if (item.$options.name === 'v-stepper-content') {
	                item.isVertical = this.vertical;
	                this.content.push(item);
	            }
	        },
	        unregister: function unregister(item) {
	            if (item.$options.name === 'v-stepper-step') {
	                this.steps = this.steps.filter(function (i) {
	                    return i !== item;
	                });
	            } else if (item.$options.name === 'v-stepper-content') {
	                item.isVertical = this.vertical;
	                this.content = this.content.filter(function (i) {
	                    return i !== item;
	                });
	            }
	        },
	        stepClick: function stepClick(step) {
	            var _this = this;
	            this.$nextTick(function () {
	                return _this.inputValue = step;
	            });
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            'class': this.classes
	        }, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepperContent.js":
	/*!****************************************************!*\
	  !*** ./src/components/VStepper/VStepperContent.js ***!
	  \****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	// Components
	
	// Mixins
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-stepper-content',
	    mixins: [Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_1__["inject"])('stepper', 'v-stepper-content', 'v-stepper')],
	    inject: {
	        isVerticalProvided: {
	            from: 'isVertical'
	        }
	    },
	    props: {
	        step: {
	            type: [Number, String],
	            required: true
	        }
	    },
	    data: function data() {
	        return {
	            height: 0,
	            // Must be null to allow
	            // previous comparison
	            isActive: null,
	            isReverse: false,
	            isVertical: this.isVerticalProvided
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-stepper__content': true
	            };
	        },
	        computedTransition: function computedTransition() {
	            return this.isReverse ? _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabReverseTransition"] : _transitions__WEBPACK_IMPORTED_MODULE_0__["VTabTransition"];
	        },
	        styles: function styles() {
	            if (!this.isVertical) return {};
	            return {
	                height: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_2__["convertToUnit"])(this.height)
	            };
	        },
	        wrapperClasses: function wrapperClasses() {
	            return {
	                'v-stepper__wrapper': true
	            };
	        }
	    },
	    watch: {
	        isActive: function isActive(current, previous) {
	            // If active and the previous state
	            // was null, is just booting up
	            if (current && previous == null) {
	                return this.height = 'auto';
	            }
	            if (!this.isVertical) return;
	            if (this.isActive) this.enter();else this.leave();
	        }
	    },
	    mounted: function mounted() {
	        this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
	        this.stepper && this.stepper.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
	        this.stepper && this.stepper.unregister(this);
	    },
	    methods: {
	        onTransition: function onTransition(e) {
	            if (!this.isActive || e.propertyName !== 'height') return;
	            this.height = 'auto';
	        },
	        enter: function enter() {
	            var _this = this;
	            var scrollHeight = 0;
	            // Render bug with height
	            requestAnimationFrame(function () {
	                scrollHeight = _this.$refs.wrapper.scrollHeight;
	            });
	            this.height = 0;
	            // Give the collapsing element time to collapse
	            setTimeout(function () {
	                return _this.isActive && (_this.height = scrollHeight || 'auto');
	            }, 450);
	        },
	        leave: function leave() {
	            var _this = this;
	            this.height = this.$refs.wrapper.clientHeight;
	            setTimeout(function () {
	                return _this.height = 0;
	            }, 10);
	        },
	        toggle: function toggle(step, reverse) {
	            this.isActive = step.toString() === this.step.toString();
	            this.isReverse = reverse;
	        }
	    },
	    render: function render(h) {
	        var contentData = {
	            'class': this.classes
	        };
	        var wrapperData = {
	            'class': this.wrapperClasses,
	            style: this.styles,
	            ref: 'wrapper'
	        };
	        if (!this.isVertical) {
	            contentData.directives = [{
	                name: 'show',
	                value: this.isActive
	            }];
	        }
	        var wrapper = h('div', wrapperData, [this.$slots.default]);
	        var content = h('div', contentData, [wrapper]);
	        return h(this.computedTransition, {
	            on: this.$listeners
	        }, [content]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VStepper/VStepperStep.js":
	/*!*************************************************!*\
	  !*** ./src/components/VStepper/VStepperStep.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	// Components
	
	// Mixins
	
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-stepper-step',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_2__["inject"])('stepper', 'v-stepper-step', 'v-stepper')],
	    inject: ['stepClick'],
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        complete: Boolean,
	        completeIcon: {
	            type: String,
	            default: '$vuetify.icons.complete'
	        },
	        editIcon: {
	            type: String,
	            default: '$vuetify.icons.edit'
	        },
	        errorIcon: {
	            type: String,
	            default: '$vuetify.icons.error'
	        },
	        editable: Boolean,
	        rules: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        step: [Number, String]
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            isInactive: true
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-stepper__step': true,
	                'v-stepper__step--active': this.isActive,
	                'v-stepper__step--editable': this.editable,
	                'v-stepper__step--inactive': this.isInactive,
	                'v-stepper__step--error': this.hasError,
	                'v-stepper__step--complete': this.complete,
	                'error--text': this.hasError
	            };
	        },
	        hasError: function hasError() {
	            return this.rules.some(function (i) {
	                return i() !== true;
	            });
	        }
	    },
	    mounted: function mounted() {
	        this.stepper && this.stepper.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.stepper && this.stepper.unregister(this);
	    },
	    methods: {
	        click: function click(e) {
	            e.stopPropagation();
	            this.$emit('click', e);
	            if (this.editable) {
	                this.stepClick(this.step);
	            }
	        },
	        toggle: function toggle(step) {
	            this.isActive = step.toString() === this.step.toString();
	            this.isInactive = Number(step) < Number(this.step);
	        }
	    },
	    render: function render(h) {
	        var data = {
	            'class': this.classes,
	            directives: [{
	                name: 'ripple',
	                value: this.editable
	            }],
	            on: { click: this.click }
	        };
	        var stepContent;
	        if (this.hasError) {
	            stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.errorIcon)];
	        } else if (this.complete) {
	            if (this.editable) {
	                stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.editIcon)];
	            } else {
	                stepContent = [h(_VIcon__WEBPACK_IMPORTED_MODULE_0__["default"], {}, this.completeIcon)];
	            }
	        } else {
	            stepContent = this.step;
	        }
	        var color = !this.hasError && (this.complete || this.isActive) ? this.color : false;
	        var step = h('span', this.setBackgroundColor(color, {
	            staticClass: 'v-stepper__step__step'
	        }), stepContent);
	        var label = h('div', {
	            staticClass: 'v-stepper__label'
	        }, this.$slots.default);
	        return h('div', data, [step, label]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VStepper/index.js":
	/*!******************************************!*\
	  !*** ./src/components/VStepper/index.js ***!
	  \******************************************/
	/*! exports provided: VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() { return VStepperHeader; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VStepperItems", function() { return VStepperItems; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VStepper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VStepper */ "./src/components/VStepper/VStepper.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VStepperStep__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VStepperStep */ "./src/components/VStepper/VStepperStep.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperStep", function() { return _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VStepperContent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VStepperContent */ "./src/components/VStepper/VStepperContent.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperContent", function() { return _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	
	
	
	
	var VStepperHeader = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-stepper__header');
	var VStepperItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-stepper__items');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VStepper: _VStepper__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VStepperContent: _VStepperContent__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VStepperStep: _VStepperStep__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VStepperHeader: VStepperHeader,
	        VStepperItems: VStepperItems
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSubheader/VSubheader.js":
	/*!*************************************************!*\
	  !*** ./src/components/VSubheader/VSubheader.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_subheaders.styl */ "./src/stylus/components/_subheaders.styl");
	/* harmony import */ var _stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_subheaders_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-subheader',
	    mixins: [_mixins_themeable__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        inset: Boolean
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-subheader',
	            class: __assign({ 'v-subheader--inset': this.inset }, this.themeClasses),
	            attrs: this.$attrs,
	            on: this.$listeners
	        }, this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSubheader/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VSubheader/index.js ***!
	  \********************************************/
	/*! exports provided: VSubheader, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSubheader */ "./src/components/VSubheader/VSubheader.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return _VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSubheader__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSwitch/VSwitch.js":
	/*!*******************************************!*\
	  !*** ./src/components/VSwitch/VSwitch.js ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_selection-controls.styl */ "./src/stylus/components/_selection-controls.styl");
	/* harmony import */ var _stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_selection_controls_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../stylus/components/_switch.styl */ "./src/stylus/components/_switch.styl");
	/* harmony import */ var _stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_switch_styl__WEBPACK_IMPORTED_MODULE_1__);
	/* harmony import */ var _mixins_selectable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/selectable */ "./src/mixins/selectable.js");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../VProgressCircular/VProgressCircular */ "./src/components/VProgressCircular/VProgressCircular.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	// Mixins
	
	// Directives
	
	// Components
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-switch',
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_3__["default"] },
	    mixins: [_mixins_selectable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        loading: {
	            type: [Boolean, String],
	            default: false
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-input--selection-controls v-input--switch': true
	            };
	        },
	        switchData: function switchData() {
	            return this.setTextColor(this.loading ? undefined : this.computedColor, {
	                class: this.themeClasses
	            });
	        }
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genSwitch(), this.genLabel()];
	        },
	        genSwitch: function genSwitch() {
	            return this.$createElement('div', {
	                staticClass: 'v-input--selection-controls__input'
	            }, [this.genInput('checkbox', this.$attrs), this.genRipple(this.setTextColor(this.computedColor, {
	                directives: [{
	                    name: 'touch',
	                    value: {
	                        left: this.onSwipeLeft,
	                        right: this.onSwipeRight
	                    }
	                }]
	            })), this.$createElement('div', __assign({ staticClass: 'v-input--switch__track' }, this.switchData)), this.$createElement('div', __assign({ staticClass: 'v-input--switch__thumb' }, this.switchData), [this.genProgress()])]);
	        },
	        genProgress: function genProgress() {
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_4__["VFabTransition"], {}, [this.loading === false ? null : this.$slots.progress || this.$createElement(_VProgressCircular_VProgressCircular__WEBPACK_IMPORTED_MODULE_5__["default"], {
	                props: {
	                    color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
	                    size: 16,
	                    width: 2,
	                    indeterminate: true
	                }
	            })]);
	        },
	        onSwipeLeft: function onSwipeLeft() {
	            if (this.isActive) this.onChange();
	        },
	        onSwipeRight: function onSwipeRight() {
	            if (!this.isActive) this.onChange();
	        },
	        onKeydown: function onKeydown(e) {
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].left && this.isActive || e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_6__["keyCodes"].right && !this.isActive) this.onChange();
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSwitch/index.js":
	/*!*****************************************!*\
	  !*** ./src/components/VSwitch/index.js ***!
	  \*****************************************/
	/*! exports provided: VSwitch, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSwitch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSwitch */ "./src/components/VSwitch/VSwitch.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return _VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSwitch__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VSystemBar/VSystemBar.js":
	/*!*************************************************!*\
	  !*** ./src/components/VSystemBar/VSystemBar.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_system-bars.styl */ "./src/stylus/components/_system-bars.styl");
	/* harmony import */ var _stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_system_bars_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-system-bar',
	    mixins: [Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('bar', ['height', 'window']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        height: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        lightsOut: Boolean,
	        status: Boolean,
	        window: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-system-bar--lights-out': this.lightsOut, 'v-system-bar--absolute': this.absolute, 'v-system-bar--fixed': !this.absolute && (this.app || this.fixed), 'v-system-bar--status': this.status, 'v-system-bar--window': this.window }, this.themeClasses);
	        },
	        computedHeight: function computedHeight() {
	            if (this.height) return parseInt(this.height);
	            return this.window ? 32 : 24;
	        }
	    },
	    methods: {
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            return this.computedHeight;
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-system-bar',
	            'class': this.classes,
	            style: {
	                height: this.computedHeight + "px"
	            }
	        };
	        return h('div', this.setBackgroundColor(this.color, data), this.$slots.default);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VSystemBar/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VSystemBar/index.js ***!
	  \********************************************/
	/*! exports provided: VSystemBar, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VSystemBar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VSystemBar */ "./src/components/VSystemBar/VSystemBar.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return _VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VSystemBar__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTab.js":
	/*!**************************************!*\
	  !*** ./src/components/VTabs/VTab.js ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _mixins_routable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/routable */ "./src/mixins/routable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Mixins
	
	
	
	// Utilities
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tab',
	    mixins: [_mixins_routable__WEBPACK_IMPORTED_MODULE_1__["default"],
	    // Must be after routable
	    // to overwrite activeClass
	    Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_0__["factory"])('tabGroup'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        ripple: {
	            type: [Boolean, Object],
	            default: true
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-tabs__item': true, 'v-tabs__item--disabled': this.disabled }, this.groupClasses);
	        },
	        value: function value() {
	            var to = this.to || this.href || '';
	            if (this.$router && this.to === Object(this.to)) {
	                var resolve = this.$router.resolve(this.to, this.$route, this.append);
	                to = resolve.href;
	            }
	            return to.replace('#', '');
	        }
	    },
	    watch: {
	        $route: 'onRouteChange'
	    },
	    mounted: function mounted() {
	        this.onRouteChange();
	    },
	    methods: {
	        click: function click(e) {
	            // If user provides an
	            // actual link, do not
	            // prevent default
	            if (this.href && this.href.indexOf('#') > -1) e.preventDefault();
	            this.$emit('click', e);
	            this.to || this.toggle();
	        },
	        onRouteChange: function onRouteChange() {
	            var _this = this;
	            if (!this.to || !this.$refs.link) return;
	            var path = "_vnode.data.class." + this.activeClass;
	            this.$nextTick(function () {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["getObjectValueByPath"])(_this.$refs.link, path)) {
	                    _this.toggle();
	                }
	            });
	        }
	    },
	    render: function render(h) {
	        var link = this.generateRouteLink(this.classes);
	        var data = link.data;
	        // If disabled, use div as anchor tags do not support
	        // being disabled
	        var tag = this.disabled ? 'div' : link.tag;
	        data.ref = 'link';
	        return h('div', {
	            staticClass: 'v-tabs__div'
	        }, [h(tag, data, this.$slots.default)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabItem.js":
	/*!******************************************!*\
	  !*** ./src/components/VTabs/VTabItem.js ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	// Extensions
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-tab-item',
	    props: {
	        id: String
	    },
	    render: function render(h) {
	        var render = _VWindow_VWindowItem__WEBPACK_IMPORTED_MODULE_0__["default"].options.render.call(this, h);
	        // For backwards compatibility with v1.2
	        /* istanbul ignore next */
	        if (this.id) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["deprecate"])('id', 'value', this);
	            render.data.domProps = render.data.domProps || {};
	            render.data.domProps.id = this.id;
	        }
	        return render;
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabs.js":
	/*!***************************************!*\
	  !*** ./src/components/VTabs/VTabs.js ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tabs.styl */ "./src/stylus/components/_tabs.styl");
	/* harmony import */ var _stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tabs_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony import */ var _mixins_tabs_computed__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixins/tabs-computed */ "./src/components/VTabs/mixins/tabs-computed.js");
	/* harmony import */ var _mixins_tabs_generators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/tabs-generators */ "./src/components/VTabs/mixins/tabs-generators.js");
	/* harmony import */ var _mixins_tabs_props__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/tabs-props */ "./src/components/VTabs/mixins/tabs-props.js");
	/* harmony import */ var _mixins_tabs_touch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/tabs-touch */ "./src/components/VTabs/mixins/tabs-touch.js");
	/* harmony import */ var _mixins_tabs_watchers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/tabs-watchers */ "./src/components/VTabs/mixins/tabs-watchers.js");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _directives_resize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../directives/resize */ "./src/directives/resize.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	/* harmony import */ var _util_ThemeProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../util/ThemeProvider */ "./src/util/ThemeProvider.ts");
	// Styles
	
	// Extensions
	
	// Component level mixins
	
	
	
	
	
	// Mixins
	
	
	
	// Directives
	
	
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].extend({
	    name: 'v-tabs',
	    directives: {
	        Resize: _directives_resize__WEBPACK_IMPORTED_MODULE_10__["default"],
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_11__["default"]
	    },
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_7__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_8__["default"], _mixins_tabs_computed__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_tabs_props__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_tabs_generators__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_tabs_touch__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_tabs_watchers__WEBPACK_IMPORTED_MODULE_6__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_9__["default"]],
	    provide: function provide() {
	        return {
	            tabGroup: this,
	            tabProxy: this.tabProxy,
	            registerItems: this.registerItems,
	            unregisterItems: this.unregisterItems
	        };
	    },
	    data: function data() {
	        return {
	            bar: [],
	            content: [],
	            isOverflowing: false,
	            nextIconVisible: false,
	            prevIconVisible: false,
	            resizeTimeout: null,
	            scrollOffset: 0,
	            sliderWidth: null,
	            sliderLeft: null,
	            startX: 0,
	            tabItems: null,
	            transitionTime: 300,
	            widths: {
	                bar: 0,
	                container: 0,
	                wrapper: 0
	            }
	        };
	    },
	    watch: {
	        items: 'onResize',
	        tabs: 'onResize'
	    },
	    mounted: function mounted() {
	        this.init();
	    },
	    methods: {
	        checkIcons: function checkIcons() {
	            this.prevIconVisible = this.checkPrevIcon();
	            this.nextIconVisible = this.checkNextIcon();
	        },
	        checkPrevIcon: function checkPrevIcon() {
	            return this.scrollOffset > 0;
	        },
	        checkNextIcon: function checkNextIcon() {
	            // Check one scroll ahead to know the width of right-most item
	            return this.widths.container > this.scrollOffset + this.widths.wrapper;
	        },
	        callSlider: function callSlider() {
	            var _this = this;
	            if (this.hideSlider || !this.activeTab) return false;
	            // Give screen time to paint
	            var activeTab = this.activeTab;
	            this.$nextTick(function () {
	                /* istanbul ignore if */
	                if (!activeTab || !activeTab.$el) return;
	                _this.sliderWidth = activeTab.$el.scrollWidth;
	                _this.sliderLeft = activeTab.$el.offsetLeft;
	            });
	        },
	        // Do not process
	        // until DOM is
	        // painted
	        init: function init() {
	            /* istanbul ignore next */
	            if (this.$listeners['input']) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_12__["deprecate"])('@input', '@change', this);
	            }
	        },
	        /**
	         * When v-navigation-drawer changes the
	         * width of the container, call resize
	         * after the transition is complete
	         */
	        onResize: function onResize() {
	            if (this._isDestroyed) return;
	            this.setWidths();
	            var delay = this.isBooted ? this.transitionTime : 0;
	            clearTimeout(this.resizeTimeout);
	            this.resizeTimeout = setTimeout(this.updateTabsView, delay);
	        },
	        overflowCheck: function overflowCheck(e, fn) {
	            this.isOverflowing && fn(e);
	        },
	        scrollTo: function scrollTo(direction) {
	            this.scrollOffset = this.newOffset(direction);
	        },
	        setOverflow: function setOverflow() {
	            this.isOverflowing = this.widths.bar < this.widths.container;
	        },
	        setWidths: function setWidths() {
	            var bar = this.$refs.bar ? this.$refs.bar.clientWidth : 0;
	            var container = this.$refs.container ? this.$refs.container.clientWidth : 0;
	            var wrapper = this.$refs.wrapper ? this.$refs.wrapper.clientWidth : 0;
	            this.widths = { bar: bar, container: container, wrapper: wrapper };
	            this.setOverflow();
	        },
	        parseNodes: function parseNodes() {
	            var item = [];
	            var items = [];
	            var slider = [];
	            var tab = [];
	            var length = (this.$slots.default || []).length;
	            for (var i = 0; i < length; i++) {
	                var vnode = this.$slots.default[i];
	                if (vnode.componentOptions) {
	                    switch (vnode.componentOptions.Ctor.options.name) {
	                        case 'v-tabs-slider':
	                            slider.push(vnode);
	                            break;
	                        case 'v-tabs-items':
	                            items.push(vnode);
	                            break;
	                        case 'v-tab-item':
	                            item.push(vnode);
	                            break;
	                        // case 'v-tab' - intentionally omitted
	                        default:
	                            tab.push(vnode);
	                    }
	                } else {
	                    tab.push(vnode);
	                }
	            }
	            return { tab: tab, slider: slider, items: items, item: item };
	        },
	        registerItems: function registerItems(fn) {
	            this.tabItems = fn;
	            fn(this.internalValue);
	        },
	        unregisterItems: function unregisterItems() {
	            this.tabItems = null;
	        },
	        updateTabsView: function updateTabsView() {
	            this.callSlider();
	            this.scrollIntoView();
	            this.checkIcons();
	        },
	        scrollIntoView: function scrollIntoView() {
	            /* istanbul ignore next */
	            if (!this.activeTab) return;
	            if (!this.isOverflowing) return this.scrollOffset = 0;
	            var totalWidth = this.widths.wrapper + this.scrollOffset;
	            var _a = this.activeTab.$el,
	                clientWidth = _a.clientWidth,
	                offsetLeft = _a.offsetLeft;
	            var itemOffset = clientWidth + offsetLeft;
	            var additionalOffset = clientWidth * 0.3;
	            if (this.activeTab === this.items[this.items.length - 1]) {
	                additionalOffset = 0; // don't add an offset if selecting the last tab
	            }
	            /* istanbul ignore else */
	            if (offsetLeft < this.scrollOffset) {
	                this.scrollOffset = Math.max(offsetLeft - additionalOffset, 0);
	            } else if (totalWidth < itemOffset) {
	                this.scrollOffset -= totalWidth - itemOffset - additionalOffset;
	            }
	        },
	        tabProxy: function tabProxy(val) {
	            this.internalValue = val;
	        }
	    },
	    render: function render(h) {
	        var _a = this.parseNodes(),
	            tab = _a.tab,
	            slider = _a.slider,
	            items = _a.items,
	            item = _a.item;
	        return h('div', {
	            staticClass: 'v-tabs',
	            directives: [{
	                name: 'resize',
	                modifiers: { quiet: true },
	                value: this.onResize
	            }]
	        }, [this.genBar([this.hideSlider ? null : this.genSlider(slider), tab]), h(_util_ThemeProvider__WEBPACK_IMPORTED_MODULE_13__["default"], {
	            props: { dark: this.theme.isDark, light: !this.theme.isDark }
	        }, [this.genItems(items, item)])]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabsItems.js":
	/*!********************************************!*\
	  !*** ./src/components/VTabs/VTabsItems.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VWindow/VWindow */ "./src/components/VWindow/VWindow.ts");
	// Extensions
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].extend({
	    name: 'v-tabs-items',
	    inject: {
	        registerItems: {
	            default: null
	        },
	        tabProxy: {
	            default: null
	        },
	        unregisterItems: {
	            default: null
	        }
	    },
	    props: {
	        cycle: Boolean
	    },
	    watch: {
	        internalValue: function internalValue(val) {
	            /* istanbul ignore else */
	            if (this.tabProxy) this.tabProxy(val);
	        }
	    },
	    created: function created() {
	        this.registerItems && this.registerItems(this.changeModel);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.unregisterItems && this.unregisterItems();
	    },
	    methods: {
	        changeModel: function changeModel(val) {
	            this.internalValue = val;
	        },
	        // For backwards compatability with v1.2
	        getValue: function getValue(item, i) {
	            /* istanbul ignore if */
	            if (item.id) return item.id;
	            return _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.getValue.call(this, item, i);
	        },
	        next: function next() {
	            if (!this.cycle && this.internalIndex === this.items.length - 1) {
	                return;
	            }
	            _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.next.call(this);
	        },
	        prev: function prev() {
	            if (!this.cycle && this.internalIndex === 0) {
	                return;
	            }
	            _VWindow_VWindow__WEBPACK_IMPORTED_MODULE_0__["default"].options.methods.prev.call(this);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTabs/VTabsSlider.js":
	/*!*********************************************!*\
	  !*** ./src/components/VTabs/VTabsSlider.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tabs-slider',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_0__["default"]],
	    render: function render(h) {
	        return h('div', this.setBackgroundColor(this.color || 'accent', {
	            staticClass: 'v-tabs__slider'
	        }));
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/index.js":
	/*!***************************************!*\
	  !*** ./src/components/VTabs/index.js ***!
	  \***************************************/
	/*! exports provided: VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTabs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTabs */ "./src/components/VTabs/VTabs.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTab__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTab */ "./src/components/VTabs/VTab.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTab", function() { return _VTab__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VTabsItems__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTabsItems */ "./src/components/VTabs/VTabsItems.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsItems", function() { return _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _VTabItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VTabItem */ "./src/components/VTabs/VTabItem.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabItem", function() { return _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VTabsSlider */ "./src/components/VTabs/VTabsSlider.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() { return _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTabs: _VTabs__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTab: _VTab__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VTabsItems: _VTabsItems__WEBPACK_IMPORTED_MODULE_2__["default"],
	        VTabItem: _VTabItem__WEBPACK_IMPORTED_MODULE_3__["default"],
	        VTabsSlider: _VTabsSlider__WEBPACK_IMPORTED_MODULE_4__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-computed.js":
	/*!******************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-computed.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs computed
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    computed: {
	        activeTab: function activeTab() {
	            if (!this.selectedItems.length) return undefined;
	            return this.selectedItems[0];
	        },
	        containerStyles: function containerStyles() {
	            return this.height ? {
	                height: parseInt(this.height, 10) + "px"
	            } : null;
	        },
	        hasArrows: function hasArrows() {
	            return (this.showArrows || !this.isMobile) && this.isOverflowing;
	        },
	        isMobile: function isMobile() {
	            return this.$vuetify.breakpoint.width < this.mobileBreakPoint;
	        },
	        sliderStyles: function sliderStyles() {
	            return {
	                left: this.sliderLeft + "px",
	                transition: this.sliderLeft != null ? null : 'none',
	                width: this.sliderWidth + "px"
	            };
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-generators.js":
	/*!********************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-generators.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTabsItems__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../VTabsItems */ "./src/components/VTabs/VTabsItems.js");
	/* harmony import */ var _VTabsSlider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTabsSlider */ "./src/components/VTabs/VTabsSlider.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../VIcon */ "./src/components/VIcon/index.ts");
	
	
	
	/**
	 * Tabs generators
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genBar: function genBar(items) {
	            return this.$createElement('div', this.setBackgroundColor(this.color, {
	                staticClass: 'v-tabs__bar',
	                'class': this.themeClasses,
	                ref: 'bar'
	            }), [this.genTransition('prev'), this.genWrapper(this.genContainer(items)), this.genTransition('next')]);
	        },
	        genContainer: function genContainer(items) {
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__container',
	                class: {
	                    'v-tabs__container--align-with-title': this.alignWithTitle,
	                    'v-tabs__container--centered': this.centered,
	                    'v-tabs__container--fixed-tabs': this.fixedTabs,
	                    'v-tabs__container--grow': this.grow,
	                    'v-tabs__container--icons-and-text': this.iconsAndText,
	                    'v-tabs__container--overflow': this.isOverflowing,
	                    'v-tabs__container--right': this.right
	                },
	                style: this.containerStyles,
	                ref: 'container'
	            }, items);
	        },
	        genIcon: function genIcon(direction) {
	            var _this = this;
	            if (!this.hasArrows || !this[direction + "IconVisible"]) return null;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                staticClass: "v-tabs__icon v-tabs__icon--" + direction,
	                props: {
	                    disabled: !this[direction + "IconVisible"]
	                },
	                on: {
	                    click: function click() {
	                        return _this.scrollTo(direction);
	                    }
	                }
	            }, this[direction + "Icon"]);
	        },
	        genItems: function genItems(items, item) {
	            if (items.length > 0) return items;
	            if (!item.length) return null;
	            return this.$createElement(_VTabsItems__WEBPACK_IMPORTED_MODULE_0__["default"], item);
	        },
	        genTransition: function genTransition(direction) {
	            return this.$createElement('transition', {
	                props: { name: 'fade-transition' }
	            }, [this.genIcon(direction)]);
	        },
	        genWrapper: function genWrapper(items) {
	            var _this = this;
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__wrapper',
	                class: {
	                    'v-tabs__wrapper--show-arrows': this.hasArrows
	                },
	                ref: 'wrapper',
	                directives: [{
	                    name: 'touch',
	                    value: {
	                        start: function start(e) {
	                            return _this.overflowCheck(e, _this.onTouchStart);
	                        },
	                        move: function move(e) {
	                            return _this.overflowCheck(e, _this.onTouchMove);
	                        },
	                        end: function end(e) {
	                            return _this.overflowCheck(e, _this.onTouchEnd);
	                        }
	                    }
	                }]
	            }, [items]);
	        },
	        genSlider: function genSlider(items) {
	            if (!items.length) {
	                items = [this.$createElement(_VTabsSlider__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                    props: { color: this.sliderColor }
	                })];
	            }
	            return this.$createElement('div', {
	                staticClass: 'v-tabs__slider-wrapper',
	                style: this.sliderStyles
	            }, items);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-props.js":
	/*!***************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-props.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs props
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-tabs__item--active'
	        },
	        alignWithTitle: Boolean,
	        centered: Boolean,
	        fixedTabs: Boolean,
	        grow: Boolean,
	        height: {
	            type: [Number, String],
	            default: undefined,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        hideSlider: Boolean,
	        iconsAndText: Boolean,
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        mobileBreakPoint: {
	            type: [Number, String],
	            default: 1264,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        right: Boolean,
	        showArrows: Boolean,
	        sliderColor: {
	            type: String,
	            default: 'accent'
	        },
	        value: [Number, String]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-touch.js":
	/*!***************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-touch.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs touch
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        newOffset: function newOffset(direction) {
	            var clientWidth = this.$refs.wrapper.clientWidth;
	            if (direction === 'prev') {
	                return Math.max(this.scrollOffset - clientWidth, 0);
	            } else {
	                return Math.min(this.scrollOffset + clientWidth, this.$refs.container.clientWidth - clientWidth);
	            }
	        },
	        onTouchStart: function onTouchStart(e) {
	            this.startX = this.scrollOffset + e.touchstartX;
	            this.$refs.container.style.transition = 'none';
	            this.$refs.container.style.willChange = 'transform';
	        },
	        onTouchMove: function onTouchMove(e) {
	            this.scrollOffset = this.startX - e.touchmoveX;
	        },
	        onTouchEnd: function onTouchEnd() {
	            var container = this.$refs.container;
	            var wrapper = this.$refs.wrapper;
	            var maxScrollOffset = container.clientWidth - wrapper.clientWidth;
	            container.style.transition = null;
	            container.style.willChange = null;
	            /* istanbul ignore else */
	            if (this.scrollOffset < 0 || !this.isOverflowing) {
	                this.scrollOffset = 0;
	            } else if (this.scrollOffset >= maxScrollOffset) {
	                this.scrollOffset = maxScrollOffset;
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTabs/mixins/tabs-watchers.js":
	/*!******************************************************!*\
	  !*** ./src/components/VTabs/mixins/tabs-watchers.js ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/**
	 * Tabs watchers
	 *
	 * @mixin
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    watch: {
	        activeTab: function activeTab(val, oldVal) {
	            this.setOverflow();
	            if (!val) return;
	            this.tabItems && this.tabItems(this.getValue(val, this.items.indexOf(val)));
	            // Do nothing for first tab
	            // is handled from isBooted
	            // watcher
	            if (oldVal == null) return;
	            this.updateTabsView();
	        },
	        alignWithTitle: 'callSlider',
	        centered: 'callSlider',
	        fixedTabs: 'callSlider',
	        hasArrows: function hasArrows(val) {
	            if (!val) this.scrollOffset = 0;
	        },
	        /* @deprecate */
	        internalValue: function internalValue(val) {
	            /* istanbul ignore else */
	            if (!this.$listeners['input']) return;
	            this.$emit('input', val);
	        },
	        lazyValue: 'updateTabs',
	        right: 'callSlider',
	        '$vuetify.application.left': 'onResize',
	        '$vuetify.application.right': 'onResize',
	        scrollOffset: function scrollOffset(val) {
	            this.$refs.container.style.transform = "translateX(" + -val + "px)";
	            if (this.hasArrows) {
	                this.prevIconVisible = this.checkPrevIcon();
	                this.nextIconVisible = this.checkNextIcon();
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTextField/VTextField.js":
	/*!*************************************************!*\
	  !*** ./src/components/VTextField/VTextField.js ***!
	  \*************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_text-fields.styl */ "./src/stylus/components/_text-fields.styl");
	/* harmony import */ var _stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_text_fields_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VInput */ "./src/components/VInput/index.js");
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VCounter */ "./src/components/VCounter/index.js");
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../VLabel */ "./src/components/VLabel/index.js");
	/* harmony import */ var _mixins_maskable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/maskable */ "./src/mixins/maskable.js");
	/* harmony import */ var _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/loadable */ "./src/mixins/loadable.ts");
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	// Components
	
	
	// Mixins
	
	
	// Directives
	
	// Utilities
	
	
	var dirtyTypes = ['color', 'file', 'time', 'date', 'datetime-local', 'week', 'month'];
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-text-field',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_6__["default"] },
	    extends: _VInput__WEBPACK_IMPORTED_MODULE_1__["default"],
	    mixins: [_mixins_maskable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_loadable__WEBPACK_IMPORTED_MODULE_5__["default"]],
	    inheritAttrs: false,
	    props: {
	        appendOuterIcon: String,
	        /** @deprecated */
	        appendOuterIconCb: Function,
	        autofocus: Boolean,
	        box: Boolean,
	        browserAutocomplete: String,
	        clearable: Boolean,
	        clearIcon: {
	            type: String,
	            default: '$vuetify.icons.clear'
	        },
	        clearIconCb: Function,
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        counter: [Boolean, Number, String],
	        flat: Boolean,
	        fullWidth: Boolean,
	        label: String,
	        outline: Boolean,
	        placeholder: String,
	        prefix: String,
	        prependInnerIcon: String,
	        /** @deprecated */
	        prependInnerIconCb: Function,
	        reverse: Boolean,
	        singleLine: Boolean,
	        solo: Boolean,
	        soloInverted: Boolean,
	        suffix: String,
	        type: {
	            type: String,
	            default: 'text'
	        }
	    },
	    data: function data() {
	        return {
	            badInput: false,
	            initialValue: null,
	            internalChange: false,
	            isClearing: false
	        };
	    },
	    computed: {
	        classes: function classes() {
	            return {
	                'v-text-field': true,
	                'v-text-field--full-width': this.fullWidth,
	                'v-text-field--prefix': this.prefix,
	                'v-text-field--single-line': this.isSingle,
	                'v-text-field--solo': this.isSolo,
	                'v-text-field--solo-inverted': this.soloInverted,
	                'v-text-field--solo-flat': this.flat,
	                'v-text-field--box': this.box,
	                'v-text-field--enclosed': this.isEnclosed,
	                'v-text-field--reverse': this.reverse,
	                'v-text-field--outline': this.hasOutline,
	                'v-text-field--placeholder': this.placeholder
	            };
	        },
	        counterValue: function counterValue() {
	            return (this.internalValue || '').toString().length;
	        },
	        directivesInput: function directivesInput() {
	            return [];
	        },
	        // TODO: Deprecate
	        hasOutline: function hasOutline() {
	            return this.outline || this.textarea;
	        },
	        internalValue: {
	            get: function get() {
	                return this.lazyValue;
	            },
	            set: function set(val) {
	                if (this.mask) {
	                    this.lazyValue = this.unmaskText(this.maskText(this.unmaskText(val)));
	                    this.setSelectionRange();
	                } else {
	                    this.lazyValue = val;
	                    this.$emit('input', this.lazyValue);
	                }
	            }
	        },
	        isDirty: function isDirty() {
	            return this.lazyValue != null && this.lazyValue.toString().length > 0 || this.badInput;
	        },
	        isEnclosed: function isEnclosed() {
	            return this.box || this.isSolo || this.hasOutline || this.fullWidth;
	        },
	        isLabelActive: function isLabelActive() {
	            return this.isDirty || dirtyTypes.includes(this.type);
	        },
	        isSingle: function isSingle() {
	            return this.isSolo || this.singleLine;
	        },
	        isSolo: function isSolo() {
	            return this.solo || this.soloInverted;
	        },
	        labelPosition: function labelPosition() {
	            var offset = this.prefix && !this.labelValue ? this.prefixWidth : 0;
	            return !this.$vuetify.rtl !== !this.reverse ? {
	                left: 'auto',
	                right: offset
	            } : {
	                left: offset,
	                right: 'auto'
	            };
	        },
	        showLabel: function showLabel() {
	            return this.hasLabel && (!this.isSingle || !this.isLabelActive && !this.placeholder && !this.prefixLabel);
	        },
	        labelValue: function labelValue() {
	            return !this.isSingle && Boolean(this.isFocused || this.isLabelActive || this.placeholder || this.prefixLabel);
	        },
	        prefixWidth: function prefixWidth() {
	            if (!this.prefix && !this.$refs.prefix) return;
	            return this.$refs.prefix.offsetWidth;
	        },
	        prefixLabel: function prefixLabel() {
	            return this.prefix && !this.value;
	        }
	    },
	    watch: {
	        isFocused: function isFocused(val) {
	            // Sets validationState from validatable
	            this.hasColor = val;
	            if (val) {
	                this.initialValue = this.lazyValue;
	            } else if (this.initialValue !== this.lazyValue) {
	                this.$emit('change', this.lazyValue);
	            }
	        },
	        value: function value(val) {
	            var _this = this;
	            if (this.mask && !this.internalChange) {
	                var masked_1 = this.maskText(this.unmaskText(val));
	                this.lazyValue = this.unmaskText(masked_1);
	                // Emit when the externally set value was modified internally
	                String(val) !== this.lazyValue && this.$nextTick(function () {
	                    _this.$refs.input.value = masked_1;
	                    _this.$emit('input', _this.lazyValue);
	                });
	            } else this.lazyValue = val;
	        }
	    },
	    mounted: function mounted() {
	        this.autofocus && this.onFocus();
	    },
	    methods: {
	        /** @public */
	        focus: function focus() {
	            this.onFocus();
	        },
	        /** @public */
	        blur: function blur() {
	            this.$refs.input ? this.$refs.input.blur() : this.onBlur();
	        },
	        clearableCallback: function clearableCallback() {
	            var _this = this;
	            this.internalValue = null;
	            this.$nextTick(function () {
	                return _this.$refs.input.focus();
	            });
	        },
	        genAppendSlot: function genAppendSlot() {
	            var slot = [];
	            if (this.$slots['append-outer']) {
	                slot.push(this.$slots['append-outer']);
	            } else if (this.appendOuterIcon) {
	                slot.push(this.genIcon('appendOuter'));
	            }
	            return this.genSlot('append', 'outer', slot);
	        },
	        genPrependInnerSlot: function genPrependInnerSlot() {
	            var slot = [];
	            if (this.$slots['prepend-inner']) {
	                slot.push(this.$slots['prepend-inner']);
	            } else if (this.prependInnerIcon) {
	                slot.push(this.genIcon('prependInner'));
	            }
	            return this.genSlot('prepend', 'inner', slot);
	        },
	        genIconSlot: function genIconSlot() {
	            var slot = [];
	            if (this.$slots['append']) {
	                slot.push(this.$slots['append']);
	            } else if (this.appendIcon) {
	                slot.push(this.genIcon('append'));
	            }
	            return this.genSlot('append', 'inner', slot);
	        },
	        genInputSlot: function genInputSlot() {
	            var input = _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genInputSlot.call(this);
	            var prepend = this.genPrependInnerSlot();
	            prepend && input.children.unshift(prepend);
	            return input;
	        },
	        genClearIcon: function genClearIcon() {
	            if (!this.clearable) return null;
	            var icon = !this.isDirty ? false : 'clear';
	            if (this.clearIconCb) Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["deprecate"])(':clear-icon-cb', '@click:clear', this);
	            return this.genSlot('append', 'inner', [this.genIcon(icon, !this.$listeners['click:clear'] && this.clearIconCb || this.clearableCallback, false)]);
	        },
	        genCounter: function genCounter() {
	            if (this.counter === false || this.counter == null) return null;
	            var max = this.counter === true ? this.$attrs.maxlength : this.counter;
	            return this.$createElement(_VCounter__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                props: {
	                    dark: this.dark,
	                    light: this.light,
	                    max: max,
	                    value: this.counterValue
	                }
	            });
	        },
	        genDefaultSlot: function genDefaultSlot() {
	            return [this.genTextFieldSlot(), this.genClearIcon(), this.genIconSlot(), this.genProgress()];
	        },
	        genLabel: function genLabel() {
	            if (!this.showLabel) return null;
	            var data = {
	                props: {
	                    absolute: true,
	                    color: this.validationState,
	                    dark: this.dark,
	                    disabled: this.disabled,
	                    focused: !this.isSingle && (this.isFocused || !!this.validationState),
	                    left: this.labelPosition.left,
	                    light: this.light,
	                    right: this.labelPosition.right,
	                    value: this.labelValue
	                }
	            };
	            if (this.$attrs.id) data.props.for = this.$attrs.id;
	            return this.$createElement(_VLabel__WEBPACK_IMPORTED_MODULE_3__["default"], data, this.$slots.label || this.label);
	        },
	        genInput: function genInput() {
	            var listeners = Object.assign({}, this.$listeners);
	            delete listeners['change']; // Change should not be bound externally
	            var data = {
	                style: {},
	                domProps: {
	                    value: this.maskText(this.lazyValue)
	                },
	                attrs: __assign({ 'aria-label': (!this.$attrs || !this.$attrs.id) && this.label }, this.$attrs, { autofocus: this.autofocus, disabled: this.disabled, readonly: this.readonly, type: this.type }),
	                on: Object.assign(listeners, {
	                    blur: this.onBlur,
	                    input: this.onInput,
	                    focus: this.onFocus,
	                    keydown: this.onKeyDown
	                }),
	                ref: 'input'
	            };
	            if (this.placeholder) data.attrs.placeholder = this.placeholder;
	            if (this.mask) data.attrs.maxlength = this.masked.length;
	            if (this.browserAutocomplete) data.attrs.autocomplete = this.browserAutocomplete;
	            return this.$createElement('input', data);
	        },
	        genMessages: function genMessages() {
	            if (this.hideDetails) return null;
	            return this.$createElement('div', {
	                staticClass: 'v-text-field__details'
	            }, [_VInput__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genMessages.call(this), this.genCounter()]);
	        },
	        genTextFieldSlot: function genTextFieldSlot() {
	            return this.$createElement('div', {
	                staticClass: 'v-text-field__slot'
	            }, [this.genLabel(), this.prefix ? this.genAffix('prefix') : null, this.genInput(), this.suffix ? this.genAffix('suffix') : null]);
	        },
	        genAffix: function genAffix(type) {
	            return this.$createElement('div', {
	                'class': "v-text-field__" + type,
	                ref: type
	            }, this[type]);
	        },
	        onBlur: function onBlur(e) {
	            this.isFocused = false;
	            // Reset internalChange state
	            // to allow external change
	            // to persist
	            this.internalChange = false;
	            this.$emit('blur', e);
	        },
	        onClick: function onClick() {
	            if (this.isFocused || this.disabled) return;
	            this.$refs.input.focus();
	        },
	        onFocus: function onFocus(e) {
	            if (!this.$refs.input) return;
	            if (document.activeElement !== this.$refs.input) {
	                return this.$refs.input.focus();
	            }
	            if (!this.isFocused) {
	                this.isFocused = true;
	                this.$emit('focus', e);
	            }
	        },
	        onInput: function onInput(e) {
	            this.internalChange = true;
	            this.mask && this.resetSelections(e.target);
	            this.internalValue = e.target.value;
	            this.badInput = e.target.validity && e.target.validity.badInput;
	        },
	        onKeyDown: function onKeyDown(e) {
	            this.internalChange = true;
	            if (e.keyCode === _util_helpers__WEBPACK_IMPORTED_MODULE_7__["keyCodes"].enter) this.$emit('change', this.internalValue);
	            this.$emit('keydown', e);
	        },
	        onMouseDown: function onMouseDown(e) {
	            // Prevent input from being blurred
	            if (e.target !== this.$refs.input) {
	                e.preventDefault();
	                e.stopPropagation();
	            }
	            _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onMouseDown.call(this, e);
	        },
	        onMouseUp: function onMouseUp(e) {
	            if (this.hasMouseDown) this.focus();
	            _VInput__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onMouseUp.call(this, e);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTextField/index.js":
	/*!********************************************!*\
	  !*** ./src/components/VTextField/index.js ***!
	  \********************************************/
	/*! exports provided: VTextField, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return wrapper; });
	/* harmony import */ var _VTextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _VTextarea_VTextarea__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTextarea/VTextarea */ "./src/components/VTextarea/VTextarea.js");
	/* harmony import */ var _util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/rebuildFunctionalSlots */ "./src/util/rebuildFunctionalSlots.js");
	/* harmony import */ var _util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/dedupeModelListeners */ "./src/util/dedupeModelListeners.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	// TODO: remove this in v2.0
	/* @vue/component */
	var wrapper = {
	    functional: true,
	    $_wrapperFor: _VTextField__WEBPACK_IMPORTED_MODULE_0__["default"],
	    props: {
	        textarea: Boolean,
	        multiLine: Boolean
	    },
	    render: function render(h, _a) {
	        var props = _a.props,
	            data = _a.data,
	            slots = _a.slots,
	            parent = _a.parent;
	        Object(_util_dedupeModelListeners__WEBPACK_IMPORTED_MODULE_3__["default"])(data);
	        var children = Object(_util_rebuildFunctionalSlots__WEBPACK_IMPORTED_MODULE_2__["default"])(slots(), h);
	        if (props.textarea) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('<v-text-field textarea>', '<v-textarea outline>', wrapper, parent);
	        }
	        if (props.multiLine) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_4__["deprecate"])('<v-text-field multi-line>', '<v-textarea>', wrapper, parent);
	        }
	        if (props.textarea || props.multiLine) {
	            data.attrs.outline = props.textarea;
	            return h(_VTextarea_VTextarea__WEBPACK_IMPORTED_MODULE_1__["default"], data, children);
	        } else {
	            return h(_VTextField__WEBPACK_IMPORTED_MODULE_0__["default"], data, children);
	        }
	    }
	};
	
	/* harmony default export */ __webpack_exports__["default"] = (wrapper);
	
	/***/ }),
	
	/***/ "./src/components/VTextarea/VTextarea.js":
	/*!***********************************************!*\
	  !*** ./src/components/VTextarea/VTextarea.js ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_textarea.styl */ "./src/stylus/components/_textarea.styl");
	/* harmony import */ var _stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_textarea_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VTextField/VTextField */ "./src/components/VTextField/VTextField.js");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Extensions
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-textarea',
	    extends: _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"],
	    props: {
	        autoGrow: Boolean,
	        noResize: Boolean,
	        outline: Boolean,
	        rowHeight: {
	            type: [Number, String],
	            default: 24,
	            validator: function validator(v) {
	                return !isNaN(parseFloat(v));
	            }
	        },
	        rows: {
	            type: [Number, String],
	            default: 5,
	            validator: function validator(v) {
	                return !isNaN(parseInt(v, 10));
	            }
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-textarea': true, 'v-textarea--auto-grow': this.autoGrow, 'v-textarea--no-resize': this.noResizeHandle }, _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].computed.classes.call(this, null));
	        },
	        dynamicHeight: function dynamicHeight() {
	            return this.autoGrow ? this.inputHeight : 'auto';
	        },
	        isEnclosed: function isEnclosed() {
	            return this.textarea || _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].computed.isEnclosed.call(this);
	        },
	        noResizeHandle: function noResizeHandle() {
	            return this.noResize || this.autoGrow;
	        }
	    },
	    watch: {
	        lazyValue: function lazyValue() {
	            !this.internalChange && this.autoGrow && this.$nextTick(this.calculateInputHeight);
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	        setTimeout(function () {
	            _this.autoGrow && _this.calculateInputHeight();
	        }, 0);
	        // TODO: remove (2.0)
	        if (this.autoGrow && this.noResize) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleInfo"])('"no-resize" is now implied when using "auto-grow", and can be removed', this);
	        }
	    },
	    methods: {
	        calculateInputHeight: function calculateInputHeight() {
	            var input = this.$refs.input;
	            if (input) {
	                input.style.height = 0;
	                var height = input.scrollHeight;
	                var minHeight = parseInt(this.rows, 10) * parseFloat(this.rowHeight);
	                // This has to be done ASAP, waiting for Vue
	                // to update the DOM causes ugly layout jumping
	                input.style.height = Math.max(minHeight, height) + 'px';
	            }
	        },
	        genInput: function genInput() {
	            var input = _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].methods.genInput.call(this);
	            input.tag = 'textarea';
	            delete input.data.attrs.type;
	            input.data.attrs.rows = this.rows;
	            return input;
	        },
	        onInput: function onInput(e) {
	            _VTextField_VTextField__WEBPACK_IMPORTED_MODULE_1__["default"].methods.onInput.call(this, e);
	            this.autoGrow && this.calculateInputHeight();
	        },
	        onKeyDown: function onKeyDown(e) {
	            // Prevents closing of a
	            // dialog when pressing
	            // enter
	            if (this.isFocused && e.keyCode === 13) {
	                e.stopPropagation();
	            }
	            this.internalChange = true;
	            this.$emit('keydown', e);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTextarea/index.js":
	/*!*******************************************!*\
	  !*** ./src/components/VTextarea/index.js ***!
	  \*******************************************/
	/*! exports provided: VTextarea, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTextarea__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTextarea */ "./src/components/VTextarea/VTextarea.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextarea", function() { return _VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VTextarea__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePicker.js":
	/*!***************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePicker.js ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimePickerTitle */ "./src/components/VTimePicker/VTimePickerTitle.js");
	/* harmony import */ var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimePickerClock */ "./src/components/VTimePicker/VTimePickerClock.js");
	/* harmony import */ var _mixins_picker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/picker */ "./src/mixins/picker.js");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../VDatePicker/util/pad */ "./src/components/VDatePicker/util/pad.js");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	// Components
	
	
	// Mixins
	
	// Utils
	
	
	var rangeHours24 = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(24);
	var rangeHours12am = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(12);
	var rangeHours12pm = rangeHours12am.map(function (v) {
	    return v + 12;
	});
	var rangeMinutes = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["createRange"])(60);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-time-picker',
	    mixins: [_mixins_picker__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        allowedHours: Function,
	        allowedMinutes: Function,
	        format: {
	            type: String,
	            default: 'ampm',
	            validator: function validator(val) {
	                return ['ampm', '24hr'].includes(val);
	            }
	        },
	        min: String,
	        max: String,
	        readonly: Boolean,
	        scrollable: Boolean,
	        value: null
	    },
	    data: function data() {
	        return {
	            inputHour: null,
	            inputMinute: null,
	            period: 'am',
	            selectingHour: true
	        };
	    },
	    computed: {
	        isAllowedHourCb: function isAllowedHourCb() {
	            var _this = this;
	            if (!this.min && !this.max) return this.allowedHours;
	            var minHour = this.min ? this.min.split(':')[0] : 0;
	            var maxHour = this.max ? this.max.split(':')[0] : 23;
	            return function (val) {
	                return val >= minHour * 1 && val <= maxHour * 1 && (!_this.allowedHours || _this.allowedHours(val));
	            };
	        },
	        isAllowedMinuteCb: function isAllowedMinuteCb() {
	            var _this = this;
	            var isHourAllowed = !this.allowedHours || this.allowedHours(this.inputHour);
	            if (!this.min && !this.max) {
	                return isHourAllowed ? this.allowedMinutes : function () {
	                    return false;
	                };
	            }
	            var _a = __read(this.min ? this.min.split(':') : [0, 0], 2),
	                minHour = _a[0],
	                minMinute = _a[1];
	            var _b = __read(this.max ? this.max.split(':') : [23, 59], 2),
	                maxHour = _b[0],
	                maxMinute = _b[1];
	            var minTime = minHour * 60 + minMinute * 1;
	            var maxTime = maxHour * 60 + maxMinute * 1;
	            return function (val) {
	                var time = 60 * _this.inputHour + val;
	                return time >= minTime && time <= maxTime && isHourAllowed && (!_this.allowedMinutes || _this.allowedMinutes(val));
	            };
	        },
	        isAmPm: function isAmPm() {
	            return this.format === 'ampm';
	        }
	    },
	    watch: {
	        value: 'setInputData'
	    },
	    mounted: function mounted() {
	        this.setInputData(this.value);
	    },
	    methods: {
	        emitValue: function emitValue() {
	            if (this.inputHour != null && this.inputMinute != null) {
	                this.$emit('input', Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(this.inputHour) + ":" + Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(this.inputMinute));
	            }
	        },
	        setPeriod: function setPeriod(period) {
	            this.period = period;
	            if (this.inputHour != null) {
	                var newHour = this.inputHour + (period === 'am' ? -12 : 12);
	                this.inputHour = this.firstAllowed('hour', newHour);
	                this.emitValue();
	            }
	        },
	        setInputData: function setInputData(value) {
	            if (value == null || value === '') {
	                this.inputHour = null;
	                this.inputMinute = null;
	                return;
	            }
	            if (value instanceof Date) {
	                this.inputHour = value.getHours();
	                this.inputMinute = value.getMinutes();
	            } else {
	                var _a = __read(value.trim().toLowerCase().match(/^(\d+):(\d+)(:\d+)?([ap]m)?$/, '') || [], 5),
	                    hour = _a[1],
	                    minute = _a[2],
	                    period = _a[4];
	                this.inputHour = period ? this.convert12to24(parseInt(hour, 10), period) : parseInt(hour, 10);
	                this.inputMinute = parseInt(minute, 10);
	            }
	            this.period = this.inputHour < 12 ? 'am' : 'pm';
	        },
	        convert24to12: function convert24to12(hour) {
	            return hour ? (hour - 1) % 12 + 1 : 12;
	        },
	        convert12to24: function convert12to24(hour, period) {
	            return hour % 12 + (period === 'pm' ? 12 : 0);
	        },
	        onInput: function onInput(value) {
	            if (this.selectingHour) {
	                this.inputHour = this.isAmPm ? this.convert12to24(value, this.period) : value;
	            } else {
	                this.inputMinute = value;
	            }
	            this.emitValue();
	        },
	        onChange: function onChange() {
	            if (!this.selectingHour) {
	                this.$emit('change', this.value);
	            } else {
	                this.selectingHour = false;
	            }
	        },
	        firstAllowed: function firstAllowed(type, value) {
	            var allowedFn = type === 'hour' ? this.isAllowedHourCb : this.isAllowedMinuteCb;
	            if (!allowedFn) return value;
	            // TODO: clean up
	            var range = type === 'minute' ? rangeMinutes : this.isAmPm ? value < 12 ? rangeHours12am : rangeHours12pm : rangeHours24;
	            var first = range.find(function (v) {
	                return allowedFn((v + value) % range.length + range[0]);
	            });
	            return ((first || 0) + value) % range.length + range[0];
	        },
	        genClock: function genClock() {
	            return this.$createElement(_VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    allowedValues: this.selectingHour ? this.isAllowedHourCb : this.isAllowedMinuteCb,
	                    color: this.color,
	                    dark: this.dark,
	                    double: this.selectingHour && !this.isAmPm,
	                    format: this.selectingHour ? this.isAmPm ? this.convert24to12 : function (val) {
	                        return val;
	                    } : function (val) {
	                        return Object(_VDatePicker_util_pad__WEBPACK_IMPORTED_MODULE_4__["default"])(val, 2);
	                    },
	                    light: this.light,
	                    max: this.selectingHour ? this.isAmPm && this.period === 'am' ? 11 : 23 : 59,
	                    min: this.selectingHour && this.isAmPm && this.period === 'pm' ? 12 : 0,
	                    readonly: this.readonly,
	                    scrollable: this.scrollable,
	                    size: this.width - (!this.fullWidth && this.landscape ? 80 : 20),
	                    step: this.selectingHour ? 1 : 5,
	                    value: this.selectingHour ? this.inputHour : this.inputMinute
	                },
	                on: {
	                    input: this.onInput,
	                    change: this.onChange
	                },
	                ref: 'clock'
	            });
	        },
	        genPickerBody: function genPickerBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-time-picker-clock__container',
	                key: this.selectingHour
	            }, [this.genClock()]);
	        },
	        genPickerTitle: function genPickerTitle() {
	            var _this = this;
	            return this.$createElement(_VTimePickerTitle__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    ampm: this.isAmPm,
	                    hour: this.inputHour,
	                    minute: this.inputMinute,
	                    period: this.period,
	                    readonly: this.readonly,
	                    selectingHour: this.selectingHour
	                },
	                on: {
	                    'update:selectingHour': function updateSelectingHour(value) {
	                        return _this.selectingHour = value;
	                    },
	                    'update:period': this.setPeriod
	                },
	                ref: 'title',
	                slot: 'title'
	            });
	        }
	    },
	    render: function render() {
	        return this.genPicker('v-picker--time');
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePickerClock.js":
	/*!********************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePickerClock.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_time-picker-clock.styl */ "./src/stylus/components/_time-picker-clock.styl");
	/* harmony import */ var _stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_time_picker_clock_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-time-picker-clock',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        allowedValues: Function,
	        double: Boolean,
	        format: {
	            type: Function,
	            default: function _default(val) {
	                return val;
	            }
	        },
	        max: {
	            type: Number,
	            required: true
	        },
	        min: {
	            type: Number,
	            required: true
	        },
	        scrollable: Boolean,
	        readonly: Boolean,
	        rotate: {
	            type: Number,
	            default: 0
	        },
	        step: {
	            type: Number,
	            default: 1
	        },
	        value: Number
	    },
	    data: function data() {
	        return {
	            inputValue: this.value,
	            isDragging: false,
	            valueOnMouseDown: null,
	            valueOnMouseUp: null
	        };
	    },
	    computed: {
	        count: function count() {
	            return this.max - this.min + 1;
	        },
	        degreesPerUnit: function degreesPerUnit() {
	            return 360 / this.roundCount;
	        },
	        degrees: function degrees() {
	            return this.degreesPerUnit * Math.PI / 180;
	        },
	        displayedValue: function displayedValue() {
	            return this.value == null ? this.min : this.value;
	        },
	        innerRadiusScale: function innerRadiusScale() {
	            return 0.62;
	        },
	        roundCount: function roundCount() {
	            return this.double ? this.count / 2 : this.count;
	        }
	    },
	    watch: {
	        value: function value(_value) {
	            this.inputValue = _value;
	        }
	    },
	    methods: {
	        wheel: function wheel(e) {
	            e.preventDefault();
	            var delta = Math.sign(e.wheelDelta || 1);
	            var value = this.displayedValue;
	            do {
	                value = value + delta;
	                value = (value - this.min + this.count) % this.count + this.min;
	            } while (!this.isAllowed(value) && value !== this.displayedValue);
	            if (value !== this.displayedValue) {
	                this.update(value);
	            }
	        },
	        isInner: function isInner(value) {
	            return this.double && value - this.min >= this.roundCount;
	        },
	        handScale: function handScale(value) {
	            return this.isInner(value) ? this.innerRadiusScale : 1;
	        },
	        isAllowed: function isAllowed(value) {
	            return !this.allowedValues || this.allowedValues(value);
	        },
	        genValues: function genValues() {
	            var children = [];
	            for (var value = this.min; value <= this.max; value = value + this.step) {
	                var color = value === this.value && (this.color || 'accent');
	                children.push(this.$createElement('span', this.setBackgroundColor(color, {
	                    staticClass: 'v-time-picker-clock__item',
	                    'class': {
	                        'v-time-picker-clock__item--active': value === this.displayedValue,
	                        'v-time-picker-clock__item--disabled': !this.isAllowed(value)
	                    },
	                    style: this.getTransform(value),
	                    domProps: { innerHTML: "<span>" + this.format(value) + "</span>" }
	                })));
	            }
	            return children;
	        },
	        genHand: function genHand() {
	            var scale = "scaleY(" + this.handScale(this.displayedValue) + ")";
	            var angle = this.rotate + this.degreesPerUnit * (this.displayedValue - this.min);
	            var color = this.value != null && (this.color || 'accent');
	            return this.$createElement('div', this.setBackgroundColor(color, {
	                staticClass: 'v-time-picker-clock__hand',
	                'class': {
	                    'v-time-picker-clock__hand--inner': this.isInner(this.value)
	                },
	                style: {
	                    transform: "rotate(" + angle + "deg) " + scale
	                }
	            }));
	        },
	        getTransform: function getTransform(i) {
	            var _a = this.getPosition(i),
	                x = _a.x,
	                y = _a.y;
	            return {
	                left: 50 + x * 50 + "%",
	                top: 50 + y * 50 + "%"
	            };
	        },
	        getPosition: function getPosition(value) {
	            var rotateRadians = this.rotate * Math.PI / 180;
	            return {
	                x: Math.sin((value - this.min) * this.degrees + rotateRadians) * this.handScale(value),
	                y: -Math.cos((value - this.min) * this.degrees + rotateRadians) * this.handScale(value)
	            };
	        },
	        onMouseDown: function onMouseDown(e) {
	            e.preventDefault();
	            this.valueOnMouseDown = null;
	            this.valueOnMouseUp = null;
	            this.isDragging = true;
	            this.onDragMove(e);
	        },
	        onMouseUp: function onMouseUp() {
	            this.isDragging = false;
	            if (this.valueOnMouseUp !== null && this.isAllowed(this.valueOnMouseUp)) {
	                this.$emit('change', this.valueOnMouseUp);
	            }
	        },
	        onDragMove: function onDragMove(e) {
	            e.preventDefault();
	            if (!this.isDragging && e.type !== 'click') return;
	            var _a = this.$refs.clock.getBoundingClientRect(),
	                width = _a.width,
	                top = _a.top,
	                left = _a.left;
	            var innerWidth = this.$refs.innerClock.getBoundingClientRect().width;
	            var _b = 'touches' in e ? e.touches[0] : e,
	                clientX = _b.clientX,
	                clientY = _b.clientY;
	            var center = { x: width / 2, y: -width / 2 };
	            var coords = { x: clientX - left, y: top - clientY };
	            var handAngle = Math.round(this.angle(center, coords) - this.rotate + 360) % 360;
	            var insideClick = this.double && this.euclidean(center, coords) < (innerWidth + innerWidth * this.innerRadiusScale) / 4;
	            var value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.roundCount : 0);
	            // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
	            var newValue;
	            if (handAngle >= 360 - this.degreesPerUnit / 2) {
	                newValue = insideClick ? this.max - this.roundCount + 1 : this.min;
	            } else {
	                newValue = value;
	            }
	            if (this.isAllowed(value)) {
	                if (this.valueOnMouseDown === null) {
	                    this.valueOnMouseDown = newValue;
	                }
	                this.valueOnMouseUp = newValue;
	                this.update(newValue);
	            }
	        },
	        update: function update(value) {
	            if (this.inputValue !== value) {
	                this.inputValue = value;
	                this.$emit('input', value);
	            }
	        },
	        euclidean: function euclidean(p0, p1) {
	            var dx = p1.x - p0.x;
	            var dy = p1.y - p0.y;
	            return Math.sqrt(dx * dx + dy * dy);
	        },
	        angle: function angle(center, p1) {
	            var value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
	            return Math.abs(value * 180 / Math.PI);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var data = {
	            staticClass: 'v-time-picker-clock',
	            class: __assign({ 'v-time-picker-clock--indeterminate': this.value == null }, this.themeClasses),
	            on: this.readonly ? undefined : {
	                mousedown: this.onMouseDown,
	                mouseup: this.onMouseUp,
	                mouseleave: function mouseleave() {
	                    return _this.isDragging && _this.onMouseUp();
	                },
	                touchstart: this.onMouseDown,
	                touchend: this.onMouseUp,
	                mousemove: this.onDragMove,
	                touchmove: this.onDragMove
	            },
	            ref: 'clock'
	        };
	        !this.readonly && this.scrollable && (data.on.wheel = this.wheel);
	        return h('div', data, [h('div', {
	            staticClass: 'v-time-picker-clock__inner',
	            ref: 'innerClock'
	        }, [this.genHand(), this.genValues()])]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/VTimePickerTitle.js":
	/*!********************************************************!*\
	  !*** ./src/components/VTimePicker/VTimePickerTitle.js ***!
	  \********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_time-picker-title.styl */ "./src/stylus/components/_time-picker-title.styl");
	/* harmony import */ var _stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_time_picker_title_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/picker-button */ "./src/mixins/picker-button.js");
	/* harmony import */ var _VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../VDatePicker/util */ "./src/components/VDatePicker/util/index.js");
	
	// Mixins
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-time-picker-title',
	    mixins: [_mixins_picker_button__WEBPACK_IMPORTED_MODULE_1__["default"]],
	    props: {
	        ampm: Boolean,
	        hour: Number,
	        minute: Number,
	        period: {
	            type: String,
	            validator: function validator(period) {
	                return period === 'am' || period === 'pm';
	            }
	        },
	        readonly: Boolean,
	        selectingHour: Boolean
	    },
	    methods: {
	        genTime: function genTime() {
	            var hour = this.hour;
	            if (this.ampm) {
	                hour = hour ? (hour - 1) % 12 + 1 : 12;
	            }
	            var displayedHour = this.hour == null ? '--' : this.ampm ? hour : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(hour);
	            var displayedMinute = this.minute == null ? '--' : Object(_VDatePicker_util__WEBPACK_IMPORTED_MODULE_2__["pad"])(this.minute);
	            return this.$createElement('div', {
	                'class': 'v-time-picker-title__time'
	            }, [this.genPickerButton('selectingHour', true, displayedHour), this.$createElement('span', ':'), this.genPickerButton('selectingHour', false, displayedMinute)]);
	        },
	        genAmPm: function genAmPm() {
	            return this.$createElement('div', {
	                staticClass: 'v-time-picker-title__ampm'
	            }, [this.genPickerButton('period', 'am', 'am', this.readonly), this.genPickerButton('period', 'pm', 'pm', this.readonly)]);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-time-picker-title'
	        }, [this.genTime(), this.ampm ? this.genAmPm() : null]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTimePicker/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/VTimePicker/index.js ***!
	  \*********************************************/
	/*! exports provided: VTimePicker, VTimePickerClock, VTimePickerTitle, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTimePicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimePicker */ "./src/components/VTimePicker/VTimePicker.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimePickerClock */ "./src/components/VTimePicker/VTimePickerClock.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() { return _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTimePickerTitle */ "./src/components/VTimePicker/VTimePickerTitle.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() { return _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTimePicker: _VTimePicker__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTimePickerClock: _VTimePickerClock__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VTimePickerTitle: _VTimePickerTitle__WEBPACK_IMPORTED_MODULE_2__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/VTimeline.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VTimeline/VTimeline.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_timeline.styl */ "./src/stylus/components/_timeline.styl");
	/* harmony import */ var _stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_timeline_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	
	// Mixins
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-timeline',
	    props: {
	        alignTop: Boolean,
	        dense: Boolean
	    },
	    computed: {
	        classes: function classes() {
	            return __assign({ 'v-timeline--align-top': this.alignTop, 'v-timeline--dense': this.dense }, this.themeClasses);
	        }
	    },
	    render: function render(h) {
	        return h('div', {
	            staticClass: 'v-timeline',
	            'class': this.classes
	        }, this.$slots.default);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/VTimelineItem.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VTimeline/VTimelineItem.ts ***!
	  \***************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Types
	
	// Components
	
	// Mixins
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])(_mixins_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-timeline-item',
	    props: {
	        color: {
	            type: String,
	            default: 'primary'
	        },
	        fillDot: Boolean,
	        hideDot: Boolean,
	        icon: String,
	        iconColor: String,
	        large: Boolean,
	        left: Boolean,
	        right: Boolean,
	        small: Boolean
	    },
	    computed: {
	        hasIcon: function hasIcon() {
	            return !!this.icon || !!this.$slots.icon;
	        }
	    },
	    methods: {
	        genBody: function genBody() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__body'
	            }, this.$slots.default);
	        },
	        genIcon: function genIcon() {
	            if (this.$slots.icon) {
	                return this.$slots.icon;
	            }
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.iconColor,
	                    dark: !this.theme.isDark,
	                    small: this.small
	                }
	            }, this.icon);
	        },
	        genInnerDot: function genInnerDot() {
	            var data = this.setBackgroundColor(this.color);
	            return this.$createElement('div', __assign({ staticClass: 'v-timeline-item__inner-dot' }, data), [this.hasIcon && this.genIcon()]);
	        },
	        genDot: function genDot() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__dot',
	                class: {
	                    'v-timeline-item__dot--small': this.small,
	                    'v-timeline-item__dot--large': this.large
	                }
	            }, [this.genInnerDot()]);
	        },
	        genOpposite: function genOpposite() {
	            return this.$createElement('div', {
	                staticClass: 'v-timeline-item__opposite'
	            }, this.$slots.opposite);
	        }
	    },
	    render: function render(h) {
	        var children = [this.genBody()];
	        if (!this.hideDot) children.unshift(this.genDot());
	        if (this.$slots.opposite) children.push(this.genOpposite());
	        return h('div', {
	            staticClass: 'v-timeline-item',
	            class: __assign({ 'v-timeline-item--fill-dot': this.fillDot, 'v-timeline-item--left': this.left, 'v-timeline-item--right': this.right }, this.themeClasses)
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTimeline/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VTimeline/index.ts ***!
	  \*******************************************/
	/*! exports provided: VTimeline, VTimelineItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTimeline__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTimeline */ "./src/components/VTimeline/VTimeline.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimeline", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTimelineItem */ "./src/components/VTimeline/VTimelineItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() { return _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTimeline: _VTimeline__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTimelineItem: _VTimelineItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/VToolbar.js":
	/*!*********************************************!*\
	  !*** ./src/components/VToolbar/VToolbar.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_toolbar.styl */ "./src/stylus/components/_toolbar.styl");
	/* harmony import */ var _stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_toolbar_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/applicationable */ "./src/mixins/applicationable.ts");
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/ssr-bootable */ "./src/mixins/ssr-bootable.ts");
	/* harmony import */ var _directives_scroll__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../directives/scroll */ "./src/directives/scroll.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Styles
	
	// Mixins
	
	
	
	
	// Directives
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-toolbar',
	    directives: { Scroll: _directives_scroll__WEBPACK_IMPORTED_MODULE_5__["default"] },
	    mixins: [Object(_mixins_applicationable__WEBPACK_IMPORTED_MODULE_1__["default"])('top', ['clippedLeft', 'clippedRight', 'computedHeight', 'invertedScroll', 'manualScroll']), _mixins_colorable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_ssr_bootable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_themeable__WEBPACK_IMPORTED_MODULE_3__["default"]],
	    props: {
	        card: Boolean,
	        clippedLeft: Boolean,
	        clippedRight: Boolean,
	        dense: Boolean,
	        extended: Boolean,
	        extensionHeight: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        flat: Boolean,
	        floating: Boolean,
	        height: {
	            type: [Number, String],
	            validator: function validator(v) {
	                return !isNaN(parseInt(v));
	            }
	        },
	        invertedScroll: Boolean,
	        manualScroll: Boolean,
	        prominent: Boolean,
	        scrollOffScreen: Boolean,
	        /* @deprecated */
	        scrollToolbarOffScreen: Boolean,
	        scrollTarget: String,
	        scrollThreshold: {
	            type: Number,
	            default: 300
	        },
	        tabs: Boolean
	    },
	    data: function data() {
	        return {
	            activeTimeout: null,
	            currentScroll: 0,
	            heights: {
	                mobileLandscape: 48,
	                mobile: 56,
	                desktop: 64,
	                dense: 48
	            },
	            isActive: true,
	            isExtended: false,
	            isScrollingUp: false,
	            previousScroll: null,
	            previousScrollDirection: null,
	            savedScroll: 0,
	            target: null
	        };
	    },
	    computed: {
	        canScroll: function canScroll() {
	            // TODO: remove
	            if (this.scrollToolbarOffScreen) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["deprecate"])('scrollToolbarOffScreen', 'scrollOffScreen', this);
	                return true;
	            }
	            return this.scrollOffScreen || this.invertedScroll;
	        },
	        computedContentHeight: function computedContentHeight() {
	            if (this.height) return parseInt(this.height);
	            if (this.dense) return this.heights.dense;
	            if (this.prominent || this.$vuetify.breakpoint.mdAndUp) return this.heights.desktop;
	            if (this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width > this.$vuetify.breakpoint.height) return this.heights.mobileLandscape;
	            return this.heights.mobile;
	        },
	        computedExtensionHeight: function computedExtensionHeight() {
	            if (this.tabs) return 48;
	            if (this.extensionHeight) return parseInt(this.extensionHeight);
	            return this.computedContentHeight;
	        },
	        computedHeight: function computedHeight() {
	            if (!this.isExtended) return this.computedContentHeight;
	            return this.computedContentHeight + this.computedExtensionHeight;
	        },
	        computedMarginTop: function computedMarginTop() {
	            if (!this.app) return 0;
	            return this.$vuetify.application.bar;
	        },
	        classes: function classes() {
	            return __assign({ 'v-toolbar': true, 'elevation-0': this.flat || !this.isActive && !this.tabs && this.canScroll, 'v-toolbar--absolute': this.absolute, 'v-toolbar--card': this.card, 'v-toolbar--clipped': this.clippedLeft || this.clippedRight, 'v-toolbar--dense': this.dense, 'v-toolbar--extended': this.isExtended, 'v-toolbar--fixed': !this.absolute && (this.app || this.fixed), 'v-toolbar--floating': this.floating, 'v-toolbar--prominent': this.prominent }, this.themeClasses);
	        },
	        computedPaddingLeft: function computedPaddingLeft() {
	            if (!this.app || this.clippedLeft) return 0;
	            return this.$vuetify.application.left;
	        },
	        computedPaddingRight: function computedPaddingRight() {
	            if (!this.app || this.clippedRight) return 0;
	            return this.$vuetify.application.right;
	        },
	        computedTransform: function computedTransform() {
	            return !this.isActive ? this.canScroll ? -this.computedContentHeight : -this.computedHeight : 0;
	        },
	        currentThreshold: function currentThreshold() {
	            return Math.abs(this.currentScroll - this.savedScroll);
	        },
	        styles: function styles() {
	            return {
	                marginTop: this.computedMarginTop + "px",
	                paddingRight: this.computedPaddingRight + "px",
	                paddingLeft: this.computedPaddingLeft + "px",
	                transform: "translateY(" + this.computedTransform + "px)"
	            };
	        }
	    },
	    watch: {
	        currentThreshold: function currentThreshold(val) {
	            if (this.invertedScroll) {
	                return this.isActive = this.currentScroll > this.scrollThreshold;
	            }
	            if (val < this.scrollThreshold || !this.isBooted) return;
	            this.isActive = this.isScrollingUp;
	            this.savedScroll = this.currentScroll;
	        },
	        isActive: function isActive() {
	            this.savedScroll = 0;
	        },
	        invertedScroll: function invertedScroll(val) {
	            this.isActive = !val;
	        },
	        manualScroll: function manualScroll(val) {
	            this.isActive = !val;
	        },
	        isScrollingUp: function isScrollingUp() {
	            this.savedScroll = this.savedScroll || this.currentScroll;
	        }
	    },
	    created: function created() {
	        if (this.invertedScroll || this.manualScroll) this.isActive = false;
	    },
	    mounted: function mounted() {
	        if (this.scrollTarget) {
	            this.target = document.querySelector(this.scrollTarget);
	        }
	    },
	    methods: {
	        onScroll: function onScroll() {
	            if (!this.canScroll || this.manualScroll || typeof window === 'undefined') return;
	            var target = this.target || window;
	            this.currentScroll = this.scrollTarget ? target.scrollTop : target.pageYOffset || document.documentElement.scrollTop;
	            this.isScrollingUp = this.currentScroll < this.previousScroll;
	            this.previousScroll = this.currentScroll;
	        },
	        /**
	         * Update the application layout
	         *
	         * @return {number}
	         */
	        updateApplication: function updateApplication() {
	            return this.invertedScroll || this.manualScroll ? 0 : this.computedHeight;
	        }
	    },
	    render: function render(h) {
	        this.isExtended = this.extended || !!this.$slots.extension;
	        var children = [];
	        var data = this.setBackgroundColor(this.color, {
	            'class': this.classes,
	            style: this.styles,
	            on: this.$listeners
	        });
	        data.directives = [{
	            arg: this.scrollTarget,
	            name: 'scroll',
	            value: this.onScroll
	        }];
	        children.push(h('div', {
	            staticClass: 'v-toolbar__content',
	            style: { height: this.computedContentHeight + "px" },
	            ref: 'content'
	        }, this.$slots.default));
	        if (this.isExtended) {
	            children.push(h('div', {
	                staticClass: 'v-toolbar__extension',
	                style: { height: this.computedExtensionHeight + "px" }
	            }, this.$slots.extension));
	        }
	        return h('nav', data, children);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/VToolbarSideIcon.js":
	/*!*****************************************************!*\
	  !*** ./src/components/VToolbar/VToolbarSideIcon.js ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../components/VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _components_VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../components/VIcon */ "./src/components/VIcon/index.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-toolbar-side-icon',
	    functional: true,
	    render: function render(h, _a) {
	        var slots = _a.slots,
	            listeners = _a.listeners,
	            props = _a.props,
	            data = _a.data;
	        var classes = data.staticClass ? data.staticClass + " v-toolbar__side-icon" : 'v-toolbar__side-icon';
	        var d = Object.assign(data, {
	            staticClass: classes,
	            props: Object.assign(props, {
	                icon: true
	            }),
	            on: listeners
	        });
	        var defaultSlot = slots().default;
	        return h(_components_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], d, defaultSlot || [h(_components_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], '$vuetify.icons.menu')]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VToolbar/index.js":
	/*!******************************************!*\
	  !*** ./src/components/VToolbar/index.js ***!
	  \******************************************/
	/*! exports provided: VToolbar, VToolbarSideIcon, VToolbarTitle, VToolbarItems, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() { return VToolbarTitle; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() { return VToolbarItems; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _VToolbar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VToolbar */ "./src/components/VToolbar/VToolbar.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VToolbarSideIcon */ "./src/components/VToolbar/VToolbarSideIcon.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarSideIcon", function() { return _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	
	
	
	var VToolbarTitle = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-toolbar__title');
	var VToolbarItems = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleFunctional"])('v-toolbar__items');
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VToolbar: _VToolbar__WEBPACK_IMPORTED_MODULE_1__["default"],
	        VToolbarItems: VToolbarItems,
	        VToolbarTitle: VToolbarTitle,
	        VToolbarSideIcon: _VToolbarSideIcon__WEBPACK_IMPORTED_MODULE_2__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTooltip/VTooltip.js":
	/*!*********************************************!*\
	  !*** ./src/components/VTooltip/VTooltip.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_tooltips.styl */ "./src/stylus/components/_tooltips.styl");
	/* harmony import */ var _stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_tooltips_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/delayable */ "./src/mixins/delayable.ts");
	/* harmony import */ var _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/dependent */ "./src/mixins/dependent.ts");
	/* harmony import */ var _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../mixins/detachable */ "./src/mixins/detachable.js");
	/* harmony import */ var _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../mixins/menuable */ "./src/mixins/menuable.js");
	/* harmony import */ var _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../mixins/toggleable */ "./src/mixins/toggleable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	
	// Mixins
	
	
	
	
	
	
	// Helpers
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'v-tooltip',
	    mixins: [_mixins_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _mixins_delayable__WEBPACK_IMPORTED_MODULE_2__["default"], _mixins_dependent__WEBPACK_IMPORTED_MODULE_3__["default"], _mixins_detachable__WEBPACK_IMPORTED_MODULE_4__["default"], _mixins_menuable__WEBPACK_IMPORTED_MODULE_5__["default"], _mixins_toggleable__WEBPACK_IMPORTED_MODULE_6__["default"]],
	    props: {
	        closeDelay: {
	            type: [Number, String],
	            default: 200
	        },
	        debounce: {
	            type: [Number, String],
	            default: 0
	        },
	        disabled: Boolean,
	        fixed: {
	            type: Boolean,
	            default: true
	        },
	        openDelay: {
	            type: [Number, String],
	            default: 200
	        },
	        tag: {
	            type: String,
	            default: 'span'
	        },
	        transition: String,
	        zIndex: {
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            calculatedMinWidth: 0,
	            closeDependents: false
	        };
	    },
	    computed: {
	        calculatedLeft: function calculatedLeft() {
	            var _a = this.dimensions,
	                activator = _a.activator,
	                content = _a.content;
	            var unknown = !this.bottom && !this.left && !this.top && !this.right;
	            var left = 0;
	            if (this.top || this.bottom || unknown) {
	                left = activator.left + activator.width / 2 - content.width / 2;
	            } else if (this.left || this.right) {
	                left = activator.left + (this.right ? activator.width : -content.width) + (this.right ? 10 : -10);
	            }
	            if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
	            if (this.nudgeRight) left += parseInt(this.nudgeRight);
	            return this.calcXOverflow(left) + "px";
	        },
	        calculatedTop: function calculatedTop() {
	            var _a = this.dimensions,
	                activator = _a.activator,
	                content = _a.content;
	            var top = 0;
	            if (this.top || this.bottom) {
	                top = activator.top + (this.bottom ? activator.height : -content.height) + (this.bottom ? 10 : -10);
	            } else if (this.left || this.right) {
	                top = activator.top + activator.height / 2 - content.height / 2;
	            }
	            if (this.nudgeTop) top -= parseInt(this.nudgeTop);
	            if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
	            return this.calcYOverflow(top + this.pageYOffset) + "px";
	        },
	        classes: function classes() {
	            return {
	                'v-tooltip--top': this.top,
	                'v-tooltip--right': this.right,
	                'v-tooltip--bottom': this.bottom,
	                'v-tooltip--left': this.left
	            };
	        },
	        computedTransition: function computedTransition() {
	            if (this.transition) return this.transition;
	            if (this.top) return 'slide-y-reverse-transition';
	            if (this.right) return 'slide-x-transition';
	            if (this.bottom) return 'slide-y-transition';
	            if (this.left) return 'slide-x-reverse-transition';
	        },
	        offsetY: function offsetY() {
	            return this.top || this.bottom;
	        },
	        offsetX: function offsetX() {
	            return this.left || this.right;
	        },
	        styles: function styles() {
	            return {
	                left: this.calculatedLeft,
	                maxWidth: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_7__["convertToUnit"])(this.maxWidth),
	                opacity: this.isActive ? 0.9 : 0,
	                top: this.calculatedTop,
	                zIndex: this.zIndex || this.activeZIndex
	            };
	        }
	    },
	    mounted: function mounted() {
	        this.value && this.callActivate();
	    },
	    methods: {
	        activate: function activate() {
	            // Update coordinates and dimensions of menu
	            // and its activator
	            this.updateDimensions();
	            // Start the transition
	            requestAnimationFrame(this.startTransition);
	        }
	    },
	    render: function render(h) {
	        var _this = this;
	        var _a;
	        var tooltip = h('div', this.setBackgroundColor(this.color, {
	            staticClass: 'v-tooltip__content',
	            'class': (_a = {}, _a[this.contentClass] = true, _a['menuable__content__active'] = this.isActive, _a),
	            style: this.styles,
	            attrs: this.getScopeIdAttrs(),
	            directives: [{
	                name: 'show',
	                value: this.isContentActive
	            }],
	            ref: 'content'
	        }), this.showLazyContent(this.$slots.default));
	        return h(this.tag, {
	            staticClass: 'v-tooltip',
	            'class': this.classes
	        }, [h('transition', {
	            props: {
	                name: this.computedTransition
	            }
	        }, [tooltip]), h('span', {
	            on: this.disabled ? {} : {
	                mouseenter: function mouseenter() {
	                    _this.runDelay('open');
	                },
	                mouseleave: function mouseleave() {
	                    _this.runDelay('close');
	                }
	            },
	            ref: 'activator'
	        }, this.$slots.activator)]);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VTooltip/index.js":
	/*!******************************************!*\
	  !*** ./src/components/VTooltip/index.js ***!
	  \******************************************/
	/*! exports provided: VTooltip, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTooltip */ "./src/components/VTooltip/VTooltip.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return _VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = (_VTooltip__WEBPACK_IMPORTED_MODULE_0__["default"]);
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/VTreeview.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VTreeview/VTreeview.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_treeview.styl */ "./src/stylus/components/_treeview.styl");
	/* harmony import */ var _stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_treeview_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	// Styles
	
	// Components
	
	// Mixins
	
	
	// Utils
	
	
	
	function ston(s) {
	    var n = Number(s);
	    return !isNaN(n) ? n : s;
	}
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_5__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["provide"])('treeview'), _mixins_themeable__WEBPACK_IMPORTED_MODULE_2__["default"]
	/* @vue/component */
	).extend({
	    name: 'v-treeview',
	    provide: function provide() {
	        return { treeview: this };
	    },
	    props: __assign({ active: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, items: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, hoverable: Boolean, multipleActive: Boolean, open: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        }, openAll: Boolean, value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        } }, _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["VTreeviewNodeProps"]),
	    data: function data() {
	        return {
	            nodes: {},
	            selectedCache: new Set(),
	            activeCache: new Set(),
	            openCache: new Set()
	        };
	    },
	    watch: {
	        items: {
	            handler: function handler() {
	                // We only care if nodes are removed or added
	                if (Object.keys(this.nodes).length === this.countItems(this.items)) return;
	                var oldSelectedCache = __spread(this.selectedCache);
	                this.selectedCache = new Set();
	                this.activeCache = new Set();
	                this.openCache = new Set();
	                this.buildTree(this.items);
	                // Only emit selected if selection has changed
	                // as a result of items changing. This fixes a
	                // potential double emit when selecting a node
	                // with dynamic children
	                if (!Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(oldSelectedCache, __spread(this.selectedCache))) this.emitSelected();
	            },
	            deep: true
	        },
	        active: function active(value) {
	            var _this = this;
	            var old = __spread(this.activeCache);
	            if (!value || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(old, value)) return;
	            old.forEach(function (key) {
	                return _this.updateActive(key, false);
	            });
	            value.forEach(function (key) {
	                return _this.updateActive(key, true);
	            });
	            this.emitActive();
	        },
	        value: function value(_value) {
	            var _this = this;
	            var old = __spread(this.selectedCache);
	            if (!_value || Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(old, _value)) return;
	            old.forEach(function (key) {
	                return _this.updateSelected(key, false);
	            });
	            _value.forEach(function (key) {
	                return _this.updateSelected(key, true);
	            });
	            this.emitSelected();
	        },
	        open: function open(value) {
	            var _this = this;
	            var old = __spread(this.openCache);
	            if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["deepEqual"])(old, value)) return;
	            old.forEach(function (key) {
	                return _this.updateOpen(key, false);
	            });
	            value.forEach(function (key) {
	                return _this.updateOpen(key, true);
	            });
	            this.emitOpen();
	        }
	    },
	    created: function created() {
	        var _this = this;
	        this.buildTree(this.items);
	        this.value.forEach(function (key) {
	            return _this.updateSelected(key, true);
	        });
	        this.emitSelected();
	        this.active.forEach(function (key) {
	            return _this.updateActive(key, true);
	        });
	        this.emitActive();
	    },
	    mounted: function mounted() {
	        var _this = this;
	        // Save the developer from themselves
	        if (this.$slots.prepend || this.$slots.append) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_6__["consoleWarn"])('The prepend and append slots require a slot-scope attribute', this);
	        }
	        if (this.openAll) {
	            Object.keys(this.nodes).forEach(function (key) {
	                return _this.updateOpen(ston(key), true);
	            });
	        } else {
	            this.open.forEach(function (key) {
	                return _this.updateOpen(key, true);
	            });
	        }
	        this.emitOpen();
	    },
	    methods: {
	        buildTree: function buildTree(items, parent) {
	            var _this = this;
	            if (parent === void 0) {
	                parent = null;
	            }
	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemKey);
	                var children = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(item, this.itemChildren, []);
	                var oldNode = this.nodes.hasOwnProperty(key) ? this.nodes[key] : {
	                    isSelected: false, isIndeterminate: false, isActive: false, isOpen: false, vnode: null
	                };
	                var node = {
	                    vnode: oldNode.vnode,
	                    parent: parent,
	                    children: children.map(function (c) {
	                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(c, _this.itemKey);
	                    })
	                };
	                this.buildTree(children, key);
	                // This fixed bug with dynamic children resetting selected parent state
	                if (!this.nodes.hasOwnProperty(key) && parent !== null && this.nodes.hasOwnProperty(parent)) {
	                    node.isSelected = this.nodes[parent].isSelected;
	                    node.isIndeterminate = this.nodes[parent].isIndeterminate;
	                } else {
	                    node.isSelected = oldNode.isSelected;
	                    node.isIndeterminate = oldNode.isIndeterminate;
	                }
	                node.isActive = oldNode.isActive;
	                node.isOpen = oldNode.isOpen;
	                this.nodes[key] = !children.length ? node : this.calculateState(node, this.nodes);
	                // Don't forget to rebuild cache
	                if (this.nodes[key].isSelected) this.selectedCache.add(key);
	                if (this.nodes[key].isActive) this.activeCache.add(key);
	                if (this.nodes[key].isOpen) this.openCache.add(key);
	                this.updateVnodeState(key);
	            }
	        },
	        countItems: function countItems(items) {
	            var count = 0;
	            for (var i = 0; i < items.length; i++) {
	                var item = items[i];
	                count += 1;
	                count += item.children ? this.countItems(item.children) : 0;
	            }
	            return count;
	        },
	        calculateState: function calculateState(node, state) {
	            var counts = node.children.reduce(function (counts, child) {
	                counts[0] += +Boolean(state[child].isSelected);
	                counts[1] += +Boolean(state[child].isIndeterminate);
	                return counts;
	            }, [0, 0]);
	            node.isSelected = !!node.children.length && counts[0] === node.children.length;
	            node.isIndeterminate = !node.isSelected && (counts[0] > 0 || counts[1] > 0);
	            return node;
	        },
	        emitOpen: function emitOpen() {
	            this.$emit('update:open', __spread(this.openCache));
	        },
	        emitSelected: function emitSelected() {
	            this.$emit('input', __spread(this.selectedCache));
	        },
	        emitActive: function emitActive() {
	            this.$emit('update:active', __spread(this.activeCache));
	        },
	        getDescendants: function getDescendants(key, descendants) {
	            if (descendants === void 0) {
	                descendants = [];
	            }
	            var children = this.nodes[key].children;
	            descendants.push.apply(descendants, __spread(children));
	            for (var i = 0; i < children.length; i++) {
	                descendants = this.getDescendants(children[i], descendants);
	            }
	            return descendants;
	        },
	        getParents: function getParents(key) {
	            var parent = this.nodes[key].parent;
	            var parents = [];
	            while (parent !== null) {
	                parents.push(parent);
	                parent = this.nodes[parent].parent;
	            }
	            return parents;
	        },
	        register: function register(node) {
	            var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node.item, this.itemKey);
	            this.nodes[key].vnode = node;
	            this.updateVnodeState(key);
	        },
	        unregister: function unregister(node) {
	            var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_4__["getObjectValueByPath"])(node.item, this.itemKey);
	            this.nodes[key].vnode = null;
	        },
	        updateActive: function updateActive(key, isActive) {
	            var _this = this;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            if (!this.multipleActive) {
	                this.activeCache.forEach(function (active) {
	                    _this.nodes[active].isActive = false;
	                    _this.updateVnodeState(active);
	                    _this.activeCache.delete(active);
	                });
	            }
	            var node = this.nodes[key];
	            if (!node) return;
	            if (isActive) this.activeCache.add(key);else this.activeCache.delete(key);
	            node.isActive = isActive;
	            this.updateVnodeState(key);
	        },
	        updateSelected: function updateSelected(key, isSelected) {
	            var _this = this;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            var changed = {};
	            var descendants = __spread([key], this.getDescendants(key));
	            descendants.forEach(function (descendant) {
	                _this.nodes[descendant].isSelected = isSelected;
	                _this.nodes[descendant].isIndeterminate = false;
	                changed[descendant] = isSelected;
	            });
	            var parents = this.getParents(key);
	            parents.forEach(function (parent) {
	                _this.nodes[parent] = _this.calculateState(_this.nodes[parent], _this.nodes);
	                changed[parent] = _this.nodes[parent].isSelected;
	            });
	            var all = __spread([key], descendants, parents);
	            all.forEach(this.updateVnodeState);
	            Object.keys(changed).forEach(function (k) {
	                changed[k] === true ? _this.selectedCache.add(ston(k)) : _this.selectedCache.delete(ston(k));
	            });
	        },
	        updateOpen: function updateOpen(key, isOpen) {
	            var _this = this;
	            if (!this.nodes.hasOwnProperty(key)) return;
	            var node = this.nodes[key];
	            if (node.children && !node.children.length && node.vnode && !node.vnode.hasLoaded) {
	                node.vnode.checkChildren().then(function () {
	                    return _this.updateOpen(key, isOpen);
	                });
	            } else {
	                node.isOpen = isOpen;
	                node.isOpen ? this.openCache.add(key) : this.openCache.delete(key);
	                this.updateVnodeState(key);
	            }
	        },
	        updateVnodeState: function updateVnodeState(key) {
	            var node = this.nodes[key];
	            if (node && node.vnode) {
	                node.vnode.isSelected = node.isSelected;
	                node.vnode.isIndeterminate = node.isIndeterminate;
	                node.vnode.isActive = node.isActive;
	                node.vnode.isOpen = node.isOpen;
	            }
	        }
	    },
	    render: function render(h) {
	        var children = this.items.length ? this.items.map(_VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"].options.methods.genChild.bind(this))
	        /* istanbul ignore next */
	        : this.$slots.default; // TODO: remove type annotation with TS 3.2
	        return h('div', {
	            staticClass: 'v-treeview',
	            class: __assign({ 'v-treeview--hoverable': this.hoverable }, this.themeClasses)
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/VTreeviewNode.ts":
	/*!***************************************************!*\
	  !*** ./src/components/VTreeview/VTreeviewNode.ts ***!
	  \***************************************************/
	/*! exports provided: VTreeviewNodeProps, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNodeProps", function() { return VTreeviewNodeProps; });
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../transitions */ "./src/components/transitions/index.js");
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony import */ var _mixins_registrable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../mixins/registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	// Components
	
	
	
	// Mixins
	
	// Utils
	
	
	var VTreeviewNodeProps = {
	    activatable: Boolean,
	    activeClass: {
	        type: String,
	        default: 'v-treeview-node--active'
	    },
	    selectable: Boolean,
	    selectedColor: {
	        type: String,
	        default: 'accent'
	    },
	    indeterminateIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxIndeterminate'
	    },
	    onIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxOn'
	    },
	    offIcon: {
	        type: String,
	        default: '$vuetify.icons.checkboxOff'
	    },
	    expandIcon: {
	        type: String,
	        default: '$vuetify.icons.subgroup'
	    },
	    loadingIcon: {
	        type: String,
	        default: '$vuetify.icons.loading'
	    },
	    itemKey: {
	        type: String,
	        default: 'id'
	    },
	    itemText: {
	        type: String,
	        default: 'name'
	    },
	    itemChildren: {
	        type: String,
	        default: 'children'
	    },
	    loadChildren: Function,
	    openOnClick: Boolean,
	    transition: Boolean
	};
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(Object(_mixins_registrable__WEBPACK_IMPORTED_MODULE_3__["inject"])('treeview')
	/* @vue/component */
	).extend({
	    name: 'v-treeview-node',
	    inject: {
	        treeview: {
	            default: null
	        }
	    },
	    props: __assign({ item: {
	            type: Object,
	            default: function _default() {
	                return null;
	            }
	        } }, VTreeviewNodeProps),
	    data: function data() {
	        return {
	            isOpen: false,
	            isSelected: false,
	            isIndeterminate: false,
	            isActive: false,
	            isLoading: false,
	            hasLoaded: false
	        };
	    },
	    computed: {
	        key: function key() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemKey);
	        },
	        children: function children() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemChildren);
	        },
	        text: function text() {
	            return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(this.item, this.itemText);
	        },
	        scopedProps: function scopedProps() {
	            return {
	                item: this.item,
	                leaf: !this.children,
	                selected: this.isSelected,
	                indeterminate: this.isIndeterminate,
	                active: this.isActive,
	                open: this.isOpen
	            };
	        },
	        computedIcon: function computedIcon() {
	            if (this.isIndeterminate) return this.indeterminateIcon;else if (this.isSelected) return this.onIcon;else return this.offIcon;
	        },
	        hasChildren: function hasChildren() {
	            return !!this.children && (!!this.children.length || !!this.loadChildren);
	        }
	    },
	    created: function created() {
	        this.treeview.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.treeview.unregister(this);
	    },
	    methods: {
	        checkChildren: function checkChildren() {
	            var _this = this;
	            return new Promise(function (resolve) {
	                // TODO: Potential issue with always trying
	                // to load children if response is empty?
	                if (!_this.children || _this.children.length || !_this.loadChildren || _this.hasLoaded) return resolve();
	                _this.isLoading = true;
	                resolve(_this.loadChildren(_this.item));
	            }).then(function () {
	                _this.isLoading = false;
	                _this.hasLoaded = true;
	            });
	        },
	        open: function open() {
	            this.isOpen = !this.isOpen;
	            this.treeview.updateOpen(this.key, this.isOpen);
	            this.treeview.emitOpen();
	        },
	        genLabel: function genLabel() {
	            return this.$createElement('label', {
	                slot: 'label',
	                staticClass: 'v-treeview-node__label'
	            }, [this.text]);
	        },
	        genContent: function genContent() {
	            var children = [this.$scopedSlots.prepend && this.$scopedSlots.prepend(this.scopedProps), this.genLabel(), this.$scopedSlots.append && this.$scopedSlots.append(this.scopedProps)];
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__content'
	            }, children);
	        },
	        genToggle: function genToggle() {
	            var _this = this;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
	                staticClass: 'v-treeview-node__toggle',
	                class: {
	                    'v-treeview-node__toggle--open': this.isOpen,
	                    'v-treeview-node__toggle--loading': this.isLoading
	                },
	                slot: 'prepend',
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (_this.isLoading) return;
	                        _this.checkChildren().then(function () {
	                            return _this.open();
	                        });
	                    }
	                }
	            }, [this.isLoading ? this.loadingIcon : this.expandIcon]);
	        },
	        genCheckbox: function genCheckbox() {
	            var _this = this;
	            return this.$createElement(_VIcon__WEBPACK_IMPORTED_MODULE_1__["VIcon"], {
	                staticClass: 'v-treeview-node__checkbox',
	                props: {
	                    color: this.isSelected ? this.selectedColor : undefined
	                },
	                on: {
	                    click: function click(e) {
	                        e.stopPropagation();
	                        if (_this.isLoading) return;
	                        _this.checkChildren().then(function () {
	                            // We nextTick here so that items watch in VTreeview has a chance to run first
	                            _this.$nextTick(function () {
	                                _this.isSelected = !_this.isSelected;
	                                _this.isIndeterminate = false;
	                                _this.treeview.updateSelected(_this.key, _this.isSelected);
	                                _this.treeview.emitSelected();
	                            });
	                        });
	                    }
	                }
	            }, [this.computedIcon]);
	        },
	        genNode: function genNode() {
	            var _this = this;
	            var children = [this.genContent()];
	            if (this.selectable) children.unshift(this.genCheckbox());
	            if (this.hasChildren) children.unshift(this.genToggle());
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__root',
	                on: {
	                    click: function click() {
	                        if (_this.openOnClick && _this.children) {
	                            _this.open();
	                        } else if (_this.activatable) {
	                            _this.isActive = !_this.isActive;
	                            _this.treeview.updateActive(_this.key, _this.isActive);
	                            _this.treeview.emitActive();
	                        }
	                    }
	                }
	            }, children);
	        },
	        genChild: function genChild(item) {
	            return this.$createElement(_VTreeviewNode__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                key: Object(_util_helpers__WEBPACK_IMPORTED_MODULE_5__["getObjectValueByPath"])(item, this.itemKey),
	                props: {
	                    activatable: this.activatable,
	                    activeClass: this.activeClass,
	                    item: item,
	                    selectable: this.selectable,
	                    selectedColor: this.selectedColor,
	                    expandIcon: this.expandIcon,
	                    indeterminateIcon: this.indeterminateIcon,
	                    offIcon: this.offIcon,
	                    onIcon: this.onIcon,
	                    loadingIcon: this.loadingIcon,
	                    itemKey: this.itemKey,
	                    itemText: this.itemText,
	                    itemChildren: this.itemChildren,
	                    loadChildren: this.loadChildren,
	                    transition: this.transition,
	                    openOnClick: this.openOnClick
	                },
	                scopedSlots: this.$scopedSlots
	            });
	        },
	        genChildrenWrapper: function genChildrenWrapper() {
	            if (!this.isOpen || !this.children) return null;
	            var children = [this.children.map(this.genChild)];
	            return this.$createElement('div', {
	                staticClass: 'v-treeview-node__children'
	            }, children);
	        },
	        genTransition: function genTransition() {
	            return this.$createElement(_transitions__WEBPACK_IMPORTED_MODULE_0__["VExpandTransition"], [this.genChildrenWrapper()]);
	        }
	    },
	    render: function render(h) {
	        var _a;
	        var children = [this.genNode()];
	        if (this.transition) children.push(this.genTransition());else children.push(this.genChildrenWrapper());
	        return h('div', {
	            staticClass: 'v-treeview-node',
	            class: (_a = {}, _a[this.activeClass] = this.isActive, _a['v-treeview-node--leaf'] = !this.hasChildren, _a['v-treeview-node--click'] = this.openOnClick, _a['v-treeview-node--selected'] = this.isSelected, _a)
	        }, children);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VTreeview/index.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VTreeview/index.ts ***!
	  \*******************************************/
	/*! exports provided: VTreeview, VTreeviewNode, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VTreeview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VTreeview */ "./src/components/VTreeview/VTreeview.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeview", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VTreeviewNode */ "./src/components/VTreeview/VTreeviewNode.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() { return _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VTreeview: _VTreeview__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VTreeviewNode: _VTreeviewNode__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/VWindow/VWindow.ts":
	/*!*******************************************!*\
	  !*** ./src/components/VWindow/VWindow.ts ***!
	  \*******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../stylus/components/_windows.styl */ "./src/stylus/components/_windows.styl");
	/* harmony import */ var _stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_windows_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	// Styles
	
	// Components
	
	// Directives
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_1__["BaseItemGroup"].extend({
	    name: 'v-window',
	    provide: function provide() {
	        return {
	            windowGroup: this
	        };
	    },
	    directives: { Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_2__["default"] },
	    props: {
	        mandatory: {
	            type: Boolean,
	            default: true
	        },
	        reverse: {
	            type: Boolean,
	            default: undefined
	        },
	        touch: Object,
	        touchless: Boolean,
	        value: {
	            required: false
	        },
	        vertical: Boolean
	    },
	    data: function data() {
	        return {
	            internalHeight: undefined,
	            isActive: false,
	            isBooted: false,
	            isReverse: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            if (!this.isBooted) return '';
	            var axis = this.vertical ? 'y' : 'x';
	            var direction = this.internalReverse === !this.$vuetify.rtl ? '-reverse' : '';
	            return "v-window-" + axis + direction + "-transition";
	        },
	        internalIndex: function internalIndex() {
	            var _this = this;
	            return this.items.findIndex(function (item, i) {
	                return _this.internalValue === _this.getValue(item, i);
	            });
	        },
	        internalReverse: function internalReverse() {
	            if (this.reverse !== undefined) return this.reverse;
	            return this.isReverse;
	        }
	    },
	    watch: {
	        internalIndex: 'updateReverse'
	    },
	    mounted: function mounted() {
	        var _this = this;
	        this.$nextTick(function () {
	            return _this.isBooted = true;
	        });
	    },
	    methods: {
	        genContainer: function genContainer() {
	            return this.$createElement('div', {
	                staticClass: 'v-window__container',
	                class: {
	                    'v-window__container--is-active': this.isActive
	                },
	                style: {
	                    height: this.internalHeight
	                }
	            }, this.$slots.default);
	        },
	        next: function next() {
	            this.isReverse = false;
	            var nextIndex = (this.internalIndex + 1) % this.items.length;
	            var item = this.items[nextIndex];
	            this.internalValue = this.getValue(item, nextIndex);
	        },
	        prev: function prev() {
	            this.isReverse = true;
	            var lastIndex = (this.internalIndex + this.items.length - 1) % this.items.length;
	            var item = this.items[lastIndex];
	            this.internalValue = this.getValue(item, lastIndex);
	        },
	        updateReverse: function updateReverse(val, oldVal) {
	            this.isReverse = val < oldVal;
	        }
	    },
	    render: function render(h) {
	        var data = {
	            staticClass: 'v-window',
	            directives: []
	        };
	        if (!this.touchless) {
	            var value = this.touch || {
	                left: this.next,
	                right: this.prev
	            };
	            data.directives.push({
	                name: 'touch',
	                value: value
	            });
	        }
	        return h('div', data, [this.genContainer()]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VWindow/VWindowItem.ts":
	/*!***********************************************!*\
	  !*** ./src/components/VWindow/VWindowItem.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../mixins/bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _mixins_groupable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../mixins/groupable */ "./src/mixins/groupable.ts");
	/* harmony import */ var _directives_touch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../directives/touch */ "./src/directives/touch.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/mixins */ "./src/util/mixins.ts");
	// Mixins
	
	
	// Directives
	
	// Utilities
	
	
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_4__["default"])(_mixins_bootable__WEBPACK_IMPORTED_MODULE_0__["default"], Object(_mixins_groupable__WEBPACK_IMPORTED_MODULE_1__["factory"])('windowGroup', 'v-window-item', 'v-window')
	/* @vue/component */
	).extend({
	    name: 'v-window-item',
	    directives: {
	        Touch: _directives_touch__WEBPACK_IMPORTED_MODULE_2__["default"]
	    },
	    props: {
	        reverseTransition: {
	            type: [Boolean, String],
	            default: undefined
	        },
	        transition: {
	            type: [Boolean, String],
	            default: undefined
	        },
	        value: {
	            required: false
	        }
	    },
	    data: function data() {
	        return {
	            done: null,
	            isActive: false,
	            wasCancelled: false
	        };
	    },
	    computed: {
	        computedTransition: function computedTransition() {
	            if (!this.windowGroup.internalReverse) {
	                return typeof this.transition !== 'undefined' ? this.transition || '' : this.windowGroup.computedTransition;
	            }
	            return typeof this.reverseTransition !== 'undefined' ? this.reverseTransition || '' : this.windowGroup.computedTransition;
	        }
	    },
	    mounted: function mounted() {
	        this.$el.addEventListener('transitionend', this.onTransitionEnd, false);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.$el.removeEventListener('transitionend', this.onTransitionEnd, false);
	    },
	    methods: {
	        genDefaultSlot: function genDefaultSlot() {
	            return this.$slots.default;
	        },
	        onAfterEnter: function onAfterEnter() {
	            var _this = this;
	            if (this.wasCancelled) {
	                this.wasCancelled = false;
	                return;
	            }
	            requestAnimationFrame(function () {
	                _this.windowGroup.internalHeight = undefined;
	                _this.windowGroup.isActive = false;
	            });
	        },
	        onBeforeEnter: function onBeforeEnter() {
	            this.windowGroup.isActive = true;
	        },
	        onLeave: function onLeave(el) {
	            this.windowGroup.internalHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(el.clientHeight);
	        },
	        onEnterCancelled: function onEnterCancelled() {
	            this.wasCancelled = true;
	        },
	        onEnter: function onEnter(el, done) {
	            var _this = this;
	            var isBooted = this.windowGroup.isBooted;
	            if (isBooted) this.done = done;
	            requestAnimationFrame(function () {
	                if (!_this.computedTransition) return done();
	                _this.windowGroup.internalHeight = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_3__["convertToUnit"])(el.clientHeight);
	                // On initial render, there is no transition
	                // Vue leaves a `enter` transition class
	                // if done is called too fast
	                !isBooted && setTimeout(done, 100);
	            });
	        },
	        onTransitionEnd: function onTransitionEnd(e) {
	            // This ensures we only call done
	            // when the element transform
	            // completes
	            if (e.propertyName !== 'transform' || e.target !== this.$el || !this.done) return;
	            this.done();
	            this.done = null;
	        }
	    },
	    render: function render(h) {
	        var div = h('div', {
	            staticClass: 'v-window-item',
	            directives: [{
	                name: 'show',
	                value: this.isActive
	            }],
	            on: this.$listeners
	        }, this.showLazyContent(this.genDefaultSlot()));
	        return h('transition', {
	            props: {
	                name: this.computedTransition
	            },
	            on: {
	                afterEnter: this.onAfterEnter,
	                beforeEnter: this.onBeforeEnter,
	                leave: this.onLeave,
	                enter: this.onEnter,
	                enterCancelled: this.onEnterCancelled
	            }
	        }, [div]);
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/components/VWindow/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/VWindow/index.ts ***!
	  \*****************************************/
	/*! exports provided: VWindow, VWindowItem, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VWindow */ "./src/components/VWindow/VWindow.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindow", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _VWindowItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VWindowItem */ "./src/components/VWindow/VWindowItem.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindowItem", function() { return _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VWindow: _VWindow__WEBPACK_IMPORTED_MODULE_0__["default"],
	        VWindowItem: _VWindowItem__WEBPACK_IMPORTED_MODULE_1__["default"]
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/index.ts":
	/*!*****************************************!*\
	  !*** ./src/components/Vuetify/index.ts ***!
	  \*****************************************/
	/*! exports provided: checkVueVersion, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkVueVersion", function() { return checkVueVersion; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _mixins_application__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins/application */ "./src/components/Vuetify/mixins/application.ts");
	/* harmony import */ var _mixins_breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mixins/breakpoint */ "./src/components/Vuetify/mixins/breakpoint.ts");
	/* harmony import */ var _mixins_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./mixins/theme */ "./src/components/Vuetify/mixins/theme.ts");
	/* harmony import */ var _mixins_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mixins/icons */ "./src/components/Vuetify/mixins/icons.js");
	/* harmony import */ var _mixins_options__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./mixins/options */ "./src/components/Vuetify/mixins/options.js");
	/* harmony import */ var _mixins_lang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./mixins/lang */ "./src/components/Vuetify/mixins/lang.ts");
	/* harmony import */ var _util_goTo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./util/goTo */ "./src/components/Vuetify/util/goTo.js");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../util/console */ "./src/util/console.ts");
	
	
	
	
	
	
	
	
	// Utils
	
	var Vuetify = {
	    install: function install(Vue, opts) {
	        if (opts === void 0) {
	            opts = {};
	        }
	        if (this.installed) return;
	        this.installed = true;
	        if (vue__WEBPACK_IMPORTED_MODULE_0___default.a !== Vue) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleError"])('Multiple instances of Vue detected\nSee https://github.com/vuetifyjs/vuetify/issues/4068\n\nIf you\'re seeing "$attrs is readonly", it\'s caused by this');
	        }
	        checkVueVersion(Vue);
	        var lang = Object(_mixins_lang__WEBPACK_IMPORTED_MODULE_6__["default"])(opts.lang);
	        Vue.prototype.$vuetify = new Vue({
	            mixins: [_mixins_breakpoint__WEBPACK_IMPORTED_MODULE_2__["default"]],
	            data: {
	                application: _mixins_application__WEBPACK_IMPORTED_MODULE_1__["default"],
	                dark: false,
	                icons: Object(_mixins_icons__WEBPACK_IMPORTED_MODULE_4__["default"])(opts.iconfont, opts.icons),
	                lang: lang,
	                options: Object(_mixins_options__WEBPACK_IMPORTED_MODULE_5__["default"])(opts.options),
	                rtl: opts.rtl,
	                theme: Object(_mixins_theme__WEBPACK_IMPORTED_MODULE_3__["default"])(opts.theme)
	            },
	            methods: {
	                goTo: _util_goTo__WEBPACK_IMPORTED_MODULE_7__["default"],
	                t: lang.t.bind(lang)
	            }
	        });
	        if (opts.directives) {
	            for (var name in opts.directives) {
	                Vue.directive(name, opts.directives[name]);
	            }
	        }
	        (function registerComponents(components) {
	            if (components) {
	                for (var key in components) {
	                    var component = components[key];
	                    if (component && !registerComponents(component.$_vuetify_subcomponents)) {
	                        Vue.component(key, component);
	                    }
	                }
	                return true;
	            }
	            return false;
	        })(opts.components);
	    },
	    version: '1.3.14'
	};
	function checkVueVersion(Vue, requiredVue) {
	    var vueDep = requiredVue || '^2.5.18';
	    var required = vueDep.split('.', 3).map(function (v) {
	        return v.replace(/\D/g, '');
	    }).map(Number);
	    var actual = Vue.version.split('.', 3).map(function (n) {
	        return parseInt(n, 10);
	    });
	    // Simple semver caret range comparison
	    var passes = actual[0] === required[0] && ( // major matches
	    actual[1] > required[1] || // minor is greater
	    actual[1] === required[1] && actual[2] >= required[2] // or minor is eq and patch is >=
	    );
	    if (!passes) {
	        Object(_util_console__WEBPACK_IMPORTED_MODULE_8__["consoleWarn"])("Vuetify requires Vue version " + vueDep);
	    }
	}
	/* harmony default export */ __webpack_exports__["default"] = (Vuetify);
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/application.ts":
	/*!******************************************************!*\
	  !*** ./src/components/Vuetify/mixins/application.ts ***!
	  \******************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony default export */ __webpack_exports__["default"] = ({
	    bar: 0,
	    bottom: 0,
	    footer: 0,
	    insetFooter: 0,
	    left: 0,
	    right: 0,
	    top: 0,
	    components: {
	        bar: {},
	        bottom: {},
	        footer: {},
	        insetFooter: {},
	        left: {},
	        right: {},
	        top: {}
	    },
	    bind: function bind(uid, target, value) {
	        var _a;
	        if (!this.components[target]) return;
	        this.components[target] = (_a = {}, _a[uid] = value, _a);
	        this.update(target);
	    },
	    unbind: function unbind(uid, target) {
	        if (this.components[target][uid] == null) return;
	        delete this.components[target][uid];
	        this.update(target);
	    },
	    update: function update(target) {
	        this[target] = Object.values(this.components[target]).reduce(function (acc, cur) {
	            return acc + cur;
	        }, 0);
	    }
	});
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/breakpoint.ts":
	/*!*****************************************************!*\
	  !*** ./src/components/Vuetify/mixins/breakpoint.ts ***!
	  \*****************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * A modified version of https://gist.github.com/cb109/b074a65f7595cffc21cea59ce8d15f9b
	 */
	/**
	 * A Vue mixin to get the current width/height and the associated breakpoint.
	 *
	 *   <div v-if="$breakpoint.smAndDown">...</div>
	 *
	 */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    data: function data() {
	        return {
	            clientHeight: getClientHeight(),
	            clientWidth: getClientWidth(),
	            resizeTimeout: undefined
	        };
	    },
	    computed: {
	        breakpoint: function breakpoint() {
	            var xs = this.clientWidth < 600;
	            var sm = this.clientWidth < 960 && !xs;
	            var md = this.clientWidth < 1280 - 16 && !(sm || xs);
	            var lg = this.clientWidth < 1920 - 16 && !(md || sm || xs);
	            var xl = this.clientWidth >= 1920 - 16;
	            var xsOnly = xs;
	            var smOnly = sm;
	            var smAndDown = (xs || sm) && !(md || lg || xl);
	            var smAndUp = !xs && (sm || md || lg || xl);
	            var mdOnly = md;
	            var mdAndDown = (xs || sm || md) && !(lg || xl);
	            var mdAndUp = !(xs || sm) && (md || lg || xl);
	            var lgOnly = lg;
	            var lgAndDown = (xs || sm || md || lg) && !xl;
	            var lgAndUp = !(xs || sm || md) && (lg || xl);
	            var xlOnly = xl;
	            var name;
	            switch (true) {
	                case xs:
	                    name = 'xs';
	                    break;
	                case sm:
	                    name = 'sm';
	                    break;
	                case md:
	                    name = 'md';
	                    break;
	                case lg:
	                    name = 'lg';
	                    break;
	                default:
	                    name = 'xl';
	                    break;
	            }
	            return {
	                // Definite breakpoint.
	                xs: xs,
	                sm: sm,
	                md: md,
	                lg: lg,
	                xl: xl,
	                // Useful e.g. to construct CSS class names dynamically.
	                name: name,
	                // Breakpoint ranges.
	                xsOnly: xsOnly,
	                smOnly: smOnly,
	                smAndDown: smAndDown,
	                smAndUp: smAndUp,
	                mdOnly: mdOnly,
	                mdAndDown: mdAndDown,
	                mdAndUp: mdAndUp,
	                lgOnly: lgOnly,
	                lgAndDown: lgAndDown,
	                lgAndUp: lgAndUp,
	                xlOnly: xlOnly,
	                // For custom breakpoint logic.
	                width: this.clientWidth,
	                height: this.clientHeight
	            };
	        }
	    },
	    created: function created() {
	        if (typeof window === 'undefined') return;
	        window.addEventListener('resize', this.onResize, { passive: true });
	    },
	    beforeDestroy: function beforeDestroy() {
	        if (typeof window === 'undefined') return;
	        window.removeEventListener('resize', this.onResize);
	    },
	    methods: {
	        onResize: function onResize() {
	            clearTimeout(this.resizeTimeout);
	            // Added debounce to match what
	            // v-resize used to do but was
	            // removed due to a memory leak
	            // https://github.com/vuetifyjs/vuetify/pull/2997
	            this.resizeTimeout = window.setTimeout(this.setDimensions, 200);
	        },
	        setDimensions: function setDimensions() {
	            this.clientHeight = getClientHeight();
	            this.clientWidth = getClientWidth();
	        }
	    }
	}));
	// Cross-browser support as described in:
	// https://stackoverflow.com/questions/1248081
	function getClientWidth() {
	    if (typeof document === 'undefined') return 0; // SSR
	    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}
	function getClientHeight() {
	    if (typeof document === 'undefined') return 0; // SSR
	    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/icons.js":
	/*!************************************************!*\
	  !*** ./src/components/Vuetify/mixins/icons.js ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return icons; });
	// Maps internal Vuetify icon names to actual Material Design icon names.
	var ICONS_MATERIAL = {
	    'complete': 'check',
	    'cancel': 'cancel',
	    'close': 'close',
	    'delete': 'cancel',
	    'clear': 'clear',
	    'success': 'check_circle',
	    'info': 'info',
	    'warning': 'priority_high',
	    'error': 'warning',
	    'prev': 'chevron_left',
	    'next': 'chevron_right',
	    'checkboxOn': 'check_box',
	    'checkboxOff': 'check_box_outline_blank',
	    'checkboxIndeterminate': 'indeterminate_check_box',
	    'delimiter': 'fiber_manual_record',
	    'sort': 'arrow_upward',
	    'expand': 'keyboard_arrow_down',
	    'menu': 'menu',
	    'subgroup': 'arrow_drop_down',
	    'dropdown': 'arrow_drop_down',
	    'radioOn': 'radio_button_checked',
	    'radioOff': 'radio_button_unchecked',
	    'edit': 'edit',
	    'ratingEmpty': 'star_border',
	    'ratingFull': 'star',
	    'ratingHalf': 'star_half',
	    'loading': 'cached'
	};
	// Maps internal Vuetify icon names to actual icons from materialdesignicons.com
	var ICONS_MDI = {
	    'complete': 'mdi-check',
	    'cancel': 'mdi-close-circle',
	    'close': 'mdi-close',
	    'delete': 'mdi-close-circle',
	    'clear': 'mdi-close',
	    'success': 'mdi-check-circle',
	    'info': 'mdi-information',
	    'warning': 'mdi-exclamation',
	    'error': 'mdi-alert',
	    'prev': 'mdi-chevron-left',
	    'next': 'mdi-chevron-right',
	    'checkboxOn': 'mdi-checkbox-marked',
	    'checkboxOff': 'mdi-checkbox-blank-outline',
	    'checkboxIndeterminate': 'mdi-minus-box',
	    'delimiter': 'mdi-circle',
	    'sort': 'mdi-arrow-up',
	    'expand': 'mdi-chevron-down',
	    'menu': 'mdi-menu',
	    'subgroup': 'mdi-menu-down',
	    'dropdown': 'mdi-menu-down',
	    'radioOn': 'mdi-radiobox-marked',
	    'radioOff': 'mdi-radiobox-blank',
	    'edit': 'mdi-pencil',
	    'ratingEmpty': 'mdi-star-outline',
	    'ratingFull': 'mdi-star',
	    'ratingHalf': 'mdi-star-half'
	};
	// Maps internal Vuetify icon names to actual Font-Awesome 4 icon names.
	var ICONS_FONTAWESOME4 = {
	    'complete': 'fa fa-check',
	    'cancel': 'fa fa-times-circle',
	    'close': 'fa fa-times',
	    'delete': 'fa fa-times-circle',
	    'clear': 'fa fa-times-circle',
	    'success': 'fa fa-check-circle',
	    'info': 'fa fa-info-circle',
	    'warning': 'fa fa-exclamation',
	    'error': 'fa fa-exclamation-triangle',
	    'prev': 'fa fa-chevron-left',
	    'next': 'fa fa-chevron-right',
	    'checkboxOn': 'fa fa-check-square',
	    'checkboxOff': 'fa fa-square-o',
	    'checkboxIndeterminate': 'fa fa-minus-square',
	    'delimiter': 'fa fa-circle',
	    'sort': 'fa fa-sort-up',
	    'expand': 'fa fa-chevron-down',
	    'menu': 'fa fa-bars',
	    'subgroup': 'fa fa-caret-down',
	    'dropdown': 'fa fa-caret-down',
	    'radioOn': 'fa fa-dot-circle',
	    'radioOff': 'fa fa-circle-o',
	    'edit': 'fa fa-pencil',
	    'ratingEmpty': 'fa fa-star-o',
	    'ratingFull': 'fa fa-star',
	    'ratingHalf': 'fa fa-star-half-o'
	};
	// Maps internal Vuetify icon names to actual Font-Awesome 5+ icon names.
	var ICONS_FONTAWESOME = {
	    'complete': 'fas fa-check',
	    'cancel': 'fas fa-times-circle',
	    'close': 'fas fa-times',
	    'delete': 'fas fa-times-circle',
	    'clear': 'fas fa-times-circle',
	    'success': 'fas fa-check-circle',
	    'info': 'fas fa-info-circle',
	    'warning': 'fas fa-exclamation',
	    'error': 'fas fa-exclamation-triangle',
	    'prev': 'fas fa-chevron-left',
	    'next': 'fas fa-chevron-right',
	    'checkboxOn': 'fas fa-check-square',
	    'checkboxOff': 'far fa-square',
	    'checkboxIndeterminate': 'fas fa-minus-square',
	    'delimiter': 'fas fa-circle',
	    'sort': 'fas fa-sort-up',
	    'expand': 'fas fa-chevron-down',
	    'menu': 'fas fa-bars',
	    'subgroup': 'fas fa-caret-down',
	    'dropdown': 'fas fa-caret-down',
	    'radioOn': 'far fa-dot-circle',
	    'radioOff': 'far fa-circle',
	    'edit': 'fas fa-edit',
	    'ratingEmpty': 'far fa-star',
	    'ratingFull': 'fas fa-star',
	    'ratingHalf': 'fas fa-star-half'
	};
	var iconSets = {
	    md: ICONS_MATERIAL,
	    mdi: ICONS_MDI,
	    fa: ICONS_FONTAWESOME,
	    fa4: ICONS_FONTAWESOME4
	};
	function icons(iconfont, icons) {
	    if (iconfont === void 0) {
	        iconfont = 'md';
	    }
	    if (icons === void 0) {
	        icons = {};
	    }
	    return Object.assign({}, iconSets[iconfont] || iconSets.md, icons);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/lang.ts":
	/*!***********************************************!*\
	  !*** ./src/components/Vuetify/mixins/lang.ts ***!
	  \***********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return lang; });
	/* harmony import */ var _locale_en__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../locale/en */ "./src/locale/en.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	var LANG_PREFIX = '$vuetify.';
	var fallback = Symbol('Lang fallback');
	function getTranslation(locale, key, usingFallback) {
	    if (usingFallback === void 0) {
	        usingFallback = false;
	    }
	    var shortKey = key.replace(LANG_PREFIX, '');
	    var translation = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["getObjectValueByPath"])(locale, shortKey, fallback);
	    if (translation === fallback) {
	        if (usingFallback) {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])("Translation key \"" + shortKey + "\" not found in fallback");
	            translation = key;
	        } else {
	            Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleWarn"])("Translation key \"" + shortKey + "\" not found, falling back to default");
	            translation = getTranslation(_locale_en__WEBPACK_IMPORTED_MODULE_0__["default"], key, true);
	        }
	    }
	    return translation;
	}
	function lang(config) {
	    if (config === void 0) {
	        config = {};
	    }
	    return {
	        locales: Object.assign({ en: _locale_en__WEBPACK_IMPORTED_MODULE_0__["default"] }, config.locales),
	        current: config.current || 'en',
	        t: function t(key) {
	            var params = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                params[_i - 1] = arguments[_i];
	            }
	            if (!key.startsWith(LANG_PREFIX)) return key;
	            if (config.t) return config.t.apply(config, __spread([key], params));
	            var translation = getTranslation(this.locales[this.current], key);
	            return translation.replace(/\{(\d+)\}/g, function (match, index) {
	                return String(params[+index]);
	            });
	        }
	    };
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/options.js":
	/*!**************************************************!*\
	  !*** ./src/components/Vuetify/mixins/options.js ***!
	  \**************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return options; });
	var OPTIONS_DEFAULTS = {
	    minifyTheme: null,
	    themeCache: null,
	    customProperties: false,
	    cspNonce: null
	};
	function options(options) {
	    if (options === void 0) {
	        options = {};
	    }
	    return Object.assign({}, OPTIONS_DEFAULTS, options);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/mixins/theme.ts":
	/*!************************************************!*\
	  !*** ./src/components/Vuetify/mixins/theme.ts ***!
	  \************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return theme; });
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	/* eslint-disable no-multi-spaces */
	var THEME_DEFAULTS = {
	    primary: '#1976D2',
	    secondary: '#424242',
	    accent: '#82B1FF',
	    error: '#FF5252',
	    info: '#2196F3',
	    success: '#4CAF50',
	    warning: '#FFC107' // amber.base
	};
	function theme(theme) {
	    if (theme === void 0) {
	        theme = {};
	    }
	    if (theme === false) return false;
	    return __assign({}, THEME_DEFAULTS, theme);
	}
	
	/***/ }),
	
	/***/ "./src/components/Vuetify/util/goTo.js":
	/*!*********************************************!*\
	  !*** ./src/components/Vuetify/util/goTo.js ***!
	  \*********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return goTo; });
	/* harmony import */ var _util_easing_patterns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../util/easing-patterns */ "./src/util/easing-patterns.js");
	
	var defaults = {
	    duration: 500,
	    offset: 0,
	    easing: 'easeInOutCubic'
	};
	function getDocumentHeight() {
	    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
	}
	function getWindowHeight() {
	    return window.innerHeight || (document.documentElement || document.body).clientHeight;
	}
	function isVueComponent(obj) {
	    return obj != null && obj._isVue;
	}
	function getTargetLocation(target, settings) {
	    var location;
	    if (isVueComponent(target)) {
	        target = target.$el;
	    }
	    if (target instanceof Element) {
	        location = target.getBoundingClientRect().top + window.pageYOffset;
	    } else if (typeof target === 'string') {
	        var targetEl = document.querySelector(target);
	        if (!targetEl) throw new TypeError("Target element \"" + target + "\" not found.");
	        location = targetEl.getBoundingClientRect().top + window.pageYOffset;
	    } else if (typeof target === 'number') {
	        location = target;
	    } else {
	        var type = target == null ? target : target.constructor.name;
	        throw new TypeError("Target must be a Selector/Number/DOMElement/VueComponent, received " + type + " instead.");
	    }
	    return Math.round(Math.min(Math.max(location + settings.offset, 0), getDocumentHeight() - getWindowHeight()));
	}
	function goTo(target, options) {
	    return new Promise(function (resolve, reject) {
	        if (typeof window === 'undefined') return reject('Window is undefined');
	        var settings = Object.assign({}, defaults, options);
	        var startTime = performance.now();
	        var startLocation = window.pageYOffset;
	        var targetLocation = getTargetLocation(target, settings);
	        var distanceToScroll = targetLocation - startLocation;
	        var easingFunction = typeof settings.easing === 'function' ? settings.easing : _util_easing_patterns__WEBPACK_IMPORTED_MODULE_0__[settings.easing];
	        if (!easingFunction) throw new TypeError("Easing function '" + settings.easing + "' not found.");
	        function step(currentTime) {
	            var progressPercentage = Math.min(1, (currentTime - startTime) / settings.duration);
	            var targetPosition = Math.floor(startLocation + distanceToScroll * easingFunction(progressPercentage));
	            window.scrollTo(0, targetPosition);
	            if (Math.round(window.pageYOffset) === targetLocation || progressPercentage === 1) {
	                return resolve(target);
	            }
	            window.requestAnimationFrame(step);
	        }
	        window.requestAnimationFrame(step);
	    });
	}
	
	/***/ }),
	
	/***/ "./src/components/index.ts":
	/*!*********************************!*\
	  !*** ./src/components/index.ts ***!
	  \*********************************/
	/*! exports provided: VApp, VAlert, VAutocomplete, VAvatar, VBadge, VBottomNav, VBottomSheet, VBreadcrumbs, VBreadcrumbsItem, VBreadcrumbsDivider, VBtn, VBtnToggle, VCard, VCardMedia, VCardTitle, VCardActions, VCardText, VCarousel, VCarouselItem, VCheckbox, VChip, VCombobox, VCounter, VDataIterator, VDataTable, VEditDialog, VTableOverflow, VDatePicker, VDatePickerTitle, VDatePickerHeader, VDatePickerDateTable, VDatePickerMonthTable, VDatePickerYears, VDialog, VDivider, VExpansionPanel, VExpansionPanelContent, VFooter, VForm, VContainer, VContent, VFlex, VLayout, VSpacer, VHover, VIcon, VImg, VInput, VItem, VItemGroup, VJumbotron, VLabel, VList, VListGroup, VListTile, VListTileAction, VListTileAvatar, VListTileActionText, VListTileContent, VListTileTitle, VListTileSubTitle, VMenu, VMessages, VNavigationDrawer, VOverflowBtn, VPagination, VParallax, VPicker, VProgressCircular, VProgressLinear, VRadioGroup, VRadio, VRangeSlider, VRating, VResponsive, VSelect, VSlider, VSnackbar, VSpeedDial, VStepper, VStepperContent, VStepperStep, VStepperHeader, VStepperItems, VSubheader, VSwitch, VSystemBar, VTabs, VTab, VTabItem, VTabsItems, VTabsSlider, VTextarea, VTextField, VTimeline, VTimelineItem, VTimePicker, VTimePickerClock, VTimePickerTitle, VToolbar, VToolbarSideIcon, VToolbarTitle, VToolbarItems, VTooltip, VTreeview, VTreeviewNode, VWindow, VWindowItem, VBottomSheetTransition, VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VRowExpandTransition */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _VApp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VApp */ "./src/components/VApp/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VApp", function() { return _VApp__WEBPACK_IMPORTED_MODULE_0__["VApp"]; });
	
	/* harmony import */ var _VAlert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./VAlert */ "./src/components/VAlert/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAlert", function() { return _VAlert__WEBPACK_IMPORTED_MODULE_1__["VAlert"]; });
	
	/* harmony import */ var _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./VAutocomplete */ "./src/components/VAutocomplete/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAutocomplete", function() { return _VAutocomplete__WEBPACK_IMPORTED_MODULE_2__["VAutocomplete"]; });
	
	/* harmony import */ var _VAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./VAvatar */ "./src/components/VAvatar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VAvatar", function() { return _VAvatar__WEBPACK_IMPORTED_MODULE_3__["VAvatar"]; });
	
	/* harmony import */ var _VBadge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./VBadge */ "./src/components/VBadge/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBadge", function() { return _VBadge__WEBPACK_IMPORTED_MODULE_4__["VBadge"]; });
	
	/* harmony import */ var _VBottomNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VBottomNav */ "./src/components/VBottomNav/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomNav", function() { return _VBottomNav__WEBPACK_IMPORTED_MODULE_5__["VBottomNav"]; });
	
	/* harmony import */ var _VBottomSheet__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./VBottomSheet */ "./src/components/VBottomSheet/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheet", function() { return _VBottomSheet__WEBPACK_IMPORTED_MODULE_6__["VBottomSheet"]; });
	
	/* harmony import */ var _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./VBreadcrumbs */ "./src/components/VBreadcrumbs/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbs", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbs"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsItem", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbsItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBreadcrumbsDivider", function() { return _VBreadcrumbs__WEBPACK_IMPORTED_MODULE_7__["VBreadcrumbsDivider"]; });
	
	/* harmony import */ var _VBtn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./VBtn */ "./src/components/VBtn/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtn", function() { return _VBtn__WEBPACK_IMPORTED_MODULE_8__["VBtn"]; });
	
	/* harmony import */ var _VBtnToggle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./VBtnToggle */ "./src/components/VBtnToggle/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBtnToggle", function() { return _VBtnToggle__WEBPACK_IMPORTED_MODULE_9__["VBtnToggle"]; });
	
	/* harmony import */ var _VCard__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./VCard */ "./src/components/VCard/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCard", function() { return _VCard__WEBPACK_IMPORTED_MODULE_10__["VCard"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardMedia", function() { return _VCard__WEBPACK_IMPORTED_MODULE_10__["VCardMedia"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardTitle", function() { return _VCard__WEBPACK_IMPORTED_MODULE_10__["VCardTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardActions", function() { return _VCard__WEBPACK_IMPORTED_MODULE_10__["VCardActions"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCardText", function() { return _VCard__WEBPACK_IMPORTED_MODULE_10__["VCardText"]; });
	
	/* harmony import */ var _VCarousel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./VCarousel */ "./src/components/VCarousel/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarousel", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_11__["VCarousel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselItem", function() { return _VCarousel__WEBPACK_IMPORTED_MODULE_11__["VCarouselItem"]; });
	
	/* harmony import */ var _VCheckbox__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./VCheckbox */ "./src/components/VCheckbox/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCheckbox", function() { return _VCheckbox__WEBPACK_IMPORTED_MODULE_12__["VCheckbox"]; });
	
	/* harmony import */ var _VChip__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./VChip */ "./src/components/VChip/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VChip", function() { return _VChip__WEBPACK_IMPORTED_MODULE_13__["VChip"]; });
	
	/* harmony import */ var _VCombobox__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./VCombobox */ "./src/components/VCombobox/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCombobox", function() { return _VCombobox__WEBPACK_IMPORTED_MODULE_14__["VCombobox"]; });
	
	/* harmony import */ var _VCounter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./VCounter */ "./src/components/VCounter/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCounter", function() { return _VCounter__WEBPACK_IMPORTED_MODULE_15__["VCounter"]; });
	
	/* harmony import */ var _VDataIterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./VDataIterator */ "./src/components/VDataIterator/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataIterator", function() { return _VDataIterator__WEBPACK_IMPORTED_MODULE_16__["VDataIterator"]; });
	
	/* harmony import */ var _VDataTable__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./VDataTable */ "./src/components/VDataTable/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDataTable", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_17__["VDataTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VEditDialog", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_17__["VEditDialog"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTableOverflow", function() { return _VDataTable__WEBPACK_IMPORTED_MODULE_17__["VTableOverflow"]; });
	
	/* harmony import */ var _VDatePicker__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./VDatePicker */ "./src/components/VDatePicker/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePicker", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePicker"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerTitle", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePickerTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerHeader", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePickerHeader"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerDateTable", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePickerDateTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerMonthTable", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePickerMonthTable"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDatePickerYears", function() { return _VDatePicker__WEBPACK_IMPORTED_MODULE_18__["VDatePickerYears"]; });
	
	/* harmony import */ var _VDialog__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./VDialog */ "./src/components/VDialog/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialog", function() { return _VDialog__WEBPACK_IMPORTED_MODULE_19__["VDialog"]; });
	
	/* harmony import */ var _VDivider__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./VDivider */ "./src/components/VDivider/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDivider", function() { return _VDivider__WEBPACK_IMPORTED_MODULE_20__["VDivider"]; });
	
	/* harmony import */ var _VExpansionPanel__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./VExpansionPanel */ "./src/components/VExpansionPanel/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanel", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_21__["VExpansionPanel"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpansionPanelContent", function() { return _VExpansionPanel__WEBPACK_IMPORTED_MODULE_21__["VExpansionPanelContent"]; });
	
	/* harmony import */ var _VFooter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./VFooter */ "./src/components/VFooter/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFooter", function() { return _VFooter__WEBPACK_IMPORTED_MODULE_22__["VFooter"]; });
	
	/* harmony import */ var _VForm__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./VForm */ "./src/components/VForm/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VForm", function() { return _VForm__WEBPACK_IMPORTED_MODULE_23__["VForm"]; });
	
	/* harmony import */ var _VGrid__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./VGrid */ "./src/components/VGrid/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContainer", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_24__["VContainer"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VContent", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_24__["VContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFlex", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_24__["VFlex"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLayout", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_24__["VLayout"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpacer", function() { return _VGrid__WEBPACK_IMPORTED_MODULE_24__["VSpacer"]; });
	
	/* harmony import */ var _VHover__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./VHover */ "./src/components/VHover/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VHover", function() { return _VHover__WEBPACK_IMPORTED_MODULE_25__["VHover"]; });
	
	/* harmony import */ var _VIcon__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./VIcon */ "./src/components/VIcon/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VIcon", function() { return _VIcon__WEBPACK_IMPORTED_MODULE_26__["VIcon"]; });
	
	/* harmony import */ var _VImg__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./VImg */ "./src/components/VImg/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VImg", function() { return _VImg__WEBPACK_IMPORTED_MODULE_27__["VImg"]; });
	
	/* harmony import */ var _VInput__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./VInput */ "./src/components/VInput/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VInput", function() { return _VInput__WEBPACK_IMPORTED_MODULE_28__["VInput"]; });
	
	/* harmony import */ var _VItemGroup__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./VItemGroup */ "./src/components/VItemGroup/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItem", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_29__["VItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VItemGroup", function() { return _VItemGroup__WEBPACK_IMPORTED_MODULE_29__["VItemGroup"]; });
	
	/* harmony import */ var _VJumbotron__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./VJumbotron */ "./src/components/VJumbotron/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VJumbotron", function() { return _VJumbotron__WEBPACK_IMPORTED_MODULE_30__["VJumbotron"]; });
	
	/* harmony import */ var _VLabel__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./VLabel */ "./src/components/VLabel/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VLabel", function() { return _VLabel__WEBPACK_IMPORTED_MODULE_31__["VLabel"]; });
	
	/* harmony import */ var _VList__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./VList */ "./src/components/VList/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VList", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VList"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListGroup", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListGroup"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTile", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTile"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAction", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileAction"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileAvatar", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileAvatar"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileActionText", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileActionText"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileContent", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileTitle", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VListTileSubTitle", function() { return _VList__WEBPACK_IMPORTED_MODULE_32__["VListTileSubTitle"]; });
	
	/* harmony import */ var _VMenu__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./VMenu */ "./src/components/VMenu/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenu", function() { return _VMenu__WEBPACK_IMPORTED_MODULE_33__["VMenu"]; });
	
	/* harmony import */ var _VMessages__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./VMessages */ "./src/components/VMessages/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMessages", function() { return _VMessages__WEBPACK_IMPORTED_MODULE_34__["VMessages"]; });
	
	/* harmony import */ var _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./VNavigationDrawer */ "./src/components/VNavigationDrawer/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VNavigationDrawer", function() { return _VNavigationDrawer__WEBPACK_IMPORTED_MODULE_35__["VNavigationDrawer"]; });
	
	/* harmony import */ var _VOverflowBtn__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./VOverflowBtn */ "./src/components/VOverflowBtn/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VOverflowBtn", function() { return _VOverflowBtn__WEBPACK_IMPORTED_MODULE_36__["VOverflowBtn"]; });
	
	/* harmony import */ var _VPagination__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./VPagination */ "./src/components/VPagination/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPagination", function() { return _VPagination__WEBPACK_IMPORTED_MODULE_37__["VPagination"]; });
	
	/* harmony import */ var _VParallax__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./VParallax */ "./src/components/VParallax/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VParallax", function() { return _VParallax__WEBPACK_IMPORTED_MODULE_38__["VParallax"]; });
	
	/* harmony import */ var _VPicker__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./VPicker */ "./src/components/VPicker/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VPicker", function() { return _VPicker__WEBPACK_IMPORTED_MODULE_39__["VPicker"]; });
	
	/* harmony import */ var _VProgressCircular__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./VProgressCircular */ "./src/components/VProgressCircular/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressCircular", function() { return _VProgressCircular__WEBPACK_IMPORTED_MODULE_40__["VProgressCircular"]; });
	
	/* harmony import */ var _VProgressLinear__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./VProgressLinear */ "./src/components/VProgressLinear/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VProgressLinear", function() { return _VProgressLinear__WEBPACK_IMPORTED_MODULE_41__["VProgressLinear"]; });
	
	/* harmony import */ var _VRadioGroup__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./VRadioGroup */ "./src/components/VRadioGroup/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadioGroup", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_42__["VRadioGroup"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRadio", function() { return _VRadioGroup__WEBPACK_IMPORTED_MODULE_42__["VRadio"]; });
	
	/* harmony import */ var _VRangeSlider__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./VRangeSlider */ "./src/components/VRangeSlider/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRangeSlider", function() { return _VRangeSlider__WEBPACK_IMPORTED_MODULE_43__["VRangeSlider"]; });
	
	/* harmony import */ var _VRating__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./VRating */ "./src/components/VRating/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRating", function() { return _VRating__WEBPACK_IMPORTED_MODULE_44__["VRating"]; });
	
	/* harmony import */ var _VResponsive__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./VResponsive */ "./src/components/VResponsive/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VResponsive", function() { return _VResponsive__WEBPACK_IMPORTED_MODULE_45__["VResponsive"]; });
	
	/* harmony import */ var _VSelect__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./VSelect */ "./src/components/VSelect/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSelect", function() { return _VSelect__WEBPACK_IMPORTED_MODULE_46__["VSelect"]; });
	
	/* harmony import */ var _VSlider__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./VSlider */ "./src/components/VSlider/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlider", function() { return _VSlider__WEBPACK_IMPORTED_MODULE_47__["VSlider"]; });
	
	/* harmony import */ var _VSnackbar__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./VSnackbar */ "./src/components/VSnackbar/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSnackbar", function() { return _VSnackbar__WEBPACK_IMPORTED_MODULE_48__["VSnackbar"]; });
	
	/* harmony import */ var _VSpeedDial__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./VSpeedDial */ "./src/components/VSpeedDial/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSpeedDial", function() { return _VSpeedDial__WEBPACK_IMPORTED_MODULE_49__["VSpeedDial"]; });
	
	/* harmony import */ var _VStepper__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./VStepper */ "./src/components/VStepper/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepper", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_50__["VStepper"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperContent", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_50__["VStepperContent"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperStep", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_50__["VStepperStep"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperHeader", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_50__["VStepperHeader"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VStepperItems", function() { return _VStepper__WEBPACK_IMPORTED_MODULE_50__["VStepperItems"]; });
	
	/* harmony import */ var _VSubheader__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./VSubheader */ "./src/components/VSubheader/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSubheader", function() { return _VSubheader__WEBPACK_IMPORTED_MODULE_51__["VSubheader"]; });
	
	/* harmony import */ var _VSwitch__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./VSwitch */ "./src/components/VSwitch/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSwitch", function() { return _VSwitch__WEBPACK_IMPORTED_MODULE_52__["VSwitch"]; });
	
	/* harmony import */ var _VSystemBar__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./VSystemBar */ "./src/components/VSystemBar/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSystemBar", function() { return _VSystemBar__WEBPACK_IMPORTED_MODULE_53__["VSystemBar"]; });
	
	/* harmony import */ var _VTabs__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./VTabs */ "./src/components/VTabs/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabs", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_54__["VTabs"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTab", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_54__["VTab"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabItem", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_54__["VTabItem"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsItems", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_54__["VTabsItems"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabsSlider", function() { return _VTabs__WEBPACK_IMPORTED_MODULE_54__["VTabsSlider"]; });
	
	/* harmony import */ var _VTextarea__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./VTextarea */ "./src/components/VTextarea/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextarea", function() { return _VTextarea__WEBPACK_IMPORTED_MODULE_55__["VTextarea"]; });
	
	/* harmony import */ var _VTextField__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./VTextField */ "./src/components/VTextField/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTextField", function() { return _VTextField__WEBPACK_IMPORTED_MODULE_56__["VTextField"]; });
	
	/* harmony import */ var _VTimeline__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./VTimeline */ "./src/components/VTimeline/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimeline", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_57__["VTimeline"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimelineItem", function() { return _VTimeline__WEBPACK_IMPORTED_MODULE_57__["VTimelineItem"]; });
	
	/* harmony import */ var _VTimePicker__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./VTimePicker */ "./src/components/VTimePicker/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePicker", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_58__["VTimePicker"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerClock", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_58__["VTimePickerClock"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTimePickerTitle", function() { return _VTimePicker__WEBPACK_IMPORTED_MODULE_58__["VTimePickerTitle"]; });
	
	/* harmony import */ var _VToolbar__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./VToolbar */ "./src/components/VToolbar/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbar", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_59__["VToolbar"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarSideIcon", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_59__["VToolbarSideIcon"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarTitle", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_59__["VToolbarTitle"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VToolbarItems", function() { return _VToolbar__WEBPACK_IMPORTED_MODULE_59__["VToolbarItems"]; });
	
	/* harmony import */ var _VTooltip__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./VTooltip */ "./src/components/VTooltip/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTooltip", function() { return _VTooltip__WEBPACK_IMPORTED_MODULE_60__["VTooltip"]; });
	
	/* harmony import */ var _VTreeview__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./VTreeview */ "./src/components/VTreeview/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeview", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_61__["VTreeview"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTreeviewNode", function() { return _VTreeview__WEBPACK_IMPORTED_MODULE_61__["VTreeviewNode"]; });
	
	/* harmony import */ var _VWindow__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./VWindow */ "./src/components/VWindow/index.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindow", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_62__["VWindow"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VWindowItem", function() { return _VWindow__WEBPACK_IMPORTED_MODULE_62__["VWindowItem"]; });
	
	/* harmony import */ var _transitions__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ./transitions */ "./src/components/transitions/index.js");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VBottomSheetTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VBottomSheetTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VCarouselTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VCarouselReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VTabTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VTabReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VMenuTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFabTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VFabTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VDialogTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VDialogBottomTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VFadeTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VScaleTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VScrollXTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VScrollXReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VScrollYTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VScrollYReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VSlideXTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VSlideXReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VSlideYTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VSlideYReverseTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VExpandTransition"]; });
	
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VRowExpandTransition", function() { return _transitions__WEBPACK_IMPORTED_MODULE_63__["VRowExpandTransition"]; });
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	/***/ }),
	
	/***/ "./src/components/transitions/expand-transition.js":
	/*!*********************************************************!*\
	  !*** ./src/components/transitions/expand-transition.js ***!
	  \*********************************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony default export */ __webpack_exports__["default"] = (function (expandedParentClass) {
	    if (expandedParentClass === void 0) {
	        expandedParentClass = '';
	    }
	    return {
	        beforeEnter: function beforeEnter(el) {
	            el._parent = el.parentNode;
	            el._initialStyle = {
	                transition: el.style.transition,
	                visibility: el.style.visibility,
	                overflow: el.style.overflow,
	                height: el.style.height
	            };
	        },
	        enter: function enter(el) {
	            var initialStyle = el._initialStyle;
	            el.style.setProperty('transition', 'none', 'important');
	            el.style.visibility = 'hidden';
	            var height = el.offsetHeight + "px";
	            el.style.visibility = initialStyle.visibility;
	            el.style.overflow = 'hidden';
	            el.style.height = 0;
	            void el.offsetHeight; // force reflow
	            el.style.transition = initialStyle.transition;
	            expandedParentClass && el._parent && el._parent.classList.add(expandedParentClass);
	            requestAnimationFrame(function () {
	                el.style.height = height;
	            });
	        },
	        afterEnter: resetStyles,
	        enterCancelled: resetStyles,
	        leave: function leave(el) {
	            el._initialStyle = {
	                overflow: el.style.overflow,
	                height: el.style.height
	            };
	            el.style.overflow = 'hidden';
	            el.style.height = el.offsetHeight + "px";
	            requestAnimationFrame(function () {
	                return el.style.height = 0;
	            });
	        },
	        afterLeave: afterLeave,
	        leaveCancelled: afterLeave
	    };
	    function afterLeave(el) {
	        expandedParentClass && el._parent && el._parent.classList.remove(expandedParentClass);
	        resetStyles(el);
	    }
	});
	function resetStyles(el) {
	    el.style.overflow = el._initialStyle.overflow;
	    el.style.height = el._initialStyle.height;
	    delete el._initialStyle;
	}
	
	/***/ }),
	
	/***/ "./src/components/transitions/index.js":
	/*!*********************************************!*\
	  !*** ./src/components/transitions/index.js ***!
	  \*********************************************/
	/*! exports provided: VBottomSheetTransition, VCarouselTransition, VCarouselReverseTransition, VTabTransition, VTabReverseTransition, VMenuTransition, VFabTransition, VDialogTransition, VDialogBottomTransition, VFadeTransition, VScaleTransition, VScrollXTransition, VScrollXReverseTransition, VScrollYTransition, VScrollYReverseTransition, VSlideXTransition, VSlideXReverseTransition, VSlideYTransition, VSlideYReverseTransition, VExpandTransition, VRowExpandTransition, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VBottomSheetTransition", function() { return VBottomSheetTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCarouselTransition", function() { return VCarouselTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VCarouselReverseTransition", function() { return VCarouselReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTabTransition", function() { return VTabTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VTabReverseTransition", function() { return VTabReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VMenuTransition", function() { return VMenuTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VFabTransition", function() { return VFabTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VDialogTransition", function() { return VDialogTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VDialogBottomTransition", function() { return VDialogBottomTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VFadeTransition", function() { return VFadeTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScaleTransition", function() { return VScaleTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollXTransition", function() { return VScrollXTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollXReverseTransition", function() { return VScrollXReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollYTransition", function() { return VScrollYTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VScrollYReverseTransition", function() { return VScrollYReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideXTransition", function() { return VSlideXTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideXReverseTransition", function() { return VSlideXReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideYTransition", function() { return VSlideYTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VSlideYReverseTransition", function() { return VSlideYReverseTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VExpandTransition", function() { return VExpandTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VRowExpandTransition", function() { return VRowExpandTransition; });
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _expand_transition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./expand-transition */ "./src/components/transitions/expand-transition.js");
	
	
	// Component specific transitions
	var VBottomSheetTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('bottom-sheet-transition');
	var VCarouselTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('carousel-transition');
	var VCarouselReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('carousel-reverse-transition');
	var VTabTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('tab-transition');
	var VTabReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('tab-reverse-transition');
	var VMenuTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('menu-transition');
	var VFabTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('fab-transition', 'center center', 'out-in');
	// Generic transitions
	var VDialogTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('dialog-transition');
	var VDialogBottomTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('dialog-bottom-transition');
	var VFadeTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('fade-transition');
	var VScaleTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scale-transition');
	var VScrollXTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-x-transition');
	var VScrollXReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-x-reverse-transition');
	var VScrollYTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-y-transition');
	var VScrollYReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('scroll-y-reverse-transition');
	var VSlideXTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-x-transition');
	var VSlideXReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-x-reverse-transition');
	var VSlideYTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-y-transition');
	var VSlideYReverseTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createSimpleTransition"])('slide-y-reverse-transition');
	// JavaScript transitions
	var VExpandTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createJavaScriptTransition"])('expand-transition', Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])());
	var VRowExpandTransition = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["createJavaScriptTransition"])('row-expand-transition', Object(_expand_transition__WEBPACK_IMPORTED_MODULE_1__["default"])('datatable__expand-col--expanded'));
	/* harmony default export */ __webpack_exports__["default"] = ({
	    $_vuetify_subcomponents: {
	        VBottomSheetTransition: VBottomSheetTransition,
	        VCarouselTransition: VCarouselTransition,
	        VCarouselReverseTransition: VCarouselReverseTransition,
	        VDialogTransition: VDialogTransition,
	        VDialogBottomTransition: VDialogBottomTransition,
	        VFabTransition: VFabTransition,
	        VFadeTransition: VFadeTransition,
	        VMenuTransition: VMenuTransition,
	        VScaleTransition: VScaleTransition,
	        VScrollXTransition: VScrollXTransition,
	        VScrollXReverseTransition: VScrollXReverseTransition,
	        VScrollYTransition: VScrollYTransition,
	        VScrollYReverseTransition: VScrollYReverseTransition,
	        VSlideXTransition: VSlideXTransition,
	        VSlideXReverseTransition: VSlideXReverseTransition,
	        VSlideYTransition: VSlideYTransition,
	        VSlideYReverseTransition: VSlideYReverseTransition,
	        VTabReverseTransition: VTabReverseTransition,
	        VTabTransition: VTabTransition,
	        VExpandTransition: VExpandTransition,
	        VRowExpandTransition: VRowExpandTransition
	    }
	});
	
	/***/ }),
	
	/***/ "./src/directives/click-outside.ts":
	/*!*****************************************!*\
	  !*** ./src/directives/click-outside.ts ***!
	  \*****************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	var __values = undefined && undefined.__values || function (o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator],
	        i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function next() {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	};
	function closeConditional() {
	    return false;
	}
	function directive(e, el, binding) {
	    // Args may not always be supplied
	    binding.args = binding.args || {};
	    // If no closeConditional was supplied assign a default
	    var isActive = binding.args.closeConditional || closeConditional;
	    // The include element callbacks below can be expensive
	    // so we should avoid calling them when we're not active.
	    // Explicitly check for false to allow fallback compatibility
	    // with non-toggleable components
	    if (!e || isActive(e) === false) return;
	    // If click was triggered programmaticaly (domEl.click()) then
	    // it shouldn't be treated as click-outside
	    // Chrome/Firefox support isTrusted property
	    // IE/Edge support pointerType property (empty if not triggered
	    // by pointing device)
	    if ('isTrusted' in e && !e.isTrusted || 'pointerType' in e && !e.pointerType) return;
	    // Check if additional elements were passed to be included in check
	    // (click must be outside all included elements, if any)
	    var elements = (binding.args.include || function () {
	        return [];
	    })();
	    // Add the root element for the component this directive was defined on
	    elements.push(el);
	    // Check if it's a click outside our elements, and then if our callback returns true.
	    // Non-toggleable components should take action in their callback and return falsy.
	    // Toggleable can return true if it wants to deactivate.
	    // Note that, because we're in the capture phase, this callback will occure before
	    // the bubbling click event on any outside elements.
	    !clickedInEls(e, elements) && setTimeout(function () {
	        isActive(e) && binding.value(e);
	    }, 0);
	}
	function clickedInEls(e, elements) {
	    var e_1, _a;
	    // Get position of click
	    var x = e.clientX,
	        y = e.clientY;
	    try {
	        // Loop over all included elements to see if click was in any of them
	        for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
	            var el = elements_1_1.value;
	            if (clickedInEl(el, x, y)) return true;
	        }
	    } catch (e_1_1) {
	        e_1 = { error: e_1_1 };
	    } finally {
	        try {
	            if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
	        } finally {
	            if (e_1) throw e_1.error;
	        }
	    }
	    return false;
	}
	function clickedInEl(el, x, y) {
	    // Get bounding rect for element
	    // (we're in capturing event and we want to check for multiple elements,
	    //  so can't use target.)
	    var b = el.getBoundingClientRect();
	    // Check if the click was in the element's bounding rect
	    return x >= b.left && x <= b.right && y >= b.top && y <= b.bottom;
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    // [data-app] may not be found
	    // if using bind, inserted makes
	    // sure that the root element is
	    // available, iOS does not support
	    // clicks on body
	    inserted: function inserted(el, binding) {
	        var onClick = function onClick(e) {
	            return directive(e, el, binding);
	        };
	        // iOS does not recognize click events on document
	        // or body, this is the entire purpose of the v-app
	        // component and [data-app], stop removing this
	        var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
	        app.addEventListener('click', onClick, true);
	        el._clickOutside = onClick;
	    },
	    unbind: function unbind(el) {
	        if (!el._clickOutside) return;
	        var app = document.querySelector('[data-app]') || document.body; // This is only for unit tests
	        app && app.removeEventListener('click', el._clickOutside, true);
	        delete el._clickOutside;
	    }
	});
	
	/***/ }),
	
	/***/ "./src/directives/index.ts":
	/*!*********************************!*\
	  !*** ./src/directives/index.ts ***!
	  \*********************************/
	/*! exports provided: ClickOutside, Ripple, Resize, Scroll, Touch, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _click_outside__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./click-outside */ "./src/directives/click-outside.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return _click_outside__WEBPACK_IMPORTED_MODULE_0__["default"]; });
	
	/* harmony import */ var _resize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./resize */ "./src/directives/resize.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return _resize__WEBPACK_IMPORTED_MODULE_1__["default"]; });
	
	/* harmony import */ var _ripple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ripple */ "./src/directives/ripple.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return _ripple__WEBPACK_IMPORTED_MODULE_2__["default"]; });
	
	/* harmony import */ var _scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./scroll */ "./src/directives/scroll.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return _scroll__WEBPACK_IMPORTED_MODULE_3__["default"]; });
	
	/* harmony import */ var _touch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./touch */ "./src/directives/touch.ts");
	/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return _touch__WEBPACK_IMPORTED_MODULE_4__["default"]; });
	
	
	
	
	
	
	
	/* harmony default export */ __webpack_exports__["default"] = ({
	    ClickOutside: _click_outside__WEBPACK_IMPORTED_MODULE_0__["default"],
	    Ripple: _ripple__WEBPACK_IMPORTED_MODULE_2__["default"],
	    Resize: _resize__WEBPACK_IMPORTED_MODULE_1__["default"],
	    Scroll: _scroll__WEBPACK_IMPORTED_MODULE_3__["default"],
	    Touch: _touch__WEBPACK_IMPORTED_MODULE_4__["default"]
	});
	
	/***/ }),
	
	/***/ "./src/directives/resize.ts":
	/*!**********************************!*\
	  !*** ./src/directives/resize.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function inserted(el, binding) {
	    var callback = binding.value;
	    var options = binding.options || { passive: true };
	    window.addEventListener('resize', callback, options);
	    el._onResize = {
	        callback: callback,
	        options: options
	    };
	    if (!binding.modifiers || !binding.modifiers.quiet) {
	        callback();
	    }
	}
	function unbind(el) {
	    if (!el._onResize) return;
	    var _a = el._onResize,
	        callback = _a.callback,
	        options = _a.options;
	    window.removeEventListener('resize', callback, options);
	    delete el._onResize;
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/directives/ripple.ts":
	/*!**********************************!*\
	  !*** ./src/directives/ripple.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function transform(el, value) {
	    el.style['transform'] = value;
	    el.style['webkitTransform'] = value;
	}
	function opacity(el, value) {
	    el.style['opacity'] = value.toString();
	}
	var calculate = function calculate(e, el, value) {
	    if (value === void 0) {
	        value = {};
	    }
	    var offset = el.getBoundingClientRect();
	    var localX = e.clientX - offset.left;
	    var localY = e.clientY - offset.top;
	    var radius = 0;
	    var scale = 0.3;
	    if (el._ripple && el._ripple.circle) {
	        scale = 0.15;
	        radius = el.clientWidth / 2;
	        radius = value.center ? radius : radius + Math.sqrt(Math.pow(localX - radius, 2) + Math.pow(localY - radius, 2)) / 4;
	    } else {
	        radius = Math.sqrt(Math.pow(el.clientWidth, 2) + Math.pow(el.clientHeight, 2)) / 2;
	    }
	    var centerX = (el.clientWidth - radius * 2) / 2 + "px";
	    var centerY = (el.clientHeight - radius * 2) / 2 + "px";
	    var x = value.center ? centerX : localX - radius + "px";
	    var y = value.center ? centerY : localY - radius + "px";
	    return { radius: radius, scale: scale, x: x, y: y, centerX: centerX, centerY: centerY };
	};
	var ripple = {
	    /* eslint-disable max-statements */
	    show: function show(e, el, value) {
	        if (value === void 0) {
	            value = {};
	        }
	        if (!el._ripple || !el._ripple.enabled) {
	            return;
	        }
	        var container = document.createElement('span');
	        var animation = document.createElement('span');
	        container.appendChild(animation);
	        container.className = 'v-ripple__container';
	        if (value.class) {
	            container.className += " " + value.class;
	        }
	        var _a = calculate(e, el, value),
	            radius = _a.radius,
	            scale = _a.scale,
	            x = _a.x,
	            y = _a.y,
	            centerX = _a.centerX,
	            centerY = _a.centerY;
	        var size = radius * 2 + "px";
	        animation.className = 'v-ripple__animation';
	        animation.style.width = size;
	        animation.style.height = size;
	        el.appendChild(container);
	        var computed = window.getComputedStyle(el);
	        if (computed.position === 'static') {
	            el.style.position = 'relative';
	            el.dataset.previousPosition = 'static';
	        }
	        animation.classList.add('v-ripple__animation--enter');
	        animation.classList.add('v-ripple__animation--visible');
	        transform(animation, "translate(" + x + ", " + y + ") scale3d(" + scale + "," + scale + "," + scale + ")");
	        opacity(animation, 0);
	        animation.dataset.activated = String(performance.now());
	        setTimeout(function () {
	            animation.classList.remove('v-ripple__animation--enter');
	            animation.classList.add('v-ripple__animation--in');
	            transform(animation, "translate(" + centerX + ", " + centerY + ") scale3d(1,1,1)");
	            opacity(animation, 0.25);
	            setTimeout(function () {
	                animation.classList.remove('v-ripple__animation--in');
	                animation.classList.add('v-ripple__animation--out');
	                opacity(animation, 0);
	            }, 300);
	        }, 0);
	    },
	    hide: function hide(el) {
	        if (!el || !el._ripple || !el._ripple.enabled) return;
	        var ripples = el.getElementsByClassName('v-ripple__animation');
	        if (ripples.length === 0) return;
	        var animation = ripples[ripples.length - 1];
	        if (animation.dataset.isHiding) return;else animation.dataset.isHiding = 'true';
	        var diff = performance.now() - Number(animation.dataset.activated);
	        var delay = Math.max(200 - diff, 0);
	        setTimeout(function () {
	            animation.classList.remove('v-ripple__animation--out');
	            setTimeout(function () {
	                var ripples = el.getElementsByClassName('v-ripple__animation');
	                if (ripples.length === 1 && el.dataset.previousPosition) {
	                    el.style.position = el.dataset.previousPosition;
	                    delete el.dataset.previousPosition;
	                }
	                animation.parentNode && el.removeChild(animation.parentNode);
	            }, 300);
	        }, delay);
	    }
	};
	function isRippleEnabled(value) {
	    return typeof value === 'undefined' || !!value;
	}
	function rippleShow(e) {
	    var value = {};
	    var element = e.currentTarget;
	    if (!element) return;
	    value.center = element._ripple.centered;
	    if (element._ripple.class) {
	        value.class = element._ripple.class;
	    }
	    ripple.show(e, element, value);
	}
	function rippleHide(e) {
	    ripple.hide(e.currentTarget);
	}
	function updateRipple(el, binding, wasEnabled) {
	    var enabled = isRippleEnabled(binding.value);
	    if (!enabled) {
	        ripple.hide(el);
	    }
	    el._ripple = el._ripple || {};
	    el._ripple.enabled = enabled;
	    var value = binding.value || {};
	    if (value.center) {
	        el._ripple.centered = true;
	    }
	    if (value.class) {
	        el._ripple.class = binding.value.class;
	    }
	    if (value.circle) {
	        el._ripple.circle = value.circle;
	    }
	    if (enabled && !wasEnabled) {
	        if ('ontouchstart' in window) {
	            el.addEventListener('touchend', rippleHide, false);
	            el.addEventListener('touchcancel', rippleHide, false);
	        }
	        el.addEventListener('mousedown', rippleShow, false);
	        el.addEventListener('mouseup', rippleHide, false);
	        el.addEventListener('mouseleave', rippleHide, false);
	        // Anchor tags can be dragged, causes other hides to fail - #1537
	        el.addEventListener('dragstart', rippleHide, false);
	    } else if (!enabled && wasEnabled) {
	        removeListeners(el);
	    }
	}
	function removeListeners(el) {
	    el.removeEventListener('mousedown', rippleShow, false);
	    el.removeEventListener('touchend', rippleHide, false);
	    el.removeEventListener('touchcancel', rippleHide, false);
	    el.removeEventListener('mouseup', rippleHide, false);
	    el.removeEventListener('mouseleave', rippleHide, false);
	    el.removeEventListener('dragstart', rippleHide, false);
	}
	function directive(el, binding) {
	    updateRipple(el, binding, false);
	}
	function unbind(el) {
	    delete el._ripple;
	    removeListeners(el);
	}
	function update(el, binding) {
	    if (binding.value === binding.oldValue) {
	        return;
	    }
	    var wasEnabled = isRippleEnabled(binding.oldValue);
	    updateRipple(el, binding, wasEnabled);
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    bind: directive,
	    unbind: unbind,
	    update: update
	});
	
	/***/ }),
	
	/***/ "./src/directives/scroll.ts":
	/*!**********************************!*\
	  !*** ./src/directives/scroll.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	function inserted(el, binding) {
	    var callback = binding.value;
	    var options = binding.options || { passive: true };
	    var target = binding.arg ? document.querySelector(binding.arg) : window;
	    if (!target) return;
	    target.addEventListener('scroll', callback, options);
	    el._onScroll = {
	        callback: callback,
	        options: options,
	        target: target
	    };
	}
	function unbind(el) {
	    if (!el._onScroll) return;
	    var _a = el._onScroll,
	        callback = _a.callback,
	        options = _a.options,
	        target = _a.target;
	    target.removeEventListener('scroll', callback, options);
	    delete el._onScroll;
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/directives/touch.ts":
	/*!*********************************!*\
	  !*** ./src/directives/touch.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	var handleGesture = function handleGesture(wrapper) {
	    var touchstartX = wrapper.touchstartX,
	        touchendX = wrapper.touchendX,
	        touchstartY = wrapper.touchstartY,
	        touchendY = wrapper.touchendY;
	    var dirRatio = 0.5;
	    var minDistance = 16;
	    wrapper.offsetX = touchendX - touchstartX;
	    wrapper.offsetY = touchendY - touchstartY;
	    if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
	        wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
	        wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
	    }
	    if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
	        wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
	        wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
	    }
	};
	function _touchstart(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchstartX = touch.clientX;
	    wrapper.touchstartY = touch.clientY;
	    wrapper.start && wrapper.start(Object.assign(event, wrapper));
	}
	function _touchend(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchendX = touch.clientX;
	    wrapper.touchendY = touch.clientY;
	    wrapper.end && wrapper.end(Object.assign(event, wrapper));
	    handleGesture(wrapper);
	}
	function _touchmove(event, wrapper) {
	    var touch = event.changedTouches[0];
	    wrapper.touchmoveX = touch.clientX;
	    wrapper.touchmoveY = touch.clientY;
	    wrapper.move && wrapper.move(Object.assign(event, wrapper));
	}
	function createHandlers(value) {
	    var wrapper = {
	        touchstartX: 0,
	        touchstartY: 0,
	        touchendX: 0,
	        touchendY: 0,
	        touchmoveX: 0,
	        touchmoveY: 0,
	        offsetX: 0,
	        offsetY: 0,
	        left: value.left,
	        right: value.right,
	        up: value.up,
	        down: value.down,
	        start: value.start,
	        move: value.move,
	        end: value.end
	    };
	    return {
	        touchstart: function touchstart(e) {
	            return _touchstart(e, wrapper);
	        },
	        touchend: function touchend(e) {
	            return _touchend(e, wrapper);
	        },
	        touchmove: function touchmove(e) {
	            return _touchmove(e, wrapper);
	        }
	    };
	}
	function inserted(el, binding, vnode) {
	    var value = binding.value;
	    var target = value.parent ? el.parentElement : el;
	    var options = value.options || { passive: true };
	    // Needed to pass unit tests
	    if (!target) return;
	    var handlers = createHandlers(binding.value);
	    target._touchHandlers = Object(target._touchHandlers);
	    target._touchHandlers[vnode.context._uid] = handlers;
	    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function (eventName) {
	        target.addEventListener(eventName, handlers[eventName], options);
	    });
	}
	function unbind(el, binding, vnode) {
	    var target = binding.value.parent ? el.parentElement : el;
	    if (!target || !target._touchHandlers) return;
	    var handlers = target._touchHandlers[vnode.context._uid];
	    Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["keys"])(handlers).forEach(function (eventName) {
	        target.removeEventListener(eventName, handlers[eventName]);
	    });
	    delete target._touchHandlers[vnode.context._uid];
	}
	/* harmony default export */ __webpack_exports__["default"] = ({
	    inserted: inserted,
	    unbind: unbind
	});
	
	/***/ }),
	
	/***/ "./src/index.ts":
	/*!**********************!*\
	  !*** ./src/index.ts ***!
	  \**********************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_app_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./stylus/app.styl */ "./src/stylus/app.styl");
	/* harmony import */ var _stylus_app_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_app_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _components_Vuetify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/Vuetify */ "./src/components/Vuetify/index.ts");
	/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components */ "./src/components/index.ts");
	/* harmony import */ var _directives__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./directives */ "./src/directives/index.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	
	
	var Vuetify = {
	    install: function install(Vue, args) {
	        Vue.use(_components_Vuetify__WEBPACK_IMPORTED_MODULE_1__["default"], __assign({ components: _components__WEBPACK_IMPORTED_MODULE_2__,
	            directives: _directives__WEBPACK_IMPORTED_MODULE_3__["default"] }, args));
	    },
	    version: '1.3.14'
	};
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(Vuetify);
	}
	/* harmony default export */ __webpack_exports__["default"] = (Vuetify);
	
	/***/ }),
	
	/***/ "./src/locale/en.ts":
	/*!**************************!*\
	  !*** ./src/locale/en.ts ***!
	  \**************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony default export */ __webpack_exports__["default"] = ({
	    dataIterator: {
	        rowsPerPageText: 'Items per page:',
	        rowsPerPageAll: 'All',
	        pageText: '{0}-{1} of {2}',
	        noResultsText: 'No matching records found',
	        nextPage: 'Next page',
	        prevPage: 'Previous page'
	    },
	    dataTable: {
	        rowsPerPageText: 'Rows per page:'
	    },
	    noDataText: 'No data available'
	});
	
	/***/ }),
	
	/***/ "./src/mixins/applicationable.ts":
	/*!***************************************!*\
	  !*** ./src/mixins/applicationable.ts ***!
	  \***************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return applicationable; });
	/* harmony import */ var _positionable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	
	// Util
	
	function applicationable(value, events) {
	    if (events === void 0) {
	        events = [];
	    }
	    /* @vue/component */
	    return Object(_util_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(Object(_positionable__WEBPACK_IMPORTED_MODULE_0__["factory"])(['absolute', 'fixed'])).extend({
	        name: 'applicationable',
	        props: {
	            app: Boolean
	        },
	        computed: {
	            applicationProperty: function applicationProperty() {
	                return value;
	            }
	        },
	        watch: {
	            // If previous value was app
	            // reset the provided prop
	            app: function app(x, prev) {
	                prev ? this.removeApplication(true) : this.callUpdate();
	            },
	            applicationProperty: function applicationProperty(newVal, oldVal) {
	                this.$vuetify.application.unbind(this._uid, oldVal);
	            }
	        },
	        activated: function activated() {
	            this.callUpdate();
	        },
	        created: function created() {
	            for (var i = 0, length = events.length; i < length; i++) {
	                this.$watch(events[i], this.callUpdate);
	            }
	            this.callUpdate();
	        },
	        mounted: function mounted() {
	            this.callUpdate();
	        },
	        deactivated: function deactivated() {
	            this.removeApplication();
	        },
	        destroyed: function destroyed() {
	            this.removeApplication();
	        },
	        methods: {
	            callUpdate: function callUpdate() {
	                if (!this.app) return;
	                this.$vuetify.application.bind(this._uid, this.applicationProperty, this.updateApplication());
	            },
	            removeApplication: function removeApplication(force) {
	                if (force === void 0) {
	                    force = false;
	                }
	                if (!force && !this.app) return;
	                this.$vuetify.application.unbind(this._uid, this.applicationProperty);
	            },
	            updateApplication: function updateApplication() {
	                return 0;
	            }
	        }
	    });
	}
	
	/***/ }),
	
	/***/ "./src/mixins/bootable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/bootable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * Bootable
	 * @mixin
	 *
	 * Used to add lazy content functionality to components
	 * Looks for change in "isActive" to automatically boot
	 * Otherwise can be set manually
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'bootable',
	    props: {
	        lazy: Boolean
	    },
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    computed: {
	        hasContent: function hasContent() {
	            return this.isBooted || !this.lazy || this.isActive;
	        }
	    },
	    watch: {
	        isActive: function isActive() {
	            this.isBooted = true;
	        }
	    },
	    methods: {
	        showLazyContent: function showLazyContent(content) {
	            return this.hasContent ? content : undefined;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/button-group.ts":
	/*!************************************!*\
	  !*** ./src/mixins/button-group.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VItemGroup/VItemGroup */ "./src/components/VItemGroup/VItemGroup.ts");
	// Extensions
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (_components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].extend({
	    name: 'button-group',
	    provide: function provide() {
	        return {
	            btnToggle: this
	        };
	    },
	    props: {
	        activeClass: {
	            type: String,
	            default: 'v-btn--active'
	        }
	    },
	    computed: {
	        classes: function classes() {
	            return _components_VItemGroup_VItemGroup__WEBPACK_IMPORTED_MODULE_0__["BaseItemGroup"].options.computed.classes.call(this);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/colorable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/colorable.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	function isCssColor(color) {
	    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
	}
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'colorable',
	    props: {
	        color: String
	    },
	    methods: {
	        setBackgroundColor: function setBackgroundColor(color, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            var _a;
	            if (isCssColor(color)) {
	                data.style = __assign({}, data.style, { 'background-color': "" + color, 'border-color': "" + color });
	            } else if (color) {
	                data.class = __assign({}, data.class, (_a = {}, _a[color] = true, _a));
	            }
	            return data;
	        },
	        setTextColor: function setTextColor(color, data) {
	            if (data === void 0) {
	                data = {};
	            }
	            var _a;
	            if (isCssColor(color)) {
	                data.style = __assign({}, data.style, { 'color': "" + color, 'caret-color': "" + color });
	            } else if (color) {
	                var _b = __read(color.toString().trim().split(' ', 2), 2),
	                    colorName = _b[0],
	                    colorModifier = _b[1];
	                data.class = __assign({}, data.class, (_a = {}, _a[colorName + '--text'] = true, _a));
	                if (colorModifier) {
	                    data.class['text--' + colorModifier] = true;
	                }
	            }
	            return data;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/comparable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/comparable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'comparable',
	    props: {
	        valueComparator: {
	            type: Function,
	            default: _util_helpers__WEBPACK_IMPORTED_MODULE_1__["deepEqual"]
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/data-iterable.js":
	/*!*************************************!*\
	  !*** ./src/mixins/data-iterable.js ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VBtn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VBtn */ "./src/components/VBtn/index.ts");
	/* harmony import */ var _components_VIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/VIcon */ "./src/components/VIcon/index.ts");
	/* harmony import */ var _components_VSelect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/VSelect */ "./src/components/VSelect/index.js");
	/* harmony import */ var _filterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./filterable */ "./src/mixins/filterable.ts");
	/* harmony import */ var _themeable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _loadable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./loadable */ "./src/mixins/loadable.ts");
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	
	
	
	
	
	
	
	/**
	 * DataIterable
	 *
	 * @mixin
	 *
	 * Base behavior for data table and data iterator
	 * providing selection, pagination, sorting and filtering.
	 *
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'data-iterable',
	    mixins: [_filterable__WEBPACK_IMPORTED_MODULE_3__["default"], _loadable__WEBPACK_IMPORTED_MODULE_5__["default"], _themeable__WEBPACK_IMPORTED_MODULE_4__["default"]],
	    props: {
	        expand: Boolean,
	        hideActions: Boolean,
	        disableInitialSort: Boolean,
	        mustSort: Boolean,
	        noResultsText: {
	            type: String,
	            default: '$vuetify.dataIterator.noResultsText'
	        },
	        nextIcon: {
	            type: String,
	            default: '$vuetify.icons.next'
	        },
	        prevIcon: {
	            type: String,
	            default: '$vuetify.icons.prev'
	        },
	        rowsPerPageItems: {
	            type: Array,
	            default: function _default() {
	                return [5, 10, 25, {
	                    text: '$vuetify.dataIterator.rowsPerPageAll',
	                    value: -1
	                }];
	            }
	        },
	        rowsPerPageText: {
	            type: String,
	            default: '$vuetify.dataIterator.rowsPerPageText'
	        },
	        selectAll: [Boolean, String],
	        search: {
	            required: false
	        },
	        filter: {
	            type: Function,
	            default: function _default(val, search) {
	                return val != null && typeof val !== 'boolean' && val.toString().toLowerCase().indexOf(search) !== -1;
	            }
	        },
	        customFilter: {
	            type: Function,
	            default: function _default(items, search, filter) {
	                search = search.toString().toLowerCase();
	                if (search.trim() === '') return items;
	                return items.filter(function (i) {
	                    return Object.keys(i).some(function (j) {
	                        return filter(i[j], search);
	                    });
	                });
	            }
	        },
	        customSort: {
	            type: Function,
	            default: function _default(items, index, isDescending) {
	                if (index === null) return items;
	                return items.sort(function (a, b) {
	                    var _a, _b;
	                    var sortA = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(a, index);
	                    var sortB = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(b, index);
	                    if (isDescending) {
	                        _a = __read([sortB, sortA], 2), sortA = _a[0], sortB = _a[1];
	                    }
	                    // Check if both are numbers
	                    if (!isNaN(sortA) && !isNaN(sortB)) {
	                        return sortA - sortB;
	                    }
	                    // Check if both cannot be evaluated
	                    if (sortA === null && sortB === null) {
	                        return 0;
	                    }
	                    _b = __read([sortA, sortB].map(function (s) {
	                        return (s || '').toString().toLocaleLowerCase();
	                    }), 2), sortA = _b[0], sortB = _b[1];
	                    if (sortA > sortB) return 1;
	                    if (sortA < sortB) return -1;
	                    return 0;
	                });
	            }
	        },
	        value: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        items: {
	            type: Array,
	            required: true,
	            default: function _default() {
	                return [];
	            }
	        },
	        totalItems: {
	            type: Number,
	            default: null
	        },
	        itemKey: {
	            type: String,
	            default: 'id'
	        },
	        pagination: {
	            type: Object,
	            default: function _default() {}
	        }
	    },
	    data: function data() {
	        return {
	            searchLength: 0,
	            defaultPagination: {
	                descending: false,
	                page: 1,
	                rowsPerPage: 5,
	                sortBy: null,
	                totalItems: 0
	            },
	            expanded: {},
	            actionsClasses: 'v-data-iterator__actions',
	            actionsRangeControlsClasses: 'v-data-iterator__actions__range-controls',
	            actionsSelectClasses: 'v-data-iterator__actions__select',
	            actionsPaginationClasses: 'v-data-iterator__actions__pagination'
	        };
	    },
	    computed: {
	        computedPagination: function computedPagination() {
	            return this.hasPagination ? this.pagination : this.defaultPagination;
	        },
	        computedRowsPerPageItems: function computedRowsPerPageItems() {
	            var _this = this;
	            return this.rowsPerPageItems.map(function (item) {
	                return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["isObject"])(item) ? Object.assign({}, item, {
	                    text: _this.$vuetify.t(item.text)
	                }) : { value: item, text: Number(item).toLocaleString(_this.$vuetify.lang.current) };
	            });
	        },
	        hasPagination: function hasPagination() {
	            var pagination = this.pagination || {};
	            return Object.keys(pagination).length > 0;
	        },
	        hasSelectAll: function hasSelectAll() {
	            return this.selectAll !== undefined && this.selectAll !== false;
	        },
	        itemsLength: function itemsLength() {
	            if (this.hasSearch) return this.searchLength;
	            return this.totalItems || this.items.length;
	        },
	        indeterminate: function indeterminate() {
	            return this.hasSelectAll && this.someItems && !this.everyItem;
	        },
	        everyItem: function everyItem() {
	            var _this = this;
	            return this.filteredItems.length && this.filteredItems.every(function (i) {
	                return _this.isSelected(i);
	            });
	        },
	        someItems: function someItems() {
	            var _this = this;
	            return this.filteredItems.some(function (i) {
	                return _this.isSelected(i);
	            });
	        },
	        getPage: function getPage() {
	            var rowsPerPage = this.computedPagination.rowsPerPage;
	            return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
	        },
	        pageStart: function pageStart() {
	            return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
	        },
	        pageStop: function pageStop() {
	            return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
	        },
	        filteredItems: function filteredItems() {
	            return this.filteredItemsImpl();
	        },
	        selected: function selected() {
	            var selected = {};
	            for (var index = 0; index < this.value.length; index++) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(this.value[index], this.itemKey);
	                selected[key] = true;
	            }
	            return selected;
	        },
	        hasSearch: function hasSearch() {
	            return this.search != null;
	        }
	    },
	    watch: {
	        items: function items() {
	            if (this.pageStart >= this.itemsLength) {
	                this.resetPagination();
	            }
	        },
	        search: function search() {
	            var _this = this;
	            this.$nextTick(function () {
	                _this.updatePagination({ page: 1, totalItems: _this.itemsLength });
	            });
	        },
	        'computedPagination.sortBy': 'resetPagination',
	        'computedPagination.descending': 'resetPagination'
	    },
	    methods: {
	        initPagination: function initPagination() {
	            if (!this.rowsPerPageItems.length) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("The prop 'rows-per-page-items' can not be empty", this);
	            } else {
	                this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
	            }
	            this.defaultPagination.totalItems = this.items.length;
	            this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
	        },
	        updatePagination: function updatePagination(val) {
	            var pagination = this.hasPagination ? this.pagination : this.defaultPagination;
	            var updatedPagination = Object.assign({}, pagination, val);
	            this.$emit('update:pagination', updatedPagination);
	            if (!this.hasPagination) {
	                this.defaultPagination = updatedPagination;
	            }
	        },
	        isSelected: function isSelected(item) {
	            return this.selected[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, this.itemKey)];
	        },
	        isExpanded: function isExpanded(item) {
	            return this.expanded[Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, this.itemKey)];
	        },
	        filteredItemsImpl: function filteredItemsImpl() {
	            var additionalFilterArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                additionalFilterArgs[_i] = arguments[_i];
	            }
	            if (this.totalItems) return this.items;
	            var items = this.items.slice();
	            if (this.hasSearch) {
	                items = this.customFilter.apply(this, __spread([items, this.search, this.filter], additionalFilterArgs));
	                this.searchLength = items.length;
	            }
	            items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);
	            return this.hideActions && !this.hasPagination ? items : items.slice(this.pageStart, this.pageStop);
	        },
	        resetPagination: function resetPagination() {
	            this.computedPagination.page !== 1 && this.updatePagination({ page: 1 });
	        },
	        sort: function sort(index) {
	            var _a = this.computedPagination,
	                sortBy = _a.sortBy,
	                descending = _a.descending;
	            if (sortBy === null) {
	                this.updatePagination({ sortBy: index, descending: false });
	            } else if (sortBy === index && !descending) {
	                this.updatePagination({ descending: true });
	            } else if (sortBy !== index) {
	                this.updatePagination({ sortBy: index, descending: false });
	            } else if (!this.mustSort) {
	                this.updatePagination({ sortBy: null, descending: null });
	            } else {
	                this.updatePagination({ sortBy: index, descending: false });
	            }
	        },
	        toggle: function toggle(value) {
	            var _this = this;
	            var selected = Object.assign({}, this.selected);
	            for (var index = 0; index < this.filteredItems.length; index++) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(this.filteredItems[index], this.itemKey);
	                selected[key] = value;
	            }
	            this.$emit('input', this.items.filter(function (i) {
	                var key = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(i, _this.itemKey);
	                return selected[key];
	            }));
	        },
	        createProps: function createProps(item, index) {
	            var _this = this;
	            var props = { item: item, index: index };
	            var keyProp = this.itemKey;
	            var itemKey = Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(item, keyProp);
	            Object.defineProperty(props, 'selected', {
	                get: function get() {
	                    return _this.selected[itemKey];
	                },
	                set: function set(value) {
	                    if (itemKey == null) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("\"" + keyProp + "\" attribute must be defined for item", _this);
	                    }
	                    var selected = _this.value.slice();
	                    if (value) selected.push(item);else selected = selected.filter(function (i) {
	                        return Object(_util_helpers__WEBPACK_IMPORTED_MODULE_6__["getObjectValueByPath"])(i, keyProp) !== itemKey;
	                    });
	                    _this.$emit('input', selected);
	                }
	            });
	            Object.defineProperty(props, 'expanded', {
	                get: function get() {
	                    return _this.expanded[itemKey];
	                },
	                set: function set(value) {
	                    if (itemKey == null) {
	                        Object(_util_console__WEBPACK_IMPORTED_MODULE_7__["consoleWarn"])("\"" + keyProp + "\" attribute must be defined for item", _this);
	                    }
	                    if (!_this.expand) {
	                        for (var key in _this.expanded) {
	                            _this.expanded.hasOwnProperty(key) && _this.$set(_this.expanded, key, false);
	                        }
	                    }
	                    _this.$set(_this.expanded, itemKey, value);
	                }
	            });
	            return props;
	        },
	        genItems: function genItems() {
	            if (!this.itemsLength && !this.items.length) {
	                var noData = this.$slots['no-data'] || this.$vuetify.t(this.noDataText);
	                return [this.genEmptyItems(noData)];
	            }
	            if (!this.filteredItems.length) {
	                var noResults = this.$slots['no-results'] || this.$vuetify.t(this.noResultsText);
	                return [this.genEmptyItems(noResults)];
	            }
	            return this.genFilteredItems();
	        },
	        genPrevIcon: function genPrevIcon() {
	            var _this = this;
	            return this.$createElement(_components_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    disabled: this.computedPagination.page === 1,
	                    icon: true,
	                    flat: true
	                },
	                on: {
	                    click: function click() {
	                        var page = _this.computedPagination.page;
	                        _this.updatePagination({ page: page - 1 });
	                    }
	                },
	                attrs: {
	                    'aria-label': this.$vuetify.t('$vuetify.dataIterator.prevPage')
	                }
	            }, [this.$createElement(_components_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.$vuetify.rtl ? this.nextIcon : this.prevIcon)]);
	        },
	        genNextIcon: function genNextIcon() {
	            var _this = this;
	            var pagination = this.computedPagination;
	            var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;
	            return this.$createElement(_components_VBtn__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                props: {
	                    disabled: disabled,
	                    icon: true,
	                    flat: true
	                },
	                on: {
	                    click: function click() {
	                        var page = _this.computedPagination.page;
	                        _this.updatePagination({ page: page + 1 });
	                    }
	                },
	                attrs: {
	                    'aria-label': this.$vuetify.t('$vuetify.dataIterator.nextPage')
	                }
	            }, [this.$createElement(_components_VIcon__WEBPACK_IMPORTED_MODULE_1__["default"], this.$vuetify.rtl ? this.prevIcon : this.nextIcon)]);
	        },
	        genSelect: function genSelect() {
	            var _this = this;
	            return this.$createElement('div', {
	                'class': this.actionsSelectClasses
	            }, [this.$vuetify.t(this.rowsPerPageText), this.$createElement(_components_VSelect__WEBPACK_IMPORTED_MODULE_2__["default"], {
	                attrs: {
	                    'aria-label': this.$vuetify.t(this.rowsPerPageText)
	                },
	                props: {
	                    items: this.computedRowsPerPageItems,
	                    value: this.computedPagination.rowsPerPage,
	                    hideDetails: true,
	                    menuProps: {
	                        auto: true,
	                        dark: this.dark,
	                        light: this.light,
	                        minWidth: '75px'
	                    }
	                },
	                on: {
	                    input: function input(val) {
	                        _this.updatePagination({
	                            page: 1,
	                            rowsPerPage: val
	                        });
	                    }
	                }
	            })]);
	        },
	        genPagination: function genPagination() {
	            var _this = this;
	            var _a;
	            var pagination = '–';
	            if (this.itemsLength) {
	                var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;
	                pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
	                    pageStart: this.pageStart + 1,
	                    pageStop: stop,
	                    itemsLength: this.itemsLength
	                }) : (_a = this.$vuetify).t.apply(_a, __spread(['$vuetify.dataIterator.pageText'], [this.pageStart + 1, stop, this.itemsLength].map(function (n) {
	                    return Number(n).toLocaleString(_this.$vuetify.lang.current);
	                })));
	            }
	            return this.$createElement('div', {
	                'class': this.actionsPaginationClasses
	            }, [pagination]);
	        },
	        genActions: function genActions() {
	            var rangeControls = this.$createElement('div', {
	                'class': this.actionsRangeControlsClasses
	            }, [this.genPagination(), this.genPrevIcon(), this.genNextIcon()]);
	            return [this.$createElement('div', {
	                'class': this.actionsClasses
	            }, [this.$slots['actions-prepend'] ? this.$createElement('div', {}, this.$slots['actions-prepend']) : null, this.rowsPerPageItems.length > 1 ? this.genSelect() : null, rangeControls, this.$slots['actions-append'] ? this.$createElement('div', {}, this.$slots['actions-append']) : null])];
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/delayable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/delayable.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * Delayable
	 *
	 * @mixin
	 *
	 * Changes the open or close delay time for elements
	 */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'delayable',
	    props: {
	        openDelay: {
	            type: [Number, String],
	            default: 0
	        },
	        closeDelay: {
	            type: [Number, String],
	            default: 0
	        }
	    },
	    data: function data() {
	        return {
	            openTimeout: undefined,
	            closeTimeout: undefined
	        };
	    },
	    methods: {
	        /**
	         * Clear any pending delay timers from executing
	         */
	        clearDelay: function clearDelay() {
	            clearTimeout(this.openTimeout);
	            clearTimeout(this.closeTimeout);
	        },
	        /**
	         * Runs callback after a specified delay
	         */
	        runDelay: function runDelay(type, cb) {
	            var _this = this;
	            this.clearDelay();
	            var delay = parseInt(this[type + "Delay"], 10);
	            this[type + "Timeout"] = setTimeout(cb || function () {
	                _this.isActive = { open: true, close: false }[type];
	            }, delay);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/dependent.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/dependent.ts ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/mixins */ "./src/util/mixins.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	function searchChildren(children) {
	    var results = [];
	    for (var index = 0; index < children.length; index++) {
	        var child = children[index];
	        if (child.isActive && child.isDependent) {
	            results.push(child);
	        } else {
	            results.push.apply(results, __spread(searchChildren(child.$children)));
	        }
	    }
	    return results;
	}
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_util_mixins__WEBPACK_IMPORTED_MODULE_0__["default"])().extend({
	    name: 'dependent',
	    data: function data() {
	        return {
	            closeDependents: true,
	            isActive: false,
	            isDependent: true
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) return;
	            var openDependents = this.getOpenDependents();
	            for (var index = 0; index < openDependents.length; index++) {
	                openDependents[index].isActive = false;
	            }
	        }
	    },
	    methods: {
	        getOpenDependents: function getOpenDependents() {
	            if (this.closeDependents) return searchChildren(this.$children);
	            return [];
	        },
	        getOpenDependentElements: function getOpenDependentElements() {
	            var result = [];
	            var openDependents = this.getOpenDependents();
	            for (var index = 0; index < openDependents.length; index++) {
	                result.push.apply(result, __spread(openDependents[index].getClickableDependentElements()));
	            }
	            return result;
	        },
	        getClickableDependentElements: function getClickableDependentElements() {
	            var result = [this.$el];
	            if (this.$refs.content) result.push(this.$refs.content);
	            result.push.apply(result, __spread(this.getOpenDependentElements()));
	            return result;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/detachable.js":
	/*!**********************************!*\
	  !*** ./src/mixins/detachable.js ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _bootable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./bootable */ "./src/mixins/bootable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	function validateAttachTarget(val) {
	    var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	    if (type === 'boolean' || type === 'string') return true;
	    return val.nodeType === Node.ELEMENT_NODE;
	}
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'detachable',
	    mixins: [_bootable__WEBPACK_IMPORTED_MODULE_0__["default"]],
	    props: {
	        attach: {
	            type: null,
	            default: false,
	            validator: validateAttachTarget
	        },
	        contentClass: {
	            default: ''
	        }
	    },
	    data: function data() {
	        return {
	            hasDetached: false
	        };
	    },
	    watch: {
	        attach: function attach() {
	            this.hasDetached = false;
	            this.initDetach();
	        },
	        hasContent: 'initDetach'
	    },
	    mounted: function mounted() {
	        !this.lazy && this.initDetach();
	    },
	    deactivated: function deactivated() {
	        this.isActive = false;
	    },
	    beforeDestroy: function beforeDestroy() {
	        if (!this.$refs.content) return;
	        // IE11 Fix
	        try {
	            this.$refs.content.parentNode.removeChild(this.$refs.content);
	        } catch (e) {
	            console.log(e);
	        }
	    },
	    methods: {
	        getScopeIdAttrs: function getScopeIdAttrs() {
	            var _a;
	            var scopeId = this.$vnode && this.$vnode.context.$options._scopeId;
	            return scopeId && (_a = {}, _a[scopeId] = '', _a);
	        },
	        initDetach: function initDetach() {
	            if (this._isDestroyed || !this.$refs.content || this.hasDetached ||
	            // Leave menu in place if attached
	            // and dev has not changed target
	            this.attach === '' || // If used as a boolean prop (<v-menu attach>)
	            this.attach === true || // If bound to a boolean (<v-menu :attach="true">)
	            this.attach === 'attach' // If bound as boolean prop in pug (v-menu(attach))
	            ) return;
	            var target;
	            if (this.attach === false) {
	                // Default, detach to app
	                target = document.querySelector('[data-app]');
	            } else if (typeof this.attach === 'string') {
	                // CSS selector
	                target = document.querySelector(this.attach);
	            } else {
	                // DOM Element
	                target = this.attach;
	            }
	            if (!target) {
	                Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("Unable to locate target " + (this.attach || '[data-app]'), this);
	                return;
	            }
	            target.insertBefore(this.$refs.content, target.firstChild);
	            this.hasDetached = true;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/filterable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/filterable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'filterable',
	    props: {
	        noDataText: {
	            type: String,
	            default: '$vuetify.noDataText'
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/groupable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/groupable.ts ***!
	  \*********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./registrable */ "./src/mixins/registrable.ts");
	// Mixins
	
	function factory(namespace, child, parent) {
	    return Object(_registrable__WEBPACK_IMPORTED_MODULE_0__["inject"])(namespace, child, parent).extend({
	        name: 'groupable',
	        props: {
	            activeClass: {
	                type: String,
	                default: function _default() {
	                    if (!this[namespace]) return undefined;
	                    return this[namespace].activeClass;
	                }
	            },
	            disabled: Boolean
	        },
	        data: function data() {
	            return {
	                isActive: false
	            };
	        },
	        computed: {
	            groupClasses: function groupClasses() {
	                var _a;
	                if (!this.activeClass) return {};
	                return _a = {}, _a[this.activeClass] = this.isActive, _a;
	            }
	        },
	        created: function created() {
	            this[namespace] && this[namespace].register(this);
	        },
	        beforeDestroy: function beforeDestroy() {
	            this[namespace] && this[namespace].unregister(this);
	        },
	        methods: {
	            toggle: function toggle() {
	                this.$emit('change');
	            }
	        }
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Groupable = factory('itemGroup');
	/* harmony default export */ __webpack_exports__["default"] = (Groupable);
	
	/***/ }),
	
	/***/ "./src/mixins/loadable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/loadable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/VProgressLinear */ "./src/components/VProgressLinear/index.ts");
	
	
	/**
	 * Loadable
	 *
	 * @mixin
	 *
	 * Used to add linear progress bar to components
	 * Can use a default bar with a specific color
	 * or designate a custom progress linear bar
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'loadable',
	    props: {
	        loading: {
	            type: [Boolean, String],
	            default: false
	        }
	    },
	    methods: {
	        genProgress: function genProgress() {
	            if (this.loading === false) return null;
	            return this.$slots.progress || this.$createElement(_components_VProgressLinear__WEBPACK_IMPORTED_MODULE_1__["default"], {
	                props: {
	                    color: this.loading === true || this.loading === '' ? this.color || 'primary' : this.loading,
	                    height: 2,
	                    indeterminate: true
	                }
	            });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/maskable.js":
	/*!********************************!*\
	  !*** ./src/mixins/maskable.js ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_mask__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/mask */ "./src/util/mask.js");
	/**
	 * Maskable
	 *
	 * @mixin
	 *
	 * Creates an input mask that is
	 * generated from a masked str
	 *
	 * Example: mask="#### #### #### ####"
	 */
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'maskable',
	    props: {
	        dontFillMaskBlanks: Boolean,
	        mask: {
	            type: [Object, String],
	            default: null
	        },
	        returnMaskedValue: Boolean,
	        value: { required: false }
	    },
	    data: function data(vm) {
	        return {
	            selection: 0,
	            lazySelection: 0,
	            lazyValue: vm.value,
	            preDefined: {
	                'credit-card': '#### - #### - #### - ####',
	                'date': '##/##/####',
	                'date-with-time': '##/##/#### ##:##',
	                'phone': '(###) ### - ####',
	                'social': '###-##-####',
	                'time': '##:##',
	                'time-with-seconds': '##:##:##'
	            }
	        };
	    },
	    computed: {
	        masked: function masked() {
	            var preDefined = this.preDefined[this.mask];
	            var mask = preDefined || this.mask || '';
	            return mask.split('');
	        }
	    },
	    watch: {
	        /**
	         * Make sure the cursor is in the correct
	         * location when the mask changes
	         */
	        mask: function mask() {
	            var _this = this;
	            if (!this.$refs.input) return;
	            var oldValue = this.$refs.input.value;
	            var newValue = this.maskText(Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["unmaskText"])(this.lazyValue));
	            var position = 0;
	            var selection = this.selection;
	            for (var index = 0; index < selection; index++) {
	                Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(oldValue[index]) || position++;
	            }
	            selection = 0;
	            if (newValue) {
	                for (var index = 0; index < newValue.length; index++) {
	                    Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(newValue[index]) || position--;
	                    selection++;
	                    if (position <= 0) break;
	                }
	            }
	            this.$nextTick(function () {
	                _this.$refs.input.value = newValue;
	                _this.setCaretPosition(selection);
	            });
	        }
	    },
	    beforeMount: function beforeMount() {
	        if (!this.mask || this.value == null || !this.returnMaskedValue) return;
	        var value = this.maskText(this.value);
	        // See if masked value does not
	        // match the user given value
	        if (value === this.value) return;
	        this.$emit('input', value);
	    },
	    methods: {
	        setCaretPosition: function setCaretPosition(selection) {
	            var _this = this;
	            this.selection = selection;
	            window.setTimeout(function () {
	                _this.$refs.input && _this.$refs.input.setSelectionRange(_this.selection, _this.selection);
	            }, 0);
	        },
	        updateRange: function updateRange() {
	            /* istanbul ignore next */
	            if (!this.$refs.input) return;
	            var newValue = this.maskText(this.lazyValue);
	            var selection = 0;
	            this.$refs.input.value = newValue;
	            if (newValue) {
	                for (var index = 0; index < newValue.length; index++) {
	                    if (this.lazySelection <= 0) break;
	                    Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(newValue[index]) || this.lazySelection--;
	                    selection++;
	                }
	            }
	            this.setCaretPosition(selection);
	            // this.$emit() must occur only when all internal values are correct
	            this.$emit('input', this.returnMaskedValue ? this.$refs.input.value : this.lazyValue);
	        },
	        maskText: function maskText(text) {
	            return this.mask ? Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["maskText"])(text, this.masked, this.dontFillMaskBlanks) : text;
	        },
	        unmaskText: function unmaskText(text) {
	            return this.mask && !this.returnMaskedValue ? Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["unmaskText"])(text) : text;
	        },
	        // When the input changes and is
	        // re-created, ensure that the
	        // caret location is correct
	        setSelectionRange: function setSelectionRange() {
	            this.$nextTick(this.updateRange);
	        },
	        resetSelections: function resetSelections(input) {
	            if (!input.selectionEnd) return;
	            this.selection = input.selectionEnd;
	            this.lazySelection = 0;
	            for (var index = 0; index < this.selection; index++) {
	                Object(_util_mask__WEBPACK_IMPORTED_MODULE_0__["isMaskDelimiter"])(input.value[index]) || this.lazySelection++;
	            }
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/measurable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/measurable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'measurable',
	    props: {
	        height: [Number, String],
	        maxHeight: [Number, String],
	        maxWidth: [Number, String],
	        width: [Number, String]
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/menuable.js":
	/*!********************************!*\
	  !*** ./src/mixins/menuable.js ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _positionable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./positionable */ "./src/mixins/positionable.ts");
	/* harmony import */ var _stackable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./stackable */ "./src/mixins/stackable.js");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	
	/* eslint-disable object-property-newline */
	var dimensions = {
	    activator: {
	        top: 0, left: 0,
	        bottom: 0, right: 0,
	        width: 0, height: 0,
	        offsetTop: 0, scrollHeight: 0
	    },
	    content: {
	        top: 0, left: 0,
	        bottom: 0, right: 0,
	        width: 0, height: 0,
	        offsetTop: 0, scrollHeight: 0
	    },
	    hasWindow: false
	};
	/* eslint-enable object-property-newline */
	/**
	 * Menuable
	 *
	 * @mixin
	 *
	 * Used for fixed or absolutely positioning
	 * elements within the DOM
	 * Can calculate X and Y axis overflows
	 * As well as be manually positioned
	 */
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'menuable',
	    mixins: [_positionable__WEBPACK_IMPORTED_MODULE_1__["default"], _stackable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        activator: {
	            default: null,
	            validator: function validator(val) {
	                return ['string', 'object'].includes(typeof val === 'undefined' ? 'undefined' : _typeof(val));
	            }
	        },
	        allowOverflow: Boolean,
	        inputActivator: Boolean,
	        light: Boolean,
	        dark: Boolean,
	        maxWidth: {
	            type: [Number, String],
	            default: 'auto'
	        },
	        minWidth: [Number, String],
	        nudgeBottom: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeLeft: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeRight: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeTop: {
	            type: [Number, String],
	            default: 0
	        },
	        nudgeWidth: {
	            type: [Number, String],
	            default: 0
	        },
	        offsetOverflow: Boolean,
	        positionX: {
	            type: Number,
	            default: null
	        },
	        positionY: {
	            type: Number,
	            default: null
	        },
	        zIndex: {
	            type: [Number, String],
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            absoluteX: 0,
	            absoluteY: 0,
	            dimensions: Object.assign({}, dimensions),
	            isContentActive: false,
	            pageYOffset: 0,
	            stackClass: 'v-menu__content--active',
	            stackMinZIndex: 6
	        };
	    },
	    computed: {
	        computedLeft: function computedLeft() {
	            var a = this.dimensions.activator;
	            var c = this.dimensions.content;
	            var minWidth = a.width < c.width ? c.width : a.width;
	            var left = 0;
	            left += this.left ? a.left - (minWidth - a.width) : a.left;
	            if (this.offsetX) left += this.left ? -a.width : a.width;
	            if (this.nudgeLeft) left -= parseInt(this.nudgeLeft);
	            if (this.nudgeRight) left += parseInt(this.nudgeRight);
	            return left;
	        },
	        computedTop: function computedTop() {
	            var a = this.dimensions.activator;
	            var c = this.dimensions.content;
	            var top = this.top ? a.bottom - c.height : a.top;
	            if (!this.isAttached) top += this.pageYOffset;
	            if (this.offsetY) top += this.top ? -a.height : a.height;
	            if (this.nudgeTop) top -= parseInt(this.nudgeTop);
	            if (this.nudgeBottom) top += parseInt(this.nudgeBottom);
	            return top;
	        },
	        hasActivator: function hasActivator() {
	            return !!this.$slots.activator || this.activator || this.inputActivator;
	        },
	        isAttached: function isAttached() {
	            return this.attach !== false;
	        }
	    },
	    watch: {
	        disabled: function disabled(val) {
	            val && this.callDeactivate();
	        },
	        isActive: function isActive(val) {
	            if (this.disabled) return;
	            val ? this.callActivate() : this.callDeactivate();
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.checkForWindow();
	    },
	    methods: {
	        absolutePosition: function absolutePosition() {
	            return {
	                offsetTop: 0,
	                scrollHeight: 0,
	                top: this.positionY || this.absoluteY,
	                bottom: this.positionY || this.absoluteY,
	                left: this.positionX || this.absoluteX,
	                right: this.positionX || this.absoluteX,
	                height: 0,
	                width: 0
	            };
	        },
	        activate: function activate() {},
	        calcLeft: function calcLeft() {
	            return (this.isAttached ? this.computedLeft : this.calcXOverflow(this.computedLeft)) + "px";
	        },
	        calcTop: function calcTop() {
	            return (this.isAttached ? this.computedTop : this.calcYOverflow(this.computedTop)) + "px";
	        },
	        calcXOverflow: function calcXOverflow(left) {
	            var parsedMaxWidth = isNaN(parseInt(this.maxWidth)) ? 0 : parseInt(this.maxWidth);
	            var innerWidth = this.getInnerWidth();
	            var maxWidth = Math.max(this.dimensions.content.width, parsedMaxWidth);
	            var totalWidth = left + maxWidth;
	            var availableWidth = totalWidth - innerWidth;
	            if ((!this.left || this.right) && availableWidth > 0) {
	                left = innerWidth - maxWidth - (innerWidth > 600 ? 30 : 12) // Account for scrollbar
	                ;
	            }
	            if (left < 0) left = 12;
	            return left + this.getOffsetLeft();
	        },
	        calcYOverflow: function calcYOverflow(top) {
	            var documentHeight = this.getInnerHeight();
	            var toTop = this.pageYOffset + documentHeight;
	            var activator = this.dimensions.activator;
	            var contentHeight = this.dimensions.content.height;
	            var totalHeight = top + contentHeight;
	            var isOverflowing = toTop < totalHeight;
	            // If overflowing bottom and offset
	            // TODO: set 'bottom' position instead of 'top'
	            if (isOverflowing && this.offsetOverflow &&
	            // If we don't have enough room to offset
	            // the overflow, don't offset
	            activator.top > contentHeight) {
	                top = this.pageYOffset + (activator.top - contentHeight);
	                // If overflowing bottom
	            } else if (isOverflowing && !this.allowOverflow) {
	                top = toTop - contentHeight - 12;
	                // If overflowing top
	            } else if (top < this.pageYOffset && !this.allowOverflow) {
	                top = this.pageYOffset + 12;
	            }
	            return top < 12 ? 12 : top;
	        },
	        callActivate: function callActivate() {
	            if (!this.hasWindow) return;
	            this.activate();
	        },
	        callDeactivate: function callDeactivate() {
	            this.isContentActive = false;
	            this.deactivate();
	        },
	        checkForWindow: function checkForWindow() {
	            if (!this.hasWindow) {
	                this.hasWindow = typeof window !== 'undefined';
	            }
	        },
	        checkForPageYOffset: function checkForPageYOffset() {
	            if (this.hasWindow) {
	                this.pageYOffset = this.getOffsetTop();
	            }
	        },
	        deactivate: function deactivate() {},
	        getActivator: function getActivator() {
	            if (this.inputActivator) {
	                return this.$el.querySelector('.v-input__slot');
	            }
	            if (this.activator) {
	                return typeof this.activator === 'string' ? document.querySelector(this.activator) : this.activator;
	            }
	            return this.$refs.activator.children.length > 0 ? this.$refs.activator.children[0] : this.$refs.activator;
	        },
	        getInnerHeight: function getInnerHeight() {
	            if (!this.hasWindow) return 0;
	            return window.innerHeight || document.documentElement.clientHeight;
	        },
	        getInnerWidth: function getInnerWidth() {
	            if (!this.hasWindow) return 0;
	            return window.innerWidth;
	        },
	        getOffsetLeft: function getOffsetLeft() {
	            if (!this.hasWindow) return 0;
	            return window.pageXOffset || document.documentElement.scrollLeft;
	        },
	        getOffsetTop: function getOffsetTop() {
	            if (!this.hasWindow) return 0;
	            return window.pageYOffset || document.documentElement.scrollTop;
	        },
	        getRoundedBoundedClientRect: function getRoundedBoundedClientRect(el) {
	            var rect = el.getBoundingClientRect();
	            return {
	                top: Math.round(rect.top),
	                left: Math.round(rect.left),
	                bottom: Math.round(rect.bottom),
	                right: Math.round(rect.right),
	                width: Math.round(rect.width),
	                height: Math.round(rect.height)
	            };
	        },
	        measure: function measure(el, selector) {
	            el = selector ? el.querySelector(selector) : el;
	            if (!el || !this.hasWindow) return null;
	            var rect = this.getRoundedBoundedClientRect(el);
	            // Account for activator margin
	            if (this.isAttached) {
	                var style = window.getComputedStyle(el);
	                rect.left = parseInt(style.marginLeft);
	                rect.top = parseInt(style.marginTop);
	            }
	            return rect;
	        },
	        sneakPeek: function sneakPeek(cb) {
	            var _this = this;
	            requestAnimationFrame(function () {
	                var el = _this.$refs.content;
	                if (!el || _this.isShown(el)) return cb();
	                el.style.display = 'inline-block';
	                cb();
	                el.style.display = 'none';
	            });
	        },
	        startTransition: function startTransition() {
	            var _this = this;
	            return new Promise(function (resolve) {
	                return requestAnimationFrame(function () {
	                    _this.isContentActive = _this.hasJustFocused = _this.isActive;
	                    resolve();
	                });
	            });
	        },
	        isShown: function isShown(el) {
	            return el.style.display !== 'none';
	        },
	        updateDimensions: function updateDimensions() {
	            var _this = this;
	            this.checkForWindow();
	            this.checkForPageYOffset();
	            var dimensions = {};
	            // Activator should already be shown
	            dimensions.activator = !this.hasActivator || this.absolute ? this.absolutePosition() : this.measure(this.getActivator());
	            // Display and hide to get dimensions
	            this.sneakPeek(function () {
	                dimensions.content = _this.measure(_this.$refs.content);
	                _this.dimensions = dimensions;
	            });
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/overlayable.js":
	/*!***********************************!*\
	  !*** ./src/mixins/overlayable.js ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../stylus/components/_overlay.styl */ "./src/stylus/components/_overlay.styl");
	/* harmony import */ var _stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_stylus_components_overlay_styl__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	// Utils
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'overlayable',
	    props: {
	        hideOverlay: Boolean
	    },
	    data: function data() {
	        return {
	            overlay: null,
	            overlayOffset: 0,
	            overlayTimeout: null,
	            overlayTransitionDuration: 500 + 150 // transition + delay
	        };
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.removeOverlay();
	    },
	    methods: {
	        genOverlay: function genOverlay() {
	            var _this = this;
	            // If fn is called and timeout is active
	            // or overlay already exists
	            // cancel removal of overlay and re-add active
	            if (!this.isActive || this.hideOverlay || this.isActive && this.overlayTimeout || this.overlay) {
	                clearTimeout(this.overlayTimeout);
	                return this.overlay && this.overlay.classList.add('v-overlay--active');
	            }
	            this.overlay = document.createElement('div');
	            this.overlay.className = 'v-overlay';
	            if (this.absolute) this.overlay.className += ' v-overlay--absolute';
	            this.hideScroll();
	            var parent = this.absolute ? this.$el.parentNode : document.querySelector('[data-app]');
	            parent && parent.insertBefore(this.overlay, parent.firstChild);
	            // eslint-disable-next-line no-unused-expressions
	            this.overlay.clientHeight; // Force repaint
	            requestAnimationFrame(function () {
	                // https://github.com/vuetifyjs/vuetify/issues/4678
	                if (!_this.overlay) return;
	                _this.overlay.className += ' v-overlay--active';
	                if (_this.activeZIndex !== undefined) {
	                    _this.overlay.style.zIndex = _this.activeZIndex - 1;
	                }
	            });
	            return true;
	        },
	        /** removeOverlay(false) will not restore the scollbar afterwards */
	        removeOverlay: function removeOverlay(showScroll) {
	            var _this = this;
	            if (showScroll === void 0) {
	                showScroll = true;
	            }
	            if (!this.overlay) {
	                return showScroll && this.showScroll();
	            }
	            this.overlay.classList.remove('v-overlay--active');
	            this.overlayTimeout = setTimeout(function () {
	                // IE11 Fix
	                try {
	                    if (_this.overlay && _this.overlay.parentNode) {
	                        _this.overlay.parentNode.removeChild(_this.overlay);
	                    }
	                    _this.overlay = null;
	                    showScroll && _this.showScroll();
	                } catch (e) {
	                    console.log(e);
	                }
	                clearTimeout(_this.overlayTimeout);
	                _this.overlayTimeout = null;
	            }, this.overlayTransitionDuration);
	        },
	        /**
	         * @param {Event} e
	         * @returns void
	         */
	        scrollListener: function scrollListener(e) {
	            if (e.type === 'keydown') {
	                if (['INPUT', 'TEXTAREA', 'SELECT'].includes(e.target.tagName) ||
	                // https://github.com/vuetifyjs/vuetify/issues/4715
	                e.target.isContentEditable) return;
	                var up = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].up, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pageup];
	                var down = [_util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].down, _util_helpers__WEBPACK_IMPORTED_MODULE_1__["keyCodes"].pagedown];
	                if (up.includes(e.keyCode)) {
	                    e.deltaY = -1;
	                } else if (down.includes(e.keyCode)) {
	                    e.deltaY = 1;
	                } else {
	                    return;
	                }
	            }
	            if (e.target === this.overlay || e.type !== 'keydown' && e.target === document.body || this.checkPath(e)) e.preventDefault();
	        },
	        hasScrollbar: function hasScrollbar(el) {
	            if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
	            var style = window.getComputedStyle(el);
	            return ['auto', 'scroll'].includes(style['overflow-y']) && el.scrollHeight > el.clientHeight;
	        },
	        shouldScroll: function shouldScroll(el, delta) {
	            if (el.scrollTop === 0 && delta < 0) return true;
	            return el.scrollTop + el.clientHeight === el.scrollHeight && delta > 0;
	        },
	        isInside: function isInside(el, parent) {
	            if (el === parent) {
	                return true;
	            } else if (el === null || el === document.body) {
	                return false;
	            } else {
	                return this.isInside(el.parentNode, parent);
	            }
	        },
	        /**
	         * @param {Event} e
	         * @returns boolean
	         */
	        checkPath: function checkPath(e) {
	            var path = e.path || this.composedPath(e);
	            var delta = e.deltaY || -e.wheelDelta;
	            if (e.type === 'keydown' && path[0] === document.body) {
	                var dialog = this.$refs.dialog;
	                var selected = window.getSelection().anchorNode;
	                if (this.hasScrollbar(dialog) && this.isInside(selected, dialog)) {
	                    return this.shouldScroll(dialog, delta);
	                }
	                return true;
	            }
	            for (var index = 0; index < path.length; index++) {
	                var el = path[index];
	                if (el === document) return true;
	                if (el === document.documentElement) return true;
	                if (el === this.$refs.content) return true;
	                if (this.hasScrollbar(el)) return this.shouldScroll(el, delta);
	            }
	            return true;
	        },
	        /**
	         * Polyfill for Event.prototype.composedPath
	         * @param {Event} e
	         * @returns Element[]
	         */
	        composedPath: function composedPath(e) {
	            if (e.composedPath) return e.composedPath();
	            var path = [];
	            var el = e.target;
	            while (el) {
	                path.push(el);
	                if (el.tagName === 'HTML') {
	                    path.push(document);
	                    path.push(window);
	                    return path;
	                }
	                el = el.parentElement;
	            }
	        },
	        hideScroll: function hideScroll() {
	            if (this.$vuetify.breakpoint.smAndDown) {
	                document.documentElement.classList.add('overflow-y-hidden');
	            } else {
	                window.addEventListener('wheel', this.scrollListener);
	                window.addEventListener('keydown', this.scrollListener);
	            }
	        },
	        showScroll: function showScroll() {
	            document.documentElement.classList.remove('overflow-y-hidden');
	            window.removeEventListener('wheel', this.scrollListener);
	            window.removeEventListener('keydown', this.scrollListener);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/picker-button.js":
	/*!*************************************!*\
	  !*** ./src/mixins/picker-button.js ***!
	  \*************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    methods: {
	        genPickerButton: function genPickerButton(prop, value, content, readonly, staticClass) {
	            var _this = this;
	            if (readonly === void 0) {
	                readonly = false;
	            }
	            if (staticClass === void 0) {
	                staticClass = '';
	            }
	            var active = this[prop] === value;
	            var click = function click(event) {
	                event.stopPropagation();
	                _this.$emit("update:" + prop, value);
	            };
	            return this.$createElement('div', {
	                staticClass: ("v-picker__title__btn " + staticClass).trim(),
	                'class': {
	                    'v-picker__title__btn--active': active,
	                    'v-picker__title__btn--readonly': readonly
	                },
	                on: active || readonly ? undefined : { click: click }
	            }, Array.isArray(content) ? content : [content]);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/picker.js":
	/*!******************************!*\
	  !*** ./src/mixins/picker.js ***!
	  \******************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VPicker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VPicker */ "./src/components/VPicker/index.js");
	/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./colorable */ "./src/mixins/colorable.ts");
	/* harmony import */ var _themeable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./themeable */ "./src/mixins/themeable.ts");
	// Components
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'picker',
	    mixins: [_colorable__WEBPACK_IMPORTED_MODULE_1__["default"], _themeable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    props: {
	        fullWidth: Boolean,
	        headerColor: String,
	        landscape: Boolean,
	        noTitle: Boolean,
	        width: {
	            type: [Number, String],
	            default: 290
	        }
	    },
	    methods: {
	        genPickerTitle: function genPickerTitle() {},
	        genPickerBody: function genPickerBody() {},
	        genPickerActionsSlot: function genPickerActionsSlot() {
	            return this.$scopedSlots.default ? this.$scopedSlots.default({
	                save: this.save,
	                cancel: this.cancel
	            }) : this.$slots.default;
	        },
	        genPicker: function genPicker(staticClass) {
	            return this.$createElement(_components_VPicker__WEBPACK_IMPORTED_MODULE_0__["default"], {
	                staticClass: staticClass,
	                props: {
	                    color: this.headerColor || this.color,
	                    dark: this.dark,
	                    fullWidth: this.fullWidth,
	                    landscape: this.landscape,
	                    light: this.light,
	                    width: this.width
	                }
	            }, [this.noTitle ? null : this.genPickerTitle(), this.genPickerBody(), this.$createElement('template', { slot: 'actions' }, [this.genPickerActionsSlot()])]);
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/positionable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/positionable.ts ***!
	  \************************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	
	
	var availableProps = {
	  absolute: Boolean,
	  bottom: Boolean,
	  fixed: Boolean,
	  left: Boolean,
	  right: Boolean,
	  top: Boolean
	};
	function factory(selected) {
	  if (selected === void 0) {
	    selected = [];
	  }
	  return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'positionable',
	    props: selected.length ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_1__["filterObjectOnKeys"])(availableProps, selected) : availableProps
	  });
	}
	/* harmony default export */ __webpack_exports__["default"] = (factory());
	// Add a `*` before the second `/`
	/* Tests /
	let single = factory(['top']).extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	  }
	})
	
	let some = factory(['top', 'bottom']).extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	  }
	})
	
	let all = factory().extend({
	  created () {
	    this.top
	    this.bottom
	    this.absolute
	    this.foobar
	  }
	})
	/**/
	
	/***/ }),
	
	/***/ "./src/mixins/proxyable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/proxyable.ts ***!
	  \*********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	function factory(prop, event) {
	    if (prop === void 0) {
	        prop = 'value';
	    }
	    if (event === void 0) {
	        event = 'change';
	    }
	    var _a, _b;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'proxyable',
	        model: {
	            prop: prop,
	            event: event
	        },
	        props: (_a = {}, _a[prop] = {
	            required: false
	        }, _a),
	        data: function data() {
	            return {
	                internalLazyValue: this[prop]
	            };
	        },
	        computed: {
	            internalValue: {
	                get: function get() {
	                    return this.internalLazyValue;
	                },
	                set: function set(val) {
	                    if (val === this.internalLazyValue) return;
	                    this.internalLazyValue = val;
	                    this.$emit(event, val);
	                }
	            }
	        },
	        watch: (_b = {}, _b[prop] = function (val) {
	            this.internalLazyValue = val;
	        }, _b)
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Proxyable = factory();
	/* harmony default export */ __webpack_exports__["default"] = (Proxyable);
	
	/***/ }),
	
	/***/ "./src/mixins/registrable.ts":
	/*!***********************************!*\
	  !*** ./src/mixins/registrable.ts ***!
	  \***********************************/
	/*! exports provided: inject, provide */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provide", function() { return provide; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	
	
	function generateWarning(child, parent) {
	    return function () {
	        return Object(_util_console__WEBPACK_IMPORTED_MODULE_1__["consoleWarn"])("The " + child + " component must be used inside a " + parent);
	    };
	}
	function inject(namespace, child, parent) {
	    var _a;
	    var defaultImpl = child && parent ? {
	        register: generateWarning(child, parent),
	        unregister: generateWarning(child, parent)
	    } : null;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'registrable-inject',
	        inject: (_a = {}, _a[namespace] = {
	            default: defaultImpl
	        }, _a)
	    });
	}
	function provide(namespace) {
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'registrable-provide',
	        methods: {
	            register: null,
	            unregister: null
	        },
	        provide: function provide() {
	            var _a;
	            return _a = {}, _a[namespace] = {
	                register: this.register,
	                unregister: this.unregister
	            }, _a;
	        }
	    });
	}
	
	/***/ }),
	
	/***/ "./src/mixins/returnable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/returnable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'returnable',
	    props: {
	        returnValue: null
	    },
	    data: function data() {
	        return {
	            isActive: false,
	            originalValue: null
	        };
	    },
	    watch: {
	        isActive: function isActive(val) {
	            if (val) {
	                this.originalValue = this.returnValue;
	            } else {
	                this.$emit('update:returnValue', this.originalValue);
	            }
	        }
	    },
	    methods: {
	        save: function save(value) {
	            this.originalValue = value;
	            this.isActive = false;
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/rippleable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/rippleable.ts ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../directives/ripple */ "./src/directives/ripple.ts");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);
	// Directives
	
	// Types
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_1___default.a.extend({
	    name: 'rippleable',
	    directives: { Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_0__["default"] },
	    props: {
	        ripple: {
	            type: [Boolean, Object],
	            default: true
	        }
	    },
	    methods: {
	        genRipple: function genRipple(data) {
	            if (data === void 0) {
	                data = {};
	            }
	            if (!this.ripple) return null;
	            data.staticClass = 'v-input--selection-controls__ripple';
	            data.directives = data.directives || [];
	            data.directives.push({
	                name: 'ripple',
	                value: { center: true }
	            });
	            data.on = Object.assign({
	                click: this.onChange
	            }, this.$listeners);
	            return this.$createElement('div', data);
	        },
	        onChange: function onChange() {}
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/routable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/routable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* harmony import */ var _directives_ripple__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../directives/ripple */ "./src/directives/ripple.ts");
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'routable',
	    directives: {
	        Ripple: _directives_ripple__WEBPACK_IMPORTED_MODULE_1__["default"]
	    },
	    props: {
	        activeClass: String,
	        append: Boolean,
	        disabled: Boolean,
	        exact: {
	            type: Boolean,
	            default: undefined
	        },
	        exactActiveClass: String,
	        href: [String, Object],
	        to: [String, Object],
	        nuxt: Boolean,
	        replace: Boolean,
	        ripple: [Boolean, Object],
	        tag: String,
	        target: String
	    },
	    computed: {
	        computedRipple: function computedRipple() {
	            return this.ripple && !this.disabled ? this.ripple : false;
	        }
	    },
	    methods: {
	        click: function click(e) {
	            this.$emit('click', e);
	        },
	        generateRouteLink: function generateRouteLink(classes) {
	            var _a;
	            var exact = this.exact;
	            var tag;
	            var data = (_a = {
	                attrs: { disabled: this.disabled },
	                class: classes,
	                props: {},
	                directives: [{
	                    name: 'ripple',
	                    value: this.computedRipple
	                }]
	            }, _a[this.to ? 'nativeOn' : 'on'] = __assign({}, this.$listeners, { click: this.click }), _a);
	            if (typeof this.exact === 'undefined') {
	                exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
	            }
	            if (this.to) {
	                // Add a special activeClass hook
	                // for component level styles
	                var activeClass = this.activeClass;
	                var exactActiveClass = this.exactActiveClass || activeClass;
	                // TODO: apply only in VListTile
	                if (this.proxyClass) {
	                    activeClass += ' ' + this.proxyClass;
	                    exactActiveClass += ' ' + this.proxyClass;
	                }
	                tag = this.nuxt ? 'nuxt-link' : 'router-link';
	                Object.assign(data.props, {
	                    to: this.to,
	                    exact: exact,
	                    activeClass: activeClass,
	                    exactActiveClass: exactActiveClass,
	                    append: this.append,
	                    replace: this.replace
	                });
	            } else {
	                tag = this.href && 'a' || this.tag || 'a';
	                if (tag === 'a' && this.href) data.attrs.href = this.href;
	            }
	            if (this.target) data.attrs.target = this.target;
	            return { tag: tag, data: data };
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/selectable.js":
	/*!**********************************!*\
	  !*** ./src/mixins/selectable.js ***!
	  \**********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _components_VInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/VInput */ "./src/components/VInput/index.js");
	/* harmony import */ var _rippleable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./rippleable */ "./src/mixins/rippleable.ts");
	/* harmony import */ var _comparable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./comparable */ "./src/mixins/comparable.ts");
	// Components
	
	// Mixins
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'selectable',
	    extends: _components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"],
	    mixins: [_rippleable__WEBPACK_IMPORTED_MODULE_1__["default"], _comparable__WEBPACK_IMPORTED_MODULE_2__["default"]],
	    model: {
	        prop: 'inputValue',
	        event: 'change'
	    },
	    props: {
	        color: {
	            type: String,
	            default: 'accent'
	        },
	        id: String,
	        inputValue: null,
	        falseValue: null,
	        trueValue: null,
	        multiple: {
	            type: Boolean,
	            default: null
	        },
	        label: String
	    },
	    data: function data(vm) {
	        return {
	            lazyValue: vm.inputValue
	        };
	    },
	    computed: {
	        computedColor: function computedColor() {
	            return this.isActive ? this.color : this.validationState;
	        },
	        isMultiple: function isMultiple() {
	            return this.multiple === true || this.multiple === null && Array.isArray(this.internalValue);
	        },
	        isActive: function isActive() {
	            var _this = this;
	            var value = this.value;
	            var input = this.internalValue;
	            if (this.isMultiple) {
	                if (!Array.isArray(input)) return false;
	                return input.some(function (item) {
	                    return _this.valueComparator(item, value);
	                });
	            }
	            if (this.trueValue === undefined || this.falseValue === undefined) {
	                return value ? this.valueComparator(value, input) : Boolean(input);
	            }
	            return this.valueComparator(input, this.trueValue);
	        },
	        isDirty: function isDirty() {
	            return this.isActive;
	        }
	    },
	    watch: {
	        inputValue: function inputValue(val) {
	            this.lazyValue = val;
	        }
	    },
	    methods: {
	        genLabel: function genLabel() {
	            if (!this.hasLabel) return null;
	            var label = _components_VInput__WEBPACK_IMPORTED_MODULE_0__["default"].methods.genLabel.call(this);
	            label.data.on = { click: this.onChange };
	            return label;
	        },
	        genInput: function genInput(type, attrs) {
	            return this.$createElement('input', {
	                attrs: Object.assign({
	                    'aria-label': this.label,
	                    'aria-checked': this.isActive.toString(),
	                    disabled: this.isDisabled,
	                    id: this.id,
	                    role: type,
	                    type: type
	                }, attrs),
	                domProps: {
	                    value: this.value,
	                    checked: this.isActive
	                },
	                on: {
	                    blur: this.onBlur,
	                    change: this.onChange,
	                    focus: this.onFocus,
	                    keydown: this.onKeydown
	                },
	                ref: 'input'
	            });
	        },
	        onBlur: function onBlur() {
	            this.isFocused = false;
	        },
	        onChange: function onChange() {
	            var _this = this;
	            if (this.isDisabled) return;
	            var value = this.value;
	            var input = this.internalValue;
	            if (this.isMultiple) {
	                if (!Array.isArray(input)) {
	                    input = [];
	                }
	                var length = input.length;
	                input = input.filter(function (item) {
	                    return !_this.valueComparator(item, value);
	                });
	                if (input.length === length) {
	                    input.push(value);
	                }
	            } else if (this.trueValue !== undefined && this.falseValue !== undefined) {
	                input = this.valueComparator(input, this.trueValue) ? this.falseValue : this.trueValue;
	            } else if (value) {
	                input = this.valueComparator(input, value) ? null : value;
	            } else {
	                input = !input;
	            }
	            this.validate(true, input);
	            this.internalValue = input;
	        },
	        onFocus: function onFocus() {
	            this.isFocused = true;
	        },
	        /** @abstract */
	        onKeydown: function onKeydown(e) {}
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/sizeable.ts":
	/*!********************************!*\
	  !*** ./src/mixins/sizeable.ts ***!
	  \********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'sizeable',
	    props: {
	        large: Boolean,
	        medium: Boolean,
	        size: {
	            type: [Number, String]
	        },
	        small: Boolean,
	        xLarge: Boolean
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/ssr-bootable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/ssr-bootable.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/**
	 * SSRBootable
	 *
	 * @mixin
	 *
	 * Used in layout components (drawer, toolbar, content)
	 * to avoid an entry animation when using SSR
	 */
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'ssr-bootable',
	    data: function data() {
	        return {
	            isBooted: false
	        };
	    },
	    mounted: function mounted() {
	        var _this = this;
	        // Use setAttribute instead of dataset
	        // because dataset does not work well
	        // with unit tests
	        window.requestAnimationFrame(function () {
	            _this.$el.setAttribute('data-booted', 'true');
	            _this.isBooted = true;
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/stackable.js":
	/*!*********************************!*\
	  !*** ./src/mixins/stackable.js ***!
	  \*********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	var __spread = undefined && undefined.__spread || function () {
	    for (var ar = [], i = 0; i < arguments.length; i++) {
	        ar = ar.concat(__read(arguments[i]));
	    }return ar;
	};
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'stackable',
	    data: function data() {
	        return {
	            stackBase: null,
	            stackClass: 'unpecified',
	            stackElement: null,
	            stackExclude: null,
	            stackMinZIndex: 0
	        };
	    },
	    computed: {
	        /**
	         * Currently active z-index
	         *
	         * @return {number}
	         */
	        activeZIndex: function activeZIndex() {
	            if (typeof window === 'undefined') return 0;
	            var content = this.stackElement || this.$refs.content;
	            // Return current zindex if not active
	            var index = !this.isActive ? Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getZIndex"])(content) : this.getMaxZIndex(this.stackExclude || [content]) + 2;
	            if (index == null) return index;
	            // Return max current z-index (excluding self) + 2
	            // (2 to leave room for an overlay below, if needed)
	            return parseInt(index);
	        }
	    },
	    methods: {
	        getMaxZIndex: function getMaxZIndex(exclude) {
	            if (exclude === void 0) {
	                exclude = [];
	            }
	            var base = this.stackBase || this.$el;
	            // Start with lowest allowed z-index or z-index of
	            // base component's element, whichever is greater
	            var zis = [this.stackMinZIndex, Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getZIndex"])(base)];
	            // Convert the NodeList to an array to
	            // prevent an Edge bug with Symbol.iterator
	            // https://github.com/vuetifyjs/vuetify/issues/2146
	            var activeElements = __spread(document.getElementsByClassName(this.stackClass));
	            // Get z-index for all active dialogs
	            for (var index = 0; index < activeElements.length; index++) {
	                if (!exclude.includes(activeElements[index])) {
	                    zis.push(Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["getZIndex"])(activeElements[index]));
	                }
	            }
	            return Math.max.apply(Math, __spread(zis));
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/mixins/themeable.ts":
	/*!*********************************!*\
	  !*** ./src/mixins/themeable.ts ***!
	  \*********************************/
	/*! exports provided: functionalThemeClasses, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "functionalThemeClasses", function() { return functionalThemeClasses; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function functionalThemeClasses(context) {
	    var vm = __assign({}, context.props, context.injections);
	    var isDark = Themeable.options.computed.isDark.call(vm);
	    return Themeable.options.computed.themeClasses.call({ isDark: isDark });
	}
	/* @vue/component */
	var Themeable = vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend().extend({
	    name: 'themeable',
	    provide: function provide() {
	        return {
	            theme: this.themeableProvide
	        };
	    },
	    inject: {
	        theme: {
	            default: {
	                isDark: false
	            }
	        }
	    },
	    props: {
	        dark: {
	            type: Boolean,
	            default: null
	        },
	        light: {
	            type: Boolean,
	            default: null
	        }
	    },
	    data: function data() {
	        return {
	            themeableProvide: {
	                isDark: false
	            }
	        };
	    },
	    computed: {
	        isDark: function isDark() {
	            if (this.dark === true) {
	                // explicitly dark
	                return true;
	            } else if (this.light === true) {
	                // explicitly light
	                return false;
	            } else {
	                // inherit from parent, or default false if there is none
	                return this.theme.isDark;
	            }
	        },
	        themeClasses: function themeClasses() {
	            return {
	                'theme--dark': this.isDark,
	                'theme--light': !this.isDark
	            };
	        },
	        /** Used by menus and dialogs, inherits from v-app instead of the parent */
	        rootIsDark: function rootIsDark() {
	            if (this.dark === true) {
	                // explicitly dark
	                return true;
	            } else if (this.light === true) {
	                // explicitly light
	                return false;
	            } else {
	                // inherit from v-app
	                return this.$vuetify.dark;
	            }
	        },
	        rootThemeClasses: function rootThemeClasses() {
	            return {
	                'theme--dark': this.rootIsDark,
	                'theme--light': !this.rootIsDark
	            };
	        }
	    },
	    watch: {
	        isDark: {
	            handler: function handler(newVal, oldVal) {
	                if (newVal !== oldVal) {
	                    this.themeableProvide.isDark = this.isDark;
	                }
	            },
	            immediate: true
	        }
	    }
	});
	/* harmony default export */ __webpack_exports__["default"] = (Themeable);
	
	/***/ }),
	
	/***/ "./src/mixins/toggleable.ts":
	/*!**********************************!*\
	  !*** ./src/mixins/toggleable.ts ***!
	  \**********************************/
	/*! exports provided: factory, default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "factory", function() { return factory; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	function factory(prop, event) {
	    if (prop === void 0) {
	        prop = 'value';
	    }
	    if (event === void 0) {
	        event = 'input';
	    }
	    var _a, _b;
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: 'toggleable',
	        model: { prop: prop, event: event },
	        props: (_a = {}, _a[prop] = { required: false }, _a),
	        data: function data() {
	            return {
	                isActive: !!this[prop]
	            };
	        },
	        watch: (_b = {}, _b[prop] = function (val) {
	            this.isActive = !!val;
	        }, _b.isActive = function (val) {
	            !!val !== this[prop] && this.$emit(event, val);
	        }, _b)
	    });
	}
	/* eslint-disable-next-line no-redeclare */
	var Toggleable = factory();
	/* harmony default export */ __webpack_exports__["default"] = (Toggleable);
	
	/***/ }),
	
	/***/ "./src/mixins/transitionable.ts":
	/*!**************************************!*\
	  !*** ./src/mixins/transitionable.ts ***!
	  \**************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'transitionable',
	    props: {
	        mode: String,
	        origin: String,
	        transition: String
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/translatable.ts":
	/*!************************************!*\
	  !*** ./src/mixins/translatable.ts ***!
	  \************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	
	/* harmony default export */ __webpack_exports__["default"] = (vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	    name: 'translatable',
	    props: {
	        height: Number
	    },
	    data: function data() {
	        return {
	            elOffsetTop: 0,
	            parallax: 0,
	            parallaxDist: 0,
	            percentScrolled: 0,
	            scrollTop: 0,
	            windowHeight: 0,
	            windowBottom: 0
	        };
	    },
	    computed: {
	        imgHeight: function imgHeight() {
	            return this.objHeight();
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        window.removeEventListener('scroll', this.translate, false);
	        window.removeEventListener('resize', this.translate, false);
	    },
	    methods: {
	        calcDimensions: function calcDimensions() {
	            var offset = this.$el.getBoundingClientRect();
	            this.scrollTop = window.pageYOffset;
	            this.parallaxDist = this.imgHeight - this.height;
	            this.elOffsetTop = offset.top + this.scrollTop;
	            this.windowHeight = window.innerHeight;
	            this.windowBottom = this.scrollTop + this.windowHeight;
	        },
	        listeners: function listeners() {
	            window.addEventListener('scroll', this.translate, false);
	            window.addEventListener('resize', this.translate, false);
	        },
	        /** @abstract **/
	        objHeight: function objHeight() {
	            throw new Error('Not implemented !');
	        },
	        translate: function translate() {
	            this.calcDimensions();
	            this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (parseInt(this.height) + this.windowHeight);
	            this.parallax = Math.round(this.parallaxDist * this.percentScrolled);
	        }
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/mixins/validatable.js":
	/*!***********************************!*\
	  !*** ./src/mixins/validatable.js ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _util_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../util/helpers */ "./src/util/helpers.ts");
	/* harmony import */ var _registrable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./registrable */ "./src/mixins/registrable.ts");
	/* harmony import */ var _util_console__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/console */ "./src/util/console.ts");
	/* harmony import */ var _colorable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./colorable */ "./src/mixins/colorable.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	
	
	
	// Mixins
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = ({
	    name: 'validatable',
	    mixins: [_colorable__WEBPACK_IMPORTED_MODULE_3__["default"], Object(_registrable__WEBPACK_IMPORTED_MODULE_1__["inject"])('form')],
	    props: {
	        disabled: Boolean,
	        error: Boolean,
	        errorCount: {
	            type: [Number, String],
	            default: 1
	        },
	        errorMessages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        messages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        readonly: Boolean,
	        rules: {
	            type: Array,
	            default: function _default() {
	                return [];
	            }
	        },
	        success: Boolean,
	        successMessages: {
	            type: [String, Array],
	            default: function _default() {
	                return [];
	            }
	        },
	        validateOnBlur: Boolean
	    },
	    data: function data() {
	        return {
	            errorBucket: [],
	            hasColor: false,
	            hasFocused: false,
	            hasInput: false,
	            isFocused: false,
	            isResetting: false,
	            valid: false
	        };
	    },
	    computed: {
	        hasError: function hasError() {
	            return this.internalErrorMessages.length > 0 || this.errorBucket.length > 0 || this.error;
	        },
	        externalError: function externalError() {
	            return this.internalErrorMessages.length > 0 || this.error;
	        },
	        // TODO: Add logic that allows the user to enable based
	        // upon a good validation
	        hasSuccess: function hasSuccess() {
	            return this.successMessages.length > 0 || this.success;
	        },
	        hasMessages: function hasMessages() {
	            return this.validations.length > 0;
	        },
	        hasState: function hasState() {
	            return this.hasSuccess || this.shouldValidate && this.hasError;
	        },
	        internalErrorMessages: function internalErrorMessages() {
	            return this.errorMessages || '';
	        },
	        shouldValidate: function shouldValidate() {
	            return this.externalError || !this.isResetting && (this.validateOnBlur ? this.hasFocused && !this.isFocused : this.hasInput || this.hasFocused);
	        },
	        validations: function validations() {
	            return this.validationTarget.slice(0, this.errorCount);
	        },
	        validationState: function validationState() {
	            if (this.hasError && this.shouldValidate) return 'error';
	            if (this.hasSuccess) return 'success';
	            if (this.hasColor) return this.color;
	            return null;
	        },
	        validationTarget: function validationTarget() {
	            var target = this.internalErrorMessages.length > 0 ? this.errorMessages : this.successMessages.length > 0 ? this.successMessages : this.messages;
	            // String
	            if (!Array.isArray(target)) {
	                return [target];
	                // Array with items
	            } else if (target.length > 0) {
	                return target;
	                // Currently has validation
	            } else if (this.shouldValidate) {
	                return this.errorBucket;
	            } else {
	                return [];
	            }
	        }
	    },
	    watch: {
	        rules: {
	            handler: function handler(newVal, oldVal) {
	                if (Object(_util_helpers__WEBPACK_IMPORTED_MODULE_0__["deepEqual"])(newVal, oldVal)) return;
	                this.validate();
	            },
	            deep: true
	        },
	        internalValue: function internalValue() {
	            // If it's the first time we're setting input,
	            // mark it with hasInput
	            this.hasInput = true;
	            this.validateOnBlur || this.$nextTick(this.validate);
	        },
	        isFocused: function isFocused(val) {
	            // Should not check validation
	            // if disabled or readonly
	            if (!val && !this.disabled && !this.readonly) {
	                this.hasFocused = true;
	                this.validateOnBlur && this.validate();
	            }
	        },
	        isResetting: function isResetting() {
	            var _this = this;
	            setTimeout(function () {
	                _this.hasInput = false;
	                _this.hasFocused = false;
	                _this.isResetting = false;
	            }, 0);
	        },
	        hasError: function hasError(val) {
	            if (this.shouldValidate) {
	                this.$emit('update:error', val);
	            }
	        }
	    },
	    beforeMount: function beforeMount() {
	        this.validate();
	    },
	    created: function created() {
	        this.form && this.form.register(this);
	    },
	    beforeDestroy: function beforeDestroy() {
	        this.form && this.form.unregister(this);
	    },
	    methods: {
	        /** @public */
	        reset: function reset() {
	            this.isResetting = true;
	            this.internalValue = Array.isArray(this.internalValue) ? [] : undefined;
	        },
	        /** @public */
	        resetValidation: function resetValidation() {
	            this.isResetting = true;
	        },
	        /** @public */
	        validate: function validate(force, value) {
	            if (force === void 0) {
	                force = false;
	            }
	            if (value === void 0) {
	                value = this.internalValue;
	            }
	            var errorBucket = [];
	            if (force) this.hasInput = this.hasFocused = true;
	            for (var index = 0; index < this.rules.length; index++) {
	                var rule = this.rules[index];
	                var valid = typeof rule === 'function' ? rule(value) : rule;
	                if (valid === false || typeof valid === 'string') {
	                    errorBucket.push(valid);
	                } else if (valid !== true) {
	                    Object(_util_console__WEBPACK_IMPORTED_MODULE_2__["consoleError"])("Rules should return a string or boolean, received '" + (typeof valid === 'undefined' ? 'undefined' : _typeof(valid)) + "' instead", this);
	                }
	            }
	            this.errorBucket = errorBucket;
	            this.valid = errorBucket.length === 0;
	            return this.valid;
	        }
	    }
	});
	
	/***/ }),
	
	/***/ "./src/stylus/app.styl":
	/*!*****************************!*\
	  !*** ./src/stylus/app.styl ***!
	  \*****************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_alerts.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_alerts.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_app.styl":
	/*!*****************************************!*\
	  !*** ./src/stylus/components/_app.styl ***!
	  \*****************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_autocompletes.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_autocompletes.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_avatars.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_avatars.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_badges.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_badges.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_bottom-navs.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_bottom-navs.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_bottom-sheets.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_bottom-sheets.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_breadcrumbs.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_breadcrumbs.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_button-toggle.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_button-toggle.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_buttons.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_buttons.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_cards.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_cards.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_carousel.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_carousel.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_chips.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_chips.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_content.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_content.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_counters.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_counters.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_data-iterator.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_data-iterator.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_data-table.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_data-table.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-header.styl":
	/*!********************************************************!*\
	  !*** ./src/stylus/components/_date-picker-header.styl ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-table.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-table.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-title.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-title.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_date-picker-years.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_date-picker-years.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_dialogs.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_dialogs.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_dividers.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_dividers.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_expansion-panel.styl":
	/*!*****************************************************!*\
	  !*** ./src/stylus/components/_expansion-panel.styl ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_footer.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_footer.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_forms.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_forms.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_grid.styl":
	/*!******************************************!*\
	  !*** ./src/stylus/components/_grid.styl ***!
	  \******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_icons.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_icons.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_images.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_images.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_inputs.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_inputs.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_item-group.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_item-group.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_jumbotrons.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_jumbotrons.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_labels.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_labels.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_lists.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_lists.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_menus.styl":
	/*!*******************************************!*\
	  !*** ./src/stylus/components/_menus.styl ***!
	  \*******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_messages.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_messages.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_navigation-drawer.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_navigation-drawer.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_overflow-buttons.styl":
	/*!******************************************************!*\
	  !*** ./src/stylus/components/_overflow-buttons.styl ***!
	  \******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_overlay.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_overlay.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_pagination.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_pagination.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_parallax.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_parallax.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_pickers.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_pickers.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_progress-circular.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_progress-circular.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_progress-linear.styl":
	/*!*****************************************************!*\
	  !*** ./src/stylus/components/_progress-linear.styl ***!
	  \*****************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_radio-group.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_radio-group.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_radios.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_radios.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_range-sliders.styl":
	/*!***************************************************!*\
	  !*** ./src/stylus/components/_range-sliders.styl ***!
	  \***************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_rating.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_rating.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_responsive.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_responsive.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_select.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_select.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_selection-controls.styl":
	/*!********************************************************!*\
	  !*** ./src/stylus/components/_selection-controls.styl ***!
	  \********************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_sliders.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_sliders.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_small-dialog.styl":
	/*!**************************************************!*\
	  !*** ./src/stylus/components/_small-dialog.styl ***!
	  \**************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_snackbars.styl":
	/*!***********************************************!*\
	  !*** ./src/stylus/components/_snackbars.styl ***!
	  \***********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_speed-dial.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_speed-dial.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_steppers.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_steppers.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_subheaders.styl":
	/*!************************************************!*\
	  !*** ./src/stylus/components/_subheaders.styl ***!
	  \************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_switch.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_switch.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_system-bars.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_system-bars.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tables.styl":
	/*!********************************************!*\
	  !*** ./src/stylus/components/_tables.styl ***!
	  \********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tabs.styl":
	/*!******************************************!*\
	  !*** ./src/stylus/components/_tabs.styl ***!
	  \******************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_text-fields.styl":
	/*!*************************************************!*\
	  !*** ./src/stylus/components/_text-fields.styl ***!
	  \*************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_textarea.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_textarea.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_time-picker-clock.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_time-picker-clock.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_time-picker-title.styl":
	/*!*******************************************************!*\
	  !*** ./src/stylus/components/_time-picker-title.styl ***!
	  \*******************************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_timeline.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_timeline.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_toolbar.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_toolbar.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_tooltips.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_tooltips.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_treeview.styl":
	/*!**********************************************!*\
	  !*** ./src/stylus/components/_treeview.styl ***!
	  \**********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/stylus/components/_windows.styl":
	/*!*********************************************!*\
	  !*** ./src/stylus/components/_windows.styl ***!
	  \*********************************************/
	/*! no static exports found */
	/***/ (function(module, exports, __webpack_require__) {
	
	// extracted by mini-css-extract-plugin
	
	/***/ }),
	
	/***/ "./src/util/ThemeProvider.ts":
	/*!***********************************!*\
	  !*** ./src/util/ThemeProvider.ts ***!
	  \***********************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony import */ var _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../mixins/themeable */ "./src/mixins/themeable.ts");
	/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mixins */ "./src/util/mixins.ts");
	
	
	/* @vue/component */
	/* harmony default export */ __webpack_exports__["default"] = (Object(_mixins__WEBPACK_IMPORTED_MODULE_1__["default"])(_mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"]).extend({
	    name: 'theme-provider',
	    props: {
	        root: Boolean
	    },
	    computed: {
	        isDark: function isDark() {
	            return this.root ? this.rootIsDark : _mixins_themeable__WEBPACK_IMPORTED_MODULE_0__["default"].options.computed.isDark.call(this);
	        }
	    },
	    render: function render() {
	        return this.$slots.default && this.$slots.default.find(function (node) {
	            return !node.isComment && node.text !== ' ';
	        });
	    }
	}));
	
	/***/ }),
	
	/***/ "./src/util/color/transformCIELAB.ts":
	/*!*******************************************!*\
	  !*** ./src/util/color/transformCIELAB.ts ***!
	  \*******************************************/
	/*! exports provided: fromXYZ, toXYZ */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromXYZ", function() { return fromXYZ; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toXYZ", function() { return toXYZ; });
	var delta = 0.20689655172413793; // 6÷29
	var cielabForwardTransform = function cielabForwardTransform(t) {
	    return t > Math.pow(delta, 3) ? Math.cbrt(t) : t / (3 * Math.pow(delta, 2)) + 4 / 29;
	};
	var cielabReverseTransform = function cielabReverseTransform(t) {
	    return t > delta ? Math.pow(t, 3) : 3 * Math.pow(delta, 2) * (t - 4 / 29);
	};
	function fromXYZ(xyz) {
	    var transform = cielabForwardTransform;
	    var transformedY = transform(xyz[1]);
	    return [116 * transformedY - 16, 500 * (transform(xyz[0] / 0.95047) - transformedY), 200 * (transformedY - transform(xyz[2] / 1.08883))];
	}
	function toXYZ(lab) {
	    var transform = cielabReverseTransform;
	    var Ln = (lab[0] + 16) / 116;
	    return [transform(Ln + lab[1] / 500) * 0.95047, transform(Ln), transform(Ln - lab[2] / 200) * 1.08883];
	}
	
	/***/ }),
	
	/***/ "./src/util/color/transformSRGB.ts":
	/*!*****************************************!*\
	  !*** ./src/util/color/transformSRGB.ts ***!
	  \*****************************************/
	/*! exports provided: fromXYZ, toXYZ */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromXYZ", function() { return fromXYZ; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toXYZ", function() { return toXYZ; });
	// For converting XYZ to sRGB
	var srgbForwardMatrix = [[3.2406, -1.5372, -0.4986], [-0.9689, 1.8758, 0.0415], [0.0557, -0.2040, 1.0570]];
	// Forward gamma adjust
	var srgbForwardTransform = function srgbForwardTransform(C) {
	    return C <= 0.0031308 ? C * 12.92 : 1.055 * Math.pow(C, 1 / 2.4) - 0.055;
	};
	// For converting sRGB to XYZ
	var srgbReverseMatrix = [[0.4124, 0.3576, 0.1805], [0.2126, 0.7152, 0.0722], [0.0193, 0.1192, 0.9505]];
	// Reverse gamma adjust
	var srgbReverseTransform = function srgbReverseTransform(C) {
	    return C <= 0.04045 ? C / 12.92 : Math.pow((C + 0.055) / 1.055, 2.4);
	};
	function clamp(value) {
	    return Math.max(0, Math.min(1, value));
	}
	function fromXYZ(xyz) {
	    var rgb = Array(3);
	    var transform = srgbForwardTransform;
	    var matrix = srgbForwardMatrix;
	    // Matrix transform, then gamma adjustment
	    for (var i = 0; i < 3; ++i) {
	        rgb[i] = Math.round(clamp(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
	    }
	    // Rescale back to [0, 255]
	    return (rgb[0] << 16) + (rgb[1] << 8) + (rgb[2] << 0);
	}
	function toXYZ(rgb) {
	    var xyz = [0, 0, 0];
	    var transform = srgbReverseTransform;
	    var matrix = srgbReverseMatrix;
	    // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
	    var r = transform((rgb >> 16 & 0xff) / 255);
	    var g = transform((rgb >> 8 & 0xff) / 255);
	    var b = transform((rgb >> 0 & 0xff) / 255);
	    // Matrix color space transform
	    for (var i = 0; i < 3; ++i) {
	        xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
	    }
	    return xyz;
	}
	
	/***/ }),
	
	/***/ "./src/util/colorUtils.ts":
	/*!********************************!*\
	  !*** ./src/util/colorUtils.ts ***!
	  \********************************/
	/*! exports provided: colorToInt, intToHex, colorToHex */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorToInt", function() { return colorToInt; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intToHex", function() { return intToHex; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorToHex", function() { return colorToHex; });
	/* harmony import */ var _console__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./console */ "./src/util/console.ts");
	
	function colorToInt(color) {
	    var rgb;
	    if (typeof color === 'number') {
	        rgb = color;
	    } else if (typeof color === 'string') {
	        var c = color[0] === '#' ? color.substring(1) : color;
	        if (c.length === 3) {
	            c = c.split('').map(function (char) {
	                return char + char;
	            }).join('');
	        }
	        if (c.length !== 6) {
	            Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color + "' is not a valid rgb color");
	        }
	        rgb = parseInt(c, 16);
	    } else {
	        throw new TypeError("Colors can only be numbers or strings, recieved " + (color == null ? color : color.constructor.name) + " instead");
	    }
	    if (rgb < 0) {
	        Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("Colors cannot be negative: '" + color + "'");
	        rgb = 0;
	    } else if (rgb > 0xffffff || isNaN(rgb)) {
	        Object(_console__WEBPACK_IMPORTED_MODULE_0__["consoleWarn"])("'" + color + "' is not a valid rgb color");
	        rgb = 0xffffff;
	    }
	    return rgb;
	}
	function intToHex(color) {
	    var hexColor = color.toString(16);
	    if (hexColor.length < 6) hexColor = '0'.repeat(6 - hexColor.length) + hexColor;
	    return '#' + hexColor;
	}
	function colorToHex(color) {
	    return intToHex(colorToInt(color));
	}
	
	/***/ }),
	
	/***/ "./src/util/console.ts":
	/*!*****************************!*\
	  !*** ./src/util/console.ts ***!
	  \*****************************/
	/*! exports provided: consoleInfo, consoleWarn, consoleError, deprecate */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleInfo", function() { return consoleInfo; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleWarn", function() { return consoleWarn; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "consoleError", function() { return consoleError; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deprecate", function() { return deprecate; });
	function createMessage(message, vm, parent) {
	    if (parent) {
	        vm = {
	            _isVue: true,
	            $parent: parent,
	            $options: vm
	        };
	    }
	    if (vm) {
	        // Only show each message once per instance
	        vm.$_alreadyWarned = vm.$_alreadyWarned || [];
	        if (vm.$_alreadyWarned.includes(message)) return;
	        vm.$_alreadyWarned.push(message);
	    }
	    return "[Vuetify] " + message + (vm ? generateComponentTrace(vm) : '');
	}
	function consoleInfo(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.info(newMessage);
	}
	function consoleWarn(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.warn(newMessage);
	}
	function consoleError(message, vm, parent) {
	    var newMessage = createMessage(message, vm, parent);
	    newMessage != null && console.error(newMessage);
	}
	function deprecate(original, replacement, vm, parent) {
	    consoleWarn("'" + original + "' is deprecated, use '" + replacement + "' instead", vm, parent);
	}
	/**
	 * Shamelessly stolen from vuejs/vue/blob/dev/src/core/util/debug.js
	 */
	var classifyRE = /(?:^|[-_])(\w)/g;
	var classify = function classify(str) {
	    return str.replace(classifyRE, function (c) {
	        return c.toUpperCase();
	    }).replace(/[-_]/g, '');
	};
	function formatComponentName(vm, includeFile) {
	    if (vm.$root === vm) {
	        return '<Root>';
	    }
	    var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm || {};
	    var name = options.name || options._componentTag;
	    var file = options.__file;
	    if (!name && file) {
	        var match = file.match(/([^/\\]+)\.vue$/);
	        name = match && match[1];
	    }
	    return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
	}
	function generateComponentTrace(vm) {
	    if (vm._isVue && vm.$parent) {
	        var tree = [];
	        var currentRecursiveSequence = 0;
	        while (vm) {
	            if (tree.length > 0) {
	                var last = tree[tree.length - 1];
	                if (last.constructor === vm.constructor) {
	                    currentRecursiveSequence++;
	                    vm = vm.$parent;
	                    continue;
	                } else if (currentRecursiveSequence > 0) {
	                    tree[tree.length - 1] = [last, currentRecursiveSequence];
	                    currentRecursiveSequence = 0;
	                }
	            }
	            tree.push(vm);
	            vm = vm.$parent;
	        }
	        return '\n\nfound in\n\n' + tree.map(function (vm, i) {
	            return "" + (i === 0 ? '---> ' : ' '.repeat(5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
	        }).join('\n');
	    } else {
	        return "\n\n(found in " + formatComponentName(vm) + ")";
	    }
	}
	
	/***/ }),
	
	/***/ "./src/util/dedupeModelListeners.ts":
	/*!******************************************!*\
	  !*** ./src/util/dedupeModelListeners.ts ***!
	  \******************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return dedupeModelListeners; });
	/**
	 * Removes duplicate `@input` listeners when
	 * using v-model with functional components
	 *
	 * @see https://github.com/vuetifyjs/vuetify/issues/4460
	 */
	function dedupeModelListeners(data) {
	    if (data.model && data.on && data.on.input) {
	        if (Array.isArray(data.on.input)) {
	            var i = data.on.input.indexOf(data.model.callback);
	            if (i > -1) data.on.input.splice(i, 1);
	        } else {
	            delete data.on.input;
	        }
	    }
	}
	
	/***/ }),
	
	/***/ "./src/util/easing-patterns.js":
	/*!*************************************!*\
	  !*** ./src/util/easing-patterns.js ***!
	  \*************************************/
	/*! exports provided: linear, easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInOutCubic, easeInQuart, easeOutQuart, easeInOutQuart, easeInQuint, easeOutQuint, easeInOutQuint */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuad", function() { return easeInQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuad", function() { return easeOutQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuad", function() { return easeInOutQuad; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInCubic", function() { return easeInCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutCubic", function() { return easeOutCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutCubic", function() { return easeInOutCubic; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuart", function() { return easeInQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuart", function() { return easeOutQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuart", function() { return easeInOutQuart; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInQuint", function() { return easeInQuint; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOutQuint", function() { return easeOutQuint; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOutQuint", function() { return easeInOutQuint; });
	// linear
	var linear = function linear(t) {
	  return t;
	};
	// accelerating from zero velocity
	var easeInQuad = function easeInQuad(t) {
	  return t * t;
	};
	// decelerating to zero velocity
	var easeOutQuad = function easeOutQuad(t) {
	  return t * (2 - t);
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuad = function easeInOutQuad(t) {
	  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
	};
	// accelerating from zero velocity
	var easeInCubic = function easeInCubic(t) {
	  return t * t * t;
	};
	// decelerating to zero velocity
	var easeOutCubic = function easeOutCubic(t) {
	  return --t * t * t + 1;
	};
	// acceleration until halfway, then deceleration
	var easeInOutCubic = function easeInOutCubic(t) {
	  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
	};
	// accelerating from zero velocity
	var easeInQuart = function easeInQuart(t) {
	  return t * t * t * t;
	};
	// decelerating to zero velocity
	var easeOutQuart = function easeOutQuart(t) {
	  return 1 - --t * t * t * t;
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuart = function easeInOutQuart(t) {
	  return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
	};
	// accelerating from zero velocity
	var easeInQuint = function easeInQuint(t) {
	  return t * t * t * t * t;
	};
	// decelerating to zero velocity
	var easeOutQuint = function easeOutQuint(t) {
	  return 1 + --t * t * t * t * t;
	};
	// acceleration until halfway, then deceleration
	var easeInOutQuint = function easeInOutQuint(t) {
	  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
	};
	
	/***/ }),
	
	/***/ "./src/util/helpers.ts":
	/*!*****************************!*\
	  !*** ./src/util/helpers.ts ***!
	  \*****************************/
	/*! exports provided: createSimpleFunctional, createSimpleTransition, createJavaScriptTransition, directiveConfig, addOnceEventListener, getNestedValue, deepEqual, getObjectValueByPath, getPropertyFromItem, createRange, getZIndex, escapeHTML, filterObjectOnKeys, filterChildren, convertToUnit, kebabCase, isObject, keyCodes, remapInternalIcon, keys, camelize */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSimpleFunctional", function() { return createSimpleFunctional; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSimpleTransition", function() { return createSimpleTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createJavaScriptTransition", function() { return createJavaScriptTransition; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "directiveConfig", function() { return directiveConfig; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOnceEventListener", function() { return addOnceEventListener; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNestedValue", function() { return getNestedValue; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getObjectValueByPath", function() { return getObjectValueByPath; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPropertyFromItem", function() { return getPropertyFromItem; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRange", function() { return createRange; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZIndex", function() { return getZIndex; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeHTML", function() { return escapeHTML; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterObjectOnKeys", function() { return filterObjectOnKeys; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterChildren", function() { return filterChildren; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToUnit", function() { return convertToUnit; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCase", function() { return kebabCase; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyCodes", function() { return keyCodes; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remapInternalIcon", function() { return remapInternalIcon; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keys", function() { return keys; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelize", function() { return camelize; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __assign = undefined && undefined.__assign || function () {
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function createSimpleFunctional(c, el, name) {
	    if (el === void 0) {
	        el = 'div';
	    }
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({
	        name: name || c.replace(/__/g, '-'),
	        functional: true,
	        render: function render(h, _a) {
	            var data = _a.data,
	                children = _a.children;
	            data.staticClass = (c + " " + (data.staticClass || '')).trim();
	            return h(el, data, children);
	        }
	    });
	}
	function mergeTransitions(transitions, array) {
	    if (Array.isArray(transitions)) return transitions.concat(array);
	    if (transitions) array.push(transitions);
	    return array;
	}
	function createSimpleTransition(name, origin, mode) {
	    if (origin === void 0) {
	        origin = 'top center 0';
	    }
	    return {
	        name: name,
	        functional: true,
	        props: {
	            group: {
	                type: Boolean,
	                default: false
	            },
	            hideOnLeave: {
	                type: Boolean,
	                default: false
	            },
	            leaveAbsolute: {
	                type: Boolean,
	                default: false
	            },
	            mode: {
	                type: String,
	                default: mode
	            },
	            origin: {
	                type: String,
	                default: origin
	            }
	        },
	        render: function render(h, context) {
	            var tag = "transition" + (context.props.group ? '-group' : '');
	            context.data = context.data || {};
	            context.data.props = {
	                name: name,
	                mode: context.props.mode
	            };
	            context.data.on = context.data.on || {};
	            if (!Object.isExtensible(context.data.on)) {
	                context.data.on = __assign({}, context.data.on);
	            }
	            var ourBeforeEnter = [];
	            var ourLeave = [];
	            var absolute = function absolute(el) {
	                return el.style.position = 'absolute';
	            };
	            ourBeforeEnter.push(function (el) {
	                el.style.transformOrigin = context.props.origin;
	                el.style.webkitTransformOrigin = context.props.origin;
	            });
	            if (context.props.leaveAbsolute) ourLeave.push(absolute);
	            if (context.props.hideOnLeave) {
	                ourLeave.push(function (el) {
	                    return el.style.display = 'none';
	                });
	            }
	            var _a = context.data.on,
	                beforeEnter = _a.beforeEnter,
	                leave = _a.leave;
	            // Type says Function | Function[] but
	            // will only work if provided a function
	            context.data.on.beforeEnter = function () {
	                return mergeTransitions(beforeEnter, ourBeforeEnter);
	            };
	            context.data.on.leave = mergeTransitions(leave, ourLeave);
	            return h(tag, context.data, context.children);
	        }
	    };
	}
	function createJavaScriptTransition(name, functions, mode) {
	    if (mode === void 0) {
	        mode = 'in-out';
	    }
	    return {
	        name: name,
	        functional: true,
	        props: {
	            mode: {
	                type: String,
	                default: mode
	            }
	        },
	        render: function render(h, context) {
	            var data = {
	                props: __assign({}, context.props, { name: name }),
	                on: functions
	            };
	            return h('transition', data, context.children);
	        }
	    };
	}
	function directiveConfig(binding, defaults) {
	    if (defaults === void 0) {
	        defaults = {};
	    }
	    return __assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
	}
	function addOnceEventListener(el, event, cb) {
	    var once = function once() {
	        cb();
	        el.removeEventListener(event, once, false);
	    };
	    el.addEventListener(event, once, false);
	}
	function getNestedValue(obj, path, fallback) {
	    var last = path.length - 1;
	    if (last < 0) return obj === undefined ? fallback : obj;
	    for (var i = 0; i < last; i++) {
	        if (obj == null) {
	            return fallback;
	        }
	        obj = obj[path[i]];
	    }
	    if (obj == null) return fallback;
	    return obj[path[last]] === undefined ? fallback : obj[path[last]];
	}
	function deepEqual(a, b) {
	    if (a === b) return true;
	    if (a instanceof Date && b instanceof Date) {
	        // If the values are Date, they were convert to timestamp with getTime and compare it
	        if (a.getTime() !== b.getTime()) return false;
	    }
	    if (a !== Object(a) || b !== Object(b)) {
	        // If the values aren't objects, they were already checked for equality
	        return false;
	    }
	    var props = Object.keys(a);
	    if (props.length !== Object.keys(b).length) {
	        // Different number of props, don't bother to check
	        return false;
	    }
	    return props.every(function (p) {
	        return deepEqual(a[p], b[p]);
	    });
	}
	function getObjectValueByPath(obj, path, fallback) {
	    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
	    if (!path || path.constructor !== String) return fallback;
	    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
	    path = path.replace(/^\./, ''); // strip a leading dot
	    return getNestedValue(obj, path.split('.'), fallback);
	}
	function getPropertyFromItem(item, property, fallback) {
	    if (property == null) return item === undefined ? fallback : item;
	    if (item !== Object(item)) return fallback === undefined ? item : fallback;
	    if (typeof property === 'string') return getObjectValueByPath(item, property, fallback);
	    if (Array.isArray(property)) return getNestedValue(item, property, fallback);
	    if (typeof property !== 'function') return fallback;
	    var value = property(item, fallback);
	    return typeof value === 'undefined' ? fallback : value;
	}
	function createRange(length) {
	    return Array.from({ length: length }, function (v, k) {
	        return k;
	    });
	}
	function getZIndex(el) {
	    if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
	    var index = +window.getComputedStyle(el).getPropertyValue('z-index');
	    if (isNaN(index)) return getZIndex(el.parentNode);
	    return index;
	}
	var tagsToReplace = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;'
	};
	function escapeHTML(str) {
	    return str.replace(/[&<>]/g, function (tag) {
	        return tagsToReplace[tag] || tag;
	    });
	}
	function filterObjectOnKeys(obj, keys) {
	    var filtered = {};
	    for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        if (typeof obj[key] !== 'undefined') {
	            filtered[key] = obj[key];
	        }
	    }
	    return filtered;
	}
	function filterChildren(array, tag) {
	    if (array === void 0) {
	        array = [];
	    }
	    return array.filter(function (child) {
	        return child.componentOptions && child.componentOptions.Ctor.options.name === tag;
	    });
	}
	function convertToUnit(str, unit) {
	    if (unit === void 0) {
	        unit = 'px';
	    }
	    if (str == null || str === '') {
	        return undefined;
	    } else if (isNaN(+str)) {
	        return String(str);
	    } else {
	        return "" + Number(str) + unit;
	    }
	}
	function kebabCase(str) {
	    return (str || '').replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
	function isObject(obj) {
	    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	}
	// KeyboardEvent.keyCode aliases
	var keyCodes = Object.freeze({
	    enter: 13,
	    tab: 9,
	    delete: 46,
	    esc: 27,
	    space: 32,
	    up: 38,
	    down: 40,
	    left: 37,
	    right: 39,
	    end: 35,
	    home: 36,
	    del: 46,
	    backspace: 8,
	    insert: 45,
	    pageup: 33,
	    pagedown: 34
	});
	var ICONS_PREFIX = '$vuetify.icons.';
	// This remaps internal names like '$vuetify.icons.cancel' to the current name
	// for that icon.
	function remapInternalIcon(vm, iconName) {
	    if (!iconName.startsWith(ICONS_PREFIX)) {
	        return iconName;
	    }
	    // Now look up icon indirection name, e.g. '$vuetify.icons.cancel'
	    return getObjectValueByPath(vm, iconName, iconName);
	}
	function keys(o) {
	    return Object.keys(o);
	}
	/**
	 * Camelize a hyphen-delimited string.
	 */
	var camelizeRE = /-(\w)/g;
	var camelize = function camelize(str) {
	    return str.replace(camelizeRE, function (_, c) {
	        return c ? c.toUpperCase() : '';
	    });
	};
	
	/***/ }),
	
	/***/ "./src/util/mask.js":
	/*!**************************!*\
	  !*** ./src/util/mask.js ***!
	  \**************************/
	/*! exports provided: defaultDelimiters, isMaskDelimiter, maskText, unmaskText */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultDelimiters", function() { return defaultDelimiters; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMaskDelimiter", function() { return isMaskDelimiter; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maskText", function() { return maskText; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmaskText", function() { return unmaskText; });
	/**
	 * Default delimiter RegExp
	 *
	 * @type {RegExp}
	 */
	var defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
	/**
	 *
	 * @param {String} char
	 *
	 * @return {Boolean}
	 */
	var isMaskDelimiter = function isMaskDelimiter(char) {
	    return char && defaultDelimiters.test(char);
	};
	/**
	 * Mask keys
	 *
	 * @type {Object}
	 */
	var allowedMasks = {
	    '#': {
	        test: function test(char) {
	            return char.match(/[0-9]/);
	        }
	    },
	    'A': {
	        test: function test(char) {
	            return char.match(/[A-Z]/i);
	        },
	        convert: function convert(char) {
	            return char.toUpperCase();
	        }
	    },
	    'a': {
	        test: function test(char) {
	            return char.match(/[a-z]/i);
	        },
	        convert: function convert(char) {
	            return char.toLowerCase();
	        }
	    },
	    'N': {
	        test: function test(char) {
	            return char.match(/[0-9A-Z]/i);
	        },
	        convert: function convert(char) {
	            return char.toUpperCase();
	        }
	    },
	    'n': {
	        test: function test(char) {
	            return char.match(/[0-9a-z]/i);
	        },
	        convert: function convert(char) {
	            return char.toLowerCase();
	        }
	    },
	    'X': {
	        test: isMaskDelimiter
	    }
	};
	/**
	 * Is Character mask
	 *
	 * @param  {String} char
	 *
	 * @return {Boolean}
	 */
	var isMask = function isMask(char) {
	    return allowedMasks.hasOwnProperty(char);
	};
	/**
	 * Automatically convert char case
	 *
	 * @param  {String} mask
	 * @param  {String} char
	 *
	 * @return {String}
	 */
	var convert = function convert(mask, char) {
	    return allowedMasks[mask].convert ? allowedMasks[mask].convert(char) : char;
	};
	/**
	 * Mask Validation
	 *
	 * @param  {String} mask
	 * @param  {String} char
	 *
	 * @return {Boolean}
	 */
	var maskValidates = function maskValidates(mask, char) {
	    if (char == null || !isMask(mask)) return false;
	    return allowedMasks[mask].test(char);
	};
	/**
	 * Mask Text
	 *
	 * Takes a string or an array of characters
	 * and returns a masked string
	 *
	 * @param {*} text
	 * @param {Array|String} masked
	 * @param {Boolean} [dontFillMaskBlanks]
	 *
	 * @return {String}
	 */
	var maskText = function maskText(text, masked, dontFillMaskBlanks) {
	    if (text == null) return '';
	    text = String(text);
	    if (!masked.length || !text.length) return text;
	    if (!Array.isArray(masked)) masked = masked.split('');
	    var textIndex = 0;
	    var maskIndex = 0;
	    var newText = '';
	    while (maskIndex < masked.length) {
	        var mask = masked[maskIndex];
	        // Assign the next character
	        var char = text[textIndex];
	        // Check if mask is delimiter
	        // and current char matches
	        if (!isMask(mask) && char === mask) {
	            newText += mask;
	            textIndex++;
	            // Check if not mask
	        } else if (!isMask(mask) && !dontFillMaskBlanks) {
	            newText += mask;
	            // Check if is mask and validates
	        } else if (maskValidates(mask, char)) {
	            newText += convert(mask, char);
	            textIndex++;
	        } else {
	            return newText;
	        }
	        maskIndex++;
	    }
	    return newText;
	};
	/**
	 * Unmask Text
	 *
	 * @param {String} text
	 *
	 * @return {String}
	 */
	var unmaskText = function unmaskText(text) {
	    return text ? String(text).replace(new RegExp(defaultDelimiters, 'g'), '') : text;
	};
	
	/***/ }),
	
	/***/ "./src/util/mixins.ts":
	/*!****************************!*\
	  !*** ./src/util/mixins.ts ***!
	  \****************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return mixins; });
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! vue */ "vue");
	/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
	/* eslint-disable max-len, import/export, no-use-before-define */
	
	function mixins() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return vue__WEBPACK_IMPORTED_MODULE_0___default.a.extend({ mixins: args });
	}
	
	/***/ }),
	
	/***/ "./src/util/rebuildFunctionalSlots.js":
	/*!********************************************!*\
	  !*** ./src/util/rebuildFunctionalSlots.js ***!
	  \********************************************/
	/*! exports provided: default */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return rebuildFunctionalSlots; });
	/**
	 *
	 * @param {object} slots
	 * @param {function} h
	 * @returns {array}
	 */
	function rebuildFunctionalSlots(slots, h) {
	    var children = [];
	    for (var slot in slots) {
	        if (slots.hasOwnProperty(slot)) {
	            children.push(h('template', { slot: slot }, slots[slot]));
	        }
	    }
	    return children;
	}
	
	/***/ }),
	
	/***/ "./src/util/theme.ts":
	/*!***************************!*\
	  !*** ./src/util/theme.ts ***!
	  \***************************/
	/*! exports provided: parse, genStyles, genVariations */
	/***/ (function(module, __webpack_exports__, __webpack_require__) {
	
	"use strict";
	__webpack_require__.r(__webpack_exports__);
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genStyles", function() { return genStyles; });
	/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "genVariations", function() { return genVariations; });
	/* harmony import */ var _colorUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./colorUtils */ "./src/util/colorUtils.ts");
	/* harmony import */ var _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color/transformSRGB */ "./src/util/color/transformSRGB.ts");
	/* harmony import */ var _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./color/transformCIELAB */ "./src/util/color/transformCIELAB.ts");
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var __read = undefined && undefined.__read || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o),
	        r,
	        ar = [],
	        e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
	            ar.push(r.value);
	        }
	    } catch (error) {
	        e = { error: error };
	    } finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        } finally {
	            if (e) throw e.error;
	        }
	    }
	    return ar;
	};
	
	
	
	function parse(theme, isItem) {
	    if (isItem === void 0) {
	        isItem = false;
	    }
	    var colors = Object.keys(theme);
	    var parsedTheme = {};
	    for (var i = 0; i < colors.length; ++i) {
	        var name = colors[i];
	        var value = theme[name];
	        if (isItem) {
	            if (name === 'base' || name.startsWith('lighten') || name.startsWith('darken')) {
	                parsedTheme[name] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["colorToHex"])(value);
	            }
	        } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
	            parsedTheme[name] = parse(value, true);
	        } else {
	            parsedTheme[name] = genVariations(name, Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["colorToInt"])(value));
	        }
	    }
	    return parsedTheme;
	}
	/**
	 * Generate the CSS for a base color (.primary)
	 */
	var genBaseColor = function genBaseColor(name, value) {
	    return "\n." + name + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n." + name + "--text {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
	};
	/**
	 * Generate the CSS for a variant color (.primary.darken-2)
	 */
	var genVariantColor = function genVariantColor(name, variant, value) {
	    var _a = __read(variant.split(/(\d)/, 2), 2),
	        type = _a[0],
	        n = _a[1];
	    return "\n." + name + "." + type + "-" + n + " {\n  background-color: " + value + " !important;\n  border-color: " + value + " !important;\n}\n." + name + "--text.text--" + type + "-" + n + " {\n  color: " + value + " !important;\n  caret-color: " + value + " !important;\n}";
	};
	var genColorVariableName = function genColorVariableName(name, variant) {
	    if (variant === void 0) {
	        variant = 'base';
	    }
	    return "--v-" + name + "-" + variant;
	};
	var genColorVariable = function genColorVariable(name, variant) {
	    if (variant === void 0) {
	        variant = 'base';
	    }
	    return "var(" + genColorVariableName(name, variant) + ")";
	};
	function genStyles(theme, cssVar) {
	    if (cssVar === void 0) {
	        cssVar = false;
	    }
	    var colors = Object.keys(theme);
	    if (!colors.length) return '';
	    var variablesCss = '';
	    var css = '';
	    var aColor = cssVar ? genColorVariable('primary') : theme.primary.base;
	    css += "a { color: " + aColor + "; }";
	    for (var i = 0; i < colors.length; ++i) {
	        var name = colors[i];
	        var value = theme[name];
	        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) !== 'object') continue;
	        css += genBaseColor(name, cssVar ? genColorVariable(name) : value.base);
	        cssVar && (variablesCss += "  " + genColorVariableName(name) + ": " + value.base + ";\n");
	        var variants = Object.keys(value);
	        for (var i_1 = 0; i_1 < variants.length; ++i_1) {
	            var variant = variants[i_1];
	            var variantValue = value[variant];
	            if (variant === 'base') continue;
	            css += genVariantColor(name, variant, cssVar ? genColorVariable(name, variant) : variantValue);
	            cssVar && (variablesCss += "  " + genColorVariableName(name, variant) + ": " + variantValue + ";\n");
	        }
	    }
	    if (cssVar) {
	        variablesCss = ":root {\n" + variablesCss + "}\n\n";
	    }
	    return variablesCss + css;
	}
	function genVariations(name, value) {
	    var values = {
	        base: Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(value)
	    };
	    for (var i = 5; i > 0; --i) {
	        values["lighten" + i] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(lighten(value, i));
	    }
	    for (var i = 1; i <= 4; ++i) {
	        values["darken" + i] = Object(_colorUtils__WEBPACK_IMPORTED_MODULE_0__["intToHex"])(darken(value, i));
	    }
	    return values;
	}
	function lighten(value, amount) {
	    var lab = _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["toXYZ"](value));
	    lab[0] = lab[0] + amount * 10;
	    return _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["fromXYZ"](_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](lab));
	}
	function darken(value, amount) {
	    var lab = _color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["fromXYZ"](_color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["toXYZ"](value));
	    lab[0] = lab[0] - amount * 10;
	    return _color_transformSRGB__WEBPACK_IMPORTED_MODULE_1__["fromXYZ"](_color_transformCIELAB__WEBPACK_IMPORTED_MODULE_2__["toXYZ"](lab));
	}
	
	/***/ }),
	
	/***/ "vue":
	/*!******************************************************************************!*\
	  !*** external {"commonjs":"vue","commonjs2":"vue","amd":"vue","root":"Vue"} ***!
	  \******************************************************************************/
	/*! no static exports found */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_vue__;
	
	/***/ })
	
	/******/ })["default"];
	});
	//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 102 */,
/* 103 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ })
]);


// WEBPACK FOOTER //
// static/js/vendor.0d437650c763eff98cf6.js